import type { SVGProps } from 'react'
import { useId } from 'react'
import { Bell, MessageSquareText, Send } from '@ondit/ui/icons'

export function EnrichmentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 24 24'
      fill='currentColor'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M12 2.5l1.9 4.6 4.6 1.9-4.6 1.9L12 15.5l-1.9-4.6L5.5 9l4.6-1.9L12 2.5z' />
      <path d='M18.5 14l.95 2.3 2.3.95-2.3.95L18.5 20.5l-.95-2.3-2.3-.95 2.3-.95.95-2.3z' />
      <path d='M5.5 14.5l.7 1.7 1.7.7-1.7.7-.7 1.7-.7-1.7-1.7-.7 1.7-.7.7-1.7z' />
    </svg>
  )
}

export function AgentMailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 350 363' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M318.03 88.34C196.47 115.33 153.48 115.32 33.92 88.33C30.62 87.58 27.14 88.97 25.33 91.83L1.24 129.77C-1.76 134.51 0.97 140.8 6.46 141.9C152.61 171.13 197.68 171.18 343.9 141.84C349.3 140.75 352.06 134.64 349.25 129.91L326.72 92.05C324.95 89.07 321.41 87.59 318.03 88.34Z'
        fill='currentColor'
      />
      <path
        d='M75.99 246.6L149.94 311.65C151.97 313.44 151.63 316.97 149.28 318.48L119.14 337.84C117.28 339.03 114.95 338.41 113.93 336.45L70.13 252.04C68.08 248.09 72.76 243.75 75.99 246.6Z'
        fill='currentColor'
      />
      <path
        d='M274.02 246.6L200.08 311.65C198.05 313.44 198.39 316.97 200.74 318.48L230.88 337.84C232.74 339.03 235.07 338.41 236.09 336.45L279.89 252.04C281.94 248.09 277.26 243.75 274.02 246.6Z'
        fill='currentColor'
      />
      <path
        d='M138.75 198.47L152.44 192.98C155.24 191.92 157.77 191.92 158.57 191.92C164.12 192.13 169.56 192.23 175.01 192.24C180.45 192.23 185.9 192.13 191.44 191.92C192.25 191.92 194.78 191.92 197.58 192.98L211.27 198.47C212.65 199.03 214.08 199.38 215.54 199.45C218.59 199.59 221.73 199.46 224.63 198.81C225.71 198.57 226.73 198.1 227.7 197.55L243.05 188.78C244.81 187.78 246.73 187.14 248.7 186.9L258.28 185.5H259.24H263.56L262.71 190.97L256.68 234.22C255.96 238.31 254.25 242.33 250.44 245.83L187.38 299.26C184.56 301.65 181.11 302.94 177.56 302.94H175.01H172.46C168.91 302.94 165.46 301.65 162.64 299.26L99.58 245.83C95.77 242.33 94.06 238.31 93.34 234.22L87.31 190.97L86.46 185.5H90.78H91.74L101.32 186.9C103.29 187.14 105.21 187.78 106.97 188.78L122.31 197.55C123.29 198.1 124.31 198.57 125.39 198.81C128.29 199.46 131.43 199.59 134.47 199.45C135.94 199.38 137.37 199.03 138.75 198.47Z'
        fill='currentColor'
      />
      <path
        d='M102.47 0.85C205.43 44.8 156.46 42.1 248.43 1.63C252.89 -1.1 258.35 1.89 259.42 7.69L269.24 61.17L270.82 69.79L263.59 71.82L263.58 71.83C190.59 92.31 165.24 92.01 86.76 71.74L79.2 69.79L80.99 60.87L91.84 6.92C92.96 1.37 98.11 -1.56 102.47 0.85Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function AgentPhoneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 236 240' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M113.14 79.35C126.85 79.35 138.66 80.3 143.63 85.26C149.3 90.93 151.66 103.45 151.66 120.7C151.66 129.92 150.48 136.54 146.94 141.74C140.32 151.19 119.76 154.73 95.66 155.44C76.81 155.44 70.57 153.61 66.77 149.05L66.59 148.83C61.86 143.63 59.5 129.92 58.79 114.09C58.79 108.18 59.03 100.15 61.39 95.18C64.6 88.32 68.91 86.11 77.56 83.61L78.41 83.37C89.53 80.03 104.45 79.35 113.14 79.35ZM103.87 23.82C105.68 23.92 107.24 25.53 107.24 27.36L107.23 27.52C107.14 29.34 105.53 30.91 103.69 30.91L103.54 30.9C101.92 30.82 100.15 29.42 100.15 27.36C100.15 27.3 100.15 27.23 100.15 27.16C100.27 25.26 101.99 23.77 103.87 23.82ZM92.38 114.38C91.76 109.22 89.96 101.34 83.84 101.57C78.41 102.04 75.33 107.95 76.04 116.45C76.52 122.6 79.11 129.22 84.31 129.22C91.63 129.7 92.94 121.33 92.53 115.74C92.5 115.36 92.45 114.91 92.38 114.38ZM119.29 112.17C118.75 106.77 120.09 97.91 126.85 97.32C133.47 97.55 135.83 106.77 136.06 112.2C136.3 116.22 135.59 120.95 133.23 123.31C131.57 125.2 127.32 125.67 124.96 124.02C121.5 122.18 119.84 116.73 119.33 112.52L119.29 112.17ZM106.08 135.14C104.87 135.17 103.54 135.18 102.04 135.13C101.58 135.13 101.07 135.08 100.53 135.04C98.28 134.85 95.66 134.63 95.66 137.49C95.66 141.51 100.86 144.58 107.23 145.05C115.51 145.29 120.94 139.38 120.7 136.31C120.7 134.66 119.76 133 117.63 133.47C117.05 133.59 116.48 133.71 115.93 133.82C112.84 134.47 109.93 135.02 106.08 135.14Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.91 164.38C18.01 173.45 21.1 182.05 26.89 189C37.05 200.81 55.96 210.5 79.59 211.92C83.13 212.16 87.15 211.69 90.22 210.98C98.49 208.85 103.45 202.71 103.45 195.14C103.45 189 98.97 179.31 85.97 177.66C70.77 176.44 55.49 174.06 45.32 161.35C51.7 165.37 62.57 169.86 81.24 170.57C90.45 170.57 95.37 172.38 103.44 175.61L103.64 175.39C111.11 167.01 116.99 160.41 128.03 160.41C134.03 160.26 138.13 162.49 141.05 164.08C142.72 164.99 144.01 165.69 145.05 165.6C148.35 165.37 164.66 145.04 168.68 132.99C169.3 130.93 169.38 129.22 169.38 128.51C169.39 126.95 167.21 125.55 165.78 124.63L165.76 124.62C165.53 124.47 165.31 124.33 165.13 124.21C164.41 123.71 163.73 123.25 163.24 122.83C158.75 119.52 154.97 114.09 154.97 108.42C154.97 99.44 160.88 86.91 167.97 75.33C164.99 67.55 159.13 58.21 147.37 53.77L146.81 53.56C133.95 49.07 118.23 48.45 104.64 49.81L106.53 36.82C109.6 35.87 113.62 33.03 113.62 27.84C113.85 23.18 109.96 18.07 103.98 17.91L103.69 17.91C98.02 17.91 94 22.4 93.53 26.89C93.29 31.38 96.13 34.92 99.44 36.58L97.31 49.81C87.86 50.52 78.88 51.47 68.95 53.36C61.86 54.89 54.54 56.48 47.99 59.7C39.44 63.94 32.74 69.82 29.25 79.82C25.71 88.09 24.76 105.58 24.53 123.07L25.24 141.26C20.98 148.21 17.91 155.63 17.91 163.95L17.91 164.38ZM143.63 85.26C138.66 80.3 126.85 79.35 113.14 79.35C104.45 79.35 89.53 80.03 78.41 83.37L77.56 83.61C68.91 86.11 64.6 88.32 61.39 95.18C59.03 100.15 58.79 108.18 58.79 114.09C59.5 129.92 61.86 143.63 66.59 148.83L66.77 149.05C70.57 153.61 76.81 155.44 95.66 155.44C119.76 154.73 140.32 151.19 146.94 141.74C150.48 136.54 151.66 129.92 151.66 120.7C151.66 103.45 149.3 90.93 143.63 85.26ZM107.24 27.36C107.24 25.53 105.68 23.92 103.87 23.82C101.99 23.77 100.27 25.26 100.15 27.16C100.15 27.23 100.15 27.3 100.15 27.36C100.15 29.42 101.92 30.82 103.54 30.9L103.69 30.91C105.53 30.91 107.14 29.34 107.23 27.52L107.24 27.36Z'
        fill='#171717'
      />
      <path
        d='M92.38 114.38C91.76 109.22 89.96 101.34 83.84 101.57C78.41 102.04 75.33 107.95 76.04 116.45C76.52 122.6 79.11 129.22 84.31 129.22C91.63 129.7 92.94 121.33 92.53 115.74C92.5 115.36 92.45 114.91 92.38 114.38Z'
        fill='#171717'
      />
      <path
        d='M106.08 135.14C104.87 135.17 103.54 135.18 102.04 135.13C101.58 135.13 101.07 135.08 100.53 135.04C98.28 134.85 95.66 134.63 95.66 137.49C95.66 141.51 100.86 144.58 107.23 145.05C115.51 145.29 120.94 139.38 120.7 136.31C120.7 134.66 119.76 133 117.63 133.47C117.05 133.59 116.48 133.71 115.93 133.82C112.84 134.47 109.93 135.02 106.08 135.14Z'
        fill='#171717'
      />
      <path
        d='M126.85 97.32C120.09 97.91 118.75 106.77 119.29 112.17L119.33 112.52C119.84 116.73 121.5 122.18 124.96 124.02C127.32 125.67 131.57 125.2 133.23 123.31C135.59 120.95 136.3 116.22 136.06 112.2C135.83 106.77 133.47 97.55 126.85 97.32Z'
        fill='#171717'
      />
      <path
        d='M185.22 73.44C174.35 74.15 165.13 91.64 162.06 104.87C161.12 109.83 163.24 114.09 166.31 117.4C167.35 118.26 168.44 119.03 169.5 119.77C172.79 122.07 175.77 124.16 175.77 128.27C175.64 141.82 163.3 156.58 154.5 165.84C149.06 171.75 145.75 174.58 138.9 170.57C131.81 165.84 124.96 164.19 117.16 171.28C113.85 174.35 109.6 179.31 106.76 183.09C108.18 186.16 109.36 189.47 109.36 194.91C109.13 199.4 107.24 204.6 104.4 209.09C124.53 231.46 155.46 220.91 173.89 202.64C178.18 198.38 182.19 193.8 185.22 189.71C185.57 189.24 185.58 189.05 185.22 188.76C181.44 185.69 178.13 179.78 178.13 171.51C178.13 160.17 186.39 147.98 197.03 146.46C200.5 145.97 203.65 145.75 209.56 147.41C214.28 135.59 217.83 122.83 217.59 111.25C217.59 89.75 201.76 73.92 185.22 73.44Z'
        fill='#171717'
      />
      <path
        d='M201.76 151.19C194.67 150.96 188.76 154.97 185.69 162.06C182.85 169.15 183.56 177.19 189.94 183.09C192.31 185.46 195.38 188.29 201.76 187.82C206.34 186.9 210.7 184.44 213.54 179.98C217.79 173.22 219.34 163.5 213.58 157.1C212.87 156.15 211.21 154.5 209.32 153.55C206.72 151.9 204.12 151.19 201.76 151.19Z'
        fill='#171717'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M151.95 36.39C145.29 34.14 138.25 32.75 131.23 31.99C133.6 15.55 120.53 0 103.69 0C88.01 0 77.06 12.28 75.72 25.02C75.4 28 75.67 31.07 76.38 33.98C72.14 34.58 67.91 35.26 63.73 36.16L63.7 36.17L63.67 36.17C41.53 41.02 21.09 49.67 12.54 73.36C6.35 88.52 6.84 106.75 6.62 122.83L7.14 136.86C3.18 144.41 0 153.46 0 163.95C0 177.2 4.61 190.6 13.31 200.68C31 221.25 69.48 237.24 97.82 227.37C107.06 234.7 119.55 239.95 133.78 239.99C152.32 240.28 166.93 232.39 177.97 223.12C184.19 217.97 190.49 211.59 195.61 205.44C209.56 207 220.45 197.5 226 187.82C232.49 176.5 235 165 228.72 147.33C232.66 136.16 235.73 123.51 235.5 111.05C235.4 81.27 213.17 56.32 185.73 55.54C183.2 55.59 180.73 55.87 178.28 56.53C171.91 47.11 162.7 40.08 151.95 36.39ZM185.22 73.44C174.35 74.15 165.13 91.64 162.06 104.87C161.12 109.83 163.24 114.09 166.31 117.4C167.35 118.26 168.44 119.03 169.5 119.77C172.79 122.07 175.77 124.16 175.77 128.27C175.64 141.82 163.3 156.58 154.5 165.84C149.06 171.75 145.75 174.58 138.9 170.57C131.81 165.84 124.96 164.19 117.16 171.28C113.85 174.35 109.6 179.31 106.76 183.09C108.18 186.16 109.36 189.47 109.36 194.91C109.13 199.4 107.24 204.6 104.4 209.09C124.53 231.46 155.46 220.91 173.89 202.64C178.18 198.38 182.19 193.8 185.22 189.71C185.57 189.24 185.58 189.05 185.22 188.76C181.44 185.69 178.13 179.78 178.13 171.51C178.13 160.17 186.39 147.98 197.03 146.46C200.5 145.97 203.65 145.75 209.56 147.41C214.28 135.59 217.83 122.83 217.59 111.25C217.59 89.75 201.76 73.92 185.22 73.44ZM201.76 151.19C194.67 150.96 188.76 154.97 185.69 162.06C182.85 169.15 183.56 177.19 189.94 183.09C192.31 185.46 195.38 188.29 201.76 187.82C206.34 186.9 210.7 184.44 213.54 179.98C217.79 173.22 219.34 163.5 213.58 157.1C212.87 156.15 211.21 154.5 209.32 153.55C206.72 151.9 204.12 151.19 201.76 151.19ZM17.91 164.38C18.01 173.45 21.1 182.05 26.89 189C37.05 200.81 55.96 210.5 79.59 211.92C83.13 212.16 87.15 211.69 90.22 210.98C98.49 208.85 103.45 202.71 103.45 195.14C103.45 189 98.97 179.31 85.97 177.66C70.77 176.44 55.49 174.06 45.32 161.35C51.7 165.37 62.57 169.86 81.24 170.57C90.45 170.57 95.37 172.38 103.44 175.61L103.64 175.39C111.11 167.01 116.99 160.41 128.03 160.41C134.03 160.26 138.13 162.49 141.05 164.08C142.72 164.99 144.01 165.69 145.05 165.6C148.35 165.37 164.66 145.04 168.68 132.99C169.3 130.93 169.38 129.22 169.38 128.51C169.39 126.95 167.21 125.55 165.78 124.63L165.76 124.62C165.53 124.47 165.31 124.33 165.13 124.21C164.41 123.71 163.73 123.25 163.24 122.83C158.75 119.52 154.97 114.09 154.97 108.42C154.97 99.44 160.88 86.91 167.97 75.33C164.99 67.55 159.13 58.21 147.37 53.77L146.81 53.56C133.95 49.07 118.23 48.45 104.64 49.81L106.53 36.82C109.6 35.87 113.62 33.03 113.62 27.84C113.85 23.18 109.96 18.07 103.98 17.91L103.69 17.91C98.02 17.91 94 22.4 93.53 26.89C93.29 31.38 96.13 34.92 99.44 36.58L97.31 49.81C87.86 50.52 78.88 51.47 68.95 53.36C61.86 54.89 54.54 56.48 47.99 59.7C39.44 63.94 32.74 69.82 29.25 79.82C25.71 88.09 24.76 105.58 24.53 123.07L25.24 141.26C20.98 148.21 17.91 155.63 17.91 163.95L17.91 164.38Z'
        fill='white'
      />
    </svg>
  )
}

export function CrowdStrikeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='10.639 -145.334 703.607 703.607'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m152.8 23.6c-.8.8.3 4.4 1.3 4.4.5 0 .9.5.9 1.2 0 1.5 7.2 15.9 8.8 17.6.6.7 1.2 1.7 1.2 2.2 0 1.3 8.6 13.7 12.8 18.4 10 11.2 28.2 28.1 35.2 32.7 1.4.9 3.9 2.9 5.5 4.3 1.7 1.5 4.8 3.9 7 5.4s4.9 3.5 5.9 4.4c1.1 1 3.8 3 6 4.5 2.3 1.6 5 3.6 6 4.5 1.1 1 3.8 3 6 4.5 2.3 1.5 4.3 3 4.6 3.3s3.7 3 7.5 6c3.9 3 7.5 5.9 8.1 6.5.6.5 4.6 4.1 8.9 8 14.6 13.1 25.8 25.3 32.6 35.5 6.6 10 9.2 14.4 15.1 25.8 3.1 6.2 7.7 14.4 10 18.3 2.4 3.9 5.4 8.9 6.7 11.2s3 4.8 3.8 5.5c.7.7 1.3 1.8 1.3 2.3s.5 1.5 1 2.2c.6.7 5.3 7.7 10.6 15.7 16.9 25.6 40.1 46 62.9 55.1 10.8 4.3 33.4 6 63 4.7 20.6-.8 44.2-.2 48.3 1.3 1.3.5 4.2.9 6.5.9 2.3.1 6 .7 8.2 1.5s4.9 1.5 6 1.5 3.3.7 4.9 1.5c1.5.8 3.5 1.5 4.3 1.5 1.6 0 7.1 2.4 19.8 8.6 18.3 9.1 33.1 19.9 48.7 35.6 10.4 10.5 10.8 10.8 11.4 8.2.8-3.1-.2-13.7-1.5-16.1-.5-1-2-4.1-3.3-6.8-2.5-5.6-7.2-12.3-14.2-20.4-2.7-3.3-4.6-6.5-4.6-7.9 0-4.1-3.9-10.5-8.5-13.9-5.8-4.3-23.6-13.3-26.3-13.3-.5 0-2.3-.7-3.8-1.5-1.6-.8-3.7-1.5-4.7-1.5-.9 0-2.5-.4-3.5-.9-.9-.5-5.1-1.9-9.2-3.1-13.7-4.1-22.5-7.2-25.6-9.1-3.3-2-6.4-7.2-6.4-10.7 0-2.6 3.8-14.4 5-15.6.6-.6 1-1.7 1-2.5 0-.9.6-2.8 1.4-4.3.8-1.4 1.9-5.8 2.6-9.7 3.3-19.4-7.2-31.8-41-48.7-4.5-2.2-12.7-5.9-16.5-7.5-1.1-.4-4.1-1.7-6.7-2.8-2.6-1.2-5.4-2.1-6.2-2.1s-1.8-.5-2.1-1c-.3-.6-1.3-1-2.2-1-.8 0-2.9-.6-4.6-1.4-1.8-.8-10.4-3.8-19.2-6.6-8.8-2.9-16.7-5.6-17.6-6-.9-.5-3.4-1.2-5.5-1.6-2.2-.3-4.3-1-4.9-1.4-.5-.4-2.6-1.1-4.5-1.4-1.9-.4-4.4-1.1-5.5-1.6-1.1-.4-4-1.3-6.5-2-2.5-.6-6.3-1.6-8.5-2.1-2.2-.6-4.9-1.5-6-1.9-1.1-.5-3.6-1.2-5.5-1.6-1.9-.3-4.1-1-5-1.4-.8-.4-4.9-1.8-9-3s-8.2-2.5-9-2.9c-.9-.5-3.1-1.2-5-1.6s-3.9-1-4.5-1.4c-.5-.4-4.4-1.8-8.5-3.1-4.1-1.2-7.9-2.6-8.5-3-.5-.4-3.9-1.7-7.5-3s-6.9-2.7-7.4-3.2c-.6-.4-1.6-.8-2.4-.8-2 0-11.4-4.3-35.2-15.9-16.7-8.2-32.1-16.6-35.5-19.3-.5-.4-4.6-3.1-9-6s-8.4-5.6-9-6c-.5-.4-5.2-3.9-10.4-7.8-18.1-13.5-44.4-38.8-55.5-53.5-2.1-2.8-3.9-5.1-4-5.3-.2-.1-.5.1-.8.4zm447.2 303c10.2 3.4 13.5 6 15.9 12.1 2.4 5.9-1.6 7.3-6.5 2.2-1.6-1.7-4.5-4-6.4-5.2s-4.1-2.7-4.8-3.4-1.9-1.3-2.7-1.3c-1.3 0-2.5-2.1-2.5-4.6 0-1.8 1.4-1.8 7 .2zm-519-240c0 1.1 8.5 17.9 10 19.7.6.7 2.7 3.4 4.7 6.2 7.3 9.8 18.7 21.5 33.9 34.5 3.8 3.3 14.2 11.1 17.5 13.2 1.4.9 3.2 2.3 4 3 .8.8 3.2 2.5 5.4 3.8s4.2 2.7 4.5 3c.6.8 30.1 18.3 39.5 23.5 7.4 4.2 15.4 8.2 43.5 21.9 16.5 8.1 19.6 9.7 31.7 17 9.1 5.5 23.7 16.9 31 24.2 4.1 4.1 7.6 7.4 7.8 7.4.3 0-.1-1.1-.7-2.5s-1.5-2.5-2-2.5c-.4 0-.8-.6-.8-1.3 0-.8-.9-2.5-2-3.8s-2.3-2.9-2.7-3.4c-7.3-9.6-13.3-15.4-31.7-31-2.5-2.2-19-13.4-26.7-18.2-6.1-3.9-18.4-10.8-30.9-17.5-3-1.7-5.9-3.4-6.5-3.8-.9-.7-5.2-3-19.5-10.8-9-4.8-31.8-18.9-35.5-21.9-.5-.5-2.8-2-5-3.3s-4.4-2.8-5-3.2c-.5-.4-5.9-4.4-12-8.9-6-4.5-11.2-8.5-11.5-8.8-.3-.4-2.7-2.4-5.5-4.5-5.6-4.2-12.8-10.8-26.2-24-5.1-5-9.3-8.6-9.3-8zm113.6 179.1c-1 1 15.8 16.6 26.9 24.9 5.5 4.1 10.5 7.8 11 8.2 2.6 2 11.6 7.2 12.4 7.2.5 0 1.6.6 2.3 1.2.7.7 2.9 2 4.8 3 13.3 6.3 19 8.8 20.4 8.8.8 0 1.7.4 2 .8.8 1.3 32.3 11.2 35.8 11.2 1 0 2.6.4 3.6 1 .9.5 3.7 1.4 6.2 1.9 8.7 1.9 13.5 3.1 15.5 4 1.1.5 5.4 1.9 9.5 3.2s7.9 2.6 8.5 3.1c.5.4 1.5.8 2.3.8s2.8.6 4.5 1.4c16.4 7.1 20.8 8.8 21.4 8.3.3-.4-.7-1.7-2.3-2.9-2.5-2-6.9-5.9-16.4-14.8-1.5-1.4-4.2-3.8-6-5.4-5-4.3-26-19.9-30.5-22.6-2.2-1.3-4.2-2.7-4.5-3-.3-.4-1.2-1-2-1.4s-4.2-2.2-7.5-4.1c-6.2-3.6-18.9-9.9-26-12.9-2.2-.9-4.7-2.1-5.5-2.5-.9-.5-3-1.2-4.8-1.5-1.7-.4-3.4-1.2-3.7-1.7-.4-.5-1.6-.9-2.8-.9-2.2.1-2.2.1-.2 1.2 1.1.6 2.2 1.4 2.5 1.8.3.3 2.5 1.8 5 3.3 5.3 3.1 15 11.7 15 13.3 0 .6-.7 1.7-1.5 2.4-1.2 1-4.1.9-14.5-.4-7.2-.9-14.1-2.1-15.3-2.6-1.2-.4-4.7-1.6-7.7-2.5-15.6-4.7-47-22.1-56.1-31-.9-.8-1.9-1.2-2.3-.8z'
        fill='currentColor'
      />
    </svg>
  )
}

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <circle cx='11' cy='11' r='8' />
      <path d='m21 21-4.3-4.3' />
    </svg>
  )
}

export function AgentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='21'
      height='24'
      viewBox='0 0 21 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.67 9.25H4.67C2.64 9.25 1 10.89 1 12.92V18.42C1 20.44 2.64 22.08 4.67 22.08H15.67C17.69 22.08 19.33 20.44 19.33 18.42V12.92C19.33 10.89 17.69 9.25 15.67 9.25Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.17 5.58C11.18 5.58 12 4.76 12 3.75C12 2.74 11.18 1.92 10.17 1.92C9.15 1.92 8.33 2.74 8.33 3.75C8.33 4.76 9.15 5.58 10.17 5.58Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.17 5.59V9.25M7.42 16.59V14.75M12.92 14.75V16.59'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function ApiIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.61 24.39C8.5 27.28 12.47 25.47 13.56 24.39L15.72 22.22L7.78 14.28L5.61 16.44C4.53 17.53 2.72 21.5 5.61 24.39ZM5.61 24.39L2 28M24.39 5.61C21.5 2.72 17.53 4.53 16.44 5.61L14.28 7.78L22.22 15.72L24.39 13.56C25.47 12.47 27.28 8.5 24.39 5.61ZM24.39 5.61L28 2M15.72 9.22L12.83 12.11M20.78 14.28L17.89 17.17'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function ConditionalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='28'
      height='29'
      viewBox='0 0 28 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.1 1.02C22.18 1.01 21.29 1.34 20.59 1.93C19.89 2.52 19.41 3.34 19.26 4.25C19.1 5.15 19.27 6.09 19.74 6.88C20.2 7.67 20.93 8.27 21.8 8.58V12.72H6.2V8.58C7.07 8.27 7.8 7.67 8.26 6.87C8.73 6.08 8.9 5.15 8.74 4.24C8.59 3.33 8.12 2.51 7.41 1.92C6.71 1.33 5.82 1 4.9 1C3.98 1 3.09 1.33 2.39 1.92C1.68 2.51 1.21 3.33 1.06 4.24C0.9 5.15 1.07 6.08 1.54 6.87C2 7.67 2.73 8.27 3.6 8.58V12.72C3.6 13.41 3.87 14.07 4.36 14.56C4.85 15.04 5.51 15.32 6.2 15.32H12.7V20.76C11.83 21.06 11.1 21.67 10.64 22.46C10.17 23.25 10 24.19 10.16 25.09C10.31 26 10.78 26.82 11.49 27.42C12.19 28.01 13.08 28.33 14 28.33C14.92 28.33 15.81 28.01 16.51 27.42C17.22 26.82 17.69 26 17.85 25.09C18 24.19 17.83 23.25 17.36 22.46C16.9 21.67 16.17 21.06 15.3 20.76V15.32H21.8C22.49 15.32 23.15 15.04 23.64 14.56C24.13 14.07 24.4 13.41 24.4 12.72V8.58C25.27 8.27 26 7.67 26.46 6.88C26.93 6.09 27.1 5.15 26.94 4.25C26.79 3.34 26.32 2.52 25.61 1.93C24.91 1.34 24.02 1.01 23.1 1.02ZM4.9 6.22C4.64 6.22 4.39 6.14 4.18 6C3.96 5.85 3.8 5.65 3.7 5.41C3.6 5.18 3.58 4.91 3.63 4.66C3.68 4.41 3.8 4.18 3.98 4C4.16 3.82 4.39 3.69 4.65 3.64C4.9 3.59 5.16 3.62 5.4 3.72C5.64 3.81 5.84 3.98 5.98 4.19C6.12 4.41 6.2 4.66 6.2 4.92C6.2 5.26 6.06 5.59 5.82 5.84C5.58 6.08 5.25 6.22 4.9 6.22ZM14 25.72C13.74 25.72 13.49 25.64 13.28 25.5C13.06 25.36 12.9 25.15 12.8 24.92C12.7 24.68 12.68 24.42 12.73 24.16C12.78 23.91 12.9 23.68 13.08 23.5C13.26 23.32 13.5 23.19 13.75 23.14C14 23.09 14.26 23.12 14.5 23.22C14.74 23.32 14.94 23.48 15.08 23.7C15.22 23.91 15.3 24.16 15.3 24.42C15.3 24.76 15.16 25.09 14.92 25.34C14.68 25.58 14.35 25.72 14 25.72ZM23.1 6.22C22.84 6.22 22.59 6.14 22.38 6C22.17 5.85 22 5.65 21.9 5.41C21.8 5.18 21.78 4.91 21.83 4.66C21.88 4.41 22 4.18 22.18 4C22.36 3.82 22.6 3.69 22.85 3.64C23.1 3.59 23.36 3.62 23.6 3.72C23.84 3.81 24.04 3.98 24.18 4.19C24.33 4.41 24.4 4.66 24.4 4.92C24.4 5.26 24.26 5.59 24.02 5.84C23.78 6.08 23.45 6.22 23.1 6.22Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.25'
      />
    </svg>
  )
}

export function CredentialIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='8' cy='15' r='4' stroke='currentColor' strokeWidth='1.75' />
      <path d='M11.83 13.17L20 5' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' />
      <path
        d='M18 7l2 2'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 10l2 2'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function NoteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='4'
        y='3'
        width='16'
        height='18'
        rx='2.5'
        stroke='currentColor'
        strokeWidth='1.5'
        fill='none'
      />
      <path d='M15 3H18C18.55 3 19 3.45 19 4V7L15 3Z' fill='currentColor' />
      <path d='M8 11H15.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      <path d='M8 15H13' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  )
}

export function WorkdayIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `workday_clip_${id}`
  return (
    <svg {...props} viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath={`url(#${clipId})`} transform='matrix(0.53,0,0,0.53,-124.64,-16)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m 251.21,88.78 h 8.22 c 1.17,0 2.18,0.78 2.44,1.89 l 11.06,44.68 c 0.15,0 12.18,-44.64 12.18,-44.64 0.31,-1.14 1.36,-1.93 2.57,-1.93 h 12.74 c 1.14,0 2.14,0.75 2.44,1.83 l 12.12,44.93 c 0.45,-0.28 11.15,-44.87 11.15,-44.87 0.27,-1.11 1.28,-1.89 2.44,-1.89 h 8.22 c 1.65,0 2.85,1.52 2.44,3.07 l -15.08,56.32 c -0.29,1.07 -1.27,1.82 -2.41,1.83 l -12.44,-0.02 c -1.14,0 -2.14,-0.74 -2.43,-1.82 -2.13,-7.8 -12.6,-47.28 -12.6,-47.28 0,0 -11.01,39.47 -13.13,47.28 -0.29,1.08 -1.29,1.82 -2.43,1.82 L 266.26,150 c -1.13,-0.01 -2.12,-0.76 -2.41,-1.83 L 248.78,91.84 c -0.42,-1.55 0.79,-3.07 2.43,-3.07 z'
          fill='#005cb9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m 333.32,72.24 c 0.53,0 1.07,-0.07 1.61,-0.22 3.18,-0.9 5.04,-4.23 4.15,-7.45 -0.13,-0.47 -0.26,-0.93 -0.41,-1.39 C 332.53,43.33 314.57,30 293.99,30 c -20.56,0 -38.51,13.31 -44.67,33.13 -0.14,0.44 -0.27,0.88 -0.39,1.32 -0.9,3.21 0.94,6.55 4.12,7.46 3.17,0.91 6.48,-0.95 7.38,-4.17 0.09,-0.33 0.19,-0.66 0.29,-0.99 4.59,-14.76 17.96,-24.67 33.27,-24.67 15.33,0 28.7,9.93 33.28,24.71 0.11,0.34 0.21,0.68 0.3,1.03 0.74,2.67 3.14,4.42 5.76,4.42 z'
          fill='#f38b00'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <path d='M 354,30 H 234 v 120 h 120 z' fill='#ffffff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function WorkflowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='30'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        className='a'
        cx='12'
        cy='6'
        r='3'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        className='a'
        height='5'
        rx='2'
        width='8'
        x='2'
        y='16'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        className='a'
        height='5'
        rx='2'
        width='8'
        x='14'
        y='16'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='a'
        d='M6,16V14a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <line
        className='a'
        x1='12'
        x2='12'
        y1='9'
        y2='12'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function SignalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='29'
      height='35'
      viewBox='0 0 29 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.96 33.2C26.25 28.42 27.5 23.22 27.5 17.6C27.5 11.98 26.25 6.58 23.96 2M16.48 29.66C18.14 25.92 19.18 21.76 19.18 17.6C19.18 13.44 18.14 9.07 16.48 5.33M8.99 26.13C10.24 23.42 10.86 20.51 10.86 17.6C10.86 14.69 10.24 11.57 8.99 9.07M1.5 22.38C2.12 20.93 2.54 19.26 2.54 17.6C2.54 15.94 2.12 14.06 1.5 12.61'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 4.89V2M8.5 4.89V2M2.36 9.22H27.64M2 12.17C2 9.12 2 7.59 2.63 6.42C3.2 5.38 4.08 4.55 5.15 4.04C6.39 3.44 8.01 3.44 11.24 3.44H18.76C21.99 3.44 23.61 3.44 24.85 4.04C25.93 4.56 26.82 5.4 27.37 6.42C28 7.59 28 9.12 28 12.18V19.27C28 22.33 28 23.85 27.37 25.02C26.8 26.06 25.92 26.9 24.85 27.41C23.61 28 21.99 28 18.76 28H11.24C8.01 28 6.39 28 5.15 27.4C4.08 26.9 3.2 26.06 2.63 25.02C2 23.85 2 22.32 2 19.27V12.17Z'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function MessagesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.89 15C6.28 13.96 8 13.45 9.73 13.57C11.47 13.7 13.1 14.44 14.33 15.67C15.56 16.9 16.3 18.53 16.43 20.26C16.55 22 16.04 23.72 15 25.11M4.89 15C3.99 15.67 3.26 16.54 2.76 17.55C2.26 18.55 2 19.66 2 20.78C2 21.5 2.11 22.22 2.32 22.92C2.72 24.19 2.43 25.6 2.18 26.94C2.16 27.05 2.17 27.17 2.2 27.28C2.24 27.39 2.3 27.49 2.39 27.57C2.47 27.65 2.58 27.7 2.69 27.73C2.81 27.75 2.92 27.75 3.04 27.72C4.26 27.38 5.48 27.1 6.73 27.56C7.53 27.85 8.37 28 9.22 28C10.34 28 11.45 27.74 12.45 27.24C13.46 26.74 14.33 26.01 15 25.11M4.89 15C4.89 8.23 9.04 2 16.44 2C18.3 2 20.12 2.45 21.77 3.3C23.41 4.15 24.83 5.39 25.89 6.9C26.96 8.42 27.65 10.17 27.9 12C28.14 13.84 27.95 15.71 27.32 17.45C26.63 19.37 27.38 21.93 27.81 24.05C27.83 24.16 27.83 24.28 27.79 24.39C27.76 24.5 27.69 24.6 27.61 24.68C27.52 24.76 27.42 24.81 27.31 24.83C27.19 24.86 27.07 24.85 26.97 24.81C25.07 24.22 22.85 23.39 21.07 24.14C19.14 24.95 17.11 25.11 15 25.11'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function NotificationsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='33'
      viewBox='0 0 30 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.91 24.75H10.09M19.91 24.75H25.78C28.83 24.75 28.31 21.73 26.77 20.19C21.22 14.68 29.1 2 15 2C0.89 2 8.78 14.67 3.23 20.19C1.74 21.67 1.11 24.75 4.22 24.75H10.09M19.91 24.75C19.91 27.88 18.85 31.25 15 31.25C11.14 31.25 10.09 27.88 10.09 24.75'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function MailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='24'
      viewBox='0 0 30 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.36 5.83L11.77 12.11C13.07 12.97 13.71 13.4 14.42 13.57C15.04 13.72 15.68 13.72 16.3 13.57C17 13.4 17.65 12.97 18.95 12.11L28.36 5.83M8.83 21.72H21.89C24.15 21.72 25.28 21.72 26.15 21.28C26.91 20.89 27.53 20.27 27.92 19.51C28.36 18.65 28.36 17.52 28.36 15.25V7.97C28.36 5.71 28.36 4.57 27.92 3.71C27.53 2.95 26.91 2.33 26.15 1.94C25.28 1.5 24.15 1.5 21.89 1.5H8.83C6.56 1.5 5.43 1.5 4.57 1.94C3.81 2.33 3.19 2.95 2.8 3.71C2.36 4.57 2.36 5.71 2.36 7.97V15.25C2.36 17.52 2.36 18.65 2.8 19.51C3.19 20.27 3.8 20.89 4.57 21.28C5.43 21.72 6.56 21.72 8.83 21.72Z'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function InstantlyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 766.8 766.8' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='383.4' cy='383.4' r='383.4' fill='#0081ff' />
      <path
        d='M276.12 438.81h-101.8c-3.58 0-5.83-3.87-4.05-6.98l163.07-284.97h238.63c3.87 0 6.06 4.44 3.69 7.51L459.07 305.59c-2.36 3.07-.18 7.51 3.69 7.51h124.51c4.2 0 6.26 5.11 3.23 8.02L235.8 662.51c-3.37 3.24-8.88.06-7.76-4.48l52.61-213.45c.72-2.93-1.5-5.77-4.53-5.77z'
        fill='#fff'
      />
    </svg>
  )
}

export function EmailBisonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='-66 -2 88 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 0 C1 2.3 2 4.6 3 7 C7 8.8 7 8.8 11.7 9.9 C13.2 10.3 14.8 10.7 16.4 11.2 C17.6 11.4 18.8 11.7 20 12 C21.5 38 21.5 38 15.8 45.1 C11 49 11 49 7 50 C5.3 49.3 3.7 48.7 2 48 C2 46 2 44 2 42 C0.7 42.3 -0.6 42.7 -2 43 C-1 49.1 0.8 54.3 3 60 C-1 61 -1 61 -7 58 C-7 56.3 -7 54.7 -7 53 C-7.7 54 -8.3 55 -9 56 C-9.7 56.8 -9.7 56.8 -13 61 C-18 60 -18 60 -21 57 C-21.2 56.1 -21.2 56.1 -22 51.3 C-26.1 42.7 -31.1 41.6 -39.7 38.3 C-44 37 -44 37 -47 37 C-53.6 45.2 -56 50.5 -55 61 C-57 60.7 -59 60.3 -61 60 C-65.9 51.1 -63 42.4 -61 33 C-62 34 -63 35 -64 36 C-64.7 36 -65.3 36 -66 36 C-64.4 29.7 -62.6 24 -60 18 C-56.3 16 -52.5 14 -48.6 12.2 C-44 10 -44 10 -39.6 7.3 C-26.4 -0.8 -15.2 -1.1 0 0 Z M-61 27 C-61.3 28 -61.7 29 -62 30 C-61.3 30 -60.7 30 -60 30 C-60.3 29 -60.7 28 -61 27 Z M-7 50 C-6 52 -6 52 -6 52 Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function MailServerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='3'
        y='4'
        width='18'
        height='16'
        rx='2'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 8L10.89 13.26C11.22 13.48 11.6 13.6 12 13.6C12.4 13.6 12.78 13.48 13.11 13.26L21 8'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <line
        x1='7'
        y1='16'
        x2='7'
        y2='16'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='10'
        y1='16'
        x2='10'
        y2='16'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  )
}

export function CodeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='27'
      viewBox='0 0 30 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.26 6.83L23.64 7.2C26.54 10.11 28 11.56 28 13.37C28 15.18 26.54 16.63 23.64 19.54L23.26 19.91M18.04 2L11.95 24.74M6.73 6.83L6.36 7.2C3.45 10.11 2 11.56 2 13.37C2 15.18 3.45 16.63 6.36 19.54L6.73 19.91'
        stroke='currentColor'
        strokeWidth='2.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function ChartBarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='22'
      viewBox='0 0 24 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.4 0C14.91 0 15.41 0.21 15.77 0.59C16.13 0.96 16.33 1.47 16.33 2V6.5H21.6C22.11 6.5 22.61 6.71 22.97 7.09C23.33 7.46 23.53 7.97 23.53 8.5V19.2C23.53 19.73 23.33 20.24 22.97 20.61C22.61 20.99 22.11 21.2 21.6 21.2H2.4C1.89 21.2 1.39 20.99 1.03 20.61C0.67 20.24 0.47 19.73 0.47 19.2V12C0.47 11.47 0.67 10.96 1.03 10.59C1.39 10.21 1.89 10 2.4 10H7.67V2C7.67 1.47 7.87 0.96 8.23 0.59C8.59 0.21 9.09 0 9.6 0H14.4ZM14.4 2.4H9.6V19.2H14.4V2.4ZM21.6 8.9H16.33V19.2H21.6V8.9ZM7.67 12.5H2.4V19.2H7.67V12.5Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function HarmonicIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 1 26 30.1' fill='none' role='img' xmlns='http://www.w3.org/2000/svg'>
      {/** svg-path-precision-exception: Preserves Harmonic's supplied brand-mark coordinates. */}
      <path
        d='M6.49743 1.08252L12.9949 4.83381V12.3364L6.49743 16.0877L0 12.3364V4.83381L6.49743 1.08252Z'
        fill='#FE5D45'
      />
      {/** svg-path-precision-exception: Preserves Harmonic's supplied brand-mark coordinates. */}
      <path
        d='M6.49743 16.0874L12.9949 19.8387V27.3413L6.49743 31.0926L0 27.3413V19.8387L6.49743 16.0874Z'
        fill='#FE5D45'
      />
      {/** svg-path-precision-exception: Preserves Harmonic's supplied brand-mark coordinates. */}
      <path
        d='M19.5026 8.58496L26 12.3363V19.8388L19.5026 23.5901L13.0051 19.8388V12.3363L19.5026 8.58496Z'
        fill='#FE5D45'
      />
    </svg>
  )
}

export function HubspotIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      role='img'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
    >
      <path d='M18.164 7.93V5.084a2.198 2.198 0 0 0 1.27-1.978v-.067A2.2 2.2 0 0 0 17.238.845h-.067a2.2 2.2 0 0 0-2.193 2.194v.067a2.196 2.196 0 0 0 1.27 1.978v2.85a6.21 6.21 0 0 0-2.974 1.31L5.443.515A2.5 2.5 0 1 0 4.3 4.664l-.123.013 7.728 6.013a6.182 6.182 0 0 0-1.043 3.45c0 1.336.43 2.605 1.157 3.62l-2.35 2.348a2.022 2.022 0 0 0-.585-.1 2.026 2.026 0 1 0 2.026 2.026 1.98 1.98 0 0 0-.1-.584l2.318-2.323A6.249 6.249 0 1 0 18.166 7.93Zm-.96 9.371a3.21 3.21 0 1 1 0-6.421 3.21 3.21 0 0 1 0 6.42z' />
    </svg>
  )
}

export function FirecrawlIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='30.778 11.238 575.239 571.826' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M301 63C299 91 303 122 298 149C295 158 289 165 283 169C274 172 266 170 261 167C253 176 248 183 244 191C230 226 226 263 226 301C216 310 203 317 192 310C179 295 175 277 174 259C161 273 153 288 146 304C141 321 138 336 137 352C140 372 145 388 152 402C161 421 174 435 187 449C181 462 165 453 157 450C158 454 161 458 165 461C195 490 231 500 268 509C240 494 211 471 195 442C179 413 172 378 180 344C191 353 200 362 211 364C223 365 232 361 236 353C247 274 299 214 323 143C322 136 327 140 329 142C354 165 367 191 375 218C387 254 381 294 379 329C393 345 413 334 424 329C429 342 432 352 429 362C427 378 417 388 413 400C422 407 433 403 440 400C432 423 419 442 404 460C383 483 358 501 335 512C379 502 420 491 449 459C443 458 427 464 428 452C443 437 464 423 472 403C482 383 485 362 484 339C482 307 472 280 458 254C459 267 452 276 445 284C434 289 426 279 424 272C415 247 424 220 418 198C415 179 405 165 397 150C370 114 336 86 303 64'
        fill='rgb(253,76,31)'
      />
      <path
        d='M324 141C303 214 249 273 244 354C235 359 229 364 223 366C205 367 193 357 182 347C180 350 179 353 180 357C178 374 178 390 182 403C185 421 193 434 200 448C212 465 227 480 243 491C258 500 269 513 285 512C284 508 257 485 252 468C241 450 235 433 233 414C241 415 254 420 263 412C260 387 265 363 273 343C281 323 293 306 310 295C317 289 324 285 330 282C328 307 328 331 329 355C330 368 332 379 338 389C358 394 376 384 388 370C383 386 377 401 371 415C376 414 381 411 385 408C383 421 380 431 376 441C366 467 356 491 334 510C358 499 381 483 400 461C418 442 430 423 440 403C432 404 421 410 413 404C414 386 428 377 427 360C429 349 428 340 424 332C413 336 404 341 392 339C386 338 381 334 379 330C380 292 385 248 371 214C366 195 358 180 349 165C341 155 333 145 323 140'
        fill='rgb(254,156,69)'
      />
      <path
        d='M330 284C309 293 289 311 279 332C267 356 261 383 265 411C256 420 242 418 235 412C237 438 245 459 258 479C269 493 281 507 295 513C288 495 265 472 265 446C272 447 281 454 288 444C296 425 303 407 309 388C317 406 321 427 336 443C346 449 358 446 363 438C355 464 348 489 334 511C344 501 352 491 357 480C370 457 379 435 385 412C380 411 376 416 371 418C376 401 382 386 387 371C379 382 369 388 358 391C348 394 337 392 334 383C324 353 328 316 330 285'
        fill='rgb(254,220,87)'
      />
      <path
        d='M311 389C303 407 297 426 289 445C282 454 273 450 268 445C267 472 285 492 302 512C299 514 297 514 294 514C297 514 299 514 301 514C314 515 325 512 334 513C341 495 355 467 362 443C357 446 351 448 344 447C337 446 334 441 330 438C320 422 316 406 311 391'
        fill='rgb(251,250,202)'
      />
      <path
        d='M187 163C188 181 167 187 164 203C158 215 158 228 159 241C172 233 183 221 188 209C193 194 192 178 188 166'
        fill='rgb(253,76,31)'
      />
    </svg>
  )
}

export function JinaAIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='14'
      viewBox='0 0 30 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.15 5.26C17.17 5.26 17.19 5.26 17.21 5.26C17.28 5.26 17.35 5.26 17.42 5.26C17.47 5.26 17.52 5.26 17.56 5.26C17.67 5.26 17.77 5.26 17.87 5.26C18 5.26 18.12 5.26 18.25 5.26C19.3 5.25 20.25 5.39 21.06 6.12C21.1 6.15 21.13 6.17 21.16 6.2C21.83 6.79 22.21 7.69 22.27 8.57C22.28 8.74 22.28 8.91 22.28 9.08C22.28 9.13 22.28 9.19 22.28 9.24C22.28 9.35 22.28 9.47 22.28 9.58C22.28 9.72 22.28 9.86 22.28 10.01C22.28 10.12 22.28 10.23 22.28 10.34C22.28 10.39 22.28 10.45 22.28 10.5C22.28 10.57 22.28 10.64 22.28 10.72C22.28 10.74 22.28 10.76 22.28 10.78C22.28 10.94 22.24 11.06 22.13 11.18C21.99 11.29 21.9 11.31 21.72 11.31C21.69 11.31 21.69 11.31 21.66 11.31C21.59 11.31 21.52 11.31 21.45 11.31C21.4 11.31 21.36 11.31 21.31 11.31C21.17 11.31 21.04 11.31 20.91 11.31C20.83 11.31 20.75 11.31 20.66 11.31C20.41 11.31 20.15 11.31 19.89 11.31C19.59 11.31 19.3 11.31 19 11.32C18.77 11.32 18.54 11.32 18.31 11.32C18.17 11.32 18.03 11.32 17.9 11.32C17.77 11.32 17.64 11.32 17.51 11.32C17.46 11.32 17.41 11.32 17.37 11.32C17.3 11.32 17.24 11.32 17.17 11.32C17.13 11.32 17.1 11.32 17.06 11.32C16.93 11.3 16.83 11.26 16.74 11.17C16.62 11.03 16.61 10.92 16.61 10.74C16.61 10.71 16.61 10.71 16.61 10.68C16.61 10.61 16.61 10.53 16.61 10.46C16.61 10.41 16.61 10.36 16.61 10.3C16.6 10.13 16.6 9.96 16.6 9.79C16.6 9.73 16.6 9.67 16.6 9.61C16.6 9.33 16.6 9.06 16.6 8.78C16.6 8.46 16.6 8.14 16.6 7.82C16.6 7.57 16.6 7.32 16.6 7.08C16.6 6.93 16.6 6.78 16.6 6.63C16.6 6.49 16.6 6.35 16.6 6.22C16.6 6.16 16.6 6.11 16.6 6.06C16.59 5.57 16.59 5.57 16.73 5.39C16.86 5.28 16.98 5.26 17.15 5.26Z'
        fill='currentColor'
      />
      <path
        d='M28.49 5.83C28.53 5.87 28.58 5.91 28.62 5.95C28.64 5.96 28.66 5.97 28.68 5.99C29.22 6.42 29.53 7.12 29.65 7.79C29.65 7.84 29.65 7.88 29.65 7.93C29.65 7.97 29.65 7.97 29.65 8.01C29.65 8.04 29.65 8.07 29.65 8.1C29.65 8.13 29.65 8.16 29.65 8.19C29.65 8.29 29.66 8.39 29.66 8.49C29.66 8.53 29.66 8.56 29.66 8.6C29.66 8.78 29.66 8.96 29.66 9.14C29.66 9.33 29.66 9.52 29.66 9.71C29.66 9.86 29.66 10 29.66 10.15C29.66 10.22 29.66 10.29 29.66 10.36C29.66 10.45 29.66 10.55 29.66 10.65C29.66 10.69 29.66 10.69 29.66 10.73C29.66 10.9 29.65 11 29.53 11.13C29.38 11.27 29.25 11.27 29.06 11.26C29.03 11.26 29 11.26 28.97 11.26C28.87 11.26 28.77 11.26 28.67 11.26C28.6 11.26 28.53 11.26 28.46 11.26C28.32 11.26 28.17 11.26 28.03 11.26C27.85 11.26 27.66 11.26 27.48 11.26C27.34 11.26 27.19 11.26 27.05 11.26C26.98 11.26 26.92 11.26 26.85 11.26C25.98 11.27 25.18 11.05 24.55 10.43C24.52 10.4 24.49 10.37 24.46 10.34C24.44 10.32 24.41 10.29 24.39 10.27C23.84 9.69 23.6 8.91 23.61 8.12C23.63 7.32 23.99 6.6 24.55 6.03C25.62 5.03 27.33 4.92 28.49 5.83Z'
        fill='currentColor'
      />
      <path
        d='M8.64 5.42C8.76 5.59 8.74 5.76 8.74 5.96C8.74 6 8.74 6.03 8.74 6.07C8.74 6.17 8.74 6.27 8.74 6.37C8.74 6.48 8.74 6.58 8.74 6.69C8.74 6.87 8.74 7.05 8.74 7.23C8.74 7.43 8.74 7.63 8.74 7.84C8.74 8.04 8.74 8.24 8.74 8.43C8.74 8.52 8.74 8.6 8.74 8.69C8.74 9.82 8.64 10.94 7.85 11.83C7.83 11.86 7.81 11.88 7.79 11.91C7.72 11.98 7.65 12.06 7.59 12.13C7.57 12.14 7.56 12.16 7.54 12.18C6.94 12.83 6 13.19 5.13 13.23C5.1 13.23 5.08 13.23 5.05 13.23C4.99 13.23 4.93 13.24 4.86 13.24C4.86 12.03 4.86 10.82 4.86 9.61C4.86 9.45 4.86 9.29 4.86 9.13C4.86 8.64 4.86 8.15 4.87 7.66C4.87 7.46 4.87 7.25 4.87 7.04C4.87 6.84 4.87 6.64 4.87 6.45C4.87 6.38 4.87 6.3 4.87 6.23C4.87 6.13 4.87 6.03 4.87 5.94C4.87 5.91 4.87 5.88 4.87 5.85C4.88 5.66 4.91 5.53 5.04 5.39C5.17 5.27 5.32 5.29 5.48 5.29C5.51 5.29 5.54 5.29 5.57 5.29C5.67 5.29 5.77 5.29 5.87 5.28C5.93 5.28 6 5.28 6.07 5.28C6.21 5.28 6.36 5.28 6.5 5.28C6.68 5.28 6.87 5.28 7.05 5.28C7.19 5.27 7.33 5.27 7.47 5.27C7.54 5.27 7.61 5.27 7.67 5.27C7.77 5.27 7.86 5.27 7.96 5.27C7.99 5.27 8.01 5.27 8.04 5.27C8.46 5.27 8.46 5.27 8.64 5.42Z'
        fill='currentColor'
      />
      <path
        d='M11.26 5.27C11.29 5.27 11.32 5.27 11.34 5.27C11.37 5.27 11.4 5.27 11.43 5.27C11.46 5.27 11.49 5.27 11.52 5.27C11.62 5.27 11.72 5.26 11.82 5.26C11.87 5.26 11.87 5.26 11.92 5.26C12.1 5.26 12.28 5.26 12.46 5.26C12.64 5.26 12.83 5.26 13.01 5.26C13.15 5.26 13.3 5.26 13.44 5.26C13.51 5.26 13.57 5.26 13.64 5.26C13.74 5.26 13.83 5.26 13.93 5.26C13.96 5.26 13.99 5.26 14.01 5.26C14.19 5.26 14.33 5.29 14.47 5.39C14.61 5.56 14.62 5.68 14.62 5.89C14.62 5.91 14.62 5.93 14.62 5.96C14.62 6.03 14.62 6.1 14.62 6.17C14.62 6.22 14.62 6.27 14.62 6.32C14.62 6.46 14.62 6.6 14.62 6.74C14.62 6.86 14.62 6.97 14.62 7.09C14.62 7.36 14.62 7.63 14.62 7.91C14.62 8.19 14.63 8.47 14.63 8.75C14.63 8.99 14.63 9.24 14.63 9.48C14.63 9.62 14.63 9.77 14.63 9.91C14.63 10.05 14.63 10.18 14.63 10.32C14.63 10.37 14.63 10.42 14.63 10.47C14.63 10.54 14.63 10.61 14.63 10.67C14.63 10.71 14.63 10.75 14.63 10.79C14.62 10.95 14.59 11.06 14.49 11.18C14.3 11.35 14.11 11.34 13.87 11.34C13.82 11.34 13.82 11.34 13.78 11.34C13.69 11.34 13.59 11.34 13.5 11.34C13.44 11.34 13.37 11.34 13.31 11.34C13.17 11.34 13.03 11.34 12.9 11.34C12.72 11.34 12.55 11.34 12.38 11.34C12.24 11.34 12.11 11.34 11.98 11.34C11.91 11.34 11.85 11.34 11.78 11.34C11.69 11.34 11.6 11.34 11.51 11.34C11.47 11.34 11.47 11.34 11.43 11.34C11.24 11.34 11.06 11.33 10.9 11.21C10.78 11.05 10.74 10.91 10.74 10.7C10.74 10.68 10.74 10.66 10.74 10.64C10.74 10.57 10.74 10.5 10.74 10.42C10.74 10.37 10.74 10.32 10.74 10.27C10.74 10.13 10.74 9.99 10.74 9.85C10.74 9.71 10.74 9.56 10.74 9.42C10.74 9.17 10.74 8.93 10.74 8.68C10.74 8.4 10.74 8.12 10.74 7.83C10.74 7.59 10.74 7.35 10.74 7.11C10.74 6.96 10.74 6.82 10.74 6.67C10.74 6.54 10.74 6.4 10.74 6.26C10.74 6.21 10.74 6.16 10.74 6.11C10.74 6.04 10.74 5.98 10.74 5.91C10.74 5.87 10.74 5.83 10.74 5.79C10.76 5.62 10.8 5.48 10.93 5.36C11.04 5.28 11.13 5.27 11.26 5.27Z'
        fill='currentColor'
      />
      <path
        d='M3.59 9.89C3.98 10.27 4.19 10.76 4.2 11.31C4.18 11.87 3.96 12.36 3.56 12.75C3.19 13.08 2.7 13.27 2.21 13.25C2.18 13.24 2.16 13.24 2.14 13.24C2.11 13.24 2.08 13.23 2.05 13.23C1.52 13.17 1.08 12.92 0.73 12.51C0.37 12.01 0.29 11.48 0.36 10.88C0.48 10.37 0.8 9.94 1.23 9.67C2 9.22 2.91 9.3 3.59 9.89Z'
        fill='currentColor'
      />
      <path
        d='M12.67 0.75C12.7 0.75 12.73 0.75 12.76 0.75C13.23 0.75 13.69 0.95 14.03 1.28C14.38 1.63 14.59 2.08 14.6 2.58C14.6 3.14 14.46 3.62 14.06 4.04C13.69 4.4 13.2 4.59 12.69 4.61C12.14 4.59 11.69 4.4 11.29 4.03C10.91 3.62 10.74 3.13 10.75 2.58C10.77 2.08 10.99 1.61 11.34 1.26C11.72 0.92 12.16 0.74 12.67 0.75Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function TranslateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <path d='m5 8 6 6' />
      <path d='m4 14 6-6 2-3' />
      <path d='M2 5h12' />
      <path d='M7 2h1' />
      <path d='m22 22-5-10-5 10' />
      <path d='M14 18h6' />
    </svg>
  )
}

export function SlackIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g>
        <path
          d='M53.84,161.32 C53.84,176.15 41.85,188.14 27.02,188.14 C12.19,188.14 0.2,176.15 0.2,161.32 C0.2,146.49 12.19,134.5 27.02,134.5 L53.84,134.5 L53.84,161.32 Z M67.25,161.32 C67.25,146.49 79.24,134.5 94.07,134.5 C108.9,134.5 120.89,146.49 120.89,161.32 L120.89,228.37 C120.89,243.2 108.9,255.19 94.07,255.19 C79.24,255.19 67.25,243.2 67.25,228.37 L67.25,161.32 Z'
          fill='#E01E5A'
        />
        <path
          d='M94.07,53.64 C79.24,53.64 67.25,41.65 67.25,26.82 C67.25,11.99 79.24,0 94.07,0 C108.9,0 120.89,11.99 120.89,26.82 L120.89,53.64 L94.07,53.64 Z M94.07,67.25 C108.9,67.25 120.89,79.24 120.89,94.07 C120.89,108.9 108.9,120.89 94.07,120.89 L26.82,120.89 C11.99,120.89 0,108.9 0,94.07 C0,79.24 11.99,67.25 26.82,67.25 L94.07,67.25 Z'
          fill='#36C5F0'
        />
        <path
          d='M201.55,94.07 C201.55,79.24 213.54,67.25 228.37,67.25 C243.2,67.25 255.19,79.24 255.19,94.07 C255.19,108.9 243.2,120.89 228.37,120.89 L201.55,120.89 L201.55,94.07 Z M188.14,94.07 C188.14,108.9 176.15,120.89 161.32,120.89 C146.49,120.89 134.5,108.9 134.5,94.07 L134.5,26.82 C134.5,11.99 146.49,0 161.32,0 C176.15,0 188.14,11.99 188.14,26.82 L188.14,94.07 Z'
          fill='#2EB67D'
        />
        <path
          d='M161.32,201.55 C176.15,201.55 188.14,213.54 188.14,228.37 C188.14,243.2 176.15,255.19 161.32,255.19 C146.49,255.19 134.5,243.2 134.5,228.37 L134.5,201.55 L161.32,201.55 Z M161.32,188.14 C146.49,188.14 134.5,176.15 134.5,161.32 C134.5,146.49 146.49,134.5 161.32,134.5 L228.57,134.5 C243.4,134.5 255.39,146.49 255.39,161.32 C255.39,176.15 243.4,188.14 228.57,188.14 L161.32,188.14 Z'
          fill='#ECB22E'
        />
      </g>
    </svg>
  )
}

export function SlackMonoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg' fill='currentColor' {...props}>
      <g>
        <path d='M53.84,161.32 C53.84,176.15 41.85,188.14 27.02,188.14 C12.19,188.14 0.2,176.15 0.2,161.32 C0.2,146.49 12.19,134.5 27.02,134.5 L53.84,134.5 L53.84,161.32 Z M67.25,161.32 C67.25,146.49 79.24,134.5 94.07,134.5 C108.9,134.5 120.89,146.49 120.89,161.32 L120.89,228.37 C120.89,243.2 108.9,255.19 94.07,255.19 C79.24,255.19 67.25,243.2 67.25,228.37 L67.25,161.32 Z' />
        <path d='M94.07,53.64 C79.24,53.64 67.25,41.65 67.25,26.82 C67.25,11.99 79.24,0 94.07,0 C108.9,0 120.89,11.99 120.89,26.82 L120.89,53.64 L94.07,53.64 Z M94.07,67.25 C108.9,67.25 120.89,79.24 120.89,94.07 C120.89,108.9 108.9,120.89 94.07,120.89 L26.82,120.89 C11.99,120.89 0,108.9 0,94.07 C0,79.24 11.99,67.25 26.82,67.25 L94.07,67.25 Z' />
        <path d='M201.55,94.07 C201.55,79.24 213.54,67.25 228.37,67.25 C243.2,67.25 255.19,79.24 255.19,94.07 C255.19,108.9 243.2,120.89 228.37,120.89 L201.55,120.89 L201.55,94.07 Z M188.14,94.07 C188.14,108.9 176.15,120.89 161.32,120.89 C146.49,120.89 134.5,108.9 134.5,94.07 L134.5,26.82 C134.5,11.99 146.49,0 161.32,0 C176.15,0 188.14,11.99 188.14,26.82 L188.14,94.07 Z' />
        <path d='M161.32,201.55 C176.15,201.55 188.14,213.54 188.14,228.37 C188.14,243.2 176.15,255.19 161.32,255.19 C146.49,255.19 134.5,243.2 134.5,228.37 L134.5,201.55 L161.32,201.55 Z M161.32,188.14 C146.49,188.14 134.5,176.15 134.5,161.32 C134.5,146.49 146.49,134.5 161.32,134.5 L228.57,134.5 C243.4,134.5 255.39,146.49 255.39,161.32 C255.39,176.15 243.4,188.14 228.57,188.14 L161.32,188.14 Z' />
      </g>
    </svg>
  )
}

export function GammaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='-14 0 192 192' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M47.2,14.4c-14.4,8.2-26,19.6-34.4,33.6C4.3,62.1,0,77.7,0,94.3s4.3,32.2,12.7,46.3c8.5,14.1,20,25.4,34.4,33.6,14.4,8.2,30.4,12.4,47.7,12.4h69.8v-112.5h-81v39.1h38.2v31.8h-25.6c-9.1,0-17.6-2.3-25.2-6.9-7.6-4.6-13.8-10.8-18.3-18.4-4.5-7.7-6.7-16.2-6.7-25.3s2.3-17.7,6.7-25.3c4.5-7.7,10.6-13.9,18.3-18.4,7.6-4.6,16.1-6.9,25.2-6.9h68.5V2h-69.8c-17.3,0-33.3,4.2-47.7,12.4h0Z'
      />
    </svg>
  )
}

export function GithubIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width='26' height='26' viewBox='0 0 26 26' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13 0C11.29 0 9.6 0.34 8.03 0.99C6.45 1.64 5.01 2.6 3.81 3.81C1.37 6.25 0 9.55 0 13C0 18.75 3.73 23.62 8.89 25.35C9.54 25.45 9.75 25.05 9.75 24.7V22.5C6.15 23.28 5.38 20.76 5.38 20.76C4.78 19.25 3.94 18.85 3.94 18.85C2.76 18.04 4.03 18.07 4.03 18.07C5.33 18.16 6.02 19.41 6.02 19.41C7.15 21.39 9.06 20.8 9.8 20.49C9.92 19.64 10.26 19.07 10.62 18.75C7.74 18.42 4.71 17.3 4.71 12.35C4.71 10.91 5.2 9.75 6.05 8.83C5.92 8.5 5.46 7.15 6.18 5.4C6.18 5.4 7.27 5.04 9.75 6.72C10.78 6.44 11.9 6.29 13 6.29C14.11 6.29 15.22 6.44 16.25 6.72C18.73 5.04 19.83 5.4 19.83 5.4C20.54 7.15 20.09 8.5 19.95 8.83C20.8 9.75 21.29 10.91 21.29 12.35C21.29 17.32 18.25 18.41 15.35 18.73C15.82 19.14 16.25 19.93 16.25 21.14V24.7C16.25 25.05 16.46 25.47 17.12 25.35C22.28 23.61 26 18.75 26 13C26 11.29 25.66 9.6 25.01 8.03C24.36 6.45 23.4 5.01 22.19 3.81C20.99 2.6 19.55 1.64 17.97 0.99C16.4 0.34 14.71 0 13 0Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function GithubOutlineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 21C15 21 15 18.73 15 18C15 17.37 15.15 16.04 14.5 15.5C15.89 15.37 16.98 14.92 18 14C19.02 13.08 19.5 11.69 19.5 9.5C19.5 8 19.25 7 18.5 6C18.79 5.22 18.84 4 18.5 3C16.94 3 15.53 4.07 15 4.5C14.61 4.4 13.67 4 12 4C10.33 4 9.39 4.4 9 4.5C8.47 4.07 7.06 3 5.5 3C5.16 4 5.21 5.22 5.5 6C4.75 7 4.5 8 4.5 9.5C4.5 11.69 4.98 13.08 6 14C7.02 14.92 8.11 15.37 9.5 15.5C8.85 16.04 9 17.37 9 18C9 18.73 9 21 9 21'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 19C7.59 19 6.16 18.44 5.31 17.81C4.47 17.18 4.22 16.15 3 15.5'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function BitbucketIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `bitbucket_original_a_${id}`

  return (
    <svg {...props} viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient
          id={gradientId}
          gradientUnits='userSpaceOnUse'
          x1='28.593'
          y1='14.226'
          x2='16.672'
          y2='23.532'
          gradientTransform='scale(4)'
        >
          <stop offset='.176' stopColor='#0052cc' />
          <stop offset='1' stopColor='#2684ff' />
        </linearGradient>
      </defs>
      <path
        d='M19.082 20c-1.918 0-3.355 1.758-3.039 3.516l12.95 79.289c.32 2.078 2.077 3.515 4.155 3.515h62.66c1.442 0 2.72-1.12 3.04-2.558l13.109-80.086c.316-1.918-1.121-3.516-3.039-3.516zM74.07 77.227H54.09l-5.278-28.293h30.215zm0 0'
        fill='#2684ff'
      />
      <path
        d='M107.64 48.934H78.868L74.07 77.227H54.09l-23.5 27.972s1.12.961 2.719.961h62.66c1.441 0 2.719-1.12 3.039-2.558zm0 0'
        fill={`url(#${gradientId})`}
      />
    </svg>
  )
}

export function GitLabIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z'
        fill='#FC6D26'
      />
      <path d='M12 22.13L16.05 9.67H7.95L12 22.13z' fill='#E24329' />
      <path d='M12 22.13L7.95 9.67H1.69L12 22.13z' fill='#FC6D26' />
      <path d='M1.69 9.67L.47 13.45a.84.84 0 0 0 .3.94L12 22.13 1.69 9.67z' fill='#FCA326' />
      <path
        d='M1.69 9.67H7.95L5.51 2.16A.42.42 0 0 0 4.93 2a.42.42 0 0 0-.11.18L1.69 9.67z'
        fill='#E24329'
      />
      <path d='M12 22.13L16.05 9.67H22.31L12 22.13z' fill='#FC6D26' />
      <path d='M22.31 9.67L23.53 13.45a.84.84 0 0 1-.3.94L12 22.13 22.31 9.67z' fill='#FCA326' />
      <path
        d='M22.31 9.67H16.05l2.44-7.51A.42.42 0 0 1 19.07 2a.42.42 0 0 1 .11.18l3.13 7.49z'
        fill='#E24329'
      />
    </svg>
  )
}

export function SerperIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='35.411 -19.109 628.098 628.098' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M324 38C356 37 389 36 417 47C452 56 484 72 509 94C539 118 561 145 577 176C593 205 601 238 606 271C610 343 590 403 552 452C528 482 499 507 467 523C438 539 404 547 372 552C297 556 235 534 184 492C133 449 103 392 93 330C93 292 89 255 102 224C112 189 128 158 149 132C194 78 255 46 322 38'
        fill='rgb(71,97,118)'
      />
      <path
        d='M326 39C286 43 250 55 217 75C185 94 156 120 137 150C100 204 87 266 95 336C107 402 142 462 198 502C249 538 309 556 378 551C415 545 449 533 477 516C511 497 535 472 557 445C592 393 611 333 605 265C595 196 563 140 511 95C484 73 452 57 419 48C390 38 359 38 327 39'
        fill='rgb(71,97,119)'
      />
      <path
        d='M342 40C407 42 465 61 513 103C541 126 562 155 576 184C592 217 600 251 600 288C602 357 579 416 535 465C510 493 478 515 445 528C416 541 385 546 352 546C284 548 225 523 178 481C130 436 103 379 96 313C94 244 113 186 151 138C179 103 209 80 245 64C276 50 307 44 340 41'
        fill='rgb(71,97,119)'
      />
      <path
        d='M344 42C309 44 277 51 247 64C209 81 180 103 153 136C114 186 95 244 96 312C104 379 131 435 177 480C225 522 284 547 351 546C385 545 416 540 443 528C478 514 509 492 533 466C578 416 601 357 600 289C599 251 591 217 576 187C561 156 541 127 515 105C466 63 409 44 346 41'
        fill='rgb(71,97,118)'
      />
      <path
        d='M327 81C378 78 423 89 462 114C511 144 546 196 557 248C567 306 559 363 530 406C498 457 448 492 395 503C338 513 282 506 239 477C192 450 156 402 143 351C126 296 137 235 163 190C198 130 258 89 325 82'
        fill='rgb(44,56,71)'
      />
      <path
        d='M329 83C260 89 199 129 165 189C138 235 127 296 144 349C157 401 193 449 237 475C282 505 338 512 393 503C448 491 497 457 529 408C558 363 566 306 557 250C545 196 511 145 464 116C424 91 380 79 330 82'
        fill='rgb(43,55,70)'
      />
      <path
        d='M334 87C381 83 423 94 458 117C510 148 544 201 554 258C562 317 551 370 521 412C487 460 440 491 385 500C331 507 281 499 241 473C191 444 157 394 145 339C136 284 143 227 171 186C207 129 265 91 332 87'
        fill='rgb(41,53,67)'
      />
      <path
        d='M335 88C267 90 208 129 173 184C144 227 137 284 145 338C158 393 191 443 240 471C281 498 331 506 384 500C439 490 487 459 519 413C550 370 561 317 554 259C543 201 509 149 460 119C424 96 383 85 337 88'
        fill='rgb(41,53,67)'
      />
      <path
        d='M347 166C361 164 373 169 387 168C412 180 437 193 447 221C449 232 443 243 434 248C403 245 398 204 365 207C338 206 315 210 297 228C294 238 289 257 303 260C337 280 382 276 417 292C436 300 448 314 455 330C457 349 462 373 449 385C435 408 413 418 391 427C361 429 328 436 304 421C280 413 260 392 250 370C246 356 255 343 268 343C293 360 316 398 356 389C382 390 409 380 416 357C389 295 298 335 260 276C246 256 248 233 258 214C279 184 309 167 346 167'
        fill='rgb(121,172,205)'
      />
      <path
        d='M349 168C312 167 280 183 259 212C249 233 247 256 260 274C299 334 390 294 422 354C409 381 382 391 357 389C316 399 293 361 272 342C255 344 247 356 251 368C260 391 280 412 302 420C328 435 361 428 389 428C412 417 434 407 447 386C461 373 456 349 456 332C428 270 351 289 304 262C288 258 293 239 295 229C314 209 338 204 363 204C398 203 403 244 431 249C443 242 448 232 449 222C436 193 412 181 388 172C374 170 363 166 350 167'
        fill='rgb(125,177,211)'
      />
      <path
        d='M349 169C386 169 425 185 441 220C444 231 441 240 432 243C409 237 402 209 380 206C347 200 314 201 293 226C290 238 286 256 297 262C332 283 375 281 411 295C431 304 446 317 452 337C455 360 452 383 434 396C415 415 391 421 366 426C338 430 316 422 295 413C276 402 261 385 254 366C254 353 261 343 275 348C290 381 325 398 360 394C388 395 411 382 420 360C425 342 413 334 404 327C359 304 298 318 265 276C253 254 255 235 261 214C280 187 314 173 346 170'
        fill='rgb(137,195,233)'
      />
      <path
        d='M349 171C316 173 281 187 263 214C256 235 254 254 266 273C300 316 359 304 401 325C413 333 426 342 422 358C412 382 388 396 363 395C326 399 290 382 278 348C262 345 254 353 253 365C261 384 277 401 292 411C316 421 338 429 365 426C390 420 415 414 432 398C451 383 454 360 453 338C445 317 430 305 413 296C375 282 332 284 299 264C285 257 288 239 291 228C304 212 319 205 336 202C378 193 403 213 423 244C438 244 443 232 441 222C425 186 388 171 352 170'
        fill='rgb(139,198,236)'
      />
    </svg>
  )
}

export function TailscaleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' fill='none' {...props}>
      <path
        fill='currentColor'
        opacity={0.2}
        d='M65.6 127.7c35.3 0 63.9-28.6 63.9-63.9S100.9 0 65.6 0 1.8 28.6 1.8 63.9s28.6 63.8 63.8 63.8'
      />
      <path
        fill='currentColor'
        d='M65.6 318.1c35.3 0 63.9-28.6 63.9-63.9s-28.6-63.9-63.9-63.9S1.8 219 1.8 254.2s28.6 63.9 63.8 63.9'
      />
      <path
        fill='currentColor'
        opacity={0.2}
        d='M65.6 512c35.3 0 63.9-28.6 63.9-63.9s-28.6-63.9-63.9-63.9-63.8 28.7-63.8 63.9S30.4 512 65.6 512'
      />
      <path
        fill='currentColor'
        d='M257.2 318.1c35.3 0 63.9-28.6 63.9-63.9s-28.6-63.9-63.9-63.9-63.9 28.6-63.9 63.9 28.6 63.9 63.9 63.9m0 193.9c35.3 0 63.9-28.6 63.9-63.9s-28.6-63.9-63.9-63.9-63.9 28.6-63.9 63.9 28.6 63.9 63.9 63.9'
      />
      <path
        fill='currentColor'
        opacity={0.2}
        d='M257.2 127.7c35.3 0 63.9-28.6 63.9-63.9S292.5 0 257.2 0s-63.9 28.6-63.9 63.9 28.6 63.8 63.9 63.8m189.2 0c35.3 0 63.9-28.6 63.9-63.9S481.6 0 446.4 0c-35.3 0-63.9 28.6-63.9 63.9s28.6 63.8 63.9 63.8'
      />
      <path
        fill='currentColor'
        d='M446.4 318.1c35.3 0 63.9-28.6 63.9-63.9s-28.6-63.9-63.9-63.9-63.9 28.6-63.9 63.9 28.6 63.9 63.9 63.9'
      />
      <path
        fill='currentColor'
        opacity={0.2}
        d='M446.4 512c35.3 0 63.9-28.6 63.9-63.9s-28.6-63.9-63.9-63.9-63.9 28.6-63.9 63.9 28.6 63.9 63.9 63.9'
      />
    </svg>
  )
}

export function TavilyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <title>Tavily</title>
      <path
        d='M9.1.503l2.824 4.47a1.078 1.078 0 01-.911 1.655H9.858v6.692h-1.67V0c.35 0 .7.168.912.503z'
        fill='#8FBCFA'
      />
      <path
        d='M4.453 4.974L7.277.503A1.07 1.07 0 018.189 0v13.32a2.633 2.633 0 00-1.67.48V6.628H5.364c-.85 0-1.366-.936-.912-1.654z'
        fill='#468BFF'
      />
      <path
        d='M17.041 17.74h-7.028c.423-.457.67-1.049.7-1.67h12.956c0 .35-.168.7-.502.912l-4.472 2.823a1.078 1.078 0 01-1.654-.911v-1.155z'
        fill='#FDBB11'
      />
      <path
        d='M18.695 12.334l4.47 2.824c.336.212.503.562.503.912H10.713a2.65 2.65 0 00-.493-1.67h6.822v-1.154c0-.85.935-1.366 1.653-.912z'
        fill='#F6D785'
      />
      <path
        d='M4.394 19.605L.316 23.683a1.07 1.07 0 001 .29l5.158-1.165A1.078 1.078 0 007 20.994l-.816-.816 3.073-3.074a1.61 1.61 0 000-2.276l-.042-.043-4.82 4.82z'
        fill='#FF9A9D'
      />
      <path
        d='M3.822 17.817l3.073-3.074a1.61 1.61 0 012.277 0l.042.043-4.818 4.819-4.08 4.079a1.07 1.07 0 01-.289-1l1.165-5.158A1.078 1.078 0 013.006 17l.816.817z'
        fill='#FE363B'
      />
    </svg>
  )
}

export function ConnectIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='-2 -2 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 16C24 17.47 23.48 18.72 22.43 19.77C21.39 20.81 20.13 21.33 18.67 21.33H7.77C7.48 22.11 6.99 22.75 6.32 23.25C5.64 23.75 4.87 24 4 24C2.89 24 1.94 23.61 1.17 22.83C0.39 22.06 0 21.11 0 20C0 18.89 0.39 17.94 1.17 17.17C1.94 16.39 2.89 16 4 16C4.87 16 5.64 16.25 6.32 16.75C7 17.25 7.48 17.89 7.77 18.67H18.67C19.4 18.67 20.03 18.41 20.55 17.88C21.07 17.36 21.33 16.73 21.33 16C21.33 15.27 21.07 14.64 20.55 14.12C20.03 13.59 19.4 13.33 18.67 13.33L5.33 13.33C3.87 13.33 2.61 12.81 1.57 11.77C0.52 10.72 0 9.47 0 8C0 6.53 0.52 5.28 1.57 4.23C2.61 3.19 3.87 2.67 5.33 2.67H16.23C16.52 1.89 17.01 1.25 17.68 0.75C18.36 0.25 19.13 0 20 0C21.11 0 22.06 0.39 22.83 1.17C23.61 1.94 24 2.89 24 4C24 5.11 23.61 6.06 22.83 6.83C22.06 7.61 21.11 8 20 8C19.13 8 18.36 7.75 17.67 7.25C16.98 6.75 16.5 6.11 16.23 5.33H5.33C4.6 5.33 3.97 5.59 3.45 6.12C2.93 6.64 2.67 7.27 2.67 8C2.67 8.73 2.93 9.36 3.45 9.88C3.97 10.4 4.6 10.66 5.33 10.67L18.67 10.67C20.13 10.67 21.39 11.19 22.43 12.23C23.48 13.28 24 14.53 24 16ZM5.33 20C5.33 19.62 5.21 19.31 4.95 19.05C4.69 18.79 4.38 18.67 4 18.67C3.62 18.67 3.31 18.8 3.05 19.05C2.79 19.31 2.67 19.62 2.67 20C2.67 20.38 2.79 20.69 3.05 20.95C3.31 21.2 3.62 21.33 4 21.33C4.38 21.33 4.69 21.21 4.95 20.95C5.21 20.69 5.34 20.38 5.33 20ZM21.33 4C21.33 3.62 21.21 3.31 20.95 3.05C20.69 2.79 20.38 2.67 20 2.67C19.62 2.67 19.31 2.8 19.05 3.05C18.79 3.31 18.67 3.62 18.67 4C18.67 4.38 18.79 4.69 19.05 4.95C19.31 5.2 19.62 5.33 20 5.33C20.38 5.33 20.69 5.21 20.95 4.95C21.21 4.69 21.34 4.38 21.33 4Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function YouTubeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='28'
      height='20'
      viewBox='0 0 28 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11.2 14L18.47 9.8L11.2 5.6V14ZM27.38 3.04C27.57 3.7 27.69 4.58 27.78 5.7C27.87 6.82 27.92 7.78 27.92 8.62L28 9.8C28 12.87 27.78 15.12 27.38 16.56C27.03 17.82 26.22 18.63 24.96 18.98C24.3 19.17 23.1 19.29 21.25 19.38C19.43 19.47 17.77 19.52 16.23 19.52L14 19.6C8.13 19.6 4.48 19.38 3.04 18.98C1.78 18.63 0.97 17.82 0.62 16.56C0.43 15.9 0.31 15.02 0.22 13.9C0.13 12.78 0.08 11.82 0.08 10.98L0 9.8C0 6.73 0.22 4.48 0.62 3.04C0.97 1.78 1.78 0.97 3.04 0.62C3.7 0.43 4.9 0.31 6.75 0.22C8.57 0.13 10.23 0.08 11.77 0.08L14 0C19.87 0 23.52 0.22 24.96 0.62C26.22 0.97 27.03 1.78 27.38 3.04Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function PeopleDataLabsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 99.92 90.06'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M99.91,57.77l-3.2-24.4c0-.7-.4-1.3-.8-1.8l-20-21.3c-.5-.5-1.1-.8-1.8-1L29.21.07c-1.1-.2-2.2,0-2.9.8L1.01,24.07c-.9.8-1.2,2-.9,3.1l6,23.4c.3,1.2,1.3,2.1,2.5,2.4l9.9,2,11.3,6.6h0l11.9,6.5,14.9,20.6c.8,1.1,2.2,1.6,3.5,1.3l8.1-1.9c1.4-.3,2.5-1.6,2.5-3l.3-6.8,27.4-17.4c1.1-.7,1.6-1.9,1.5-3.1ZM90.31,35.17l2.1,16.3-40.2-26.8,20.4-8.4,17.7,18.8v.1ZM31.11,7.17l31.2,6.3-18.4,7.5h0l-16.8,7.3s4-21.1,4-21.1ZM12.01,47.07l-5-19.6,16.5-15.1-3.9,20.7c-.3,1.4.4,2.7,1.6,3.4l30.1,16.6-31-4.4-8.3-1.7v.1ZM60.81,83.17l-14-19.4c-.3-.4-.7-.7-1.1-1l-9.8-5.4,29,4.1-.4,14.7-.2,6-3.5.8v.2ZM83.01,62.97l-11.7,7.4.3-11.5c0-1.2-.6-2.3-1.7-2.9l-39.8-21.9,14.8-6.4,45.7,30.4-7.7,4.9h.1Z'
      />
    </svg>
  )
}

export function PersonaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 17.02 23.3'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M17.02 20.7V21.93C17.02 22.53 16.69 22.86 16.09 22.86H0.93C0.34 22.86 0 22.53 0 21.93V20.7C0 20.1 0.33 19.77 0.93 19.77H16.09C16.69 19.77 17.02 20.1 17.02 20.7H17.02ZM15.98 11.39L12.03 9.11C11.9 9.04 11.9 8.85 12.03 8.78L15.98 6.5C16.43 6.24 16.58 5.67 16.32 5.23L15.71 4.16C15.45 3.72 14.88 3.56 14.44 3.82L10.49 6.1C10.36 6.18 10.2 6.08 10.2 5.93V1.37C10.2 0.86 9.78 0.44 9.26 0.44H8.03C7.52 0.44 7.1 0.86 7.1 1.37V5.93C7.1 6.08 6.94 6.17 6.81 6.1L2.86 3.82C2.41 3.56 1.84 3.72 1.58 4.16L0.97 5.22C0.71 5.67 0.86 6.24 1.31 6.5L5.26 8.77C5.39 8.85 5.39 9.03 5.26 9.11L1.31 11.39C0.86 11.65 0.71 12.21 0.97 12.66L1.58 13.72C1.84 14.17 2.41 14.32 2.86 14.06L6.81 11.79C6.94 11.71 7.1 11.8 7.1 11.95V16.51C7.1 17.03 7.52 17.44 8.03 17.44H9.26C9.78 17.44 10.2 17.03 10.2 16.51V11.95C10.2 11.8 10.36 11.71 10.49 11.79L14.44 14.06C14.88 14.32 15.45 14.17 15.71 13.72L16.32 12.66C16.58 12.21 16.43 11.65 15.98 11.39V11.39Z'
        fill='#7379FD'
      />
    </svg>
  )
}

export function PerplexityIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M19.79 0v7.27H22.5V17.62h-2.93V24l-7.04-6.19v6.15h-1.09v-6.15L4.39 24v-6.46H1.5V7.19h2.88V0l7.05 6.49V.19h1.09v6.49L19.79 0zm-7.26 9.04v7.32l5.95 5.23V14.44l-5.95-5.4zm-1.1-.08l-5.95 5.4v7.24l5.95-5.23V8.97zm8.14 7.58h1.84V8.35H13.46l6.11 5.54v2.66zm-8.98-8.28H2.59v8.2h1.8v-2.58l6.19-5.62zM5.48 2.48v4.71h5.12l-5.11-4.71zm13.22 0l-5.11 4.71h5.12v-4.71z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  )
}

export function ObsidianIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const bl = `${id}-bl`
  const tr = `${id}-tr`
  const tl = `${id}-tl`
  const br = `${id}-br`
  const te = `${id}-te`
  const le = `${id}-le`
  const be = `${id}-be`
  const me = `${id}-me`
  const clip = `${id}-clip`
  return (
    <svg {...props} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <radialGradient
        id={bl}
        cx='0'
        cy='0'
        gradientTransform='matrix(-59 -225 150 -39 161.4 470)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.4' />
        <stop offset='1' stopOpacity='.1' />
      </radialGradient>
      <radialGradient
        id={tr}
        cx='0'
        cy='0'
        gradientTransform='matrix(50 -379 280 37 360 374.2)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.6' />
        <stop offset='1' stopColor='#fff' stopOpacity='.1' />
      </radialGradient>
      <radialGradient
        id={tl}
        cx='0'
        cy='0'
        gradientTransform='matrix(69 -319 218 47 175.4 307)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.8' />
        <stop offset='1' stopColor='#fff' stopOpacity='.4' />
      </radialGradient>
      <radialGradient
        id={br}
        cx='0'
        cy='0'
        gradientTransform='matrix(-96 -163 187 -111 335.3 512.2)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.3' />
        <stop offset='1' stopOpacity='.3' />
      </radialGradient>
      <radialGradient
        id={te}
        cx='0'
        cy='0'
        gradientTransform='matrix(-36 166 -112 -24 310 128.2)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='0' />
        <stop offset='1' stopColor='#fff' stopOpacity='.2' />
      </radialGradient>
      <radialGradient
        id={le}
        cx='0'
        cy='0'
        gradientTransform='matrix(88 89 -190 187 111 220.2)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.2' />
        <stop offset='1' stopColor='#fff' stopOpacity='.4' />
      </radialGradient>
      <radialGradient
        id={be}
        cx='0'
        cy='0'
        gradientTransform='matrix(9 130 -276 20 215 284)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.2' />
        <stop offset='1' stopColor='#fff' stopOpacity='.3' />
      </radialGradient>
      <radialGradient
        id={me}
        cx='0'
        cy='0'
        gradientTransform='matrix(-198 -104 327 -623 400 399.2)'
        gradientUnits='userSpaceOnUse'
        r='1'
      >
        <stop offset='0' stopColor='#fff' stopOpacity='.2' />
        <stop offset='.5' stopColor='#fff' stopOpacity='.2' />
        <stop offset='1' stopColor='#fff' stopOpacity='.3' />
      </radialGradient>
      <clipPath id={clip}>
        <path d='M.2.2h512v512H.2z' />
      </clipPath>
      <g clipPath={`url(#${clip})`}>
        <path
          d='M382.3 475.6c-3.1 23.4-26 41.6-48.7 35.3-32.4-8.9-69.9-22.8-103.6-25.4l-51.7-4a34 34 0 0 1-22-10.2l-89-91.7a34 34 0 0 1-6.7-37.7s55-121 57.1-127.3c2-6.3 9.6-61.2 14-90.6 1.2-7.9 5-15 11-20.3L248 8.9a34.1 34.1 0 0 1 49.6 4.3L386 125.6a37 37 0 0 1 7.6 22.4c0 21.3 1.8 65 13.6 93.2 11.5 27.3 32.5 57 43.5 71.5a17.3 17.3 0 0 1 1.3 19.2 1494 1494 0 0 1-44.8 70.6c-15 22.3-21.9 49.9-25 73.1z'
          fill='#6c31e3'
        />
        <path
          d='M165.9 478.3c41.4-84 40.2-144.2 22.6-187-16.2-39.6-46.3-64.5-70-80-.6 2.3-1.3 4.4-2.2 6.5L60.6 342a34 34 0 0 0 6.6 37.7l89.1 91.7a34 34 0 0 0 9.6 7z'
          fill={`url(#${bl})`}
        />
        <path
          d='M278.4 307.8c11.2 1.2 22.2 3.6 32.8 7.6 34 12.7 65 41.2 90.5 96.3 1.8-3.1 3.6-6.2 5.6-9.2a1536 1536 0 0 0 44.8-70.6 17 17 0 0 0-1.3-19.2c-11-14.6-32-44.2-43.5-71.5-11.8-28.2-13.5-72-13.6-93.2 0-8.1-2.6-16-7.6-22.4L297.6 13.2a34 34 0 0 0-1.5-1.7 96 96 0 0 1 2 54 198.3 198.3 0 0 1-17.6 41.3l-7.2 14.2a171 171 0 0 0-19.4 71c-1.2 29.4 4.8 66.4 24.5 115.8z'
          fill={`url(#${tr})`}
        />
        <path
          d='M278.4 307.8c-19.7-49.4-25.8-86.4-24.5-115.9a171 171 0 0 1 19.4-71c2.3-4.8 4.8-9.5 7.2-14.1 7.1-13.9 14-27 17.6-41.4a96 96 0 0 0-2-54A34.1 34.1 0 0 0 248 9l-105.4 94.8a34.1 34.1 0 0 0-10.9 20.3l-12.8 85-.5 2.3c23.8 15.5 54 40.4 70.1 80a147 147 0 0 1 7.8 24.8c28-6.8 55.7-11 82.1-8.3z'
          fill={`url(#${tl})`}
        />
        <path
          d='M333.6 511c22.7 6.2 45.6-12 48.7-35.4a187 187 0 0 1 19.4-63.9c-25.6-55-56.5-83.6-90.4-96.3-36-13.4-75.2-9-115 .7 8.9 40.4 3.6 93.3-30.4 162.2 4 1.8 8.1 3 12.5 3.3 0 0 24.4 2 53.6 4.1 29 2 72.4 17.1 101.6 25.2z'
          fill={`url(#${br})`}
        />
        <g clipRule='evenodd' fillRule='evenodd'>
          <path
            d='M254.1 190c-1.3 29.2 2.4 62.8 22.1 112.1l-6.2-.5c-17.7-51.5-21.5-78-20.2-107.6a174.7 174.7 0 0 1 20.4-72c2.4-4.9 8-14.1 10.5-18.8 7.1-13.7 11.9-21 16-33.6 5.7-17.5 4.5-25.9 3.8-34.1 4.6 29.9-12.7 56-25.7 82.4a177.1 177.1 0 0 0-20.7 72z'
            fill={`url(#${te})`}
          />
          <path
            d='M194.3 293.4c2.4 5.4 4.6 9.8 6 16.5L195 311c-2.1-7.8-3.8-13.4-6.8-20-17.8-42-46.3-63.6-69.7-79.5 28.2 15.2 57.2 39 75.7 81.9z'
            fill={`url(#${le})`}
          />
          <path
            d='M200.6 315.1c9.8 46-1.2 104.2-33.6 160.9 27.1-56.2 40.2-110.1 29.3-160z'
            fill={`url(#${be})`}
          />
          <path
            d='M312.5 311c53.1 19.9 73.6 63.6 88.9 100-19-38.1-45.2-80.3-90.8-96-34.8-11.8-64.1-10.4-114.3 1l-1.1-5c53.2-12.1 81-13.5 117.3 0z'
            fill={`url(#${me})`}
          />
        </g>
      </g>
    </svg>
  )
}

export function NotionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='1em' height='1em' {...props}>
      <path
        d='M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.139c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.934.653.934 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.447-1.632z'
        fill='currentColor'
      />
    </svg>
  )
}

export function GongIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 55.4 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M54.1,25.7H37.8c-0.9,0-1.6,1-1.3,1.8l3.9,10.1c0.2,0.4-0.2,0.9-0.7,0.9l-5-0.3c-0.2,0-0.4,0.1-0.6,0.3L30.3,44c-0.2,0.3-0.6,0.4-1,0.2l-5.8-3.9c-0.2-0.2-0.5-0.2-0.8,0l-8,5.4c-0.5,0.4-1.2-0.1-1-0.7L16,37c0.1-0.3-0.1-0.7-0.4-0.8l-4.2-1.7c-0.4-0.2-0.6-0.7-0.3-1l3.7-4.6c0.2-0.2,0.2-0.6,0-0.8l-3.1-4.5c-0.3-0.4,0-1,0.5-1l4.9-0.4c0.4,0,0.6-0.3,0.6-0.7l-0.4-6.8c0-0.5,0.5-0.8,0.9-0.7l6,2.5c0.3,0.1,0.6,0,0.8-0.2l4.2-4.6c0.3-0.4,0.9-0.3,1.1,0.2l2.5,6.4c0.3,0.8,1.3,1.1,2,0.6l9.8-7.3c1.1-0.8,0.4-2.6-1-2.4L37.3,10c-0.3,0-0.6-0.1-0.7-0.4l-3.4-8.7c-0.4-0.9-1.5-1.1-2.2-0.4l-7.4,8c-0.2,0.2-0.5,0.3-0.8,0.2l-9.7-4.1c-0.9-0.4-1.8,0.2-1.9,1.2l-0.4,10c0,0.4-0.3,0.6-0.6,0.6l-8.9,0.6c-1,0.1-1.6,1.2-1,2.1l5.9,8.7c0.2,0.2,0.2,0.6,0,0.8l-6,6.9C-0.3,36,0,37.1,0.8,37.4l6.9,3c0.3,0.1,0.5,0.5,0.4,0.8L3.7,58.3c-0.3,1.2,1.1,2.1,2.1,1.4l16.5-11.8c0.2-0.2,0.5-0.2,0.8,0l7.5,5.3c0.6,0.4,1.5,0.3,1.9-0.4l4.7-7.2c0.1-0.2,0.4-0.3,0.6-0.3l11.2,1.4c0.9,0.1,1.8-0.6,1.5-1.5l-4.7-12.1c-0.1-0.3,0-0.7,0.4-0.9l8.5-4C55.9,27.6,55.5,25.7,54.1,25.7z'
      />
    </svg>
  )
}

export function GmailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width='96px'
      height='96px'
      {...props}
    >
      <path fill='#4caf50' d='M45,16.2l-5,2.75l-5,4.75L35,40h7c1.66,0,3-1.34,3-3V16.2z' />
      <path fill='#1e88e5' d='M3,16.2l3.61,1.71L13,23.7V40H6c-1.66,0-3-1.34-3-3V16.2z' />
      <polygon
        fill='#e53935'
        points='35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17'
      />
      <path
        fill='#c62828'
        d='M3,12.3V16.2l10,7.5V11.2L9.88,8.86C9.13,8.3,8.23,8,7.3,8h0C4.92,8,3,9.92,3,12.3z'
      />
      <path
        fill='#fbc02d'
        d='M45,12.3V16.2l-10,7.5V11.2l3.12-2.34C38.87,8.3,39.77,8,40.7,8h0 C43.08,8,45,9.92,45,12.3z'
      />
    </svg>
  )
}

export function GrafanaIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `grafana_gradient_${id}`

  return (
    <svg {...props} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill='none'>
      <path
        fill={`url(#${gradientId})`}
        d='M23.02 10.59a8.578 8.578 0 0 0-.862-3.034 8.911 8.911 0 0 0-1.789-2.445c.337-1.342-.413-2.505-.413-2.505-1.292-.08-2.113.4-2.416.62-.052-.02-.102-.044-.154-.064-.22-.089-.446-.172-.677-.247-.231-.073-.47-.14-.711-.197a9.867 9.867 0 0 0-.875-.161C14.557.753 12.94 0 12.94 0c-1.804 1.145-2.147 2.744-2.147 2.744l-.018.093c-.098.029-.2.057-.298.088-.138.042-.275.094-.413.143-.138.055-.275.107-.41.166a8.869 8.869 0 0 0-1.557.87l-.063-.029c-2.497-.955-4.716.195-4.716.195-.203 2.658.996 4.33 1.235 4.636a11.608 11.608 0 0 0-.607 2.635C1.636 12.677.953 15.014.953 15.014c1.926 2.214 4.171 2.351 4.171 2.351.003-.002.006-.002.006-.005.285.509.615.994.986 1.446.156.19.32.371.488.548-.704 2.009.099 3.68.099 3.68 2.144.08 3.553-.937 3.849-1.173a9.784 9.784 0 0 0 3.164.501h.08l.055-.003.107-.002.103-.005.003.002c1.01 1.44 2.788 1.646 2.788 1.646 1.264-1.332 1.337-2.653 1.337-2.94v-.058c0-.02-.003-.039-.003-.06.265-.187.52-.387.758-.6a7.875 7.875 0 0 0 1.415-1.7c1.43.083 2.437-.885 2.437-.885-.236-1.49-1.085-2.216-1.264-2.354l-.018-.013-.016-.013a.217.217 0 0 1-.031-.02c.008-.092.016-.18.02-.27.011-.162.016-.323.016-.48v-.253l-.005-.098-.008-.135a1.891 1.891 0 0 0-.01-.13c-.003-.042-.008-.083-.013-.125l-.016-.124-.018-.122a6.215 6.215 0 0 0-2.032-3.73 6.015 6.015 0 0 0-3.222-1.46 6.292 6.292 0 0 0-.85-.048l-.107.002h-.063l-.044.003-.104.008a4.777 4.777 0 0 0-3.335 1.695c-.332.4-.592.84-.768 1.297a4.594 4.594 0 0 0-.312 1.817l.003.091c.005.055.007.11.013.164a3.615 3.615 0 0 0 .698 1.82 3.53 3.53 0 0 0 1.827 1.282c.33.098.66.14.971.137.039 0 .078 0 .114-.002l.063-.003c.02 0 .041-.003.062-.003.034-.002.065-.007.099-.01.007 0 .018-.003.028-.003l.031-.005.06-.008a1.18 1.18 0 0 0 .112-.02c.036-.008.072-.013.109-.024a2.634 2.634 0 0 0 .914-.415c.028-.02.056-.041.085-.065a.248.248 0 0 0 .039-.35.244.244 0 0 0-.309-.06l-.078.042c-.09.044-.184.083-.283.116a2.476 2.476 0 0 1-.475.096c-.028.003-.054.006-.083.006l-.083.002c-.026 0-.054 0-.08-.002l-.102-.006h-.012l-.024.006c-.016-.003-.031-.003-.044-.006-.031-.002-.06-.007-.091-.01a2.59 2.59 0 0 1-.724-.213 2.557 2.557 0 0 1-.667-.438 2.52 2.52 0 0 1-.805-1.475 2.306 2.306 0 0 1-.029-.444l.006-.122v-.023l.002-.031c.003-.021.003-.04.005-.06a3.163 3.163 0 0 1 1.352-2.29 3.12 3.12 0 0 1 .937-.43 2.946 2.946 0 0 1 .776-.101h.06l.07.002.045.003h.026l.07.005a4.041 4.041 0 0 1 1.635.49 3.94 3.94 0 0 1 1.602 1.662 3.77 3.77 0 0 1 .397 1.414l.005.076.003.075c.002.026.002.05.002.075 0 .024.003.052 0 .07v.065l-.002.073-.008.174a6.195 6.195 0 0 1-.08.639 5.1 5.1 0 0 1-.267.927 5.31 5.31 0 0 1-.624 1.13 5.052 5.052 0 0 1-3.237 2.014 4.82 4.82 0 0 1-.649.066l-.039.003h-.287a6.607 6.607 0 0 1-1.716-.265 6.776 6.776 0 0 1-3.4-2.274 6.75 6.75 0 0 1-.746-1.15 6.616 6.616 0 0 1-.714-2.596l-.005-.083-.002-.02v-.056l-.003-.073v-.096l-.003-.104v-.07l.003-.163c.008-.22.026-.45.054-.678a8.707 8.707 0 0 1 .28-1.355c.128-.444.286-.872.473-1.277a7.04 7.04 0 0 1 1.456-2.1 5.925 5.925 0 0 1 .953-.763c.169-.111.343-.213.524-.306.089-.05.182-.091.273-.135.047-.02.093-.042.138-.062a7.177 7.177 0 0 1 .714-.267l.145-.045c.049-.015.098-.026.148-.041.098-.029.197-.052.296-.076.049-.013.1-.02.15-.033l.15-.032.151-.028.076-.013.075-.01.153-.024c.057-.01.114-.013.171-.023l.169-.021c.036-.003.073-.008.106-.01l.073-.008.036-.003.042-.002c.057-.003.114-.008.171-.01l.086-.006h.023l.037-.003.145-.007a7.999 7.999 0 0 1 1.708.125 7.917 7.917 0 0 1 2.048.68 8.253 8.253 0 0 1 1.672 1.09l.09.077.089.078c.06.052.114.107.171.159.057.052.112.106.166.16.052.055.107.107.159.164a8.671 8.671 0 0 1 1.41 1.978c.012.026.028.052.04.078l.04.078.075.156c.023.051.05.1.07.153l.065.15a8.848 8.848 0 0 1 .45 1.34.19.19 0 0 0 .201.142.186.186 0 0 0 .172-.184c.01-.246.002-.532-.024-.856z'
      />
      <defs>
        <linearGradient id={gradientId} x1='0' x2='0' y1='1' y2='0'>
          <stop stopColor='#FFF200' />
          <stop offset='1' stopColor='#F15A29' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function GoogleDriveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 87.3 78'
      width='1em'
      height='1em'
      {...props}
    >
      <path
        d='m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z'
        fill='#0066da'
      />
      <path
        d='m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z'
        fill='#00ac47'
      />
      <path
        d='m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.5l5.85 11.5z'
        fill='#ea4335'
      />
      <path
        d='m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z'
        fill='#00832d'
      />
      <path
        d='m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z'
        fill='#2684fc'
      />
      <path
        d='m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z'
        fill='#ffba00'
      />
    </svg>
  )
}

export function xAIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 841.89 595.28'
      width='1em'
      height='1em'
      {...props}
    >
      <g>
        <polygon
          points='557.09,211.99 565.4,538.36 631.96,538.36 640.28,93.18'
          fill='currentColor'
        />
        <polygon
          points='640.28,56.91 538.72,56.91 379.35,284.53 430.13,357.05'
          fill='currentColor'
        />
        <polygon
          points='201.61,538.36 303.17,538.36 353.96,465.84 303.17,393.31'
          fill='currentColor'
        />
        <polygon
          points='201.61,211.99 430.13,538.36 531.69,538.36 303.17,211.99'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 520.48 520.48'
      width='1em'
      height='1em'
      {...props}
    >
      <path
        fill='#ff004f'
        d='m392.19,206.7v49.13c-8.6-.84-19.74-2.78-32.09-7.31-16.13-5.91-28.13-13.99-35.98-20.25v99.32l-.19-.31c.14,1.96.19,3.97.19,5.99,0,49.33-40.13,89.48-89.48,89.48s-89.48-40.15-89.48-89.48,40.13-89.5,89.48-89.5c4.82,0,9.57.39,14.2,1.13v48.43c-4.45-1.6-9.22-2.45-14.2-2.45-23.36,0-42.38,19-42.38,42.38s19.02,42.38,42.38,42.38,42.38-19.02,42.38-42.38c0-.88-.02-1.75-.08-2.63v-193.01h49.11c.18,4.16.35,8.34.53,12.51.33,8.19,3.25,16.05,8.32,22.49,5.97,7.57,14.76,16.36,27.13,23.38,11.57,6.56,22.45,9.38,30.15,10.7Z'
      />
      <path
        fill='#00f7ef'
        d='m375.32,166.81v49.13c-8.6-.84-19.74-2.78-32.09-7.31-16.13-5.91-28.13-13.99-35.98-20.25v99.32l-.19-.31c.14,1.96.19,3.97.19,5.99,0,49.33-40.13,89.48-89.48,89.48s-89.48-40.15-89.48-89.48,40.13-89.5,89.48-89.5c4.82,0,9.57.39,14.2,1.13v48.43c-4.45-1.6-9.22-2.45-14.2-2.45-23.36,0-42.38,19-42.38,42.38s19.02,42.38,42.38,42.38,42.38-19.02,42.38-42.38c0-.88-.02-1.75-.08-2.63V97.74h49.11c.18,4.16.35,8.34.53,12.51.33,8.19,3.25,16.05,8.33,22.49,5.97,7.57,14.76,16.36,27.13,23.38,11.57,6.56,22.45,9.38,30.15,10.7Z'
      />
      <path
        fill='#fff'
        d='m386.06,188.29v49.13c-8.6-.84-19.74-2.78-32.09-7.31-16.13-5.91-28.13-13.99-35.98-20.25v99.32l-.19-.31c.14,1.96.19,3.97.19,5.99,0,49.33-40.13,89.48-89.48,89.48s-89.48-40.15-89.48-89.48,40.13-89.5,89.48-89.5c4.82,0,9.57.39,14.2,1.13v48.43c-4.45-1.6-9.22-2.45-14.2-2.45-23.36,0-42.38,19-42.38,42.38s19.02,42.38,42.38,42.38,42.38-19.02,42.38-42.38c0-.88-.02-1.75-.08-2.63V119.22h49.11c.18,4.16.35,8.34.53,12.51.33,8.19,3.25,16.05,8.32,22.49,5.97,7.57,14.76,16.36,27.13,23.38,11.57,6.56,22.45,9.38,30.15,10.7Z'
      />
    </svg>
  )
}

export function xIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50' width='1em' height='1em' {...props}>
      <path
        d='M 5.92 6 L 20.58 27.38 L 6.23 44 L 9.41 44 L 21.99 29.42 L 31.99 44 L 44 44 L 28.68 21.67 L 42.2 6 L 39.03 6 L 27.28 19.62 L 17.93 6 L 5.92 6 z M 9.72 8 L 16.88 8 L 40.2 42 L 33.04 42 L 9.72 8 z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.5'
      />
    </svg>
  )
}

export function GoogleSheetsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width='96px'
      height='96px'
    >
      <path
        fill='#43a047'
        d='M37,45H11c-1.66,0-3-1.34-3-3V6c0-1.66,1.34-3,3-3h19l10,10v29C40,43.66,38.66,45,37,45z'
      />
      <path fill='#c8e6c9' d='M40 13L30 13 30 3z' />
      <path fill='#2e7d32' d='M30 13L40 23 40 13z' />
      <path
        fill='#e8f5e9'
        d='M31,23H17h-2v2v2v2v2v2v2v2h18v-2v-2v-2v-2v-2v-2v-2H31z M17,25h4v2h-4V25z M17,29h4v2h-4V29z M17,33h4v2h-4V33z M31,35h-8v-2h8V35z M31,31h-8v-2h8V31z M31,27h-8v-2h8V27z'
      />
    </svg>
  )
}

export const S3Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox='0 0 80 80'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g
      id='Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(40, 40) scale(1.25) translate(-40, -40)'
    >
      <g
        id='Icon-Service/64/Amazon-Simple-Storage-Service_64'
        transform='translate(8, 8)'
        fill='currentColor'
      >
        <path
          d='M52.84,34.89 L53.22,32.19 C56.76,34.31 56.81,35.19 56.81,35.21 C56.8,35.21 56.2,35.72 52.84,34.89 L52.84,34.89 Z M50.89,34.35 C44.77,32.5 36.25,28.59 32.8,26.96 C32.8,26.95 32.8,26.93 32.8,26.92 C32.8,25.59 31.73,24.52 30.4,24.52 C29.08,24.52 28,25.59 28,26.92 C28,28.24 29.08,29.32 30.4,29.32 C30.98,29.32 31.51,29.11 31.93,28.76 C35.99,30.68 44.44,34.53 50.61,36.35 L48.17,53.56 C48.16,53.61 48.16,53.65 48.16,53.7 C48.16,55.22 41.45,58 30.49,58 C19.42,58 12.64,55.22 12.64,53.7 C12.64,53.66 12.64,53.61 12.63,53.57 L7.54,16.36 C11.95,19.39 21.43,21 30.5,21 C39.56,21 49.02,19.4 53.44,16.37 L50.89,34.35 Z M7,12.48 C7.07,11.16 14.63,6 30.5,6 C46.36,6 53.93,11.16 54,12.48 L54,12.93 C53.13,15.88 43.33,19 30.5,19 C17.65,19 7.84,15.87 7,12.91 L7,12.48 Z M56,12.5 C56,9.03 46.07,4 30.5,4 C14.93,4 5,9.03 5,12.5 L5.09,13.25 L10.64,53.78 C10.77,58.31 22.86,60 30.49,60 C39.97,60 50.03,57.82 50.16,53.78 L52.55,36.88 C53.89,37.2 54.98,37.37 55.87,37.37 C57.05,37.37 57.85,37.08 58.33,36.5 C58.73,36.02 58.88,35.45 58.77,34.84 C58.51,33.46 56.87,31.96 53.52,30.05 L55.9,13.29 L56,12.5 Z'
          id='Amazon-Simple-Storage-Service-Icon_64_Squid'
        />
      </g>
    </g>
  </svg>
)

/**
 * Google's "G", drawn as vectors.
 *
 * This was the official 200x204 PNG embedded as a data URI, and the copy here
 * was corrupt: its image data breaks off after the first 16 KB, so every browser
 * refused it and the Integrations page logged `ERR_INVALID_URL` on each load. The
 * paths are the panel's `GoogleMark`, so both modules draw the same mark. Its four
 * colours are Google's and do not follow the theme.
 */
export function GoogleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' width='24' height='24'>
      <path
        fill='#4285f4'
        d='M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z'
      />
      <path
        fill='#34a853'
        d='M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z'
      />
      <path
        fill='#fbbc05'
        d='M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z'
      />
      <path
        fill='#ea4335'
        d='M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z'
      />
    </svg>
  )
}

export function DevinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 500 500' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M59.29,209.39l48.87,28.21c1.75,1.01,3.71,1.51,5.67,1.51c1.95,0,3.92-0.52,5.67-1.51l48.87-28.21c0,0,0.14-0.11,0.2-0.16c0.74-0.45,1.44-0.99,2.07-1.6c0.09-0.09,0.18-0.2,0.27-0.29c0.54-0.58,1.03-1.21,1.44-1.89c0.06-0.11,0.16-0.2,0.2-0.32c0.43-0.74,0.74-1.53,0.99-2.37c0.05-0.18,0.09-0.36,0.14-0.54c0.2-0.86,0.36-1.74,0.36-2.66v-28.21c0-10.89,5.87-21.03,15.3-26.48c9.42-5.45,21.15-5.44,30.59,0l24.43,14.11c0.79,0.45,1.62,0.77,2.47,1.01c0.18,0.05,0.37,0.11,0.54,0.16c0.83,0.2,1.69,0.32,2.54,0.34c0.05,0,0.09,0,0.11,0c0.09,0,0.18-0.05,0.26-0.05c0.79,0,1.58-0.11,2.34-0.32c0.14-0.03,0.27-0.05,0.4-0.09c0.83-0.23,1.64-0.57,2.41-0.99c0.06-0.05,0.16-0.05,0.23-0.09l48.87-28.21c3.51-2.03,5.67-5.76,5.67-9.81V64.52c0-4.05-2.16-7.78-5.67-9.81l-48.91-28.19c-3.51-2.03-7.81-2.03-11.32,0l-48.87,28.21c0,0-0.14,0.11-0.2,0.16c-0.74,0.45-1.44,0.99-2.07,1.6c-0.09,0.09-0.18,0.2-0.27,0.29c-0.54,0.58-1.03,1.21-1.44,1.89c-0.06,0.11-0.16,0.2-0.2,0.31c-0.43,0.74-0.74,1.53-0.99,2.37c-0.05,0.18-0.09,0.36-0.14,0.54c-0.2,0.86-0.36,1.74-0.36,2.66v28.21c0,10.89-5.87,21.03-15.3,26.5c-9.42,5.44-21.15,5.44-30.59,0l-24.42-14.1c-0.79-0.45-1.63-0.77-2.47-1.01c-0.18-0.05-0.36-0.11-0.54-0.16c-0.84-0.2-1.69-0.31-2.55-0.34c-0.14,0-0.25,0-0.38,0c-0.81,0-1.6,0.11-2.37,0.31c-0.14,0.02-0.25,0.05-0.38,0.09c-0.82,0.23-1.63,0.57-2.4,1c-0.06,0.05-0.16,0.05-0.23,0.09l-48.84,28.24c-3.51,2.03-5.67,5.76-5.67,9.81v56.42c0,4.05,2.16,7.78,5.67,9.81C59.29,209.41,59.29,209.39,59.29,209.39z'
        fill='#2A6DCE'
      />
      <path
        d='M325.46,223.49c9.42-5.44,21.15-5.44,30.59,0l24.43,14.11c0.79,0.45,1.62,0.77,2.47,1.01c0.18,0.05,0.36,0.11,0.54,0.16c0.83,0.2,1.69,0.31,2.54,0.34c0.05,0,0.09,0,0.11,0c0.09,0,0.18-0.03,0.26-0.05c0.79,0,1.58-0.11,2.34-0.31c0.14-0.03,0.27-0.05,0.4-0.09c0.83-0.23,1.62-0.57,2.41-0.99c0.06-0.05,0.16-0.05,0.25-0.09l48.87-28.21c3.51-2.03,5.67-5.76,5.67-9.81v-56.43c0-4.05-2.16-7.78-5.67-9.81l-48.84-28.22c-3.51-2.03-7.81-2.03-11.32,0l-48.87,28.21c0,0-0.14,0.11-0.2,0.16c-0.74,0.45-1.44,0.99-2.07,1.6c-0.09,0.09-0.18,0.2-0.26,0.29c-0.54,0.58-1.03,1.21-1.44,1.89c-0.06,0.11-0.16,0.2-0.2,0.32c-0.43,0.74-0.74,1.53-0.99,2.37c-0.05,0.18-0.09,0.36-0.14,0.54c-0.2,0.86-0.36,1.74-0.36,2.66v28.21c0,10.89-5.87,21.03-15.3,26.5c-9.42,5.44-21.15,5.44-30.59,0l-24.43-14.11c-0.79-0.45-1.62-0.77-2.47-1.01c-0.18-0.05-0.36-0.11-0.54-0.16c-0.83-0.2-1.69-0.32-2.54-0.34c-0.14,0-0.25,0-0.38,0c-0.81,0-1.6,0.11-2.37,0.32c-0.14,0.03-0.25,0.05-0.38,0.09c-0.83,0.23-1.64,0.57-2.41,0.99c-0.06,0.05-0.16,0.05-0.23,0.09l-48.87,28.21c-3.51,2.03-5.67,5.76-5.67,9.81v56.43c0,4.05,2.16,7.78,5.67,9.81l48.87,28.21c0,0,0.16,0.05,0.23,0.09c0.77,0.43,1.58,0.77,2.41,0.99c0.14,0.05,0.27,0.05,0.4,0.09c0.77,0.18,1.55,0.29,2.34,0.32c0.09,0,0.18,0.05,0.27,0.05c0.05,0,0.09,0,0.11,0c0.86,0,1.69-0.14,2.54-0.34c0.18-0.05,0.36-0.09,0.54-0.16c0.86-0.25,1.69-0.57,2.47-1.01l24.43-14.11c9.42-5.44,21.15-5.44,30.59,0c9.42,5.44,15.3,15.59,15.3,26.48v28.21c0,0.92,0.14,1.8,0.36,2.66c0.05,0.18,0.09,0.36,0.14,0.54c0.25,0.83,0.56,1.62,0.99,2.37c0.06,0.11,0.14,0.2,0.2,0.31c0.4,0.68,0.9,1.31,1.44,1.89c0.09,0.09,0.18,0.2,0.26,0.29c0.61,0.6,1.31,1.12,2.07,1.6c0.06,0.05,0.11,0.11,0.2,0.16l48.87,28.21c1.75,1.01,3.72,1.51,5.67,1.51s3.92-0.52,5.67-1.51l48.87-28.21c3.51-2.03,5.67-5.76,5.67-9.81v-56.43c0-4.05-2.16-7.78-5.67-9.81l-48.87-28.21c0,0-0.16-0.05-0.23-0.09c-0.77-0.43-1.58-0.77-2.41-0.99c-0.14-0.05-0.25-0.05-0.38-0.09c-0.79-0.18-1.57-0.29-2.38-0.32c-0.11,0-0.25,0-0.36,0c-0.86,0-1.71,0.14-2.54,0.34c-0.18,0.05-0.34,0.09-0.52,0.16c-0.86,0.25-1.69,0.57-2.47,1.01l-24.43,14.11c-9.42,5.44-21.15,5.44-30.58,0c-9.42-5.44-15.3-15.59-15.3-26.5c0-10.91,5.87-21.03,15.3-26.48C325.55,223.49,325.46,223.49,325.46,223.49z'
        fill='#1DC19C'
      />
      <path
        d='M304.5,369.22l-48.87-28.21c0,0-0.16-0.05-0.23-0.09c-0.77-0.43-1.57-0.77-2.41-0.99c-0.14-0.05-0.27-0.05-0.4-0.09c-0.79-0.18-1.57-0.29-2.37-0.32c-0.14,0-0.25,0-0.38,0c-0.86,0-1.71,0.14-2.54,0.34c-0.18,0.05-0.34,0.09-0.52,0.16c-0.86,0.25-1.69,0.57-2.47,1.01l-24.43,14.11c-9.42,5.44-21.15,5.44-30.58,0c-9.42-5.44-15.3-15.59-15.3-26.5v-28.22c0-0.92-0.14-1.8-0.36-2.66c-0.05-0.18-0.09-0.36-0.14-0.54c-0.25-0.83-0.57-1.62-0.99-2.37c-0.06-0.11-0.14-0.2-0.2-0.32c-0.4-0.68-0.9-1.31-1.44-1.89c-0.09-0.09-0.18-0.2-0.27-0.29c-0.6-0.6-1.31-1.12-2.07-1.6c-0.06-0.05-0.11-0.11-0.2-0.16l-48.87-28.21c-3.51-2.03-7.81-2.03-11.32,0L59.28,290.6c-3.51,2.03-5.67,5.76-5.67,9.81v56.43c0,4.05,2.16,7.78,5.67,9.81l48.87,28.21c0,0,0.16,0.06,0.23,0.09c0.77,0.43,1.55,0.77,2.38,0.99c0.14,0.05,0.27,0.06,0.4,0.09c0.77,0.18,1.55,0.29,2.34,0.32c0.09,0,0.18,0.05,0.29,0.05c0.05,0,0.09,0,0.14,0c0.86,0,1.69-0.14,2.52-0.34c0.18-0.05,0.36-0.09,0.54-0.16c0.86-0.25,1.69-0.57,2.47-1.01l24.43-14.11c9.42-5.44,21.15-5.44,30.59,0c9.42,5.44,15.3,15.59,15.3,26.48v28.21c0,0.92,0.14,1.8,0.36,2.66c0.05,0.18,0.09,0.36,0.14,0.54c0.25,0.83,0.57,1.62,0.99,2.37c0.06,0.11,0.14,0.2,0.2,0.32c0.4,0.68,0.9,1.31,1.44,1.89c0.09,0.09,0.18,0.2,0.27,0.29c0.61,0.61,1.31,1.12,2.07,1.6c0.06,0.05,0.11,0.11,0.2,0.16l48.87,28.21c1.75,1.01,3.71,1.51,5.67,1.51c1.96,0,3.92-0.52,5.67-1.51l48.87-28.21c3.51-2.03,5.67-5.76,5.67-9.81v-56.43c0-4.05-2.16-7.78-5.67-9.81L304.5,369.22z'
        fill='#1796E2'
      />
    </svg>
  )
}

export function DocuSignIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 1547 1549' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='m1113.4 1114.9v395.6c0 20.8-16.7 37.6-37.5 37.6h-1038.4c-20.7 0-37.5-16.8-37.5-37.6v-1039c0-20.7 16.8-37.5 37.5-37.5h394.3v643.4c0 20.7 16.8 37.5 37.5 37.5z'
        fill='#4c00ff'
      />
      <path
        d='m1546 557.1c0 332.4-193.9 557-432.6 557.8v-418.8c0-12-4.8-24-13.5-31.9l-217.1-217.4c-8.8-8.8-20-13.6-32-13.6h-418.2v-394.8c0-20.8 16.8-37.6 37.5-37.6h585.1c277.7-0.8 490.8 223 490.8 556.3z'
        fill='#ff5252'
      />
      <path
        d='m1099.9 663.4c8.7 8.7 13.5 19.9 13.5 31.9v418.8h-643.3c-20.7 0-37.5-16.8-37.5-37.5v-643.4h418.2c12 0 24 4.8 32 13.6z'
        fill='#000000'
      />
    </svg>
  )
}

export function DiscordIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='0 -28.5 256 256'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M216.86,16.6 C200.29,8.84 182.57,3.21 164.04,0 C161.77,4.11 159.11,9.65 157.28,14.05 C137.58,11.08 118.07,11.08 98.74,14.05 C96.91,9.65 94.19,4.11 91.9,0 C73.35,3.21 55.61,8.86 39.04,16.64 C5.62,67.15 -3.44,116.4 1.09,164.96 C23.26,181.51 44.74,191.57 65.86,198.15 C71.08,190.97 75.73,183.34 79.74,175.3 C72.1,172.4 64.79,168.82 57.89,164.67 C59.72,163.31 61.51,161.89 63.24,160.43 C105.37,180.13 151.13,180.13 192.75,160.43 C194.51,161.89 196.3,163.31 198.11,164.67 C191.18,168.84 183.85,172.42 176.22,175.32 C180.23,183.34 184.86,190.99 190.1,198.17 C211.24,191.59 232.74,181.53 254.91,164.96 C260.23,108.67 245.83,59.87 216.86,16.6 Z M85.47,135.09 C72.83,135.09 62.46,123.29 62.46,108.91 C62.46,94.54 72.61,82.71 85.47,82.71 C98.34,82.71 108.71,94.52 108.49,108.91 C108.51,123.29 98.34,135.09 85.47,135.09 Z M170.53,135.09 C157.88,135.09 147.51,123.29 147.51,108.91 C147.51,94.54 157.66,82.71 170.53,82.71 C183.39,82.71 193.76,94.52 193.54,108.91 C193.54,123.29 183.39,135.09 170.53,135.09 Z'
          fill='currentColor'
          fillRule='nonzero'
        />
      </g>
    </svg>
  )
}

export function LinkedInIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      height='72'
      viewBox='0 0 72 72'
      width='72'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M62,62 L51.32,62 L51.32,43.8 C51.32,38.81 49.42,36.02 45.47,36.02 C41.17,36.02 38.93,38.93 38.93,43.8 L38.93,62 L28.63,62 L28.63,27.33 L38.93,27.33 L38.93,32 C38.93,32 42.03,26.27 49.38,26.27 C56.74,26.27 62,30.76 62,40.05 L62,62 Z M16.35,22.79 C12.84,22.79 10,19.93 10,16.4 C10,12.86 12.84,10 16.35,10 C19.86,10 22.7,12.86 22.7,16.4 C22.7,19.93 19.86,22.79 16.35,22.79 Z M11.03,62 L21.77,62 L21.77,27.33 L11.03,27.33 L11.03,62 Z'
        fill='currentColor'
      />
    </svg>
  )
}

/** Instagram camera glyph rendered with the block's brand gradient background. */
export function InstagramIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' />
    </svg>
  )
}

export function CrunchbaseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='2 2 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.396 19.286c1.411 0.646 3.078 0.021 3.724-1.391h2.214c-1.38 5.651-9.698 4.651-9.698-1.167 0-5.823 8.318-6.823 9.698-1.167h-2.214c-0.813-1.786-3.161-2.214-4.547-0.823-1.391 1.385-0.964 3.734 0.823 4.547zM24.521 20.411c-0.422 0.365-0.896 0.646-1.417 0.844-1.495 0.578-3.182 0.391-4.516-0.51v0.51h-2.016v-14.094h2v5.479c0.714-0.484 1.542-0.771 2.401-0.839h0.359c4.552-0.010 6.646 5.656 3.188 8.609zM24.224 16.724c0.031 1.573-1.234 2.87-2.807 2.87s-2.839-1.297-2.802-2.87c0.078-3.656 5.526-3.656 5.609 0z'
        fill='currentColor'
      />
    </svg>
  )
}

export function InputIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='26'
      height='21'
      viewBox='0 0 26 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.6 20.8C1.89 20.8 1.27 20.55 0.76 20.04C0.26 19.53 0 18.92 0 18.2V15.6C0 15.23 0.12 14.92 0.37 14.67C0.62 14.43 0.93 14.3 1.3 14.3C1.67 14.3 1.98 14.42 2.23 14.67C2.48 14.92 2.6 15.23 2.6 15.6V18.2H23.4V2.6H2.6V5.2C2.6 5.57 2.48 5.88 2.23 6.13C1.98 6.38 1.67 6.5 1.3 6.5C0.93 6.5 0.62 6.37 0.37 6.13C0.12 5.88 0 5.57 0 5.2V2.6C0 1.89 0.25 1.27 0.76 0.76C1.27 0.26 1.89 0 2.6 0H23.4C24.12 0 24.73 0.25 25.24 0.76C25.75 1.27 26 1.89 26 2.6V18.2C26 18.92 25.75 19.53 25.24 20.04C24.73 20.55 24.12 20.8 23.4 20.8H2.6ZM13.23 11.7H1.3C0.93 11.7 0.62 11.58 0.37 11.33C0.13 11.08 0 10.77 0 10.4C0 10.03 0.12 9.72 0.37 9.47C0.62 9.22 0.93 9.1 1.3 9.1H13.23L11.44 7.35C11.18 7.11 11.06 6.81 11.07 6.45C11.08 6.09 11.2 5.79 11.44 5.53C11.7 5.27 12.01 5.13 12.37 5.12C12.72 5.11 13.03 5.23 13.29 5.49L17.29 9.49C17.55 9.75 17.68 10.05 17.68 10.4C17.68 10.75 17.55 11.05 17.29 11.31L13.29 15.31C13.03 15.57 12.72 15.7 12.37 15.7C12.01 15.7 11.7 15.57 11.44 15.31C11.2 15.05 11.08 14.74 11.07 14.38C11.05 14.02 11.18 13.72 11.44 13.46L13.23 11.7Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function StartIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='26'
      height='16'
      viewBox='0 0 26 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.8 13C9.23 13 10.45 12.49 11.47 11.47C12.49 10.45 13 9.23 13 7.8C13 6.37 12.49 5.15 11.47 4.13C10.45 3.11 9.23 2.6 7.8 2.6C6.37 2.6 5.15 3.11 4.13 4.13C3.11 5.15 2.6 6.37 2.6 7.8C2.6 9.23 3.11 10.45 4.13 11.47C5.15 12.49 6.37 13 7.8 13ZM7.8 15.6C5.63 15.6 3.79 14.84 2.28 13.33C0.76 11.81 0 9.97 0 7.8C0 5.63 0.76 3.79 2.28 2.28C3.79 0.76 5.63 0 7.8 0C9.75 0 11.45 0.62 12.89 1.85C14.33 3.09 15.2 4.64 15.5 6.5H24.7C25.07 6.5 25.38 6.62 25.63 6.87C25.88 7.12 26 7.43 26 7.8C26 8.17 25.87 8.48 25.63 8.73C25.38 8.98 25.07 9.1 24.7 9.1H15.5C15.2 10.96 14.33 12.51 12.89 13.75C11.44 14.98 9.75 15.6 7.8 15.6Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ProfoundIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width='1em' height='1em' viewBox='0 0 55 55' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='currentColor'
        d='M0 36.69V21.35a7.02 7.02 0 0 1 2.91-5.69l19.74-14.25A7.44 7.44 0 0 1 27 0h.062c1.62 0 3.19.508 4.5 1.45l19.68 14.21a7.02 7.02 0 0 1 2.91 5.69v12.3a7.01 7.01 0 0 1-2.91 5.69L31.53 53.56A7.61 7.61 0 0 1 27.08 55a7.64 7.64 0 0 1-4.46-1.44c-2.58-1.86-6.73-4.86-6.73-4.86V29.78c0-.249.28-.393.48-.248l10.54 7.61c.106.08.249.08.355 0l13.01-9.39a.306.31 0 0 0 0-.496l-13-9.39a.303.3 0 0 0-.355 0L.482 36.93A.304.3 0 0 1 0 36.69Z'
      />
    </svg>
  )
}

export function ProspeoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='1em'
      height='1em'
      viewBox='1.17 1.178 29.66 29.643'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='32' height='32' rx='6' fill='#FF1A26' />
      <g transform='translate(16 16) scale(1.12) translate(-16 -16)'>
        <path
          d='M6.07 10.21C6.01 10.25 5.98 10.31 5.98 10.38V18.74C5.98 18.81 6.01 18.88 6.07 18.91L13.13 23.09C13.19 23.13 13.27 23.13 13.33 23.09L20.38 18.91C20.45 18.88 20.48 18.81 20.48 18.74V10.38C20.48 10.31 20.45 10.25 20.38 10.21L13.33 6.04C13.27 6 13.19 6 13.13 6.04L6.07 10.21ZM19.67 10.2C19.8 10.28 19.8 10.47 19.67 10.54L13.33 14.3C13.27 14.33 13.19 14.33 13.13 14.3L6.78 10.54C6.65 10.47 6.65 10.28 6.78 10.2L13.13 6.44C13.19 6.41 13.27 6.41 13.33 6.44L19.67 10.2ZM6.32 11.03C6.32 10.87 6.49 10.78 6.62 10.86L12.96 14.61C13.02 14.64 13.06 14.71 13.06 14.78V22.29C13.06 22.44 12.89 22.54 12.75 22.46L6.42 18.71C6.36 18.67 6.32 18.61 6.32 18.54V11.03ZM13.7 22.46C13.57 22.54 13.4 22.44 13.4 22.29V14.78C13.4 14.71 13.44 14.64 13.5 14.61L19.84 10.86C19.97 10.78 20.14 10.87 20.14 11.03V18.54C20.14 18.61 20.1 18.67 20.04 18.71L13.7 22.46Z'
          fill='#FF1A26'
        />
        <path
          d='M15.5 16.24C15.44 16.27 15.41 16.34 15.41 16.41V22.67C15.41 22.74 15.44 22.81 15.5 22.84L20.61 25.96C20.68 26 20.76 26 20.82 25.96L25.93 22.84C25.99 22.81 26.02 22.74 26.02 22.67V16.41C26.02 16.34 25.99 16.27 25.93 16.24L20.82 13.12C20.76 13.08 20.68 13.08 20.61 13.12L15.5 16.24ZM25.37 16.2C25.49 16.28 25.49 16.47 25.37 16.54L20.82 19.32C20.76 19.36 20.68 19.36 20.61 19.32L16.07 16.54C15.94 16.47 15.94 16.28 16.07 16.2L20.61 13.42C20.68 13.39 20.76 13.39 20.82 13.42L25.37 16.2ZM15.66 16.96C15.66 16.8 15.83 16.71 15.97 16.79L20.49 19.56C20.55 19.59 20.59 19.66 20.59 19.73V25.28C20.59 25.44 20.42 25.54 20.29 25.45L15.76 22.69C15.7 22.65 15.66 22.59 15.66 22.52V16.96ZM21.15 25.45C21.01 25.54 20.84 25.44 20.84 25.28V19.73C20.84 19.66 20.88 19.59 20.94 19.56L25.47 16.79C25.6 16.71 25.77 16.8 25.77 16.96V22.52C25.77 22.59 25.73 22.65 25.68 22.69L21.15 25.45Z'
          fill='#FF1A26'
        />
        <path
          d='M20.04 18.71L19.81 18.31L20.04 18.71ZM19.84 10.86L20.07 11.25L19.84 10.86ZM13.5 14.61L13.27 14.21L13.5 14.61ZM13.7 22.46L13.94 22.85L13.7 22.46ZM6.42 18.71L6.19 19.1L6.42 18.71ZM12.75 22.46L12.52 22.85L12.75 22.46ZM12.96 14.61L13.19 14.21L12.96 14.61ZM6.62 10.86L6.86 10.46L6.62 10.86ZM13.13 6.44L12.89 6.05L13.13 6.44ZM13.33 6.44L13.56 6.05L13.33 6.44ZM6.78 10.54L6.55 10.94L6.78 10.54ZM6.78 10.2L7.02 10.59L6.78 10.2ZM13.33 14.3L13.1 13.9L13.33 14.3ZM13.13 14.3L12.89 14.69L13.13 14.3ZM19.67 10.54L19.44 10.15L19.67 10.54ZM13.33 6.04L13.1 6.43L13.33 6.04ZM13.13 6.04L12.89 5.64L13.13 6.04ZM20.38 10.21L20.15 10.6L20.38 10.21ZM20.38 18.91L20.62 19.31L20.38 18.91ZM13.13 23.09L13.36 22.69L13.13 23.09ZM13.33 23.09L13.1 22.69L13.33 23.09ZM6.07 18.91L6.31 18.52L6.07 18.91ZM6.07 10.21L6.31 10.6L6.07 10.21ZM5.52 10.38V18.74H6.43V10.38H5.52ZM5.84 19.31L12.89 23.48L13.36 22.69L6.31 18.52L5.84 19.31ZM13.56 23.48L20.62 19.31L20.15 18.52L13.1 22.69L13.56 23.48ZM20.94 18.74V10.38H20.02V18.74H20.94ZM20.62 9.82L13.56 5.64L13.1 6.43L20.15 10.6L20.62 9.82ZM12.89 5.64L5.84 9.82L6.31 10.6L13.36 6.43L12.89 5.64ZM19.44 10.15L13.1 13.9L13.56 14.69L19.91 10.94L19.44 10.15ZM13.36 13.9L7.02 10.15L6.55 10.94L12.89 14.69L13.36 13.9ZM7.02 10.59L13.36 6.84L12.89 6.05L6.55 9.8L7.02 10.59ZM13.1 6.84L19.44 10.59L19.91 9.8L13.56 6.05L13.1 6.84ZM6.39 11.25L12.72 15L13.19 14.21L6.86 10.46L6.39 11.25ZM12.6 14.78V22.29H13.51V14.78H12.6ZM12.99 22.06L6.65 18.31L6.19 19.1L12.52 22.85L12.99 22.06ZM6.78 18.54V11.03H5.86V18.54H6.78ZM13.86 22.29V14.78H12.94V22.29H13.86ZM13.73 15L20.07 11.25L19.6 10.46L13.27 14.21L13.73 15ZM19.68 11.03V18.54H20.6V11.03H19.68ZM19.81 18.31L13.47 22.06L13.94 22.85L20.27 19.1L19.81 18.31ZM19.68 18.54C19.68 18.45 19.73 18.36 19.81 18.31L20.27 19.1C20.47 18.98 20.6 18.77 20.6 18.54H19.68ZM20.07 11.25C19.9 11.35 19.68 11.23 19.68 11.03H20.6C20.6 10.52 20.04 10.2 19.6 10.46L20.07 11.25ZM13.86 14.78C13.86 14.87 13.81 14.95 13.73 15L13.27 14.21C13.07 14.33 12.94 14.55 12.94 14.78H13.86ZM12.94 22.29C12.94 22.8 13.5 23.11 13.94 22.85L13.47 22.06C13.64 21.96 13.86 22.09 13.86 22.29H12.94ZM6.65 18.31C6.73 18.36 6.78 18.45 6.78 18.54H5.86C5.86 18.77 5.99 18.98 6.19 19.1L6.65 18.31ZM12.6 22.29C12.6 22.09 12.82 21.96 12.99 22.06L12.52 22.85C12.96 23.11 13.51 22.8 13.51 22.29H12.6ZM12.72 15C12.65 14.95 12.6 14.87 12.6 14.78H13.51C13.51 14.55 13.39 14.33 13.19 14.21L12.72 15ZM6.86 10.46C6.42 10.2 5.86 10.52 5.86 11.03H6.78C6.78 11.23 6.56 11.35 6.39 11.25L6.86 10.46ZM13.36 6.84C13.28 6.89 13.18 6.89 13.1 6.84L13.56 6.05C13.36 5.93 13.1 5.93 12.89 6.05L13.36 6.84ZM7.02 10.15C7.19 10.25 7.19 10.49 7.02 10.59L6.55 9.8C6.12 10.06 6.12 10.68 6.55 10.94L7.02 10.15ZM13.1 13.9C13.18 13.86 13.28 13.86 13.36 13.9L12.89 14.69C13.1 14.81 13.36 14.81 13.56 14.69L13.1 13.9ZM19.91 10.94C20.34 10.68 20.34 10.06 19.91 9.8L19.44 10.59C19.27 10.49 19.27 10.25 19.44 10.15L19.91 10.94ZM13.56 5.64C13.36 5.52 13.1 5.52 12.89 5.64L13.36 6.43C13.28 6.48 13.18 6.48 13.1 6.43L13.56 5.64ZM20.94 10.38C20.94 10.15 20.82 9.93 20.62 9.82L20.15 10.6C20.07 10.56 20.02 10.47 20.02 10.38H20.94ZM20.62 19.31C20.82 19.19 20.94 18.97 20.94 18.74H20.02C20.02 18.65 20.07 18.57 20.15 18.52L20.62 19.31ZM12.89 23.48C13.1 23.61 13.36 23.61 13.56 23.48L13.1 22.69C13.18 22.65 13.28 22.65 13.36 22.69L12.89 23.48ZM5.52 18.74C5.52 18.97 5.64 19.19 5.84 19.31L6.31 18.52C6.39 18.57 6.43 18.65 6.43 18.74H5.52ZM6.43 10.38C6.43 10.47 6.39 10.56 6.31 10.6L5.84 9.82C5.64 9.93 5.52 10.15 5.52 10.38H6.43Z'
          fill='white'
        />
        <path
          d='M20.43 13.29L15.94 16.23C15.89 16.27 15.86 16.32 15.85 16.38L15.29 22.29C15.28 22.37 15.32 22.45 15.39 22.49L20.43 25.43C20.5 25.47 20.57 25.47 20.64 25.43L25.68 22.49C25.75 22.45 25.79 22.37 25.78 22.29L25.22 16.38C25.21 16.32 25.18 16.27 25.13 16.23L20.65 13.29C20.58 13.25 20.49 13.25 20.43 13.29Z'
          fill='#FF1A26'
        />
        <path
          d='M25.68 22.69L25.44 22.3L25.68 22.69ZM25.47 16.79L25.71 17.18L25.47 16.79ZM20.94 19.56L21.18 19.95L20.94 19.56ZM21.15 25.45L21.39 25.85L21.15 25.45ZM15.76 22.69L16 22.3L15.76 22.69ZM20.29 25.45L20.05 25.85L20.29 25.45ZM20.49 19.56L20.25 19.95L20.49 19.56ZM20.61 13.42L20.85 13.82L20.61 13.42ZM20.82 13.42L20.58 13.82L20.82 13.42ZM16.07 16.54L15.83 16.93L16.07 16.54ZM20.82 19.32L21.06 19.71L20.82 19.32ZM20.61 19.32L20.85 18.93L20.61 19.32ZM25.37 16.54L25.6 16.93L25.37 16.54ZM25.37 16.2L25.13 16.59L25.37 16.2ZM20.61 13.12L20.37 12.72L20.61 13.12ZM25.93 16.24L26.17 15.85L25.93 16.24ZM25.93 22.84L26.17 23.23L25.93 22.84ZM20.61 25.96L20.37 26.35L20.61 25.96ZM20.82 25.96L21.06 26.35L20.82 25.96ZM15.5 22.84L15.26 23.23L15.5 22.84ZM15.5 16.24L15.26 15.85L15.5 16.24ZM14.95 16.41V22.67H15.87V16.41H14.95ZM15.26 23.23L20.37 26.35L20.85 25.57L15.74 22.45L15.26 23.23ZM21.06 26.35L26.17 23.23L25.69 22.45L20.58 25.57L21.06 26.35ZM26.48 22.67V16.41H25.57V22.67H26.48ZM26.17 15.85L21.06 12.72L20.58 13.51L25.69 16.63L26.17 15.85ZM20.37 12.72L15.26 15.85L15.74 16.63L20.85 13.51L20.37 12.72ZM25.13 16.15L20.58 18.93L21.06 19.71L25.6 16.93L25.13 16.15ZM20.85 18.93L16.31 16.15L15.83 16.93L20.37 19.71L20.85 18.93ZM16.31 16.59L20.85 13.82L20.37 13.03L15.83 15.81L16.31 16.59ZM20.58 13.82L25.13 16.59L25.6 15.81L21.06 13.03L20.58 13.82ZM15.73 17.18L20.25 19.95L20.73 19.17L16.2 16.4L15.73 17.18ZM20.13 19.73V25.28H21.05V19.73H20.13ZM20.52 25.06L16 22.3L15.52 23.08L20.05 25.85L20.52 25.06ZM16.12 22.52V16.96H15.2V22.52H16.12ZM21.3 25.28V19.73H20.38V25.28H21.3ZM21.18 19.95L25.71 17.18L25.23 16.4L20.7 19.17L21.18 19.95ZM25.31 16.96V22.52H26.23V16.96H25.31ZM25.44 22.3L20.91 25.06L21.39 25.85L25.91 23.08L25.44 22.3ZM25.31 22.52C25.31 22.43 25.36 22.34 25.44 22.3L25.91 23.08C26.11 22.96 26.23 22.75 26.23 22.52H25.31ZM25.71 17.18C25.53 17.29 25.31 17.16 25.31 16.96H26.23C26.23 16.45 25.67 16.13 25.23 16.4L25.71 17.18ZM21.3 19.73C21.3 19.82 21.25 19.9 21.18 19.95L20.7 19.17C20.5 19.29 20.38 19.5 20.38 19.73H21.3ZM20.38 25.28C20.38 25.8 20.95 26.11 21.39 25.85L20.91 25.06C21.08 24.96 21.3 25.08 21.3 25.28H20.38ZM16 22.3C16.07 22.34 16.12 22.43 16.12 22.52H15.2C15.2 22.75 15.32 22.96 15.52 23.08L16 22.3ZM20.13 25.28C20.13 25.08 20.35 24.96 20.52 25.06L20.05 25.85C20.49 26.11 21.05 25.8 21.05 25.28H20.13ZM20.25 19.95C20.18 19.9 20.13 19.82 20.13 19.73H21.05C21.05 19.5 20.93 19.29 20.73 19.17L20.25 19.95ZM16.2 16.4C15.77 16.13 15.2 16.45 15.2 16.96H16.12C16.12 17.16 15.9 17.29 15.73 17.18L16.2 16.4ZM20.85 13.82C20.77 13.87 20.66 13.87 20.58 13.82L21.06 13.03C20.85 12.9 20.58 12.9 20.37 13.03L20.85 13.82ZM16.31 16.15C16.47 16.25 16.47 16.49 16.31 16.59L15.83 15.81C15.41 16.07 15.41 16.68 15.83 16.93L16.31 16.15ZM20.58 18.93C20.66 18.88 20.77 18.88 20.85 18.93L20.37 19.71C20.58 19.84 20.85 19.84 21.06 19.71L20.58 18.93ZM25.6 16.93C26.02 16.68 26.02 16.07 25.6 15.81L25.13 16.59C24.96 16.49 24.96 16.25 25.13 16.15L25.6 16.93ZM21.06 12.72C20.85 12.6 20.58 12.6 20.37 12.72L20.85 13.51C20.77 13.56 20.66 13.56 20.58 13.51L21.06 12.72ZM26.48 16.41C26.48 16.18 26.36 15.97 26.17 15.85L25.69 16.63C25.61 16.58 25.57 16.5 25.57 16.41H26.48ZM26.17 23.23C26.36 23.11 26.48 22.9 26.48 22.67H25.57C25.57 22.58 25.61 22.5 25.69 22.45L26.17 23.23ZM20.37 26.35C20.58 26.48 20.85 26.48 21.06 26.35L20.58 25.57C20.66 25.52 20.77 25.52 20.85 25.57L20.37 26.35ZM14.95 22.67C14.95 22.9 15.07 23.11 15.26 23.23L15.74 22.45C15.82 22.5 15.87 22.58 15.87 22.67H14.95ZM15.87 16.41C15.87 16.5 15.82 16.58 15.74 16.63L15.26 15.85C15.07 15.97 14.95 16.18 14.95 16.41H15.87Z'
          fill='white'
        />
      </g>
    </svg>
  )
}

export function PineconeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='256px'
      height='288px'
      viewBox='0 0 256 288'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <path
        d='M108.63,254.44 C117.71,254.44 125.07,261.8 125.07,270.88 C125.07,279.96 117.71,287.32 108.63,287.32 C99.55,287.32 92.19,279.96 92.19,270.88 C92.19,261.8 99.55,254.44 108.63,254.44 Z M199.85,224.44 L216.1,229.25 L203.2,272.78 C202.07,276.58 198.46,279.1 194.5,278.83 L190.52,278.55 L190.42,278.63 L149.03,275.73 L150.18,258.82 L177.99,260.71 L159.78,234.45 L173.71,224.79 L191.94,251.09 L199.85,224.44 Z M23.01,194.35 L39.92,195.54 L37.94,223.35 L64.15,205.12 L73.83,219.03 L47.58,237.28 L74.37,245.17 L69.58,261.43 L25.85,248.54 C22.03,247.42 19.51,243.79 19.79,239.82 L23.01,194.35 Z M132.15,170.67 L162.66,207.5 L148.91,218.89 L130.75,196.97 L124.87,230.67 L107.28,227.6 L113.17,193.85 L88.73,208.26 L79.67,192.87 L120.75,168.67 C124.52,166.45 129.36,167.3 132.15,170.67 Z M217.5,145.96 L232.74,137.67 L254.94,178.47 C256.89,182.05 256.09,186.49 253.02,189.16 L249.88,191.88 L217.83,219.77 L206.44,206.68 L227.99,187.93 L195.89,182.15 L198.97,165.08 L231.04,170.86 L217.5,145.96 Z M37.78,103.3 L49.26,116.31 L28.01,135.05 L60.17,140.66 L57.19,157.76 L24.99,152.14 L38.82,177.13 L23.64,185.53 L1.08,144.76 C-0.89,141.2 -0.12,136.75 2.93,134.05 L37.78,103.3 Z M146.48,89.88 L176.88,126.61 L163.13,138 L144.98,116.07 L139.09,149.78 L121.5,146.7 L127.37,113.08 L103.03,127.35 L94,111.95 L131.4,90.02 L131.44,89.88 L131.6,89.9 L135.09,87.87 C138.86,85.66 143.69,86.51 146.48,89.88 Z M185.66,71.81 L192.31,55.79 L235.32,73.64 C239.07,75.2 241.24,79.15 240.54,83.16 L239.82,87.14 L232.48,128.92 L215.39,125.91 L220.31,97.94 L191.78,113.71 L183.39,98.53 L211.98,82.74 L185.66,71.81 Z M103.72,40.24 L104.46,57.57 L76.04,58.79 L97.47,83.27 L84.42,94.7 L62.95,70.17 L57.95,98.17 L40.87,95.12 L49.06,49.36 C49.77,45.36 53.17,42.39 57.23,42.22 L61.25,42.04 L61.34,41.98 L103.72,40.24 Z M161.84,3.27 L192.1,40.24 L178.29,51.55 L160.33,29.6 L154.27,63.27 L136.7,60.11 L142.77,26.37 L118.24,40.71 L109.23,25.29 L150.43,1.22 C154.22,-1 159.06,-0.12 161.84,3.27 Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function LangChainIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#7FC8FF'
        d='M7.531 15.976a7.534 7.534 0 000-10.651L2.206 0A7.537 7.537 0 000 5.326c0 1.996.794 3.913 2.206 5.325l5.325 5.325zM18.674 16.469a7.535 7.535 0 00-10.65 0l5.325 5.325a7.536 7.536 0 0010.651 0l-5.326-5.325zM2.218 21.782a7.536 7.536 0 005.326 2.206v-7.531H.012c0 1.996.795 3.914 2.206 5.325zM20.73 8.595a7.534 7.534 0 00-10.651.001l5.325 5.326 5.326-5.327z'
      />
    </svg>
  )
}

export function CrewAIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M12.482.18C7.161 1.319 1.478 9.069 1.426 15.372c-.051 5.527 3.1 8.68 8.68 8.627 6.716-.05 14.259-6.87 12.09-10.9-.672-1.292-1.396-1.344-2.687-.207-1.602 1.395-1.654.31-.207-2.893 1.757-3.98 1.705-5.322-.31-7.544C17.03.388 14.962-.388 12.482.181Zm5.322 2.068c2.273 2.015 2.376 4.236.465 8.42-1.395 3.1-2.17 3.515-3.824 1.86-1.24-1.24-1.343-3.46-.258-6.044 1.137-2.635.982-3.1-.568-1.653-3.72 3.358-6.458 9.765-5.424 12.503.464 1.189.825 1.395 2.737 1.395 2.79 0 6.303-1.705 7.957-3.926 1.756-2.274 2.79-2.274 2.79-.052 0 3.875-6.459 8.627-11.625 8.627-6.251 0-9.351-4.752-7.491-11.47.878-2.995 4.443-7.904 7.077-9.66 3.255-2.17 5.684-2.17 8.164 0z'
      />
    </svg>
  )
}

export function DustIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 460 460' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/jpeg;base64,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'
        width='460'
        height='460'
      />
    </svg>
  )
}

export function OpenClawIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gid = (name: string) => `openclaw_${name}_${id}`

  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' {...props}>
      <linearGradient
        id={gid('a')}
        x1='-694.696'
        x2='-690.195'
        y1='793.943'
        y2='789.442'
        gradientTransform='matrix(90 0 0 -100 62582 79427)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#ff4d4d' />
        <stop offset='1' stopColor='#991b1b' />
      </linearGradient>
      <path
        fill={`url(#${gid('a')})`}
        d='M256 39.3c-135 0-202.5 112.5-202.5 202.5s67.5 180 135 202.5v45h45v-45s22.5 9 45 0v45h45v-45c67.5-22.5 135-112.5 135-202.5S391 39.3 256 39.3'
      />
      <linearGradient
        id={gid('b')}
        x1='-672.565'
        x2='-668.064'
        y1='777.351'
        y2='772.849'
        gradientTransform='matrix(23.0719 0 0 -21.7808 15519.697 17119.95)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#ff4d4d' />
        <stop offset='1' stopColor='#991b1b' />
      </linearGradient>
      <path
        fill={`url(#${gid('b')})`}
        d='M76 196.8c-67.5-22.5-90 22.5-67.5 67.5s67.5 22.5 90-22.5c13.5-31.5 0-45-22.5-45'
      />
      <linearGradient
        id={gid('c')}
        x1='-658.669'
        x2='-654.168'
        y1='777.486'
        y2='772.985'
        gradientTransform='matrix(23.0719 0 0 -21.7808 15610.38 17119.95)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#ff4d4d' />
        <stop offset='1' stopColor='#991b1b' />
      </linearGradient>
      <path
        fill={`url(#${gid('c')})`}
        d='M436 196.8c67.5-22.5 90 22.5 67.5 67.5s-67.5 22.5-90-22.5c-13.5-31.5 0-45 22.5-45'
      />
      <path
        fill='#ff4d4d'
        d='M188.5 66.3c-1.2 0-2.3-.4-3.2-1.3-27.8-27.8-49.3-38.5-62-30.8-2.1 1.3-4.9.6-6.2-1.5s-.6-4.9 1.5-6.2c17.2-10.3 41.1.2 73 32.2 1.8 1.8 1.8 4.6 0 6.4-.8.7-2 1.2-3.1 1.2M326.7 65c27.8-27.8 49.3-38.5 62-30.8 2.1 1.3 4.9.6 6.2-1.5s.6-4.9-1.5-6.2c-17.2-10.3-41.1.2-73 32.2-1.8 1.8-1.8 4.6 0 6.4.9.9 2 1.3 3.2 1.3s2.2-.6 3.1-1.4'
      />
      <path
        fill='#050810'
        d='M188.5 124.8c14.9 0 27 12.1 27 27s-12.1 27-27 27-27-12.1-27-27 12.1-27 27-27m135 0c14.9 0 27 12.1 27 27s-12.1 27-27 27-27-12.1-27-27 12.1-27 27-27'
      />
      <path
        fill='#00e5cc'
        d='M193 138.3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9m135 0c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9'
      />
    </svg>
  )
}

export function OpenAIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='0 0 24 24'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.28 9.82a5.98 5.98 0 0 0-.516-4.91 6.05 6.05 0 0 0-6.51-2.9A6.07 6.07 0 0 0 4.98 4.18a5.98 5.98 0 0 0-4 2.9 6.05 6.05 0 0 0 .743 7.1 5.98 5.98 0 0 0 .511 4.91 6.05 6.05 0 0 0 6.51 2.9A5.98 5.98 0 0 0 13.26 24a6.06 6.06 0 0 0 5.77-4.21 5.99 5.99 0 0 0 4-2.9 6.06 6.06 0 0 0-.748-7.07zm-9.02 12.61a4.48 4.48 0 0 1-2.88-1.04l.142-.08 4.78-2.76a.795.79 0 0 0 .393-.681v-6.74l2.02 1.17a.71.07 0 0 1 .38.05v5.58a4.5 4.5 0 0 1-4.49 4.49zm-9.66-4.13a4.47 4.47 0 0 1-.535-3.01l.142.09 4.78 2.76a.771.77 0 0 0 .781 0l5.84-3.37v2.33a.804.08 0 0 1-.332.06L9.74 19.95a4.5 4.5 0 0 1-6.14-1.65zM2.34 7.9a4.49 4.49 0 0 1 2.37-1.97V11.6a.766.77 0 0 0 .388.68l5.81 3.35-2.02 1.17a.757.08 0 0 1-.071 0l-4.83-2.79A4.5 4.5 0 0 1 2.34 7.87zm16.6 3.86L13.1 8.36 15.12 7.2a.757.08 0 0 1 .071 0l4.83 2.79a4.49 4.49 0 0 1-.676 8.1v-5.68a.79.79 0 0 0-.407-.667zm2.01-3.02l-.142-.085-4.77-2.78a.776.78 0 0 0-.785 0L9.41 9.23V6.9a.662.07 0 0 1 .028-.061l4.83-2.79a4.5 4.5 0 0 1 6.68 4.66zM8.31 12.86l-2.02-1.16a.804.08 0 0 1-.038-.057V6.07a4.5 4.5 0 0 1 7.38-3.45l-.142.08L8.7 5.46a.795.79 0 0 0-.393.68zm1.1-2.37l2.6-1.5 2.61 1.5v3l-2.6 1.5-2.61-1.5Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ExaAIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='252'
      height='304'
      viewBox='0 0 252 304'
      fill='none'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.82 0.75C5.94 0.75 5.94 0.75 7.09 0.75C7.95 0.75 8.81 0.74 9.69 0.74C10.64 0.74 11.59 0.75 12.57 0.75C13.58 0.75 14.58 0.75 15.62 0.75C19.01 0.74 22.4 0.75 25.79 0.76C28.22 0.76 30.64 0.75 33.06 0.75C38.97 0.75 44.88 0.75 50.79 0.76C57.66 0.77 64.54 0.77 71.41 0.77C83.67 0.77 95.94 0.78 108.2 0.79C120.11 0.81 132.02 0.82 143.93 0.81C144.67 0.81 145.4 0.81 146.16 0.81C146.89 0.81 147.62 0.81 148.38 0.81C161.92 0.81 175.46 0.82 189.01 0.83C193.8 0.83 198.6 0.83 203.4 0.83C209.85 0.83 216.3 0.84 222.75 0.85C225.12 0.85 227.5 0.85 229.87 0.85C233.1 0.85 236.33 0.86 239.55 0.87C240.51 0.86 241.46 0.86 242.44 0.86C248.89 0.89 248.89 0.89 250 2C252.1 17.51 252.1 17.51 247.83 23.73C245.55 26.54 243.02 29.08 240.42 31.59C238.38 33.62 236.64 35.85 234.88 38.13C231.09 42.9 227.24 47.62 223.37 52.33C222.38 53.53 221.4 54.73 220.41 55.94C214.43 63.23 208.44 70.51 202.31 77.69C198.11 82.61 194.1 87.66 190.13 92.76C186.1 97.93 181.88 102.93 177.63 107.91C173.67 112.54 169.84 117.28 166 122C164.5 123.83 163 125.67 161.5 127.5C159.2 130.31 156.91 133.12 154.61 135.93C153.83 136.88 153.05 137.83 152.25 138.81C151.51 139.72 150.78 140.63 150.02 141.56C148.81 143.02 147.58 144.46 146.29 145.85C143.62 148.63 143.62 148.63 143.08 152.29C144.29 155.84 146.41 158.21 148.88 160.94C149.88 162.09 150.89 163.24 151.89 164.39C152.66 165.28 152.66 165.28 153.45 166.18C155.96 169.13 158.32 172.19 160.69 175.25C164.27 179.87 167.99 184.29 171.92 188.61C174.48 191.55 176.86 194.61 179.25 197.69C183.1 202.66 187.07 207.5 191.19 212.25C195.14 216.82 199 221.44 202.75 226.18C206.38 230.72 210.09 235.2 213.79 239.68C217.1 243.7 220.4 247.72 223.69 251.75C226.93 255.73 230.24 259.65 233.56 263.56C238.15 268.96 242.64 274.42 247 280C247.85 280.84 247.85 280.84 248.71 281.7C250.78 285.39 250.31 289.11 250.19 293.25C250.17 294.09 250.16 294.93 250.15 295.8C250.11 297.87 250.06 299.93 250 302C247.72 303.14 246.47 303.13 243.93 303.13C243.08 303.13 242.22 303.14 241.34 303.14C240.39 303.14 239.45 303.14 238.47 303.13C237.47 303.14 236.47 303.14 235.44 303.14C232.06 303.15 228.69 303.15 225.31 303.15C222.9 303.15 220.49 303.15 218.08 303.15C212.2 303.16 206.32 303.17 200.44 303.17C195.66 303.17 190.88 303.17 186.1 303.17C172.57 303.18 159.03 303.19 145.5 303.19C144.77 303.19 144.04 303.19 143.28 303.19C142.55 303.19 141.82 303.19 141.07 303.19C129.21 303.19 117.36 303.19 105.5 303.21C93.34 303.22 81.18 303.23 69.02 303.23C62.19 303.23 55.36 303.23 48.52 303.24C42.1 303.25 35.68 303.25 29.26 303.25C26.89 303.24 24.53 303.25 22.17 303.25C18.95 303.26 15.74 303.26 12.53 303.25C11.58 303.25 10.64 303.26 9.66 303.26C8.81 303.26 7.95 303.25 7.07 303.25C6.32 303.25 5.58 303.25 4.82 303.25C3 303 3 303 1 301C0.75 298.84 0.75 298.84 0.75 296.11C0.74 295.07 0.74 294.02 0.73 292.95C0.74 291.8 0.74 290.65 0.75 289.46C0.74 288.24 0.74 287.02 0.74 285.77C0.73 282.38 0.73 278.99 0.74 275.6C0.74 271.95 0.74 268.3 0.73 264.65C0.72 257.49 0.72 250.34 0.73 243.18C0.73 237.37 0.73 231.55 0.73 225.74C0.73 224.91 0.73 224.09 0.73 223.23C0.73 221.56 0.73 219.88 0.73 218.2C0.72 202.45 0.73 186.7 0.74 170.94C0.75 157.42 0.75 143.89 0.74 130.36C0.73 114.67 0.72 98.97 0.73 83.28C0.73 81.61 0.73 79.93 0.73 78.26C0.73 77.03 0.73 77.03 0.73 75.77C0.74 69.96 0.73 64.15 0.73 58.34C0.72 51.26 0.72 44.19 0.73 37.11C0.74 33.5 0.74 29.88 0.73 26.27C0.73 22.36 0.74 18.45 0.75 14.54C0.74 13.39 0.74 12.24 0.73 11.05C0.74 10.01 0.74 8.97 0.75 7.89C0.75 6.99 0.75 6.09 0.75 5.16C1.08 2.33 1.93 1.15 4.82 0.75ZM39 25C40.5 28.01 41.66 29.99 43.72 32.5C44.26 33.16 44.79 33.81 45.34 34.48C45.91 35.17 46.48 35.85 47.06 36.56C47.65 37.28 48.24 38 48.84 38.73C50.56 40.83 52.28 42.91 54 45C55.5 46.83 57 48.67 58.5 50.5C59.2 51.36 59.91 52.22 60.63 53.11C74.85 70.49 74.85 70.49 81.44 78.94C86.65 85.62 92.04 92.16 97.45 98.7C106.5 109.65 115.41 120.68 124 132C126.94 131.67 127.95 131.05 130.04 128.88C130.75 127.97 131.46 127.06 132.19 126.13C132.98 125.13 133.77 124.12 134.58 123.09C135.38 122.07 136.18 121.05 137 120C138.45 118.2 139.91 116.41 141.38 114.63C142.11 113.72 142.85 112.82 143.61 111.89C146.24 108.71 148.9 105.57 151.56 102.44C155.36 97.97 159.07 93.45 162.71 88.86C167.53 82.84 172.46 76.92 177.37 70.98C181.65 65.78 185.91 60.57 190.16 55.34C193.83 50.84 197.53 46.37 201.3 41.95C209.03 34.26 209.03 34.26 213 25C155.58 25 98.16 25 39 25ZM25 48C25 78.36 25 108.72 25 140C49.42 140 73.84 140 99 140C97.17 135.43 95.23 132.63 92.06 129.06C88.15 124.55 84.35 119.97 80.69 115.25C75.9 109.09 70.96 103.05 65.98 97.04C62.31 92.6 58.69 88.14 55.1 83.63C51.81 79.51 48.48 75.42 45.15 71.34C42.2 67.72 39.27 64.09 36.34 60.45C35.75 59.71 35.16 58.98 34.55 58.22C33.41 56.81 32.27 55.39 31.14 53.96C28.5 50.49 28.5 50.49 25 48ZM25 164C25 194.36 25 224.72 25 256C29.05 252.76 31.89 249.85 34.94 245.81C39.15 240.33 43.47 234.95 47.88 229.63C49.07 228.18 50.26 226.74 51.45 225.3C52.04 224.59 52.63 223.87 53.24 223.14C60.6 214.21 67.86 205.21 74.97 196.08C78.1 192.09 81.33 188.22 84.63 184.38C93.89 174.95 93.89 174.95 99 164C74.58 164 50.16 164 25 164ZM124 172C122.3 173.68 122.3 173.68 120.63 176C119.92 176.91 119.22 177.83 118.5 178.77C118.1 179.28 117.71 179.79 117.3 180.32C114.82 183.51 112.25 186.62 109.69 189.75C105.53 194.85 101.42 199.99 97.38 205.19C93.41 210.27 89.31 215.22 85.12 220.12C81.4 224.48 77.86 228.96 74.34 233.48C69.99 239.05 65.5 244.5 60.99 249.95C57.25 254.48 53.54 259.04 49.89 263.65C46.88 267.4 43.78 271.07 40.69 274.75C38.8 276.8 38.8 276.8 39 279C96.42 279 153.84 279 213 279C211.09 274.23 208.91 271.29 205.56 267.56C201.39 262.81 197.36 258 193.5 253C189.8 248.21 185.97 243.57 182 239C177.55 233.87 173.3 228.62 169.15 223.25C165.88 219.06 162.48 215.01 159 211C154.55 205.88 150.32 200.64 146.16 195.27C142.25 190.25 138.15 185.42 133.97 180.62C131.99 178.33 130.06 176.09 128.34 173.6C127.9 173.07 127.46 172.55 127 172C126.01 172 125.02 172 124 172Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function RB2BIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `rb2b_clip_${id}`
  return (
    <svg viewBox='0 0 165 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path d='M95.97 8.4H87.57V16.81H95.97V8.4Z' fill='#0C1316' />
        <path d='M121.41 8.4H113V16.81H121.41V8.4Z' fill='#0C1316' />
        <path d='M113 16.81H104.59V25.21H113V16.81Z' fill='#0C1316' />
        <path d='M104.6 25.21H96.19V33.61H104.6V25.21Z' fill='#0C1316' />
        <path d='M87.79 39.6V42.02V48H121.4V39.6H96.19V33.61H87.79V39.6Z' fill='#0C1316' />
        <path d='M112.79 0H95.98V8.4H112.79V0Z' fill='#0C1316' />
        <path
          d='M52.38 8.4H74.36V0H52.38H43.97V48H52.38H74.36V39.6H52.38V28.2H74.36V19.8H52.38V8.4Z'
          fill='#0C1316'
        />
        <path d='M82.77 8.4H74.37V19.8H82.77V8.4Z' fill='#0C1316' />
        <path d='M82.77 28.2H74.36V39.6H82.77V28.2Z' fill='#0C1316' />
        <path d='M165 8.4H156.59V19.8H165V8.4Z' fill='#0C1316' />
        <path d='M165 28.2H156.59V39.6H165V28.2Z' fill='#0C1316' />
        <path
          d='M134.61 19.8V8.4H156.59V0H134.61H126.2V48H134.61H156.59V39.6H134.61V28.2H156.59V19.8H134.61Z'
          fill='#0C1316'
        />
        <path
          d='M8.4 8.4H30.39V0H8.4H0V48H8.4V28.2H21.99V36.6H30.39V48H38.8V28.2H30.39V19.8H8.4V8.4Z'
          fill='#0C1316'
        />
        <path d='M38.8 8.4H30.39V19.8H38.8V8.4Z' fill='#0C1316' />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='165' height='48' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function RedditIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='100px'
      height='100px'
      viewBox='0 0 50 50'
      fill='#FFFFFF'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M 29 3 C 26.89 3 24.43 4.65 24.06 12.03 C 24.38 12.02 24.68 12 25 12 C 25.35 12 25.71 12.02 26.06 12.03 C 26.3 7.6 27.36 5 29 5 C 29.7 5 30.1 5.38 30.84 6.19 C 31.71 7.13 32.84 8.35 35.06 8.81 C 35.03 8.55 35 8.27 35 8 C 35 7.58 35.04 7.18 35.13 6.78 C 33.75 6.41 33.02 5.61 32.31 4.84 C 31.52 3.98 30.61 3 29 3 Z M 41 4 C 38.79 4 37 5.8 37 8 C 37 10.2 38.79 12 41 12 C 43.21 12 45 10.2 45 8 C 45 5.8 43.21 4 41 4 Z M 25 14 C 12.87 14 3 20.18 3 29 C 3 37.82 12.87 45 25 45 C 37.13 45 47 37.82 47 29 C 47 20.18 37.13 14 25 14 Z M 7.5 14.94 C 6.04 14.94 4.65 15.54 3.59 16.59 C 1.87 18.32 1.52 20.79 2.5 22.84 C 4.01 19.92 6.61 17.42 9.97 15.56 C 9.21 15.18 8.36 14.94 7.5 14.94 Z M 42.5 14.94 C 41.64 14.94 40.79 15.18 40.03 15.56 C 43.39 17.42 45.99 19.92 47.5 22.84 C 48.48 20.79 48.13 18.32 46.41 16.59 C 45.35 15.54 43.96 14.94 42.5 14.94 Z M 17 23 C 18.66 23 20 24.34 20 26 C 20 27.66 18.66 29 17 29 C 15.34 29 14 27.66 14 26 C 14 24.34 15.34 23 17 23 Z M 33 23 C 34.66 23 36 24.34 36 26 C 36 27.66 34.66 29 33 29 C 31.34 29 30 27.66 30 26 C 30 24.34 31.34 23 33 23 Z M 16.06 34 C 16.31 34.04 16.56 34.18 16.72 34.41 C 16.82 34.55 19.17 37.69 25 37.69 C 30.91 37.69 33.26 34.47 33.28 34.44 C 33.6 33.99 34.23 33.87 34.69 34.19 C 35.14 34.5 35.22 35.11 34.91 35.56 C 34.79 35.73 31.94 39.69 25 39.69 C 18.06 39.69 15.21 35.73 15.09 35.56 C 14.78 35.11 14.86 34.5 15.31 34.19 C 15.54 34.03 15.81 33.96 16.06 34 Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function AirtableIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='0 -20.5 256 256'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M114.26,2.7 L18.86,42.18 C13.56,44.37 13.61,51.91 18.95,54.02 L114.75,92.01 C123.16,95.35 132.54,95.35 140.95,92.01 L236.75,54.02 C242.09,51.91 242.15,44.37 236.84,42.18 L141.44,2.7 C132.74,-0.9 122.96,-0.9 114.26,2.7'
          fill='#FFBF00'
        />
        <path
          d='M136.35,112.76 L136.35,207.66 C136.35,212.17 140.9,215.26 145.1,213.6 L251.84,172.17 C254.28,171.2 255.88,168.85 255.88,166.22 L255.88,71.32 C255.88,66.81 251.33,63.72 247.13,65.38 L140.38,106.82 C137.95,107.78 136.35,110.14 136.35,112.76'
          fill='#26B5F8'
        />
        <path
          d='M111.42,117.65 L79.74,132.95 L76.53,134.5 L9.65,166.55 C5.41,168.59 0,165.5 0,160.79 L0,71.72 C0,70.02 0.87,68.55 2.05,67.44 C2.53,66.95 3.09,66.54 3.66,66.23 C5.26,65.27 7.54,65.01 9.48,65.78 L110.89,105.96 C116.05,108 116.45,115.23 111.42,117.65'
          fill='#ED3049'
        />
        <path
          d='M111.42,117.65 L79.74,132.95 L2.05,67.44 C2.53,66.95 3.09,66.54 3.66,66.23 C5.26,65.27 7.54,65.01 9.48,65.78 L110.89,105.96 C116.05,108 116.45,115.23 111.42,117.65'
          fillOpacity='0.25'
          fill='#000000'
        />
      </g>
    </svg>
  )
}

export function AirweaveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='143'
      height='143'
      viewBox='0 0 143 143'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M89.89 128.87C79.92 123.34 66.75 115.15 60.57 107.64L60.04 107.02C58.78 105.5 57.48 104.01 56.17 102.59C51.92 97.96 47.36 93.8 42.65 90.2C40.74 88.75 38.77 87.35 36.81 86.08C35.8 85.42 34.83 84.82 33.92 84.27C31.62 82.9 28.83 82.53 26.27 83.25C23.84 83.94 21.89 85.54 20.76 87.75C18.56 92.03 20.08 97.33 24.2 99.81C27.52 101.79 30.76 104.11 33.84 106.72C34.24 107.05 34.4 107.58 34.26 108.06C33.13 112.19 32 118.96 31.57 121.67C30.64 127.43 33.47 133.08 38.6 135.75L38.78 135.85C41.02 137 43.65 136.95 45.82 135.7C47.99 134.46 49.35 132.23 49.48 129.73C49.54 128.66 49.6 127.58 49.68 126.59C49.72 126.06 50.04 125.63 50.53 125.46C50.68 125.41 50.85 125.37 51 125.37C51.36 125.37 51.68 125.51 51.95 125.78C56.24 130.19 60.88 134.17 65.72 137.63C70.37 140.95 75.87 142.71 81.64 142.71C83.74 142.71 85.84 142.47 87.89 142L88.12 141.94C90.99 141.27 93.03 139.02 93.45 136.09C93.87 133.15 92.45 130.32 89.87 128.88H89.86L89.89 128.87Z'
        fill='currentColor'
      />
      <path
        d='M142.55 58.17L142.53 58.06C142.04 55.59 140.12 53.71 137.6 53.25C135.11 52.81 132.75 53.86 131.48 55.99L131.41 56.11C126.7 64.16 120.06 71.61 111.65 78.3C109.45 80.05 107.29 81.9 105.23 83.81C103.64 85.27 101.27 85.53 99.45 84.42C97.65 83.33 95.85 82.14 94.11 80.87C90.33 78.12 86.68 74.95 83.28 71.43C81.5 69.6 79.8 67.69 78.19 65.73C76.04 63.12 73.75 60.55 71.37 58.13C66.32 52.99 56.61 45.91 53.75 43.88C53.38 43.63 53.16 43.24 53.1 42.8C53.05 42.36 53.16 41.95 53.45 41.61C55.27 39.43 57 37.18 58.57 34.92C60.24 32.53 60.79 29.6 60.09 26.89C59.41 24.25 57.64 22.11 55.13 20.88C50.91 18.79 45.9 20.1 43.23 23.93C40.84 27.36 38.02 30.73 34.87 33.93C34.57 34.23 34.13 34.34 33.72 34.19C30.52 33.14 27.23 32.29 23.95 31.66C23.71 31.62 23.35 31.55 22.91 31.5C16.41 30.53 10.11 33.78 7.22 39.57L7.12 39.75C6.18 41.63 6.27 43.83 7.32 45.67C8.4 47.52 10.33 48.7 12.46 48.82C13.46 48.87 14.44 48.94 15.37 49C15.8 49.03 16.14 49.28 16.3 49.69C16.45 50.11 16.37 50.54 16.07 50.85C12.15 54.88 8.61 59.2 5.53 63.69C1.14 70.08 -0.48 78.21 1.08 85.98L1.1 86.1C1.7 89.07 4.05 91.2 7.08 91.53C9.98 91.84 12.61 90.32 13.76 87.67L13.83 87.51C18.69 75.86 26.76 65.52 37.79 56.75C38.32 56.34 39.01 56.28 39.57 56.59C45.34 59.77 50.86 63.9 55.97 68.89C56.6 69.49 56.61 70.5 56.02 71.13C53.48 73.81 51.09 76.61 48.91 79.47C47.21 81.71 47.53 84.89 49.62 86.74L53.33 90L53.28 90.04C53.86 90.56 54.45 91.07 55.03 91.59L55.81 92.19C56.93 93.18 58.35 93.64 59.84 93.49C61.3 93.34 62.67 92.56 63.56 91.38C65.14 89.29 66.86 87.25 68.66 85.3C68.96 84.97 69.37 84.8 69.81 84.79C70.27 84.79 70.63 84.94 70.92 85.23C75.81 90.06 81.11 94.37 86.68 98C88.86 99.42 89.5 102.26 88.13 104.48C86.92 106.45 85.77 108.49 84.72 110.54C83.5 112.92 83.3 115.74 84.17 118.26C85 120.68 86.71 122.59 88.98 123.64C90.25 124.23 91.6 124.53 92.99 124.53C96.51 124.53 99.68 122.6 101.29 119.45C102.73 116.61 104.42 113.8 106.28 111.13C107.37 109.56 109.36 108.84 111.26 109.32C115.26 110.36 120.64 111.42 124.45 112.14C128.31 112.86 132.12 111.02 133.96 107.58L134.14 107.23C135.52 104.63 135.53 101.51 134.16 98.89C132.79 96.25 130.18 94.47 127.21 94.12C126.48 94.03 125.78 93.95 125.11 93.86C124.97 93.84 124.85 93.82 124.74 93.8L123.36 93.48L124.36 92.45C124.43 92.38 124.53 92.28 124.66 92.19C128.77 88.8 132.57 85.2 135.96 81.47C141.67 75.2 144.12 66.5 142.52 58.17H142.53H142.55Z'
        fill='currentColor'
      />
      <path
        d='M56.65 14.34C65.59 19.63 77.41 27.37 82.98 34.17C83.64 34.95 84.3 35.74 84.95 36.49C86.16 37.88 86.3 39.87 85.3 41.42C83.49 44.21 81.41 46.96 79.14 49.59C77.47 51.51 77.41 54.31 78.98 56.25L79.04 56.32C79.23 56.56 79.43 56.81 79.61 57.04C81.29 59.18 83.08 61.22 84.92 63.14C85.9 64.16 87.22 64.73 88.64 64.73L88.76 65.53L88.74 64.73C90.21 64.7 91.62 64.05 92.6 62.93C94.84 60.4 96.92 57.74 98.83 55.06C100.13 53.22 102.63 52.8 104.53 54.11C106.46 55.44 108.47 56.71 110.46 57.88C112.79 59.25 115.61 59.51 118.17 58.56C120.75 57.6 122.76 55.57 123.66 52.95C125.06 48.91 123.26 44.25 119.38 41.91C116.76 40.31 114.15 38.52 111.67 36.58C110.38 35.56 109.83 33.88 110.3 32.29C111.44 28.3 112.48 23.12 113.15 19.48C113.84 15.73 112.15 11.88 108.94 9.94L108.56 9.73C105.87 8.13 102.59 8.01 99.77 9.41C96.92 10.82 95.03 13.54 94.69 16.67L94.66 16.87C94.62 17.25 94.38 17.55 94.02 17.66C93.65 17.78 93.29 17.69 93.02 17.43C89 13.14 84.74 9.26 80.31 5.86C74.37 1.31 66.78 -0.58 59.49 0.68L59.18 0.73C56.11 1.27 53.75 3.6 53.19 6.68C52.64 9.73 53.99 12.72 56.67 14.3H56.66L56.65 14.34Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function AlgoliaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'>
      <path
        fill='currentColor'
        d='M25,0C11.3,0,0.2,11,0,24.6C-0.2,38.4,11,49.9,24.8,50c4.3,0,8.4-1,12-3c0.4-0.2,0.4-0.7,0.1-1l-2.3-2.1 c-0.5-0.4-1.2-0.5-1.7-0.3c-2.5,1.1-5.3,1.6-8.2,1.6c-11.2-0.1-20.2-9.4-20-20.6C4.9,13.6,13.9,4.7,25,4.7h20.3v36L33.7,30.5 c-0.4-0.3-0.9-0.3-1.2,0.1c-1.8,2.4-4.9,4-8.2,3.7c-4.6-0.3-8.4-4-8.7-8.7c-0.4-5.5,4-10.2,9.4-10.2c4.9,0,9,3.8,9.4,8.6 c0,0.4,0.2,0.8,0.6,1.1l3,2.7c0.3,0.3,0.9,0.1,1-0.3c0.2-1.2,0.3-2.4,0.2-3.6c-0.5-7-6.2-12.7-13.2-13.1c-8.1-0.5-14.8,5.8-15,13.7 c-0.2,7.7,6.1,14.4,13.8,14.5c3.2,0.1,6.2-0.9,8.6-2.7l15,13.3c0.6,0.6,1.7,0.1,1.7-0.7v-48C50,0.4,49.5,0,49,0L25,0 C25,0,25,0,25,0z'
      />
    </svg>
  )
}

export function AmplitudeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 49 49'>
      <path
        fill='currentColor'
        d='M23.4,15.3c0.6,1.8,1.2,4.1,1.9,6.7c-2.6,0-5.3-0.1-7.8-0.1h-1.3c1.5-5.7,3.2-10.1,4.6-11.1 c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0.1,0.5,0.3C21.9,11.5,22.5,12.7,23.4,15.3z M49,24.5C49,38,38,49,24.5,49S0,38,0,24.5 S11,0,24.5,0S49,11,49,24.5z M42.7,23.9c0-0.6-0.4-1.2-1-1.3l0,0l0,0l0,0c-0.1,0-0.1,0-0.2,0h-0.2c-4.1-0.3-8.4-0.4-12.4-0.5l0,0 C27,14.8,24.5,7.4,21.3,7.4c-3,0-5.8,4.9-8.2,14.5c-1.7,0-3.2,0-4.6-0.1c-0.1,0-0.2,0-0.2,0c-0.3,0-0.5,0-0.5,0 c-0.8,0.1-1.4,0.9-1.4,1.7c0,0.8,0.6,1.6,1.5,1.7l0,0h4.6c-0.4,1.9-0.8,3.8-1.1,5.6l-0.1,0.8l0,0c0,0.6,0.5,1.1,1.1,1.1 c0.4,0,0.8-0.2,1-0.5l0,0l2.2-7.1h10.7c0.8,3.1,1.7,6.3,2.8,9.3c0.6,1.6,2,5.4,4.4,5.4l0,0c3.6,0,5-5.8,5.9-9.6 c0.2-0.8,0.4-1.5,0.5-2.1l0.1-0.2l0,0c0-0.1,0-0.2,0-0.3c-0.1-0.2-0.2-0.3-0.4-0.4c-0.3-0.1-0.5,0.1-0.6,0.4l0,0l-0.1,0.2 c-0.3,0.8-0.6,1.6-0.8,2.3v0.1c-1.6,4.4-2.3,6.4-3.7,6.4l0,0l0,0l0,0c-1.8,0-3.5-7.3-4.1-10.1c-0.1-0.5-0.2-0.9-0.3-1.3h11.7 c0.2,0,0.4-0.1,0.6-0.1l0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0l0,0c0,0,0.1,0,0.1-0.1l0,0C42.5,24.6,42.7,24.3,42.7,23.9z'
      />
    </svg>
  )
}

export function GoogleAppsheetIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 36' fill='none'>
      <path
        fill='#0060d9'
        d='m29.01 6.3h-7.68l-3.1 4.4 -1.84 4.36 4.94 0.56 5.14 -0.54 3.81 -6.6c0.56 -0.97 -0.14 -2.19 -1.27 -2.19z'
      />
      <g fill='#4285f4'>
        <path d='m3.1 8.5 3.19 5.47c0.39 0.67 1.11 1.08 1.88 1.08l8.2 0.02 4.95 -8.77h-16.97c-1.13 0 -1.83 1.22 -1.26 2.19z' />
        <path d='m18.01 29.85c-0.56 0.97 -1.95 0.98 -2.52 0.02l-3.18 -5.34c-0.4 -0.67 -0.41 -1.51 -0.03 -2.19l4.09 -7.26 10.08 .02z' />
      </g>
    </svg>
  )
}

export function GoogleBooksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 478.63 540.07'>
      <path
        fill='#1C51A4'
        d='M449.06,218.23L245.52,99.54l-0.06,193.23c0.03,1.5-0.37,2.98-1.17,4.2c-0.8,1.26-1.56,2-2.91,2.55c-1.35,0.55-2.79,0.71-4.2,0.4c-1.41-0.31-2.7-1.04-3.71-2.12l-69.17-70.61l-69.38,70.18c-1.01,0.98-2.3,1.66-3.65,1.9c-1.38,0.25-2.79,0.09-4.08-0.49c-1.29-0.58-1.63-0.52-2.39-1.75c-0.77-1.2-1.2-2.61-1.2-4.08L85.03,6.01l-2.91-1.29C43.97-11.64,0,16.41,0,59.89v420.31c0,46.03,49.31,74.78,88.78,51.77l360.29-210.14C488.49,298.78,488.49,241.25,449.06,218.23z'
      />
      <path
        fill='#80D7FB'
        d='M88.81,8.12c-2.18-1.29-4.42-2.36-6.66-3.34l0.12,288.66c0,1.44,0.43,2.85,1.2,4.08c0.77,1.2,1.87,2.15,3.16,2.73c1.29,0.58,2.7,0.74,4.08,0.49c1.38-0.25,2.64-0.92,3.65-1.9l69.75-69.69l69.81,69.75c1.01,1.07,2.3,1.81,3.71,2.12c1.41,0.31,2.88,0.15,4.2-0.4c1.32-0.55,2.46-1.56,3.25-2.79c0.8-1.26,1.2-2.73,1.17-4.2V100L88.81,8.12z'
      />
    </svg>
  )
}

export function GoogleDocsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width='96px'
      height='96px'
    >
      <path
        fill='#2196f3'
        d='M37,45H11c-1.66,0-3-1.34-3-3V6c0-1.66,1.34-3,3-3h19l10,10v29C40,43.66,38.66,45,37,45z'
      />
      <path fill='#bbdefb' d='M40 13L30 13 30 3z' />
      <path fill='#1565c0' d='M30 13L40 23 40 13z' />
      <path fill='#e3f2fd' d='M15 23H33V25H15zM15 27H33V29H15zM15 31H33V33H15zM15 35H25V37H15z' />
    </svg>
  )
}

export function GoogleSlidesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width='96px'
      height='96px'
    >
      <path
        fill='#FFC107'
        d='M37,45H11c-1.66,0-3-1.34-3-3V6c0-1.66,1.34-3,3-3h19l10,10v29C40,43.66,38.66,45,37,45z'
      />
      <path fill='#FFECB3' d='M40 13L30 13 30 3z' />
      <path fill='#FFA000' d='M30 13L40 23 40 13z' />
      <path fill='#FFF8E1' d='M14 21H34V35H14z' />
      <path fill='#FFA000' d='M16 23H32V26H16zM16 28H28V30H16z' />
    </svg>
  )
}

export function GoogleContactsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500'>
      <path fill='#86a9ff' d='M199 244c-89 0-161 71-161 160v67c0 16 13 29 29 29h77l77-256z' />
      <path fill='#578cff' d='M462 349c0-58-48-105-106-105h-77v256h77c58 0 106-47 106-106' />
      <path
        fill='#0057cc'
        d='M115 349c0-58 48-105 106-105h58c58 0 106 47 106 105v45c0 59-48 106-106 106H144c-16 0-29-13-29-29z'
      />
      <circle cx='250' cy='99.4' r='99.4' fill='#0057cc' />
    </svg>
  )
}

export function GoogleCalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 200 200'
      enableBackground='new 0 0 200 200'
      xmlSpace='preserve'
    >
      <g>
        <g transform='translate(3.75 3.75)'>
          <path
            fill='#FFFFFF'
            d='M148.88,43.62l-47.37-5.26l-57.89,5.26L38.35,96.25l5.26,52.63l52.63,6.58l52.63-6.58
			l5.26-53.95L148.88,43.62z'
          />
          <path
            fill='#1A73E8'
            d='M65.21,125.28c-3.93-2.66-6.66-6.54-8.14-11.67l9.13-3.76c0.83,3.16,2.28,5.61,4.34,7.34
			c2.05,1.74,4.55,2.59,7.47,2.59c2.99,0,5.55-0.91,7.7-2.72s3.22-4.13,3.22-6.93c0-2.87-1.13-5.21-3.39-7.03
			s-5.11-2.72-8.5-2.72h-5.28v-9.04H76.5c2.92,0,5.38-0.79,7.38-2.37c2-1.58,3-3.74,3-6.49
			c0-2.45-0.89-4.39-2.68-5.85s-4.05-2.2-6.8-2.2c-2.68,0-4.82,0.71-6.39,2.15s-2.72,3.2-3.45,5.28
			l-9.04-3.76c1.2-3.39,3.4-6.39,6.62-8.99c3.22-2.59,7.34-3.89,12.34-3.89c3.7,0,7.03,0.71,9.97,2.15
			c2.95,1.43,5.26,3.42,6.93,5.95c1.67,2.54,2.5,5.38,2.5,8.54c0,3.22-0.78,5.95-2.33,8.18
			c-1.55,2.24-3.46,3.95-5.72,5.15v0.54c2.99,1.25,5.42,3.16,7.34,5.72c1.91,2.57,2.87,5.63,2.87,9.21
			s-0.91,6.78-2.72,9.58c-1.82,2.8-4.33,5.01-7.51,6.62c-3.2,1.61-6.79,2.42-10.78,2.42
			C73.41,129.26,69.15,127.93,65.21,125.28z'
          />
          <path
            fill='#1A73E8'
            d='M121.25,79.96l-9.97,7.25l-5.01-7.6l17.99-12.97h6.9v61.2h-9.89L121.25,79.96z'
          />
          <path
            fill='#EA4335'
            d='M148.88,196.25l47.37-47.37l-23.68-10.53l-23.68,10.53l-10.53,23.68L148.88,196.25z'
          />
          <path fill='#34A853' d='M33.09,172.57l10.53,23.68h105.26v-47.37H43.62L33.09,172.57z' />
          <path
            fill='#4285F4'
            d='M12.04-3.75C3.32-3.75-3.75,3.32-3.75,12.04v136.84l23.68,10.53l23.68-10.53V43.62h105.26
			l10.53-23.68L148.88-3.75H12.04z'
          />
          <path
            fill='#188038'
            d='M-3.75,148.88v31.58c0,8.72,7.07,15.79,15.79,15.79h31.58v-47.37H-3.75z'
          />
          <path fill='#FBBC04' d='M148.88,43.62v105.26h47.37V43.62l-23.68-10.53L148.88,43.62z' />
          <path
            fill='#1967D2'
            d='M196.25,43.62V12.04c0-8.72-7.07-15.79-15.79-15.79h-31.58v47.37H196.25z'
          />
        </g>
      </g>
    </svg>
  )
}

export function GoogleTasksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 527.1 500' xmlns='http://www.w3.org/2000/svg'>
      <polygon
        fill='#0066DA'
        points='410.4,58.3 368.8,81.2 348.2,120.6 368.8,168.8 407.8,211 450,187.5 475.9,142.8 450,87.5'
      />
      <path
        fill='#2684FC'
        d='M249.3,219.4l98.9-98.9c29.1,22.1,50.5,53.8,59.6,90.4L272.1,346.7c-12.2,12.2-32,12.2-44.2,0l-91.5-91.5 c-9.8-9.8-9.8-25.6,0-35.3l39-39c9.8-9.8,25.6-9.8,35.3,0L249.3,219.4z M519.8,63.6l-39.7-39.7c-9.7-9.7-25.6-9.7-35.3,0 l-34.4,34.4c27.5,23,49.9,51.8,65.5,84.5l43.9-43.9C529.6,89.2,529.6,73.3,519.8,63.6z M412.5,250c0,89.8-72.8,162.5-162.5,162.5 S87.5,339.8,87.5,250S160.2,87.5,250,87.5c36.9,0,70.9,12.3,98.2,33.1l62.2-62.2C367,21.9,311.1,0,250,0C111.9,0,0,111.9,0,250 s111.9,250,250,250s250-111.9,250-250c0-38.3-8.7-74.7-24.1-107.2L407.8,211C410.8,223.5,412.5,236.6,412.5,250z'
      />
    </svg>
  )
}

export function SupabaseIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient0 = `supabase_paint0_${id}`
  const gradient1 = `supabase_paint1_${id}`

  return (
    <svg
      {...props}
      fill='currentColor'
      width='24'
      height='24'
      viewBox='0 0 27 27'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.41 26.26C14.72 27.12 13.34 26.65 13.32 25.55L13.08 9.51H23.87C25.83 9.51 26.92 11.76 25.7 13.29L15.41 26.26Z'
        fill={`url(#${gradient0})`}
      />
      <path
        d='M15.41 26.26C14.72 27.12 13.34 26.65 13.32 25.55L13.08 9.51H23.87C25.83 9.51 26.92 11.76 25.7 13.29L15.41 26.26Z'
        fill={`url(#${gradient1})`}
        fillOpacity='0.2'
      />
      <path
        d='M11.02 0.44C11.7 -0.42 13.08 0.06 13.1 1.15L13.2 17.2H2.55C0.6 17.2 -0.49 14.94 0.72 13.41L11.02 0.44Z'
        fill='#3ECF8E'
      />
      <defs>
        <linearGradient
          id={gradient0}
          x1='13.08'
          y1='13.07'
          x2='22.67'
          y2='17.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#249361' />
          <stop offset='1' stopColor='#3ECF8E' />
        </linearGradient>
        <linearGradient
          id={gradient1}
          x1='8.83'
          y1='7.24'
          x2='13.21'
          y2='15.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function WhatsAppIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='currentColor'
      viewBox='0 0 16 16'
    >
      <path d='M13.6 2.33A7.85 7.85 0 0 0 7.99 0C3.63 0 .068 3.56.064 7.93c0 1.4.366 2.76 1.06 3.97L0 16l4.2-1.1a7.9 7.9 0 0 0 3.79.97h.004c4.37 0 7.93-3.56 7.93-7.93A7.9 7.9 0 0 0 13.6 2.33zM7.99 14.52a6.6 6.6 0 0 1-3.36-.92l-.24-.144-2.49.654.67-2.43-.156-.251a6.56 6.56 0 0 1-1.01-3.5c0-3.63 2.96-6.58 6.59-6.58a6.56 6.56 0 0 1 4.66 1.93 6.56 6.56 0 0 1 1.93 4.66c-.004 3.64-2.96 6.59-6.59 6.59m3.62-4.93c-.197-.099-1.17-.578-1.35-.646-.182-.065-.315-.099-.445.1-.133.2-.513.65-.627.78-.114.13-.232.15-.43.05-.197-.1-.836-.308-1.59-.985-.59-.525-.985-1.17-1.1-1.37-.114-.198-.011-.304.09-.403.09-.88.2-.232.3-.346.1-.114.13-.198.2-.33.07-.134.03-.248-.015-.347-.05-.099-.445-1.08-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.25c-.182.2-.691.68-.691 1.65s.71 1.92.81 2.05c.98.13 1.39 2.13 3.38 2.99.47.21.84.33 1.13.418.48.152.9.129 1.25.08.38-.058 1.17-.48 1.34-.943.16-.464.16-.86.11-.943-.049-.084-.182-.133-.38-.232' />
    </svg>
  )
}

export function SportmonksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 25 24'
      fill='none'
      fillRule='evenodd'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.857 8.546c1.893 0 3.517.678 4.872 2.033 1.355 1.336 2.032 2.96 2.032 4.872 0 1.91-.677 3.535-2.032 4.871-1.355 1.355-2.979 2.032-4.872 2.032H1V17.093h10.857c.446 0 .825-.157 1.142-.473.334-.334.5-.724.5-1.17 0-.445-.166-.835-.5-1.17a1.558 1.558 0 00-1.142-.472H7.905c-1.912 0-3.537-.677-4.873-2.032C1.678 10.421 1 8.796 1 6.903 1 4.993 1.678 3.368 3.033 2.032 4.368.678 5.992 0 7.905 0h10.188V5.263H7.904a1.65 1.65 0 00-1.17.473 1.586 1.586 0 00-.472 1.169c0 .445.157.835.473 1.17.334.315.724.472 1.17.472h3.952z'
        fill='currentColor'
      />
      <circle cx='21.27' cy='20.123' r='2.732' fill='#FF0F50' />
    </svg>
  )
}

export function SquareIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 501.42 501.42' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M501.42,83.79v333.84c0,46.27-37.5,83.79-83.79,83.79H83.79c-46.28,0-83.79-37.5-83.79-83.79V83.79C0,37.51,37.52,0,83.79,0h333.84c46.29,0,83.79,37.5,83.79,83.79h0ZM410.22,117.64c0-14.61-11.85-26.45-26.45-26.45H117.62c-14.61,0-26.45,11.84-26.45,26.45v266.19c0,14.61,11.84,26.45,26.45,26.45h266.17c14.61,0,26.45-11.85,26.45-26.45V117.64h-.02ZM182.31,197.59c0-8.43,6.79-15.26,15.17-15.26h106.4c8.39,0,15.17,6.84,15.17,15.26v106.24c0,8.43-6.75,15.26-15.17,15.26h-106.4c-8.39,0-15.17-6.84-15.17-15.26v-106.24Z'
      />
    </svg>
  )
}

export function StripeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='360'
      height='151'
      viewBox='0 0 360 151'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M360 78C360 52.4 347.6 32.2 323.9 32.2C300.1 32.2 285.7 52.4 285.7 77.8C285.7 107.9 302.7 123.1 327.1 123.1C339 123.1 348 120.4 354.8 116.6V96.6C348 100 340.2 102.1 330.3 102.1C320.6 102.1 312 98.7 310.9 86.9H359.8C359.8 85.6 360 80.4 360 78ZM310.6 68.5C310.6 57.2 317.5 52.5 323.8 52.5C329.9 52.5 336.4 57.2 336.4 68.5H310.6Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M247.1 32.2C237.3 32.2 231 36.8 227.5 40L226.2 33.8H204.2V150.4L229.2 145.1L229.3 116.8C232.9 119.4 238.2 123.1 247 123.1C264.9 123.1 281.2 108.7 281.2 77C281.1 48 264.6 32.2 247.1 32.2ZM241.1 101.1C235.2 101.1 231.7 99 229.3 96.4L229.2 59.3C231.8 56.4 235.4 54.4 241.1 54.4C250.2 54.4 256.5 64.6 256.5 77.7C256.5 91.1 250.3 101.1 241.1 101.1Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M169.8 26.3L194.9 20.9V0.6L169.8 5.9V26.3Z'
        fill='currentColor'
      />
      <path d='M194.9 33.9H169.8V121.4H194.9V33.9Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M142.9 41.3L141.3 33.9H119.7V121.4H144.7V62.1C150.6 54.4 160.6 55.8 163.7 56.9V33.9C160.5 32.7 148.8 30.5 142.9 41.3Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M92.9 12.2L68.5 17.4L68.4 97.5C68.4 112.3 79.5 123.2 94.3 123.2C102.5 123.2 108.5 121.7 111.8 119.9V99.6C108.6 100.9 92.8 105.5 92.8 90.7V55.2H111.8V33.9H92.8L92.9 12.2Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.3 59.3C25.3 55.4 28.5 53.9 33.8 53.9C41.4 53.9 51 56.2 58.6 60.3V36.8C50.3 33.5 42.1 32.2 33.8 32.2C13.5 32.2 0 42.8 0 60.5C0 88.1 38 83.7 38 95.6C38 100.2 34 101.7 28.4 101.7C20.1 101.7 9.5 98.3 1.1 93.7V117.5C10.4 121.5 19.8 123.2 28.4 123.2C49.2 123.2 63.5 112.9 63.5 95C63.4 65.2 25.3 70.5 25.3 59.3Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function EyeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      width='24'
      height='24'
      viewBox='0 0 28 23'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 6.51C12.7 6.51 11.46 7.03 10.55 7.94C9.63 8.86 9.12 10.1 9.12 11.4C9.12 12.69 9.63 13.93 10.55 14.85C11.46 15.76 12.7 16.28 14 16.28C15.3 16.28 16.54 15.76 17.45 14.85C18.37 13.93 18.88 12.69 18.88 11.4C18.88 10.1 18.37 8.86 17.45 7.94C16.54 7.03 15.3 6.51 14 6.51ZM11.07 11.4C11.07 10.62 11.38 9.87 11.93 9.32C12.48 8.77 13.22 8.47 14 8.47C14.78 8.47 15.52 8.77 16.07 9.32C16.62 9.87 16.93 10.62 16.93 11.4C16.93 12.17 16.62 12.92 16.07 13.47C15.52 14.02 14.78 14.33 14 14.33C13.22 14.33 12.48 14.02 11.93 13.47C11.38 12.92 11.07 12.17 11.07 11.4Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 0C8.12 0 4.16 3.52 1.86 6.51L1.82 6.56C1.3 7.24 0.82 7.86 0.5 8.59C0.15 9.38 0 10.24 0 11.4C0 12.55 0.15 13.41 0.5 14.2C0.82 14.93 1.3 15.56 1.82 16.23L1.86 16.28C4.16 19.27 8.12 22.79 14 22.79C19.88 22.79 23.84 19.27 26.14 16.28L26.18 16.23C26.7 15.56 27.18 14.93 27.5 14.2C27.85 13.41 28 12.55 28 11.4C28 10.24 27.85 9.38 27.5 8.59C27.18 7.86 26.7 7.24 26.18 6.56L26.14 6.51C23.84 3.52 19.88 0 14 0ZM3.41 7.7C5.53 4.94 8.99 1.95 14 1.95C19.01 1.95 22.47 4.94 24.59 7.7C25.16 8.44 25.49 8.88 25.71 9.38C25.92 9.85 26.05 10.42 26.05 11.4C26.05 12.37 25.92 12.94 25.71 13.41C25.49 13.91 25.16 14.35 24.59 15.09C22.47 17.85 19.01 20.84 14 20.84C8.99 20.84 5.53 17.85 3.41 15.09C2.84 14.35 2.51 13.91 2.29 13.41C2.08 12.94 1.95 12.37 1.95 11.4C1.95 10.42 2.08 9.85 2.29 9.38C2.51 8.88 2.84 8.44 3.41 7.7Z'
      />
    </svg>
  )
}

/**
 * Corporate Atlassian mark, used for family-wide Atlassian credentials — one
 * API token authenticates Jira, Jira Service Management, and Confluence, so no
 * single product mark represents it. Individual products keep their own icons.
 */
export function AtlassianIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `atlassian_gradient_${id}`

  return (
    <svg
      {...props}
      width='24'
      height='24'
      /*
       * The mark's artwork spans ~66 units; the box is padded to 84.5 so it
       * fills ~78% of its viewBox, matching the inset Atlassian ships on the
       * Jira and Confluence marks (artwork 16→116 inside 128). Without the
       * padding this renders ~30% heavier than its siblings in the same tile.
       */
      viewBox='-9.2 -8.9 84.5 84.5'
      focusable='false'
      fill='none'
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient
          id={gradientId}
          gradientUnits='userSpaceOnUse'
          x1='28.536019'
          y1='35.528544'
          x2='11.406018'
          y2='65.208544'
        >
          <stop offset='0' stopColor='#0052cc' />
          <stop offset='0.92' stopColor='#2684ff' />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d='m 19.64,30.52 a 1.88,1.88 0 0 0 -3.2,0.35 l -16.23,32.46 a 1.94,1.94 0 0 0 1.73,2.81 H 24.54 a 1.87,1.87 0 0 0 1.74,-1.1 c 4.87,-10 1.92,-25.37 -6.64,-34.52 z'
      />
      <path
        fill='#2684ff'
        d='m 31.55,1.04 a 42.81,42.81 0 0 0 -2.5,42.27 l 10.95,21.73 a 1.94,1.94 0 0 0 1.73,1.08 h 22.6 a 2,2 0 0 0 1.67,-2.79 l -31.15,-62.29 a 1.83,1.83 0 0 0 -3.3,0 z'
      />
    </svg>
  )
}

export function ConfluenceIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const topGradientId = `confluence_top_${id}`
  const bottomGradientId = `confluence_bottom_${id}`

  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 128 128'
      focusable='false'
      fill='none'
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient
          id={bottomGradientId}
          gradientUnits='userSpaceOnUse'
          x1='26.791'
          y1='28.467'
          x2='11.792'
          y2='19.855'
          gradientTransform='scale(4)'
        >
          <stop offset='0' stopColor='#0052cc' />
          <stop offset='0.918' stopColor='#2380fb' />
          <stop offset='1' stopColor='#2684ff' />
        </linearGradient>
        <linearGradient
          id={topGradientId}
          gradientUnits='userSpaceOnUse'
          x1='5.209'
          y1='2.523'
          x2='20.208'
          y2='11.136'
          gradientTransform='scale(4)'
        >
          <stop offset='0' stopColor='#0052cc' />
          <stop offset='0.918' stopColor='#2380fb' />
          <stop offset='1' stopColor='#2684ff' />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${bottomGradientId})`}
        d='M19.492 86.227a249.047 249.047 0 00-3.047 4.933c-.867 1.45-.433 3.336 1.016 4.207l19.863 12.188c1.45.87 3.332.433 4.203-1.016a139.349 139.349 0 012.899-4.934c7.832-12.91 15.804-11.46 30.011-4.64l19.72 9.281c1.593.727 3.335 0 4.058-1.45l9.426-21.323c.722-1.453 0-3.336-1.454-4.063-4.203-1.887-12.464-5.805-19.714-9.43-26.82-12.914-49.586-12.043-66.98 16.247zm0 0'
      />
      <path
        fill={`url(#${topGradientId})`}
        d='M108.508 37.773a249.047 249.047 0 003.047-4.933c.87-1.45.433-3.336-1.016-4.207L90.676 16.445c-1.45-.87-3.332-.433-4.203 1.016a133.55 133.55 0 01-2.899 4.934c-7.832 12.91-15.804 11.46-30.011 4.64l-19.72-9.281c-1.593-.727-3.331 0-4.058 1.45l-9.422 21.323c-.726 1.453 0 3.34 1.45 4.063 4.203 1.887 12.468 5.805 19.714 9.43 26.825 12.77 49.586 12.042 66.98-16.247zm0 0'
      />
    </svg>
  )
}

export function ContextDevIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 772.32 531.2' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M260.5,27.06v240.41c-29-28.17-69.08-44.96-113.07-43.26C69.5,227.24,5.16,289.98.31,367.81c-5.56,89.26,65.18,163.38,153.24,163.38,41.58,0,79.3-16.51,106.95-43.37h0c0,13.26,10.75,24.01,24.01,24.01h129.54c-51.07,0-96.29-24.98-124.23-63.34,2.81-5.4,5.32-10.98,7.47-16.76,0,0,0,0,0,0,.02-.12.06-.23.12-.35.46-1.2.89-2.4,1.3-3.6.41-1.22.81-2.42,1.2-3.64,0-.01,0-.02.01-.03.53-1.64,1.05-3.31,1.5-4.99,0,0,0,0,0,0,.02-.12.06-.23.08-.35,0,0,0-.01,0-.02.33-1.08.61-2.18.87-3.27,0-.02,0-.03.01-.04.12-.47.23-.95.35-1.43.27-1.08.52-2.15.74-3.23.06-.25.1-.5.17-.74.06-.29.12-.58.19-.89.04-.19.08-.37.13-.54.16-.85.33-1.7.47-2.55.04-.12.06-.25.08-.37.02-.1.04-.21.06-.33.12-.7.25-1.41.37-2.11.1-.58.19-1.18.29-1.76.02-.12.04-.23.04-.35.25-1.53.46-3.06.64-4.61.08-.72.17-1.45.25-2.17.04-.23.06-.45.08-.68h0c.06-.54.1-1.1.14-1.63h0c.02-.06.02-.13.02-.17.02-.19.04-.35.04-.54.1-.97.19-1.95.23-2.92.02-.1.04-.21.02-.31.06-.52.08-1.03.1-1.55.02-.1.02-.21.02-.31.04-.52.06-1.01.08-1.53h0c.04-.62.06-1.24.06-1.86h0c.02-.15.02-.27.02-.39.06-1.59.08-3.19.08-4.78h0c0-1.05-.02-2.11-.04-3.14,0-.39,0-.79-.02-1.16,0-.35-.02-.7-.04-1.06,0-.56-.02-1.12-.06-1.68,0-.29-.02-.58-.04-.87,0-.12,0-.23-.02-.33,0-.21-.02-.41-.04-.6,0-.19,0-.37-.02-.56,0-.08,0-.17-.02-.25-.02-.37-.04-.74-.06-1.1-.02-.37-.06-.72-.08-1.08,0-.08,0-.16-.02-.23-.04-.77-.12-1.55-.21-2.34-.02-.41-.06-.81-.1-1.2-.02-.14-.02-.29-.04-.41-.12-1.2-.27-2.38-.41-3.56-.06-.48-.12-.95-.19-1.43-.08-.6-.17-1.18-.25-1.76-.06-.37-.12-.72-.17-1.08-.06-.35-.1-.7-.17-1.03-.14-.85-.29-1.7-.43-2.52-.02-.12-.04-.25-.06-.37-.19-1.01-.39-2.03-.6-3.04-.08-.39-.15-.79-.25-1.16-.12-.58-.25-1.18-.37-1.76-.12-.54-.25-1.06-.37-1.59-.1-.46-.21-.91-.31-1.35-.15-.56-.29-1.1-.43-1.66-.1-.5-.25-.97-.37-1.47-.25-.89-.5-1.8-.74-2.71-.04-.1-.06-.21-.1-.31-.12-.43-.25-.89-.39-1.32-.27-.93-.56-1.84-.87-2.77-.12-.43-.27-.89-.41-1.32-.12-.35-.23-.68-.35-1.03-.1-.29-.19-.58-.29-.87-.1-.31-.23-.62-.33-.93-.33-.93-.66-1.86-1.01-2.79-.43-1.16-.89-2.3-1.34-3.44-.48-1.18-.95-2.36-1.47-3.52-.19-.43-.37-.87-.56-1.32-.33-.72-.66-1.43-.99-2.15-.1-.23-.21-.46-.33-.68-.1-.23-.23-.43-.33-.68-.85-1.78-1.72-3.58-2.65-5.34-.02-.08-.06-.14-.1-.23-.56-1.08-1.14-2.13-1.74-3.21-.56-1.03-1.16-2.05-1.76-3.06-.02-.06-.06-.14-.1-.21-.41-.72-.85-1.43-1.3-2.15-.89-1.49-1.82-2.94-2.77-4.39-.66-.99-1.32-2.01-2.03-3-.17-.23-.31-.48-.5-.7-.33-.48-.66-.97-1.03-1.47-.02-.02-.04-.06-.08-.1-.14-.23-.29-.43-.45-.66v-.02l-.1-.1c-.27-.37-.56-.77-.83-1.14-.17-.23-.33-.43-.5-.66-.31-.39-.62-.81-.93-1.2-.64-.85-1.3-1.7-1.99-2.55-.27-.35-.56-.7-.87-1.06-.6-.77-1.22-1.51-1.86-2.26-.83-.97-1.66-1.95-2.5-2.9-.52-.58-1.03-1.16-1.57-1.72-.58-.64-1.18-1.28-1.8-1.92-.25-.29-.52-.56-.81-.85h0c.29.29.56.56.81.85.62.64,1.22,1.28,1.8,1.92.54.56,1.05,1.14,1.57,1.72.85.95,1.68,1.92,2.5,2.9.64.74,1.26,1.49,1.86,2.26.31.35.6.7.87,1.06.68.85,1.34,1.7,1.99,2.55.31.39.62.81.93,1.2.17.23.33.44.5.66.27.37.56.77.83,1.14l.1.1c26.35-50.54,79.92-84.63,141.29-82.65,78.35,2.52,143.32,65.42,148.19,143.66,5.55,89.25-65.19,163.36-153.24,163.36h331.21c14.95,0,27.06-12.12,27.06-27.06V27.06c0-14.95-12.12-27.06-27.06-27.06h-457.7c-14.95,0-27.06,12.12-27.06,27.06ZM286.24,454.89s.01-.02.02-.03c0,0,0,.02-.01.02h0ZM286.62,454.23c.69-1.19,1.34-2.41,2-3.63-.66,1.21-1.31,2.44-1.99,3.62,0,0,0,0,0,.01Z'
      />
    </svg>
  )
}

export function ConvexIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='31 31.5 122 125'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M108.09 130.02C126.26 128 143.38 118.32 152.81 102.17C148.35 142.13 104.65 167.38 68.99 151.88C65.7 150.45 62.87 148.08 60.93 145.03C52.91 132.45 50.28 116.43 54.06 101.9C64.88 120.57 86.87 132.01 108.09 130.02Z'
        fill='#F3B01C'
      />
      <path
        d='M53.4 90.17C46.04 107.19 45.72 127.11 54.75 143.51C22.98 119.61 23.32 68.46 54.36 44.79C57.23 42.61 60.64 41.31 64.22 41.11C78.93 40.34 93.88 46.02 104.36 56.62C83.06 56.83 62.32 70.48 53.4 90.17Z'
        fill='#8D2676'
      />
      <path
        d='M114.64 61.86C103.89 46.87 87.07 36.67 68.64 36.36C104.26 20.19 148.09 46.4 152.86 85.17C153.3 88.76 152.72 92.43 151.12 95.68C144.47 109.19 132.12 119.68 117.7 123.56C128.27 103.96 126.97 80.02 114.64 61.86Z'
        fill='#EE342F'
      />
    </svg>
  )
}

export function TwilioIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='-8 -8 272 272'>
      <path
        fill='currentColor'
        d='M128 0c70.66 0 128 57.34 128 128s-57.34 128-128 128S0 198.66 0 128 57.34 0 128 0zm0 33.79c-52.22 0-94.21 41.98-94.21 94.21S75.78 222.21 128 222.21s94.21-41.98 94.21-94.21S180.22 33.79 128 33.79zm31.74 99.33c14.7 0 26.62 11.92 26.62 26.62 0 14.7-11.92 26.62-26.62 26.62-14.7 0-26.62-11.92-26.62-26.62 0-14.7 11.92-26.62 26.62-26.62zm-63.49 0c14.7 0 26.62 11.92 26.62 26.62 0 14.7-11.92 26.62-26.62 26.62-14.7 0-26.62-11.92-26.62-26.62 0-14.7 11.92-26.62 26.62-26.62zm63.49-63.49c14.7 0 26.62 11.92 26.62 26.62 0 14.7-11.92 26.62-26.62 26.62-14.7 0-26.62-11.92-26.62-26.62 0-14.7 11.92-26.62 26.62-26.62zm-63.49 0c14.7 0 26.62 11.92 26.62 26.62 0 14.7-11.92 26.62-26.62 26.62-14.7 0-26.62-11.92-26.62-26.62 0-14.7 11.92-26.62 26.62-26.62z'
      />
    </svg>
  )
}

export function SendblueIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 72 72' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M58.54 5.2C53.99 5.2 50.29 8.89 50.29 13.45C50.29 18.01 53.99 21.7 58.54 21.7C63.1 21.7 66.79 18.01 66.79 13.45C66.79 8.89 63.1 5.2 58.54 5.2Z'
      />
      <path
        fill='currentColor'
        d='M0.01 36C0.01 41.68 4.37 46.33 9.93 46.81C6.34 51.07 6.54 57.45 10.55 61.46C14.56 65.47 20.94 65.67 25.2 62.08C25.67 67.64 30.33 72 36.01 72C41.69 72 46.33 67.64 46.81 62.08C51.07 65.67 57.45 65.47 61.46 61.46C65.47 57.45 65.67 51.07 62.08 46.81C67.64 46.34 72 41.68 72 36C72 30.01 67.14 25.14 61.15 25.14C60.73 25.14 60.32 25.18 59.91 25.23C59.47 25.28 59.01 25.29 58.54 25.29C56.99 25.29 55.52 24.99 54.17 24.45C51.15 23.25 48.74 20.83 47.54 17.82C47 16.46 46.7 14.99 46.7 13.45C46.7 12.98 46.72 12.54 46.76 12.08C46.81 11.67 46.85 11.26 46.85 10.86C46.85 4.86 41.99 0 35.99 0C30.32 0 25.67 4.36 25.19 9.92C20.93 6.33 14.55 6.53 10.54 10.54C6.53 14.55 6.33 20.93 9.92 25.19C4.36 25.66 0 30.32 0 36L0.01 36Z'
      />
    </svg>
  )
}

export function ImageIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M24.9 10.32C16.09 9.11 8.49 15.65 9 24.33M5.67 7.67C5.67 8.37 5.95 9.05 6.45 9.55C6.95 10.05 7.63 10.33 8.33 10.33C9.04 10.33 9.72 10.05 10.22 9.55C10.72 9.05 11 8.37 11 7.67C11 6.96 10.72 6.28 10.22 5.78C9.72 5.28 9.04 5 8.33 5C7.63 5 6.95 5.28 6.45 5.78C5.95 6.28 5.67 6.96 5.67 7.67Z' />
      <path d='M1 14.42C4.71 13.91 8.03 15.7 9.83 18.55' />
      <path d='M1 9.53C1 6.55 1 5.05 1.58 3.91C2.09 2.91 2.91 2.09 3.91 1.58C5.05 1 6.55 1 9.53 1H16.47C19.45 1 20.95 1 22.09 1.58C23.09 2.09 23.91 2.91 24.42 3.91C25 5.05 25 6.55 25 9.53V16.47C25 19.45 25 20.95 24.42 22.09C23.91 23.09 23.09 23.91 22.09 24.42C20.95 25 19.45 25 16.47 25H9.53C6.55 25 5.05 25 3.91 24.42C2.91 23.91 2.09 23.09 1.58 22.09C1 20.95 1 19.45 1 16.47V9.53Z' />
    </svg>
  )
}

export function EmbeddingsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      {/* Rays sit below the nodes in weight, but not so far below that they
          wash out to loose dots at the 14px search-row size. */}
      <path
        d='M13 13L5.5 6.5M13 13L21 7M13 13L6.5 20M13 13L21 19'
        strokeWidth='1.6'
        opacity='0.9'
      />
      <circle cx='13' cy='13' r='3.1' fill='currentColor' stroke='none' />
      <circle cx='5.5' cy='6.5' r='1.9' fill='currentColor' stroke='none' />
      <circle cx='21' cy='7' r='1.9' fill='currentColor' stroke='none' />
      <circle cx='6.5' cy='20' r='1.9' fill='currentColor' stroke='none' />
      <circle cx='21' cy='19' r='1.9' fill='currentColor' stroke='none' />
    </svg>
  )
}

export function TypeformIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 122.3 80.3'
      xmlSpace='preserve'
    >
      <g>
        <path
          fill='currentColor'
          d='M94.3,0H65.4c-26,0-28,11.2-28,26.2l0,27.9c0,15.6,2,26.2,28.1,26.2h28.8c26,0,28-11.2,28-26.1V26.2
		C122.3,11.2,120.3,0,94.3,0z M0,20.1C0,6.9,5.2,0,14,0c8.8,0,14,6.9,14,20.1v40.1c0,13.2-5.2,20.1-14,20.1c-8.8,0-14-6.9-14-20.1
		V20.1z'
        />
      </g>
    </svg>
  )
}

export function DocumentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='23'
      height='28'
      viewBox='0 0 23 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 15.2H15.2M8 20H11.6M2 4.4V23.6C2 24.24 2.25 24.85 2.7 25.3C3.15 25.75 3.76 26 4.4 26H18.8C19.44 26 20.05 25.75 20.5 25.3C20.95 24.85 21.2 24.24 21.2 23.6V9.61C21.2 9.29 21.14 8.97 21.01 8.68C20.89 8.38 20.71 8.12 20.48 7.89L15.15 2.68C14.7 2.25 14.1 2 13.47 2H4.4C3.76 2 3.15 2.25 2.7 2.7C2.25 3.15 2 3.76 2 4.4Z'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 2V6.8C14 7.44 14.25 8.05 14.7 8.5C15.15 8.95 15.76 9.2 16.4 9.2H21.2'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function WindchillIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='79 57 88 88'
      role='img'
      aria-label='Windchill icon'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='79' y='57' width='88' height='88' fill='#FFFFFF' />
      <g fill='#3D4647'>
        <polygon points='137.2,86.6 137.2,68.5 122.8,60.2 107.1,69.2' />
        <polygon points='142.7,106.4 158.4,97.3 158.4,80.7 142.7,71.6' />
        <polygon points='108.5,115.8 108.5,133.9 122.8,142.2 138.5,133.2' />
        <polygon points='128.2,121 143.9,130.1 158.4,121.7 158.4,103.6' />
        <polygon points='117.4,81.4 101.7,72.4 87.3,80.7 87.3,98.8' />
        <polygon points='103,96 87.3,105.1 87.3,121.7 103,130.8' />
      </g>
      <polygon
        fill='#40AA1D'
        points='137.2,109.5 122.8,117.8 108.4,109.5 108.4,92.9 122.8,84.6 137.2,92.9'
      />
    </svg>
  )
}

export function MintlifyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19 19' fill='none'>
      <path
        d='M18.37 7.29V1.6C18.37 0.99 17.87 0.5 17.27 0.5H11.58C10.69 0.5 9.8 0.68 8.98 1.01C8.16 1.36 7.41 1.85 6.78 2.49L6.73 2.54C5.9 3.38 5.31 4.42 5.01 5.57C5.55 5.43 6.1 5.36 6.66 5.35C8.15 5.33 9.61 5.81 10.79 6.7C11.86 7.5 12.68 8.6 13.12 9.86C13.58 11.15 13.63 12.55 13.29 13.87C14.43 13.56 15.48 12.97 16.32 12.14L16.37 12.1C17 11.47 17.5 10.71 17.84 9.89C18.19 9.07 18.36 8.18 18.36 7.29H18.37Z'
        fill='#18E299'
      />
      <path
        d='M4.84 7.19C4.85 5.45 5.54 3.77 6.77 2.52L2.04 7.25C2.02 7.27 2 7.28 1.98 7.3C0.83 8.45 0.13 9.98 0.02 11.6C-0.09 13.12 0.31 14.62 1.15 15.87C1.23 15.99 1.45 16.03 1.58 15.91L4.48 13.02C5.38 12.11 5.67 10.76 5.23 9.56C4.96 8.81 4.83 8 4.84 7.19Z'
        fill='#0C8C5E'
      />
      <path
        d='M16.34 12.09C15.43 12.98 14.3 13.6 13.06 13.88C11.82 14.15 10.53 14.07 9.33 13.65C9.33 13.65 9.33 13.65 9.32 13.65C8.11 13.21 6.76 13.5 5.85 14.4L2.95 17.29C2.83 17.41 2.85 17.61 3 17.71C4.25 18.55 5.75 18.95 7.26 18.85C8.88 18.73 10.41 18.04 11.56 16.88L11.61 16.84L16.34 12.1V12.09Z'
        fill='#0C8C5E'
      />
    </svg>
  )
}

export function MistralIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `mistral_clip_${id}`

  return (
    <svg
      {...props}
      width='22'
      height='22'
      viewBox='1 0.5 24 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <g clipPath={`url(#${clipId})`}>
        <path d='M17.45 0H21.82V4.39H17.45V0Z' fill='black' />
        <path d='M19.64 0H24V4.39H19.64V0Z' fill='#F7D046' />
        <path
          d='M0 0H4.36V4.39H0V0ZM0 4.39H4.36V8.79H0V4.39ZM0 8.79H4.36V13.18H0V8.79ZM0 13.18H4.36V17.58H0V13.18ZM0 17.58H4.36V21.97H0V17.58Z'
          fill='black'
        />
        <path d='M2.18 0H6.55V4.39H2.18V0Z' fill='#F7D046' />
        <path d='M19.64 4.39H24V8.79H19.64V4.39ZM2.18 4.39H6.55V8.79H2.18V4.39Z' fill='#F2A73B' />
        <path d='M13.09 4.39H17.45V8.79H13.09V4.39Z' fill='black' />
        <path
          d='M15.27 4.39H19.64V8.79H15.27V4.39ZM6.55 4.39H10.91V8.79H6.55V4.39Z'
          fill='#F2A73B'
        />
        <path
          d='M10.91 8.79H15.27V13.18H10.91V8.79ZM15.27 8.79H19.64V13.18H15.27V8.79ZM6.55 8.79H10.91V13.18H6.55V8.79Z'
          fill='#EE792F'
        />
        <path d='M8.73 13.18H13.09V17.58H8.73V13.18Z' fill='black' />
        <path d='M10.91 13.18H15.27V17.58H10.91V13.18Z' fill='#EB5829' />
        <path d='M19.64 8.79H24V13.18H19.64V8.79ZM2.18 8.79H6.55V13.18H2.18V8.79Z' fill='#EE792F' />
        <path d='M17.45 13.18H21.82V17.58H17.45V13.18Z' fill='black' />
        <path d='M19.64 13.18H24V17.58H19.64V13.18Z' fill='#EB5829' />
        <path d='M17.45 17.58H21.82V21.97H17.45V17.58Z' fill='black' />
        <path d='M2.18 13.18H6.55V17.58H2.18V13.18Z' fill='#EB5829' />
        <path
          d='M19.64 17.58H24V21.97H19.64V17.58ZM2.18 17.58H6.55V21.97H2.18V17.58Z'
          fill='#EA3326'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='24' height='22' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BrainIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 256 256' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path d='M212,76V72a44,44,0,0,0-74.86-31.31,3.93,3.93,0,0,0-1.14,2.8v88.72a4,4,0,0,0,6.2,3.33A47.67,47.67,0,0,1,167.68,128a8.18,8.18,0,0,1,8.31,7.58,8,8,0,0,1-8,8.42,32,32,0,0,0-32,32v33.88a4,4,0,0,0,1.49,3.12,47.92,47.92,0,0,0,74.21-17.16,4,4,0,0,0-4.49-5.56A68.06,68.06,0,0,1,192,192h-7.73a8.18,8.18,0,0,1-8.25-7.47,8,8,0,0,1,8-8.53h8a51.6,51.6,0,0,0,24-5.88v0A52,52,0,0,0,212,76Zm-12,36h-4a36,36,0,0,1-36-36V72a8,8,0,0,1,16,0v4a20,20,0,0,0,20,20h4a8,8,0,0,1,0,16ZM88,28A44.05,44.05,0,0,0,44,72v4a52,52,0,0,0-4,94.12h0A51.6,51.6,0,0,0,64,176h7.73A8.18,8.18,0,0,1,80,183.47,8,8,0,0,1,72,192H64a67.48,67.48,0,0,1-15.21-1.73,4,4,0,0,0-4.5,5.55A47.93,47.93,0,0,0,118.51,213a4,4,0,0,0,1.49-3.12V176a32,32,0,0,0-32-32,8,8,0,0,1-8-8.42A8.18,8.18,0,0,1,88.32,128a47.67,47.67,0,0,1,25.48,7.54,4,4,0,0,0,6.2-3.33V43.49a4,4,0,0,0-1.14-2.81A43.85,43.85,0,0,0,88,28Zm8,48a36,36,0,0,1-36,36H56a8,8,0,0,1,0-16h4A20,20,0,0,0,80,76V72a8,8,0,0,1,16,0Z' />
    </svg>
  )
}

export function StagehandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='256'
      height='352'
      viewBox='0 0 256 352'
      fill='none'
    >
      <path
        d='M 242.29,45.79 C 242.29,28.88 226.69,13.76 206.61,13.76 C 188.59,13.76 174.82,28.66 174.82,45.85 V 101.97 C 168.89,98.09 163.18,96.76 157.14,96.76 C 145.94,96.76 137.02,101.49 128.83,110.17 C 121.81,101.01 112.07,95.73 100.72,95.73 C 93.97,95.73 87.82,98.09 82.11,100.9 V 80.05 C 82.11,64.08 66.14,47.28 48.74,47.28 C 31.12,47.28 14.54,62.71 14.54,78.79 V 219.4 C 14.54,273.71 56.99,337.89 125.23,337.89 C 197.41,337.89 242.29,289.05 242.29,186.01 V 78.9 L 242.29,45.79 Z'
        fill='black'
      />
      <path
        d='M 224.94,46.23 C 224.94,36.76 215.91,28.66 205.91,28.66 C 196.75,28.66 189.9,36.11 189.9,45.14 V 152.72 C 202.88,153.38 214.08,155.96 224.94,166.19 V 78.79 L 224.94,46.23 Z'
        fill='white'
      />
      <path
        d='M 157.21,113.21 C 146.12,113.21 137.93,122.02 137.93,131.76 V 154.62 C 142.24,153.05 145.95,152.61 149.83,152.61 H 174.71 V 131.76 C 174.71,122.35 166.73,113.21 157.21,113.21 Z'
        fill='white'
      />
      <path
        d='M 100.06,111.75 C 89.19,111.75 81.85,121.06 81.85,130.31 V 157.86 C 81.85,167.71 89.72,175.38 99.24,175.38 C 109.71,175.38 118.39,166.91 118.39,157.39 V 130.31 C 118.39,120.79 110.03,111.75 100.06,111.75 Z'
        fill='white'
      />
      <path
        d='M 192.04,168.87 H 150.16 C 140.19,168.87 133.34,175.39 133.34,183.86 C 133.34,192.9 140.19,199.75 148.66,199.75 H 182.52 C 188.01,199.75 189.63,204.81 189.63,207.49 C 189.63,211.91 186.37,214.64 181.09,215.51 C 162.96,218.66 137.71,229.13 137.71,259.68 C 137.71,265.07 133.67,267.42 130.29,267.42 C 126.09,267.42 122.38,264.74 122.38,260.12 C 122.38,241.15 129.02,228.17 143.26,214.81 C 131.01,212.02 119.21,202.99 117.75,186.43 C 111.93,189.81 107.2,191.15 100.18,191.15 C 82.11,191.15 66.68,176.58 66.68,158.29 V 80.71 C 66.68,71.24 57.16,63.5 49.18,63.5 C 38.71,63.5 29.89,72.42 29.89,80.27 V 217.19 C 29.89,266.48 68.71,322.19 124.88,322.19 C 185.91,322.19 223.91,282.15 223.91,207.16 C 223.91,187.19 214.28,168.87 192.04,168.87 Z'
        fill='white'
      />
    </svg>
  )
}

export function BrandfetchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 29 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M29 7.55C29 9.47 28.32 11.14 26.95 12.54C25.58 13.93 23.59 14.92 20.96 15.53C22.38 15.92 23.45 16.55 24.18 17.44C24.91 18.3 25.27 19.3 25.27 20.43C25.27 22.22 24.7 23.77 23.56 25.09C22.45 26.4 20.8 27.42 18.64 28.14C16.47 28.85 13.86 29.2 10.81 29.2C9.67 29.2 8.75 29.16 8.07 29.1C8.05 29.73 7.77 30.21 7.25 30.52C6.73 30.84 6.05 31 5.23 31C4.41 31 3.84 30.82 3.52 30.46C3.23 30.09 3.1 29.56 3.15 28.86C3.35 25.69 3.75 22.37 4.34 18.9C4.94 15.41 5.69 12.04 6.6 8.8C6.76 8.24 7.08 7.84 7.56 7.61C8.04 7.39 8.66 7.27 9.44 7.27C10.83 7.27 11.52 7.66 11.52 8.43C11.52 8.75 11.46 9.11 11.32 9.52C10.73 11.29 10.13 13.69 9.54 16.72C8.95 19.74 8.53 22.62 8.28 25.36C9.37 25.45 10.26 25.49 10.94 25.49C14.14 25.49 16.47 25.04 17.95 24.13C19.46 23.2 20.21 22.03 20.21 20.6C20.21 19.6 19.78 18.76 18.91 18.08C18.07 17.4 16.64 17.03 14.64 16.96C14.18 16.94 13.86 16.83 13.68 16.62C13.5 16.42 13.41 16.09 13.41 15.64C13.41 14.98 13.54 14.45 13.82 14.04C14.09 13.63 14.59 13.42 15.32 13.39C16.94 13.35 18.4 13.11 19.7 12.68C21.02 12.25 22.06 11.65 22.81 10.88C23.56 10.08 23.94 9.17 23.94 8.12C23.94 6.81 23.29 5.78 21.99 5.03C20.69 4.26 18.69 3.88 16 3.88C13.57 3.88 11.21 4.19 8.93 4.83C6.65 5.44 4.71 6.22 3.11 7.17C2.38 7.6 1.77 7.82 1.27 7.82C0.85 7.82 0.54 7.68 0.31 7.41C0.1 7.12 0 6.75 0 6.32C0 5.76 0.11 5.27 0.34 4.86C0.59 4.45 1.17 3.99 2.09 3.47C4 2.38 6.25 1.53 8.82 0.92C11.4 0.31 14.03 0 16.72 0C20.85 0 23.93 0.69 25.96 2.07C27.99 3.46 29 5.28 29 7.55Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function BrexIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 223 179.3' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M144.9,14.3c-8.7,11.6-10.8,15.5-19.2,15.5H0v149.4h49.3c11.1,0,21.9-5.4,28.9-14.3c9-12,10.2-15.5,18.9-15.5 H223V0h-49.6C162.3,0,151.5,5.4,144.9,14.3L144.9,14.3z M183.9,110.9h-52.6c-11.4,0-21.9,4.8-28.9,14c-9,12-10.8,15.5-19.2,15.5 H38.8V68.7h52.6c11.4,0,21.9-5.4,28.9-14.3c9-11.6,11.4-15.2,19.5-15.2h44.2V110.9z'
      />
    </svg>
  )
}

/**
 * Official QuickBooks circular mark, cropped from the user-supplied
 * Intuit_QuickBooks_logo.svg wordmark.
 */
export function QuickBooksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 61.54 61.54' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#2CA01C'
        d='M30.77 61.54c16.99 0 30.77-13.78 30.77-30.77S47.76 0 30.77 0 0 13.78 0 30.77s13.77 30.77 30.77 30.77Z'
      />
      <path
        fill='#FFF'
        d='M20.51 18.8c-6.61 0-11.97 5.36-11.97 11.97s5.35 11.96 11.97 11.96h1.71v-4.44h-1.71c-4.15 0-7.52-3.37-7.52-7.52 0-4.15 3.37-7.52 7.52-7.52h4.11V46.5c0 2.45 1.99 4.44 4.44 4.44V18.8h-8.55Zm20.52 23.93c6.61 0 11.97-5.36 11.97-11.96S47.65 18.81 41.03 18.81h-1.71v4.44h1.71c4.15 0 7.52 3.37 7.52 7.52s-3.37 7.52-7.52 7.52h-4.11V15.04c0-2.45-1.99-4.44-4.44-4.44v32.13h8.55Z'
      />
    </svg>
  )
}

export function BrightDataIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='32.147 86.569 61.723 61.723'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M62 95.21c.19 2.16 1.85 3.24 2.82 4.74.25.38.48.11.67-.16.21-.31.6-1.21 1.15-1.28-.35 1.38-.04 3.15.16 4.45.49 3.05-1.22 5.64-4.07 6.18-3.38.65-6.22-2.21-5.6-5.62.23-1.24 1.37-2.5.77-3.7-.85-1.7.54-.52.79-.22 1.04 1.2 1.21.09 1.45-.55.24-.63.31-1.31.47-1.97.19-.77.55-1.4 1.39-1.87z'
        fill='#4280f6'
      />
      <path
        d='M66.70 123.37c0 3.69.04 7.38-.03 11.07-.02 1.04.31 1.48 1.32 1.49.29 0 .59.12.88.13.93.01 1.18.47 1.16 1.37-.05 2.19 0 2.19-2.24 2.19-3.48 0-6.96-.04-10.44.03-1.09.02-1.47-.33-1.3-1.36.02-.12.02-.26 0-.38-.28-1.39.39-1.96 1.7-1.9 1.36.06 1.76-.51 1.74-1.88-.09-5.17-.08-10.35 0-15.53.02-1.22-.32-1.87-1.52-2.17-.57-.14-1.47-.11-1.57-.85-.15-1.04-.05-2.11.01-3.17.02-.34.44-.35.73-.39 2.81-.39 5.63-.77 8.44-1.18.92-.14 1.15.2 1.14 1.09-.04 3.8-.02 7.62-.02 11.44z'
        fill='#4280f6'
      />
    </svg>
  )
}

export function BrowserUseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 150 150'
      preserveAspectRatio='xMidYMid meet'
    >
      <g transform='translate(0,150) scale(0.05,-0.05)' fill='currentColor' stroke='none'>
        <path
          d='M786 2713 c-184 -61 -353 -217 -439 -405 -76 -165 -65 -539 19 -666
l57 -85 -48 -124 c-203 -517 -79 -930 346 -1155 159 -85 441 -71 585 28 l111
77 196 -76 c763 -293 1353 304 1051 1063 -77 191 -77 189 -14 282 163 239 97
660 -140 893 -235 231 -528 256 -975 83 l-96 -37 -121 67 c-144 79 -383 103
-532 55z m459 -235 c88 -23 96 -51 22 -79 -29 -11 -84 -47 -121 -80 -57 -50
-84 -59 -178 -59 -147 0 -190 -44 -238 -241 -102 -424 -230 -440 -230 -29 1
417 289 606 745 488z m1046 -18 c174 -85 266 -309 239 -582 -26 -256 -165
-165 -230 151 -73 356 -469 332 -954 -58 -587 -472 -829 -1251 -388 -1251 108
0 126 -7 214 -80 54 -44 104 -80 113 -80 54 0 -2 -43 -89 -69 -220 -66 -426
-22 -568 120 -599 599 871 2232 1663 1849z m-234 -510 c969 -1036 357 -1962
-787 -1190 -254 171 -348 303 -323 454 21 128 40 123 231 -59 691 -658 1362
-583 1052 117 -106 239 -366 585 -504 671 l-72 44 98 45 c150 68 169 63 305
-82z m-329 -310 c161 -184 163 -160 -30 -338 -188 -173 -180 -173 -386 19
-163 153 -163 157 7 324 218 213 219 213 409 -5z m354 -375 c92 -239 -179
-462 -377 -309 l-46 35 186 163 c211 186 209 185 237 111z'
        />
      </g>
    </svg>
  )
}

export function BufferIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 86.7 97.9'
      fill='currentColor'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0,22.3L43.1,0l43.6,22.3L43.1,44.8L0,22.3z M43.1,83.1l-29.4-16L0,74.5l43.1,23.4l43.6-23.4l-13.9-7.4 L43.1,83.1z M13.7,42l29.4,14.5L72.9,42l13.9,6.8L43.1,69.9L0,48.7L13.7,42z'
      />
    </svg>
  )
}

export function Mem0Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='479'
      height='108'
      viewBox='0 0 108 108'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        fill='currentColor'
        clipRule='evenodd'
        d='M56.15 8.96C58.62 8.96 60.61 6.96 60.61 4.5C60.61 2.03 58.62 0.04 56.15 0.04C53.69 0.04 51.69 2.03 51.69 4.5C51.69 6.96 53.69 8.96 56.15 8.96ZM38.42 29.35C37.27 27.87 36.35 26.02 36.83 24.2C37.32 22.39 39.04 21.25 40.78 20.54C42.96 19.65 44.71 17.78 45.37 15.33C46.48 11.17 44.01 6.89 39.85 5.77C35.68 4.66 31.4 7.13 30.29 11.29C29.63 13.74 30.22 16.23 31.66 18.09C32.81 19.58 33.73 21.43 33.24 23.24C32.76 25.05 31.03 26.2 29.3 26.91C27.12 27.8 25.37 29.66 24.71 32.11C23.59 36.28 26.06 40.56 30.23 41.67C34.39 42.79 38.67 40.32 39.79 36.15C40.44 33.7 39.86 31.22 38.42 29.35ZM86.15 38.63C84.34 38.14 82.48 39.06 81 40.21C79.14 41.65 76.65 42.24 74.2 41.58C70.04 40.46 67.56 36.18 68.68 32.02C69.8 27.86 74.08 25.39 78.24 26.5C80.69 27.16 82.55 28.91 83.44 31.09C84.15 32.82 85.3 34.55 87.11 35.04C88.92 35.52 90.78 34.6 92.26 33.45C94.12 32.01 96.61 31.43 99.06 32.08C103.22 33.2 105.69 37.48 104.58 41.64C103.46 45.8 99.18 48.28 95.02 47.16C92.57 46.5 90.71 44.75 89.81 42.57C89.1 40.84 87.96 39.11 86.15 38.63ZM103.56 77.18C100.51 80.22 95.57 80.22 92.52 77.18C90.73 75.38 89.99 72.94 90.31 70.6C90.56 68.74 90.43 66.68 89.11 65.35C87.78 64.03 85.71 63.9 83.86 64.15C81.52 64.47 79.07 63.73 77.28 61.93C74.23 58.89 74.23 53.95 77.28 50.9C80.33 47.85 85.27 47.85 88.32 50.9C90.11 52.69 90.85 55.14 90.53 57.47C90.28 59.33 90.41 61.4 91.74 62.72C93.06 64.05 95.13 64.18 96.99 63.92C99.32 63.61 101.77 64.35 103.56 66.14C106.61 69.19 106.61 74.13 103.56 77.18ZM64.12 96.04C63 100.2 65.48 104.48 69.64 105.6C73.8 106.71 78.08 104.24 79.2 100.08C79.85 97.63 79.27 95.14 77.83 93.28C76.68 91.79 75.76 89.94 76.24 88.13C76.73 86.32 78.45 85.17 80.19 84.46C82.37 83.57 84.12 81.71 84.78 79.26C85.89 75.09 83.42 70.81 79.26 69.7C75.09 68.58 70.81 71.05 69.7 75.22C69.04 77.67 69.63 80.16 71.07 82.02C72.22 83.5 73.14 85.35 72.65 87.17C72.17 88.98 70.44 90.12 68.71 90.83C66.53 91.72 64.78 93.59 64.12 96.04ZM28.84 99.71C26.68 95.98 27.96 91.2 31.69 89.05C33.89 87.78 36.45 87.7 38.62 88.61C40.35 89.34 42.38 89.75 44 88.81C45.63 87.87 46.28 85.91 46.52 84.05C46.82 81.71 48.17 79.54 50.36 78.27C54.09 76.11 58.87 77.39 61.02 81.13C63.18 84.86 61.9 89.63 58.17 91.79C55.97 93.06 53.41 93.14 51.24 92.23C49.51 91.5 47.48 91.09 45.86 92.03C44.23 92.97 43.58 94.93 43.34 96.79C43.04 99.12 41.69 101.3 39.5 102.57C35.77 104.72 30.99 103.44 28.84 99.71ZM28.49 71.16C27 72.31 25.15 73.23 23.34 72.74C21.53 72.26 20.38 70.53 19.67 68.8C18.78 66.62 16.92 64.87 14.47 64.21C10.3 63.1 6.02 65.57 4.91 69.73C3.79 73.89 6.26 78.17 10.43 79.29C12.88 79.94 15.37 79.36 17.23 77.92C18.71 76.77 20.56 75.85 22.38 76.33C24.19 76.82 25.33 78.55 26.04 80.28C26.93 82.46 28.8 84.21 31.25 84.87C35.41 85.98 39.69 83.51 40.81 79.35C41.92 75.19 39.45 70.91 35.29 69.79C32.84 69.13 30.35 69.72 28.49 71.16ZM5.92 34.19C8.97 31.15 13.91 31.15 16.96 34.19C18.76 35.99 19.49 38.44 19.18 40.77C18.92 42.63 19.05 44.69 20.38 46.02C21.71 47.35 23.77 47.47 25.63 47.22C27.96 46.9 30.41 47.64 32.21 49.43C35.25 52.48 35.25 57.42 32.21 60.47C29.16 63.52 24.22 63.52 21.17 60.47C19.37 58.68 18.64 56.23 18.95 53.9C19.21 52.04 19.08 49.97 17.75 48.65C16.42 47.32 14.36 47.19 12.5 47.45C10.17 47.76 7.72 47.02 5.92 45.23C2.88 42.18 2.88 37.24 5.92 34.19ZM65.48 22.56C63.86 23.5 63.2 25.46 62.97 27.32C62.67 29.66 61.32 31.83 59.12 33.1C55.39 35.26 50.62 33.98 48.46 30.24C46.31 26.51 47.59 21.74 51.32 19.58C53.52 18.31 56.07 18.23 58.24 19.14C59.97 19.87 62 20.28 63.63 19.34C65.25 18.4 65.91 16.44 66.15 14.58C66.45 12.25 67.79 10.07 69.99 8.8C73.72 6.65 78.49 7.93 80.65 11.66C82.8 15.39 81.53 20.17 77.79 22.32C75.6 23.59 73.04 23.67 70.87 22.76C69.14 22.04 67.11 21.62 65.48 22.56ZM104.47 60.25C106.93 60.25 108.93 58.25 108.93 55.79C108.93 53.32 106.93 51.33 104.47 51.33C102.01 51.33 100.01 53.32 100.01 55.79C100.01 58.25 102.01 60.25 104.47 60.25ZM96.29 21.59C96.29 24.06 94.3 26.05 91.83 26.05C89.37 26.05 87.37 24.06 87.37 21.59C87.37 19.13 89.37 17.13 91.83 17.13C94.3 17.13 96.29 19.13 96.29 21.59ZM23.45 20.11C23.45 22.57 21.45 24.57 18.99 24.57C16.53 24.57 14.53 22.57 14.53 20.11C14.53 17.64 16.53 15.65 18.99 15.65C21.45 15.65 23.45 17.64 23.45 20.11ZM4.87 60.25C7.33 60.25 9.33 58.25 9.33 55.79C9.33 53.32 7.33 51.33 4.87 51.33C2.4 51.33 0.41 53.32 0.41 55.79C0.41 58.25 2.4 60.25 4.87 60.25ZM22.71 89.23C22.71 91.7 20.71 93.69 18.25 93.69C15.78 93.69 13.79 91.7 13.79 89.23C13.79 86.77 15.78 84.77 18.25 84.77C20.71 84.77 22.71 86.77 22.71 89.23ZM52.44 107.82C54.9 107.82 56.9 105.82 56.9 103.36C56.9 100.89 54.9 98.9 52.44 98.9C49.97 98.9 47.98 100.89 47.98 103.36C47.98 105.82 49.97 107.82 52.44 107.82ZM95.55 90.72C95.55 93.18 93.55 95.18 91.09 95.18C88.63 95.18 86.63 93.18 86.63 90.72C86.63 88.26 88.63 86.26 91.09 86.26C93.55 86.26 95.55 88.26 95.55 90.72ZM54.48 68.56C61.87 68.56 67.86 62.57 67.86 55.18C67.86 47.79 61.87 41.79 54.48 41.79C47.08 41.79 41.09 47.79 41.09 55.18C41.09 62.57 47.08 68.56 54.48 68.56Z'
      />
    </svg>
  )
}

export function ExtendIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 24' fill='none'>
      <path
        d='M6.38 13.77L4.29 14.81C4.11 14.89 4.11 15.14 4.29 15.22L15.89 20.95C16.14 21.07 16.43 21.07 16.68 20.95L28.29 15.22C28.46 15.14 28.46 14.89 28.29 14.81L26.2 13.77C27.38 13.19 28.51 12.64 29.46 12.18C30.26 12.57 31.07 12.97 31.87 13.36C32.3 13.57 32.57 14.01 32.57 14.49V15.54C32.57 16.02 32.3 16.46 31.87 16.67C31.87 16.67 19.58 22.7 17.55 23.69C16.73 24.09 15.9 24.11 15.06 23.7C12.81 22.61 1.96 17.29 0.71 16.67C0.27 16.46 0 16.02 0 15.54V14.49C0 14.01 0.27 13.57 0.7 13.36C1.44 13 2.26 12.6 3.12 12.18C4.07 12.64 5.19 13.19 6.38 13.77Z'
        fill='currentColor'
      />
      <path
        d='M15.1 6.31C15.9 5.92 16.72 5.93 17.51 6.32C20.17 7.62 22.83 8.92 25.49 10.23L22.25 11.83L16.68 9.08C16.43 8.96 16.14 8.96 15.89 9.08L10.33 11.83L7.09 10.23C11.21 8.21 15.07 6.32 15.1 6.31Z'
        fill='currentColor'
      />
      <path
        clipRule='evenodd'
        d='M16.29 0C16.7 0 17.11 0.1 17.51 0.29C22.3 2.63 27.08 4.99 31.87 7.34C32.3 7.55 32.57 7.99 32.57 8.46V9.51C32.57 10 32.3 10.44 31.87 10.65C31.87 10.65 19.58 16.67 17.55 17.66C17.14 17.87 16.69 17.97 16.29 17.97C15.88 17.97 15.47 17.88 15.06 17.68C12.81 16.58 1.96 11.26 0.71 10.64C0.27 10.43 0 9.99 0 9.51V8.46C0 7.98 0.27 7.55 0.7 7.33C5.9 4.78 15.06 0.3 15.1 0.28C15.5 0.09 15.88 0 16.29 0ZM16.29 2.96C16.15 2.96 16.02 2.99 15.89 3.05L4.29 8.78C4.11 8.86 4.11 9.11 4.29 9.2L15.89 14.92C16.02 14.98 16.15 15.01 16.29 15.01C16.42 15.01 16.55 14.98 16.68 14.92L28.29 9.2C28.46 9.11 28.46 8.86 28.29 8.78L16.68 3.05C16.55 2.99 16.42 2.96 16.29 2.96Z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}

export function ElevenLabsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='876'
      height='876'
      viewBox='0 0 876 876'
      fill='none'
    >
      <path d='M498 138H618V738H498V138Z' fill='currentColor' />
      <path d='M258 138H378V738H258V138Z' fill='currentColor' />
    </svg>
  )
}

export function FindymailIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient0 = `findymail_paint0_${id}`
  const gradient1 = `findymail_paint1_${id}`
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45.4462 31.2952' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.78 8.18C26.63 8.18 25.48 8.62 24.6 9.5L22.72 11.07L20.85 9.5C19.97 8.62 18.82 8.18 17.67 8.18C16.52 8.18 15.37 8.62 14.49 9.5C12.74 11.25 12.74 14.1 14.49 15.85L20.97 22.09C21.95 23.03 23.5 23.03 24.47 22.09L30.96 15.85C32.71 14.1 32.71 11.25 30.96 9.5C30.08 8.62 28.93 8.18 27.78 8.18Z'
        fill={`url(#${gradient0})`}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M42.38 27.3C42.38 27.86 41.93 28.31 41.37 28.31H4.07C3.51 28.31 3.07 27.86 3.07 27.3V7.29C3.07 6.4 4.13 5.94 4.78 6.55L9.54 11C9.95 11.39 10.62 11.2 10.77 10.65C10.88 10.27 11.02 9.9 11.18 9.55C11.41 9.08 11.26 8.52 10.88 8.16L7.19 4.71C6.53 4.09 6.96 2.99 7.86 2.99H37.58C38.48 2.99 38.92 4.09 38.26 4.71L34.57 8.16C34.19 8.51 34.04 9.08 34.26 9.55C34.43 9.9 34.57 10.27 34.67 10.64C34.83 11.19 35.49 11.39 35.91 11L40.67 6.55C41.32 5.94 42.38 6.4 42.38 7.29V27.3ZM42.91 0H2.53C1.13 0 0 1.13 0 2.53V28.76C0 30.16 1.13 31.3 2.53 31.3H42.91C44.31 31.3 45.45 30.16 45.45 28.76V2.53C45.45 1.13 44.31 0 42.91 0Z'
        fill={`url(#${gradient1})`}
      />
      <defs>
        <linearGradient
          id={gradient0}
          x1='20.5769'
          y1='8.68821'
          x2='24.6922'
          y2='23.0919'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F04249' />
          <stop offset='0.289072' stopColor='#DE2337' />
          <stop offset='1' stopColor='#B91C1C' />
        </linearGradient>
        <linearGradient
          id={gradient1}
          x1='22.7231'
          y1='0'
          x2='22.7231'
          y2='31.2952'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#18181B' />
          <stop offset='1' />
        </linearGradient>
      </defs>
    </svg>
  )
}
export function ZeroBounceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 26' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.33 21.84H11.31C11.48 21.84 11.6 21.9 11.66 22.08L13.12 24.42C13.24 24.65 13.18 24.89 13.01 25.06C12.95 25.12 12.83 25.12 12.77 25.12H1.47C1.23 25.12 1 24.95 1 24.65V22.66C1 22.54 1.06 22.43 1.12 22.37L6.92 15.69C7.09 15.52 7.03 15.22 6.86 15.05C6.8 14.99 6.68 14.93 6.56 14.93H1.7C1.47 14.93 1.23 14.75 1.23 14.46V12.12C1.23 11.88 1.41 11.65 1.7 11.65H12.48C12.71 11.65 12.95 11.83 12.95 12.12V14.05C12.95 14.17 12.89 14.29 12.83 14.34L7.03 21.02C6.86 21.2 6.92 21.49 7.09 21.67C7.15 21.78 7.21 21.84 7.33 21.84Z'
        fill='#171E25'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.6 18.27C24.6 16.22 23.37 14.81 21.61 14.81C19.86 14.81 18.68 16.28 18.68 18.27C18.68 20.26 19.91 21.78 21.61 21.78C23.31 21.78 24.6 20.32 24.6 18.27ZM28.93 18.39C28.93 22.43 26.53 25.12 22.78 25.12C21.55 25.12 20.38 24.71 19.45 23.95C19.27 23.77 18.98 23.83 18.8 24.01C18.74 24.07 18.68 24.18 18.68 24.3V24.54C18.68 24.77 18.51 25 18.22 25H14.82C14.58 25 14.35 24.83 14.35 24.54V7.08C14.35 6.85 14.53 6.61 14.82 6.61H18.22C18.45 6.61 18.68 6.79 18.68 7.08V12.29C18.68 12.53 18.86 12.76 19.15 12.76C19.27 12.76 19.39 12.7 19.45 12.65C20.38 11.88 21.5 11.47 22.67 11.47C26.42 11.47 28.93 14.23 28.93 18.39Z'
        fill='#171E25'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.73 1.69C7.26 0.01 18.33 -1.2 22.43 8.1C22.5 8.22 22.62 8.28 22.74 8.22C22.81 8.19 22.87 8.13 22.87 8.07C23.18 6.88 24.42 4.77 29.03 3.09C29.15 3.03 29.28 3.09 29.34 3.21C29.4 3.34 29.34 3.46 29.21 3.53C27.04 4.77 23.99 6.88 22.93 9.43C22.93 9.43 22.87 9.75 22.71 9.47C22.71 9.47 17.74 -0.64 0.82 2.13C0.7 2.13 0.6 2 0.6 1.88C0.6 1.82 0.66 1.75 0.73 1.69Z'
        fill='#FBDD46'
      />
    </svg>
  )
}
export function NeverBounceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 51' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.083.5C47.8.5 50 2.354 50 4.64v41.72c0 2.286-2.201 4.14-4.917 4.14H4.917C2.201 50.5 0 48.646 0 46.36V30.406c0-1.754 1.902-2.847 3.417-1.964l1.997 1.164a2.273 2.273 0 0 0 2.29-3.927l-6.576-3.832A2.273 2.273 0 0 1 0 19.885v-.465c0-1.78 1.954-2.87 3.468-1.933l20.335 12.578a2.273 2.273 0 0 0 2.398-.004l12.844-8.008a2.273 2.273 0 0 0-2.405-3.858L26.192 24.71a2.273 2.273 0 0 1-2.398.004L1.077 10.664A2.273 2.273 0 0 1 0 8.73V4.64C0 2.354 2.201.5 4.917.5h40.166Z'
        fill='currentColor'
      />
    </svg>
  )
}
export function MillionVerifierIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient = `millionverifier_${id}`
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='-37 -15 50 50' fill='none'>
      <path fill='#0C1516' d='M-35.7,8.2v22h5.8V14L-35.7,8.2z' />
      <path fill='#0C1516' d='M-12.5,15.5v14.7h5.8V9.7L-12.5,15.5z' />
      <g transform='translate(-36 -14)'>
        <linearGradient
          id={gradient}
          gradientUnits='userSpaceOnUse'
          x1='-903.2258'
          y1='565.0618'
          x2='-902.2228'
          y2='564.5618'
          gradientTransform='matrix(47.912 0 0 -32.672 43287.0039 18472.4121)'
        >
          <stop offset='0' stopColor='#20CC95' />
          <stop offset='1' stopColor='#205CCC' />
        </linearGradient>
        <path fill={`url(#${gradient})`} d='M0.3,18.7l15.2,15.2L48.2,1.3l-32.7,25L0.3,18.7z' />
      </g>
    </svg>
  )
}
export function FathomIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' fill='none'>
      <path
        d='M0,668.7v205.78c0,53.97,34.24,102.88,85.8,119.08,87.48,27.49,167.88-36.99,167.88-120.22v-77.45L0,668.7Z'
        fill='#007299'
      />
      <path
        d='M873.72,626.07c-19.05,0-38.38-4.3-56.58-13.38L72.78,241.43C11.15,210.69-17.51,136.6,11.18,74.05,41.2,8.59,119.26-18.53,183.23,13.38l744.25,371.21c62.45,31.15,91,109.08,59.79,171.43-22.22,44.38-67.02,70.05-113.55,70.05Z'
        fill='#00beff'
      />
      <path
        d='M500.09,813.66c-19.05,0-38.38-4.3-56.58-13.38l-370.72-184.9c-61.63-30.74-90.29-104.82-61.61-167.37,30.02-65.46,108.08-92.59,172.06-60.68l370.62,184.85c62.45,31.15,91,109.08,59.79,171.43-22.22,44.38-67.02,70.05-113.55,70.05Z'
        fill='#00beff'
      />
    </svg>
  )
}
export function LinkupIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 154 107' fill='none'>
      <path
        d='M150.68 72.71C146.61 70.25 137.91 69.54 124.79 70.61C128.99 57.68 133.76 35.39 121.32 25.15C115.89 20.67 107.47 19.04 97.62 20.56C94.68 21.01 91.58 21.74 88.39 22.73C78.87 8.28 66.3 0 53.86 0C39.43 0 26.13 9.34 16.41 26.29C5.68 45.01 0 71.96 0 104.23V104.53L3.6 106.94L3.88 106.83C30.58 95.56 67.58 85.07 100.59 79.4C101.6 87.64 102.12 95.99 102.12 104.24V104.52L105.49 107L105.76 106.91C106.26 106.75 155.16 90.88 153.98 77.59C153.86 76.2 153.18 74.23 150.68 72.71ZM148.41 78.09C148.72 81.54 133.24 91.06 111.84 98.89C115.97 92.1 119.82 84.17 122.78 76.36C135.66 75.14 144.53 75.55 147.79 77.53C148.38 77.88 148.41 78.09 148.41 78.09ZM116.67 77.01C114.08 83.38 110.95 89.63 107.54 95.25C107.33 89.51 106.91 83.88 106.3 78.46C109.92 77.9 113.41 77.41 116.67 77.01ZM117.77 29.5C125.38 35.76 125.78 51.32 118.87 71.18C114.75 71.63 110.28 72.24 105.6 72.98C103.05 55.17 98.28 39.97 91.42 27.75C94.57 26.82 96.97 26.35 98.46 26.11C106.72 24.84 113.58 26.04 117.77 29.5ZM53.86 5.62C65.06 5.62 74.89 12 83.09 24.59C57.7 34.54 30.32 59.41 5.78 94.8C7.43 51.48 23.03 5.62 53.86 5.62M10.19 98.24C40.75 53.93 68.2 36.44 86.07 29.59C92.45 41.24 97.2 56.55 99.84 73.93C70.52 79.03 35.64 88.5 10.19 98.24Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function JiraIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const middleGradientId = `jira_middle_${id}`
  const bottomGradientId = `jira_bottom_${id}`

  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 128 128'
      width='24'
      height='24'
      focusable='false'
      fill='none'
      aria-hidden='true'
    >
      <defs>
        <linearGradient
          id={middleGradientId}
          gradientUnits='userSpaceOnUse'
          x1='22.034'
          y1='9.773'
          x2='17.118'
          y2='14.842'
          gradientTransform='scale(4)'
        >
          <stop offset='0.176' stopColor='#0052cc' />
          <stop offset='1' stopColor='#2684ff' />
        </linearGradient>
        <linearGradient
          id={bottomGradientId}
          gradientUnits='userSpaceOnUse'
          x1='16.641'
          y1='15.564'
          x2='10.957'
          y2='21.094'
          gradientTransform='scale(4)'
        >
          <stop offset='0.176' stopColor='#0052cc' />
          <stop offset='1' stopColor='#2684ff' />
        </linearGradient>
      </defs>
      <path
        fill='#2684ff'
        d='M108.023 16H61.805c0 11.52 9.324 20.848 20.847 20.848h8.5v8.226c0 11.52 9.328 20.848 20.848 20.848V19.977A3.98 3.98 0 00108.023 16zm0 0'
      />
      <path
        fill={`url(#${middleGradientId})`}
        d='M85.121 39.04H38.902c0 11.519 9.325 20.847 20.844 20.847h8.504v8.226c0 11.52 9.328 20.848 20.848 20.848V43.016a3.983 3.983 0 00-3.977-3.977zm0 0'
      />
      <path
        fill={`url(#${bottomGradientId})`}
        d='M62.219 62.078H16c0 11.524 9.324 20.848 20.848 20.848h8.5v8.23c0 11.52 9.328 20.844 20.847 20.844V66.059a3.984 3.984 0 00-3.976-3.98zm0 0'
      />
    </svg>
  )
}

export function LinqIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 113.4 116' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <polygon
        fill='currentColor'
        points='34.3 116 39.2 114.3 97 91 105.1 63.9 41.5 90.5 15.4 27.4 8.8 55.1 34.2 116'
      />
      <path
        fill='currentColor'
        d='m18.5 24.1 25.3 60.9 60.9-25-25.4-60-60.8 24.1zm33.6-9.7 25-9.9 2.9 6.7-24.9 10.3-3-7.1zm33.7 7.6-4.2-7.3-25.1 10.4 5.8 13.9 25.3-10.1-1.8-4.5v-1.5-0.9zm-62.2 4.2 18-7.3 2.9 7.2 7.2-3 7.1 17.5-24.7 10.7-10.5-25.1zm40.3 16.6 25.2-10.5 7.5 18.1-3.6 1.4 1.4 3.7-3.6 1.4 1.5 3.5-17.9 7.2-10.5-24.8zm-28.4 11.9 14.4-5.8 1.5 3.6 3.3-1.5-1.4-3.6 6.9-3 10.6 24.7-14.2 5.8-1.5-3.6-3.6 1.5 1.4 3.6-7 3.1-10.4-24.8zm59 0.8 3.7-1.5 1.5 3.6-3.6 1.4-1.6-3.5z'
      />
    </svg>
  )
}

export function ClickUpIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const bodyGradientId = `clickup_body_${id}`
  const arrowGradientId = `clickup_arrow_${id}`
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54.8 65.8' fill='none'>
      <linearGradient
        id={bodyGradientId}
        gradientUnits='userSpaceOnUse'
        x1='0'
        y1='15.0492'
        x2='54.8446'
        y2='15.0492'
        gradientTransform='matrix(1 0 0 -1 0 69.3604)'
      >
        <stop offset='0' stopColor='#8930FD' />
        <stop offset='1' stopColor='#49CCF9' />
      </linearGradient>
      <linearGradient
        id={arrowGradientId}
        gradientUnits='userSpaceOnUse'
        x1='1.1953'
        y1='53.166'
        x2='53.7447'
        y2='53.166'
        gradientTransform='matrix(1 0 0 -1 0 69.3604)'
      >
        <stop offset='0' stopColor='#FF02F0' />
        <stop offset='1' stopColor='#FFC800' />
      </linearGradient>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill={`url(#${bodyGradientId})`}
        d='M0,50.6l10.1-7.8c5.4,7,11.1,10.3,17.4,10.3c6.3,0,11.9-3.2,17-10.2l10.3,7.6c-7.4,10-16.6,15.3-27.3,15.3C16.9,65.8,7.6,60.5,0,50.6z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill={`url(#${arrowGradientId})`}
        d='M27.5,16.9l-18,15.5l-8.3-9.7L27.6,0l26.2,22.7l-8.4,9.6L27.5,16.9z'
      />
    </svg>
  )
}

export function LinearIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      width='200'
      height='200'
      viewBox='0 0 100 100'
    >
      <path
        fill='currentColor'
        d='M1.23 61.52c-.223-.949.91-1.55 1.6-.857L39.33 97.18c.689.69.09 1.82-.857 1.6C20.05 94.45 5.55 79.95 1.23 61.52ZM.002 46.89c-.176.28.89.56.29.76L52.35 99.71c.201.2.48.31.76.29 2.37-.148 4.69-.46 6.96-.926.76-.157 1.03-1.1.48-1.65L2.58 39.45c-.552-.552-1.49-.286-1.65.48-.466 2.27-.778 4.59-.926 6.96ZM4.21 29.71c-.166.37-.817.81.21 1.1l64.78 64.78c.289.29.73.37 1.1.21 1.79-.796 3.52-1.69 5.19-2.68.55-.328.64-1.9.18-1.54L8.44 24.34c-.454-.454-1.21-.369-1.54.18-.991 1.67-1.89 3.4-2.68 5.19ZM12.66 18.07c-.37-.37-.393-.964-.044-1.35C21.78 6.46 35.11 0 49.95 0 77.59 0 100 22.41 100 50.05c0 14.84-6.46 28.17-16.72 37.34-.39.35-.984.33-1.35-.044L12.66 18.07Z'
      />
    </svg>
  )
}

export function LangsmithIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48 12C48 18.62 42.53 24 35.8 24H12.2C5.47 24 0 18.62 0 12C0 5.38 5.47 0 12.2 0H35.8C42.53 0 48 5.38 48 12ZM19.71 11.48C20.73 12.71 21.51 14.16 22.14 15.61C22.25 15.81 22.3 16.06 22.36 16.27C22.46 16.58 22.5 16.89 22.73 17.14C22.79 17.21 22.96 17.3 23.1 17.43C23.43 17.73 23.83 18.13 23.69 18.3C23.73 18.39 23.9 18.48 24.06 18.59C24.31 18.77 24.54 18.94 24.35 19.09C23.95 19.18 23.48 19.2 23.17 18.88C23.08 19.09 22.91 19.07 22.73 19.02C22.69 19.01 22.62 18.96 22.58 18.95C22.56 19 22.6 19.04 22.58 19.09C21.9 19.14 21.37 18.46 21.04 17.93C20.72 17.77 20.34 17.64 20.01 17.5C19.65 17.35 19.32 17.25 18.98 17.06C18.97 17.18 18.98 17.3 18.98 17.43C18.97 17.94 18.92 18.42 18.46 18.73C18.45 19.35 18.99 19.39 19.49 19.38C19.92 19.38 20.37 19.35 20.45 19.75C20.42 19.75 20.34 19.75 20.3 19.75L20.3 19.75C20.2 19.75 20.16 19.75 20.08 19.82C19.84 20.05 19.54 20 19.27 19.89C19.02 19.8 18.79 19.66 18.53 19.82C18.3 19.93 18.09 20.01 17.94 20.11C17.64 20.31 17.45 20.49 16.84 20.54C16.79 20.47 16.8 20.44 16.84 20.4C16.92 20.3 17.01 20.21 17.06 20.11C17.17 19.91 17.22 19.68 17.5 19.6C17.12 19.54 16.8 19.72 16.47 19.89C16.43 19.92 16.37 19.94 16.32 19.96C16.12 20.05 16.01 20.03 15.88 19.96C15.71 19.87 15.58 19.76 15.15 20.04C15.06 19.97 15.1 19.87 15.15 19.82C15.34 19.59 15.53 19.59 15.81 19.6C15.08 19.2 14.62 19.44 14.19 19.67C13.81 19.88 13.46 20.07 13.16 19.67C13.02 19.71 12.94 19.8 12.86 19.89C12.83 19.93 12.83 20 12.79 20.04C12.72 19.96 12.7 19.84 12.72 19.75C12.72 19.71 12.79 19.71 12.79 19.67C12.77 19.67 12.74 19.61 12.72 19.6C12.61 19.56 12.46 19.55 12.5 19.38C12.26 19.31 12.15 19.4 11.98 19.53C11.97 19.54 11.92 19.52 11.91 19.53C11.79 19.44 11.89 19.34 11.98 19.24C12.02 19.19 12.04 19.14 12.05 19.09C12.13 18.96 12.29 18.95 12.42 18.95C12.53 18.95 12.64 18.96 12.72 18.88C12.99 18.72 13.33 18.8 13.67 18.88C13.93 18.94 14.18 18.98 14.41 18.95C14.83 19 15.36 18.58 15.15 18.15C14.76 17.66 14.78 17.08 14.78 16.48C14.78 16.38 14.78 16.29 14.78 16.19C14.75 15.97 14.44 15.66 14.12 15.4C13.87 15.2 13.57 15 13.45 14.82C13.12 14.44 12.9 14.01 12.64 13.58C12.63 13.57 12.58 13.6 12.57 13.58C12.13 12.74 12.01 11.78 11.83 10.83C11.62 9.69 11.4 8.58 10.73 7.64C10.17 7.94 9.44 7.75 8.96 7.35C8.71 7.57 8.69 7.91 8.67 8.22C8.05 7.61 8.1 6.43 8.59 5.75C8.8 5.49 9.06 5.3 9.33 5.1C9.39 5.06 9.4 5.03 9.4 4.96C9.89 2.79 13.21 3.2 14.26 4.74C14.61 5.17 14.91 5.62 15.15 6.12C15.43 6.71 15.71 7.31 16.18 7.78C16.63 8.28 17.09 8.76 17.58 9.23C18.33 9.97 19.06 10.66 19.71 11.48ZM28.18 15.76C28.87 15.14 29.57 14.46 29.58 14.45C29.63 14.41 30.41 13.74 31.57 12.42L32.97 14.24C32.34 15.01 31.97 15.49 31.64 15.98C30.64 17.44 29.81 18.65 29.8 18.66C29.8 18.67 29.15 19.6 28.18 19.6C28.03 19.6 27.9 19.58 27.74 19.53C27.2 19.36 26.81 19.08 26.63 18.66C26.4 18.12 26.56 17.57 26.63 17.43C26.91 16.9 27.5 16.37 28.18 15.76ZM39.08 17.72C39.26 17.92 39.37 18.17 39.37 18.44V18.59C39.37 18.83 39.3 19.05 39.15 19.24C38.95 19.49 38.6 19.67 38.27 19.67C38.2 19.67 38.08 19.65 38.01 19.63L37.9 19.6C37.63 19.55 37.33 19.39 37.16 19.17C36.66 18.5 35.57 17.01 34.59 15.69C34.17 15.12 33.8 14.59 33.48 14.16C33.37 14.01 33.21 13.85 33.11 13.73C32.91 13.45 32.14 12.47 31.94 12.21C30.84 10.8 30.1 9.97 30.1 9.96C30.01 9.85 29.74 9.63 29.51 9.6C29.14 9.61 28.71 9.39 28.7 9.38C28.54 9.3 28.39 9.23 28.33 9.23C28.2 9.31 28.18 9.36 28.18 9.52C28.18 9.54 28.18 9.58 28.18 9.6C28.18 9.64 28.18 9.62 28.18 9.67C28.17 9.91 27.98 10.09 27.96 10.1C27.96 10.1 27.71 10.35 27.37 10.61C26.96 10.92 26.65 10.69 26.63 10.68C26.61 10.66 26.1 10.22 25.82 9.89C25.55 9.56 25.47 9.45 25.16 9.02C24.8 8.52 25.08 8.16 25.09 8.15L25.68 7.64L25.68 7.64C25.77 7.57 26.18 7.25 26.41 7.42C26.61 7.56 26.85 7.43 26.86 7.42C26.86 7.42 26.97 7.33 26.93 7.06C26.86 6.65 27.14 6.35 27.15 6.33C27.16 6.33 27.95 5.68 28.92 4.88C30.39 3.93 32.22 4.3 32.94 4.44L32.97 4.45C33.48 4.55 34.03 4.79 34 5.03C33.99 5.08 33.99 5.26 33.78 5.25C32.14 5.18 31.04 5.94 30.76 6.19C30.74 6.2 30.76 6.24 30.76 6.26V6.33C30.76 6.35 30.75 6.39 30.76 6.41L31.13 7.28C31.21 7.49 31.27 7.7 31.27 7.93V8.51L31.42 8.87C31.54 9.02 32.94 10.85 34.22 12.28C35.24 13.42 37.91 16.36 38.93 17.5L39.08 17.72ZM40.04 6.26L40.26 6.48C40.34 6.56 40.36 6.73 40.33 6.84L39.96 8.29C39.94 8.36 39.43 10.02 37.9 10.39C37.35 10.53 36.98 10.53 36.72 10.54C36.3 10.55 36.2 10.57 35.69 11.12C35.59 11.23 35.44 11.36 35.32 11.48C35.13 11.68 34.96 11.88 34.73 12.13L33.19 10.39C33.23 10.34 33.3 10.29 33.34 10.25C33.41 10.17 33.46 10.08 33.56 9.96C33.84 9.59 34.04 9.35 34.15 9.16C34.23 9.01 34.23 8.83 34.22 8.65L34.22 8.64C34.19 8.2 34.15 7.4 34.22 6.91C34.32 6.25 34.89 5.53 35.69 5.1C36.26 4.8 37.06 4.5 37.38 4.38L37.39 4.38C37.51 4.33 37.67 4.42 37.75 4.52L37.9 4.67C38 4.79 38 4.91 37.9 5.03L36.58 6.62C36.54 6.67 36.5 6.71 36.5 6.77V7.13C36.5 7.2 36.53 7.31 36.58 7.35L37.39 8C37.43 8.04 37.47 8.01 37.53 8H38.05C38.11 8 38.16 7.97 38.2 7.93L39.52 6.33C39.58 6.27 39.65 6.19 39.74 6.19C39.83 6.18 39.97 6.2 40.04 6.26Z'
        fill='currentColor'
      />
      <path
        d='M15.66 18.59C15.59 18.95 15.88 19.14 16.18 19.02C16.47 18.89 16.67 19.07 16.77 19.31C17.22 19.38 17.85 19.19 17.87 18.66C17.33 18.35 17.14 17.83 16.91 17.28C16.9 17.25 16.86 17.17 16.84 17.14C16.81 17.05 16.73 17 16.69 16.92C16.69 16.91 16.7 16.86 16.69 16.85C16.67 16.95 16.65 17.08 16.62 17.21C16.49 17.83 16.36 18.56 15.66 18.59Z'
        fill='currentColor'
      />
      <path
        d='M28.55 18.66C28.41 18.89 28.02 18.94 27.67 18.73C27.48 18.62 27.3 18.46 27.22 18.3C27.16 18.15 27.16 18.04 27.22 17.93C27.3 17.81 27.49 17.72 27.67 17.72C27.83 17.72 28.01 17.76 28.18 17.86C28.54 18.07 28.69 18.43 28.55 18.66Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function LatexIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 500' fill='currentColor'>
      <path
        d='m5.46 4.23h-.25c-.1 1.02-.24 2.26-2 2.26h-.81c-.47 0-.49-.07-.49-.4v-5.31c0-.34 0-.48.94-.48h.33v-.3c-.36.03-1.26.03-1.67.03-.39 0-1.17 0-1.51-.03v.3h.23c.77 0 .79.11.79.47v5.25c0 .36-.02.47-.79.47h-.23v.31h5.19z'
        transform='matrix(45 0 0 45 40 47.65)'
      />
      <path
        d='m2.81.16c-.04-.12-.06-.16-.19-.16s-.16.04-.2.16l-1.61 4.08c-.07.17-.19.48-.81.48v.25h1.55v-.25c-.31 0-.5-.14-.5-.34 0-.05.01-.07.03-.14 0 0 .34-.86.34-.86h1.98l.4 1.02c.02.04.04.09.04.12 0 .2-.38.2-.57.2v.25h1.97v-.25h-.14c-.47 0-.52-.07-.59-.27 0 0-1.7-4.29-1.7-4.29zm-.4.71.89 2.26h-1.78z'
        transform='matrix(45 0 0 45 151.6 40)'
      />
      <path
        d='m6.27 0h-6.09s-.18 2.24-.18 2.24h.24c.14-1.61.29-1.94 1.8-1.94.18 0 .44 0 .54.02.21.04.21.15.21.38v5.25c0 .34 0 .48-1.05.48h-.4v.31c.41-.03 1.42-.03 1.88-.03s1.49 0 1.9.03v-.31h-.4c-1.05 0-1.05-.14-1.05-.48v-5.25c0-.2 0-.34.18-.38.11-.02.38-.02.57-.02 1.5 0 1.65.33 1.79 1.94h.25s-.19-2.24-.19-2.24z'
        transform='matrix(45 0 0 45 356.35 50.35)'
      />
      <path
        d='m6.16 4.2h-.25c-.25 1.53-.48 2.26-2.19 2.26h-1.32c-.47 0-.49-.07-.49-.4v-2.66h.89c.97 0 1.08.32 1.08 1.17h.25v-2.64h-.25c0 .85-.11 1.16-1.08 1.16h-.89v-2.39c0-.33.02-.4.49-.4h1.28c1.53 0 1.79.55 1.95 1.94h.25l-.28-2.24h-5.6v.3h.23c.77 0 .79.11.79.47v5.22c0 .36-.02.47-.79.47h-.23v.31h5.74z'
        transform='matrix(45 0 0 45 602.5 150.25)'
      />
      <path
        d='m3.76 2.95 1.37-2c.21-.32.55-.64 1.44-.65v-.3h-2.38v.3c.4.01.62.23.62.46 0 .1-.02.12-.09.23 0 0-1.14 1.68-1.14 1.68l-1.28-1.92c-.02-.03-.07-.11-.07-.15 0-.12.22-.29.64-.3v-.3c-.34.03-1.07.03-1.45.03-.31 0-.93-.01-1.3-.03v.3h.19c.55 0 .74.07.93.35 0 0 1.83 2.77 1.83 2.77l-1.63 2.41c-.14.2-.44.66-1.44.66v.31h2.38v-.31c-.46-.01-.63-.28-.63-.46 0-.09.03-.13.1-.24l1.41-2.09 1.58 2.38c.02.04.05.08.05.11 0 .12-.22.29-.65.3v.31c.35-.03 1.08-.03 1.45-.03.42 0 .88.01 1.3.03v-.31h-.19c-.52 0-.73-.05-.94-.36 0 0-2.1-3.18-2.1-3.18z'
        transform='matrix(45 0 0 45 845.95 47.65)'
      />
    </svg>
  )
}

export function LaunchDarklyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 216 214.94' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='M109.8,214.94a4.87,4.87,0,0,1-4.26-2.66,4.5,4.5,0,0,1,.44-4.82l50.49-69.53L68,174.11a4.61,4.61,0,0,1-1.9.41,4.77,4.77,0,0,1-4.52-3.4,4.57,4.57,0,0,1,2-5.21L141.33,120,4.41,112.13a4.69,4.69,0,0,1,0-9.36l137-7.87L63.61,49a4.56,4.56,0,0,1-1.94-5.2,4.74,4.74,0,0,1,4.51-3.4,4.6,4.6,0,0,1,1.9.4L156.5,77,106,7.48a4.56,4.56,0,0,1-.44-4.83A4.84,4.84,0,0,1,109.84,0a4.59,4.59,0,0,1,3.28,1.41L213.77,102.05a7.65,7.65,0,0,1,0,10.8L113.08,213.53A4.59,4.59,0,0,1,109.8,214.94Z'
      />
    </svg>
  )
}

export function LemlistIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='24 24.92 132 132' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32.05 0.92H147.95C165.65 0.92 180 15.27 180 32.97V148.87C180 166.57 165.65 180.92 147.95 180.92H32.05C14.35 180.92 0 166.57 0 148.87V32.97C0 15.27 14.35 0.92 32.05 0.92ZM119.56 82.89H85.08C82.47 82.89 80.36 85 80.36 87.61V94.23C80.36 96.84 82.47 98.96 85.08 98.96H119.56C122.17 98.96 124.29 96.84 124.29 94.23V87.61C124.29 85 122.17 82.89 119.56 82.89ZM85.08 49.13H127.06C129.67 49.13 131.79 51.25 131.79 53.86V60.48C131.79 63.09 129.67 65.21 127.06 65.21H85.08C82.47 65.21 80.36 63.09 80.36 60.48V53.86C80.36 51.25 82.47 49.13 85.08 49.13ZM131.79 127.98V121.36C131.79 118.75 129.67 116.63 127.06 116.63H76.57C69.78 116.63 64.29 111.14 64.29 104.35V53.86C64.29 51.25 62.17 49.13 59.56 49.13H52.94C50.33 49.13 48.21 51.25 48.21 53.86V114.2C48.85 124.13 56.79 132.07 66.72 132.71H127.06C129.67 132.71 131.79 130.59 131.79 127.98Z'
        fill='#316BFF'
      />
      <path
        d='M85.08 49.13H127.06C129.67 49.13 131.79 51.25 131.79 53.86V60.48C131.79 63.09 129.67 65.21 127.06 65.21H85.08C82.47 65.21 80.36 63.09 80.36 60.48V53.86C80.36 51.25 82.47 49.13 85.08 49.13Z'
        fill='white'
      />
      <path
        d='M85.08 82.89H119.56C122.17 82.89 124.29 85 124.29 87.61V94.23C124.29 96.84 122.17 98.96 119.56 98.96H85.08C82.47 98.96 80.36 96.84 80.36 94.23V87.61C80.36 85 82.47 82.89 85.08 82.89Z'
        fill='white'
      />
      <path
        d='M131.79 121.36V127.98C131.79 130.59 129.67 132.71 127.06 132.71H66.72C56.79 132.07 48.85 124.13 48.21 114.2V53.86C48.21 51.25 50.33 49.13 52.94 49.13H59.56C62.17 49.13 64.29 51.25 64.29 53.86V104.35C64.29 111.14 69.78 116.63 76.57 116.63H127.06C129.67 116.63 131.79 118.75 131.79 121.36Z'
        fill='white'
      />
    </svg>
  )
}

/**
 * The four brand fills are hardcoded rather than `currentColor`: this is a
 * multi-color mark, so it stays legible on the white tile and bare on a neutral
 * page in both themes. No `iconColor` is set for the same reason — there is no
 * single brand tint to adopt.
 *
 * The source SVG carried its fills through `.st0`–`.st3` CSS classes; those are
 * inlined here so the mark cannot depend on (or leak) global styles.
 */
export function ManageEngineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 120.2 118.8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#FFCD22'
        d='M83.1,3.9c46.2,32.2,27,106.8-22.5,114.9l0,0C124.1,118.8,144.8,32.7,83.1,3.9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#0078B6'
        d='M33.9,3.4c55.2-8.1,77.8,60,53.6,91.5C127.5,54.7,95.5-16.4,33.9,3.4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#009A50'
        d='M1.3,36.7C28.5-3.6,85,21.3,90.7,62C97.2,11.7,30.8-16.2,1.3,36.7'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#CA2031'
        d='M0,66.8C6.6,25,61,20.6,80.6,49.9C64.6,8.3,1.1,13.4,0,66.8'
      />
    </svg>
  )
}

export function TelegramIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='1 1 22 22'
      width='24'
      height='24'
      fill='none'
    >
      <circle cx='12' cy='12' r='10' fill='#0088CC' />
      <path
        d='M16.7 8.4c.1-.6-.4-1.1-1-.8l-9.8 4.3c-.4.2-.4.8.1.9l2.1.7c.4.1.8.1 1.1-.2l4.5-3.1c.1-.1.3.1.2.2l-3.2 3.5c-.3.3-.2.8.2 1l3.6 2.3c.4.2.9-.1 1-.5l1.2-7.8Z'
        fill='white'
      />
    </svg>
  )
}

const TINYFISH_ICON_PNG_DATA_URI =
  'data:image/png;base64,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'

/**
 * TinyFish's goldfish mark.
 *
 * TinyFish ships this mark only as a raster asset, so the official 256x256 PNG is embedded
 * verbatim inside an SVG wrapper to keep the shared `SVGProps<SVGSVGElement>` icon API. The
 * wrapper's viewBox matches the artwork exactly.
 *
 * @see https://www.tinyfish.ai/favicon-for-app/icon0.svg
 */
export function TinyFishIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 256 256'
      width='24'
      height='24'
      fill='none'
    >
      <image href={TINYFISH_ICON_PNG_DATA_URI} x='0' y='0' width='256' height='256' />
    </svg>
  )
}

export function TinybirdIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'>
      <rect x='0' y='0' width='24' height='24' fill='#2EF598' rx='6' />
      <g transform='translate(2, 2) scale(0.83)'>
        <path d='M25 2.64 17.2.5 14.45 6.64z' fill='#1E7F63' />
        <path d='M17.54 17.77 10.39 15.22 6.2 25.5z' fill='#1E7F63' />
        <path d='M0 11.5 17.54 17.77 20.41 4.36z' fill='#1F2437' />
      </g>
    </svg>
  )
}

export function ThriveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 27.583 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.76 0C21.85 0 23.39 0 24.57 0.59C25.61 1.11 26.45 1.93 26.98 2.95C27.58 4.1 27.58 5.62 27.58 8.64V18.36C27.58 21.38 27.58 22.9 26.98 24.05C26.45 25.07 25.61 25.89 24.57 26.41C23.39 27 21.85 27 18.76 27H8.83C5.74 27 4.19 27 3.01 26.41C1.97 25.89 1.13 25.07 0.6 24.05C0 22.9 0 21.38 0 18.36V8.64C0 5.62 0 4.1 0.6 2.95C1.13 1.93 1.97 1.11 3.01 0.59C4.19 0 5.74 0 8.83 0H18.76ZM7.17 7.29C7.17 8.04 7.79 8.64 8.55 8.64H11.58V20.25C11.58 21 12.2 21.6 12.96 21.6H16V11.34C16 9.85 14.76 8.64 13.24 8.64H20.41V6.75C20.41 6.01 19.79 5.4 19.03 5.4H7.17V7.29Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ClayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 400 400'>
      <path
        xmlns='http://www.w3.org/2000/svg'
        fill='#41B9FD'
        d=' M225,1   C227.04,1 229.08,1 231.9,1.24   
      C233.98,1.65 235.28,1.97 236.59,1.97   C276.43,1.99 316.27,1.96 356.35,2.04   
      C356.71,2.24 356.84,2.36 357.01,2.7   C357.36,3.24 357.66,3.57 358.03,3.92   
      C358.1,3.94 358.06,4.09 358.04,4.4   C358.3,5.45 358.58,6.2 358.92,7.42   
      C358.92,27.88 358.86,47.87 358.41,67.91   C355.2,68.11 352.38,68.38 349.56,68.39  
       C311.43,68.41 273.31,68.3 235.18,68.5   C229.32,68.52 223.47,69.89 217.28,70.63   
       C216.31,70.74 215.66,70.85 214.72,70.82   C211.83,71.35 209.24,72.01 206.38,72.68   
       C205.74,72.78 205.39,72.87 204.74,72.83   C198.87,74.72 193.29,76.73 187.52,78.78   
       C187.33,78.8 187,78.98 186.62,78.96   C183.34,80.4 180.44,81.86 177.45,83.36   
       C177.35,83.39 177.2,83.53 176.86,83.48   C174.94,84.54 173.35,85.66 171.49,86.87   
       C170.87,87.15 170.53,87.34 169.9,87.48   C169.07,87.95 168.52,88.47 167.77,89.06   
       C167.56,89.13 167.18,89.37 166.87,89.34   C166.04,89.87 165.5,90.43 164.77,91.07   
       C164.57,91.16 164.2,91.41 163.89,91.36   C162.85,91.96 162.12,92.61 161.33,93.27   
       C161.27,93.28 161.21,93.38 160.87,93.37   C158.69,94.91 156.86,96.46 154.78,98.18   
       C154.1,98.73 153.66,99.12 153.03,99.56   C152.56,99.79 152.51,100.03 152.41,100.48   
       C151.75,101.07 151.33,101.49 150.67,101.98   C150.24,102.33 150.07,102.62 149.7,103.03  
        C149.25,103.34 149.04,103.58 148.63,103.92   C148.19,104.28 148.01,104.57 147.66,104.97   
        C147.49,105.07 147.19,105.35 146.85,105.35   C145.51,106.65 144.49,107.94 143.33,109.4   
        C143.18,109.55 142.94,109.92 142.69,109.99   C142.26,110.36 142.09,110.65 141.67,111.13  
        C140.73,112.11 140.05,112.9 139.06,113.71   C138.27,114.55 137.78,115.37 137.26,116.21  
        C137.23,116.23 137.22,116.31 136.91,116.42   C134.92,118.57 133.07,120.51 131.58,122.69   
        C117.24,143.73 109.91,167.06 108.8,192.46   C106.87,236.39 120.18,274.07 154.21,303.2   
        C157.54,306.05 161.52,308.15 165.4,310.72   C165.58,310.83 166,310.99 166.11,311.31   
        C169.42,313.48 172.62,315.34 176.07,317.44   C196.15,328.75 217.59,333.05 240.14,332.97   
        C276.61,332.84 313.08,332.91 349.55,332.93   C352.37,332.93 355.19,333.18 358.04,333.76   
        C358.11,352.5 358.14,370.81 358.17,389.12   C358.18,398.05 357.16,399.08 348.1,399.08   
        C309.49,399.09 270.88,399.09 232.26,399.03   C229.12,399.03 225.98,398.45 222.83,398.4   
        C219.88,398.34 216.92,398.62 213.66,398.75   C212.95,398.67 212.54,398.6 211.93,398.25  
         C205.14,396.92 198.56,395.87 191.66,394.79   C190.96,394.59 190.57,394.44 189.98,394.04   
         C188.75,393.63 187.73,393.46 186.52,393.27   C186.33,393.25 185.97,393.13 185.71,392.88   
         C179.82,390.9 174.18,389.18 168.38,387.42   C168.21,387.39 167.92,387.22 167.71,386.94   
         C163.18,384.93 158.85,383.2 154.35,381.44   C154.19,381.4 153.91,381.23 153.72,380.94   
         C150.96,379.51 148.39,378.36 145.86,377.11   C145.91,377 145.83,377.22 145.7,376.91   
         C143.28,375.47 141,374.35 138.55,373.15   C138.37,373.08 138.07,372.85 137.96,372.54   
         C136.49,371.59 135.12,370.96 133.84,370.23   C133.91,370.14 133.73,370.3 133.64,369.97   
         C130.26,367.56 126.97,365.48 123.68,363.37   C123.67,363.34 123.62,363.36 123.53,363.04   
         C122.53,362.22 121.63,361.72 120.55,361.14   C120.39,361.06 120.1,360.83 120.01,360.51   
         C116.85,357.86 113.79,355.54 110.45,353.09   C109.48,352.26 108.78,351.57 108.01,350.55   
         C106.57,349.18 105.21,348.15 103.62,346.95   C102.89,346.25 102.39,345.71 101.85,344.82   
         C99.23,341.97 96.63,339.47 93.83,336.81   C93.32,336.23 93.01,335.81 92.63,335.11   
         C92.24,334.65 91.94,334.46 91.47,334.12   C91.11,333.74 90.95,333.5 90.82,332.88   
         C89.43,331.13 88.07,329.71 86.75,328.26   C86.8,328.23 86.68,328.24 86.63,328   
         C86.41,327.45 86.15,327.26 85.84,327.09   C85.87,327 85.79,327.18 85.79,326.85   
         C85.09,325.78 84.39,325.03 83.75,324.19   C83.81,324.1 83.66,324.27 83.68,323.92   
         C82.69,322.49 81.69,321.4 80.7,320.27   C80.72,320.23 80.64,320.26 80.66,319.91   
         C79.35,317.82 78.01,316.09 76.63,314.34   C76.6,314.32 76.61,314.25 76.57,314.02   
         C76.38,313.47 76.15,313.27 75.85,313.13   C75.89,313.09 75.79,313.14 75.79,312.84   
         C75.41,312.14 75.04,311.73 74.65,311.3   C74.64,311.28 74.61,311.25 74.65,310.93   
         C74.04,309.8 73.39,309.01 72.85,308.1   C72.95,307.99 72.74,308.21 72.75,307.9   
         C72.25,307.03 71.73,306.47 71.12,305.73   C71.02,305.55 70.88,305.16 70.9,304.78   
         C66.2,293.81 61.43,283.22 56.75,272.6   C54.9,268.39 53.25,264.09 51.4,259.54   
         C51.23,258.82 51.16,258.41 51.28,257.68   C50.13,252.53 48.79,247.69 47.37,242.55   
         C47.25,241.85 47.21,241.44 47.35,240.7   C46.85,237.2 46.19,234.02 45.44,230.55   
         C45.31,229.85 45.27,229.44 45.4,228.68   C45.65,226.68 45.81,225.03 45.78,223.39   
         C45.54,210 45.24,196.61 45.02,183.22   C44.97,179.8 45.12,176.38 45.18,172.66   
         C45.26,171.95 45.33,171.54 45.69,170.94   C46.38,167.16 46.78,163.56 47.2,159.66   
         C47.33,158.95 47.44,158.56 47.82,157.95   C48.41,156.82 48.8,155.91 49.04,154.97   
         C53.32,137.56 58.71,120.56 67.08,104.61   C68.43,102.03 69.44,99.27 70.7,96.33   
         C70.96,95.76 71.14,95.44 71.63,95.02   C72.88,93.19 73.82,91.45 74.83,89.54   
         C74.9,89.37 75.12,89.06 75.41,88.95   C76.06,88.12 76.4,87.41 76.81,86.52   
         C76.88,86.35 77.1,86.05 77.43,85.97   C78.77,84.2 79.79,82.52 80.91,80.89   
         C81,80.94 80.81,80.85 81.11,80.72   C81.9,79.68 82.39,78.76 82.98,77.65   
         C83.26,77.19 83.47,76.98 83.97,76.7   C84.38,76.26 84.54,75.94 84.78,75.47   
         C84.86,75.31 85.09,75.06 85.39,74.96   C86.07,74.17 86.46,73.49 86.96,72.55   
         C87.57,71.76 88.08,71.23 88.92,70.61   C90.44,68.93 91.62,67.34 92.89,65.58   
         C92.98,65.41 93.22,65.11 93.54,65.04   C94.93,63.67 95.99,62.38 97.04,61.05   
         C97.01,61.02 97.09,61.06 97.42,61   C100.39,58.14 103.02,55.34 105.84,52.29   
         C107.27,50.97 108.53,49.9 110.12,48.82   C111.32,47.9 112.19,46.99 113.03,46.04   
         C113,46 113.07,46.06 113.42,46.04   C115.38,44.56 116.99,43.1 118.62,41.6   
         C118.63,41.57 118.71,41.57 118.94,41.53   C119.5,41.35 119.69,41.1 119.88,40.86   
         C120,40.97 119.75,40.75 120.09,40.7   C121.55,39.66 122.69,38.68 123.97,37.54   
         C124.35,37.18 124.61,37.03 125.25,36.93   C127.11,35.72 128.61,34.5 130.28,33.16   
         C130.46,33.04 130.85,32.89 131.19,32.88   C132.72,31.98 133.91,31.09 135.24,30.07   
         C135.39,29.95 135.74,29.79 136.12,29.8   C144.04,25.67 151.6,21.53 159.44,17.27   
         C160.34,16.93 160.94,16.72 161.93,16.61   C166.28,15.02 170.24,13.33 174.48,11.5   
         C175.18,11.27 175.59,11.17 176.28,11.23   C181.05,9.93 185.53,8.48 190.28,6.94   
         C190.93,6.8 191.3,6.73 192.11,6.76   C200.66,5.63 208.8,4.49 216.9,3.16   
         C219.65,2.7 222.3,1.73 225,1  z'
      />
      <path
        xmlns='http://www.w3.org/2000/svg'
        fill='#CF207F'
        d=' M139.36,113.68   C140.05,112.9 140.73,112.11 141.94,111.07   
      C142.61,110.53 142.78,110.22 142.94,109.92   C142.94,109.92 143.18,109.55 143.64,109.34   
      C145.12,107.87 146.15,106.61 147.19,105.35   C147.19,105.35 147.49,105.07 147.93,104.92   
      C148.54,104.46 148.71,104.16 148.88,103.86   C149.04,103.58 149.25,103.34 149.97,103.1   
      C150.64,103.06 150.82,103.06 151.05,103.13   C151.08,103.2 151.3,103.19 151.3,103.19   
      C151.3,103.19 151.07,103.01 151.06,102.73   C151.01,102.28 150.96,102.1 150.92,101.92   
      C151.33,101.49 151.75,101.07 152.64,100.46   C153.11,100.28 153.5,100.05 153.79,100.04   
      C154.77,99.45 155.46,98.88 156.41,98.12   C157.49,97.32 158.32,96.71 159.41,96.02   
      C160.09,95.61 160.51,95.28 161.01,94.69   C161.13,94.08 161.17,93.73 161.21,93.38   
      C161.21,93.38 161.27,93.28 161.64,93.28   C162.73,92.66 163.46,92.03 164.2,91.41   
      C164.2,91.41 164.57,91.16 165.07,91.08   C166.12,90.46 166.65,89.91 167.18,89.37   
      C167.18,89.37 167.56,89.13 168.07,89.08   C169.11,88.53 169.65,88.03 170.19,87.53   
      C170.53,87.34 170.87,87.15 171.84,86.91   C174.04,85.75 175.62,84.64 177.2,83.53   
      C177.2,83.53 177.35,83.39 177.8,83.39   C179.82,82.88 181.39,82.38 183.17,81.81   
      C183.63,81.6 183.86,81.42 184.37,81.12   C185.49,80.7 186.29,80.37 187.36,79.99   
      C188.1,79.7 188.57,79.44 189.28,79.14   C189.69,79.05 189.85,79.02 190.21,78.9   
      C190.65,78.69 190.87,78.52 191.37,78.24   C192.11,78.07 192.53,77.97 193.24,77.85   
      C194.05,77.59 194.56,77.34 195.4,77.02   C196.82,76.61 197.91,76.27 199.27,75.91   
      C200.04,75.66 200.53,75.42 201.36,75.11   C202.83,74.69 203.95,74.36 205.38,74.02   
      C206.47,73.77 207.25,73.52 208.39,73.23   C209.49,73.09 210.23,73 211.29,72.94   
      C212.41,72.68 213.21,72.41 214.27,72.1   C214.71,72.04 214.88,72.01 215.42,72   
      C217.2,71.73 218.61,71.46 220.41,71.15   C221.88,71.07 222.95,71.01 224.28,71.17   
      C226.07,70.99 227.59,70.6 229.42,70.2   C230.14,70.17 230.55,70.15 231.31,70.33   
      C235.12,70.38 238.57,70.24 242.49,70.09   C280.95,70.1 318.95,70.12 357.05,70.53   
      C357.46,73.05 357.99,75.17 358,77.3   C358.07,93.94 358.04,110.59 358.03,127.23   
      C358.03,134.05 358.02,134.06 351.1,134.06   C310.82,134.07 270.53,133.93 230.25,134.27   
      C225.25,134.31 220.26,136.84 215.23,138.28   C215.2,138.35 215.07,138.31 214.81,138.29   
      C214.12,138.51 213.68,138.74 213.01,139.12   C212.58,139.28 212.4,139.3 211.83,139.28   
      C208.41,140.91 205.36,142.6 202.28,144.31   C202.24,144.34 202.17,144.27 201.97,144.35   
      C201.53,144.57 201.36,144.78 201.06,145.32   C200.65,145.71 200.46,145.84 199.95,145.98   
      C197.42,147.95 195.21,149.92 192.99,151.94   C192.99,151.99 192.9,151.99 192.55,152.02   
      C187.41,154.77 184.24,158.68 183.25,164.11   C183.19,163.99 183.29,164.24 182.95,164.35   
      C180.43,169.37 177.15,174.1 176.31,179.24   C174.78,188.51 174.32,198.01 174.12,207.44   
      C173.84,219.94 178.27,231.2 184.9,241.6   C185.8,243.01 187.57,243.85 188.99,244.97   
      C189.05,244.98 189.03,245.09 189.04,245.44   C189.76,247.07 190.23,248.59 191.23,249.58   
      C202.88,261.02 217.22,267.48 233.24,267.75   C272.87,268.4 312.52,268.03 352.16,267.87   
      C356.78,267.86 358.16,269.3 358.11,273.88   C357.87,292.86 357.97,311.85 357.48,330.88   
      C338.91,330.96 320.8,331.05 302.68,331.01   C276.77,330.95 250.85,330.8 224.64,330.52   
      C223.24,330.27 222.13,330.17 220.6,330.06   C219.1,329.93 218,329.81 216.71,329.55   
      C216.03,329.28 215.55,329.16 214.71,329.01   C213.89,328.91 213.42,328.85 212.66,328.61   
      C211.25,328.3 210.12,328.18 208.74,328.01   C208.33,327.94 208.17,327.91 207.94,327.64   
      C207.25,327.3 206.63,327.21 205.59,327.08   C204.1,326.88 203.02,326.72 201.8,326.45   
      C201.47,326.21 201.26,326.11 200.69,325.97   C199.21,325.51 198.09,325.12 196.75,324.58   
      C196.01,324.31 195.49,324.2 194.63,324.04   C193.85,323.89 193.41,323.79 192.84,323.54   
      C192.54,323.24 192.33,323.11 192.07,322.99   C192.03,322.97 191.97,322.92 191.73,322.72   
      C190.7,322.35 189.91,322.18 188.82,321.92   C188.32,321.77 188.12,321.71 187.81,321.53   
      C187.51,321.24 187.31,321.12 186.81,320.97   C186.34,320.85 186.16,320.81 185.82,320.62   
      C185.45,320.3 185.2,320.18 184.58,320.02   C183.12,319.46 182.02,319 180.81,318.45   
      C180.57,318.23 180.41,318.13 179.91,317.9   C178.71,317.36 177.82,316.97 176.81,316.47   
      C176.5,316.21 176.29,316.09 175.77,315.86   C174.3,315.08 173.13,314.44 171.83,313.64   
      C171.53,313.3 171.32,313.15 170.8,312.94   C170.33,312.78 170.15,312.72 169.84,312.53   
      C169.54,312.24 169.35,312.11 168.84,311.85   C167.69,311.46 166.85,311.23 166,310.99   
      C166,310.99 165.58,310.83 165.34,310.39   C163.55,308.48 162.13,306.84 160.43,305.58   
      C135.45,286.99 120.42,262.05 113.76,231.92   C110.15,215.56 109.79,198.97 111.78,182.34   
      C113.83,165.22 118.6,148.94 127.16,133.89   C130.5,128.02 133.87,122.17 137.22,116.31   
      C137.22,116.31 137.23,116.23 137.54,116.21   C138.21,116.11 138.57,116.01 139.06,115.85   
      C139.43,115.55 139.47,115.28 139.37,114.76   C139.5,114.25 139.48,113.96 139.36,113.68  z'
      />
      <path
        xmlns='http://www.w3.org/2000/svg'
        fill='#FFC947'
        d=' M200.27,145.97   C200.46,145.84 200.65,145.71 201.27,145.28   
      C201.99,144.83 202.15,144.59 202.17,144.27   C202.17,144.27 202.24,144.34 202.63,144.27   
      C206.08,142.58 209.15,140.96 212.22,139.33   C212.4,139.3 212.58,139.28 213.26,139.13   
      C214.19,138.78 214.63,138.54 215.07,138.31   C215.07,138.31 215.2,138.35 215.62,138.26   
      C222.24,137.12 228.44,135.18 234.65,135.14   C276.03,134.89 317.42,135.04 358.81,135.06   
      C358.82,178.41 358.83,221.76 358.35,265.62   C317.22,266.13 276.59,266.23 235.96,266.05   
      C230.53,266.03 225.03,265.02 219.71,263.81   C207.45,261.02 197.83,253.68 189.03,245.09   
      C189.03,245.09 189.05,244.98 188.93,244.64   C178.65,231.03 175.02,215.78 175.03,199.39   
      C175.03,187.01 178.39,175.45 183.29,164.24   C183.29,164.24 183.19,163.99 183.54,163.96   
      C186.89,159.95 189.89,155.97 192.9,151.99   C192.9,151.99 192.99,151.99 193.31,151.84   
      C195.84,149.79 198.05,147.88 200.27,145.97  z'
      />
    </svg>
  )
}

export function ClerkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 128 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='64' cy='64' r='20' fill='currentColor' />
      <path
        d='M99.57 10.79C101.57 12.13 101.74 14.94 100.04 16.65L85.42 31.26C84.1 32.58 82.05 32.79 80.39 31.94C75.48 29.42 69.9 28 64 28C44.12 28 28 44.12 28 64C28 69.9 29.42 75.48 31.94 80.39C32.79 82.05 32.58 84.1 31.26 85.42L16.65 100.04C14.94 101.74 12.13 101.57 10.79 99.57C3.97 89.4 0 77.16 0 64C0 28.65 28.65 0 64 0C77.16 0 89.4 3.97 99.57 10.79Z'
        fill='currentColor'
        fillOpacity='0.4'
      />
      <path
        d='M100.04 111.35C101.74 113.06 101.57 115.87 99.57 117.21C89.4 124.03 77.16 128 64 128C50.84 128 38.6 124.03 28.43 117.21C26.43 115.87 26.26 113.06 27.96 111.35L42.58 96.74C43.9 95.42 45.95 95.21 47.61 96.06C52.52 98.58 58.1 100 64 100C69.9 100 75.48 98.58 80.39 96.06C82.05 95.21 84.1 95.42 85.42 96.74L100.04 111.35Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ClickHouseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 150 150' xmlns='http://www.w3.org/2000/svg'>
      <path d='m0 0h150v150h-150z' fill='#f9ff69' />
      <path
        d='m30 28.3c0-.6.5-1.1 1.1-1.1h8.4c.6 0 1.1.5 1.1 1.1v93.3c0 .6-.5 1.1-1.1 1.1h-8.4c-.6 0-1.1-.5-1.1-1.1zm21.2 0c0-.6.5-1.1 1.1-1.1h8.4c.6 0 1.1.5 1.1 1.1v93.3c0 .6-.5 1.1-1.1 1.1h-8.4c-.6 0-1.1-.5-1.1-1.1zm21.2 0c0-.6.5-1.1 1.1-1.1h8.4c.6 0 1.1.5 1.1 1.1v93.3c0 .6-.5 1.1-1.1 1.1h-8.4c-.6 0-1.1-.5-1.1-1.1zm21.3 0c0-.6.5-1.1 1.1-1.1h8.4c.6 0 1.1.5 1.1 1.1v93.3c0 .6-.5 1.1-1.1 1.1h-8.4c-.6 0-1.1-.5-1.1-1.1zm21.2 37.2c0-.6.5-1.1 1.1-1.1h8.4c.6 0 1.1.5 1.1 1.1v19c0 .6-.5 1.1-1.1 1.1h-8.4c-.6 0-1.1-.5-1.1-1.1z'
        fill='#161616'
      />
    </svg>
  )
}

export function MicrosoftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 109 109' {...props}>
      <polygon fill='#F1511B' points='51.9,51.9 0,51.9 0,0 51.9,0' />
      <polygon fill='#80CC28' points='109.3,51.9 57.3,51.9 57.3,0 109.3,0' />
      <polygon fill='#00ADEF' points='51.9,109.3 0,109.3 0,57.4 51.9,57.4' />
      <polygon fill='#FBBC09' points='109.3,109.3 57.3,109.3 57.3,57.4 109.3,57.4' />
    </svg>
  )
}

export function MicrosoftCopilotIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gid = (name: string) => `mscopilot_${name}_${id}`

  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 23.3 512.1 465.4' {...props}>
      <radialGradient
        id={gid('a')}
        cx='-79.674'
        cy='645.551'
        r='11.637'
        gradientTransform='matrix(-10.9605 -13.3892 -12.5901 10.3064 7673.291 -7504.614)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='.096' stopColor='#00aeff' />
        <stop offset='.773' stopColor='#2253ce' />
        <stop offset='1' stopColor='#0736c4' />
      </radialGradient>
      <path
        fill={`url(#${gid('a')})`}
        d='M374 62c-6.7-22.9-27.8-38.7-51.7-38.7h-15.7c-26 0-48.3 18.6-53 44.2l-26.9 146.8 6.7-22.9c6.7-23 27.8-38.8 51.7-38.8h91.4l38.3 14.9 36.9-14.9H441c-23.9 0-45-15.8-51.7-38.7z'
      />
      <radialGradient
        id={gid('b')}
        cx='-20.581'
        cy='641.788'
        r='11.637'
        gradientTransform='matrix(9.8803 12.5737 12.1968 -9.5842 -7518.271 6768.395)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#ffb657' />
        <stop offset='.634' stopColor='#ff5f3d' />
        <stop offset='.923' stopColor='#c02b3c' />
      </radialGradient>
      <path
        fill={`url(#${gid('b')})`}
        d='M143.5 449.8c6.7 23 27.8 38.9 51.8 38.9h33.4c29.2 0 53.1-23.3 53.9-52.5l3.6-141.5-7.6 26c-6.7 23-27.8 38.7-51.7 38.7h-92.2l-32.9-17.8-35.6 17.8h10.6c24 0 45.1 15.9 51.8 38.9z'
      />
      <linearGradient
        id={gid('c')}
        x1='151.476'
        x2='178.106'
        y1='452.543'
        y2='144.451'
        gradientTransform='matrix(1 0 0 -1 0 514)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='.156' stopColor='#0d91e1' />
        <stop offset='.487' stopColor='#52b471' />
        <stop offset='.652' stopColor='#98bd42' />
        <stop offset='.937' stopColor='#ffc800' />
      </linearGradient>
      <path
        fill={`url(#${gid('c')})`}
        d='M320 23.3H133.4C80 23.3 48 93.7 26.7 164.2 1.4 247.7-31.6 359.4 64 359.4h80.6c24.1 0 45.2-15.9 51.8-39.1 14-49 38.6-134.5 57.9-199.6 9.8-33.1 18-61.5 30.5-79.2 7.1-9.9 18.8-18.2 35.2-18.2'
      />
      <linearGradient
        id={gid('d')}
        x1='154.129'
        x2='168.669'
        y1='491.116'
        y2='155.012'
        gradientTransform='matrix(1 0 0 -1 0 514)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#3dcbff' />
        <stop offset='.247' stopColor='#0588f7' stopOpacity='0' />
      </linearGradient>
      <path
        fill={`url(#${gid('d')})`}
        d='M320 23.3H133.4C80 23.3 48 93.7 26.7 164.2 1.4 247.7-31.6 359.4 64 359.4h80.6c24.1 0 45.2-15.9 51.8-39.1 14-49 38.6-134.5 57.9-199.6 9.8-33.1 18-61.5 30.5-79.2 7.1-9.9 18.8-18.2 35.2-18.2'
      />
      <radialGradient
        id={gid('e')}
        cx='-46.943'
        cy='664.318'
        r='11.637'
        gradientTransform='matrix(-12.6711 36.2357 43.4092 15.1796 -28974.764 -8263.428)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='.066' stopColor='#8c48ff' />
        <stop offset='.5' stopColor='#f2598a' />
        <stop offset='.896' stopColor='#ffb152' />
      </radialGradient>
      <path
        fill={`url(#${gid('e')})`}
        d='M192 488.7h186.7c53.3 0 85.3-70.5 106.7-141 25.3-83.5 58.3-195.2-37.3-195.2h-80.6c-24.1 0-45.2 15.9-51.8 39.1-14 49-38.6 134.6-57.9 199.7-9.8 33.1-18 61.5-30.5 79.2-7.2 9.9-18.9 18.2-35.3 18.2'
      />
      <linearGradient
        id={gid('f')}
        x1='352.459'
        x2='352.268'
        y1='382.231'
        y2='290.663'
        gradientTransform='matrix(1 0 0 -1 0 514)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='.058' stopColor='#f8adfa' />
        <stop offset='.708' stopColor='#a86edd' stopOpacity='0' />
      </linearGradient>
      <path
        fill={`url(#${gid('f')})`}
        d='M192 488.7h186.7c53.3 0 85.3-70.5 106.7-141 25.3-83.5 58.3-195.2-37.3-195.2h-80.6c-24.1 0-45.2 15.9-51.8 39.1-14 49-38.6 134.6-57.9 199.7-9.8 33.1-18 61.5-30.5 79.2-7.2 9.9-18.9 18.2-35.3 18.2'
      />
    </svg>
  )
}

export function MicrosoftTeamsIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `msteams_gradient_${id}`

  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2228.83 2073.33'>
      <path
        fill='#5059C9'
        d='M1554.64,777.5h575.71c54.39,0,98.48,44.09,98.48,98.48c0,0,0,0,0,0v524.4 c0,199.9-162.05,361.95-361.95,361.95h0h-1.71c-199.9,0.03-361.97-162-362-361.9c0-0.02,0-0.03,0-0.05V828.97 C1503.17,800.54,1526.21,777.5,1554.64,777.5L1554.64,777.5z'
      />
      <circle fill='#5059C9' cx='1943.75' cy='440.58' r='233.25' />
      <circle fill='#7B83EB' cx='1218.08' cy='336.92' r='336.92' />
      <path
        fill='#7B83EB'
        d='M1667.32,777.5H717.01c-53.74,1.33-96.26,45.93-95.01,99.68v598.11 c-7.5,322.52,247.66,590.16,570.17,598.05c322.51-7.89,577.67-275.53,570.17-598.05V877.18 C1763.58,823.43,1721.07,778.83,1667.32,777.5z'
      />
      <path
        opacity='.1'
        d='M1244,777.5v838.15c-0.26,38.44-23.55,72.96-59.09,87.6 c-11.32,4.79-23.48,7.25-35.76,7.26H667.61c-6.74-17.1-12.96-34.21-18.14-51.83 c-18.14-59.48-27.4-121.31-27.47-183.49V877.02c-1.25-53.66,41.2-98.19,94.86-99.52H1244z'
      />
      <path
        opacity='.2'
        d='M1192.17,777.5v889.98c0,12.29-2.47,24.45-7.26,35.77 c-14.63,35.54-49.16,58.83-87.6,59.09H691.98c-8.81-17.1-17.1-34.21-24.36-51.83 c-7.26-17.62-12.96-34.21-18.14-51.83c-18.14-59.48-27.4-121.31-27.47-183.49V877.02 c-1.25-53.66,41.2-98.19,94.86-99.52H1192.17z'
      />
      <path
        opacity='.2'
        d='M1192.17,777.5v786.31c-0.39,52.22-42.63,94.46-94.85,94.86h-447.84 c-18.14-59.48-27.4-121.31-27.47-183.49V877.02c-1.25-53.66,41.2-98.19,94.86-99.52H1192.17z'
      />
      <path
        opacity='.2'
        d='M1140.33,777.5v786.31c-0.39,52.22-42.63,94.46-94.85,94.86H649.47 c-18.14-59.48-27.4-121.31-27.47-183.49V877.02c-1.25-53.66,41.2-98.19,94.86-99.52H1140.33z'
      />
      <path
        opacity='.1'
        d='M1244,509.52v163.28c-8.81,0.52-17.1,1.04-25.92,1.04 c-8.81,0-17.1-0.52-25.92-1.04c-17.5-1.16-34.85-3.94-51.83-8.29c-104.96-24.86-191.68-98.47-233.25-198 c-7.15-16.71-12.71-34.07-16.59-51.83h258.65C1201.45,414.87,1243.8,457.22,1244,509.52z'
      />
      <path
        opacity='.2'
        d='M1192.17,561.36v111.44c-17.5-1.16-34.85-3.94-51.83-8.29 c-104.96-24.86-191.68-98.47-233.25-198h190.23C1149.62,466.7,1191.97,509.05,1192.17,561.36z'
      />
      <path
        opacity='.2'
        d='M1192.17,561.36v111.44c-17.5-1.16-34.85-3.94-51.83-8.29 c-104.96-24.86-191.68-98.47-233.25-198h190.23C1149.62,466.7,1191.97,509.05,1192.17,561.36z'
      />
      <path
        opacity='.2'
        d='M1140.33,561.36v103.15c-104.96-24.86-191.68-98.47-233.25-198 h138.4C1097.78,466.7,1140.13,509.05,1140.33,561.36z'
      />
      <linearGradient
        id={gradientId}
        gradientUnits='userSpaceOnUse'
        x1='198.1'
        y1='1683.07'
        x2='942.23'
        y2='394.26'
        gradientTransform='matrix(1 0 0 -1 0 2075.33)'
      >
        <stop offset='0' stopColor='#5a62c3' />
        <stop offset='.5' stopColor='#4d55bd' />
        <stop offset='1' stopColor='#3940ab' />
        <stop offset='0' stopColor='#5a62c3' />
        <stop offset='.5' stopColor='#4d55bd' />
        <stop offset='1' stopColor='#3940ab' />
      </linearGradient>
      <path
        fill={`url(#${gradientId})`}
        d='M95.01,466.5h950.31c52.47,0,95.01,42.54,95.01,95.01v950.31c0,52.47-42.54,95.01-95.01,95.01 H95.01c-52.47,0-95.01-42.54-95.01-95.01V561.51C0,509.04,42.54,466.5,95.01,466.5z'
      />
      <path
        fill='#FFF'
        d='M820.21,828.19H630.24v517.3H509.21V828.19H320.12V727.84h500.09V828.19z'
      />
    </svg>
  )
}

export function OutlookIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient1 = `outlook_gradient1_${id}`
  const gradient2 = `outlook_gradient2_${id}`

  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      id='Livello_1'
      x='0px'
      y='0px'
      viewBox='0 0 1831.09 1703.34'
      enableBackground='new 0 0 1831.09 1703.34'
    >
      <path
        fill='#0A2767'
        d='M1831.08,894.25c0.1-14.32-7.3-27.64-19.5-35.13h-0.21l-0.77-0.43l-634.49-375.58  c-2.74-1.85-5.58-3.54-8.52-5.07c-24.5-12.64-53.6-12.64-78.1,0c-2.93,1.53-5.78,3.22-8.52,5.07L446.49,858.69  l-0.77,0.43c-19.39,12.06-25.34,37.56-13.28,56.95c3.55,5.71,8.45,10.47,14.26,13.87l634.49,375.59  c2.75,1.84,5.59,3.53,8.52,5.07c24.5,12.64,53.6,12.64,78.1,0c2.93-1.54,5.77-3.23,8.52-5.07l634.49-375.58  C1823.49,922.55,1831.23,908.92,1831.08,894.25z'
      />
      <path
        fill='#0364B8'
        d='M520.45,643.48h416.38v381.67h-416.38V643.48z M1745.92,255.5V80.91  c1-43.65-33.55-79.86-77.2-80.91H588.2C544.55,1.05,510,37.26,511,80.91V255.5l638.75,170.33L1745.92,255.5z'
      />
      <path fill='#0078D4' d='M511,255.5h425.83v383.25H511V255.5z' />
      <path
        fill='#28A8EA'
        d='M1362.67,255.5H936.83v383.25L1362.67,1022h383.25V638.75L1362.67,255.5z'
      />
      <path fill='#0078D4' d='M936.83,638.75h425.83V1022H936.83V638.75z' />
      <path fill='#0364B8' d='M936.83,1022h425.83v383.25H936.83V1022z' />
      <path fill='#14447D' d='M520.45,1025.15h416.38v346.97h-416.38V1025.15z' />
      <path fill='#0078D4' d='M1362.67,1022h383.25v383.25h-383.25V1022z' />
      <linearGradient
        id={gradient1}
        gradientUnits='userSpaceOnUse'
        x1='1128.46'
        y1='811.08'
        x2='1128.46'
        y2='2'
        gradientTransform='matrix(1 0 0 -1 0 1705.33)'
      >
        <stop offset='0' style={{ stopColor: '#35B8F1' }} />
        <stop offset='1' style={{ stopColor: '#28A8EA' }} />
      </linearGradient>
      <path
        fill={`url(#${gradient1})`}
        d='M1811.58,927.59l-0.81,0.43l-634.49,356.85c-2.77,1.7-5.58,3.32-8.52,4.77  c-10.78,5.13-22.48,8.03-34.41,8.52l-34.66-20.27c-2.93-1.47-5.77-3.1-8.52-4.9L447.17,906h-0.3  l-21.04-11.75v722.38c0.33,48.2,39.65,87.01,87.85,86.7h1230.91c0.72,0,1.36-0.34,2.13-0.34  c10.18-0.65,20.22-2.74,29.81-6.22c4.14-1.76,8.15-3.83,11.97-6.22c2.85-1.62,7.75-5.15,7.75-5.15  c21.81-16.14,34.73-41.63,34.83-68.77V894.25C1831.07,908.07,1823.62,920.81,1811.58,927.59z'
      />
      <path
        opacity='0.5'
        fill='#0A2767'
        enableBackground='new    '
        d='M1797.02,891.4v44.29l-663.45,456.79L446.7,906.3  c0-0.23-0.19-0.43-0.43-0.43l0,0l-63.02-37.9v-31.94l25.98-0.43l54.93,31.51l1.28,0.43l4.68,2.98  c0,0,645.56,368.35,647.27,369.2l24.7,14.48c2.13-0.85,4.26-1.7,6.81-2.56  c1.28-0.85,640.88-360.68,640.88-360.68L1797.02,891.4z'
      />
      <path
        fill='#1490DF'
        d='M1811.58,927.59l-0.81,0.47l-634.49,356.85c-2.77,1.7-5.58,3.32-8.52,4.77  c-24.64,12.04-53.46,12.04-78.1,0c-2.92-1.44-5.76-3.04-8.52-4.77L446.66,928.06l-0.77-0.47  c-12.25-6.64-19.93-19.41-20.06-33.34v722.38c0.31,48.19,39.62,87,87.8,86.7c0,0,0,0,0,0h1229.64  c48.19,0.31,87.5-38.51,87.81-86.7c0-0.001,0-0.002,0-0.004V894.25C1831.07,908.07,1823.62,920.81,1811.58,927.59z'
      />
      <path
        opacity='0.1'
        enableBackground='new    '
        d='M1185.52,1279.63l-9.5,5.32c-2.75,1.75-5.59,3.36-8.52,4.81  c-10.46,5.14-21.84,8.15-33.47,8.86l241.41,285.48l421.11,101.48c11.54-8.72,20.72-20.18,26.7-33.34L1185.52,1279.63  z'
      />
      <path
        opacity='0.05'
        enableBackground='new    '
        d='M1228.53,1255.44l-52.5,29.51c-2.75,1.75-5.59,3.36-8.52,4.81  c-10.46,5.14-21.84,8.15-33.47,8.86l113.1,311.84l549.54,74.99c21.65-16.25,34.39-41.74,34.41-68.81v-9.33  L1228.53,1255.44z'
      />
      <path
        fill='#28A8EA'
        d='M514.83,1703.33h1228.32c18.9,0.1,37.34-5.87,52.59-17.03l-697.09-408.33  c-2.93-1.47-5.77-3.1-8.52-4.9L447.13,906.09h-0.3l-20.99-11.84v719.91  C425.79,1663.36,465.63,1703.29,514.83,1703.33C514.83,1703.33,514.83,1703.33,514.83,1703.33z'
      />
      <path
        opacity='0.1'
        enableBackground='new    '
        d='M1022,418.72v908.3c-0.08,31.85-19.44,60.47-48.97,72.39  c-9.15,3.93-19,5.96-28.96,5.96H425.83V383.25H511v-42.58h433.07C987.09,340.83,1021.91,375.7,1022,418.72z'
      />
      <path
        opacity='0.2'
        enableBackground='new    '
        d='M979.42,461.31v908.3c0.11,10.29-2.07,20.47-6.39,29.81  c-11.83,29.15-40.08,48.27-71.54,48.42H425.83V383.25h475.66c12.36-0.12,24.53,2.96,35.34,8.94  C962.94,405.34,979.41,432.08,979.42,461.31z'
      />
      <path
        opacity='0.2'
        enableBackground='new    '
        d='M979.42,461.31v823.14c-0.21,43-34.93,77.85-77.93,78.22H425.83V383.25  h475.66c12.36-0.12,24.53,2.96,35.34,8.94C962.94,405.34,979.41,432.08,979.42,461.31z'
      />
      <path
        opacity='0.2'
        enableBackground='new    '
        d='M936.83,461.31v823.14c-0.05,43.07-34.86,78.02-77.93,78.22H425.83  V383.25h433.07c43.06,0.02,77.95,34.95,77.93,78.01C936.83,461.28,936.83,461.29,936.83,461.31z'
      />
      <linearGradient
        id={gradient2}
        gradientUnits='userSpaceOnUse'
        x1='162.75'
        y1='1383.07'
        x2='774.09'
        y2='324.26'
        gradientTransform='matrix(1 0 0 -1 0 1705.33)'
      >
        <stop offset='0' style={{ stopColor: '#1784D9' }} />
        <stop offset='0.5' style={{ stopColor: '#107AD5' }} />
        <stop offset='1' style={{ stopColor: '#0A63C9' }} />
      </linearGradient>
      <path
        fill={`url(#${gradient2})`}
        d='M78.06,383.25h780.72c43.11,0,78.06,34.95,78.06,78.06v780.72  c0,43.11-34.95,78.06-78.06,78.06H78.06c-43.11,0-78.06-34.95-78.06-78.06V461.31  C0,418.2,34.95,383.25,78.06,383.25z'
      />
      <path
        fill='#FFFFFF'
        d='M243.96,710.63c19.24-40.99,50.29-75.29,89.17-98.49c43.06-24.65,92.08-36.94,141.68-35.51  c45.97-1,91.32,10.66,131.11,33.68c37.41,22.31,67.55,55,86.74,94.11c20.9,43.09,31.32,90.51,30.41,138.4  c1.01,50.04-9.71,99.63-31.3,144.78c-19.65,40.5-50.74,74.36-89.42,97.39c-41.33,23.73-88.37,35.69-136.01,34.58  c-46.95,1.13-93.3-10.65-134.01-34.07c-37.74-22.34-68.25-55.07-87.89-94.28c-21.03-42.47-31.57-89.35-30.74-136.74  C212.81,804.86,223.16,755.69,243.96,710.63z M339.01,941.86c10.26,25.91,27.65,48.39,50.16,64.81  c22.93,16.03,50.39,24.29,78.35,23.59c29.78,1.18,59.14-7.37,83.63-24.36c22.23-16.37,39.16-38.91,48.72-64.81  c10.68-28.93,15.95-59.57,15.54-90.4c0.33-31.13-4.62-62.08-14.65-91.55c-8.85-26.61-25.25-50.07-47.18-67.54  c-23.88-17.79-53.16-26.81-82.91-25.55c-28.57-0.74-56.64,7.59-80.18,23.8c-22.89,16.5-40.62,39.17-51.1,65.36  c-23.25,60.05-23.38,126.6-0.34,186.73L339.01,941.86z'
      />
      <path fill='#50D9FF' d='M1362.67,255.5h383.25v383.25h-383.25V255.5z' />
    </svg>
  )
}

export function PagerDutyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' fill='none'>
      <path
        d='M6.7 59.22H0v-33.65c0-3.45 1.42-5.54 2.6-6.7 2.63-2.58 6.2-2.66 6.78-2.66h10.55c3.77 0 5.93 1.52 7.12 2.8 2.35 2.55 2.37 5.85 2.32 6.73v12.69c0 3.66-1.5 5.83-2.73 6.99-2.55 2.4-5.93 2.45-6.73 2.42H6.7zm13.46-18.1c.36 0 1.37-.103 1.91-.62.41-.387.62-1.08.62-2.1v-13.02c0-.36-.077-1.31-.593-1.86-.5-.516-1.44-.62-2.17-.62h-10.6c-2.63 0-2.63 1.99-2.63 2.66v15.55zM57.3 4.78H64V38.46c0 3.46-1.42 5.54-2.6 6.7-2.63 2.58-6.2 2.66-6.78 2.66H44.07c-3.76 0-5.93-1.52-7.12-2.8-2.35-2.55-2.37-5.85-2.32-6.73V25.62c0-3.66 1.5-5.83 2.73-6.99 2.55-2.4 5.93-2.45 6.73-2.42h13.2zM43.84 22.9c-.36 0-1.37.103-1.91.62-.413.39-.62 1.08-.62 2.1v13.02c0 .36.08 1.32.593 1.86.5.52 1.44.62 2.17.62h10.6c2.66-.026 2.66-2 2.66-2.68V22.9z'
        fill='currentColor'
      />
    </svg>
  )
}

export function MicrosoftExcelIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `excel_gradient_${id}`

  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      id='Livello_1'
      x='0px'
      y='0px'
      viewBox='0 0 2289.75 2130'
      enableBackground='new 0 0 2289.75 2130'
    >
      <path
        fill='#185C37'
        d='M1437.75,1011.75L532.5,852v1180.39c0,53.91,43.7,97.61,97.61,97.61l0,0h1562.04  c53.91,0,97.61-43.7,97.61-97.61l0,0V1597.5L1437.75,1011.75z'
      />
      <path
        fill='#21A366'
        d='M1437.75,0H630.11C576.2,0,532.5,43.7,532.5,97.61c0,0,0,0,0,0V532.5l905.25,532.5L1917,1224.75  L2289.75,1065V532.5L1437.75,0z'
      />
      <path fill='#107C41' d='M532.5,532.5h905.25V1065H532.5V532.5z' />
      <path
        opacity='0.1'
        enableBackground='new'
        d='M1180.39,426H532.5v1331.25h647.89c53.83-0.17,97.43-43.77,97.61-97.61  V523.61C1277.83,469.77,1234.23,426.18,1180.39,426z'
      />
      <path
        opacity='0.2'
        enableBackground='new'
        d='M1127.14,479.25H532.5V1810.5h594.64  c53.83-0.17,97.43-43.77,97.61-97.61V576.86C1224.58,523.02,1180.98,479.43,1127.14,479.25z'
      />
      <path
        opacity='0.2'
        enableBackground='new'
        d='M1127.14,479.25H532.5V1704h594.64c53.83-0.17,97.43-43.77,97.61-97.61  V576.86C1224.58,523.02,1180.98,479.43,1127.14,479.25z'
      />
      <path
        opacity='0.2'
        enableBackground='new'
        d='M1073.89,479.25H532.5V1704h541.39c53.83-0.17,97.43-43.77,97.61-97.61  V576.86C1171.33,523.02,1127.73,479.43,1073.89,479.25z'
      />
      <linearGradient
        id={gradientId}
        gradientUnits='userSpaceOnUse'
        x1='203.51'
        y1='1729.02'
        x2='967.99'
        y2='404.98'
        gradientTransform='matrix(1 0 0 -1 0 2132)'
      >
        <stop offset='0' style={{ stopColor: '#18884F' }} />
        <stop offset='0.5' style={{ stopColor: '#117E43' }} />
        <stop offset='1' style={{ stopColor: '#0B6631' }} />
      </linearGradient>
      <path
        fill={`url(#${gradientId})`}
        d='M97.61,479.25h976.29c53.91,0,97.61,43.7,97.61,97.61v976.29  c0,53.91-43.7,97.61-97.61,97.61H97.61C43.7,1650.75,0,1607.05,0,1553.14V576.86C0,522.95,43.7,479.25,97.61,479.25z'
      />
      <path
        fill='#FFFFFF'
        d='M302.3,1382.26l205.33-318.17L319.5,747.68h151.34l102.67,202.35  c9.48,19.22,15.98,33.49,19.49,42.92h1.33c6.75-15.34,13.85-30.23,21.3-44.68L725.37,747.79h138.93l-192.92,314.55  L869.2,1382.26H721.38L602.79,1160.16c-5.59-9.45-10.33-19.38-14.16-29.66h-1.76c-3.47,10.07-8.08,19.72-13.74,28.76  l-122.1,223.01H302.3z'
      />
      <path
        fill='#33C481'
        d='M2192.14,0H1437.75v532.5h852V97.61C2289.75,43.7,2246.05,0,2192.14,0L2192.14,0z'
      />
      <path fill='#107C41' d='M1437.75,1065h852v532.5h-852V1065z' />
    </svg>
  )
}

export function PackageSearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14' />
      <path d='m7.5 4.27 9 5.15' />
      <polyline points='3.29 7 12 12 20.71 7' />
      <line x1='12' x2='12' y1='22' y2='12' />
      <circle cx='18.5' cy='15.5' r='2.5' />
      <path d='M20.27 17.27 22 19' />
    </svg>
  )
}
export function HuggingFaceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='256'
      height='256'
      viewBox='0 0 256 256'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M230.72 172.7C230.18 170.67 229.31 168.75 228.15 167.01C228.4 166.09 228.59 165.16 228.71 164.22C229.54 158.24 227.47 152.77 223.57 148.54C221.45 146.23 219.19 144.7 216.78 143.76C218.36 137.02 219.16 130.12 219.16 123.19C219.16 120.03 218.98 116.93 218.68 113.88C218.53 112.36 218.34 110.84 218.12 109.32C217.43 104.85 216.41 100.43 215.06 96.11C214.18 93.27 213.16 90.48 212.01 87.74C210.28 83.68 208.26 79.75 205.97 75.98C204.47 73.47 202.83 71.05 201.06 68.72C200.2 67.54 199.3 66.39 198.36 65.27C195.58 61.9 192.56 58.73 189.33 55.79C188.25 54.8 187.15 53.85 186.01 52.93C184.89 51.99 183.75 51.09 182.59 50.22C180.24 48.48 177.82 46.84 175.32 45.32C161.54 36.95 145.38 32.15 128.11 32.15C77.82 32.15 37.06 72.91 37.06 123.2C37.06 130.21 37.87 137.2 39.48 144.02C37.32 144.96 35.25 146.42 33.33 148.54C29.42 152.77 27.35 158.22 28.18 164.19C28.31 165.14 28.5 166.08 28.75 167.01C27.58 168.75 26.71 170.67 26.17 172.7C24.97 177.26 25.37 181.37 26.89 184.98C25.24 189.69 25.65 194.7 27.81 199.07C29.38 202.25 31.63 204.71 34.4 206.92C37.69 209.53 41.81 211.76 46.78 213.89C52.72 216.42 59.96 218.8 63.25 219.67C71.76 221.87 79.91 223.27 88.18 223.34C99.95 223.45 110.1 220.68 117.36 213.59C120.92 214.03 124.52 214.25 128.11 214.24C131.91 214.24 135.7 214 139.47 213.53C146.71 220.66 156.89 223.46 168.71 223.34C176.98 223.28 185.13 221.88 193.62 219.68C196.93 218.8 204.17 216.43 210.11 213.9C215.08 211.76 219.2 209.54 222.51 206.92C225.26 204.72 227.51 202.26 229.08 199.07C231.26 194.71 231.65 189.69 230.02 184.98C231.53 181.38 231.92 177.26 230.72 172.7ZM222.28 184.67C223.95 187.84 224.06 191.43 222.59 194.76C220.35 199.82 214.8 203.81 204.01 208.08C197.3 210.74 191.16 212.44 191.1 212.46C182.23 214.76 174.21 215.93 167.26 215.93C155.76 215.93 147.2 212.75 141.77 206.49C132.59 208.05 123.22 208.1 114.03 206.64C108.59 212.81 100.08 215.93 88.68 215.93C81.73 215.93 73.71 214.76 64.83 212.46C64.78 212.44 58.64 210.74 51.93 208.08C41.14 203.81 35.59 199.82 33.35 194.76C31.88 191.43 31.99 187.84 33.66 184.67C33.81 184.38 33.98 184.09 34.15 183.81C33.15 182.31 32.48 180.61 32.18 178.83C31.88 177.05 31.97 175.22 32.42 173.47C33.09 170.95 34.46 168.85 36.32 167.34C35.42 165.87 34.84 164.23 34.59 162.52C34.06 158.81 35.29 155.1 38.06 152.08C40.22 149.72 43.28 148.43 46.66 148.43H46.75C44.2 140.26 42.9 131.75 42.91 123.19C42.91 76.52 80.75 38.68 127.43 38.68C174.1 38.68 211.94 76.52 211.94 123.19C211.95 131.77 210.65 140.3 208.08 148.49C208.49 148.45 208.89 148.43 209.28 148.43C212.66 148.43 215.72 149.73 217.87 152.08C220.65 155.1 221.88 158.81 221.34 162.53C221.1 164.23 220.51 165.87 219.62 167.35C221.48 168.85 222.85 170.95 223.51 173.48C223.97 175.22 224.05 177.05 223.76 178.83C223.46 180.61 222.79 182.31 221.78 183.82C221.96 184.09 222.13 184.38 222.28 184.67Z'
        fill='white'
      />
      <path
        d='M221.78 183.82C222.79 182.31 223.46 180.61 223.76 178.83C224.05 177.05 223.97 175.22 223.51 173.48C222.85 170.95 221.48 168.85 219.62 167.35C220.51 165.87 221.1 164.23 221.34 162.53C221.88 158.81 220.65 155.1 217.87 152.08C215.72 149.73 212.66 148.43 209.28 148.43C208.89 148.43 208.49 148.45 208.08 148.49C210.64 140.3 211.94 131.77 211.93 123.2C211.93 76.52 174.1 38.69 127.42 38.69C80.75 38.69 42.91 76.52 42.91 123.2C42.9 131.75 44.19 140.26 46.74 148.43H46.65C43.27 148.43 40.22 149.72 38.06 152.08C35.29 155.1 34.05 158.81 34.59 162.52C34.83 164.23 35.42 165.87 36.32 167.35C34.46 168.85 33.09 170.95 32.42 173.47C31.96 175.22 31.88 177.05 32.18 178.83C32.48 180.61 33.15 182.31 34.15 183.82C33.97 184.09 33.81 184.38 33.65 184.68C31.98 187.85 31.88 191.43 33.35 194.77C35.59 199.82 41.14 203.81 51.93 208.09C58.64 210.75 64.78 212.45 64.83 212.46C73.71 214.76 81.73 215.93 88.68 215.93C100.08 215.93 108.59 212.81 114.03 206.65C123.22 208.11 132.59 208.05 141.77 206.49C147.2 212.76 155.76 215.93 167.26 215.93C174.21 215.93 182.23 214.76 191.1 212.46C191.16 212.45 197.3 210.75 204.01 208.09C214.8 203.81 220.35 199.82 222.59 194.77C224.06 191.43 223.95 187.85 222.28 184.68C222.13 184.38 221.96 184.09 221.78 183.82ZM110.14 197C109.67 197.82 109.17 198.61 108.64 199.39C107.23 201.45 105.38 203.02 103.24 204.19C99.14 206.42 93.95 207.21 88.68 207.21C80.35 207.21 71.81 205.26 67.02 204.02C66.79 203.95 37.69 195.74 41.37 188.74C41.99 187.56 43.01 187.09 44.3 187.09C49.48 187.09 58.93 194.82 62.99 194.82C63.9 194.82 64.54 194.43 64.8 193.49C66.53 187.28 38.5 184.68 40.86 175.69C41.28 174.1 42.41 173.46 44 173.46C50.86 173.46 66.25 185.52 69.47 185.52C69.71 185.52 69.89 185.44 69.99 185.29C70 185.27 70.02 185.25 70.03 185.22C71.54 182.73 70.67 180.91 60.32 174.57L59.33 173.97C47.94 167.07 39.94 162.93 44.49 157.98C45.01 157.4 45.75 157.15 46.65 157.15C47.72 157.15 49.01 157.51 50.44 158.11C56.45 160.65 64.79 167.56 68.28 170.58C68.82 171.06 69.37 171.54 69.91 172.02C69.91 172.02 74.32 176.61 76.99 176.61C77.6 176.61 78.12 176.37 78.47 175.77C80.36 172.58 60.91 157.84 59.81 151.76C59.07 147.63 60.33 145.55 62.67 145.55C63.79 145.55 65.15 146.02 66.64 146.97C71.29 149.92 80.27 165.35 83.56 171.35C84.66 173.36 86.54 174.21 88.24 174.21C91.6 174.21 94.23 170.87 88.55 166.62C80 160.23 83 149.78 87.08 149.14C87.25 149.11 87.43 149.1 87.6 149.1C91.31 149.1 92.95 155.49 92.95 155.49C92.95 155.49 97.74 167.52 105.98 175.75C113.45 183.22 114.49 189.35 110.14 197ZM136.77 198.41L136.34 198.46L135.61 198.54C135.23 198.58 134.84 198.62 134.46 198.65L134.08 198.69L133.74 198.72L133.26 198.76L132.72 198.8L132.18 198.83L132.06 198.84C131.92 198.85 131.78 198.86 131.64 198.86L131.46 198.87C131.3 198.88 131.13 198.89 130.96 198.9L130.38 198.92L129.85 198.94L129.5 198.95H129.32C129.21 198.95 129.1 198.96 128.99 198.96H128.82C128.71 198.96 128.6 198.96 128.49 198.96L128.04 198.97H127.42C126.93 198.97 126.44 198.96 125.95 198.95L125.55 198.94C125.44 198.94 125.33 198.94 125.22 198.93L124.8 198.92L124.28 198.9L123.81 198.88L123.68 198.88L123.24 198.85C123.11 198.85 122.99 198.84 122.87 198.83L122.58 198.81C122.21 198.79 121.85 198.77 121.49 198.74L121.11 198.71C120.95 198.7 120.79 198.68 120.63 198.67C120.44 198.65 120.25 198.63 120.07 198.61C119.75 198.59 119.44 198.55 119.13 198.52H119.11C123.68 188.32 121.37 178.8 112.14 169.58C106.08 163.53 102.05 154.59 101.22 152.63C99.52 146.83 95.05 140.38 87.61 140.38C86.98 140.38 86.35 140.43 85.73 140.52C82.47 141.04 79.62 142.91 77.59 145.73C75.4 143 73.26 140.83 71.33 139.6C68.42 137.76 65.52 136.82 62.69 136.82C59.16 136.82 56 138.27 53.8 140.9L53.75 140.97C53.7 140.8 53.66 140.63 53.62 140.45L53.62 140.43C53.2 138.64 52.85 136.83 52.56 135.02C52.56 135 52.56 134.99 52.56 134.98C52.54 134.84 52.52 134.71 52.49 134.57C52.43 134.16 52.38 133.76 52.32 133.35C52.3 133.16 52.27 132.98 52.25 132.79L52.18 132.24C52.16 132.05 52.14 131.89 52.12 131.71L52.12 131.67C52.04 130.95 51.97 130.23 51.9 129.5L51.88 129.23L51.85 128.75C51.84 128.63 51.83 128.5 51.82 128.37C51.82 128.33 51.82 128.3 51.81 128.28C51.79 127.91 51.77 127.55 51.75 127.19C51.74 127 51.73 126.81 51.72 126.62L51.7 126.12L51.7 125.97L51.68 125.52L51.67 125.13C51.67 124.97 51.66 124.82 51.66 124.66C51.66 124.51 51.65 124.34 51.65 124.17C51.65 124.01 51.65 123.85 51.65 123.69C51.64 123.52 51.65 123.36 51.65 123.2C51.65 81.34 85.58 47.41 127.44 47.41C169.29 47.41 203.22 81.34 203.22 123.2V124.17C203.22 124.34 203.22 124.5 203.21 124.66C203.21 124.8 203.21 124.93 203.2 125.07C203.2 125.19 203.2 125.31 203.2 125.43C203.2 125.58 203.19 125.73 203.18 125.88V125.9L203.16 126.43C203.15 126.58 203.15 126.74 203.14 126.89L203.13 127L203.11 127.5C203.05 128.56 202.97 129.62 202.87 130.68V130.7C202.85 130.87 202.83 131.04 202.81 131.22L202.77 131.63L202.68 132.43L202.63 132.84L202.57 133.32C202.54 133.49 202.52 133.67 202.49 133.84C202.47 134.04 202.44 134.23 202.41 134.42L202.34 134.88L202.26 135.4C202.23 135.58 202.2 135.75 202.17 135.92C202.14 136.09 202.11 136.26 202.08 136.44C202.02 136.78 201.96 137.13 201.89 137.47C201.79 137.98 201.69 138.49 201.58 139.01L201.47 139.51C201.43 139.68 201.4 139.85 201.36 140.02C199.22 137.95 196.4 136.82 193.28 136.82C190.46 136.82 187.55 137.75 184.64 139.6C182.71 140.82 180.58 143 178.38 145.73C176.35 142.9 173.5 141.03 170.24 140.52C169.62 140.42 168.99 140.37 168.36 140.37C160.93 140.37 156.45 146.82 154.76 152.63C153.92 154.59 149.89 163.52 143.82 169.58C134.6 178.78 132.27 188.25 136.77 198.41ZM215.01 178L214.98 178.09C214.9 178.29 214.81 178.48 214.71 178.67C214.64 178.81 214.56 178.95 214.47 179.08C214.3 179.33 214.12 179.57 213.92 179.79C213.88 179.85 213.83 179.9 213.78 179.95C213.71 180.03 213.63 180.1 213.56 180.18C212.21 181.51 210.16 182.68 207.84 183.75C207.58 183.87 207.31 183.99 207.04 184.11L206.77 184.23C206.6 184.31 206.42 184.39 206.23 184.46C206.05 184.54 205.86 184.62 205.68 184.7L205.12 184.93C203.81 185.46 202.48 185.97 201.17 186.48L200.62 186.7L200.06 186.91C199.7 187.06 199.34 187.2 198.98 187.34L198.45 187.56L197.93 187.77L197.67 187.88C197.5 187.95 197.33 188.02 197.17 188.09C193.33 189.74 190.57 191.41 191.15 193.49C191.16 193.55 191.18 193.6 191.2 193.66C191.25 193.81 191.32 193.96 191.41 194.1C191.47 194.18 191.53 194.25 191.59 194.32C192.27 195.03 193.52 194.92 195.08 194.36C195.3 194.28 195.52 194.19 195.74 194.1L195.87 194.05C196.23 193.9 196.61 193.73 197 193.54C197.09 193.5 197.19 193.45 197.29 193.4C199.2 192.47 201.37 191.21 203.52 190.06C204.39 189.59 205.26 189.15 206.14 188.73C208.18 187.77 210.1 187.09 211.64 187.09C212.36 187.09 213 187.24 213.53 187.58L213.62 187.64C213.95 187.88 214.23 188.18 214.44 188.53C214.48 188.6 214.52 188.67 214.56 188.74C215.32 190.18 214.69 191.68 213.19 193.15C211.76 194.56 209.54 195.94 207.01 197.22C206.82 197.31 206.63 197.41 206.44 197.5C198.91 201.2 189.05 203.98 188.91 204.02C186.28 204.7 182.53 205.59 178.29 206.26L177.67 206.36L177.56 206.37C177.09 206.45 176.61 206.51 176.14 206.57C175.66 206.64 175.17 206.7 174.68 206.75L174.59 206.76C172.81 206.97 171.02 207.1 169.23 207.17H169.2C168.55 207.19 167.91 207.2 167.26 207.2H166.51C165.52 207.19 164.54 207.15 163.55 207.07C163.53 207.07 163.51 207.07 163.48 207.06C163.13 207.04 162.78 207 162.43 206.97C162.06 206.93 161.7 206.88 161.33 206.83C161.09 206.8 160.86 206.77 160.62 206.73C160.38 206.69 160.13 206.65 159.89 206.61L159.56 206.54L159.54 206.54C159.19 206.47 158.85 206.4 158.5 206.32C158.3 206.27 158.1 206.23 157.91 206.18L157.79 206.15C157.69 206.12 157.6 206.1 157.5 206.07L157.45 206.06L157.14 205.97C157.03 205.94 156.91 205.9 156.8 205.87L156.76 205.86L156.47 205.77C156.36 205.73 156.25 205.7 156.14 205.66L155.87 205.57L155.68 205.5C155.49 205.44 155.3 205.37 155.11 205.3L154.93 205.23L154.79 205.17C154.5 205.05 154.22 204.94 153.94 204.81L153.76 204.72L153.73 204.71C153.66 204.68 153.59 204.64 153.53 204.62C153.4 204.56 153.27 204.49 153.14 204.43L153.1 204.41L152.92 204.31C152.59 204.14 152.27 203.96 151.96 203.76L151.79 203.66C151.7 203.61 151.62 203.55 151.53 203.49L151.31 203.35L151.07 203.18L150.92 203.08C150.77 202.97 150.62 202.86 150.48 202.74L150.24 202.56C150.15 202.49 150.06 202.41 149.97 202.34C149.89 202.27 149.82 202.21 149.74 202.14L149.73 202.14C149.65 202.06 149.57 201.99 149.5 201.92C149.42 201.85 149.34 201.78 149.26 201.7L149.25 201.7C149.17 201.62 149.1 201.54 149.02 201.46C148.94 201.39 148.86 201.31 148.79 201.23C148.71 201.15 148.64 201.07 148.56 200.98C148.49 200.9 148.42 200.83 148.35 200.75L148.33 200.72C148.26 200.64 148.19 200.56 148.13 200.48C147.98 200.31 147.84 200.14 147.71 199.96C147.57 199.78 147.44 199.59 147.31 199.41L147.19 199.22C147.03 198.98 146.87 198.74 146.71 198.49C146.6 198.32 146.48 198.14 146.37 197.96C146.3 197.84 146.23 197.73 146.17 197.62L146.14 197.57C146.07 197.46 146.01 197.35 145.95 197.25C145.91 197.19 145.88 197.13 145.85 197.07C145.81 197 145.77 196.94 145.74 196.88L145.68 196.78L145.65 196.72C145.58 196.6 145.51 196.47 145.45 196.35C145.42 196.3 145.39 196.24 145.36 196.19L145.27 196.02L145.18 195.85C144.96 195.4 144.74 194.94 144.54 194.48L144.47 194.31C144.43 194.2 144.38 194.09 144.34 193.98C144.32 193.92 144.29 193.87 144.27 193.81C144.17 193.54 144.07 193.26 143.98 192.98C143.94 192.87 143.91 192.78 143.88 192.68C143.81 192.45 143.74 192.22 143.69 191.99C143.61 191.72 143.55 191.45 143.5 191.18C143.49 191.12 143.48 191.07 143.47 191.01C143.42 190.75 143.37 190.48 143.34 190.21C143.33 190.15 143.33 190.1 143.32 190.05L143.3 189.89C143.28 189.67 143.26 189.46 143.25 189.25C143.25 189.19 143.25 189.14 143.25 189.09C143.24 188.98 143.24 188.88 143.24 188.77C143.18 184.5 145.35 180.39 149.97 175.77C158.2 167.54 163 155.5 163 155.5C163 155.5 163.13 155 163.39 154.27C163.43 154.17 163.47 154.06 163.51 153.96C163.67 153.55 163.85 153.15 164.04 152.76L164.08 152.68C164.25 152.35 164.43 152.03 164.62 151.71C164.67 151.64 164.71 151.57 164.77 151.49C164.91 151.28 165.07 151.07 165.23 150.86C165.32 150.75 165.42 150.64 165.51 150.53C165.55 150.49 165.59 150.45 165.63 150.41C166.11 149.92 166.65 149.51 167.27 149.3L167.35 149.27C167.4 149.26 167.45 149.24 167.51 149.23C167.57 149.21 167.63 149.2 167.69 149.18L167.72 149.18C167.85 149.15 167.98 149.13 168.11 149.12H168.13C168.19 149.12 168.26 149.12 168.34 149.12C168.42 149.12 168.51 149.12 168.59 149.13C168.68 149.13 168.77 149.14 168.86 149.16C169.61 149.28 170.31 149.72 170.92 150.4C171.15 150.66 171.36 150.94 171.54 151.24C171.66 151.43 171.77 151.63 171.88 151.85C171.92 151.93 171.96 152.02 172 152.1C172.11 152.33 172.2 152.56 172.28 152.79C172.48 153.35 172.63 153.91 172.72 154.49C172.81 154.99 172.86 155.5 172.87 156.01C172.88 156.29 172.88 156.56 172.87 156.84C172.82 158.14 172.55 159.42 172.09 160.63C172.04 160.75 172 160.86 171.95 160.97C171.86 161.2 171.76 161.42 171.65 161.63C171.57 161.8 171.48 161.97 171.39 162.13C171.33 162.24 171.27 162.35 171.21 162.46C171.05 162.73 170.87 163.01 170.68 163.28L170.57 163.44C170.13 164.06 169.64 164.63 169.1 165.17C168.57 165.7 168 166.19 167.4 166.64C166.8 167.08 166.23 167.58 165.71 168.11C164.21 169.69 163.86 171.08 164.2 172.14C164.25 172.3 164.32 172.47 164.41 172.62C164.51 172.79 164.63 172.95 164.76 173.1L164.82 173.15L164.87 173.21C164.93 173.26 164.98 173.31 165.04 173.36L165.1 173.41C165.25 173.52 165.4 173.62 165.56 173.71C165.61 173.73 165.65 173.76 165.71 173.78C165.88 173.87 166.06 173.94 166.24 174C166.29 174.02 166.34 174.03 166.4 174.05L166.46 174.06L166.55 174.09L166.63 174.11L166.71 174.12L166.8 174.14L166.87 174.15C166.93 174.16 166.99 174.17 167.05 174.18L167.11 174.19L167.21 174.2L167.28 174.21L167.38 174.21H167.44L167.55 174.22H167.9L168 174.21L168.11 174.21L168.25 174.19L168.38 174.18C168.41 174.18 168.44 174.17 168.47 174.17C168.87 174.11 169.26 174 169.64 173.85L169.8 173.78C169.89 173.74 169.98 173.7 170.06 173.66C170.24 173.57 170.41 173.47 170.57 173.36C170.8 173.21 171.02 173.04 171.22 172.86C171.27 172.82 171.31 172.77 171.36 172.73C171.38 172.7 171.4 172.68 171.43 172.66C171.47 172.61 171.51 172.57 171.56 172.52C171.88 172.17 172.16 171.78 172.38 171.36C174.34 167.8 176.39 164.3 178.53 160.85L178.83 160.38L179.13 159.91C179.27 159.67 179.42 159.43 179.57 159.2L179.72 158.97C180.22 158.19 180.73 157.41 181.24 156.64L181.55 156.19C182.16 155.28 182.77 154.4 183.37 153.56L183.67 153.14C184.33 152.24 185.02 151.35 185.73 150.48L186.01 150.14C186.06 150.09 186.1 150.03 186.15 149.98C186.24 149.87 186.34 149.76 186.43 149.66C186.47 149.6 186.52 149.55 186.57 149.5L186.83 149.2L186.97 149.05C187.1 148.91 187.24 148.77 187.37 148.63C187.46 148.54 187.54 148.46 187.62 148.37C188.13 147.85 188.69 147.39 189.29 146.99L189.43 146.9C189.57 146.81 189.71 146.72 189.85 146.65C192.21 145.3 194.17 145.2 195.3 146.33C195.98 147.01 196.36 148.14 196.34 149.72C196.34 149.79 196.34 149.86 196.33 149.93V150.01C196.33 150.08 196.32 150.15 196.32 150.22C196.32 150.31 196.31 150.4 196.3 150.49C196.29 150.58 196.29 150.65 196.28 150.73C196.28 150.75 196.27 150.77 196.27 150.8C196.26 150.87 196.25 150.94 196.24 151.01C196.24 151.03 196.24 151.05 196.24 151.07C196.22 151.17 196.21 151.26 196.19 151.36C196.18 151.45 196.17 151.53 196.15 151.62L196.13 151.77C196.1 151.91 196.07 152.05 196.03 152.19C195.95 152.45 195.85 152.7 195.74 152.95C195.59 153.28 195.42 153.61 195.23 153.93C195.13 154.11 195.02 154.29 194.91 154.46C194.79 154.64 194.67 154.82 194.55 155C194.23 155.45 193.91 155.9 193.56 156.33L193.41 156.53C192.85 157.22 192.28 157.9 191.69 158.56L191.5 158.77C191.25 159.05 190.99 159.34 190.73 159.62L190.53 159.83C190.4 159.98 190.26 160.12 190.13 160.26C190 160.41 189.86 160.55 189.73 160.7L189.32 161.13L188.9 161.57L188.48 162C188.2 162.29 187.91 162.59 187.63 162.88C183.57 167.04 179.3 171.18 177.86 173.77C177.76 173.93 177.67 174.11 177.59 174.29C177.39 174.76 177.3 175.16 177.36 175.48C177.38 175.59 177.42 175.69 177.47 175.79C177.55 175.93 177.65 176.06 177.77 176.17C177.82 176.22 177.88 176.27 177.93 176.32C178.23 176.53 178.59 176.64 178.96 176.63H179.07L179.19 176.62L179.31 176.61L179.4 176.59C179.42 176.59 179.43 176.59 179.44 176.58L179.53 176.57L179.55 176.56L179.65 176.54L179.69 176.53C179.72 176.52 179.76 176.51 179.79 176.5C179.83 176.49 179.88 176.48 179.92 176.47C180.09 176.41 180.27 176.35 180.43 176.28C180.52 176.24 180.61 176.2 180.7 176.16C180.74 176.14 180.79 176.12 180.83 176.1L180.96 176.03C181.28 175.87 181.59 175.69 181.9 175.49L182.03 175.4C182.08 175.37 182.12 175.34 182.16 175.31L182.3 175.22L182.37 175.17L182.56 175.04C182.74 174.92 182.91 174.79 183.08 174.66L183.09 174.65L183.36 174.44C183.73 174.15 184.07 173.86 184.39 173.58L184.6 173.4L184.62 173.38L184.73 173.28C184.99 173.05 185.22 172.84 185.41 172.66L185.49 172.58C185.56 172.52 185.62 172.46 185.68 172.4L185.79 172.29L185.83 172.25L185.84 172.24L185.96 172.13L186.03 172.05L186.04 172.04L186.07 172.01L186.12 171.97L186.13 171.96L186.17 171.92L186.37 171.74L186.49 171.64C186.55 171.59 186.61 171.53 186.67 171.48L186.8 171.36C186.83 171.34 186.85 171.32 186.88 171.29L187.02 171.17L187.23 170.98L187.34 170.89C187.78 170.51 188.31 170.05 188.91 169.54L189.16 169.33L189.57 168.98L189.99 168.63C190.54 168.17 191.14 167.69 191.76 167.19L192.17 166.86C192.52 166.58 192.88 166.29 193.25 166.01C193.39 165.89 193.54 165.78 193.69 165.66C194.07 165.37 194.44 165.09 194.82 164.8C195.68 164.16 196.56 163.51 197.46 162.87L197.84 162.61C198.11 162.42 198.38 162.24 198.65 162.05L198.89 161.89C199.37 161.57 199.85 161.25 200.34 160.94L200.59 160.79L200.83 160.64C201.07 160.49 201.31 160.34 201.55 160.2L201.79 160.05L202.27 159.78L202.73 159.51L202.83 159.45L203.2 159.25C203.36 159.17 203.51 159.09 203.66 159.01L203.89 158.89L204.12 158.78C204.19 158.74 204.27 158.7 204.35 158.66C204.85 158.42 205.36 158.19 205.88 157.98C206.02 157.92 206.16 157.87 206.3 157.82L206.71 157.67C206.83 157.63 206.95 157.59 207.07 157.56L207.11 157.55C207.17 157.53 207.23 157.51 207.29 157.49L207.31 157.49C207.44 157.45 207.57 157.42 207.69 157.39H207.7C208.05 157.3 208.41 157.24 208.78 157.21C208.94 157.19 209.11 157.18 209.28 157.18H209.36C209.48 157.18 209.58 157.19 209.69 157.2C209.74 157.2 209.79 157.21 209.84 157.22H209.86C209.9 157.22 209.95 157.23 210 157.24C210.05 157.25 210.1 157.26 210.14 157.27H210.16C210.2 157.28 210.25 157.29 210.29 157.3C210.55 157.37 210.79 157.48 211.01 157.63C211.12 157.7 211.22 157.78 211.32 157.87L211.34 157.89C211.36 157.91 211.38 157.93 211.4 157.94L211.44 158C211.85 158.42 212.18 158.9 212.43 159.43L212.47 159.52C212.55 159.72 212.62 159.92 212.67 160.14C212.81 160.78 212.75 161.46 212.51 162.07C212.42 162.32 212.3 162.56 212.17 162.79C211.86 163.31 211.49 163.8 211.07 164.24L210.98 164.33C210.85 164.47 210.71 164.61 210.57 164.75C210.5 164.82 210.43 164.88 210.37 164.94L210.16 165.13L210.06 165.22C209.8 165.45 209.53 165.68 209.26 165.89C209.1 166.03 208.94 166.15 208.77 166.28C208.18 166.73 207.59 167.16 206.98 167.58C206.61 167.83 206.24 168.08 205.87 168.32C204.95 168.92 204.02 169.51 203.08 170.08C201.12 171.29 198.93 172.59 196.61 174L196.01 174.36C195.35 174.76 194.73 175.15 194.14 175.51L193.85 175.7L193.29 176.06C192.92 176.29 192.55 176.53 192.18 176.77L191.88 176.97C191.74 177.06 191.59 177.16 191.45 177.25L191.31 177.34L190.88 177.63L190.65 177.79L190.38 177.98L190.13 178.15C189.71 178.44 189.33 178.73 188.97 178.99L188.83 179.09C188.62 179.25 188.42 179.42 188.21 179.58C187.9 179.83 187.62 180.07 187.37 180.3L187.24 180.41C187.17 180.47 187.1 180.54 187.04 180.6C186.99 180.65 186.95 180.69 186.9 180.74L186.83 180.8C186.69 180.94 186.55 181.09 186.42 181.24L186.35 181.32C186.2 181.49 186.08 181.65 185.96 181.81L185.91 181.88C185.83 182.01 185.74 182.14 185.67 182.28C185.65 182.31 185.64 182.35 185.62 182.38L185.57 182.48L185.54 182.56L185.52 182.61L185.5 182.65L185.48 182.71C185.41 182.88 185.37 183.06 185.35 183.23L185.34 183.3L185.33 183.35V183.67C185.33 183.7 185.33 183.72 185.34 183.75L185.34 183.8C185.34 183.82 185.35 183.85 185.35 183.88C185.36 183.9 185.36 183.95 185.37 183.99V183.99C185.38 184.03 185.39 184.06 185.4 184.1C185.4 184.13 185.41 184.17 185.42 184.21C185.44 184.28 185.47 184.35 185.49 184.42C185.51 184.46 185.52 184.5 185.54 184.54C185.54 184.55 185.55 184.56 185.55 184.57L185.59 184.65L185.64 184.76C185.69 184.87 185.75 184.99 185.81 185.09L185.88 185.21L185.95 185.32C185.96 185.34 185.97 185.36 185.99 185.38L186.01 185.4L186.04 185.42L186.06 185.44C186.1 185.47 186.14 185.49 186.18 185.51C186.21 185.51 186.23 185.52 186.25 185.53C186.83 185.66 188.02 185.18 189.59 184.35C189.68 184.3 189.78 184.25 189.88 184.2L190.36 183.93L190.59 183.8C190.76 183.72 190.93 183.61 191.1 183.52L191.42 183.34C193.5 182.14 195.99 180.6 198.56 179.09C198.8 178.95 199.04 178.81 199.29 178.67L199.77 178.36C200.34 178.04 200.9 177.72 201.47 177.4C202.19 177.01 202.91 176.63 203.64 176.25L204.12 176.01C204.43 175.86 204.74 175.71 205.05 175.56C205.65 175.27 206.26 175 206.87 174.75L207.2 174.61L207.24 174.6C209.02 173.89 210.63 173.46 211.93 173.46C212.21 173.46 212.49 173.48 212.77 173.53H212.78C212.87 173.54 212.95 173.56 213.03 173.58H213.05C213.26 173.64 213.47 173.71 213.66 173.81C213.94 173.95 214.18 174.14 214.39 174.37C214.49 174.48 214.57 174.59 214.65 174.71C214.79 174.93 214.9 175.16 214.98 175.41C215.01 175.5 215.04 175.59 215.07 175.69C215.28 176.45 215.26 177.25 215.01 178Z'
        fill='#FF9D00'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M203.21 123.69V123.19C203.21 81.34 169.29 47.41 127.44 47.41C85.58 47.41 51.65 81.34 51.65 123.19V123.36C51.65 123.47 51.65 123.58 51.65 123.69C51.65 123.85 51.65 124.01 51.65 124.17L51.66 124.53L51.66 124.66C51.66 124.72 51.66 124.78 51.67 124.84C51.67 124.94 51.67 125.03 51.67 125.13L51.68 125.52L51.7 125.97L51.7 126.12L51.72 126.6V126.62C51.73 126.81 51.74 126.99 51.75 127.17L51.75 127.19C51.76 127.38 51.77 127.56 51.78 127.75C51.79 127.93 51.8 128.1 51.82 128.28L51.82 128.31C51.83 128.46 51.84 128.6 51.85 128.75L51.85 128.79L51.88 129.23L51.89 129.25C51.89 129.34 51.9 129.42 51.91 129.5C51.97 130.22 52.04 130.95 52.12 131.66L52.12 131.71L52.18 132.24L52.25 132.79L52.3 133.17L52.32 133.35C52.38 133.76 52.43 134.16 52.5 134.57L52.5 134.6L52.56 134.98C52.84 136.81 53.2 138.63 53.62 140.43L53.62 140.45L53.66 140.59L53.75 140.97L53.8 140.9C56 138.27 59.16 136.82 62.69 136.82C65.52 136.82 68.42 137.76 71.33 139.6C73.26 140.83 75.4 143 77.59 145.73C79.62 142.91 82.47 141.04 85.73 140.52C86.35 140.43 86.98 140.38 87.61 140.38C95.04 140.38 99.52 146.83 101.22 152.63C102.05 154.59 106.08 163.53 112.16 169.57C121.39 178.8 123.7 188.32 119.13 198.51H119.15C119.46 198.55 119.77 198.58 120.09 198.61C120.27 198.63 120.46 198.64 120.65 198.66L120.71 198.67L121.13 198.7L121.51 198.73C121.87 198.76 122.23 198.78 122.6 198.81L122.89 198.82L123.11 198.84L123.26 198.85L123.7 198.87L123.83 198.87L124.29 198.9L124.82 198.92L125.24 198.93L125.31 198.93C125.39 198.93 125.48 198.94 125.57 198.94L125.67 198.94C126.26 198.95 126.85 198.96 127.44 198.96H128.06L128.51 198.95C128.62 198.95 128.73 198.95 128.84 198.95H129.01L129.17 198.95C129.22 198.94 129.28 198.94 129.34 198.94H129.52L129.87 198.93L130.4 198.91L130.98 198.89C131.15 198.88 131.32 198.87 131.48 198.87L131.66 198.85L131.93 198.84L132.08 198.83L132.2 198.82L132.74 198.79L133.27 198.75L133.76 198.71L134.1 198.68L134.48 198.65C135.11 198.59 135.73 198.53 136.36 198.45L136.79 198.4C132.29 188.25 134.62 178.77 143.81 169.58C149.88 163.52 153.91 154.59 154.75 152.63C156.44 146.82 160.91 140.37 168.35 140.37C168.98 140.37 169.61 140.42 170.23 140.52C173.49 141.03 176.33 142.9 178.37 145.73C180.57 143 182.7 140.82 184.63 139.6C187.54 137.75 190.45 136.82 193.27 136.82C196.39 136.82 199.21 137.95 201.35 140.02C201.38 139.85 201.42 139.68 201.46 139.51L201.57 139.01C201.61 138.82 201.65 138.64 201.68 138.45C201.75 138.12 201.82 137.8 201.88 137.47C201.94 137.13 202.01 136.78 202.07 136.44L202.1 136.25C202.12 136.14 202.14 136.03 202.16 135.92C202.19 135.75 202.22 135.58 202.25 135.4L202.26 135.34L202.33 134.88L202.4 134.42V134.42C202.45 134.08 202.5 133.74 202.54 133.4L202.55 133.32L202.62 132.84L202.67 132.43L202.76 131.63L202.79 131.31L202.8 131.22C202.82 131.04 202.84 130.87 202.85 130.7V130.68C202.87 130.54 202.88 130.41 202.89 130.27C202.96 129.48 203.02 128.69 203.07 127.89C203.08 127.76 203.09 127.63 203.1 127.5V127.49L203.12 127L203.13 126.89C203.14 126.56 203.16 126.23 203.17 125.9V125.88L203.17 125.75C203.18 125.65 203.18 125.54 203.18 125.43L203.19 125.38C203.19 125.28 203.19 125.17 203.19 125.07L203.2 124.98C203.2 124.87 203.2 124.77 203.2 124.66L203.2 124.57C203.21 124.44 203.21 124.31 203.21 124.17V123.69ZM108.64 199.39C114.64 190.59 114.21 183.98 105.98 175.75C97.74 167.52 92.95 155.49 92.95 155.49C92.95 155.49 91.16 148.5 87.08 149.14C83 149.78 80.01 160.23 88.55 166.62C97.09 173.02 86.85 177.35 83.56 171.35C80.28 165.35 71.3 149.92 66.65 146.97C61.99 144.02 58.72 145.68 59.82 151.76C60.36 154.78 65.43 159.93 70.16 164.74C74.97 169.63 79.43 174.16 78.47 175.77C76.58 178.96 69.91 172.02 69.91 172.02C69.91 172.02 49.04 153.03 44.49 157.98C40.3 162.54 46.77 166.42 56.72 172.4C57.57 172.91 58.44 173.43 59.33 173.97C70.72 180.87 71.61 182.68 69.99 185.29C69.4 186.26 65.58 183.97 60.89 181.15C52.9 176.35 42.36 170.02 40.87 175.69C39.58 180.59 47.33 183.6 54.37 186.32C60.23 188.59 65.59 190.67 64.8 193.48C63.98 196.41 59.55 193.97 54.71 191.31C49.28 188.31 43.32 185.04 41.37 188.74C37.69 195.73 66.78 203.95 67.02 204.02C76.42 206.45 100.3 211.62 108.64 199.39ZM147.3 199.39C141.3 190.59 141.73 183.98 149.96 175.75C158.2 167.52 162.99 155.49 162.99 155.49C162.99 155.49 164.78 148.5 168.86 149.14C172.94 149.78 175.93 160.23 167.39 166.62C158.85 173.02 169.09 177.35 172.38 171.35C175.67 165.35 184.64 149.92 189.29 146.97C193.95 144.02 197.22 145.68 196.12 151.76C195.58 154.78 190.51 159.93 185.77 164.74C180.97 169.63 176.51 174.16 177.46 175.77C179.36 178.96 186.03 172.02 186.03 172.02C186.03 172.02 206.9 153.02 211.45 157.97C215.64 162.54 209.18 166.42 199.22 172.39C198.35 172.92 197.48 173.44 196.61 173.97C185.22 180.86 184.33 182.68 185.95 185.29C186.55 186.25 190.36 183.96 195.05 181.15C203.04 176.35 213.59 170.02 215.08 175.69C216.36 180.59 208.61 183.59 201.57 186.32C195.71 188.59 190.35 190.66 191.14 193.48C191.96 196.4 196.39 193.97 201.23 191.3C206.66 188.31 212.62 185.03 214.56 188.73C218.25 195.73 189.15 203.95 188.92 204.01C179.52 206.45 155.64 211.62 147.3 199.39Z'
        fill='#FFD21E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M152.05 102.57C153.23 102.99 154.11 104.26 154.94 105.47C156.07 107.1 157.13 108.63 158.74 107.77C160.64 106.76 162.21 105.2 163.23 103.3C164.25 101.4 164.68 99.24 164.48 97.1C164.32 95.49 163.81 93.94 162.99 92.55C162.16 91.17 161.04 89.99 159.7 89.09C158.36 88.19 156.84 87.6 155.25 87.36C153.65 87.12 152.02 87.23 150.48 87.7C148.93 88.16 147.51 88.97 146.32 90.05C145.12 91.13 144.18 92.46 143.56 93.95C142.94 95.43 142.65 97.04 142.73 98.65C142.8 100.26 143.24 101.84 143.99 103.26C144.74 104.67 146.4 104 148.15 103.3C149.53 102.75 150.96 102.18 152.05 102.57ZM100.67 102.57C99.49 102.99 98.61 104.26 97.78 105.47C96.65 107.11 95.59 108.63 93.98 107.77C91.58 106.5 89.75 104.39 88.83 101.84C87.91 99.29 87.97 96.49 89 93.98C90.03 91.48 91.96 89.45 94.41 88.29C96.86 87.12 99.65 86.92 102.24 87.7C104.31 88.32 106.14 89.54 107.51 91.21C108.89 92.87 109.73 94.9 109.95 97.05C110.17 99.19 109.74 101.36 108.73 103.26C107.98 104.67 106.32 104 104.57 103.3C103.19 102.75 101.76 102.18 100.67 102.57ZM144.1 149.32C152.24 142.9 155.23 132.43 155.23 125.98C155.23 120.88 151.8 122.48 146.31 125.2L146 125.36C140.96 127.85 134.25 131.18 126.88 131.18C119.51 131.18 112.8 127.85 107.76 125.35C102.08 122.55 98.53 120.78 98.53 125.98C98.53 132.63 101.71 143.56 110.44 149.91C111.6 147.57 113.22 145.5 115.21 143.81C117.2 142.13 119.52 140.87 122.02 140.13C122.89 139.87 123.79 141.37 124.71 142.9C125.59 144.39 126.5 145.9 127.42 145.9C128.41 145.9 129.37 144.41 130.31 142.95C131.3 141.43 132.26 139.94 133.19 140.24C137.86 141.74 141.78 144.99 144.1 149.32Z'
        fill='#32343D'
      />
      <path
        d='M144.1 149.32C139.86 152.66 134.22 154.9 126.88 154.9C119.98 154.9 114.59 152.92 110.44 149.91C111.6 147.57 113.22 145.5 115.21 143.81C117.2 142.13 119.52 140.87 122.02 140.13C123.73 139.61 125.55 145.9 127.42 145.9C129.43 145.9 131.37 139.66 133.19 140.24C137.86 141.74 141.77 144.99 144.1 149.32Z'
        fill='#FF323D'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M81.2 111.64C80.23 112.29 79.12 112.69 77.96 112.8C76.8 112.92 75.63 112.74 74.55 112.3C73.69 111.94 72.91 111.42 72.25 110.76C71.59 110.1 71.07 109.32 70.71 108.46C70.27 107.38 70.09 106.21 70.21 105.05C70.32 103.89 70.72 102.78 71.37 101.81C72.15 100.64 73.26 99.73 74.55 99.2C75.85 98.66 77.27 98.52 78.65 98.79C80.02 99.07 81.29 99.74 82.28 100.73C83.27 101.73 83.94 102.99 84.22 104.37C84.49 105.74 84.35 107.17 83.81 108.46C83.27 109.76 82.37 110.86 81.2 111.64ZM182.61 111.64C181.64 112.29 180.53 112.69 179.37 112.8C178.21 112.92 177.04 112.74 175.96 112.3C175.1 111.94 174.32 111.42 173.66 110.76C173 110.1 172.48 109.32 172.13 108.46C171.68 107.38 171.51 106.21 171.62 105.05C171.74 103.89 172.14 102.78 172.78 101.81C173.36 100.94 174.13 100.21 175.03 99.67C175.93 99.13 176.94 98.79 177.98 98.69C179.03 98.59 180.08 98.72 181.06 99.07C182.05 99.43 182.95 99.99 183.69 100.74C184.68 101.73 185.36 102.99 185.63 104.37C185.9 105.74 185.76 107.17 185.22 108.46C184.69 109.76 183.78 110.86 182.61 111.64Z'
        fill='#FFAD03'
      />
    </svg>
  )
}

export const ResponseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='currentColor'
    width='800px'
    height='800px'
    viewBox='0 0 1920 1920'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m1030.97 188 81.25 81.25-429.23 429.23h300.75c516.22 0 936.26 420.03 936.26 936.26v98.03h-114.92v-98.03c0-452.9-368.44-821.34-821.34-821.34H683l429.23 429.23-81.25 81.25-567.94-567.94L1030.97 188Zm-463.04.011 81.25 81.25-486.69 486.69 486.69 486.69-81.25 81.25L0 755.95 567.94 188.01Z'
      fillRule='evenodd'
    />
  </svg>
)

export const AnthropicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='currentColor'
    fillRule='evenodd'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Anthropic</title>
    <path d='M13.83 3.52h3.6L24 20h-3.6l-6.57-16.48zm-7.26 0h3.77L16.91 20h-3.67l-1.34-3.46H5.02l-1.34 3.46H0L6.57 3.52zm4.13 9.96L8.45 7.69 6.21 13.48H10.7z' />
  </svg>
)

export const ClaudeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='currentColor'
    height='1em'
    viewBox='0 0 100 100'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Claude</title>
    <path d='m19.6 66.5 19.7-11 .3-1-.3-.5h-1l-3.3-.2-11.2-.3L14 53l-9.5-.5-2.4-.5L0 49l.2-1.5 2-1.3 2.9.2 6.3.5 9.5.6 6.9.4L38 49.1h1.6l.2-.7-.5-.4-.4-.4L29 41l-10.6-7-5.6-4.1-3-2-1.5-2-.6-4.2 2.7-3 3.7.3.9.2 3.7 2.9 8 6.1L37 36l1.5 1.2.6-.4.1-.3-.7-1.1L33 25l-6-10.4-2.7-4.3-.7-2.6c-.3-1-.4-2-.4-3l3-4.2L28 0l4.2.6L33.8 2l2.6 6 4.1 9.3L47 29.9l2 3.8 1 3.4.3 1h.7v-.5l.5-7.2 1-8.7 1-11.2.3-3.2 1.6-3.8 3-2L61 2.6l2 2.9-.3 1.8-1.1 7.7L59 27.1l-1.5 8.2h.9l1-1.1 4.1-5.4 6.9-8.6 3-3.5L77 13l2.3-1.8h4.3l3.1 4.7-1.4 4.9-4.4 5.6-3.7 4.7-5.3 7.1-3.2 5.7.3.4h.7l12-2.6 6.4-1.1 7.6-1.3 3.5 1.6.4 1.6-1.4 3.4-8.2 2-9.6 2-14.3 3.3-.2.1.2.3 6.4.6 2.8.2h6.8l12.6 1 3.3 2 1.9 2.7-.3 2-5.1 2.6-6.8-1.6-16-3.8-5.4-1.3h-.8v.4l4.6 4.5 8.3 7.5L89 80.1l.5 2.4-1.3 2-1.4-.2-9.2-7-3.6-3-8-6.8h-.5v.7l1.8 2.7 9.8 14.7.5 4.5-.7 1.4-2.6 1-2.7-.6-5.8-8-6-9-4.7-8.2-.5.4-2.9 30.2-1.3 1.5-3 1.2-2.5-2-1.4-3 1.4-6.2 1.6-8 1.3-6.4 1.2-7.9.7-2.6v-.2H49L43 72l-9 12.3-7.2 7.6-1.7.7-3-1.5.3-2.8L24 86l10-12.8 6-7.9 4-4.6-.1-.5h-.3L17.2 77.4l-4.7.6-2-2 .2-3 1-1 8-5.5Z' />
  </svg>
)

export function AzureDataExplorerIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const wedgeGradient = `adx_wedge_${id}`
  const dashLongGradient = `adx_dash_long_${id}`
  const dashTopGradient = `adx_dash_top_${id}`
  const dashBottomGradient = `adx_dash_bottom_${id}`

  return (
    <svg
      {...props}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.47,1.47,16.53,16.53a.57.57,0,0,0,1-.4V1.07A.57.57,0,0,0,16.93.5H1.87A.57.57,0,0,0,1.47,1.47Z'
        fill={`url(#${wedgeGradient})`}
      />
      <path d='M5.53,5.53l6.94,6.94,5-5V1.07A.57.57,0,0,0,16.93.5H10.56Z' fill='#50e6ff' />
      <rect
        x='-0.38'
        y='12.85'
        width='9.37'
        height='1.7'
        rx='0.27'
        transform='translate(-8.43 7.06) rotate(-45)'
        fill={`url(#${dashLongGradient})`}
      />
      <rect
        x='0.12'
        y='9.23'
        width='5.99'
        height='1.7'
        rx='0.27'
        transform='translate(-6.22 5.15) rotate(-45)'
        fill={`url(#${dashTopGradient})`}
      />
      <rect
        x='4.89'
        y='14.04'
        width='5.99'
        height='1.7'
        rx='0.27'
        transform='translate(-8.22 9.93) rotate(-45)'
        fill={`url(#${dashBottomGradient})`}
      />
      <rect
        x='9.19'
        y='4.75'
        width='1.7'
        height='1.7'
        rx='0.38'
        transform='translate(-1.02 8.74) rotate(-45)'
        fill='#fff'
      />
      <rect
        x='11.59'
        y='2.35'
        width='1.7'
        height='1.7'
        rx='0.38'
        transform='translate(1.38 9.73) rotate(-45)'
        fill='#fff'
      />
      <rect
        x='11.59'
        y='7.15'
        width='1.7'
        height='1.7'
        rx='0.38'
        transform='translate(-2.01 11.14) rotate(-45)'
        fill='#fff'
      />
      <path
        d='M13.91,5.33l.66-.66a.38.38,0,0,1,.54,0l.66.66a.38.38,0,0,1,0,.54l-.66.66a.38.38,0,0,1-.54,0l-.66-.66a.38.38,0,0,1,0-.54'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id={wedgeGradient}
          x1='1.3'
          y1='8.6'
          x2='17.5'
          y2='8.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.1' stopColor='#54aef0' />
          <stop offset='1' stopColor='#1988d9' />
        </linearGradient>
        <linearGradient
          id={dashLongGradient}
          x1='0.5'
          y1='13.7'
          x2='8.11'
          y2='13.7'
          gradientTransform='translate(10.95 0.97) rotate(45)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#b3b2b3' />
          <stop offset='1' stopColor='#979797' />
        </linearGradient>
        <linearGradient
          id={dashTopGradient}
          x1='0.5'
          y1='10.08'
          x2='5.72'
          y2='10.08'
          gradientTransform='translate(8.04 0.75) rotate(45)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#b3b2b3' />
          <stop offset='1' stopColor='#979797' />
        </linearGradient>
        <linearGradient
          id={dashBottomGradient}
          x1='5.28'
          y1='14.89'
          x2='10.49'
          y2='14.89'
          gradientTransform='translate(12.84 -1.21) rotate(45)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#b3b2b3' />
          <stop offset='1' stopColor='#979797' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function AzureIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient0 = `azure_paint0_${id}`
  const gradient1 = `azure_paint1_${id}`
  const gradient2 = `azure_paint2_${id}`

  return (
    <svg
      {...props}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.33 1.37C5.45 1.04 5.76 0.82 6.11 0.82H11.25L5.92 16.63C5.8 16.96 5.49 17.18 5.14 17.18H1.14C0.58 17.18 0.19 16.63 0.36 16.1L5.33 1.37Z'
        fill={`url(#${gradient0})`}
      />
      <path
        d='M13.55 11.45H5.45C5.11 11.45 4.95 11.87 5.2 12.1L10.4 16.96C10.55 17.1 10.75 17.18 10.96 17.18H15.55L13.55 11.45Z'
        fill='#0078D4'
      />
      <path
        d='M6.11 0.82C5.76 0.82 5.45 1.04 5.33 1.37L0.36 16.1C0.19 16.63 0.58 17.18 1.14 17.18H5.14C5.49 17.18 5.8 16.96 5.92 16.63L6.9 13.7L10.4 16.96C10.55 17.1 10.75 17.18 10.96 17.18H15.55L13.55 11.45H7.66L11.25 0.82H6.11Z'
        fill={`url(#${gradient1})`}
      />
      <path
        d='M12.67 1.37C12.55 1.04 12.24 0.82 11.89 0.82H6.14H6.16C6.51 0.82 6.83 1.04 6.94 1.37L11.91 16.1C12.09 16.63 11.69 17.18 11.13 17.18H11.05H16.86C17.42 17.18 17.81 16.63 17.64 16.1L12.67 1.37Z'
        fill={`url(#${gradient2})`}
      />
      <defs>
        <linearGradient
          id={gradient0}
          x1='6.08'
          y1='1.38'
          x2='0.74'
          y2='17.15'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#114A8B' />
          <stop offset='1' stopColor='#0669BC' />
        </linearGradient>
        <linearGradient
          id={gradient1}
          x1='10.34'
          y1='11.46'
          x2='9.11'
          y2='11.87'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.3' />
          <stop offset='0.07' stopOpacity='0.2' />
          <stop offset='0.32' stopOpacity='0.1' />
          <stop offset='0.62' stopOpacity='0.05' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id={gradient2}
          x1='9.46'
          y1='1.38'
          x2='15.32'
          y2='16.99'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3CCBF4' />
          <stop offset='1' stopColor='#2892DF' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const GroqIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='currentColor'
    fillRule='evenodd'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Groq</title>
    <path d='M12.04 2c-3.85-.035-7 3-7.04 6.78-.035 3.78 3.06 6.87 6.91 6.91h2.42v-2.57h-2.29c-2.41.028-4.38-1.87-4.41-4.23-.029-2.36 1.9-4.3 4.31-4.33h.1c2.41 0 4.36 1.92 4.37 4.28v6.31c0 2.34-1.94 4.25-4.32 4.28a4.38 4.38 0 01-3.03-1.25l-1.85 1.82A7 7 0 0012.03 22h.092c3.8-.056 6.86-3.08 6.88-6.82v-6.5C18.91 4.96 15.82 2 12.04 2z' />
  </svg>
)

export const DeepseekIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} height='1em' viewBox='0 0 24 24' width='1em' xmlns='http://www.w3.org/2000/svg'>
    <title>DeepSeek</title>
    <path
      d='M23.748 4.651c-.254-.124-.364.113-.512.233-.051.04-.094.09-.137.137-.372.397-.806.657-1.373.626-.829-.046-1.537.214-2.163.848-.133-.782-.575-1.248-1.247-1.548-.352-.155-.708-.311-.955-.65-.172-.24-.219-.509-.305-.774-.055-.16-.11-.323-.293-.35-.2-.031-.278.136-.356.276-.313.572-.434 1.202-.422 1.84.027 1.436.633 2.58 1.838 3.393.137.094.172.187.129.323-.082.28-.18.553-.266.833-.055.179-.137.218-.328.14a5.5 5.5 0 0 1-1.737-1.179c-.857-.828-1.631-1.743-2.597-2.46a12 12 0 0 0-.689-.47c-.985-.957.13-1.743.387-1.836.27-.098.094-.433-.778-.428-.872.003-1.67.295-2.687.685a3 3 0 0 1-.465.136 9.6 9.6 0 0 0-2.883-.101c-1.885.21-3.39 1.1-4.497 2.622C.082 8.776-.231 10.854.152 13.02c.403 2.284 1.568 4.175 3.36 5.653 1.857 1.533 3.997 2.284 6.438 2.14 1.482-.085 3.132-.284 4.994-1.86.47.234.962.328 1.78.398.629.058 1.235-.031 1.705-.129.735-.155.684-.836.418-.961-2.155-1.004-1.682-.595-2.112-.926 1.095-1.295 2.768-3.598 3.284-6.733.05-.346.115-.834.108-1.114-.004-.171.035-.238.23-.257a4.2 4.2 0 0 0 1.545-.475c1.397-.763 1.96-2.016 2.093-3.517.02-.23-.004-.467-.247-.588M11.58 18.168c-2.088-1.642-3.101-2.183-3.52-2.16-.39.024-.32.472-.234.763.09.288.207.487.371.74.114.167.192.416-.113.603-.673.416-1.842-.14-1.897-.168-1.361-.801-2.5-1.86-3.301-3.306-.775-1.393-1.225-2.888-1.299-4.482-.02-.385.094-.522.477-.592a4.7 4.7 0 0 1 1.53-.038c2.131.311 3.946 1.264 5.467 2.774.868.86 1.525 1.887 2.202 2.89.72 1.066 1.494 2.082 2.48 2.915.348.291.626.513.892.677-.802.09-2.14.109-3.055-.615zm1.001-6.44a.306.306 0 0 1 .415-.287.3.3 0 0 1 .113.074.3.3 0 0 1 .086.214c0 .17-.136.307-.308.307a.303.303 0 0 1-.306-.307m3.11 1.596c-.2.081-.4.151-.591.16a1.25 1.25 0 0 1-.798-.254c-.274-.23-.47-.358-.551-.758a1.7 1.7 0 0 1 .015-.588c.07-.327-.007-.537-.238-.727-.188-.156-.426-.199-.689-.199a.6.6 0 0 1-.254-.078.253.253 0 0 1-.114-.358 1 1 0 0 1 .192-.21c.356-.202.767-.136 1.146.016.352.144.618.408 1.001.782.392.451.462.576.685.915.176.264.336.536.446.848.066.194-.02.353-.25.45'
      fill='#4D6BFE'
    />
  </svg>
)

export const SakanaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} height='1em' viewBox='152 5 38 30' width='1em' xmlns='http://www.w3.org/2000/svg'>
    <title>Sakana AI</title>
    <path
      d='m187.2 7.8-2.5-0.7c-6.3-1.8-12.7-1.2-18 1.5l-10.2 5.7c-1.2 0.7-0.2 2.5 1 1.8l7.6-4.4c0.8 1.7 1.5 4 1.1 7.7-1.4-0.3-6-1.4-10.9 1.5-0.6 0.3-0.8 1.1-0.3 1.7 0.5 0.5 1.2 0.3 1.3 0.2 2.2-1.3 5.6-2.4 9.6-1.4-0.7 2.5-2.5 5.6-6 7.8-1.5 0.7-0.4 2.3 0.7 1.8 1.8-1 5.3-3.4 6.9-9 2.1 0.9 4.2 2.4 5.9 4.6l-7.2 4.1c-1.2 0.6-0.3 2.4 1.1 1.7l9-5c4.6-2.7 8.3-7.5 10.1-13.1l1.3-5.3c0.4-0.4 0-1.1-0.5-1.2zm-11.5 17.5-0.6 0.4c-2-2.6-4.5-4.7-7.5-5.7 0.5-3.8-0.3-6.8-1.2-9.1l1.1-0.6c4.8-2 9.8-2.7 16.2-0.9l1.6 0.4-0.8 2.7c-1.5 4.9-4.5 9.6-8.8 12.8z'
      fill='#E60000'
    />
  </svg>
)

export const NvidiaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    height='1em'
    viewBox='30 28 280 172'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>NVIDIA</title>
    <path
      d='M82.211,102.414c0,0,22.504-33.203,67.437-36.638V53.73c-49.769,3.997-92.867,46.149-92.867,46.149s24.41,70.565,92.867,77.026v-12.804C99.411,157.781,82.211,102.414,82.211,102.414z M149.648,138.637v11.726c-37.968-6.769-48.507-46.237-48.507-46.237s18.23-20.195,48.507-23.47v12.867c-0.023,0-0.039-0.007-0.058-0.007c-15.891-1.907-28.305,12.938-28.305,12.938S128.243,131.445,149.648,138.637 M149.648,31.512V53.73c1.461-0.112,2.922-0.207,4.391-0.257c56.582-1.907,93.449,46.406,93.449,46.406s-42.343,51.488-86.457,51.488c-4.043,0-7.828-0.375-11.383-1.005v13.739c3.04,0.386,6.192,0.613,9.481,0.613c41.051,0,70.738-20.965,99.484-45.778c4.766,3.817,24.278,13.103,28.289,17.168c-27.332,22.883-91.031,41.329-127.144,41.329c-3.481,0-6.824-0.211-10.11-0.528v19.306h156.032V31.512H149.648z M149.648,80.656V65.777c1.446-0.101,2.903-0.179,4.391-0.226c40.688-1.278,67.382,34.965,67.382,34.965s-28.832,40.043-59.746,40.043c-4.449,0-8.438-0.715-12.028-1.922V93.523c15.84,1.914,19.028,8.911,28.551,24.786l21.18-17.859c0,0-15.461-20.277-41.524-20.277C155.021,80.172,152.31,80.371,149.648,80.656'
      fill='#77B900'
    />
  </svg>
)

export const ZaiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} height='1em' viewBox='0 0 30 30' width='1em' xmlns='http://www.w3.org/2000/svg'>
    <title>Z.ai</title>
    <path
      d='M24.51,28.51H5.49c-2.21,0-4-1.79-4-4V5.49c0-2.21,1.79-4,4-4h19.03c2.21,0,4,1.79,4,4v19.03C28.51,26.72,26.72,28.51,24.51,28.51z'
      fill='#2D2D2D'
    />
    <path
      d='M15.47,7.1l-1.3,1.85c-0.2,0.29-0.54,0.47-0.9,0.47h-7.1V7.09C6.16,7.1,15.47,7.1,15.47,7.1z'
      fill='#FFFFFF'
    />
    <polygon fill='#FFFFFF' points='24.3,7.1 13.14,22.91 5.7,22.91 16.86,7.1' />
    <path d='M14.53,22.91l1.31-1.86c0.2-0.29,0.54-0.47,0.9-0.47h7.09v2.33H14.53z' fill='#FFFFFF' />
  </svg>
)

export const KimiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} height='1em' viewBox='0 0 24 24' width='1em' xmlns='http://www.w3.org/2000/svg'>
    <title>Kimi</title>
    <path
      d='M21.846 0a1.923 1.923 0 110 3.846H20.15a.226.226 0 01-.227-.226V1.923C19.923.861 20.784 0 21.846 0z'
      fill='#1783FF'
    />
    <path
      d='M11.065 11.199l7.257-7.2c.137-.136.06-.41-.116-.41H14.3a.164.164 0 00-.117.051l-7.82 7.756c-.122.12-.302.013-.302-.179V3.82c0-.127-.083-.23-.185-.23H3.186c-.103 0-.186.103-.186.23V19.77c0 .128.083.23.186.23h2.69c.103 0 .186-.102.186-.23v-3.25c0-.069.025-.135.069-.178l2.424-2.406a.158.158 0 01.205-.023l6.484 4.772a7.677 7.677 0 003.453 1.283c.108.012.2-.095.2-.23v-3.06c0-.117-.07-.212-.164-.227a5.028 5.028 0 01-2.027-.807l-5.613-4.064c-.117-.078-.132-.279-.028-.381z'
      fill='currentColor'
    />
  </svg>
)

export function MetaIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient1Id = `meta_gradient_1_${id}`
  const gradient2Id = `meta_gradient_2_${id}`

  return (
    <svg
      {...props}
      height='1em'
      viewBox='0 -48.28 287.56 287.56'
      width='1em'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>Meta</title>
      <defs>
        <linearGradient
          id={gradient1Id}
          x1='61'
          x2='259'
          y1='117'
          y2='127'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#0064e1' />
          <stop offset='0.4' stopColor='#0064e1' />
          <stop offset='0.83' stopColor='#0073ee' />
          <stop offset='1' stopColor='#0082fb' />
        </linearGradient>
        <linearGradient
          id={gradient2Id}
          x1='45'
          x2='45'
          y1='139'
          y2='66'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#0082fb' />
          <stop offset='1' stopColor='#0064e0' />
        </linearGradient>
      </defs>
      <path
        d='m31.06,125.96c0,10.98 2.41,19.41 5.56,24.51 4.13,6.68 10.29,9.51 16.57,9.51 8.1,0 15.51-2.01 29.79-21.76 11.44-15.83 24.92-38.05 33.99-51.98l15.36-23.6c10.67-16.39 23.02-34.61 37.18-46.96 11.56-10.08 24.03-15.68 36.58-15.68 21.07,0 41.14,12.21 56.5,35.11 16.81,25.08 24.97,56.67 24.97,89.27 0,19.38-3.82,33.62-10.32,44.87-6.28,10.88-18.52,21.75-39.11,21.75l0-31.02c17.63,0 22.03-16.2 22.03-34.74 0-26.42-6.16-55.74-19.73-76.69-9.63-14.86-22.11-23.94-35.84-23.94-14.85,0-26.8,11.2-40.23,31.17-7.14,10.61-14.47,23.54-22.7,38.13l-9.06,16.05c-18.2,32.27-22.81,39.62-31.91,51.75-15.95,21.24-29.57,29.29-47.5,29.29-21.27,0-34.72-9.21-43.05-23.09-6.8-11.31-10.14-26.15-10.14-43.06z'
        fill='#0081fb'
      />
      <path
        d='m24.49,37.3c14.24-21.95 34.79-37.3 58.36-37.3 13.65,0 27.22,4.04 41.39,15.61 15.5,12.65 32.02,33.48 52.63,67.81l7.39,12.32c17.84,29.72 27.99,45.01 33.93,52.22 7.64,9.26 12.99,12.02 19.94,12.02 17.63,0 22.03-16.2 22.03-34.74l27.4-.86c0,19.38-3.82,33.62-10.32,44.87-6.28,10.88-18.52,21.75-39.11,21.75-12.8,0-24.14-2.78-36.68-14.61-9.64-9.08-20.91-25.21-29.58-39.71l-25.79-43.08c-12.94-21.62-24.81-37.74-31.68-45.04-7.39-7.85-16.89-17.33-32.05-17.33-12.27,0-22.69,8.61-31.41,21.78z'
        fill={`url(#${gradient1Id})`}
      />
      <path
        d='m82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78-12.33,18.61-19.88,46.33-19.88,72.95 0,10.98 2.41,19.41 5.56,24.51l-26.48,17.44c-6.8-11.31-10.14-26.15-10.14-43.06 0-30.75 8.44-62.8 24.49-87.55 14.24-21.95 34.79-37.3 58.36-37.3z'
        fill={`url(#${gradient2Id})`}
      />
    </svg>
  )
}

export function GeminiIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `gemini_gradient_${id}`

  return (
    <svg {...props} height='1em' viewBox='0 0 24 24' width='1em' xmlns='http://www.w3.org/2000/svg'>
      <title>Gemini</title>
      <defs>
        <linearGradient id={gradientId} x1='0%' x2='68.73%' y1='100%' y2='30.4%'>
          <stop offset='0%' stopColor='#1C7DFF' />
          <stop offset='52.02%' stopColor='#1C69FF' />
          <stop offset='100%' stopColor='#F0DCD6' />
        </linearGradient>
      </defs>
      <path
        d='M12 24A14.3 14.3 0 000 12 14.3 14.3 0 0012 0a14.31 14.31 0 0012 12 14.31 14.31 0 00-12 12'
        fill={`url(#${gradientId})`}
        fillRule='nonzero'
      />
    </svg>
  )
}

export const VertexIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    id='standard_product_icon'
    xmlns='http://www.w3.org/2000/svg'
    version='1.1'
    viewBox='0 0 512 512'
  >
    <g id='bounding_box'>
      <rect width='512' height='512' fill='none' />
    </g>
    <g id='art'>
      <path
        d='M128,244.99c-8.84,0-16-7.16-16-16v-95.97c0-8.84,7.16-16,16-16s16,7.16,16,16v95.97c0,8.84-7.16,16-16,16Z'
        fill='#ea4335'
      />
      <path
        d='M256,458c-2.98,0-5.97-.83-8.59-2.5l-186-122c-7.46-4.74-9.65-14.63-4.91-22.09,4.75-7.46,14.64-9.65,22.09-4.91l177.41,116.53,177.41-116.53c7.45-4.74,17.34-2.55,22.09,4.91,4.74,7.46,2.55,17.34-4.91,22.09l-186,122c-2.62,1.67-5.61,2.5-8.59,2.5Z'
        fill='#fbbc04'
      />
      <path
        d='M256,388.03c-8.84,0-16-7.16-16-16v-73.06c0-8.84,7.16-16,16-16s16,7.16,16,16v73.06c0,8.84-7.16,16-16,16Z'
        fill='#34a853'
      />
      <circle cx='128' cy='70' r='16' fill='#ea4335' />
      <circle cx='128' cy='292' r='16' fill='#ea4335' />
      <path
        d='M384.23,308.01c-8.82,0-15.98-7.14-16-15.97l-.23-94.01c-.02-8.84,7.13-16.02,15.97-16.03h.04c8.82,0,15.98,7.14,16,15.97l.23,94.01c.02,8.84-7.13,16.02-15.97,16.03h-.04Z'
        fill='#4285f4'
      />
      <circle cx='384' cy='70' r='16' fill='#4285f4' />
      <circle cx='384' cy='134' r='16' fill='#4285f4' />
      <path
        d='M320,220.36c-8.84,0-16-7.16-16-16v-103.02c0-8.84,7.16-16,16-16s16,7.16,16,16v103.02c0,8.84-7.16,16-16,16Z'
        fill='#fbbc04'
      />
      <circle cx='256' cy='171' r='16' fill='#34a853' />
      <circle cx='256' cy='235' r='16' fill='#34a853' />
      <circle cx='320' cy='265' r='16' fill='#fbbc04' />
      <circle cx='320' cy='329' r='16' fill='#fbbc04' />
      <path
        d='M192,217.36c-8.84,0-16-7.16-16-16v-100.02c0-8.84,7.16-16,16-16s16,7.16,16,16v100.02c0,8.84-7.16,16-16,16Z'
        fill='#fbbc04'
      />
      <circle cx='192' cy='265' r='16' fill='#fbbc04' />
      <circle cx='192' cy='329' r='16' fill='#fbbc04' />
    </g>
  </svg>
)

export const CerebrasIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='currentColor'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Cerebras</title>
    <path
      clipRule='evenodd'
      d='M14.12 2.7a9.3 9.3 0 000 18.6V22.7c-5.91 0-10.7-4.79-10.7-10.7S8.21 1.3 14.12 1.3V2.7zm4.75 3.68A7.35 7.35 0 109.42 17.64l-.901 1.07a8.75 8.75 0 01-1.08-12.33 8.76 8.76 0 112.34-1.08l-.901 1.08zm-2.25.844a5.41 5.41 0 00-5.05 9.56l-.656 1.24a6.81 6.81 0 016.36-12.04l-.654 1.24zM14.12 8.54a3.46 3.46 0 100 6.92v1.4a4.86 4.86 0 010-9.73v1.4z'
      fill='#F15A29'
      fillRule='evenodd'
    />
    <path d='M15.41 10.84a2.24 2.24 0 00-.51-.409 1.08 1.08 0 00-.544-.152c-.255 0-.483.05-.684.14a1.58 1.58 0 00-.84.91c-.74.2-.11.42-.11.63 0 .218.04.43.11.63a1.59 1.59 0 00.84.91c.2.09.43.14.68.14.22 0 .417-.46.6-.135.19-.09.35-.225.48-.392l.928 1.01c-.14.14-.3.26-.482.36a3.37 3.37 0 01-1.08.38c-.17.03-.317.04-.44.04a3.32 3.32 0 01-1.18-.21 2.83 2.83 0 01-.961-.597 2.82 2.82 0 01-.644-.929 2.99 2.99 0 01-.238-1.21c0-.444.08-.847.24-1.21.15-.35.37-.666.64-.929.28-.261.61-.464.96-.596a3.32 3.32 0 11.18-.21c.355 0 .712.07 1.07.204.36.138.69.36.94.649l-.962.97z' />
  </svg>
)

export const OllamaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='currentColor'
    fillRule='evenodd'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Ollama</title>
    <path d='M7.905 1.09c.216.085.411.225.588.41.295.306.544.744.734 1.263.191.522.315 1.1.362 1.68a5.054 5.054 0 012.049-.636l.051-.004c.87-.07 1.73.087 2.48.474.101.053.2.11.297.17.05-.569.172-1.134.36-1.644.19-.52.439-.957.733-1.264a1.67 1.67 0 01.589-.41c.257-.1.53-.118.796-.042.401.114.745.368 1.016.737.248.337.434.769.561 1.287.23.934.27 2.163.115 3.645l.053.04.026.019c.757.576 1.284 1.397 1.563 2.35.435 1.487.216 3.155-.534 4.088l-.018.021.002.003c.417.762.67 1.567.724 2.4l.002.03c.064 1.065-.2 2.137-.814 3.19l-.007.01.01.024c.472 1.157.62 2.322.438 3.486l-.006.039a.651.651 0 01-.747.536.648.648 0 01-.54-.742c.167-1.033.01-2.069-.48-3.123a.643.643 0 01.04-.617l.004-.006c.604-.924.854-1.83.8-2.72-.046-.779-.325-1.544-.8-2.273a.644.644 0 01.18-.886l.009-.006c.243-.159.467-.565.58-1.12a4.229 4.229 0 00-.095-1.974c-.205-.7-.58-1.284-1.105-1.683-.595-.454-1.383-.673-2.38-.61a.653.653 0 01-.632-.371c-.314-.665-.772-1.141-1.343-1.436a3.288 3.288 0 00-1.772-.332c-1.245.099-2.343.801-2.67 1.686a.652.652 0 01-.61.425c-1.067.002-1.893.252-2.497.703-.522.39-.878.935-1.066 1.588a4.07 4.07 0 00-.068 1.886c.112.558.331 1.02.582 1.269l.008.007c.212.207.257.53.109.785-.36.622-.629 1.549-.673 2.44-.05 1.018.186 1.902.719 2.536l.016.019a.643.643 0 01.095.69c-.576 1.236-.753 2.252-.562 3.052a.652.652 0 01-1.269.298c-.243-1.018-.078-2.184.473-3.498l.014-.035-.008-.012a4.339 4.339 0 01-.598-1.309l-.005-.019a5.764 5.764 0 01-.177-1.785c.044-.91.278-1.842.622-2.59l.012-.026-.002-.002c-.293-.418-.51-.953-.63-1.545l-.005-.024a5.352 5.352 0 01.093-2.49c.262-.915.777-1.701 1.536-2.269.06-.045.123-.09.186-.132-.159-1.493-.119-2.73.112-3.67.127-.518.314-.95.562-1.287.27-.368.614-.622 1.015-.737.266-.076.54-.059.797.042zm4.116 9.09c.936 0 1.8.313 2.446.855.63.527 1.005 1.235 1.005 1.94 0 .888-.406 1.58-1.133 2.022-.62.375-1.451.557-2.403.557-1.009 0-1.871-.259-2.493-.734-.617-.47-.963-1.13-.963-1.845 0-.707.398-1.417 1.056-1.946.668-.537 1.55-.849 2.485-.849zm0 .896a3.07 3.07 0 00-1.916.65c-.461.37-.722.835-.722 1.25 0 .428.21.829.61 1.134.455.347 1.124.548 1.943.548.799 0 1.473-.147 1.932-.426.463-.28.7-.686.7-1.257 0-.423-.246-.89-.683-1.256-.484-.405-1.14-.643-1.864-.643zm.662 1.21l.004.004c.12.151.095.37-.056.49l-.292.23v.446a.375.375 0 01-.376.373.375.375 0 01-.376-.373v-.46l-.271-.218a.347.347 0 01-.052-.49.353.353 0 01.494-.051l.215.172.22-.174a.353.353 0 01.49.051zm-5.04-1.919c.478 0 .867.39.867.871a.87.87 0 01-.868.871.87.87 0 01-.867-.87.87.87 0 01.867-.872zm8.706 0c.48 0 .868.39.868.871a.87.87 0 01-.868.871.87.87 0 01-.867-.87.87.87 0 01.867-.872zM7.44 2.3l-.003.002a.659.659 0 00-.285.238l-.005.006c-.138.189-.258.467-.348.832-.17.692-.216 1.631-.124 2.782.43-.128.899-.208 1.404-.237l.01-.001.019-.034c.046-.082.095-.161.148-.239.123-.771.022-1.692-.253-2.444-.134-.364-.297-.65-.453-.813a.628.628 0 00-.107-.09L7.44 2.3zm9.174.04l-.002.001a.628.628 0 00-.107.09c-.156.163-.32.45-.453.814-.29.794-.387 1.776-.23 2.572l.058.097.008.014h.03a5.184 5.184 0 011.466.212c.086-1.124.038-2.043-.128-2.722-.09-.365-.21-.643-.349-.832l-.004-.006a.659.659 0 00-.285-.239h-.004z' />
  </svg>
)
export const FalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} height='1em' viewBox='0 0 24 24' width='1em' xmlns='http://www.w3.org/2000/svg'>
    <title>Fal</title>
    <path
      clipRule='evenodd'
      d='M15.477 0c.415 0 .749.338.788.752a7.775 7.775 0 006.985 6.984c.413.04.752.373.752.788v6.952c0 .415-.338.748-.752.788a7.775 7.775 0 00-6.985 6.984c-.04.414-.373.752-.788.752H8.525c-.416 0-.749-.338-.789-.752a7.775 7.775 0 00-6.984-6.984c-.414-.04-.752-.373-.752-.788V8.524c0-.415.338-.748.752-.788A7.775 7.775 0 007.736.752C7.776.338 8.11 0 8.526 0h6.95zM4.819 11.98a7.226 7.226 0 007.223 7.23 7.226 7.226 0 007.223-7.23c0-3.994-3.234-7.23-7.223-7.23a7.227 7.227 0 00-7.223 7.23z'
      fill='#EC0648'
      fillRule='evenodd'
    />
  </svg>
)
export function ShieldCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10' />
      <path d='m9 12 2 2 4-4' />
    </svg>
  )
}

export function WealthboxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      version='1.0'
      width='200'
      height='200'
      viewBox='50 -50 200 200'
    >
      <g fill='#106ED4' stroke='none' transform='translate(0, 200) scale(0.15, -0.15)'>
        <path d='M764 1542 c-110 -64 -230 -134 -266 -156 -42 -24 -71 -49 -78 -65 -7 -19 -10 -126 -8 -334 3 -291 4 -307 23 -326 11 -11 103 -67 205 -126 102 -59 219 -127 261 -151 42 -24 85 -44 96 -44 23 0 527 288 561 320 22 22 22 23 22 340 0 288 -2 320 -17 338 -32 37 -537 322 -569 321 -18 0 -107 -46 -230 -117z m445 -144 c108 -62 206 -123 219 -135 22 -22 22 -26 22 -261 0 -214 -2 -242 -17 -260 -23 -26 -414 -252 -437 -252 -9 0 -70 31 -134 69 -64 37 -161 94 -215 125 l-97 57 2 261 3 261 210 123 c116 67 219 123 229 123 10 1 107 -50 215 -111z' />
        <path d='M700 1246 l-55 -32 -3 -211 -2 -211 37 -23 c21 -12 52 -30 69 -40 l30 -18 103 59 c56 33 109 60 117 60 8 0 62 -27 119 -60 l104 -60 63 37 c35 21 66 42 70 48 4 5 8 101 8 212 l0 202 -62 35 -63 35 -3 -197 c-1 -108 -6 -200 -11 -205 -5 -5 -54 17 -114 52 -58 34 -108 61 -111 61 -2 0 -51 -27 -107 -60 -56 -32 -106 -57 -111 -54 -4 3 -8 95 -8 205 0 109 -3 199 -7 199 -5 -1 -33 -16 -63 -34z' />
      </g>
    </svg>
  )
}

export function WebhookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      width='800px'
      height='800px'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M17.97 7A4.97 4.97 0 0 0 18 6.5a5.5 5.5 0 1 0-8.67 4.49L7.18 15.11A2.43 2.43 0 0 0 6.5 15 2.5 2.5 0 1 0 9 17.5a2.36 2.36 0 0 0-.93-1.92l2.58-4.94-.41-.241A4.5 4.5 0 1 1 17 6.5a4.8 4.8 0 0 1-.22.45zM6.5 19a1.5 1.5 0 1 1 1.5-1.5A1.52 1.52 0 0 1 6.5 19zM18.5 12a5.74 5.74 0 0 0-1.45.157l-2.74-3.94A2.41 2.41 0 0 0 15 6.5a2.54 2.54 0 1 0-1.52 2.28l3.17 4.56.36-.13A4.27 4.27 0 0 1 18.5 13a4.5 4.5 0 1 1-.008 9h-.006a4.68 4.68 0 0 1-3.12-1.35l-.703.71A5.65 5.65 0 0 0 18.49 23h.011a5.5 5.5 0 0 0 0-11zM11 6.5A1.5 1.5 0 1 1 12.5 8 1.51 1.51 0 0 1 11 6.5zM18.5 20a2.5 2.5 0 1 0-2.45-3h-5.05l-.3.5A4.55 4.55 0 0 1 6.5 22 4.53 4.53 0 0 1 2 17.5a4.6 4.6 0 0 1 3.15-4.37l-.296-.954A5.61 5.61 0 0 0 1 17.5 5.53 5.53 0 0 0 6.5 23a5.57 5.57 0 0 0 5.48-5h4.08a2.49 2.49 0 0 0 2.44 2zm0-4a1.5 1.5 0 1 1-1.5 1.5 1.51 1.51 0 0 1 1.5-1.5z' />
      <path fill='none' d='M0 0h24v24H0z' />
    </svg>
  )
}

export function ScheduleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M8 2v4' />
      <path d='M16 2v4' />
      <rect width='18' height='18' x='3' y='4' rx='2' />
      <path d='M3 10h18' />
    </svg>
  )
}

export function QdrantIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `qdrant_gradient_${id}`
  const clipPathId = `qdrant_clippath_${id}`

  return (
    <svg {...props} fill='none' viewBox='0 0 49 56' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d='m38.49 51.48-1.12-30.79-2.02-8.12 13.5 1.43v37.24l-8.25 4.76-2.11-4.53z'
          clipRule='evenodd'
          fill='#24386C'
          fillRule='evenodd'
        />
        <path
          d='m48.85 14-8.25 4.76-17.02-3.73-19.92 8.11-3.32-9.14 12.12-7 12.13-7 12.12 7 12.13 7z'
          clipRule='evenodd'
          fill='#7589BE'
          fillRule='evenodd'
        />
        <path
          d='m0.35 14 8.25 4.76 4.78 14.22 16.14 12.91-4.92 10.11-12.13-7-12.12-7v-28z'
          clipRule='evenodd'
          fill='#B2BFE8'
          fillRule='evenodd'
        />
        <path
          d='m30.07 38.42-5.47 8.06v9.52l7.76-4.48 4-5.97'
          clipRule='evenodd'
          fill='#24386C'
          fillRule='evenodd'
        />
        <path
          d='m24.6 36.96-7.76-13.44 1.67-4.45 6.35-3.08 7.49 7.53-7.75 13.44z'
          clipRule='evenodd'
          fill='#7589BE'
          fillRule='evenodd'
        />
        <path
          d='m16.84 23.53 7.76 4.48v8.96l-7.17 0.31-4.34-5.54 3.76-8.2z'
          clipRule='evenodd'
          fill='#B2BFE8'
          fillRule='evenodd'
        />
        <path
          d='m24.6 28 7.76-4.48 5.28 8.79-6.39 5.28-6.65-0.63v-8.96z'
          clipRule='evenodd'
          fill='#24386C'
          fillRule='evenodd'
        />
        <path
          d='m32.35 51.52 8.25 4.48v-37.24l-8-4.62-8-4.62-8 4.62-8 4.62v18.48l8 4.62 8 4.62 7.76-4.48v9.52zm0-19.05-7.76 4.48-7.76-4.48v-8.95l7.76-4.48 7.76 4.48v8.95z'
          clipRule='evenodd'
          fill='#DC244C'
          fillRule='evenodd'
        />
        <path d='m24.6 46.48v-9.52l-7.72-4.44v9.51l7.72 4.46z' fill={`url(#${gradientId})`} />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1='23.18'
          x2='15.49'
          y1='38.78'
          y2='38.78'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3364' offset='0' />
          <stop stopColor='#C91540' stopOpacity='0' offset='1' />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect transform='translate(.34961)' width='48.3' height='56' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function QuartrIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='6' fill='white' />
      <g transform='translate(6 6.19) scale(0.16624)'>
        <path
          d='M34.07 88.5C34.07 104.79 58.42 118 77.23 118C87.24 118 96.25 114.26 102.48 108.31L77.23 88.5H34.07Z'
          fill='black'
        />
        <path d='M0 88.5C0 104.79 15.25 118 34.07 118V59C15.25 59 0 72.21 0 88.5Z' fill='black' />
        <path
          d='M77.23 29.5V81.15H111.3V29.57C111.27 13.19 96.03 -0.04 77.23 0H33.74V0C15.07 0.16 0 13.3 0 29.5V59H34.07V29.5H77.23'
          fill='black'
        />
        <path d='M83.16 86.52L120.31 114.84V86.52H83.16Z' fill='black' />
      </g>
    </svg>
  )
}

export function QuiverIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='18.75 18.75 212.5 212.5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='m249.3 0.88h-248.5v248.2h248.5v-248.2z' fill='#F6F6F7' />
      <path
        d='m124.3 25h-5.93l-1.95 0.59-7.9 0.29-1.47 0.88-7.9 1.18-1.18 0.88-9.09 2.85-0.88 0.88-11.86 5.93-0.88 1.18-6.23 2.55-8.29 8.3-7.61 4.75-5.34 8.6-5.04 4.75-4.46 8.6-2.05 1.18-3.26 8.6-0.88 0.59-3.85 12.16-0.59 0.59-2.35 13.04v1.47l-0.59 7.12 0.3 1.18-0.3 3.15 1.18 13.04 0.59 0.88 0.88 7.51 0.88 1.18 3.85 12.16 0.88 0.6 4.44 9.97 1.18 0.88 4.15 8 12.73 16.17 4.45 2.06 8.8 8.3 0.88 0.29 4.16 3.15h1.18l8.2 4.75h0.88l7.9 3.44h0.88l9.38 2.85 0.88 0.3 13.33 1.46h107.9v-101.3l-0.88-2.06v-8.3l-0.59-0.88v-4.16l-4.75-14.23v-4.16l-11.26-19.46-1.48-1.48-10.37-13.05-5.63-3.15-7.61-7.31-3.15-1.18-5.93-4.75-1.48-0.29-7.01-4.15h-1.18l-8.2-3.15h-0.88l-10.37-3.14h-1.18l-8.49-1.18-2.06-0.88h-7.5z'
        fill='#333'
      />
      <path
        d='m78.38 72.26 118.6 41.21c4.65 1.69 3.47 8.5-1.47 8.5h-74v74.32c0 5.04-7.11 5.92-8.78 1.17l-40.58-118.5c-1.28-3.95 2.27-8.11 6.19-6.72z'
        fill='#F9F9F9'
      />
    </svg>
  )
}

export function AshbyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 254 260' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M76.07 250.54v9.16H.343v-9.16c19.62 0 27.47-4.38 34.53-23.5l73.76-209.09h34.92l81.22 209.09c7.85 19.52 11.77 23.5 28.64 23.5v9.16H134.36v-9.16c28.24 0 30.63-2.58 22.14-23.5l-21.58-57.35H69.4l-19.23 56.16c-5.61 19-4.39 24.69 25.9 24.69zm24.33-171.65l-26.68 78.46h56.5l-29.82-78.46z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ArxivIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} id='logomark' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.73 24.27'>
      <g id='tiny'>
        <path
          d='M573.55,280.92l2.27,2.74,6.67-7.84c.353-.47.52-.717.35-1.12a1.22,1.22,0,0,0-1.06-.748h0a.953.95,0,0,0-.712.26Z'
          transform='translate(-566.98 -271.55)'
          fill='#bdb9b4'
        />
        <path
          d='M579.53,282.23l-10.61-10.17a1.41,1.41,0,0,0-.834-.5,1.09,1.09,0,0,0-1.03.66c-.167.4-.47.68.319,1.21l8.44,10.24h0l-6.28,7.72a1.34,1.34,0,0,0-.323,1.3,1.11,1.11,0,0,0,1.04.69A.992.99,0,0,0,571,293l8.52-7.92A1.92,1.92,0,0,0,579.53,282.23Z'
          transform='translate(-566.98 -271.55)'
          fill='#b31b1b'
        />
        <path
          d='M584.32,293.91l-8.52-10.27,0,0L573.53,280.9l-1.39,1.25a2.06,2.06,0,0,0,0,2.97l10.81,10.42a.925.93,0,0,0,.742.28,1.04,1.04,0,0,0,.953-.667A1.26,1.26,0,0,0,584.32,293.91Z'
          transform='translate(-566.98 -271.55)'
          fill='#bdb9b4'
        />
      </g>
    </svg>
  )
}

export function WikipediaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      version='1.1'
      id='Capa_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='800px'
      height='800px'
      viewBox='0 0 98.05 98.05'
      xmlSpace='preserve'
    >
      <g>
        <path
          d='M98.02,17.47l-19.58-0.06c0,0.71-0.01,1.56-0.02,2.12c1.66,0.04,5.92,0.82,7.26,4.33L66.92,67.16
		c-0.92-2.15-9.64-21.53-10.64-24.02l9.07-18.82c1.87-2.86,5.46-4.71,8.92-4.84l-0.01-1.97L55.42,17.49
		c-0.04,0.5,0,1.55-0.07,2.07c5.32,0.14,7.22,1.33,5.94,4.51c-2.1,4.78-6.51,13.82-7.37,15.48
		c-2.7-5.63-4.41-9.97-7.34-16.06c-1.27-2.82,1.53-3.92,4.49-4v-1.98l-21.82-0.07
		c0.02,0.93-0.02,1.45-0.02,2.13c3.04,0.05,6.99,0.37,8.56,3.02c2.09,4.06,9.04,20.19,11.15,24.51
		c-2.68,5.15-9.21,17.34-11.54,21.91c-3.35-7.43-15.73-36.69-19.23-44.24c-1.3-3.22,3.73-5.08,6.65-5.21
		l0.02-2.15L0,17.4c0.01,0.65,0.03,1.71,0.03,2.19c4.03-0.04,9.91,6.57,11.59,10.68
		c7.24,16.81,14.72,33.52,21.93,50.35c0,0.03,2.26,0.06,2.28,0.01c4.72-9.65,10.23-19.8,15.21-29.56
		L63.59,80.64c0.01,0,2.08,0.02,2.09,0.01c7.96-18.2,19.89-46.12,23.79-54.93c1.59-3.77,4.25-6.06,8.54-6.19
		l0.03-1.96L98.02,17.47z'
        />
      </g>
    </svg>
  )
}

export function HunterIOIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='20'
      height='19'
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.07 8.43C11.66 8.55 11.22 8.55 10.8 8.54C10.31 8.51 9.8 8.45 9.35 8.25C8.98 8.09 8.69 7.79 8.84 7.37C8.95 7.07 9.19 6.8 9.47 6.65C9.79 6.48 10.13 6.5 10.45 6.66C10.8 6.83 11.09 7.11 11.36 7.4C11.5 7.55 11.63 7.7 11.76 7.86C11.83 7.93 12.24 8.34 12.07 8.43ZM18.79 8.58C18.17 8.44 17.43 8.49 16.81 8.39C15.83 8.23 14.36 7.09 13.57 5.92C13.02 5.11 12.76 4.29 12.34 3.28C12.04 2.58 11.4 0.37 10.5 1.4C10.13 1.83 9.72 3.24 9.42 3.22C9.19 3.27 9.16 2.83 9.09 2.65C8.96 2.31 8.89 1.92 8.72 1.6C8.58 1.34 8.4 1.04 8.12 0.91C7.63 0.66 7.04 1.42 6.74 2.33C6.61 2.82 5.77 3.76 5.4 3.99C3.72 5.02 0.34 6.12 0 9.75C0 9.77 0 9.81 0.06 9.77C0.46 9.48 5.02 6.2 2.09 12.55C0.3 16.44 8.96 18.92 9.41 18.93C9.47 18.93 9.46 18.9 9.46 18.88C10.15 12.67 16.98 13.33 18.57 11.84C20.15 10.36 20.18 8.94 18.79 8.58Z'
        fill='#FA5320'
      />
    </svg>
  )
}

export function MicrosoftOneDriveIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='35.98 139.2 648.03 430.85' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <radialGradient
          id={`onedrive_radial0_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(130.864814,156.804864,-260.089994,217.063603,48.669602,228.766494)'
        >
          <stop offset='0' stopColor='rgb(28.235294%,58.039216%,99.607843%)' stopOpacity={1} />
          <stop
            offset='0.695072'
            stopColor='rgb(3.529412%,20.392157%,70.196078%)'
            stopOpacity={1}
          />
        </radialGradient>
        <radialGradient
          id={`onedrive_radial1_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(-575.289668,663.594003,-491.728488,-426.294267,596.956501,-6.380235)'
        >
          <stop
            offset='0.165327'
            stopColor='rgb(13.72549%,75.294118%,99.607843%)'
            stopOpacity={1}
          />
          <stop offset='0.534' stopColor='rgb(10.980392%,56.862745%,100%)' stopOpacity={1} />
        </radialGradient>
        <radialGradient
          id={`onedrive_radial2_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(-136.753383,-114.806698,262.816935,-313.057562,181.196995,240.395994)'
        >
          <stop offset='0' stopColor='rgb(100%,100%,100%)' stopOpacity={0.4} />
          <stop offset='0.660528' stopColor='rgb(67.843137%,75.294118%,100%)' stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id={`onedrive_radial3_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(-153.638428,-130.000063,197.433014,-233.332948,375.353994,451.43549)'
        >
          <stop offset='0' stopColor='rgb(1.176471%,22.745098%,80%)' stopOpacity={1} />
          <stop offset='1' stopColor='rgb(21.176471%,55.686275%,100%)' stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id={`onedrive_radial4_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(175.585899,405.198026,-437.434522,189.555055,169.378495,125.589294)'
        >
          <stop
            offset='0.592618'
            stopColor='rgb(20.392157%,39.215686%,89.019608%)'
            stopOpacity={0}
          />
          <stop offset='1' stopColor='rgb(1.176471%,22.745098%,80%)' stopOpacity={0.6} />
        </radialGradient>
        <radialGradient
          id={`onedrive_radial5_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(-459.329491,459.329491,-719.614455,-719.614455,589.876499,39.484649)'
        >
          <stop
            offset='0'
            stopColor='rgb(29.411765%,99.215686%,90.980392%)'
            stopOpacity={0.898039}
          />
          <stop
            offset='0.543937'
            stopColor='rgb(29.411765%,99.215686%,90.980392%)'
            stopOpacity={0}
          />
        </radialGradient>
        <linearGradient
          id={`onedrive_linear0_${id}`}
          gradientUnits='userSpaceOnUse'
          x1='29.999701'
          y1='37.9823'
          x2='29.999701'
          y2='18.398199'
          gradientTransform='matrix(15,0,0,15,0,0)'
        >
          <stop offset='0' stopColor='rgb(0%,52.54902%,100%)' stopOpacity={1} />
          <stop offset='0.49' stopColor='rgb(0%,73.333333%,100%)' stopOpacity={1} />
        </linearGradient>
        <radialGradient
          id={`onedrive_radial6_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(273.622108,108.513684,-205.488428,518.148261,296.488495,307.441492)'
        >
          <stop offset='0' stopColor='rgb(100%,100%,100%)' stopOpacity={0.4} />
          <stop offset='0.785262' stopColor='rgb(100%,100%,100%)' stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id={`onedrive_radial7_${id}`}
          gradientUnits='userSpaceOnUse'
          cx='0'
          cy='0'
          fx='0'
          fy='0'
          r='1'
          gradientTransform='matrix(-305.683909,263.459223,-264.352324,-306.720147,674.845505,249.378004)'
        >
          <stop
            offset='0'
            stopColor='rgb(29.411765%,99.215686%,90.980392%)'
            stopOpacity={0.898039}
          />
          <stop
            offset='0.584724'
            stopColor='rgb(29.411765%,99.215686%,90.980392%)'
            stopOpacity={0}
          />
        </radialGradient>
      </defs>
      <path
        fill={`url(#onedrive_radial0_${id})`}
        fillRule='nonzero'
        d='M 215.08 205.09 C 116.01 205.09 41.96 286.19 36.38 376.53 C 39.84 395.99 51.18 434.43 68.94 432.46 C 91.14 429.99 147.07 432.46 194.77 346.11 C 229.61 283.03 301.29 205.09 215.08 205.09 Z M 215.08 205.09 '
      />
      <path
        fill={`url(#onedrive_radial1_${id})`}
        fillRule='nonzero'
        d='M 192.17 238.81 C 158.87 291.54 114.04 367.09 98.91 390.86 C 80.93 419.12 33.3 407.11 37.25 366.61 C 36.86 369.89 36.56 373.21 36.36 376.55 C 29.84 481.93 113.4 569.45 217.38 569.45 C 331.97 569.45 605.27 426.67 577.61 283.61 C 548.46 199.52 466.52 139.2 373.66 139.2 C 280.81 139.2 221.3 192.7 192.17 238.81 Z M 192.17 238.81 '
      />
      <path
        fill={`url(#onedrive_radial2_${id})`}
        fillRule='nonzero'
        d='M 192.17 238.81 C 158.87 291.54 114.04 367.09 98.91 390.86 C 80.93 419.12 33.3 407.11 37.25 366.61 C 36.86 369.89 36.56 373.21 36.36 376.55 C 29.84 481.93 113.4 569.45 217.38 569.45 C 331.97 569.45 605.27 426.67 577.61 283.61 C 548.46 199.52 466.52 139.2 373.66 139.2 C 280.81 139.2 221.3 192.7 192.17 238.81 Z M 192.17 238.81 '
      />
      <path
        fill={`url(#onedrive_radial3_${id})`}
        fillRule='nonzero'
        d='M 192.17 238.81 C 158.87 291.54 114.04 367.09 98.91 390.86 C 80.93 419.12 33.3 407.11 37.25 366.61 C 36.86 369.89 36.56 373.21 36.36 376.55 C 29.84 481.93 113.4 569.45 217.38 569.45 C 331.97 569.45 605.27 426.67 577.61 283.61 C 548.46 199.52 466.52 139.2 373.66 139.2 C 280.81 139.2 221.3 192.7 192.17 238.81 Z M 192.17 238.81 '
      />
      <path
        fill={`url(#onedrive_radial4_${id})`}
        fillRule='nonzero'
        d='M 192.17 238.81 C 158.87 291.54 114.04 367.09 98.91 390.86 C 80.93 419.12 33.3 407.11 37.25 366.61 C 36.86 369.89 36.56 373.21 36.36 376.55 C 29.84 481.93 113.4 569.45 217.38 569.45 C 331.97 569.45 605.27 426.67 577.61 283.61 C 548.46 199.52 466.52 139.2 373.66 139.2 C 280.81 139.2 221.3 192.7 192.17 238.81 Z M 192.17 238.81 '
      />
      <path
        fill={`url(#onedrive_radial5_${id})`}
        fillRule='nonzero'
        d='M 192.17 238.81 C 158.87 291.54 114.04 367.09 98.91 390.86 C 80.93 419.12 33.3 407.11 37.25 366.61 C 36.86 369.89 36.56 373.21 36.36 376.55 C 29.84 481.93 113.4 569.45 217.38 569.45 C 331.97 569.45 605.27 426.67 577.61 283.61 C 548.46 199.52 466.52 139.2 373.66 139.2 C 280.81 139.2 221.3 192.7 192.17 238.81 Z M 192.17 238.81 '
      />
      <path
        fill={`url(#onedrive_linear0_${id})`}
        fillRule='nonzero'
        d='M 215.7 569.5 C 215.7 569.5 489.32 570.04 535.73 570.04 C 619.96 570.04 684 501.27 684 421.03 C 684 340.79 618.67 272.45 535.73 272.45 C 452.79 272.45 405.03 334.49 369.15 402.23 C 327.12 481.59 273.49 568.55 215.7 569.5 Z M 215.7 569.5 '
      />
      <path
        fill={`url(#onedrive_radial6_${id})`}
        fillRule='nonzero'
        d='M 215.7 569.5 C 215.7 569.5 489.32 570.04 535.73 570.04 C 619.96 570.04 684 501.27 684 421.03 C 684 340.79 618.67 272.45 535.73 272.45 C 452.79 272.45 405.03 334.49 369.15 402.23 C 327.12 481.59 273.49 568.55 215.7 569.5 Z M 215.7 569.5 '
      />
      <path
        fill={`url(#onedrive_radial7_${id})`}
        fillRule='nonzero'
        d='M 215.7 569.5 C 215.7 569.5 489.32 570.04 535.73 570.04 C 619.96 570.04 684 501.27 684 421.03 C 684 340.79 618.67 272.45 535.73 272.45 C 452.79 272.45 405.03 334.49 369.15 402.23 C 327.12 481.59 273.49 568.55 215.7 569.5 Z M 215.7 569.5 '
      />
    </svg>
  )
}

export function MicrosoftWordIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const bodyId = `word_body_${id}`
  const midId = `word_mid_${id}`
  const midGlowId = `word_mid_glow_${id}`
  const midShadeId = `word_mid_shade_${id}`
  const topId = `word_top_${id}`
  const topGlowId = `word_top_glow_${id}`
  const tileId = `word_tile_${id}`
  const tileGlowId = `word_tile_glow_${id}`

  const midPath =
    'M5,15.04c0-2.49,2.01-4.5,4.5-4.5h20.39l5.11-2.54v12.5c0,1.93-1.57,3.5-3.5,3.5H11c-3.31,0-6,2.69-6,6v-14.96Z'
  const topPath =
    'M5,6C5,2.69,7.69,0,11,0h20.5c1.93,0,3.5,1.57,3.5,3.5v5c0,1.93-1.57,3.5-3.5,3.5H11c-3.31,0-6,2.69-6,6V6Z'

  return (
    <svg {...props} viewBox='0 0 35 36' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <radialGradient
          id={bodyId}
          cx='-619.29'
          cy='488.84'
          fx='-619.29'
          fy='488.84'
          r='1'
          gradientTransform='translate(29495.74 9885.89) scale(47.57 -20.15)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='.18' stopColor='#1657f4' />
          <stop offset='.57' stopColor='#0036c4' />
        </radialGradient>
        <linearGradient
          id={midId}
          x1='5'
          y1='97'
          x2='27.97'
          y2='97'
          gradientTransform='translate(0 116) scale(1 -1)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#66c0ff' />
          <stop offset='.26' stopColor='#0094f0' />
        </linearGradient>
        <radialGradient
          id={midGlowId}
          cx='-637.72'
          cy='517.98'
          fx='-637.72'
          fy='517.98'
          r='1'
          gradientTransform='translate(-40017.96 -12225.34) rotate(133.55) scale(29.36 -72.32)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='.14' stopColor='#d471ff' />
          <stop offset='.83' stopColor='#509df5' stopOpacity='0' />
        </radialGradient>
        <radialGradient
          id={midShadeId}
          cx='-611.76'
          cy='514.18'
          fx='-611.76'
          fy='514.18'
          r='1'
          gradientTransform='translate(-52234.57 11411.47) rotate(90) scale(18.62 -101.65)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='.28' stopColor='#4f006f' stopOpacity='0' />
          <stop offset='1' stopColor='#4f006f' />
        </radialGradient>
        <linearGradient
          id={topId}
          x1='5'
          y1='107.22'
          x2='35'
          y2='106.72'
          gradientTransform='translate(0 116) scale(1 -1)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#9deaff' />
          <stop offset='.2' stopColor='#3bd5ff' />
        </linearGradient>
        <radialGradient
          id={topGlowId}
          cx='-650.27'
          cy='515.34'
          fx='-650.27'
          fy='515.34'
          r='1'
          gradientTransform='translate(-26921.47 -31089.42) rotate(166.85) scale(29.49 -70.64)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='.06' stopColor='#e4a7fe' />
          <stop offset='.54' stopColor='#e4a7fe' stopOpacity='0' />
        </radialGradient>
        <radialGradient
          id={tileId}
          cx='-600.8'
          cy='515.58'
          fx='-600.8'
          fy='515.58'
          r='1'
          gradientTransform='translate(1363.5 17878.99) rotate(45) scale(22.63 -22.63)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='.08' stopColor='#367af2' />
          <stop offset='.87' stopColor='#001a8f' />
        </radialGradient>
        <radialGradient
          id={tileGlowId}
          cx='-598.04'
          cy='557.24'
          fx='-598.04'
          fy='557.24'
          r='1'
          gradientTransform='translate(-7105.12 6724.6) rotate(90) scale(11.2 -12.77)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='.59' stopColor='#2763e5' stopOpacity='0' />
          <stop offset='.97' stopColor='#58aafe' />
        </radialGradient>
      </defs>
      <path
        d='M5,27.09l14-17.09,16,11.11v11.39c0,1.93-1.57,3.5-3.5,3.5H11c-3.31,0-6-2.69-6-6v-2.91Z'
        fill={`url(#${bodyId})`}
      />
      <path d={midPath} fill={`url(#${midId})`} />
      <path d={midPath} fill={`url(#${midGlowId})`} fillOpacity='.6' />
      <path d={midPath} fill={`url(#${midShadeId})`} fillOpacity='.1' />
      <path d={topPath} fill={`url(#${topId})`} />
      <path d={topPath} fill={`url(#${topGlowId})`} fillOpacity='.8' />
      <rect y='17' width='16' height='16' rx='3.25' ry='3.25' fill={`url(#${tileId})`} />
      <rect
        y='17'
        width='16'
        height='16'
        rx='3.25'
        ry='3.25'
        fill={`url(#${tileGlowId})`}
        fillOpacity='.65'
      />
      <path
        d='M13.49,20.43l-1.97,9.14h-2.35s-1.16-5.48-1.16-5.48l-1.22,5.49h-2.38l-1.89-9.14h1.94l1.17,6.03,1.16-6.03h2.38l1.21,6.03,1.14-6.03h1.97Z'
        fill='#fff'
      />
    </svg>
  )
}

export function MicrosoftSharepointIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill='currentColor' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
      <circle fill='#036C70' cx='16.31' cy='8.90' r='8.90' />
      <circle fill='#1A9BA1' cx='23.72' cy='17.05' r='8.15' />
      <circle fill='#37C6D0' cx='17.42' cy='24.83' r='6.30' />
      <path
        fill='#000000'
        opacity='0.1'
        d='M17.79,8.03v15.82c0,0.55-0.34,1.04-0.85,1.25c-0.16,0.07-0.34,0.10-0.51,0.10H11.13c-0.01-0.13-0.01-0.24-0.01-0.37c0-0.12,0-0.25,0.01-0.37c0.14-2.37,1.59-4.46,3.77-5.40v-1.38c-4.85-0.77-8.15-5.32-7.39-10.17c0.01-0.03,0.01-0.07,0.02-0.10c0.04-0.25,0.09-0.50,0.16-0.74h8.74c0.74,0,1.36,0.60,1.36,1.36z'
      />
      <path
        fill='#000000'
        opacity='0.2'
        d='M15.69,7.41H7.54c-0.82,4.84,2.43,9.43,7.27,10.25c0.15,0.02,0.29,0.05,0.44,0.06c-2.30,1.09-3.97,4.18-4.12,6.73c-0.01,0.12-0.02,0.25-0.01,0.37c0,0.13,0,0.24,0.01,0.37c0.01,0.25,0.05,0.50,0.10,0.74h4.47c0.55,0,1.04-0.34,1.25-0.85c0.07-0.16,0.10-0.34,0.10-0.51V8.77c0-0.75-0.61-1.36-1.36-1.36z'
      />
      <path
        fill='#000000'
        opacity='0.2'
        d='M15.69,7.41H7.54c-0.82,4.84,2.43,9.43,7.27,10.26c0.10,0.02,0.20,0.03,0.30,0.05c-2.22,1.17-3.83,4.26-3.97,6.75h4.56c0.75,0,1.35-0.61,1.36-1.36V8.77c0-0.75-0.61-1.36-1.36-1.36z'
      />
      <path
        fill='#000000'
        opacity='0.2'
        d='M14.95,7.41H7.54c-0.78,4.57,2.08,8.97,6.58,10.11c-1.84,2.43-2.27,5.61-2.58,7.22h3.82c0.75,0,1.35-0.61,1.36-1.36V8.77c0-0.75-0.61-1.36-1.36-1.36z'
      />
      <path
        fill='#008789'
        d='M1.36,7.41h13.58c0.75,0,1.36,0.61,1.36,1.36v13.58c0,0.75-0.61,1.36-1.36,1.36H1.36c-0.75,0-1.36-0.61-1.36-1.36V8.77C0,8.02,0.61,7.41,1.36,7.41z'
      />
      <path
        fill='#FFFFFF'
        d='M6.07,15.42c-0.32-0.21-0.58-0.49-0.78-0.82c-0.19-0.34-0.28-0.73-0.27-1.12c-0.02-0.53,0.16-1.05,0.50-1.46c0.36-0.41,0.82-0.71,1.34-0.87c0.59-0.19,1.21-0.29,1.83-0.28c0.82-0.03,1.63,0.08,2.41,0.34v1.71c-0.34-0.20-0.71-0.35-1.09-0.44c-0.42-0.10-0.84-0.15-1.27-0.15c-0.45-0.02-0.90,0.08-1.31,0.28c-0.31,0.14-0.52,0.44-0.52,0.79c0,0.21,0.08,0.41,0.22,0.56c0.17,0.18,0.37,0.32,0.59,0.42c0.25,0.12,0.62,0.29,1.11,0.49c0.05,0.02,0.11,0.04,0.16,0.06c0.49,0.19,0.96,0.42,1.40,0.69c0.34,0.21,0.62,0.49,0.83,0.83c0.21,0.39,0.31,0.82,0.30,1.26c0.02,0.54-0.14,1.08-0.47,1.52c-0.33,0.40-0.77,0.69-1.26,0.85c-0.58,0.18-1.19,0.27-1.80,0.26c-0.55,0-1.09-0.04-1.63-0.13c-0.45-0.07-0.90-0.20-1.32-0.39v-1.80c0.40,0.29,0.86,0.50,1.34,0.64c0.48,0.15,0.97,0.23,1.47,0.24c0.46,0.03,0.92-0.07,1.34-0.28c0.29-0.16,0.46-0.47,0.46-0.80c0-0.23-0.09-0.45-0.25-0.61c-0.20-0.20-0.44-0.36-0.69-0.48c-0.30-0.15-0.73-0.34-1.31-0.59C6.91,16.14,6.48,15.80,6.07,15.42z'
      />
    </svg>
  )
}

export function MicrosoftPlannerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.26 15.74C7.22 16.77 5.55 16.77 4.52 15.74L0.77 12C-0.26 10.97 -0.26 9.29 0.77 8.26L4.52 4.52C5.55 3.48 7.22 3.48 8.26 4.52L12 8.26C13.03 9.29 13.03 10.97 12 12L8.26 15.74Z'
        fill='#185ABD'
      />
      <path
        d='M0.77 12C1.81 13.03 3.48 13.03 4.52 12L15.74 0.77C16.77 -0.26 18.45 -0.26 19.48 0.77L23.23 4.52C24.26 5.55 24.26 7.22 23.23 8.26L12 19.48C10.97 20.52 9.29 20.52 8.26 19.48L0.77 12Z'
        fill='#41A5EE'
      />
      <path
        d='M4.52 15.74C5.55 16.77 7.22 16.77 8.26 15.74L15.74 8.26C16.77 7.22 18.45 7.22 19.48 8.26L23.22 12C24.26 13.03 24.26 14.71 23.22 15.74L15.74 23.22C14.71 24.26 13.03 24.26 12 23.22L4.52 15.74Z'
        fill='#2B7CD3'
      />
    </svg>
  )
}

export function ParallelIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      width='271'
      height='270'
      viewBox='0 0 271 270'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M267.8 105.65H193.83C194.03 106.81 194.19 108 194.35 109.18H76.67C76.45 110.74 76.24 112.31 76.06 113.87H1.63C1.27 116.2 0.95 118.54 0.7 120.93H75.38C75.25 122.48 75.16 124.06 75.07 125.62H195.95C196 126.78 196.06 127.96 196.09 129.14H270.68V125.38C270.2 118.65 269.24 112.06 267.8 105.65Z'
        fill='currentColor'
      />
      <path
        d='M195.95 144.4H75.07C75.14 145.98 75.25 147.54 75.38 149.09H0.7C0.95 151.46 1.26 153.8 1.63 156.15H76.06C76.24 157.72 76.44 159.28 76.67 160.84H194.35C194.19 162.02 194.01 163.19 193.83 164.37H267.8C269.24 157.96 270.2 151.37 270.68 144.63V140.87H196.09C196.06 142.06 196 143.22 195.95 144.4Z'
        fill='currentColor'
      />
      <path
        d='M190.63 179.64H80.36C80.75 181.22 81.18 182.78 81.61 184.33H9.31C10.24 186.72 11.25 189.06 12.31 191.39H83.75C84.27 192.97 84.8 194.52 85.35 196.08H185.59C185.16 197.26 184.73 198.43 184.28 199.61H254.52C258.6 192.18 261.98 184.32 264.6 176.11H191.46C191.19 177.3 190.9 178.46 190.61 179.64H190.63Z'
        fill='currentColor'
      />
      <path
        d='M177.67 214.88H93.34C94.11 216.46 94.92 218.03 95.74 219.57H29.88C31.84 221.99 33.87 224.34 35.97 226.63H99.66C100.6 228.21 101.55 229.78 102.52 231.32H168.5C167.76 232.5 167.01 233.69 166.23 234.85H226.76C234.47 227.85 241.36 219.95 247.29 211.36H179.36C178.8 212.54 178.26 213.72 177.68 214.88H177.67Z'
        fill='currentColor'
      />
      <path
        d='M154.94 250.11H116.06C117.37 251.7 118.7 253.26 120.07 254.8H73.02C91.61 264.43 112.72 269.95 135.1 270C135.24 270 135.37 270 135.49 270C135.62 270 135.76 270 135.89 270C164.04 269.91 190.18 261.28 211.81 246.56H157.75C156.81 247.74 155.88 248.92 154.93 250.09L154.94 250.11Z'
        fill='currentColor'
      />
      <path
        d='M116.06 19.91H154.94C155.9 21.08 156.83 22.26 157.77 23.44H211.82C190.18 8.72 164.06 0.09 135.91 0C135.76 0 135.64 0 135.51 0C135.38 0 135.24 0 135.12 0C112.72 0.07 91.63 5.57 73.04 15.2H120.09C118.72 16.74 117.39 18.32 116.08 19.89L116.06 19.91Z'
        fill='currentColor'
      />
      <path
        d='M93.34 55.15H177.67C178.24 56.32 178.8 57.5 179.34 58.68H247.27C241.34 50.09 234.46 42.19 226.74 35.19H166.22C166.99 36.35 167.74 37.53 168.48 38.71H102.5C101.53 40.27 100.58 41.83 99.65 43.41H35.95C33.83 45.68 31.8 48.03 29.86 50.46H95.73C94.9 52.02 94.11 53.58 93.32 55.15H93.34Z'
        fill='currentColor'
      />
      <path
        d='M80.37 90.38H190.65C190.93 91.54 191.22 92.72 191.49 93.9H264.64C262.02 85.7 258.64 77.84 254.56 70.41H184.32C184.77 71.57 185.2 72.76 185.63 73.94H85.39C84.83 75.5 84.29 77.05 83.79 78.63H12.35C11.29 80.94 10.28 83.28 9.35 85.68H81.65C81.22 87.24 80.79 88.8 80.39 90.38H80.37Z'
        fill='currentColor'
      />
    </svg>
  )
}

/**
 * Microsoft SQL Server brand mark. Multi-color artwork, so the fills stay
 * hardcoded and no `iconColor` is set.
 */
export function MicrosoftSqlIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#cfd8dc'
        d='M23.084,11.277c-1.633-2.449-1.986-5.722-2.063-7.067c-4.148,0.897-8.269,2.506-8.031,3.691 c0.03,0.149,0.218,0.328,0.53,0.502l-0.488,0.873c-0.596-0.334-0.931-0.719-1.022-1.179c-0.269-1.341,1.25-2.554,4.642-3.709 c2.316-0.789,4.652-1.26,4.751-1.279l0.597-0.12L22,3.6c0,0.042,0.026,4.288,1.916,7.123L23.084,11.277z'
      />
      <path
        fill='#cfd8dc'
        d='M24.751,43H24.5c-8.192,0-17.309-2.573-18.386-6.879c-0.657-2.63,1.492-5.536,6.214-8.401 l0.52,0.854c-4.249,2.579-6.296,5.172-5.763,7.305c0.935,3.738,9.575,6.068,17.153,6.12c0.901-1.347,5.742-9.26,2.979-19.873 l0.967-0.252c3.149,12.092-3.218,20.837-3.282,20.924L24.751,43z'
      />
      <path
        fill='#cfd8dc'
        d='M9.931,39.306c-0.539,0-0.806-0.059-0.85-0.07c-0.176-0.043-0.314-0.178-0.362-0.352 c-0.049-0.174,0.001-0.361,0.129-0.488c0.072-0.072,7.197-7.208,8.159-12.978l0.986,0.164c-0.827,4.964-5.715,10.623-7.656,12.707 c1.939-0.111,6.835-1.019,16.234-6.28c-7.335-0.804-8.495-6.676-8.507-6.739l0.983-0.181c0.047,0.246,1.226,6.011,9.244,6.011 c0.003,0,0.005,0,0.008,0l0,0c0.227,0,0.424,0.152,0.482,0.37c0.06,0.218-0.036,0.449-0.231,0.563 C17.315,38.542,11.867,39.305,9.931,39.306z'
      />
      <path
        fill='#cfd8dc'
        d='M14.524,41.7c-0.207,0-0.395-0.128-0.468-0.325c-0.079-0.211-0.007-0.45,0.177-0.582 c0.034-0.025,1.813-1.338,3.706-4.228c-0.728-0.322-1.465-0.698-2.196-1.137c-0.888-0.533-1.559-1.105-2.06-1.691 c-2.57,0.678-4.942,0.946-7.025,0.769l0.084-0.996c1.876,0.159,4.009-0.063,6.321-0.64c-1.573-2.688-0.129-5.356-0.109-5.392 l0.874,0.487c-0.067,0.122-1.265,2.37,0.249,4.633c2.201-0.632,4.549-1.567,6.979-2.782c0.559-1.835,0.996-3.922,1.225-6.276 c0.016-0.161,0.108-0.304,0.248-0.385s0.311-0.088,0.458-0.021c0.032,0.015,3.264,1.491,5.604,2.454 c0.17,0.07,0.288,0.228,0.307,0.411c0.02,0.183-0.063,0.361-0.216,0.465c-2.289,1.56-4.563,2.913-6.778,4.042 c-0.702,2.225-1.571,4.077-2.459,5.591c3.702,1.383,6.915,1.404,6.956,1.404c0.228,0,0.427,0.154,0.484,0.375 c0.057,0.221-0.042,0.452-0.241,0.563c-4.54,2.522-11.767,3.232-12.072,3.261C14.556,41.699,14.54,41.7,14.524,41.7z M18.909,36.967c-1.04,1.614-2.062,2.773-2.826,3.53c1.998-0.294,5.501-0.938,8.408-2.139 C23.099,38.187,21.084,37.807,18.909,36.967z M14.767,33.431c0.393,0.392,0.883,0.775,1.49,1.14 c0.736,0.442,1.483,0.817,2.22,1.135c0.754-1.264,1.501-2.781,2.142-4.568C18.598,32.1,16.636,32.868,14.767,33.431z M23.202,24.329c-0.205,1.768-0.521,3.381-0.913,4.85c1.66-0.885,3.354-1.896,5.062-3.026 C25.802,25.497,24.099,24.734,23.202,24.329z'
      />
      <path
        fill='#cfd8dc'
        d='M17.924,10.6c-0.117,0-0.233-0.042-0.325-0.12c-1.61-1.378-3.505-4.182-3.585-4.301 c-0.129-0.191-0.109-0.446,0.046-0.616c0.154-0.171,0.408-0.211,0.608-0.102c0.011,0.003,0.938,0.385,7.217,1.431 c0.181,0.03,0.33,0.156,0.39,0.328c0.061,0.172,0.022,0.364-0.1,0.5c-1.758,1.953-3.979,2.813-4.073,2.848 C18.044,10.589,17.983,10.6,17.924,10.6z M15.647,6.746c0.631,0.849,1.54,1.996,2.372,2.769c0.511-0.233,1.657-0.818,2.744-1.798 C18.18,7.276,16.604,6.962,15.647,6.746z'
      />
      <path
        fill='#b71c1c'
        d='M21.843,24.4c-0.068,0-0.137-0.014-0.201-0.042c-0.199-0.088-0.319-0.294-0.296-0.51 c0.292-2.749-3.926-3.852-3.969-3.862c-0.174-0.044-0.312-0.179-0.359-0.352s0.002-0.359,0.129-0.486 c0.207-0.207,5.139-5.098,11.327-7.784c0.173-0.075,0.369-0.047,0.515,0.07c0.145,0.118,0.212,0.307,0.174,0.489 c-1.186,5.744-6.71,12.044-6.944,12.309C22.12,24.341,21.982,24.4,21.843,24.4z M18.455,19.285 c1.184,0.445,3.258,1.475,3.783,3.356c1.449-1.808,4.542-5.973,5.697-9.934C23.548,14.817,19.854,17.999,18.455,19.285z'
      />
      <path
        fill='#b71c1c'
        d='M13.079,28.36l-0.475-0.88c1.883-1.015,4.04-2.883,5.807-5.054c-1.504,1.03-2.365,1.735-2.392,1.758 l-0.639-0.77c0.039-0.032,1.764-1.447,4.631-3.22c0.787-1.266,1.392-2.568,1.703-3.816c0.053-0.212,0.099-0.417,0.136-0.615 c-1.925-0.687-3.701-1.094-4.921-1.269c-0.185-0.026-0.339-0.153-0.401-0.328c-0.062-0.175-0.021-0.371,0.104-0.507 c0.085-0.092,2.116-2.268,4.654-3.463c0.197-0.093,0.433-0.047,0.581,0.114c0.067,0.073,1.44,1.615,1.091,4.805 c1.155,0.45,2.345,0.997,3.491,1.648c2.759-1.24,5.892-2.356,9.229-3.03c0.172-0.034,0.363,0.028,0.481,0.168 c0.117,0.14,0.149,0.333,0.083,0.503c-1.3,3.332-4.786,6.891-4.934,7.041c-0.101,0.102-0.239,0.153-0.383,0.148 c-0.143-0.008-0.275-0.076-0.365-0.188c-1.12-1.408-2.584-2.574-4.163-3.523c-2.175,1.004-4.101,2.078-5.684,3.049 C18.693,24.084,15.644,26.979,13.079,28.36z M27.492,17.396c1.29,0.832,2.491,1.81,3.484,2.948 c0.828-0.898,2.815-3.168,3.942-5.422C32.268,15.532,29.76,16.415,27.492,17.396z M22.799,16.122 c-0.033,0.163-0.071,0.33-0.113,0.5c-0.21,0.839-0.544,1.701-0.972,2.561c1.096-0.626,2.309-1.272,3.618-1.898 C24.494,16.841,23.639,16.455,22.799,16.122z M18.048,13.672c1.111,0.218,2.48,0.574,3.941,1.086 c0.152-1.843-0.346-2.972-0.647-3.472C19.966,12.004,18.761,13.014,18.048,13.672z'
      />
      <path
        fill='#b71c1c'
        d='M18.05,18.5c0,4.38-3.65,7.86-6.28,10.4c-0.44,0.43-1.93,0.5-1.93,0.5 c0.37-0.38,0.79-0.78,1.24-1.21c2.5-2.42,5.97-5.73,5.97-9.69c0-4.69-1.89-6.54-3.38-8.02c-0.66-0.67-1.22-1.31-1.56-2.09 l0.31-0.13c0.34,0.15,0.73,0.32,1.03,0.45c0.24,0.35,0.56,0.69,0.93,1.06C15.91,11.3,18.05,13.4,18.05,18.5z'
      />
      <path
        fill='#b71c1c'
        d='M42.935,19.794c0,0-0.605,0.086-0.775,0.106c-8.76,0.97-17.8,3.49-22.97,5.56 c-1.87,0.75-3.81,1.66-5.58,2.68c-0.01,0.01-0.02,0.01-0.04,0.02C12.53,28.76,10,30,7.95,31.09c3-3.19,8.62-5.65,10.86-6.55 c5.07-2.03,13.78-4.48,22.35-5.53c-1.01-1.18-3.48-3.68-8.34-5.54c-2.84-1.1-7.16-1.72-10.97-2.27c-6.06-0.87-9.51-1.45-9.84-3.1 c-0.07-0.33-0.02-0.66,0.13-0.98c0.33,0.54,0.8,0.92,1.11,1.14c0.15,0.1,0.26,0.16,0.3,0.18l0.01,0.01 c1.42,0.75,5.25,1.3,8.44,1.76c3.86,0.56,8.23,1.19,11.18,2.32c6.87,2.65,9.24,6.44,9.34,6.6 C42.61,19.28,42.935,19.794,42.935,19.794z'
      />
    </svg>
  )
}

export function PostgresIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='-4 0 264 264'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMinYMin meet'
    >
      <path d='M255.01 158.09c-1.53-4.65-5.56-7.89-10.76-8.66-2.45-.366-5.26-.21-8.58.475-5.79 1.2-10.09 1.65-13.22 1.74 11.84-19.98 21.46-42.77 27-64.23 8.96-34.69 4.17-50.49-1.42-57.64C233.22 10.85 211.61.683 185.55.372c-13.9-.17-26.11 2.58-32.47 4.55-5.93-1.05-12.3-1.63-18.99-1.74-12.54-.2-23.61 2.53-33.08 8.15-5.24-1.77-13.65-4.27-23.36-5.86-22.84-3.75-41.25-.828-54.72 8.69C6.62 25.67-.937 45.68.461 73.63c.444 8.87 5.41 35.87 13.22 61.48 4.49 14.72 9.28 26.94 14.24 36.33 7.03 13.32 14.55 21.16 22.99 23.97 4.73 1.58 13.33 2.68 22.37-4.85 1.15 1.39 2.68 2.77 4.7 4.05 2.58 1.63 5.73 2.95 8.88 3.74 11.34 2.84 21.96 2.13 31.03-1.85.056 1.61.099 3.15.135 4.48.06 2.16.12 4.27.199 6.25.54 13.37 1.45 23.77 4.14 31.05.148.4.35 1.1.56 1.66 1.35 4.12 3.59 11.01 9.32 16.41 5.93 5.59 13.09 7.31 19.66 7.31 3.29 0 6.43-.432 9.19-1.02 9.82-2.1 20.97-5.31 29.04-16.8 7.63-10.86 11.34-27.22 12.01-52.99.09-.729.17-1.42.244-2.09l.16-1.36 1.8.158.46.031c10.002.456 22.232-1.665 29.743-5.154 5.935-2.754 24.954-12.795 20.476-26.351' />
      <path
        d='M237.91 160.72c-29.74 6.14-31.78-3.93-31.78-3.93 31.4-46.59 44.53-105.74 33.2-120.21-30.9-39.48-84.4-20.81-85.29-20.33l-.287.05c-5.88-1.22-12.45-1.95-19.84-2.07-13.46-.22-23.66 3.53-31.41 9.4 0 0-95.43-39.31-90.99 49.44.944 18.88 27.06 142.87 58.22 105.42 11.39-13.69 22.39-25.27 22.39-25.27 5.46 3.63 12.01 5.48 18.86 4.82l.533-.452c-.166 1.7-.09 3.36.213 5.33-8.03 8.97-5.67 10.54-21.71 13.84-16.23 3.35-6.7 9.3-.471 10.86 7.55 1.89 25.01 4.56 36.81-11.96l-.47 1.89c3.14 2.52 5.35 16.38 4.98 28.95-.37 12.57-.617 21.2 1.86 27.94 2.48 6.74 4.95 21.91 26.04 17.39 17.62-3.78 26.76-13.56 28.03-29.89.9-11.61 2.94-9.89 3.07-20.27l1.64-4.91c1.89-15.73.3-20.81 11.16-18.45l2.64.23c7.99.36 18.45-1.29 24.59-4.14 13.22-6.13 21.06-16.38 8.02-13.69h.002'
        fill='#336791'
      />
      <path
        d='M108.08 81.53c-2.68-.373-5.11-.028-6.33.902-.69.52-.904 1.13-.962 1.55-.154 1.11.62 2.33 1.1 2.96 1.35 1.78 3.31 3.01 5.26 3.28.28.4.56.58.84.058 3.25 0 6.2-2.53 6.46-4.39.325-2.34-3.07-3.89-6.35-4.35M196.86 81.6c-.256-1.83-3.51-2.35-6.61-1.92-3.09.43-6.08 1.82-5.83 3.66.2 1.43 2.78 3.86 5.83 3.86.258 0 .518-.017.78-.054 2.04-.282 3.53-1.57 4.24-2.32 1.08-1.14 1.71-2.4 1.59-3.22'
        fill='#FFF'
      />
      <path
        d='M247.8 160.03c-1.13-3.43-4.78-4.53-10.85-3.28-18 3.72-24.45 1.14-26.57-.417 14-21.32 25.51-47.09 31.72-71.14 2.94-11.39 4.57-21.97 4.7-30.59.15-9.46-1.46-16.42-4.79-20.66-13.4-17.12-33.07-26.31-56.88-26.56-16.37-.184-30.2 4.01-32.88 5.18-5.65-1.4-11.8-2.27-18.5-2.38-12.29-.199-22.91 2.74-31.7 8.74-3.82-1.42-13.69-4.81-25.76-6.76-20.87-3.36-37.46-.814-49.29 7.57-14.12 10.01-20.64 27.89-19.38 53.16.43 8.5 5.27 34.65 12.91 59.7 10.06 32.96 21 51.63 32.51 55.46 1.35.449 2.9.76 4.61.763 4.2 0 9.35-1.89 14.7-8.33a529.83 529.83 0 0 1 20.26-22.93c4.52 2.43 9.49 3.78 14.58 3.92.1.13.23.27.35.4a117.66 117.66 0 0 0-2.57 3.18c-3.52 4.47-4.25 5.4-15.59 7.74-3.22.666-11.79 2.43-11.92 8.44-.136 6.56 10.13 9.32 11.29 9.61 4.07 1.02 8 1.52 11.74 1.52 9.1 0 17.11-2.99 23.52-8.78-.197 23.39.778 46.43 3.59 53.45 2.3 5.75 7.92 19.8 25.66 19.79 2.6 0 5.47-.303 8.62-.979 18.52-3.97 26.56-12.16 29.68-30.2 1.67-9.64 4.52-32.68 5.87-45.03 2.84.885 6.49 1.29 10.43 1.29 8.23 0 17.73-1.75 23.69-4.51 6.69-3.11 18.77-10.73 16.58-17.36zm-44.11-83.48c-.061 3.65-.563 6.96-1.09 10.41-.573 3.72-1.16 7.56-1.31 12.23-.147 4.54.42 9.26.97 13.83 1.11 9.22 2.25 18.71-2.16 28.08a36.51 36.51 0 0 1-1.95-4.01c-.547-1.33-1.73-3.46-3.38-6.4-6.4-11.48-21.38-38.35-13.71-49.32 2.29-3.26 8.08-6.62 22.64-4.81zm-17.64-61.79c21.33.471 38.21 8.45 50.16 23.72 9.16 11.71-.927 65-30.14 110.97a171.33 171.33 0 0 0-.886-1.12l-.37-.462c7.55-12.47 6.07-24.8 4.76-35.74-.54-4.49-1.05-8.73-.92-12.71.134-4.22.69-7.84 1.23-11.34.66-4.31 1.34-8.78 1.15-14.04.139-.552.2-1.2.122-1.98-.475-5.04-6.23-20.14-17.98-33.81-6.42-7.47-15.79-15.84-28.57-21.48 5.5-1.14 13.02-2.2 21.44-2.02zM66.67 175.78c-5.9 7.09-9.97 5.73-11.31 5.29-8.73-2.91-18.86-21.36-27.79-50.62-7.73-25.32-12.24-50.78-12.6-57.92-1.13-22.58 4.35-38.31 16.27-46.77 19.4-13.76 51.31-5.52 64.13-1.35-.184.18-.376.35-.558.54-21.04 21.24-20.54 57.54-20.48 59.76-.2.86.07 2.07.168 3.74.362 6.11 1.04 17.47-.764 30.33-1.67 11.96 2.01 23.66 10.11 32.11a36.28 36.28 0 0 0 2.62 2.47c-3.6 3.86-11.44 12.4-19.77 22.43zm22.48-29.99c-6.53-6.81-9.49-16.28-8.13-25.99 1.9-13.59 1.2-25.43.82-31.79-.053-.89-.1-1.67-.127-2.28 3.07-2.72 17.31-10.35 27.47-8.03 4.63 1.06 7.46 4.22 8.63 9.65 6.08 28.1.804 39.82-3.43 49.23-.873 1.94-1.7 3.77-2.4 5.67l-.546 1.47c-1.38 3.71-2.67 7.15-3.46 10.42-6.94-.02-13.69-2.98-18.82-8.34zm1.07 37.9c-2.03-.506-3.85-1.38-4.92-2.11.893-.42 2.48-.992 5.24-1.56 13.34-2.74 15.4-4.68 19.9-10.39 1.03-1.31 2.2-2.79 3.82-4.6l.002-.002c2.41-2.7 3.51-2.24 5.51-1.41 1.62.67 3.2 2.7 3.84 4.94.303 1.06.643 3.06-.47 4.62-9.4 13.16-23.09 12.99-32.92 10.53zm69.8 64.95c-16.32 3.5-22.09-4.83-25.9-14.35-2.46-6.14-3.66-33.85-2.81-64.45.011-.407-.047-.8-.159-1.17a15.44 15.44 0 0 0-.456-2.16c-1.27-4.45-4.38-8.18-8.1-9.72-1.48-.613-4.2-1.74-7.46-.903.7-2.87 1.9-6.11 3.21-9.61l.549-1.47c.618-1.66 1.39-3.39 2.21-5.21 4.43-9.85 10.5-23.34 3.92-53.81-2.47-11.41-10.71-16.99-23.2-15.69-7.49.78-14.34 3.8-17.76 5.53-.735.37-1.41.732-2.03 1.08.954-11.5 4.56-32.99 18.04-46.59 8.49-8.56 19.79-12.79 33.57-12.56 27.14.44 44.54 14.37 54.37 25.98 8.46 10 13.05 20.08 14.88 25.51-13.75-1.4-23.11 1.32-27.85 8.1-10.32 14.75 5.64 43.37 13.32 57.13 1.41 2.52 2.62 4.7 3 5.63 2.5 6.05 5.73 10.1 8.09 13.05.724.9 1.43 1.78 1.96 2.55-4.17 1.2-11.65 3.98-10.97 17.85-.55 6.96-4.46 39.55-6.45 51.06-2.62 15.21-8.22 20.88-23.96 24.25zm68.1-77.94c-4.26 1.98-11.39 3.46-18.16 3.78-7.48.35-11.29-.838-12.18-1.57-.42-8.64 2.8-9.55 6.2-10.5.535-.15 1.06-.297 1.56-.473.31.255.66.508 1.03.756 6.01 3.97 16.74 4.4 31.87 1.27l.166-.033c-2.04 1.91-5.54 4.47-10.49 6.77z'
        fill='#FFF'
      />
    </svg>
  )
}

export function MySQLIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='64'
      height='64'
      viewBox='0 0 25.6 25.6'
    >
      <path
        d='M179.08 94.89c-3.57-.1-6.34.268-8.66 1.25-.668.27-1.74.27-1.83 1.12.357.36.4.94.713 1.43.535.89 1.47 2.1 2.32 2.72l2.86 2.05c1.74 1.07 3.7 1.7 5.4 2.77.982.63 1.96 1.43 2.95 2.1.5.36.803.94 1.43 1.16v-.135c-.312-.4-.402-.98-.713-1.43l-1.34-1.29c-1.29-1.74-2.9-3.26-4.64-4.51-1.43-.982-4.55-2.32-5.13-3.97l-.088-.1c.98-.1 2.14-.447 3.08-.715 1.52-.4 2.9-.312 4.46-.713l2.14-.625v-.4c-.803-.803-1.38-1.87-2.23-2.63-2.27-1.96-4.78-3.88-7.36-5.49-1.38-.892-3.17-1.47-4.64-2.23-.537-.268-1.43-.402-1.74-.848-.805-.98-1.25-2.27-1.83-3.44l-3.66-7.76c-.803-1.74-1.29-3.48-2.27-5.09-4.6-7.58-9.59-12.18-17.27-16.69-1.65-.937-3.61-1.34-5.7-1.83l-3.35-.18c-.715-.312-1.43-1.16-2.05-1.56-2.54-1.61-9.1-5.09-10.98-.5-1.2 2.9 1.79 5.76 2.8 7.23.76 1.03 1.74 2.19 2.28 3.35.3.76.4 1.56.713 2.37.713 1.96 1.38 4.15 2.32 5.98.5.94 1.02 1.92 1.65 2.77.357.5.98.714 1.12 1.52-.625.89-.668 2.23-1.02 3.35-1.61 5.04-.982 11.29 1.29 15 .715 1.12 2.4 3.57 4.69 2.63 2.01-.803 1.56-3.35 2.14-5.58.135-.535.04-.892.31-1.25v.1l1.83 3.7c1.38 2.19 3.79 4.46 5.8 5.98 1.7.8 1.92 2.19 3.26 2.68v-.135h-.088c-.268-.4-.67-.58-1.03-.892-.803-.803-1.69-1.78-2.32-2.68-1.87-2.5-3.52-5.26-5-8.12-.715-1.38-1.34-2.9-1.92-4.28-.27-.536-.27-1.34-.715-1.61-.67.98-1.65 1.83-2.14 3.03-.848 1.92-.936 4.28-1.25 6.74-.18.05-.1 0-.18.1-1.43-.356-1.92-1.83-2.45-3.08-1.34-3.17-1.56-8.25-.402-11.91.312-.937 1.65-3.88 1.12-4.77-.27-.848-1.16-1.34-1.65-2.01-.58-.848-1.2-1.92-1.6-2.85-1.07-2.5-1.6-5.26-2.77-7.76-.537-1.16-1.47-2.37-2.23-3.43-.848-1.2-1.78-2.05-2.45-3.48-.223-.5-.535-1.29-.178-1.83.09-.357.27-.5.62-.58.58-.5 2.23.134 2.81.4 1.65.67 3.03 1.29 4.42 2.23.63.446 1.3 1.29 2.1 1.52h.938c1.43.312 3.03.1 4.37.5 2.37.76 4.51 1.87 6.43 3.08 5.84 3.7 10.66 8.97 13.92 15.26.54 1.03.758 1.96 1.25 3.03.938 2.19 2.1 4.42 3.03 6.56.94 2.1 1.83 4.24 3.17 5.98.67.94 3.35 1.43 4.55 1.92.893.4 2.28.76 3.08 1.25 1.52.937 3.03 2.01 4.46 3.03.713.53 2.95 1.65 3.08 2.54zm-45.5-38.77a7.09 7.09 0 0 0-1.83.223v.1h.088c.357.71.982 1.21 1.43 1.83l1.03 2.14.088-.1c.625-.446.94-1.16.94-2.23-.268-.312-.312-.625-.535-.937-.268-.446-.848-.67-1.21-1.03z'
        transform='matrix(.390229 0 0 .38781 -46.3 -16.86)'
        fillRule='evenodd'
        fill='#00678c'
      />
    </svg>
  )
}

export function FireworksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      height='1em'
      width='1em'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      fillRule='evenodd'
      clipRule='evenodd'
    >
      <path
        d='M14.8 5l-2.801 6.795L9.195 5H7.397l3.072 7.428a1.64 1.64 0 003.038.002L16.598 5H14.8zm1.196 10.352l5.124-5.244-.699-1.669-5.596 5.739a1.664 1.664 0 00-.343 1.807 1.642 1.642 0 001.516 1.012L16 17l8-.02-.699-1.669-7.303.041h-.002zM2.88 10.104l.699-1.669 5.596 5.739c.468.479.603 1.189.343 1.807a1.643 1.643 0 01-1.516 1.012l-8-.018-.002.002.699-1.669 7.303.042-5.122-5.246z'
        fill='#5019C5'
      />
    </svg>
  )
}

export function OpenRouterIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      fillRule='evenodd'
      height='1em'
      viewBox='0 0 24 24'
      width='1em'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M16.8 1.96l7.22 4.11v.087L16.73 10.21l.017-2.12-.821-.03c-1.06-.028-1.61.002-2.27.11-1.06.175-2.04.577-3.15 1.35L8.35 11.03c-.284.2-.495.34-.68.46l-.515.32-.397.23.385.23.53.34c.476.31 1.17.8 2.7 1.87 1.11.78 2.08 1.18 3.15 1.35l.3.05c.694.09 1.38.094 2.83.033l.022-2.16 7.22 4.11v.087L16.59 22l.014-1.86-.635.02c-1.39.042-2.14.002-3.14-.162-1.69-.28-3.26-.926-4.88-2.06l-2.16-1.5a22 22 0 00-.755-.498l-.467-.28a55.93 55.93 0 00-.76-.43C2.91 14.73.56 14.12 0 14.12V9.89l.14.004c.564-.007 2.91-.622 3.81-1.12l1.02-.58.44-.274c.428-.28 1.07-.726 2.69-1.85 1.62-1.13 3.19-1.78 4.88-2.06 1.15-.19 1.97-.213 3.81-.138l.02-1.91z' />
    </svg>
  )
}

export function TogetherIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} height='1em' width='1em' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M23.197 4.503A6 6 0 0015 2.307a5.973 5.973 0 00-2.995 4.933l5.996.008v.515h-5.996c.039.937.298 1.87.8 2.74a6 6 0 1010.39-6z'
        fill='#EF2CC1'
      />
      <path
        d='M.805 4.5A6 6 0 003 12.697a5.972 5.972 0 005.77.127L5.779 7.627l.446-.257 2.997 5.192A6 6 0 10.804 4.5z'
        fill='#CAAEF5'
      />
      <path
        d='M12 23.894a6 6 0 005.999-6c0-2.13-1.1-3.996-2.775-5.06l-3.005 5.189-.444-.258 2.997-5.192A6 6 0 1012 23.894z'
        fill='#FC4C02'
      />
    </svg>
  )
}

export function BasetenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill='currentColor'
      fillRule='evenodd'
      height='1em'
      width='1em'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M2.316 4.8h14.682v4.8H7.31a.302.302 0 00-.308.3v4.2c0 .171.14.3.308.3h9.688v4.8h-4.686a.302.302 0 00-.308.3v4.2c0 .171.141.3.308.3h4.378a.297.297 0 00.308-.3v-4.5h4.694a.302.302 0 00.308-.3v-4.2c0-.171-.14-.3-.308-.3h-4.694V9.6h4.694A.302.302 0 0022 9.3V5.1c0-.171-.14-.3-.308-.3h-4.694V.3c0-.171-.14-.3-.308-.3H2.316A.31.31 0 002 .3v4.2c0 .171.14.3.316.3z' />
    </svg>
  )
}

export function CohereIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} height='1em' width='1em' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <title>Cohere</title>
      <path
        d='M8.128 14.099c.592 0 1.77-.033 3.398-.703 1.897-.781 5.672-2.2 8.395-3.656 1.905-1.018 2.74-2.366 2.74-4.18A4.56 4.56 0 0018.1 1H7.549A6.55 6.55 0 001 7.55c0 3.617 2.745 6.549 7.128 6.549z'
        clipRule='evenodd'
        fill='#39594D'
        fillRule='evenodd'
      />
      <path
        d='M9.912 18.61a4.387 4.387 0 012.705-4.052l3.323-1.38c3.361-1.394 7.06 1.076 7.06 4.715a5.104 5.104 0 01-5.105 5.104l-3.597-.001a4.386 4.386 0 01-4.386-4.387z'
        clipRule='evenodd'
        fill='#D18EE2'
        fillRule='evenodd'
      />
      <path
        d='M4.776 14.962A3.775 3.775 0 001 18.738v.489a3.776 3.776 0 007.551 0v-.49a3.775 3.775 0 00-3.775-3.775z'
        fill='#FF7759'
      />
    </svg>
  )
}

export function MondayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 -50 256 256'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M31.85,153.49 C20.32,153.51 9.68,147.34 3.99,137.32 C-1.63,127.37 -1.29,115.13 4.86,105.5 L62.23,15.4 C68.21,5.55 79.03,-0.33 90.56,0.01 C102.07,0.29 112.55,6.75 117.97,16.91 C123.32,27.02 122.65,39.19 116.24,48.68 L58.9,138.78 C52.99,147.99 42.79,153.54 31.85,153.49 L31.85,153.49 Z'
          fill='#F62B54'
        />
        <path
          d='M130.26,153.49 C118.68,153.49 108.04,147.3 102.44,137.36 C96.84,127.43 97.18,115.22 103.32,105.62 L160.58,15.73 C166.48,5.73 177.33,-0.28 188.93,0.01 C200.6,0.27 211.17,6.8 216.52,17.01 C221.83,27.22 221.06,39.46 214.46,48.93 L157.2,138.82 C151.31,147.99 141.15,153.52 130.26,153.49 Z'
          fill='#FFCC00'
        />
        <ellipse fill='#00CA72' cx='226.47' cy='125.32' rx='29.54' ry='28.92' />
      </g>
    </svg>
  )
}

export function ModalIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const leftHighlight = `modal_left_highlight_${id}`
  const leftBody = `modal_left_body_${id}`
  const rightHighlight = `modal_right_highlight_${id}`
  const rightBody = `modal_right_body_${id}`

  return (
    <svg {...props} viewBox='0 0 300 300' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M121.683 75.25L149.997 124L91.482 224.75C90.313 226.757 88.155 228 85.817 228H32.966C31.798 228 30.678 227.691 29.697 227.131C28.716 226.57 27.891 225.758 27.302 224.75L0.877 179.25C-0.292 177.243 -0.292 174.765 0.877 172.75L57.512 75.25C58.092 74.243 58.926 73.43 59.907 72.869C60.888 72.309 62.007 72 63.176 72H116.027C118.365 72 120.523 73.243 121.692 75.25H121.683ZM299.125 172.75L242.49 75.25C241.91 74.243 241.076 73.43 240.095 72.869C239.114 72.309 237.995 72 236.826 72H183.975C181.637 72 179.479 73.243 178.311 75.25L149.997 124L208.512 224.75C209.681 226.757 211.839 228 214.177 228H267.027C268.196 228 269.316 227.691 270.297 227.131C271.278 226.57 272.103 225.758 272.692 224.75L299.117 179.25C300.286 177.243 300.286 174.765 299.117 172.75H299.125Z'
        fill='#62DE61'
      />
      <path
        d='M89.602 124H150.005L121.692 75.25C120.523 73.243 118.365 72 116.027 72H63.176C62.007 72 60.888 72.309 59.907 72.869L89.602 124Z'
        fill={`url(#${leftHighlight})`}
      />
      <path
        d='M89.602 124L59.907 72.869C58.926 73.43 58.1 74.243 57.512 75.25L0.877 172.75C-0.292 174.765 -0.292 177.235 0.877 179.25L27.302 224.75C27.883 225.758 28.716 226.57 29.697 227.131L89.594 124H89.602Z'
        fill={`url(#${leftBody})`}
      />
      <path
        d='M149.997 124H89.594L29.697 227.131C30.678 227.691 31.798 228 32.966 228H85.817C88.155 228 90.313 226.757 91.482 224.75L149.997 124Z'
        fill='#09AF58'
      />
      <path
        d='M299.125 179.25C299.706 178.243 300 177.121 300 176H240.61L210.915 227.131C211.896 227.691 213.016 228 214.185 228H267.036C269.373 228 271.531 226.757 272.7 224.75L299.125 179.25Z'
        fill='#09AF58'
      />
      <path
        d='M183.975 72C182.806 72 181.686 72.309 180.705 72.869L240.602 176H299.992C299.992 174.879 299.698 173.758 299.117 172.75L242.49 75.25C241.321 73.243 239.163 72 236.826 72H183.967H183.975Z'
        fill={`url(#${rightHighlight})`}
      />
      <path
        d='M210.907 227.131L240.602 176L180.705 72.869C179.725 73.43 178.899 74.243 178.311 75.25L149.997 124L208.512 224.75C209.093 225.758 209.926 226.57 210.907 227.131Z'
        fill={`url(#${rightBody})`}
      />
      <defs>
        <linearGradient
          id={leftHighlight}
          x1='127.348'
          y1='137'
          x2='82.956'
          y2='59.64'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#BFF9B4' />
          <stop offset='1' stopColor='#80EE64' />
        </linearGradient>
        <linearGradient
          id={leftBody}
          x1='7.048'
          y1='214.131'
          x2='81.128'
          y2='85.056'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#80EE64' />
          <stop offset='0.36' stopColor='#6FE562' />
          <stop offset='0.74' stopColor='#3DCA5D' />
          <stop offset='1' stopColor='#09AF58' />
        </linearGradient>
        <linearGradient
          id={rightHighlight}
          x1='278.103'
          y1='188.561'
          x2='204.022'
          y2='59.486'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#BFF9B4' />
          <stop offset='1' stopColor='#80EE64' />
        </linearGradient>
        <linearGradient
          id={rightBody}
          x1='232.804'
          y1='214.569'
          x2='158.724'
          y2='85.486'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#80EE64' />
          <stop offset='0.36' stopColor='#6FE562' />
          <stop offset='0.74' stopColor='#3DCA5D' />
          <stop offset='1' stopColor='#09AF58' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function MongoDBIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='currentColor'
        d='M88.038 42.812c1.605 4.643 2.761 9.383 3.141 14.296.472 6.095.256 12.147-1.029 18.142-.035.165-.109.32-.164.48-.403.001-.814-.049-1.208.012-3.329.523-6.655 1.065-9.981 1.604-3.438.557-6.881 1.092-10.313 1.687-1.216.21-2.721-.041-3.212 1.641-.014.046-.154.054-.235.08l.166-10.051-.169-24.252 1.602-.275c2.62-.429 5.24-.864 7.862-1.281 3.129-.497 6.261-.98 9.392-1.465 1.381-.215 2.764-.412 4.148-.618z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#45A538'
        d='M61.73 110.05c-1.69-1.45-3.44-2.84-5.06-4.37-8.72-8.22-15.09-17.9-18.23-29.57-.865-3.21-1.44-6.47-1.63-9.79-.13-2.32-.318-4.66-.154-6.97.437-6.14 1.33-12.23 3.13-18.15l.099-.138c.175.23.427.44.516.7 1.76 5.18 3.51 10.36 5.24 15.55 5.46 16.3 10.91 32.6 16.38 48.9.11.318.38.579.58.866l-.87 2.97z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#46A037'
        d='M88.04 42.81c-1.38.206-2.77.403-4.15.616-3.13.485-6.26.968-9.39 1.47-2.62.417-5.24.852-7.86 1.28l-1.6.275-.012-1.04c-.053-.859-.144-1.72-.154-2.58-.069-5.48-.112-10.96-.18-16.43-.042-3.43-.105-6.86-.175-10.28-.043-2.13-.089-4.26-.185-6.39-.052-1.14-.236-2.28-.311-3.42-.042-.657.02-1.32.029-1.98.817 1.58 1.62 3.18 2.46 4.75 1.33 2.48 3.44 4.31 5.34 6.31 7.52 7.89 12.86 17.07 16.19 27.43z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#409433'
        d='M65.036 80.753c.081-.026.222-.034.235-.08.491-1.682 1.996-1.431 3.212-1.641 3.432-.594 6.875-1.13 10.313-1.687 3.326-.539 6.652-1.081 9.981-1.604.394-.062.805-.011 1.208-.012-.622 2.22-1.112 4.488-1.901 6.647-.896 2.449-1.98 4.839-3.131 7.182a49.142 49.142 0 01-6.353 9.763c-1.919 2.308-4.058 4.441-6.202 6.548-1.185 1.165-2.582 2.114-3.882 3.161l-.337-.23-1.214-1.038-1.256-2.753a41.402 41.402 0 01-1.394-9.838l.023-.561.171-2.426c.057-.828.133-1.655.168-2.485.129-2.982.241-5.964.359-8.946z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#4FAA41'
        d='M65.036 80.753c-.118 2.982-.23 5.964-.357 8.947-.035.83-.111 1.657-.168 2.485l-.765.289c-1.699-5.002-3.399-9.951-5.062-14.913-2.75-8.209-5.467-16.431-8.213-24.642a4498.887 4498.887 0 00-6.7-19.867c-.105-.31-.407-.552-.617-.826l4.896-9.002c.168.292.39.565.496.879a6167.476 6167.476 0 016.768 20.118c2.916 8.73 5.814 17.467 8.728 26.198.116.349.308.671.491 1.062l.67-.78-.167 10.052z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#4AA73C'
        d='M43.16 32.23c.21.27.511.52.617.83a4498.89 4498.89 0 016.7 19.87c2.75 8.21 5.46 16.43 8.21 24.64 1.66 4.96 3.36 9.91 5.06 14.91l.765-.289-.171 2.43-.155.56c-.266 2.66-.49 5.32-.814 7.97-.163 1.33-.509 2.63-.772 3.95-.198-.287-.476-.548-.583-.866-5.47-16.3-10.92-32.6-16.38-48.9a3888.97 3888.97 0 00-5.24-15.55c-.089-.263-.34-.469-.516-.702l3.27-8.84z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#57AE47'
        d='M65.2 70.7l-.67.78c-.183-.391-.375-.714-.491-1.06-2.91-8.73-5.81-17.47-8.73-26.2a6167.48 6167.48 0 00-6.77-20.12c-.105-.314-.327-.588-.496-.879l6.06-7.96c.191.26.463.48.562.77 1.68 4.92 3.35 9.85 5 14.78 1.55 4.6 3.07 9.22 4.64 13.81.105.31.47.53.714.79l.012 1.05c.058 8.08.115 16.17.171 24.25z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#60B24F'
        d='M65.02 45.4c-.244-.26-.609-.478-.714-.786-1.56-4.6-3.09-9.21-4.64-13.81-1.66-4.93-3.32-9.86-5-14.78-.099-.287-.371-.514-.562-.769 1.97-1.93 3.88-3.92 5.93-5.76 1.82-1.63 3.29-3.39 3.35-5.97.003-.107.06-.214.15-.514l.519 1.31c-.13.66-.072 1.32-.029 1.98.075 1.14.259 2.28.31 3.42.096 2.13.142 4.26.185 6.39.069 3.43.132 6.86.175 10.29.067 5.48.111 10.96.18 16.43.8.86.098 1.72.152 2.58z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#A9AA88'
        d='M62.598 107.085c.263-1.315.609-2.62.772-3.947.325-2.649.548-5.312.814-7.968l.066-.01.066.011a41.402 41.402 0 001.394 9.838c-.176.232-.425.439-.518.701-.727 2.05-1.412 4.116-2.143 6.166-.1.28-.378.498-.574.744l-.747-2.566.87-2.969z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#B6B598'
        d='M62.48 112.62c.196-.246.48-.464.57-.744.73-2.05 1.42-4.11 2.14-6.17.093-.262.34-.469.52-.701l1.25 2.75c-.248.35-.59.67-.728 1.06l-2.4 7.06c-.99.28-.437.48-.663.72l-.695-3.98z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#C2C1A7'
        d='M63.17 116.61c.227-.238.56-.439.66-.722l2.4-7.06c.137-.391.48-.709.73-1.06l1.22 1.04c-.587.58-.913 1.25-.717 2.1l-.369 1.21c-.168.21-.411.39-.494.62-.839 2.4-1.64 4.82-2.48 7.22-.107.31-.404.54-.614.81-.109-1.39-.22-2.77-.331-4.16z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#CECDB7'
        d='M63.5 120.76c.209-.269.51-.508.61-.812.85-2.4 1.65-4.82 2.49-7.22.083-.236.33-.417.49-.624l-.509 5.55c-.136.16-.333.29-.398.48-.575 1.61-1.12 3.24-1.69 4.85-.119.33-.347.63-.525.94-.158-.207-.441-.407-.454-.623-.051-.841-.016-1.69-.013-2.53z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#DBDAC7'
        d='M63.97 123.92c.178-.312.41-.606.53-.938.58-1.61 1.12-3.24 1.69-4.85.065-.183.26-.319.4-.477l.012 3.64-1.22 3.12-1.41-.495z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#EBE9DC'
        d='M65.38 124.42l1.22-3.12.251 3.7-1.47-.572z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#CECDB7'
        d='M67.46 110.9c-.196-.847.13-1.52.717-2.1l.337.23-1.05 1.87z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#4FAA41'
        d='M64.32 95.17l-.066-.011-.066.1.16-.559-.023.56z'
      />
    </svg>
  )
}

export function ServerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect width='20' height='8' x='2' y='2' rx='2' ry='2' />
      <rect width='20' height='8' x='2' y='14' rx='2' ry='2' />
      <line x1='6' x2='6.01' y1='6' y2='6' />
      <line x1='6' x2='6.01' y1='18' y2='18' />
    </svg>
  )
}
export const SOC2BadgeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='50' cy='50' r='48' fill='white' stroke='#E5E7EB' strokeWidth='2' />
    <circle cx='50' cy='50' r='45' fill='#F9FAFB' />
    <text
      x='50'
      y='40'
      textAnchor='middle'
      fill='#1F2937'
      fontSize='20'
      fontWeight='600'
      fontFamily='system-ui, -apple-system, sans-serif'
    >
      SOC 2
    </text>
    <text
      x='50'
      y='56'
      textAnchor='middle'
      fill='#6B7280'
      fontSize='11'
      fontWeight='500'
      fontFamily='system-ui, -apple-system, sans-serif'
    >
      Type II
    </text>
    <text
      x='50'
      y='70'
      textAnchor='middle'
      fill='#9CA3AF'
      fontSize='9'
      fontWeight='400'
      fontFamily='system-ui, -apple-system, sans-serif'
    >
      Compliant
    </text>
  </svg>
)

export function GoogleFormsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 65' fill='none'>
      <path
        d='M29.58 0H4.44C2 0 0 2 0 4.44v56.21C0 63.09 2 65.08 4.44 65.08h38.46c2.44 0 4.44-2 4.44-4.44V17.75L36.98 10.35 29.58 0Z'
        fill='#673AB7'
      />
      <path
        d='M29.58 0v10.35c0 2.45 1.99 4.44 4.44 4.44h13.31L36.98 10.35 29.58 0Z'
        fill='#B39DDB'
      />
      <path
        d='M19.23 50.29h16.27v-2.96H19.23v2.96Zm0-17.75v2.96h16.27v-2.96H19.23Zm-3.7 1.48c0 1.22-0.99 2.22-2.22 2.22s-2.22-0.99-2.22-2.22c0-1.22 1-2.22 2.22-2.22s2.22 1 2.22 2.22Zm0 7.4c0 1.22-0.99 2.22-2.22 2.22s-2.22-0.99-2.22-2.22c0-1.22 1-2.22 2.22-2.22s2.22 1 2.22 2.22Zm0 7.4c0 1.22-0.99 2.22-2.22 2.22s-2.22-0.99-2.22-2.22c0-1.22 1-2.22 2.22-2.22s2.22 1 2.22 2.22Zm3.7-5.92h16.27v-2.96H19.23v2.96Z'
        fill='#F1F1F1'
      />
    </svg>
  )
}

export const SMSIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill='#000000'
    width='800px'
    height='800px'
    viewBox='0 0 32 32'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M 2 5 L 2 25 L 7 25 L 7 30.09 L 8.63 28.78 L 13.34 25 L 30 25 L 30 5 Z M 4 7 L 28 7 L 28 23 L 12.66 23 L 12.38 23.22 L 9 25.91 L 9 23 L 4 23 Z M 8 12 L 8 14 L 24 14 L 24 12 Z M 8 16 L 8 18 L 20 18 L 20 16 Z' />
  </svg>
)

export const ResendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='360 360 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1000.46 450C1174.77 450 1278.43 553.67 1278.43 691.28C1278.43 828.9 1174.77 932.56 1000.46 932.56H912.38L1350 1350H1040.82L707.79 1033.48C683.94 1011.47 672.94 985.78 672.94 963.77C672.94 932.57 694.96 905.05 737.16 893.12L908.71 847.24C973.85 829.81 1018.81 779.35 1018.81 713.3C1018.8 632.57 952.75 585.78 871.1 585.78H450V450H1000.46Z'
      fill='currentColor'
    />
  </svg>
)

export const GoogleAdsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
    <g transform='matrix(.257748 0 0 .257745 -.361416 2.52)'>
      <path
        d='M85.9 28.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54l51.6 89.8c14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21l-45.4-78.8c-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9L88.8 62.2c-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6'
        fill='#3c8bd9'
      />
      <path
        d='M85.9 28.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5l32.9 56.9c1 1.7 1.8 3.4 2.8 5l-18.1 31.1-25.3 43.6c-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5l14.3-24.9L85.2 29.7c.2-.4.5-.7.7-1.1'
        fill='#fabc04'
      />
      <path
        d='M11.8 158l5.7-5.1c24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9C20 225.4 4.5 210.6 1.8 191c-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2'
        fill='#34a852'
      />
      <path d='M11.8 158c-.4.4-.4 1.1-1.1 1.2-.1-.7.3-1.1.7-1.6l.4.4' fill='#fabc04' />
      <path d='M81.6 201c-.4-.7 0-1.2.4-1.7l.4.4-.8 1.3' fill='#e1c025' />
    </g>
  </svg>
)

export const GoogleBigQueryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
    <path
      d='M14.48 58.2L.558 34.08c-.744-1.29-.744-2.88 0-4.16L14.48 5.81c.743-1.29 2.12-2.08 3.6-2.08h27.86c1.48.01 2.85.8 3.59 2.08l13.92 24.11c.744 1.29.744 2.88 0 4.16L49.52 58.2c-.743 1.29-2.12 2.08-3.6 2.08H18.07c-1.48-.005-2.85-.798-3.59-2.08z'
      fill='#4386fa'
    />
    <path
      d='M40.7 24.24s3.87 9.28-1.41 14.55-14.88 1.89-14.88 1.89L43.95 60.27h1.98c1.49-.002 2.86-.796 3.6-2.08L58.75 42.23z'
      opacity='.1'
    />
    <path
      d='M45.27 43.23L41 38.95a.67.67 0 0 0-.158-.12 11.63 11.63 0 1 0-2.03 2.04.67.67 0 0 0 .113.15l4.28 4.28a.67.67 0 0 0 .947 0l1.12-1.12a.67.67 0 0 0 0-.947zM31.64 40.46a8.75 8.75 0 1 1 8.75-8.75 8.75 8.75 0 0 1-8.75 8.75zm-5.59-9.22v3.62c.557.98 1.36 1.8 2.34 2.38v-6.01zm4.38-3v9.77a6.45 6.45 0 0 0 2.34 0V28.25zm6.76 6.61v-2.14H34.85v4.5a6.43 6.43 0 0 0 2.34-2.37z'
      fill='#fff'
    />
  </svg>
)

export const GoogleVaultIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 82 82'>
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M58.03 41.14L63.85 36.72L69 30.16C67.37 26.03 63.1 18.41 63.1 18.41C63.1 18.41 55.62 14.62 51.99 13.19L45.35 17.92L41.06 24.05L36.76 17.83L30.2 13.11C26.54 14.52 19.01 18.78 19.01 18.78C19.01 18.78 14.64 25.99 12.99 30.16L18.15 36.73L23.9 41.07L17.8 45.73L12.88 52.02C14.33 55.81 18.35 63.04 18.35 63.04C18.35 63.04 25.87 67.63 29.92 69.23L36.1 64.46L41 58.16L45.35 63.93L52.07 69.24C55.86 67.74 63.06 63.63 63.06 63.63C63.06 63.63 67.48 56.2 69.04 52.23L63.98 45.71L58.03 41.14ZM41 53.46C34.25 53.46 28.77 47.99 28.77 41.23C28.77 34.47 34.25 28.99 41 28.99C47.76 28.99 53.24 34.47 53.24 41.23C53.24 47.99 47.76 53.46 41 53.46Z'
      fill='#1967D2'
    />
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M58.03 41.14L69.01 30.16C70.37 33.58 71.12 37.32 71.12 41.23C71.12 45.11 70.38 48.82 69.04 52.23L58.03 41.14ZM13 30.16C11.64 33.59 10.89 37.32 10.89 41.23C10.89 45.04 11.6 48.67 12.89 52.02L23.91 41.07L13 30.16ZM52 13.19C48.59 11.86 44.89 11.12 41 11.12C37.2 11.12 33.56 11.83 30.2 13.12L41.06 24.05L52 13.19ZM29.93 69.23C33.36 70.59 37.1 71.34 41 71.34C44.91 71.34 48.65 70.59 52.07 69.23L41 58.17L29.93 69.23ZM69.04 52.23C65.99 59.98 59.82 66.17 52.07 69.23L62.81 79.97C64.28 81.44 66.66 81.44 68.14 79.97L79.76 68.35C81.23 66.88 81.23 64.5 79.77 63.03L69.04 52.23ZM69.01 30.16L79.98 19.19C81.45 17.72 81.45 15.34 79.98 13.86L68.35 2.24C66.88 0.77 64.51 0.77 63.04 2.23L51.99 13.19C59.75 16.24 65.94 22.41 69.01 30.16ZM12.89 52.02L2.03 62.8C0.55 64.27 0.55 66.66 2.02 68.14L13.86 79.98C15.34 81.45 17.72 81.45 19.19 79.98L29.93 69.23C22.11 66.14 15.91 59.88 12.89 52.02ZM30.2 13.12L19.2 2.03C17.73 0.55 15.34 0.55 13.86 2.02L2.02 13.86C0.55 15.34 0.55 17.72 2.02 19.19L13 30.16C16.09 22.35 22.35 16.14 30.2 13.12Z'
      fill='#4285F4'
    />
  </svg>
)

export function ZepIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 233 196'
      width='96px'
      height='96px'
    >
      <path
        d='m231.34,108.7l-1.48-1.55h-10.26l3.59-75.86-14.8-.45-2.77,49.31c-59.6-3.24-119.33-3.24-178.92-.02l-1.73-64.96-14.8.45,2.5,91.53H2.16l-1.41,1.47c-1.55,16.23-.66,32.68,2.26,48.89h10.83l.18,1.27c.67,19.34,16.1,34.68,35.9,34.68s44.86-.92,66.12-.92,46.56.92,65.95.92,35.19-15.29,35.9-34.61l.16-1.34h11.02c2.91-16.19,3.81-32.61,2.26-48.81Zm-158.23,58.01c-17.27,0-30.25-13.78-30.25-29.78s12.99-29.78,30.25-29.78,29.62,13.94,29.62,29.94-12.35,29.62-29.62,29.62Zm86.51,0c-17.27,0-30.25-13.78-30.25-29.78s12.99-29.78,30.25-29.78,29.62,13.94,29.62,29.94-12.35,29.62-29.62,29.62Z'
        fill='#FF1493'
      />
      <polygon
        points='111.77 22.4 93.39 49.97 93.52 50.48 185.88 38.51 190.95 27.68 114.32 36.55 117.7 31.48 117.7 31.47 138.38 .49 138.25 0 47.67 11.6 42.85 22.27 118.34 12.61 111.77 22.4'
        fill='#FF1493'
      />
      <path
        d='m72.97,121.47c-8.67,0-15.73,6.93-15.73,15.46s7.06,15.46,15.73,15.46,15.37-6.75,15.37-15.37-6.75-15.55-15.37-15.55Z'
        fill='#FF1493'
      />
      <path
        d='m159.48,121.47c-8.67,0-15.73,6.93-15.73,15.46s7.06,15.46,15.73,15.46,15.37-6.75,15.37-15.37-6.75-15.55-15.37-15.55Z'
        fill='#FF1493'
      />
    </svg>
  )
}

export function WebflowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='1080'
      height='674'
      viewBox='0 0 1080 674'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1080 0L735.39 673.68H411.7L555.92 394.48H549.45C430.46 548.93 252.94 650.61 0 673.68V398.34C0 398.34 161.81 388.79 256.94 288.78H0V0.01H288.77V237.52L295.25 237.49L413.25 0.01H631.64V236.01L638.13 236L760.56 0H1080Z'
        fill='#146EF5'
      />
    </svg>
  )
}

export function VariableIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M7 8l-4 4 4 4' />
      <path d='M17 8l4 4-4 4' />
      <line x1='14' y1='4' x2='10' y2='20' />
    </svg>
  )
}

export function HumanInTheLoopIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2' />
      <circle cx='12' cy='7' r='4' />
    </svg>
  )
}

export function TrelloIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='256'
      height='256'
      viewBox='0 0 256 256'
      preserveAspectRatio='xMidYMid'
    >
      <rect fill='#0052CC' x='0' y='0' width='256' height='256' rx='32' />
      <rect fill='#FFF' x='144.64' y='33.28' width='78.08' height='112' rx='12' />
      <rect fill='#FFF' x='33.28' y='33.28' width='78.08' height='176' rx='12' />
    </svg>
  )
}

export function AffinityIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.412 20.505C20.412 20.505 20.412 20.505 20.412 20.505C17.298 23.566 13.602 21.66 11.014 19.072C8.426 21.66 4.73 23.566 1.616 20.505C1.616 20.505 1.616 20.505 1.616 20.505C1.616 20.505 1.615 20.505 1.615 20.505C1.608 20.498 1.6 20.49 1.593 20.483C1.587 20.477 1.581 20.471 1.575 20.465C1.575 20.465 1.575 20.464 1.575 20.464C1.575 20.464 1.575 20.464 1.575 20.464C-1.486 17.35 0.42 13.654 3.008 11.066C0.42 8.478 -1.486 4.782 1.575 1.668C1.575 1.668 1.575 1.668 1.575 1.668C1.575 1.668 1.575 1.667 1.575 1.667C1.582 1.661 1.588 1.654 1.595 1.647C1.602 1.641 1.608 1.634 1.615 1.627C1.615 1.627 1.615 1.627 1.616 1.627C1.616 1.627 1.616 1.627 1.616 1.627C3.99 -0.706 7.381 -0.573 10.259 2.305L11.014 3.06L11.769 2.305C14.647 -0.573 18.038 -0.706 20.412 1.627C20.412 1.627 20.412 1.627 20.412 1.627C20.412 1.627 20.413 1.627 20.413 1.627C20.419 1.633 20.425 1.639 20.431 1.645C20.438 1.653 20.446 1.66 20.453 1.667C20.453 1.667 20.453 1.668 20.453 1.668C20.453 1.668 20.453 1.668 20.453 1.669C22.786 4.042 22.653 7.433 19.775 10.311L19.02 11.066C21.608 13.654 23.514 17.35 20.453 20.464C20.453 20.464 20.453 20.464 20.453 20.464C20.453 20.464 20.453 20.465 20.453 20.465C20.447 20.471 20.44 20.478 20.433 20.485C20.426 20.492 20.419 20.499 20.413 20.505C20.413 20.505 20.412 20.505 20.412 20.505ZM2.709 19.376C3.732 20.376 5.391 20.49 6.946 18.935L13.831 12.05C13.943 11.938 14.13 11.963 14.202 12.104C14.631 12.944 14.909 13.949 15.049 14.974C15.054 15.009 15.042 15.044 15.017 15.069L13.117 16.97V17.16L15.082 18.935C16.637 20.49 18.296 20.376 19.319 19.376C20.324 18.353 20.44 16.691 18.883 15.135L11.975 8.226C11.862 8.114 11.889 7.924 12.032 7.854C12.87 7.443 13.861 7.177 14.869 7.045C14.942 7.036 15.015 7.061 15.067 7.113L16.918 8.964L18.883 6.998C20.438 5.443 20.324 3.784 19.324 2.761C18.301 1.756 16.639 1.64 15.082 3.197L8.174 10.106C8.061 10.219 7.872 10.192 7.801 10.049C7.391 9.211 7.125 8.22 6.993 7.212C6.983 7.139 7.009 7.065 7.061 7.013L8.912 5.163L6.946 3.197C5.39 1.641 3.729 1.756 2.706 2.759C1.704 3.782 1.589 5.442 3.145 6.998L10.084 13.937C10.196 14.049 10.171 14.236 10.03 14.308C9.204 14.727 8.221 15.001 7.217 15.142C7.143 15.152 7.069 15.127 7.016 15.074L5.111 13.169L3.145 15.135C1.588 16.691 1.704 18.353 2.709 19.376Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function AttioIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60.9 50' fill='currentColor'>
      <path d='M60.3,34.8l-5.1-8.1c0,0,0,0,0,0L54.7,26c-0.8-1.2-2.1-1.9-3.5-1.9L43,24L42.5,25l-9.8,15.7l-0.5,0.9l4.1,6.6c0.8,1.2,2.1,1.9,3.5,1.9h11.5c1.4,0,2.8-0.7,3.5-1.9l0.4-0.6c0,0,0,0,0,0l5.1-8.2C61.1,37.9,61.1,36.2,60.3,34.8L60.3,34.8z M58.7,38.3l-5.1,8.2c0,0,0,0.1-0.1,0.1c-0.2,0.2-0.4,0.2-0.5,0.2c-0.1,0-0.4,0-0.6-0.3l-5.1-8.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.4-0.1-0.8,0-1.3c0.1-0.2,0.1-0.4,0.3-0.6l5.1-8.1c0,0,0,0,0,0c0.1-0.2,0.3-0.3,0.4-0.3c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.4,0,0.6,0.3l5.1,8.1C59.2,36.6,59.2,37.5,58.7,38.3L58.7,38.3z' />
      <path d='M45.2,15.1c0.8-1.3,0.8-3.1,0-4.4l-5.1-8.1l-0.4-0.7C38.9,0.7,37.6,0,36.2,0H24.7c-1.4,0-2.7,0.7-3.5,1.9L0.6,34.9C0.2,35.5,0,36.3,0,37c0,0.8,0.2,1.5,0.6,2.2l5.5,8.8C6.9,49.3,8.2,50,9.7,50h11.5c1.4,0,2.8-0.7,3.5-1.9l0.4-0.7c0,0,0,0,0,0c0,0,0,0,0,0l4.1-6.6l12.1-19.4L45.2,15.1L45.2,15.1z M44,13c0,0.4-0.1,0.8-0.4,1.2L23.5,46.4c-0.2,0.3-0.5,0.3-0.6,0.3c-0.1,0-0.4,0-0.6-0.3l-5.1-8.2c-0.5-0.7-0.5-1.7,0-2.4L37.4,3.6c0.2-0.3,0.5-0.3,0.6-0.3c0.1,0,0.4,0,0.6,0.3l5.1,8.1C43.9,12.1,44,12.5,44,13z' />
    </svg>
  )
}

export function AsanaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'>
      <circle cx='18' cy='16' r='4' fill='#F06A6A' />
      <circle cx='6' cy='16' r='4' fill='#F06A6A' />
      <circle cx='12' cy='6.5' r='4' fill='#F06A6A' />
    </svg>
  )
}

export function PipedriveIcon(props: SVGProps<SVGSVGElement>) {
  const pathId = useId()
  return (
    <svg
      {...props}
      width='304px'
      height='304px'
      viewBox='0 0 304 304'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <defs>
        <path
          d='M59.68,81.18 C59.68,101.53 70.01,123.49 92.73,123.49 C109.59,123.49 126.63,110.34 126.63,80.88 C126.63,55.05 113.23,37.71 93.29,37.71 C77.05,37.71 59.68,49.12 59.68,81.18 Z M101.3,0 C142.05,0 169.45,32.27 169.45,80.31 C169.45,127.6 140.58,160.61 99.32,160.61 C79.65,160.61 67.05,152.18 60.46,146.08 C60.51,147.53 60.54,149.15 60.54,150.88 L60.54,215 L18.33,215 L18.33,44.16 C18.33,41.67 17.53,40.89 15.07,40.89 L0.55,40.89 L0.55,3.47 L35.97,3.47 C52.28,3.47 56.46,11.77 57.25,18.17 C63.87,10.75 77.59,0 101.3,0 Z'
          id={pathId}
        />
      </defs>
      <g
        id='Pipedrive_letter_logo_dark'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g transform='translate(67, 44)'>
          <use fill='currentColor' xlinkHref={`#${pathId}`} />
        </g>
      </g>
    </svg>
  )
}

export function SailPointIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 109.5 107'>
      <path fill='#0033A1' d='M63,0l13.2,78.6H0L63,0z' />
      <path fill='#CC27B0' d='M62.9,0l46.7,78.6H76L62.9,0z' />
      <path fill='#0071CE' d='M0,78.6h76.2l4.8,28.4L0,78.6z' />
      <path fill='#E17FD2' d='M76,78.6h33.5L80.8,107L76,78.6z' />
    </svg>
  )
}

export function SalesforceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 273 191'>
      <path
        d='M113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.4-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.97c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8'
        fill='#00A1E0'
      />
      <path
        d='M39.4 99.3c-0.17 0.45 0.06 0.54 0.12 0.62 0.51 0.37 1.03 0.64 1.55 0.94 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.09c0-4.42-3.92-6.03-7.58-7.18l-0.48-0.15c-2.77-0.9-5.16-1.68-5.16-3.5v-0.09c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.26 0.8 7.09 1.81 0 0 0.54 0.35 0.74-0.17 0.11-0.28 1.04-2.78 1.14-3.06 0.11-0.29-0.08-0.51-0.27-0.63-2.1-1.28-5-2.15-8-2.15l-0.56 2e-3c-5.11 0-8.68 3.09-8.68 7.51v0.1c0 4.66 3.94 6.18 7.62 7.23l0.59 0.18c2.68 0.82 5 1.54 5 3.42v0.09c0 1.73-1.51 3.02-3.93 3.02-0.94 0-3.94-0.02-7.19-2.07-0.39-0.23-0.62-0.39-0.92-0.58-0.16-0.1-0.56-0.27-0.73 0.25l-1.1 3.06zm81.7 0c-0.17 0.45 0.06 0.54 0.12 0.62 0.51 0.37 1.03 0.64 1.55 0.94 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.09c0-4.42-3.91-6.03-7.58-7.18l-0.48-0.15c-2.77-0.9-5.16-1.68-5.16-3.5v-0.09c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.25 0.8 7.09 1.81 0 0 0.54 0.35 0.74-0.17 0.11-0.28 1.04-2.78 1.13-3.06 0.11-0.29-0.08-0.51-0.27-0.63-2.1-1.28-5-2.15-8-2.15l-0.56 2e-3c-5.11 0-8.68 3.09-8.68 7.51v0.1c0 4.66 3.94 6.18 7.62 7.23l0.59 0.18c2.69 0.82 5 1.54 5 3.42v0.09c0 1.73-1.51 3.02-3.93 3.02-0.94 0-3.95-0.02-7.19-2.07-0.39-0.23-0.62-0.39-0.92-0.58-0.1-0.06-0.57-0.25-0.73 0.25l-1.1 3.06zm55.8-9.36c0 2.7-0.5 4.83-1.49 6.34-0.98 1.49-2.47 2.22-4.54 2.22s-3.55-0.72-4.52-2.21c-0.98-1.5-1.47-3.64-1.47-6.34 0-2.7 0.5-4.82 1.47-6.31 0.97-1.48 2.44-2.19 4.52-2.19s3.56 0.72 4.54 2.19c0.99 1.49 1.49 3.61 1.49 6.31zm4.66-5.01c-0.46-1.55-1.17-2.91-2.12-4.05-0.95-1.14-2.15-2.06-3.58-2.72-1.42-0.66-3.1-1-5-1s-3.57 0.34-5 1c-1.42 0.66-2.63 1.58-3.58 2.72-0.95 1.14-1.66 2.5-2.12 4.05-0.45 1.54-0.69 3.22-0.69 5.01 0 1.79 0.23 3.47 0.69 5.01 0.46 1.55 1.17 2.91 2.12 4.05 0.95 1.14 2.16 2.05 3.58 2.7 1.43 0.65 3.11 0.98 5 0.98 1.89 0 3.57-0.33 4.99-0.98 1.42-0.65 2.63-1.56 3.58-2.7 0.95-1.14 1.66-2.5 2.12-4.05 0.45-1.54 0.69-3.22 0.69-5.01 0-1.78-0.23-3.47-0.68-5.01zm38.3 12.8c-0.15-0.45-0.59-0.28-0.59-0.28-0.68 0.26-1.4 0.5-2.17 0.62-0.78 0.12-1.64 0.18-2.55 0.18-2.25 0-4.05-0.67-5.33-2-1.29-1.33-2.01-3.47-2-6.37 7e-3 -2.64 0.65-4.62 1.79-6.14 1.13-1.5 2.87-2.28 5.17-2.28 1.92 0 3.39 0.22 4.93 0.71 0 0 0.37 0.16 0.54-0.32 0.41-1.13 0.71-1.94 1.15-3.18 0.12-0.35-0.18-0.5-0.29-0.55-0.6-0.24-2.03-0.62-3.11-0.79-1.01-0.15-2.18-0.23-3.5-0.23-1.96 0-3.7 0.34-5.19 1-1.49 0.66-2.75 1.58-3.75 2.72-1 1.14-1.76 2.5-2.27 4.05-0.5 1.54-0.76 3.23-0.76 5.02 0 3.86 1.04 6.99 3.1 9.28 2.06 2.3 5.16 3.46 9.2 3.46 2.39 0 4.84-0.48 6.6-1.18 0 0 0.34-0.16 0.19-0.55l-1.15-3.16zm8.15-10.4c0.22-1.5 0.63-2.75 1.28-3.72 0.97-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.81 4.42 2.29 0.65 0.98 0.93 2.27 1.04 3.72l-11.3-2e-3zm15.7-3.3c-0.4-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.92c-1.97 0-3.76 0.33-5.21 1.01-1.45 0.68-2.67 1.61-3.63 2.77-0.96 1.16-1.68 2.53-2.14 4.1-0.46 1.55-0.69 3.25-0.69 5.03 0 1.82 0.24 3.51 0.72 5.04 0.48 1.54 1.25 2.89 2.29 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.62 3.52 0.93 5.73 0.93 4.56-0.01 6.96-1.03 7.94-1.58 0.18-0.1 0.34-0.27 0.13-0.75l-1.03-2.89c-0.16-0.43-0.59-0.28-0.59-0.28-1.13 0.42-2.73 1.18-6.48 1.17-2.45-4e-3 -4.26-0.73-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.01s0.42-4e-3 0.46-0.41c0.02-0.17 0.54-3.24-0.47-6.79zm-142 3.3c0.22-1.5 0.64-2.75 1.28-3.72 0.97-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.81 4.42 2.29 0.65 0.98 0.93 2.27 1.04 3.72l-11.3-2e-3zm15.7-3.3c-0.4-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.92c-1.97 0-3.76 0.33-5.21 1.01-1.45 0.68-2.67 1.61-3.63 2.77-0.96 1.16-1.68 2.53-2.14 4.1-0.46 1.55-0.69 3.25-0.69 5.03 0 1.82 0.24 3.51 0.72 5.04 0.48 1.54 1.25 2.89 2.28 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.62 3.51 0.93 5.73 0.93 4.56-0.01 6.96-1.03 7.94-1.58 0.17-0.1 0.34-0.27 0.13-0.75l-1.03-2.89c-0.16-0.43-0.59-0.28-0.59-0.28-1.13 0.42-2.73 1.18-6.48 1.17-2.44-4e-3 -4.26-0.73-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.01s0.42-4e-3 0.46-0.41c0.02-0.17 0.54-3.24-0.47-6.79zm-49.8 13.6c-0.62-0.49-0.7-0.61-0.91-0.94-0.31-0.48-0.47-1.17-0.47-2.05 0-1.38 0.46-2.38 1.41-3.05-0.01 2e-3 1.36-1.18 4.58-1.14a32 32 0 0 1 4.28 0.37v7.17h2e-3s-2 0.43-4.26 0.57c-3.21 0.19-4.63-0.92-4.62-0.92zm6.28-11.1c-0.64-0.05-1.47-0.07-2.46-0.07-1.35 0-2.66 0.17-3.88 0.5-1.23 0.33-2.34 0.85-3.29 1.53a7.63 7.63 0 0 0-2.29 2.6c-0.56 1.04-0.84 2.26-0.84 3.64 0 1.4 0.24 2.61 0.72 3.6a6.54 6.54 0 0 0 2.06 2.47c0.88 0.64 1.96 1.11 3.21 1.39 1.24 0.28 2.64 0.43 4.18 0.43 1.62 0 3.23-0.14 4.79-0.4a95.1 95.1 0 0 0 3.97-0.77c0.53-0.12 1.11-0.28 1.11-0.28 0.39-0.1 0.36-0.52 0.36-0.52l-9e-3 -14.4c0-3.16-0.84-5.51-2.51-6.96-1.66-1.45-4.09-2.18-7.24-2.18-1.18 0-3.09 0.16-4.23 0.39 0 0-3.44 0.67-4.86 1.78 0 0-0.31 0.19-0.14 0.63l1.12 3c0.14 0.39 0.52 0.26 0.52 0.26s0.12-0.05 0.26-0.13c3.03-1.65 6.87-1.6 6.87-1.6 1.7 0 3.02 0.35 3.9 1.02 0.86 0.66 1.3 1.66 1.3 3.76v0.67c-1.35-0.2-2.6-0.31-2.6-0.31zm127-8.13a0.43 0.43 0 0 0-0.24-0.57c-0.27-0.1-1.61-0.38-2.64-0.45-1.98-0.12-3.08 0.21-4.07 0.65-0.98 0.44-2.06 1.15-2.66 1.97l-2e-3 -1.92c0-0.26-0.19-0.48-0.45-0.48h-4.04c-0.26 0-0.45 0.21-0.45 0.48v23.5a0.48 0.48 0 0 0 0.48 0.48h4.14a0.48 0.48 0 0 0 0.48-0.48v-11.8c0-1.58 0.17-3.15 0.52-4.14 0.34-0.98 0.81-1.76 1.38-2.32a4.79 4.79 0 0 1 1.95-1.17 7.68 7.68 0 0 1 2.12-0.3c0.83 0 1.73 0.21 1.73 0.21 0.3 0.03 0.47-0.15 0.58-0.43 0.27-0.72 1.04-2.88 1.19-3.31'
        fill='#fff'
      />
      <path
        d='M162.2 67.55a13.26 13.26 0 0 0-1.56-.37 12.22 12.22 0 0 0-2.14-.166c-2.85 0-5.1.806-6.68 2.4-1.57 1.58-2.63 3.99-3.17 7.15l-.193 1.07h-3.58s-.437-.018-.529.46l-.588 3.28c-.41.31.094.51.51.508h3.49l-3.54 19.74c-.277 1.59-.594 2.9-.945 3.89-.346.98-.684 1.71-1.1 2.24-.403.52-.785.89-1.44 1.12-.544.18-1.17.27-1.86.267-.382 0-.89-.064-1.26-.139-.375-.074-.57-.158-.851-.276 0 0-.409-.156-.57.25-.131.34-1.06 2.89-1.17 3.21-.112.31.45.56.243.63.464.17.809.27 1.44.421.88.207 1.62.22 2.31.22 1.45 0 2.78-.204 3.87-.6 1.1-.399 2.07-1.09 2.92-2.03.919-1.01 1.5-2.08 2.05-3.53.547-1.44 1.01-3.22 1.39-5.3l3.55-20.11h5.2s.438.02.529-.459l.588-3.28c.041-.314-.093-.51-.515-.508h-5.04c.025-.114.25-1.89.833-3.56.247-.713.71-1.29 1.11-1.68a3.27 3.27 0 0 1 1.32-.822 5.48 5.48 0 0 1 1.69-.244c.475 0 .941.06 1.3.131.49.104.68.159.81.197.51.157.58.5.68-.244l1.21-3.31c.124-.356-.178-.506-.29-.55zm-70.47 34.12c0 .264-.188.48-.452.48h-4.18c-.265 0-.453-.215-.453-.479V68c0-.263.19-.476.45-.476h4.18c.264 0 .452.21.452.48v33.67'
        fill='#fff'
      />
    </svg>
  )
}

export function SapS4HanaIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='15 10 382.38 184'>
      <defs>
        <linearGradient
          id={id}
          x1='206.19'
          y1='0'
          x2='206.19'
          y2='204'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#00b1eb' />
          <stop offset='.212' stopColor='#009ad9' />
          <stop offset='.519' stopColor='#007fc4' />
          <stop offset='.792' stopColor='#006eb8' />
          <stop offset='1' stopColor='#0069b4' />
        </linearGradient>
      </defs>
      <polyline
        fill={`url(#${id})`}
        fillRule='evenodd'
        points='0 204 208.41 204 412.38 0 0 0 0 204'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='m244.73,38.36l-40.59-.025v96.52l-35.46-96.52h-35.16l-30.28,80.72c-3.22-20.35-24.28-27.38-40.84-32.65-10.94-3.51-22.54-8.68-22.43-14.39.091-4.69,6.23-9.04,18.38-8.38,8.17.43,15.37,1.09,29.71,8.01l14.1-24.56c-13.09-6.66-31.17-10.87-45.98-10.88h-.086c-17.28,0-31.68,5.6-40.6,14.82-6.22,6.44-9.57,14.63-9.71,23.68-.227,12.45,4.34,21.29,13.94,28.34,8.1,5.94,18.47,9.79,27.6,12.63,11.27,3.49,20.47,6.53,20.36,13-.083,2.36-.977,4.55-2.67,6.34-2.81,2.9-7.12,3.99-13.08,4.1-11.5.243-20.03-1.56-33.61-9.59l-12.54,24.9c13.55,7.71,29.59,12.22,45.95,12.22l2.11-.024c14.25-.256,25.75-4.32,34.93-11.71.527-.416,1-.845,1.49-1.28l-4.07,10.87h36.88l6.19-18.82c6.48,2.21,13.85,3.44,21.68,3.44,7.62,0,14.8-1.17,21.16-3.25l5.97,18.64h60.14v-38.97h13.11c31.71,0,50.46-16.15,50.46-43.2,0-30.14-18.22-43.97-57.01-43.97Zm-93.82,82.59c-4.74,0-9.18-.828-13.01-2.27l12.87-40.59h.244l12.64,40.71c-3.8,1.35-8.14,2.16-12.75,2.16Zm96.2-23.32h-8.94v-32.71h8.94c11.93,0,21.44,3.96,21.44,16.14,0,12.6-9.51,16.57-21.44,16.57'
      />
    </svg>
  )
}

export function SapConcurIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 43.1 43.1'>
      <path
        fill='#F0AB00'
        d='M20.5,28.2c-3.6,0-6.6-3-6.6-6.6s2.9-6.6,6.6-6.6c1.8,0,3.5,0.7,4.6,1.9l3.4-3.4c-2.1-2.1-4.9-3.3-8.1-3.3 C14.1,10.2,9,15.3,9,21.6S14.1,33,20.4,33c3.1,0,6-1.3,8.1-3.3l-3.4-3.4C23.9,27.4,22.3,28.2,20.5,28.2'
      />
      <path
        fill='#F0AB00'
        d='M30.1,18.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9C33,20,31.7,18.7,30.1,18.7'
      />
      <path
        fill='#F0AB00'
        d='M0,43.1h43.1V0H0V43.1z M4.8,38.2V4.8h33.4v15.5v2.4v15.5C38.2,38.2,4.8,38.2,4.8,38.2z'
      />
    </svg>
  )
}

export function ServiceNowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 71.1 63.6'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#62D84E'
        d='M35.8,0C16.1,0,0,15.9,0,35.6c0,9.8,4,19.3,11.2,26c2.5,2.4,6.4,2.6,9.2,0.5c9-6.7,21.4-6.7,30.4,0
       c2.8,2.1,6.7,1.9,9.2-0.5C74.3,48,74.9,25.4,61.3,11.1C54.7,4.1,45.4,0.1,35.8,0 M35.6,53.5C26,53.8,18,46.2,17.8,36.7
       c0-0.3,0-0.6,0-0.9c0-9.8,8-17.8,17.8-17.8s17.8,8,17.8,17.8c0.3,9.6-7.3,17.5-16.8,17.8C36.2,53.5,35.9,53.5,35.6,53.5'
      />
    </svg>
  )
}

export function AppConfigIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id={id}>
          <stop stopColor='#B0084D' offset='0%' />
          <stop stopColor='#FF4F8B' offset='100%' />
        </linearGradient>
      </defs>
      <rect fill={`url(#${id})`} width='80' height='80' />
      <path
        d='M50.871,37.366 C50.871,42.053 47.058,45.866 42.371,45.866 C37.684,45.866 33.871,42.053 33.871,37.366 C33.871,32.679 37.684,28.866 42.371,28.866 C47.058,28.866 50.871,32.679 50.871,37.366 L50.871,37.366 Z M52.871,37.366 C52.871,31.576 48.161,26.866 42.371,26.866 C36.581,26.866 31.871,31.576 31.871,37.366 C31.871,43.156 36.581,47.866 42.371,47.866 C48.161,47.866 52.871,43.156 52.871,37.366 L52.871,37.366 Z M47.91,62.418 C48.1,62.218 48.197,61.949 48.182,61.674 L47.999,58.473 C49.846,57.979 51.611,57.248 53.265,56.291 L55.4,58.685 C55.583,58.89 55.843,59.011 56.118,59.019 C56.394,59.042 56.659,58.921 56.853,58.726 L63.702,51.878 C63.896,51.683 64.003,51.417 63.995,51.142 C63.987,50.867 63.866,50.608 63.661,50.425 L61.259,48.283 C62.214,46.631 62.944,44.868 63.437,43.023 L66.649,43.207 C66.934,43.223 67.193,43.124 67.393,42.936 C67.594,42.747 67.707,42.484 67.707,42.209 L67.707,32.524 C67.707,32.249 67.594,31.986 67.393,31.797 C67.194,31.608 66.921,31.51 66.65,31.525 L63.434,31.708 C62.941,29.867 62.211,28.106 61.255,26.453 L63.661,24.307 C63.866,24.124 63.987,23.865 63.995,23.589 C64.003,23.314 63.896,23.048 63.702,22.854 L56.853,16.006 C56.659,15.81 56.392,15.696 56.118,15.713 C55.843,15.721 55.584,15.842 55.4,16.047 L53.247,18.46 C51.597,17.505 49.838,16.776 47.999,16.284 L48.182,13.057 C48.197,12.783 48.1,12.513 47.91,12.314 C47.722,12.114 47.459,12 47.183,12 L37.499,12 C37.224,12 36.961,12.114 36.772,12.314 C36.583,12.513 36.485,12.783 36.501,13.057 L36.683,16.282 C34.844,16.773 33.084,17.502 31.432,18.456 L29.282,16.047 C29.099,15.842 28.84,15.721 28.564,15.713 C28.295,15.698 28.023,15.811 27.829,16.006 L20.98,22.854 C20.786,23.048 20.68,23.314 20.687,23.589 C20.695,23.864 20.816,24.124 21.021,24.307 L23.433,26.458 C22.476,28.109 21.745,29.869 21.251,31.708 L18.032,31.525 C17.759,31.509 17.488,31.608 17.289,31.797 C17.089,31.986 16.975,32.249 16.975,32.524 L16.975,42.209 C16.975,42.484 17.089,42.747 17.289,42.936 C17.489,43.125 17.761,43.229 18.034,43.207 L21.985,42.976 L21.868,40.979 L18.975,41.149 L18.975,33.582 L21.966,33.752 C22.454,33.776 22.889,33.451 22.998,32.975 C23.496,30.783 24.358,28.704 25.563,26.799 C25.824,26.386 25.748,25.844 25.384,25.518 L23.143,23.519 L28.495,18.168 L30.492,20.407 C30.817,20.771 31.359,20.846 31.771,20.586 C33.678,19.385 35.756,18.525 37.949,18.03 C38.427,17.922 38.756,17.485 38.727,16.997 L38.558,14 L46.125,14 L45.955,16.999 C45.927,17.487 46.256,17.924 46.732,18.032 C48.925,18.527 51.002,19.388 52.906,20.591 C53.317,20.849 53.86,20.776 54.186,20.411 L56.187,18.168 L61.539,23.519 L59.304,25.513 C58.939,25.839 58.863,26.38 59.124,26.793 C60.328,28.7 61.19,30.78 61.686,32.974 C61.795,33.451 62.237,33.776 62.719,33.752 L65.707,33.582 L65.707,41.15 L62.723,40.979 C62.237,40.954 61.798,41.28 61.689,41.757 C61.192,43.956 60.331,46.037 59.128,47.942 C58.867,48.355 58.943,48.897 59.308,49.222 L61.539,51.212 L56.188,56.564 L54.204,54.34 C53.878,53.973 53.336,53.899 52.924,54.16 C51.017,55.365 48.934,56.228 46.732,56.725 C46.256,56.833 45.927,57.27 45.955,57.758 L46.125,60.731 L38.591,60.731 L38.727,59.185 L36.735,59.009 L36.503,61.643 C36.478,61.923 36.572,62.199 36.762,62.407 C36.951,62.614 37.219,62.731 37.499,62.731 L47.183,62.731 C47.459,62.731 47.722,62.618 47.91,62.418 L47.91,62.418 Z M37.101,54.554 L35.726,53.102 L23.215,64.956 L24.59,66.408 L37.101,54.554 Z M25.246,46.654 L23.875,45.198 L12.68,55.735 L14.051,57.191 L25.246,46.654 Z M13.414,67.706 L12,66.292 L31.756,46.536 L33.17,47.95 L13.414,67.706 Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

export function ApolloIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      height='26'
      viewBox='0 0 36 36'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.6 0.09L19.61 13.26C19.61 15.34 17.42 16.67 15.61 15.7L2.58 8.72C3.58 7.06 4.83 5.58 6.27 4.32L16.49 13.89C17.03 14.4 17.88 13.85 17.66 13.14L13.7 0.49C15.03 0.17 16.42 0 17.85 0C18.44 0 19.02 0.03 19.6 0.09Z'
        fill='#000000'
      />
      <path
        d='M16.06 36.11L16.06 23C16.06 20.92 18.24 19.59 20.05 20.56L33.08 27.55C32.08 29.2 30.83 30.68 29.38 31.93L19.17 22.37C18.63 21.86 17.78 22.41 18 23.12L21.95 35.72C20.63 36.03 19.26 36.2 17.85 36.2C17.25 36.2 16.65 36.17 16.06 36.11Z'
        fill='#000000'
      />
      <path
        d='M22.01 16.77L31.47 6.39C30.24 4.92 28.77 3.65 27.14 2.64L20.23 15.88C19.27 17.72 20.59 19.93 22.64 19.93L35.62 19.92C35.68 19.32 35.71 18.72 35.71 18.1C35.71 16.67 35.54 15.28 35.23 13.94L22.75 17.96C22.05 18.18 21.51 17.32 22.01 16.77Z'
        fill='#000000'
      />
      <path
        d='M0.08 16.34L13.02 16.33C15.08 16.33 16.39 18.55 15.43 20.38L8.56 33.56C6.93 32.55 5.47 31.28 4.24 29.81L13.65 19.49C14.15 18.94 13.61 18.08 12.91 18.3L0.49 22.3C0.17 20.95 0 19.55 0 18.1C0 17.51 0.03 16.92 0.08 16.34Z'
        fill='#000000'
      />
    </svg>
  )
}

export function Neo4jIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 128 128' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(64 64) scale(1.1) translate(-64 -64)'>
        <path
          d='M63.33 32.57c-5.2.87-9.57 3-12.83 6.27-3.87 3.87-5.83 8.5-6.5 15.37-.3 3.13-.467 15.47-.2 15.47.067 0 .7-.234 1.4-.534 1.63-.7 5.17-.7 7-.033l1.4.5.17-8.03c.166-8.57.366-9.87 1.97-13.07 1.1-2.13 3.77-4.63 6.03-5.67 2.6-1.2 6.4-1.67 9.33-1.2 6.27 1.03 10 4.43 11.57 10.5.63 2.43.666 3.7.67 17.1v14.43H93.4L93.23 67.9c-.1-14.9-.166-15.9-.866-18.57-1.9-7.4-6.5-12.77-12.93-15.2-3.43-1.3-6.7-1.8-11.2-1.77-2.23.033-4.43.133-4.9.2z'
          fill='#000'
        />
        <path
          d='M22.73 57.2c-2.87 1.43-4.4 4-4.4 7.47 0 1.1.2 2.5.47 3.13.633 1.57 2.43 3.47 4 4.3 1.9 1 5.5 1 7.37.033l1.37-.7 4.27 2.9 4.27 2.93V81.7L35.8 84.63l-4.3 2.93-1.1-.667c-1.6-.933-4.7-1.13-6.6-.4-2 .767-4.07 2.6-4.83 4.33-.834 1.77-.834 5.23 0 7 .7 1.57 2.33 3.3 3.8 4.07.6.3 2.03.6 3.23.7 2.8.2 5.17-.733 6.87-2.73 1.37-1.6 2.27-4.4 2.03-6.33l-.167-1.37 4.3-2.9 4.3-2.9 1.53.7c2.33 1 5.8.77 8-.567 2.4-1.5 3.6-3.63 3.73-6.63.1-2.1 0-2.57-.833-4.2-2.17-4.13-7-5.7-11.13-3.63l-1.23.6-4.23-2.9-4.23-2.9-.1-2.33c-.066-2.8-.866-4.6-2.83-6.23-2.5-2.13-6.23-2.57-9.27-1.07z'
          fill='#018BFF'
        />
      </g>
    </svg>
  )
}

export function CbInsightsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M63.858 28.878H44V9.58h11.78A8.24 8.24 0 0 1 64 17.809v11.07z' fill='#006699' />
      <path
        d='M55.628 54.28H43.85V33.703h19.867V46.05c.142 4.54-3.548 8.23-8.1 8.23z'
        fill='#ff6633'
      />
      <path
        d='M20.718 33.703v-4.967h19.44V9.58H8.1c-4.54 0-8.1 3.7-8.1 8.23V46.2a8.24 8.24 0 0 0 8.231 8.231H40.3V33.703z'
        fill='#003366'
      />
    </svg>
  )
}

export function CalendlyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='169.28 46.16 502.57 502.57' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#006bff'
        d='M505.27,365.28c-14.79,12.86-33.19,28.86-66.71,28.86h-20.01c-24.22,0-46.25-8.62-62.01-24.28
	c-15.39-15.3-23.89-36.22-23.89-58.94v-26.87c0-22.72,8.48-43.66,23.89-58.94c15.77-15.66,37.79-24.28,62.01-24.28h20.01
	c33.51,0,51.92,16,66.71,28.86c15.34,13.34,28.59,24.86,63.89,24.86c5.48,0,10.86-0.43,16.09-1.26c-0.04-0.11-0.08-0.2-0.12-0.3
	c-2.1-5.1-4.57-10.12-7.42-14.96l-23.6-40.1c-21.65-36.8-61.68-59.46-104.98-59.46h-47.21c-43.3,0-83.33,22.67-104.98,59.46
	l-23.6,40.1c-21.65,36.8-21.65,82.12,0,118.91l23.6,40.1c21.65,36.8,61.68,59.45,104.98,59.45h47.21
	c43.3,0,83.33-22.67,104.98-59.45l23.6-40.1c2.85-4.85,5.32-9.85,7.42-14.95c0.04-0.11,0.08-0.2,0.12-0.3
	c-5.23-0.83-10.59-1.26-16.09-1.26C533.87,340.42,520.61,351.94,505.27,365.28z'
      />
      <path
        fill='#006bff'
        d='M438.57,225.16h-20.01c-36.86,0-61.09,25.83-61.09,58.89v26.87c0,33.06,24.22,58.89,61.09,58.89h20.01
	c53.71,0,49.49-53.72,130.59-53.72c7.77,0,15.45,0.7,22.92,2.06c2.46-13.66,2.46-27.64,0-41.31c-7.48,1.36-15.15,2.06-22.92,2.06
	C488.06,278.89,492.28,225.16,438.57,225.16z'
      />
      <path
        fill='#006bff'
        d='M638.66,337.76c-13.85-10.02-29.74-16.56-46.59-19.64c-0.03,0.13-0.04,0.26-0.07,0.39
	c-1.44,7.87-3.69,15.62-6.77,23.14c14.22,2.26,27.32,7.5,38.52,15.55c-0.04,0.12-0.07,0.24-0.11,0.37
	c-6.46,20.57-16.2,39.96-28.93,57.6c-12.58,17.42-27.79,32.76-45.22,45.57c-36.18,26.62-79.27,40.68-124.63,40.68
	c-28.08,0-55.31-5.39-80.94-16.02c-24.75-10.27-46.99-24.98-66.11-43.73c-19.11-18.75-34.1-40.56-44.57-64.85
	c-10.83-25.14-16.33-51.85-16.33-79.4c0-27.55,5.5-54.26,16.33-79.4c10.47-24.28,25.46-46.1,44.57-64.85
	c19.11-18.75,41.35-33.45,66.11-43.73c25.62-10.63,52.85-16.02,80.94-16.02c45.36,0,88.45,14.06,124.63,40.68
	c17.43,12.82,32.63,28.15,45.22,45.57c12.73,17.65,22.47,37.04,28.93,57.6c0.04,0.13,0.08,0.25,0.11,0.37
	c-11.19,8.04-24.3,13.3-38.52,15.55c3.08,7.53,5.34,15.3,6.77,23.17c0.03,0.13,0.04,0.25,0.07,0.38
	c16.85-3.08,32.73-9.62,46.59-19.64c13.28-9.64,10.71-20.53,8.69-26.99C618.08,136.9,529.55,69.12,424.87,69.12
	c-128.55,0-232.75,102.22-232.75,228.32c0,126.1,104.21,228.32,232.75,228.32c104.68,0,193.21-67.79,222.48-161.05
	C649.38,358.29,651.96,347.41,638.66,337.76z'
      />
      <path
        fill='#0ae8f0'
        d='M585.25,253.26c-5.23,0.83-10.59,1.26-16.09,1.26c-35.29,0-48.55-11.52-63.89-24.86
	c-14.79-12.86-33.19-28.86-66.71-28.86h-20.01c-24.22,0-46.25,8.62-62.01,24.28c-15.39,15.3-23.89,36.22-23.89,58.94v26.87
	c0,22.72,8.48,43.66,23.89,58.94c15.77,15.66,37.79,24.28,62.01,24.28h20.01c33.51,0,51.92-16.01,66.71-28.86
	c15.34-13.34,28.59-24.86,63.89-24.86c5.48,0,10.86,0.43,16.09,1.26c3.08-7.52,5.32-15.28,6.77-23.14c0.03-0.13,0.04-0.26,0.07-0.39
	c-7.48-1.36-15.15-2.06-22.92-2.06c-81.1,0-76.88,53.72-130.59,53.72h-20.01c-36.86,0-61.09-25.83-61.09-58.89v-26.87
	c0-33.06,24.22-58.89,61.09-58.89h20.01c53.71,0,49.5,53.72,130.59,53.72c7.77,0,15.45-0.7,22.92-2.06
	c-0.03-0.13-0.04-0.25-0.07-0.38C590.59,268.56,588.33,260.8,585.25,253.26z'
      />
    </svg>
  )
}

export function STTIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m15 16 2.54-7.33a1.02 1.02 1 0 1 1.93 0L22 16' />
      <path d='M15.7 14h5.61' />
      <path d='m2 16 4.04-9.69a.5.5 0 0 1 .923 0L11 16' />
      <path d='M3.3 13h6.39' />
    </svg>
  )
}

export function TTSIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M2 10v3' />
      <path d='M6 6v11' />
      <path d='M10 3v18' />
      <path d='M14 8v7' />
      <path d='M18 5v13' />
      <path d='M22 10v3' />
    </svg>
  )
}

export function VideoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m16 13 5.22 3.48a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5' />
      <rect x='2' y='6' width='14' height='12' rx='2' />
    </svg>
  )
}

export function VllmIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <title>vLLM</title>
      <path d='M0 4.97h9.32V23L0 4.97z' fill='#FDB515' />
      <path d='M13.99 4.35L22.38 0l-6.22 23H9.32l4.66-18.65z' fill='#30A2FF' />
    </svg>
  )
}

export function LitellmIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill='none' viewBox='0 0 72 72' xmlns='http://www.w3.org/2000/svg'>
      <title>LiteLLM</title>
      <image
        href='data:image/png;base64,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'
        width='72'
        height='72'
        preserveAspectRatio='xMidYMid meet'
      />
    </svg>
  )
}

export function PosthogIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='50'
      height='30'
      viewBox='0 0 50 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.89 17.21c-.368.74-1.42.74-1.79 0L8.22 15.44c-.141-.281-.141-.613 0-.894l.881-1.76c.369-.737 1.42-.737 1.79 0l.881 1.76c.141.28.14.61 0 .894l-.881 1.76zM10.89 27.2c-.368.74-1.42.737-1.79 0L8.22 25.44c-.141-.281-.141-.613 0-.894l.881-1.76c.369-.737 1.42-.737 1.79 0l.881 1.76c.141.28.14.61 0 .894l-.881 1.76z'
        fill='#1D4AFF'
      />
      <path
        d='M0 23.41c0-.891 1.08-1.34 1.71-.707l4.58 4.58c.63.63.18 1.71-.707 1.71H1c-.552 0-1-.448-1-1v-4.58zm0-4.83c0 .265.11.52.29.71l9.41 9.41c.188.19.44.29.71.29h5.17c.891 0 1.34-1.8.71-1.71L1.71 12.7C1.08 12.07 0 12.52 0 13.41v5.17zm0-10c0 .265.11.52.29.71L19.7 28.7c.188.19.44.29.71.29h5.17c.891 0 1.34-1.8.71-1.71L1.71 2.71C1.08 2.08 0 2.52 0 3.41v5.17zm10 0c0 .265.11.52.29.71l17.99 17.99c.63.63 1.71.18 1.71-.707v-5.17c0-.265-.105-.52-.293-.707l-17.99-17.99c-.63-.63-1.71-.184-1.71.71v5.17zm11.7-5.88c-.63-.63-1.71-.184-1.71.71v5.17c0 .265.11.52.29.71l8 8c.63.63 1.71.18 1.71-.707v-5.17c0-.265-.105-.52-.293-.707l-8-8z'
        fill='#F9BD2B'
      />
      <path
        d='M42.52 23.53l-9.41-9.41c-.63-.63-1.71-.184-1.71.71v13.17c0 .552.45 1 1 1h14.58c.552 0 1-.448 1-1v-1.2c0-.552-.45-.993-.997-1.06-1.68-.219-3.25-.986-4.46-2.2zm-6.32 2.26c-.883 0-1.6-.717-1.6-1.6 0-.883.72-1.6 1.6-1.6.883 0 1.6.72 1.6 1.6 0 .883-.717 1.6-1.6 1.6z'
        fill='#000'
      />
      <path
        d='M0 27.99c0 .552.45 1 1 1h4.58c.891 0 1.34-1.8.71-1.71l-4.58-4.58C1.08 22.07 0 22.52 0 23.41v4.58zM10 11L1.71 2.71C1.08 2.08 0 2.52 0 3.41v5.17c0 .265.11.52.29.71L10 18.99V11zM1.71 12.7C1.08 12.07 0 12.52 0 13.41v5.17c0 .265.11.52.29.71L10 28.99V20.99l-8.29-8.29z'
        fill='#1D4AFF'
      />
      <path
        d='M19.99 11.41c0-.265-.105-.52-.293-.707l-8-8c-.63-.63-1.71-.184-1.71.71v5.17c0 .265.11.52.29.71l9.7 9.7v-7.58zM10 28.99h5.58c.891 0 1.34-1.8.71-1.71L10 20.99v8zM10 11v7.58c0 .265.11.52.29.71l9.7 9.7v-7.58c0-.265-.105-.52-.293-.707L10 11z'
        fill='#F54E00'
      />
    </svg>
  )
}

export function SentryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='0 -14.5 256 256'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M148.37,12.4 C144.04,5.21 136.26,0.82 127.87,0.82 C119.47,0.82 111.7,5.21 107.37,12.4 L73.64,70.17 C126.07,96.34 160.69,148.34 164.62,206.81 L140.94,206.81 C137.02,156.69 106.87,112.4 61.7,90.36 L30.48,144.33 C55.85,155.7 73.68,179.21 77.79,206.7 L23.41,206.7 C22.1,206.61 20.93,205.86 20.29,204.72 C19.65,203.57 19.63,202.18 20.23,201.01 L35.3,175.39 C30.2,171.13 24.36,167.83 18.08,165.65 L3.17,191.28 C0.03,196.66 -0.82,203.07 0.81,209.08 C2.44,215.09 6.41,220.2 11.83,223.26 C15.37,225.25 19.35,226.31 23.41,226.33 L97.88,226.33 C100.7,191.62 85.14,157.97 56.88,137.61 L68.72,117.11 C104.4,141.62 124.47,183.15 121.51,226.33 L184.6,226.33 C187.59,160.9 155.56,98.82 100.5,63.35 L124.43,22.35 C125.54,20.49 127.94,19.87 129.81,20.96 C132.53,22.45 233.81,199.17 235.7,201.22 C236.38,202.44 236.36,203.93 235.64,205.13 C234.92,206.32 233.61,207.04 232.22,207.01 L207.82,207.01 C208.13,213.54 208.13,220.05 207.82,226.54 L232.32,226.54 C238.6,226.58 244.64,224.11 249.09,219.67 C253.54,215.23 256.03,209.2 256,202.91 C256,198.8 254.91,194.77 252.82,191.23 L148.37,12.4 Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function IncidentioIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `incidentio_clip_${id}`

  return (
    <svg
      {...props}
      width='128'
      height='163'
      viewBox='0 0 128 163'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M48.73 139.64V163C20.76 156.32 0 131.71 0 102.37C0 85.46 7.16 72.04 18.11 58.87C27.18 47.95 49.6 19.04 56.65 3.09C58.37 -0.78 62.73 -0.63 64.62 1.45C70.64 8.1 78.07 22.64 80.5 39.14C80.99 42.5 81.2 45.24 81.36 47.42C81.71 52.1 81.86 54.17 84.29 54.17C88.1 54.17 90.59 48.4 91.14 42.43C91.49 38.61 95.28 37.33 97.89 38.61C110.46 44.76 123.29 74.04 126.39 88.41C127.37 92.92 128 97.57 128 102.37C128 131.65 107.34 156.21 79.45 162.96V139.64H48.73ZM64 130.33C73.83 130.33 81.8 122.79 81.8 113.48C81.8 98.64 70.86 88.03 65.4 84.81C65.04 84.59 64.85 84.48 64.35 84.5C63.98 84.51 63.44 84.74 63.18 84.99C62.82 85.34 62.73 85.74 62.54 86.54C61.57 90.61 58.53 93.51 55.33 96.56C50.91 100.76 46.2 105.25 46.2 113.48C46.2 122.79 54.17 130.33 64 130.33Z'
          fill='#F25533'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='128' height='163' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function InfisicalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='20 25 233 132' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='m191.6 39.4c-20.3 0-37.15 13.21-52.9 30.61-12.99-16.4-29.8-30.61-51.06-30.61-27.74 0-50.44 23.86-50.44 51.33 0 26.68 21.43 51.8 48.98 51.8 20.55 0 37.07-13.86 51.32-31.81 12.69 16.97 29.1 31.41 53.2 31.41 27.13 0 49.85-22.96 49.85-51.4 0-27.12-20.44-51.33-48.95-51.33zm-104.3 77.94c-14.56 0-25.51-12.84-25.51-26.07 0-13.7 10.95-28.29 25.51-28.29 14.93 0 25.71 11.6 37.6 27.34-11.31 15.21-22.23 27.02-37.6 27.02zm104.4 0.25c-15 0-25.28-11.13-37.97-27.37 12.69-16.4 22.01-27.24 37.59-27.24 14.97 0 24.79 13.25 24.79 27.26 0 13-10.17 27.35-24.41 27.35z'
        fill='currentColor'
      />
    </svg>
  )
}
export function IntercomIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='-3.5 0 263 263'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M221.66,144.56 C221.66,146.9 220.76,149.15 219.17,150.8 C217.57,152.46 215.4,153.39 213.15,153.39 C210.89,153.39 208.72,152.46 207.12,150.8 C205.53,149.15 204.63,146.9 204.63,144.56 L204.63,65.68 C204.63,63.34 205.53,61.09 207.12,59.43 C208.72,57.78 210.89,56.85 213.15,56.85 C215.4,56.85 217.57,57.78 219.17,59.43 C220.76,61.09 221.66,63.34 221.66,65.68 L221.66,144.56 Z M218.7,199.22 C217.58,200.39 185.91,227.75 127.86,227.75 C69.81,227.75 38.35,200.53 37.01,199.36 C36.17,198.63 35.48,197.73 34.97,196.71 C34.47,195.69 34.16,194.59 34.07,193.45 C33.98,192.31 34.1,191.16 34.44,190.07 C34.77,188.98 35.32,187.98 36.03,187.1 C37.5,185.34 39.58,184.25 41.82,184.07 C44.06,183.9 46.28,184.64 47.99,186.16 C48.48,186.52 76.77,210.31 127.79,210.31 C178.81,210.31 207.3,186.37 207.59,186.16 C209.32,184.66 211.54,183.92 213.79,184.1 C216.04,184.27 218.13,185.35 219.62,187.1 C221.06,188.84 221.77,191.1 221.61,193.38 C221.46,195.66 220.44,197.78 218.78,199.29 L218.7,199.22 Z M33.99,65.68 C34.12,63.33 35.13,61.13 36.82,59.55 C38.51,57.98 40.73,57.17 43,57.29 C45.1,57.41 47.08,58.33 48.56,59.88 C50.04,61.43 50.92,63.5 51.02,65.68 L51.02,144.42 C51.02,146.76 50.12,149 48.52,150.66 C46.93,152.31 44.76,153.24 42.5,153.24 C40.24,153.24 38.08,152.31 36.48,150.66 C34.88,149 33.99,146.76 33.99,144.42 L33.99,65.68 Z M76.7,48.16 C76.83,45.81 77.85,43.61 79.54,42.04 C81.22,40.47 83.44,39.65 85.71,39.77 C87.81,39.9 89.79,40.82 91.27,42.37 C92.75,43.92 93.63,45.98 93.73,48.16 L93.73,164.92 C93.73,167.26 92.83,169.51 91.24,171.16 C89.64,172.82 87.47,173.75 85.22,173.75 C82.96,173.75 80.79,172.82 79.2,171.16 C77.6,169.51 76.7,167.26 76.7,164.92 L76.7,48.16 Z M119.63,43.79 C119.63,41.44 120.52,39.2 122.12,37.54 C123.72,35.89 125.88,34.96 128.14,34.96 C130.4,34.96 132.56,35.89 134.16,37.54 C135.76,39.2 136.66,41.44 136.66,43.79 L136.66,170.76 C136.66,173.1 135.76,175.35 134.16,177 C132.56,178.66 130.4,179.59 128.14,179.59 C125.88,179.59 123.72,178.66 122.12,177 C120.52,175.35 119.63,173.1 119.63,170.76 L119.63,43.79 Z M161.85,48.16 C161.85,45.82 162.74,43.58 164.34,41.92 C165.94,40.26 168.1,39.33 170.36,39.33 C172.62,39.33 174.79,40.26 176.38,41.92 C177.98,43.58 178.88,45.82 178.88,48.16 L178.88,164.92 C178.88,167.26 177.98,169.51 176.38,171.16 C174.79,172.82 172.62,173.75 170.36,173.75 C168.1,173.75 165.94,172.82 164.34,171.16 C162.74,169.51 161.85,167.26 161.85,164.92 L161.85,48.16 Z M223.98,0 L32.02,0 C27.83,-0.03 23.69,0.8 19.81,2.44 C15.94,4.07 12.41,6.48 9.44,9.53 C6.47,12.58 4.1,16.21 2.48,20.21 C0.86,24.21 0.02,28.5 0,32.84 L0,229.87 C0.02,234.2 0.86,238.5 2.48,242.49 C4.1,246.49 6.47,250.12 9.44,253.17 C12.41,256.22 15.94,258.64 19.81,260.27 C23.69,261.91 27.83,262.73 32.02,262.71 L223.98,262.71 C228.16,262.73 232.3,261.91 236.17,260.28 C240.04,258.65 243.56,256.24 246.53,253.2 C249.51,250.16 251.87,246.54 253.5,242.55 C255.12,238.55 255.97,234.27 256,229.94 L256,32.84 C255.98,28.51 255.14,24.22 253.52,20.23 C251.91,16.23 249.55,12.61 246.58,9.56 C243.62,6.51 240.1,4.1 236.24,2.46 C232.37,0.82 228.23,-0.02 224.05,0'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function LoopsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 214 186' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M122.19,0 H90.27 C40.51,0 0,39.88 0,92.95 C0,141.07 38.93,183.77 90.27,183.77 H122.19 C172.61,183.77 213.31,142.82 213.31,92.95 C213.31,43.29 173.09,0 122.19,0 Z M10.82,92.54 C10.82,50.19 45.91,11.49 91.96,11.49 C138.73,11.49 172.69,50.33 172.69,92.13 C172.69,117.76 154.06,139.09 129.02,143.31 C145.16,131.15 155.48,112.73 155.48,92.4 C155.48,59.09 127.44,28.82 92.37,28.82 C57.23,28.82 28.51,57.23 28.51,92.91 C28.51,122.63 43.61,151.08 69.99,168.21 L71.74,169.33 C35.99,161.39 10.82,130.11 10.82,92.54 Z M106.33,42.76 C128.88,50.19 143.91,68.92 143.91,92.26 C143.91,114.23 128.68,134.63 106.12,141.71 C105.44,141.96 105.17,141.96 105.17,141.96 C83.91,135.76 69.29,116.38 69.29,92.71 C69.29,69.91 83.71,50.33 106.33,42.76 Z M120.91,172.13 C76.11,172.13 40.09,137.21 40.09,93.32 C40.09,67.03 57.17,46.11 83.98,41.33 C67.04,53.83 57.3,71.71 57.3,92.71 C57.3,125.75 82.94,155.33 120.77,155.33 C155.01,155.33 184.31,125.2 184.31,92.47 C184.31,62.34 169.96,34.06 141.92,14.55 L141.65,14.34 C175.81,23.68 202.26,54.11 202.26,92.81 C202.26,135.69 166.38,172.13 120.91,172.13 Z'
        fill='#FB5001'
      />
    </svg>
  )
}

export function LumaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill='none' viewBox='0 0 133 134' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M133 67C96.28 67 66.5 36.99 66.5 0c0 36.99-29.78 67-66.5 67 36.72 0 66.5 30.01 66.5 67 0-36.99 29.78-67 66.5-67'
        fill='currentColor'
      />
    </svg>
  )
}

export function MailchimpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 230.81 244.96'
      xmlSpace='preserve'
      fill='currentColor'
    >
      <g>
        <g>
          <g>
            <g>
              <path d='M173.62,115.76c1.79-0.21,3.5-0.22,5.07,0c0.91-2.09,1.07-5.69,0.25-9.61c-1.22-5.83-2.87-9.36-6.27-8.81 c-3.41,0.55-3.53,4.77-2.31,10.6C171.04,111.22,172.26,114.02,173.62,115.76z' />
              <path d='M144.37,120.37c2.44,1.07,3.94,1.78,4.52,1.16c0.38-0.39,0.26-1.12-0.32-2.07c-1.2-1.96-3.68-3.96-6.3-5.07 c-5.37-2.31-11.77-1.54-16.71,2.01c-1.63,1.19-3.18,2.85-2.96,3.85c0.07,0.33,0.32,0.57,0.89,0.65 c1.34,0.15,6.04-2.22,11.45-2.55C138.77,118.11,141.93,119.3,144.37,120.37z' />
              <path d='M139.47,123.17c-3.17,0.5-4.93,1.55-6.05,2.52c-0.96,0.84-1.55,1.77-1.55,2.42c0,0.31,0.14,0.49,0.24,0.58 c0.14,0.13,0.32,0.2,0.52,0.2c0.72,0,2.32-0.64,2.32-0.64c4.42-1.58,7.33-1.39,10.22-1.06c1.6,0.18,2.35,0.28,2.7-0.27 c0.1-0.16,0.23-0.5-0.09-1.01C147.05,124.69,143.84,122.65,139.47,123.17z' />
              <path d='M163.74,133.44c2.16,1.06,4.53,0.64,5.3-0.93c0.77-1.57-0.35-3.7-2.5-4.76c-2.16-1.06-4.53-0.64-5.3,0.93 C160.46,130.25,161.59,132.38,163.74,133.44z' />
              <path d='M177.6,121.33c-1.75-0.03-3.2,1.89-3.24,4.29c-0.04,2.4,1.35,4.37,3.1,4.4c1.75,0.03,3.2-1.89,3.24-4.29 C180.74,123.33,179.35,121.36,177.6,121.33z' />
              <path d='M59.98,164.63c-0.44-0.55-1.15-0.38-1.84-0.22c-0.48,0.11-1.03,0.24-1.63,0.23c-1.29-0.02-2.38-0.58-2.99-1.52 c-0.8-1.22-0.75-3.05,0.13-5.14c0.12-0.28,0.26-0.59,0.41-0.94c1.4-3.15,3.76-8.42,1.12-13.45c-1.99-3.78-5.23-6.14-9.12-6.63 c-3.74-0.47-7.59,0.91-10.04,3.62c-3.87,4.27-4.48,10.09-3.73,12.14c0.27,0.75,0.7,0.96,1.02,1c0.66,0.09,1.63-0.39,2.24-2.03 c0.04-0.12,0.1-0.3,0.17-0.53c0.27-0.87,0.78-2.49,1.61-3.78c1-1.56,2.56-2.64,4.39-3.03c1.86-0.4,3.77-0.04,5.36,1 c2.71,1.78,3.76,5.1,2.6,8.27c-0.6,1.64-1.57,4.78-1.36,7.36c0.43,5.22,3.64,7.31,6.53,7.54c2.8,0.11,4.76-1.47,5.26-2.62 C60.39,165.22,60.14,164.81,59.98,164.63z' />
              <path d='M221.78,155.09c-0.11-0.38-0.8-2.92-1.76-5.98c-0.96-3.06-1.94-5.22-1.94-5.22c3.83-5.74,3.9-10.87,3.39-13.77 c-0.54-3.6-2.04-6.67-5.07-9.84c-3.02-3.17-9.2-6.42-17.89-8.86c-0.99-0.28-4.27-1.18-4.56-1.27 c-0.02-0.19-0.24-10.74-0.44-15.28c-0.14-3.28-0.43-8.39-2.01-13.43c-1.89-6.82-5.19-12.78-9.3-16.6 c11.35-11.76,18.43-24.72,18.42-35.84c-0.03-21.38-26.29-27.85-58.65-14.45c-0.03,0.01-6.81,2.89-6.86,2.91 c-0.03-0.03-12.39-12.16-12.58-12.32C85.65-27.04-29.7,101.18,7.18,132.32l8.06,6.83c-2.09,5.42-2.91,11.62-2.24,18.29 c0.86,8.57,5.28,16.79,12.45,23.13c6.8,6.03,15.74,9.84,24.42,9.83c14.35,33.07,47.14,53.36,85.59,54.5 c41.24,1.23,75.86-18.13,90.37-52.89c0.95-2.44,4.98-13.43,4.98-23.14C230.81,159.13,225.3,155.09,221.78,155.09z M53.04,181.12 c-1.25,0.21-2.53,0.3-3.82,0.27c-12.46-0.33-25.91-11.55-27.25-24.85c-1.48-14.7,6.03-26.01,19.33-28.7 c1.59-0.32,3.51-0.51,5.58-0.4c7.45,0.41,18.43,6.13,20.94,22.36C70.05,164.18,66.52,178.82,53.04,181.12z M39.13,119.05 c-8.28,1.61-15.58,6.3-20.04,12.78c-2.67-2.22-7.64-6.53-8.51-8.21c-7.12-13.53,7.77-39.83,18.18-54.68 c25.72-36.7,66-64.49,84.65-59.45c3.03,0.86,13.07,12.5,13.07,12.5s-18.64,10.34-35.93,24.76 C67.27,64.69,49.67,90.76,39.13,119.05z M169.88,175.62c0.27-0.11,0.46-0.42,0.43-0.73c-0.04-0.38-0.38-0.65-0.75-0.61 c0,0-19.51,2.89-37.95-3.86c2.01-6.53,7.35-4.17,15.42-3.52c14.55,0.87,27.58-1.26,37.22-4.02c8.35-2.4,19.31-7.12,27.83-13.84 c2.87,6.31,3.89,13.25,3.89,13.25s2.22-0.4,4.08,0.75c1.76,1.08,3.04,3.33,2.16,9.13c-1.79,10.85-6.4,19.66-14.15,27.76 c-4.72,5.08-10.45,9.5-17,12.71c-3.48,1.83-7.19,3.41-11.1,4.69c-29.22,9.54-59.13-0.95-68.77-23.48 c-0.77-1.69-1.42-3.47-1.93-5.32c-4.11-14.85-0.62-32.66,10.28-43.88c0,0,0,0,0-0.01c0.67-0.71,1.36-1.55,1.36-2.61 c0-0.89-0.56-1.82-1.05-2.48c-3.81-5.53-17.03-14.96-14.38-33.21c1.9-13.11,13.37-22.34,24.06-21.79 c0.9,0.05,1.81,0.1,2.71,0.16c4.63,0.27,8.67,0.87,12.49,1.03c6.38,0.28,12.12-0.65,18.92-6.32c2.29-1.91,4.13-3.57,7.24-4.09 c0.33-0.06,1.14-0.35,2.77-0.27c1.66,0.09,3.24,0.54,4.66,1.49c5.45,3.63,6.22,12.41,6.5,18.83c0.16,3.67,0.6,12.54,0.76,15.09 c0.35,5.82,1.88,6.65,4.97,7.67c1.74,0.57,3.36,1,5.74,1.67c7.21,2.03,11.49,4.08,14.19,6.72c1.61,1.65,2.36,3.4,2.59,5.07 c0.85,6.2-4.82,13.87-19.82,20.83c-16.4,7.61-36.3,9.54-50.05,8.01c-1.05-0.12-4.8-0.54-4.82-0.54 c-11-1.48-17.27,12.73-10.67,22.47c4.25,6.28,15.84,10.36,27.43,10.36c26.58,0,47.01-11.35,54.61-21.15 c0.23-0.29,0.25-0.33,0.61-0.87c0.37-0.56,0.07-0.87-0.4-0.56c-6.21,4.25-33.79,21.11-63.28,16.04c0,0-3.58-0.59-6.86-1.86 c-2.6-1.01-8.04-3.51-8.7-9.1C154.89,182.58,169.88,175.62,169.88,175.62z M132.17,171.17 C132.17,171.17,132.18,171.17,132.17,171.17c0.01,0.01,0.01,0.01,0.01,0.02C132.18,171.18,132.18,171.17,132.17,171.17z M86.63,68.79c9.14-10.57,20.4-19.75,30.48-24.91c0.35-0.18,0.72,0.2,0.53,0.54c-0.8,1.45-2.34,4.55-2.83,6.91 c-0.08,0.37,0.32,0.64,0.63,0.43c6.27-4.28,17.19-8.86,26.76-9.45c0.41-0.03,0.61,0.5,0.28,0.75c-1.46,1.12-3.05,2.66-4.21,4.22 c-0.2,0.27-0.01,0.65,0.32,0.65c6.72,0.05,16.2,2.4,22.37,5.86c0.42,0.23,0.12,1.04-0.35,0.94c-9.34-2.14-24.64-3.77-40.53,0.11 c-14.18,3.46-25.01,8.8-32.91,14.55C86.79,69.69,86.31,69.17,86.63,68.79z' />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function ZendeskIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='0 -30.5 256 256'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M118.25,51.23 L118.25,194.01 L0,194.01 L118.25,51.23 Z M118.25,0 C118.25,32.64 91.77,59.12 59.12,59.12 C26.48,59.12 0,32.64 0,0 L118.25,0 Z M137.75,194.01 C137.75,161.33 164.2,134.88 196.88,134.88 C229.55,134.88 256,161.36 256,194.01 L137.75,194.01 Z M137.75,142.74 L137.75,0 L256,0 L137.75,142.74 Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function ZoomIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
      <rect x='2' y='6' width='14' height='12' rx='2.5' fill='currentColor' />
      <path d='M16 9 L22 6 V18 L16 15 Z' fill='currentColor' />
    </svg>
  )
}

export function ZoomInfoIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `zoominfo-clip_${id}`
  return (
    <svg
      {...props}
      viewBox='8.03 8.03 48.485 48.485'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M0.27 8.27C0.27 3.85 3.85 0.27 8.27 0.27H56.27C60.69 0.27 64.27 3.85 64.27 8.27V56.27C64.27 60.69 60.69 64.27 56.27 64.27H8.27C3.85 64.27 0.27 60.69 0.27 56.27V8.27Z'
          fill='#EA1B15'
        />
        <path
          d='M44.27 16.27H47.71C48.02 16.27 48.27 16.52 48.27 16.84V25.7C48.27 26.01 48.03 26.26 47.72 26.27H44.84C44.52 26.27 44.27 26.02 44.27 25.71V23.12L22.04 44.27H27.71C28.02 44.27 28.27 44.52 28.27 44.84V47.71C28.27 48.02 28.02 48.27 27.71 48.27H16.84C16.52 48.27 16.27 48.02 16.27 47.71V44.27L41.48 20.27H38.84C38.52 20.27 38.27 20.02 38.27 19.71V16.85C38.27 16.53 38.52 16.28 38.84 16.28L44.27 16.27ZM24.27 20.27L33.71 20.26C34.02 20.26 34.27 20.01 34.27 19.7V16.84C34.27 16.52 34.02 16.27 33.72 16.27H16.86C16.54 16.27 16.29 16.52 16.29 16.84V25.71C16.29 26.02 16.54 26.27 16.86 26.27H19.72C20.03 26.27 20.27 26.02 20.27 25.71V20.27H24.27ZM44.27 44.27H32.84C32.52 44.27 32.27 44.52 32.27 44.84V47.71C32.27 48.02 32.52 48.27 32.84 48.27H47.71C48.02 48.27 48.27 48.02 48.27 47.71V38.79C48.27 38.48 48.02 38.23 47.71 38.23H44.84C44.52 38.23 44.27 38.48 44.27 38.79V44.27Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='64' height='64' fill='white' transform='translate(0.27 0.27)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SendgridIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='800px'
      height='800px'
      viewBox='0 0 256 256'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          d='M256,0 L256,170.67 L170.67,170.67 L170.67,256 L0,256 L0,170.67 L0,170.67 L0,85.33 L85.33,85.33 L85.33,0 L256,0 Z'
          fill='#9DD6E3'
        />
        <polygon fill='#3F72AB' points='0 256 85.34 256 85.34 170.66 0 170.66' />
        <polygon fill='#00A9D1' points='170.67 170.67 256 170.67 256 85.33 170.67 85.33' />
        <polygon fill='#00A9D1' points='85.33 85.33 170.67 85.33 170.67 0 85.33 0' />
        <polygon fill='#2191C4' points='85.33 170.66 170.67 170.66 170.67 85.33 85.33 85.33' />
        <polygon fill='#3F72AB' points='170.67 85.33 256 85.33 256 0 170.67 0' />
      </g>
    </svg>
  )
}

export function MailgunIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      version='1.1'
      viewBox='0 0 1000 1000'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      xmlSpace='preserve'
    >
      <path
        fill='currentColor'
        d='M493,305.7c-88.9,0-161,72.1-161,161c0,88.9,72.1,161,161,161c88.9,0,161-72.1,161-161 C654,377.8,582,305.7,493,305.7z M242,466.7c0-138.7,112.4-251,251-251c138.7,0,251.1,112.4,251.1,251c0,9.2-0.5,18.2-1.4,27.1 c-1.9,24.5,16.1,43.2,40.4,43.2c41.3,0,45.7-53.2,45.7-70.3c0-185.4-150.3-335.6-335.6-335.6S157.4,281.4,157.4,466.7 c0,185.4,150.3,335.6,335.6,335.6c98.4,0,187-42.4,248.4-109.9l69,57.9c-77.9,87.1-191.3,142-317.4,142 c-235.1,0-425.7-190.6-425.7-425.7S257.9,41,493,41c235.1,0,425.7,190.6,425.7,425.7c0,94.5-45,171.2-135.4,171.2 c-39.8,0-64-18.2-77.2-38.6C661.9,670.5,583,717.8,493,717.8C354.4,717.8,242,605.4,242,466.7z M493,393.1c40.7,0,73.7,33,73.7,73.7 c0,40.7-33,73.7-73.7,73.7c-40.7,0-73.7-33-73.7-73.7S452.3,393.1,493,393.1z'
      />
    </svg>
  )
}

export function SmtpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='30'
      height='24'
      viewBox='0 0 30 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.36 5.83L11.77 12.11C13.07 12.97 13.71 13.4 14.42 13.57C15.04 13.72 15.68 13.72 16.3 13.57C17 13.4 17.65 12.97 18.95 12.11L28.36 5.83M8.83 21.72H21.89C24.15 21.72 25.28 21.72 26.15 21.28C26.91 20.89 27.53 20.27 27.92 19.51C28.36 18.65 28.36 17.52 28.36 15.25V7.97C28.36 5.71 28.36 4.57 27.92 3.71C27.53 2.95 26.91 2.33 26.15 1.94C25.28 1.5 24.15 1.5 21.89 1.5H8.83C6.56 1.5 5.43 1.5 4.57 1.94C3.81 2.33 3.19 2.95 2.8 3.71C2.36 4.57 2.36 5.71 2.36 7.97V15.25C2.36 17.52 2.36 18.65 2.8 19.51C3.19 20.27 3.8 20.89 4.57 21.28C5.43 21.72 6.56 21.72 8.83 21.72Z'
        stroke='currentColor'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function PiIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 800' fill='currentColor'>
      <path
        fillRule='evenodd'
        d='M165.29 165.29 H517.36 V400 H400 V517.36 H282.65 V634.72 H165.29 Z M282.65 282.65 V400 H400 V282.65 Z'
      />
      <path d='M517.36 400 H634.72 V634.72 H517.36 Z' />
    </svg>
  )
}

export function SshIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect x='2' y='4' width='20' height='16' rx='2' />
      <path d='M6 8h.01' />
      <path d='M10 8h.01' />
      <path d='M14 8h8' />
      <path d='M6 12l3 3-3 3' />
      <path d='M12 18h6' />
    </svg>
  )
}

export function SshTerminalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='14'
      viewBox='0 0 16 14'
      fill='none'
    >
      <path
        d='M3 0C1.34 0 0 1.34 0 3V11C0 12.66 1.34 14 3 14H13C14.66 14 16 12.66 16 11V3C16 1.34 14.66 0 13 0H3ZM1 3C1 1.9 1.9 1 3 1H13C14.1 1 15 1.9 15 3V4H1V3ZM1 5H15V11C15 12.1 14.1 13 13 13H3C1.9 13 1 12.1 1 11V5Z'
        fill='currentColor'
      />
      <circle cx='3.5' cy='2.5' r='0.75' fill='currentColor' />
      <circle cx='5.75' cy='2.5' r='0.75' fill='currentColor' />
      <circle cx='8' cy='2.5' r='0.75' fill='currentColor' />
    </svg>
  )
}

export function SftpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 32 32'
      width='32px'
      height='32px'
    >
      <path
        d='M 6 3 L 6 29 L 26 29 L 26 9.59 L 25.72 9.28 L 19.72 3.28 L 19.41 3 Z M 8 5 L 18 5 L 18 11 L 24 11 L 24 27 L 8 27 Z M 20 6.44 L 22.56 9 L 20 9 Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ApifyIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `apify_clip_${id}`

  return (
    <svg
      {...props}
      width='200'
      height='200'
      viewBox='0 0 200 200'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M114.7 0H196.97C198.64 0 200 1.36 200 3.03V128.77C200 131.78 196.08 132.95 194.43 130.43L112.16 4.69C110.84 2.67 112.29 0 114.7 0Z'
          fill='#246DFF'
        />
        <path
          d='M85.3 0H3.03C1.36 0 0 1.36 0 3.03V128.77C0 131.78 3.92 132.95 5.57 130.43L87.84 4.69C89.16 2.67 87.71 0 85.3 0Z'
          fill='#20A34E'
        />
        <path
          d='M98.59 100.67L5.13 194.84C3.23 196.75 4.58 200 7.28 200H192.8C195.48 200 196.84 196.77 194.97 194.85L102.91 100.69C101.73 99.47 99.78 99.47 98.59 100.67Z'
          fill='#F86606'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='200' height='200' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function RDSIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70 70'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_Amazon-RDS_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.25) translate(-40, -40)'
      >
        <path
          d='M15.41,14 L24.71,23.29 L23.29,24.71 L14,15.41 L14,23 L12,23 L12,13 C12,12.45 12.45,12 13,12 L23,12 L23,14 L15.41,14 Z M68,13 L68,23 L66,23 L66,15.41 L56.71,24.71 L55.29,23.29 L64.59,14 L57,14 L57,12 L67,12 C67.55,12 68,12.45 68,13 L68,13 Z M66,57 L68,57 L68,67 C68,67.55 67.55,68 67,68 L57,68 L57,66 L64.59,66 L55.29,56.71 L56.71,55.29 L66,64.59 L66,57 Z M65.5,39.21 C65.5,35.89 61.67,32.62 55.25,30.44 L55.89,28.55 C63.27,31.05 67.5,34.93 67.5,39.21 C67.5,43.5 63.27,47.38 55.89,49.88 L55.25,47.98 C61.67,45.81 65.5,42.53 65.5,39.21 L65.5,39.21 Z M14.56,39.21 C14.56,42.39 18.14,45.59 24.15,47.75 L23.47,49.63 C16.54,47.13 12.56,43.33 12.56,39.21 C12.56,35.09 16.54,31.3 23.47,28.79 L24.15,30.67 C18.14,32.84 14.56,36.03 14.56,39.21 L14.56,39.21 Z M24.71,56.71 L15.41,66 L23,66 L23,68 L13,68 C12.45,68 12,67.55 12,67 L12,57 L14,57 L14,64.59 L23.29,55.29 L24.71,56.71 Z M40,31.29 C32.85,31.29 29,29.44 29,28.69 C29,27.93 32.85,26.09 40,26.09 C47.15,26.09 51,27.93 51,28.69 C51,29.44 47.15,31.29 40,31.29 L40,31.29 Z M40.03,39.03 C33.19,39.03 29,37.16 29,36.15 L29,31.28 C31.46,32.64 35.83,33.29 40,33.29 C44.17,33.29 48.54,32.64 51,31.28 L51,36.15 C51,37.16 46.84,39.03 40.03,39.03 L40.03,39.03 Z M40.03,46.67 C33.19,46.67 29,44.8 29,43.78 L29,38.86 C31.43,40.29 35.74,41.03 40.03,41.03 C44.29,41.03 48.58,40.29 51,38.87 L51,43.78 C51,44.8 46.84,46.67 40.03,46.67 L40.03,46.67 Z M40,53.52 C32.88,53.52 29,51.61 29,50.62 L29,46.5 C31.43,47.93 35.74,48.67 40.03,48.67 C44.29,48.67 48.58,47.93 51,46.5 L51,50.62 C51,51.61 47.12,53.52 40,53.52 L40,53.52 Z M40,24.09 C33.74,24.09 27,25.53 27,28.69 L27,50.62 C27,53.84 33.54,55.52 40,55.52 C46.46,55.52 53,53.84 53,50.62 L53,28.69 C53,25.53 46.26,24.09 40,24.09 L40,24.09 Z'
          id='Amazon-RDS_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function DynatraceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 89 90' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#1496FF'
        d='M29.97,7.52 C28.81,13.62 27.4,22.67 26.63,31.84 C25.28,48.01 26.12,58.85 26.12,58.85 L3.34,80.47 C3.34,80.47 1.61,68.35 0.71,54.68 C0.2,46.21 0.01,38.77 0.01,34.28 C0.01,34.02 0.13,33.76 0.13,33.51 C0.13,33.19 0.52,30.17 3.47,27.35 C6.68,24.27 30.35,5.73 29.97,7.52 Z'
      />
      <path
        fill='#1284EA'
        d='M29.97,7.52 C28.81,13.62 27.4,22.67 26.63,31.84 C26.63,31.84 1.42,28.82 0.01,34.92 C0.01,34.6 0.45,30.88 3.41,28.05 C6.61,24.98 30.35,5.73 29.97,7.52 L29.97,7.52 Z'
      />
      <path
        fill='#B4DC00'
        d='M0.01,33.44 L0.01,34.86 C0.26,33.76 0.71,32.99 1.61,31.78 C3.47,29.4 6.49,28.76 7.7,28.63 C13.86,27.8 22.97,26.84 32.15,26.58 C48.38,26.07 59.09,27.41 59.09,27.41 L81.87,5.79 C81.87,5.79 69.94,3.55 56.34,1.94 C47.42,0.85 39.59,0.27 35.16,0.02 C34.84,0.02 31.7,-0.37 28.75,2.46 C25.54,5.54 9.24,21 2.7,27.22 C-0.25,30.04 0.01,33.19 0.01,33.44 Z'
      />
      <path
        fill='#6F2DA8'
        d='M81.04,61.1 C74.88,61.93 65.77,62.96 56.59,63.28 C40.36,63.79 29.58,62.44 29.58,62.44 L6.81,84.13 C6.81,84.13 18.87,86.5 32.47,88.04 C40.81,89 48.19,89.52 52.68,89.77 C53,89.77 53.51,89.52 53.83,89.52 C54.15,89.52 57.3,88.94 60.25,86.12 C63.46,83.04 82.83,60.9 81.04,61.1 L81.04,61.1 Z'
      />
      <path
        fill='#591F91'
        d='M81.04,61.1 C74.88,61.93 65.77,62.96 56.59,63.28 C56.59,63.28 58.32,88.62 52.23,89.71 C52.55,89.71 56.72,89.52 59.67,86.69 C62.88,83.62 82.83,60.9 81.04,61.1 L81.04,61.1 Z'
      />
      <path
        fill='#73BE28'
        d='M53.58,89.84 C53.13,89.84 52.68,89.77 52.17,89.77 C53.32,89.58 54.09,89.2 55.31,88.3 C57.75,86.57 58.52,83.55 58.77,82.33 C59.86,76.24 61.34,67.19 62.05,58.02 C63.33,41.85 62.56,31.07 62.56,31.07 L85.34,9.38 C85.34,9.38 87,21.45 87.97,35.11 C88.54,44.03 88.74,51.92 88.8,56.28 C88.8,56.6 89.06,59.75 86.11,62.57 C82.9,65.65 66.6,81.18 60.12,87.4 C57.04,90.22 53.9,89.84 53.58,89.84 L53.58,89.84 Z'
      />
    </svg>
  )
}

export function DynamoDBIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5.001 5 70 70'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_Amazon-DynamoDB_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.25) translate(-40, -40)'
      >
        <path
          d='M52.09,54.85 C48.75,57.55 41.74,58.98 35.04,58.98 C28.34,58.98 21.34,57.55 18,54.85 L18,60.28 L18,60.28 C18,63 25,66.02 35.04,66.02 C45.08,66.02 52.07,63 52.09,60.29 L52.09,54.85 Z M52.09,44.52 L54.09,44.51 L54.09,44.52 C54.09,45.73 53.48,46.86 52.3,47.89 C53.73,49.15 54.09,50.38 54.09,51.26 C54.09,51.26 54.09,51.27 54.09,51.27 L54.09,60.28 L54.09,60.28 C54.09,65.3 44.27,68 35.04,68 C25.83,68 16.05,65.31 16,60.32 C16,60.31 16,60.31 16,60.3 L16,51.25 C16,51.25 16,51.25 16,51.25 C16.01,50.37 16.36,49.14 17.79,47.89 C16.37,46.64 16.01,45.41 16,44.54 L16,44.54 C16,44.54 16,44.54 16,44.53 L16,35.48 C16,35.48 16,35.48 16,35.47 C16.01,34.6 16.36,33.37 17.79,32.12 C16.37,30.86 16.01,29.64 16,28.77 L16,28.77 C16,28.77 16,28.76 16,28.76 L16,19.71 C16,19.71 16,19.71 16,19.7 C16.02,14.7 25.82,12 35.04,12 C40.25,12 45.26,12.83 48.78,14.27 L48.01,16.11 C44.73,14.76 40,13.98 35.04,13.98 C25,13.98 18,17 18,19.72 C18,22.43 25,25.45 35.04,25.45 C35.31,25.45 35.58,25.45 35.85,25.44 L35.93,27.42 C35.64,27.43 35.34,27.43 35.04,27.43 C28.34,27.43 21.34,26.01 18,23.31 L18,28.74 L18,28.74 L18,28.76 C18.01,29.8 19.08,30.71 19.97,31.29 C22.66,33 27.48,34.18 32.86,34.42 L32.77,36.4 C27.32,36.15 22.55,35.02 19.48,33.29 C18.73,33.86 18,34.62 18,35.49 C18,38.2 25,41.22 35.04,41.22 C36.03,41.22 37.01,41.19 37.95,41.12 L38.09,43.1 C37.1,43.17 36.07,43.21 35.04,43.21 C28.34,43.21 21.34,41.78 18,39.08 L18,44.51 L18,44.51 C18.01,45.57 19.08,46.48 19.97,47.06 C23.05,49.02 28.82,50.25 35.04,50.25 L35.48,50.25 L35.48,52.23 L35.04,52.23 C28.72,52.23 22.98,51.06 19.47,49.07 C18.72,49.64 18,50.4 18,51.26 C18,53.97 25,56.99 35.04,56.99 C45.08,56.99 52.07,53.97 52.09,51.26 L52.09,51.25 L52.09,51.25 C52.08,50.39 51.36,49.63 50.61,49.07 C50.12,49.34 49.6,49.61 49,49.86 L48.24,48.02 C48.96,47.72 49.59,47.4 50.11,47.06 C51.01,46.47 52.09,45.55 52.09,44.52 L52.09,44.52 Z M60.65,30.02 L55.05,30.02 C54.72,30.02 54.41,29.85 54.22,29.58 C54.03,29.31 54,28.96 54.12,28.66 L57.53,20.14 L44.62,20.14 L38.62,32.04 L45,32.04 C45.32,32.04 45.62,32.19 45.81,32.45 C46,32.7 46.05,33.03 45.95,33.33 L40.26,51.09 L60.65,30.02 Z M63.72,29.71 L38.72,55.54 C38.53,55.74 38.27,55.84 38,55.84 C37.82,55.84 37.65,55.8 37.49,55.71 C37.09,55.47 36.91,54.99 37.05,54.55 L43.63,34.02 L37,34.02 C36.65,34.02 36.33,33.85 36.15,33.55 C35.97,33.26 35.95,32.9 36.11,32.59 L43.11,18.7 C43.28,18.37 43.62,18.15 44,18.15 L59,18.15 C59.33,18.15 59.64,18.32 59.83,18.59 C60.01,18.86 60.05,19.21 59.93,19.51 L56.52,28.03 L63,28.03 C63.4,28.03 63.76,28.27 63.92,28.64 C64.08,29 64,29.43 63.72,29.71 L63.72,29.71 Z M19.45,60.67 C20.87,61.47 22.66,62.14 24.76,62.67 L25.24,60.74 C23.35,60.27 21.69,59.65 20.44,58.95 L19.45,60.67 Z M24.76,46.8 L25.24,44.88 C23.35,44.4 21.69,43.78 20.44,43.08 L19.45,44.8 C20.87,45.6 22.65,46.27 24.76,46.8 L24.76,46.8 Z M19.45,28.94 L20.44,27.21 C21.68,27.91 23.34,28.53 25.24,29.01 L24.76,30.93 C22.65,30.4 20.87,29.73 19.45,28.94 L19.45,28.94 Z'
          id='Amazon-DynamoDB_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function IAMIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='5 5 70 70' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id={id}>
          <stop stopColor='#BD0816' offset='0%' />
          <stop stopColor='#FF5252' offset='100%' />
        </linearGradient>
      </defs>
      <rect fill={`url(#${id})`} width='80' height='80' />
      <path
        d='M14,59 L66,59 L66,21 L14,21 L14,59 Z M68,20 L68,60 C68,60.55 67.55,61 67,61 L13,61 C12.45,61 12,60.55 12,60 L12,20 C12,19.45 12.45,19 13,19 L67,19 C67.55,19 68,19.45 68,20 L68,20 Z M44,48 L59,48 L59,46 L44,46 L44,48 Z M57,42 L62,42 L62,40 L57,40 L57,42 Z M44,42 L52,42 L52,40 L44,40 L44,42 Z M29,46 C29,45.45 28.55,45 28,45 C27.45,45 27,45.45 27,46 C27,46.55 27.45,47 28,47 C28.55,47 29,46.55 29,46 L29,46 Z M31,46 C31,47.3 30.16,48.4 29,48.82 L29,51 L27,51 L27,48.82 C25.84,48.4 25,47.3 25,46 C25,44.35 26.35,43 28,43 C29.65,43 31,44.35 31,46 L31,46 Z M19,53.99 L36.99,54 L37,50 L33,50 L33,48 L37,48 L37,45 L33,45 L33,43 L37,43 L37,40.01 L19.01,40 L19,53.99 Z M22,38 L34,38.01 L34,31 C34,28.7 31.2,26.68 28,26.68 L28,26.68 C24.8,26.68 22,28.7 22,31 L22,38 Z M17,54.99 L17.01,39 C17.01,38.73 17.11,38.48 17.3,38.29 C17.49,38.1 17.74,38 18.01,38 L20,38 L20,31 C20,27.51 23.59,24.68 28,24.68 L28,24.68 C32.41,24.68 36,27.52 36,31 L36,38.01 L38,38.01 C38.55,38.01 39,38.46 39,39.01 L38.99,55 C38.99,55.27 38.89,55.52 38.7,55.71 C38.51,55.9 38.26,56 37.99,56 L18,55.99 C17.45,55.99 17,55.54 17,54.99 L17,54.99 Z M60,36 L62,36 L62,34 L60,34 L60,36 Z M44,36 L55,36 L55,34 L44,34 L44,36 Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

export function IdentityCenterIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='23.75 23.75 32.5 32.5' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id={id}>
          <stop stopColor='#BD0816' offset='0%' />
          <stop stopColor='#FF5252' offset='100%' />
        </linearGradient>
      </defs>
      <rect fill={`url(#${id})`} width='80' height='80' />
      <path
        d='M46.69,46.82 C47.38,46.14 47.38,45.03 46.69,44.35 C46.35,44.01 45.91,43.84 45.46,43.84 C45.01,43.84 44.56,44.01 44.22,44.35 C43.54,45.03 43.54,46.14 44.22,46.82 C44.91,47.5 46.01,47.5 46.69,46.82 M47.72,47.14 L51.7,51.12 L51,51.83 L49.87,50.7 L48.79,51.78 L48.09,51.07 L49.16,49.99 L47.01,47.84 C46.55,48.17 46,48.33 45.46,48.33 C44.76,48.33 44.05,48.06 43.52,47.53 C42.45,46.46 42.45,44.71 43.52,43.64 C44.59,42.57 46.33,42.57 47.4,43.64 C48.35,44.59 48.46,46.07 47.72,47.14 M53,44.1 C53,46.17 51.51,47.09 50.02,47.09 L50.02,46.09 C50.49,46.09 52,45.95 52,44.1 C52,43 51.35,42.39 49.91,42.11 C49.68,42.07 49.51,41.88 49.5,41.65 C49.45,40.74 48.99,40.11 48.38,40.11 C48.08,40.11 47.85,40.24 47.62,40.55 C47.51,40.69 47.32,40.76 47.15,40.73 C46.97,40.71 46.82,40.58 46.76,40.41 C46.58,39.94 46.21,39.43 45.72,38.98 C45.23,38.51 43.88,37.51 41.97,38.27 C40.89,38.71 40.03,39.95 40.03,41.11 C40.03,41.24 40.04,41.36 40.06,41.49 C40.06,41.51 40.06,41.53 40.06,41.55 C40.06,41.8 39.88,42.01 39.65,42.05 C38.89,42.24 38,42.75 38,44.06 L38.01,44.21 C38.07,45.33 39.25,46 40.36,46 L41,46 L41,47 L40.36,47 C38.54,46.99 37.1,45.82 37.01,44.26 C37,44.19 37,44.12 37,44.06 C37,42.69 37.75,41.65 39.03,41.19 C39.03,41.16 39.03,41.13 39.03,41.11 C39.03,39.54 40.14,37.93 41.6,37.34 C43.3,36.67 45.1,37 46.41,38.25 C46.71,38.53 47.08,38.93 47.37,39.41 C47.67,39.21 48.01,39.11 48.38,39.11 C49.26,39.11 50.23,39.77 50.46,41.21 C52.15,41.63 53,42.61 53,44.1 M27,53 L27,27 L53,27 L53,34 L51,34 L51,29 L29,29 L29,51 L51,51 L51,46 L53,46 L53,53 Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

export function STSIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='5 5 70 70' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id={id}>
          <stop stopColor='#BD0816' offset='0%' />
          <stop stopColor='#FF5252' offset='100%' />
        </linearGradient>
      </defs>
      <rect fill={`url(#${id})`} width='80' height='80' />
      <path
        d='M14,59 L66,59 L66,21 L14,21 L14,59 Z M68,20 L68,60 C68,60.55 67.55,61 67,61 L13,61 C12.45,61 12,60.55 12,60 L12,20 C12,19.45 12.45,19 13,19 L67,19 C67.55,19 68,19.45 68,20 L68,20 Z M44,48 L59,48 L59,46 L44,46 L44,48 Z M57,42 L62,42 L62,40 L57,40 L57,42 Z M44,42 L52,42 L52,40 L44,40 L44,42 Z M29,46 C29,45.45 28.55,45 28,45 C27.45,45 27,45.45 27,46 C27,46.55 27.45,47 28,47 C28.55,47 29,46.55 29,46 L29,46 Z M31,46 C31,47.3 30.16,48.4 29,48.82 L29,51 L27,51 L27,48.82 C25.84,48.4 25,47.3 25,46 C25,44.35 26.35,43 28,43 C29.65,43 31,44.35 31,46 L31,46 Z M19,53.99 L36.99,54 L37,50 L33,50 L33,48 L37,48 L37,45 L33,45 L33,43 L37,43 L37,40.01 L19.01,40 L19,53.99 Z M22,38 L34,38.01 L34,31 C34,28.7 31.2,26.68 28,26.68 L28,26.68 C24.8,26.68 22,28.7 22,31 L22,38 Z M17,54.99 L17.01,39 C17.01,38.73 17.11,38.48 17.3,38.29 C17.49,38.1 17.74,38 18.01,38 L20,38 L20,31 C20,27.51 23.59,24.68 28,24.68 L28,24.68 C32.41,24.68 36,27.52 36,31 L36,38.01 L38,38.01 C38.55,38.01 39,38.46 39,39.01 L38.99,55 C38.99,55.27 38.89,55.52 38.7,55.71 C38.51,55.9 38.26,56 37.99,56 L18,55.99 C17.45,55.99 17,55.54 17,54.99 L17,54.99 Z M60,36 L62,36 L62,34 L60,34 L60,36 Z M44,36 L55,36 L55,34 L44,34 L44,36 Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

export function SESIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='5 5 70 70' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id={id}>
          <stop stopColor='#BD0816' offset='0%' />
          <stop stopColor='#FF5252' offset='100%' />
        </linearGradient>
      </defs>
      <rect fill={`url(#${id})`} width='80' height='80' />
      <path
        d='M57,61 C57,59.37 55.63,58 54,58 C52.37,58 51,59.37 51,61 C51,62.63 52.37,64 54,64 C55.63,64 57,62.63 57,61 L57,61 Z M40,60 C38.37,60 37,61.37 37,63 C37,64.63 38.37,66 40,66 C41.63,66 43,64.63 43,63 C43,61.37 41.63,60 40,60 L40,60 Z M26,58 C24.37,58 23,59.37 23,61 C23,62.63 24.37,64 26,64 C27.63,64 29,62.63 29,61 C29,59.37 27.63,58 26,58 L26,58 Z M28.61,43 L51.4,43 L43.74,36.11 L40.65,38.76 C40.46,38.92 40.23,39 40,39 C39.77,39 39.53,38.92 39.35,38.76 L36.26,36.11 L28.61,43 Z M27,28.17 L27,41.75 L34.73,34.8 L27,28.17 Z M51.3,27 L28.7,27 L40,36.68 L51.3,27 Z M53,41.75 L53,28.17 L45.27,34.8 L53,41.75 Z M59,61 C59,63.71 56.71,66 54,66 C51.29,66 49,63.71 49,61 C49,58.63 50.75,56.58 53,56.11 L53,53 L41,53 L41,58.11 C43.25,58.58 45,60.63 45,63 C45,65.71 42.71,68 40,68 C37.29,68 35,65.71 35,63 C35,60.63 36.75,58.58 39,58.11 L39,53 L27,53 L27,56.11 C29.25,56.58 31,58.63 31,61 C31,63.71 28.71,66 26,66 C23.29,66 21,63.71 21,61 C21,58.63 22.75,56.58 25,56.11 L25,52 C25,51.45 25.45,51 26,51 L39,51 L39,45 L26,45 C25.45,45 25,44.55 25,44 L25,26 C25,25.45 25.45,25 26,25 L54,25 C54.55,25 55,25.45 55,26 L55,44 C55,44.55 54.55,45 54,45 L41,45 L41,51 L54,51 C54.55,51 55,51.45 55,52 L55,56.11 C57.25,56.58 59,58.63 59,61 L59,61 Z M68,40 C68,45.91 66.18,51.56 62.73,56.34 L61.1,55.17 C64.31,50.73 66,45.48 66,40 C66,25.66 54.34,14 40,14 C25.66,14 14,25.66 14,40 C14,45.48 15.69,50.73 18.9,55.17 L17.27,56.34 C13.82,51.56 12,45.91 12,40 C12,24.56 24.56,12 40,12 C55.44,12 68,24.56 68,40 L68,40 Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

export function SecretsManagerIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  return (
    <svg {...props} viewBox='5 5 70 70' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id={id}>
          <stop stopColor='#BD0816' offset='0%' />
          <stop stopColor='#FF5252' offset='100%' />
        </linearGradient>
      </defs>
      <rect fill={`url(#${id})`} width='80' height='80' />
      <path
        d='M38.76,43.36 C38.76,44.04 39.32,44.6 40,44.6 C40.68,44.6 41.24,44.04 41.24,43.36 C41.24,42.68 40.68,42.12 40,42.12 C39.32,42.12 38.76,42.68 38.76,43.36 L38.76,43.36 Z M36.76,43.36 C36.76,41.57 38.21,40.12 40,40.12 C41.79,40.12 43.24,41.57 43.24,43.36 C43.24,44.8 42.3,46 41,46.43 L41,49 L39,49 L39,46.43 C37.7,46 36.76,44.8 36.76,43.36 L36.76,43.36 Z M49,38 L31,38 L31,51 L49,51 L49,48 L46,48 L46,46 L49,46 L49,43 L46,43 L46,41 L49,41 L49,38 Z M34,36 L46,36 L46,31 C46,28.38 43.14,26 40,26 L40,26 C38.47,26 36.93,26.57 35.76,27.58 C34.64,28.54 34,29.79 34,31 L34,36 Z M48,31 L48,36 L50,36 C50.55,36 51,36.45 51,37 L51,52 C51,52.55 50.55,53 50,53 L30,53 C29.45,53 29,52.55 29,52 L29,37 C29,36.45 29.45,36 30,36 L32,36 L32,31 C32,29.2 32.9,27.4 34.46,26.06 C35.98,24.75 38,24 40,24 L40,24 C44.27,24 48,27.27 48,31 L48,31 Z M19.21,55.05 L20.83,53.88 C18.09,50.1 16.58,45.66 16.4,41 L19,41 L19,39 L16.4,39 C16.6,34.37 18.11,29.96 20.83,26.2 L19.21,25.03 C16.24,29.13 14.6,33.94 14.4,39 L12,39 L12,41 L14.4,41 C14.58,46.09 16.22,50.93 19.21,55.05 L19.21,55.05 Z M53.84,59.21 C50.07,61.94 45.65,63.45 41,63.64 L41,61 L39,61 L39,63.64 C34.35,63.45 29.93,61.94 26.16,59.21 L24.99,60.83 C29.1,63.81 33.93,65.44 39,65.64 L39,68 L41,68 L41,65.64 C46.07,65.44 50.9,63.81 55.01,60.83 L53.84,59.21 Z M26.16,20.87 C29.93,18.14 34.35,16.63 39,16.44 L39,19 L41,19 L41,16.44 C45.65,16.63 50.07,18.14 53.84,20.87 L55.01,19.25 C50.9,16.27 46.07,14.63 41,14.44 L41,12 L39,12 L39,14.44 C33.93,14.63 29.1,16.27 24.99,19.25 L26.16,20.87 Z M65.6,39 C65.4,33.94 63.76,29.13 60.79,25.03 L59.17,26.2 C61.89,29.96 63.4,34.37 63.6,39 L61,39 L61,41 L63.6,41 C63.42,45.66 61.91,50.1 59.17,53.88 L60.79,55.05 C63.77,50.93 65.42,46.09 65.6,41 L68,41 L68,39 L65.6,39 Z M56.39,25.06 L64.23,17.22 L62.81,15.81 L54.97,23.65 L56.39,25.06 Z M23.61,55.01 L15.77,62.85 L17.19,64.26 L25.03,56.42 L23.61,55.01 Z M28.67,27.25 L13.83,12.41 L12.41,13.83 L27.25,28.67 L28.67,27.25 Z M54.19,52.78 L67.59,66.17 L66.17,67.59 L52.78,54.19 L54.19,52.78 Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

export function SSMIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70 70'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_AWS-Systems-Manager_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M47,54.998 L60,54.998 L60,56.998 L47,56.998 L47,58.999 L45,58.999 L45,56.998 L41,56.998 L41,54.998 L45,54.998 L45,53.998 L47,53.998 L47,54.998 Z M51,48.997 L60,48.997 L60,50.997 L51,50.997 L51,52.998 L49,52.998 L49,50.997 L41,50.997 L41,48.997 L49,48.997 L49,47.997 L51,47.997 L51,48.997 Z M56,42.996 L60,42.996 L60,44.997 L56,44.997 L56,46.997 L54,46.997 L54,44.997 L41,44.997 L41,42.996 L54,42.996 L54,41.996 L56,41.996 L56,42.996 Z M21,46.997 L30,46.997 L30,48.997 L21,48.997 C19.745,48.997 18.404,48.62 17.413,47.989 C15.393,46.71 12,43.715 12,38.042 C12,31.161 16.665,28.635 19.38,27.75 L19.326,26.834 C19.324,21.166 23.074,15.354 28.046,13.257 C33.869,10.781 40.036,12.008 44.545,16.537 C45.944,17.939 47.096,19.648 47.978,21.631 C49.749,20.156 52.16,19.651 54.4,20.386 C57.247,21.32 59.019,23.951 59.227,27.494 C62.065,28.173 68,30.508 68,38.132 C68,38.417 67.989,38.692 67.978,38.955 L65.979,38.902 C65.989,38.635 66,38.389 66,38.132 C66,31.398 60.443,29.706 58.054,29.292 C57.784,29.245 57.546,29.091 57.394,28.864 C57.243,28.639 57.19,28.363 57.246,28.098 C57.217,25.117 55.956,23.001 53.776,22.286 C51.823,21.643 49.677,22.352 48.434,24.044 C48.214,24.341 47.853,24.497 47.482,24.44 C47.116,24.387 46.81,24.135 46.686,23.786 C45.853,21.443 44.656,19.48 43.129,17.951 C39.216,14.019 33.867,12.955 28.826,15.099 C24.618,16.873 21.324,22.002 21.324,26.775 L21.423,28.429 C21.451,28.907 21.136,29.338 20.671,29.456 C18.18,30.09 14,32.049 14,38.042 C14,42.521 16.438,45.005 18.485,46.3 C19.16,46.731 20.123,46.997 21,46.997 L21,46.997 Z M66,52.318 L64.236,52.217 C63.763,52.192 63.312,52.518 63.204,52.996 C62.866,54.494 62.278,55.914 61.456,57.216 C61.195,57.63 61.271,58.172 61.637,58.498 L62.954,59.672 L59.673,62.954 L58.502,61.641 C58.176,61.274 57.633,61.2 57.222,61.461 C55.92,62.283 54.499,62.872 52.997,63.211 C52.521,63.319 52.191,63.756 52.22,64.244 L52.32,66 L47.68,66 L47.78,64.242 C47.809,63.754 47.479,63.317 47.003,63.209 C45.505,62.871 44.084,62.281 42.78,61.458 C42.367,61.196 41.825,61.271 41.5,61.638 L40.326,62.953 L37.046,59.672 L38.361,58.5 C38.726,58.174 38.802,57.632 38.541,57.219 C37.72,55.917 37.132,54.497 36.794,52.996 C36.687,52.518 36.209,52.192 35.762,52.217 L34,52.318 L34,47.677 L35.768,47.778 C36.233,47.804 36.691,47.477 36.8,47 C37.139,45.505 37.728,44.086 38.55,42.785 C38.811,42.371 38.734,41.829 38.37,41.504 L37.046,40.323 L40.327,37.041 L41.508,38.365 C41.834,38.729 42.376,38.804 42.787,38.544 C44.087,37.724 45.505,37.137 47.003,36.799 C47.479,36.691 47.809,36.254 47.78,35.766 L47.68,33.995 L52.32,33.995 L52.22,35.768 C52.191,36.256 52.521,36.692 52.997,36.8 C54.492,37.139 55.909,37.726 57.211,38.547 C57.622,38.808 58.165,38.732 58.49,38.368 L59.673,37.041 L62.954,40.323 L61.633,41.501 C61.269,41.827 61.192,42.368 61.453,42.782 C62.275,44.083 62.864,45.503 63.202,47 C63.31,47.476 63.763,47.804 64.234,47.778 L66,47.677 L66,52.318 Z M66.943,45.62 L64.942,45.734 C64.617,44.589 64.16,43.487 63.579,42.445 L65.076,41.11 C65.281,40.927 65.402,40.668 65.41,40.392 C65.418,40.118 65.312,39.851 65.117,39.657 L60.339,34.878 C60.145,34.683 59.868,34.571 59.604,34.586 C59.328,34.594 59.069,34.714 58.886,34.919 L57.546,36.421 C56.505,35.841 55.406,35.386 54.263,35.06 L54.377,33.052 C54.393,32.777 54.295,32.508 54.105,32.308 C53.917,32.108 53.654,31.995 53.379,31.995 L46.621,31.995 C46.346,31.995 46.083,32.108 45.895,32.308 C45.705,32.508 45.607,32.777 45.623,33.052 L45.737,35.058 C44.592,35.383 43.492,35.839 42.452,36.418 L41.114,34.919 C40.931,34.714 40.672,34.594 40.396,34.586 C40.113,34.573 39.855,34.683 39.661,34.878 L34.883,39.657 C34.688,39.851 34.582,40.118 34.59,40.392 C34.598,40.667 34.719,40.927 34.924,41.11 L36.424,42.448 C35.843,43.49 35.386,44.59 35.06,45.734 L33.057,45.62 C32.789,45.602 32.513,45.703 32.313,45.891 C32.113,46.08 32,46.343 32,46.618 L32,53.377 C32,53.652 32.113,53.915 32.313,54.104 C32.513,54.292 32.79,54.39 33.057,54.375 L35.053,54.261 C35.378,55.409 35.834,56.511 36.415,57.554 L34.924,58.884 C34.719,59.067 34.598,59.327 34.59,59.602 C34.582,59.877 34.688,60.144 34.883,60.338 L39.661,65.117 C39.855,65.312 40.138,65.419 40.396,65.41 C40.672,65.402 40.932,65.281 41.114,65.076 L42.444,63.583 C43.487,64.166 44.59,64.624 45.736,64.951 L45.623,66.943 C45.607,67.217 45.705,67.486 45.895,67.687 C46.083,67.887 46.346,68 46.621,68 L53.379,68 C53.654,68 53.917,67.887 54.106,67.687 C54.295,67.486 54.393,67.217 54.377,66.943 L54.264,64.953 C55.412,64.625 56.515,64.168 57.558,63.586 L58.886,65.076 C59.068,65.281 59.328,65.402 59.604,65.41 C59.871,65.422 60.145,65.312 60.339,65.117 L65.117,60.338 C65.312,60.144 65.418,59.877 65.41,59.602 C65.402,59.327 65.281,59.067 65.075,58.884 L63.582,57.552 C64.163,56.509 64.619,55.407 64.945,54.261 L66.943,54.375 C67.213,54.39 67.487,54.292 67.687,54.104 C67.887,53.915 68,53.652 68,53.377 L68,46.618 C68,46.343 67.887,46.08 67.687,45.891 C67.487,45.703 67.214,45.603 66.943,45.62 L66.943,45.62 Z'
          id='AWS-Systems-Manager_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function SQSIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='4.997 4.997 70.006 70.006'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_Amazon-Simple-Queue-Service_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.5) translate(-40, -40)'
      >
        <g id='Icon-Architecture-BG/64/Application-Integration' fill='currentColor'>
          <path
            d='M28.72,43.69 L31.72,40.72 C31.91,40.54 32.01,40.28 32.01,40.02 C32.02,39.76 31.91,39.5 31.72,39.32 L28.72,36.32 L27.3,37.72 L28.59,39.01 L24.01,39.01 L24.01,40.99 L28.61,40.99 L27.31,42.28 L28.72,43.69 Z M51.63,43.78 L55.63,40.79 C55.88,40.61 56.03,40.31 56.03,40 C56.03,39.69 55.88,39.39 55.63,39.2 L51.63,36.22 L50.43,37.81 L52.03,39.01 L48.02,39.01 L48.02,40.99 L52.03,40.99 L50.42,42.19 L51.63,43.78 Z M35.21,40 C35.21,42.11 34.84,44.1 34.16,45.83 C35.96,45.14 37.99,44.8 40.02,44.8 C42.05,44.8 44.08,45.14 45.88,45.83 C45.2,44.1 44.83,42.11 44.83,40 C44.83,37.89 45.2,35.9 45.88,34.17 C42.28,35.55 37.76,35.55 34.16,34.17 C34.84,35.9 35.21,37.89 35.21,40 L35.21,40 Z M30.31,49.65 C30.11,49.46 30.01,49.2 30.01,48.95 C30.01,48.69 30.11,48.44 30.31,48.25 C32.12,46.44 33.21,43.36 33.21,40 C33.21,36.64 32.12,33.56 30.31,31.75 C30.11,31.56 30.01,31.31 30.01,31.05 C30.01,30.8 30.11,30.54 30.31,30.35 C30.7,29.96 31.33,29.96 31.72,30.35 C35.6,34.2 44.44,34.2 48.32,30.35 C48.71,29.96 49.34,29.96 49.73,30.35 C49.93,30.54 50.03,30.8 50.03,31.05 C50.03,31.31 49.93,31.56 49.73,31.75 C47.92,33.56 46.83,36.64 46.83,40 C46.83,43.36 47.92,46.44 49.73,48.25 C49.93,48.44 50.03,48.69 50.03,48.95 C50.03,49.2 49.93,49.46 49.73,49.65 C49.54,49.85 49.28,49.94 49.03,49.94 C48.77,49.94 48.51,49.85 48.32,49.65 C44.44,45.8 35.6,45.8 31.72,49.65 C31.33,50.04 30.7,50.04 30.31,49.65 L30.31,49.65 Z M66,40 C66,39.08 65.64,38.21 64.98,37.55 C64.3,36.88 63.4,36.54 62.51,36.54 C61.62,36.54 60.72,36.88 60.04,37.55 C58.68,38.9 58.68,41.1 60.04,42.46 C61.4,43.81 63.62,43.81 64.98,42.46 C65.64,41.8 66,40.93 66,40 L66,40 Z M66.39,43.86 C65.32,44.93 63.92,45.46 62.51,45.46 C61.1,45.46 59.7,44.93 58.63,43.86 C56.48,41.74 56.48,38.27 58.63,36.15 C60.77,34.02 64.25,34.02 66.39,36.15 C68.54,38.27 68.54,41.74 66.39,43.86 L66.39,43.86 Z M20.98,40.03 C20.98,39.1 20.62,38.23 19.96,37.58 C19.3,36.92 18.42,36.56 17.49,36.56 C16.56,36.56 15.68,36.92 15.02,37.58 C14.36,38.23 14,39.1 14,40.03 C14,40.95 14.36,41.82 15.02,42.48 C16.34,43.79 18.64,43.79 19.96,42.48 C20.62,41.82 20.98,40.95 20.98,40.03 L20.98,40.03 Z M21.37,43.89 C20.3,44.95 18.9,45.48 17.49,45.48 C16.08,45.48 14.68,44.95 13.61,43.89 C11.46,41.76 11.46,38.3 13.61,36.17 C15.75,34.04 19.23,34.04 21.37,36.17 C23.51,38.3 23.51,41.76 21.37,43.89 L21.37,43.89 Z M54.9,54.86 C50.9,58.83 45.59,61.01 39.94,61.01 C34.29,61.01 28.98,58.83 24.98,54.86 C22.24,52.13 20.73,48.88 19.95,46.63 L18.06,47.28 C18.91,49.73 20.56,53.27 23.57,56.26 C27.94,60.61 33.75,63 39.94,63 C46.12,63 51.94,60.61 56.31,56.26 C58.84,53.75 60.85,50.56 61.98,47.28 L60.09,46.64 C59.05,49.64 57.21,52.56 54.9,54.86 L54.9,54.86 Z M19.95,33.37 L18.06,32.71 C19.27,29.25 21.23,26.06 23.57,23.73 C27.94,19.39 33.76,17 39.94,17 C46.12,17 51.93,19.39 56.3,23.73 C58.77,26.18 60.84,29.46 61.98,32.71 L60.09,33.37 C59.04,30.38 57.15,27.38 54.89,25.14 C50.9,21.17 45.59,18.99 39.94,18.99 C34.29,18.99 28.98,21.17 24.99,25.14 C22.85,27.26 21.07,30.18 19.95,33.37 L19.95,33.37 Z'
            id='AWS-Simple-Queue-Service_Icon_64_Squid'
            fill='currentColor'
          />
        </g>
      </g>
    </svg>
  )
}

export function CloudFormationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70 70'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_AWS-CloudFormation_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M53,39.96 L58,39.96 L58,37.96 L53,37.96 L53,39.96 Z M28,51.98 L33,51.98 L33,49.98 L28,49.98 L28,51.98 Z M18,51.98 L25,51.98 L25,49.98 L18,49.98 L18,51.98 Z M18,45.97 L30,45.97 L30,43.97 L18,43.97 L18,45.97 Z M18,33.95 L27,33.95 L27,31.95 L18,31.95 L18,33.95 Z M18,39.96 L51,39.96 L51,37.96 L18,37.96 L18,39.96 Z M37,62 L14,62 L14,27.94 L37,27.94 L37,35.96 L39,35.96 L39,26.94 C39,26.39 38.55,25.94 38,25.94 L13,25.94 C12.45,25.94 12,26.39 12,26.94 L12,63 C12,63.55 12.45,64 13,64 L38,64 C38.55,64 39,63.55 39,63 L39,42.97 L37,42.97 L37,62 Z M68,36.96 C68,43.43 62.17,45.68 59.09,45.97 L43,45.97 L43,43.97 L59,43.97 C59.2,43.95 66,43.21 66,36.96 C66,31.26 60.86,30.11 59.83,29.93 C59.32,29.85 58.96,29.38 59,28.86 C59.01,28.84 59.01,28.83 59.01,28.81 C58.95,25.59 56.98,24.58 56.13,24.3 C54.53,23.77 52.75,24.28 51.81,25.54 C51.59,25.84 51.23,25.99 50.86,25.93 C50.5,25.88 50.19,25.63 50.07,25.28 C49.45,23.54 48.55,22.41 47.29,21.15 C44.16,18.04 39.91,17.18 35.92,18.85 C33.84,19.73 32.01,21.73 30.92,24.33 L29.08,23.55 C30.37,20.47 32.58,18.09 35.15,17.01 C39.91,15 44.97,16.03 48.7,19.73 C49.77,20.81 50.66,21.85 51.35,23.2 C52.84,22.1 54.86,21.77 56.76,22.4 C59.19,23.21 60.73,25.32 60.98,28.13 C64.38,28.99 68,31.71 68,36.96 L68,36.96 Z'
          id='AWS-CloudFormation_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function LambdaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70 70'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_AWS-Lambda_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M28.008,66 L15.591,66 L29.324,37.296 L35.546,50.106 L28.008,66 Z M30.22,34.553 C30.051,34.208 29.7,33.989 29.318,33.989 L29.315,33.989 C28.929,33.99 28.578,34.211 28.412,34.558 L13.098,66.569 C12.95,66.879 12.971,67.243 13.155,67.534 C13.337,67.824 13.658,68 14.002,68 L28.642,68 C29.03,68 29.382,67.777 29.548,67.428 L37.564,50.528 C37.693,50.254 37.692,49.937 37.559,49.665 L30.22,34.553 Z M64.995,66 L52.659,66 L32.867,24.57 C32.701,24.222 32.349,24 31.962,24 L23.89,24 L23.899,14 L39.72,14 L59.42,55.429 C59.586,55.777 59.939,56 60.326,56 L64.995,56 L64.995,66 Z M65.998,54 L60.96,54 L41.259,12.571 C41.094,12.223 40.741,12 40.353,12 L22.898,12 C22.345,12 21.896,12.447 21.895,12.999 L21.884,24.999 C21.884,25.265 21.989,25.519 22.178,25.707 C22.365,25.895 22.62,26 22.887,26 L31.329,26 L51.122,67.43 C51.289,67.778 51.639,68 52.026,68 L65.998,68 C66.552,68 67,67.552 67,67 L67,55 C67,54.448 66.552,54 65.998,54 L65.998,54 Z'
          id='AWS-Lambda_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function AthenaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='3.625 3.625 73.75 73.75'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_Amazon-Athena_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.25) translate(-40, -40)'
      >
        <path
          d='M38.3,27.23 C42.79,27.23 45.25,28.23 45.7,28.74 C45.25,29.24 42.79,30.25 38.3,30.25 C33.8,30.25 31.34,29.24 30.89,28.74 C31.34,28.23 33.8,27.23 38.3,27.23 L38.3,27.23 Z M37.78,35.28 C37.62,35.2 37.5,35.03 37.5,34.83 C37.5,34.55 37.73,34.32 38.01,34.32 C38.09,34.32 38.16,34.34 38.23,34.38 L37.78,35.28 Z M43.57,43.59 C43.49,43.65 43.32,43.77 42.97,43.91 C42.66,44.03 42.29,44.15 41.87,44.25 C40.75,44.51 39.38,44.65 38.01,44.65 C35,44.65 32.9,44 32.45,43.6 L31.12,31.15 C33.16,31.99 36.17,32.26 38.3,32.26 C40.38,32.26 43.33,32 45.37,31.19 L44.57,36.67 C43.07,36.1 41.2,35.28 39.42,34.41 C39.24,33.79 38.68,33.32 38.01,33.32 C37.19,33.32 36.52,34 36.52,34.83 C36.52,35.66 37.19,36.34 38.01,36.34 C38.2,36.34 38.38,36.3 38.55,36.23 C41.03,37.45 42.88,38.24 44.28,38.72 L43.57,43.59 Z M28.87,28.85 L30.48,43.85 C30.59,46.63 37.7,46.67 38.01,46.67 C39.53,46.67 41.06,46.5 42.31,46.21 C42.83,46.09 43.3,45.95 43.7,45.78 C44.87,45.31 45.49,44.67 45.53,43.87 L46.2,39.28 C46.66,39.37 47.03,39.41 47.33,39.41 C48.26,39.41 48.51,39.03 48.68,38.76 C48.85,38.49 48.91,38.14 48.82,37.8 C48.63,37.01 47.52,35.97 46.77,35.35 L47.71,28.89 L47.7,28.88 C47.71,28.83 47.72,28.79 47.72,28.74 C47.72,25.95 41.8,25.21 38.3,25.21 C34.79,25.21 28.87,25.95 28.87,28.74 C28.87,28.78 28.88,28.81 28.88,28.85 L28.87,28.85 Z M37.84,20.06 C46.49,20.06 53.52,27.2 53.52,35.98 C53.52,44.77 46.49,51.91 37.84,51.91 C29.18,51.91 22.15,44.77 22.15,35.98 C22.15,27.2 29.18,20.06 37.84,20.06 L37.84,20.06 Z M12.99,41.83 L12.99,43.85 L21.92,43.85 L21.92,43.73 C24.77,49.75 30.83,53.92 37.84,53.92 C47.58,53.92 55.51,45.88 55.51,35.98 C55.51,26.09 47.58,18.04 37.84,18.04 C30.25,18.04 23.79,22.92 21.29,29.75 L12.99,29.75 L12.99,31.76 L20.68,31.76 C20.37,33.06 20.19,34.4 20.17,35.79 L11,35.79 L11,37.81 L20.25,37.81 C20.39,39.2 20.71,40.55 21.14,41.83 L12.99,41.83 Z M67.08,66.04 C65.88,67.26 63.8,67.26 62.6,66.05 L51.93,55.22 C53.65,53.92 55.18,52.39 56.49,50.68 L67.09,61.49 C67.69,62.09 68.02,62.9 68.01,63.76 C68.01,64.62 67.68,65.43 67.08,66.04 L67.08,66.04 Z M68.5,60.06 L57.66,49.01 C60.06,45.26 61.47,40.79 61.47,35.98 C61.47,22.76 50.86,12 37.84,12 C28.47,12 19.98,17.62 16.2,26.32 L18.02,27.13 C21.48,19.16 29.26,14.01 37.84,14.01 C49.77,14.01 59.48,23.87 59.48,35.98 C59.48,48.1 49.77,57.95 37.84,57.95 C29.86,57.95 22.56,53.52 18.77,46.39 L17.02,47.35 C21.16,55.13 29.13,59.97 37.84,59.97 C42.39,59.97 46.65,58.65 50.26,56.37 L61.19,67.47 C62.16,68.46 63.46,69 64.83,69 C66.21,69 67.51,68.45 68.48,67.46 C69.46,66.48 70,65.16 70,63.76 C70,62.36 69.47,61.05 68.5,60.06 L68.5,60.06 Z'
          id='Amazon-Athena_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function CloudTrailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70.002 70.002'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_AWS-Cloud-Trail_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.25) translate(-40, -40)'
      >
        <path
          d='M25,52.996 L29,52.996 L29,50.994 L25,50.994 L25,52.996 Z M59.971,38.163 C59.746,35.126 58.261,32.89 55.902,32.1 C54.003,31.467 51.911,31.914 50.318,33.213 C49.352,31.308 47.9,29.442 46.702,28.26 C42.406,24.019 37.668,22.938 32.616,25.045 C28.106,26.922 24,33.087 24,37.981 L24,38.171 C21.293,39.086 19.109,41.074 18.074,43.609 L19.926,44.366 C21.245,41.135 24.332,40.122 25.247,39.889 C25.69,39.776 26,39.377 26,38.919 L26,37.981 C26,33.936 29.657,28.445 33.385,26.893 C37.68,25.103 41.578,26.011 45.298,29.685 C46.88,31.246 48.427,33.561 49.06,35.318 C49.184,35.664 49.488,35.913 49.852,35.968 C50.212,36.023 50.577,35.874 50.799,35.58 C51.904,34.11 53.696,33.474 55.269,33.999 C57.004,34.581 58,36.397 58,38.982 C58,39.472 58.354,39.889 58.836,39.969 C59.569,40.091 66,41.352 66,47.991 C66,54.868 59.281,54.996 59,54.998 L36,54.998 L36,57 L59.002,57 C62.114,56.994 68,55.104 68,47.991 C68,41.784 63.279,38.989 59.971,38.163 L59.971,38.163 Z M31,52.996 L45,52.996 L45,50.994 L31,50.994 L31,52.996 Z M27,57 L33,57 L33,54.998 L27,54.998 L27,57 Z M12,57 L15,57 L15,54.998 L12,54.998 L12,57 Z M15,48.992 L24,48.992 L24,46.99 L15,46.99 L15,48.992 Z M13,52.996 L23,52.996 L23,50.994 L13,50.994 L13,52.996 Z M27,48.992 L34,48.992 L34,46.99 L27,46.99 L27,48.992 Z M17,57 L25,57 L25,54.998 L17,54.998 L17,57 Z'
          id='AWS-Cloud-Trail_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function CloudWatchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70.002 70.002'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_Amazon-CloudWatch_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.25) translate(-40, -40)'
      >
        <path
          d='M55.06,46.78 C55.06,42.87 51.86,39.69 47.92,39.69 C43.99,39.69 40.79,42.87 40.79,46.78 C40.79,50.69 43.99,53.87 47.92,53.87 C51.86,53.87 55.06,50.69 55.06,46.78 M57.07,46.78 C57.07,51.79 52.97,55.86 47.92,55.86 C42.88,55.86 38.78,51.79 38.78,46.78 C38.78,41.77 42.88,37.69 47.92,37.69 C52.97,37.69 57.07,41.77 57.07,46.78 M65.51,60.47 L58.5,54.2 C57.94,54.99 57.28,55.72 56.55,56.36 L63.55,62.63 C64.15,63.17 65.08,63.12 65.62,62.53 C66.16,61.93 66.11,61.01 65.51,60.47 M47.92,57.66 C53.96,57.66 58.88,52.78 58.88,46.78 C58.88,40.78 53.96,35.89 47.92,35.89 C41.88,35.89 36.97,40.78 36.97,46.78 C36.97,52.78 41.88,57.66 47.92,57.66 M67.11,63.86 C66.43,64.62 65.48,65 64.53,65 C63.7,65 62.87,64.71 62.21,64.12 L54.93,57.6 C52.91,58.9 50.51,59.66 47.92,59.66 C40.77,59.66 34.95,53.88 34.95,46.78 C34.95,39.67 40.77,33.9 47.92,33.9 C55.07,33.9 60.89,39.67 60.89,46.78 C60.89,48.82 60.4,50.74 59.55,52.45 L66.86,58.99 C68.28,60.27 68.39,62.45 67.11,63.86 M21.28,29.39 C21.28,29.91 21.31,30.43 21.37,30.93 C21.41,31.21 21.32,31.5 21.13,31.71 C20.98,31.88 20.77,32 20.55,32.03 C18.08,32.67 14.01,34.59 14.01,40.35 C14.01,44.69 16.42,47.09 18.45,48.34 C19.14,48.77 19.96,49.01 20.82,49.01 L32.95,49.03 L32.94,51.02 L20.81,51.01 C19.57,51 18.38,50.66 17.38,50.03 C15.38,48.8 12,45.89 12,40.35 C12,33.66 16.6,31.19 19.3,30.32 C19.28,30.01 19.27,29.7 19.27,29.39 C19.27,23.93 23,18.27 27.94,16.22 C33.72,13.82 39.85,15.01 44.33,19.41 C45.71,20.77 46.85,22.43 47.73,24.35 C48.91,23.38 50.36,22.85 51.88,22.85 C54.89,22.85 58.27,25.11 58.87,30.06 C61.68,30.7 67.62,32.96 67.62,40.42 C67.62,43.4 66.68,45.87 64.82,47.74 L63.39,46.34 C64.86,44.85 65.61,42.86 65.61,40.42 C65.61,33.89 60.11,32.27 57.74,31.87 C57.47,31.83 57.23,31.68 57.08,31.45 C56.93,31.24 56.87,30.97 56.91,30.71 C56.59,26.66 54.16,24.84 51.88,24.84 C50.45,24.84 49.1,25.54 48.19,26.75 C47.97,27.04 47.6,27.19 47.23,27.14 C46.87,27.09 46.56,26.84 46.44,26.49 C45.61,24.23 44.43,22.32 42.91,20.83 C39.03,17.02 33.73,15.98 28.72,18.06 C24.55,19.79 21.28,24.77 21.28,29.39'
          id='Amazon-CloudWatch_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function CodePipelineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='5 5 70.002 70.002'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Icon-Architecture/64/Arch_AWS-CodePipeline_64'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        transform='translate(40, 40) scale(1.25) translate(-40, -40)'
      >
        <path
          d='M30,31 L35,31 L35,29 L30,29 L30,31 Z M36.67,61.17 L34.82,60.41 L42.41,41.88 L44.26,42.64 L36.67,61.17 Z M45.57,55.78 L51.07,50.96 L45.58,46.2 L46.89,44.69 L53.24,50.2 C53.46,50.39 53.59,50.66 53.59,50.95 C53.59,51.24 53.47,51.52 53.25,51.71 L46.89,57.28 L45.57,55.78 Z M25.51,51.05 C25.51,50.76 25.63,50.48 25.85,50.29 L32.18,44.69 L33.51,46.19 L28.03,51.03 L33.48,55.73 L32.17,57.24 L25.86,51.8 C25.64,51.61 25.51,51.34 25.51,51.05 L25.51,51.05 Z M62.53,35 L18.46,35 C16.55,35 15,33.45 15,31.54 L15,31 L27,31 L27,29 L15,29 L15,18.46 C15,16.55 16.55,15 18.46,15 L62.53,15 C64.44,15 66,16.55 66,18.46 L66,29 L38,29 L38,31 L66,31 L66,31.54 C66,33.45 64.44,35 62.53,35 L62.53,35 Z M22,66 L58,66 L58,37 L22,37 L22,66 Z M62.53,13 L18.46,13 C15.45,13 13,15.45 13,18.46 L13,31.54 C13,34.55 15.45,37 18.46,37 L20,37 L20,67 C20,67.55 20.45,68 21,68 L59,68 C59.55,68 60,67.55 60,67 L60,37 L62.53,37 C65.55,37 68,34.55 68,31.54 L68,18.46 C68,15.45 65.55,13 62.53,13 L62.53,13 Z'
          id='AWS-CodePipeline_Icon_64_Squid'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function TextractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='10 14 60 52'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <path
        d='M22.06,50 C24.38,53.6 28.41,56 33,56 C40.17,56 46,50.17 46,43 C46,35.83 40.17,30 33,30 C27.6,30 22.97,33.31 21,38 L23.21,38 C25.04,34.44 28.74,32 33,32 C39.07,32 44,36.94 44,43 C44,49.07 39.07,54 33,54 C29.59,54 26.54,52.44 24.52,50 L22.06,50 Z M37,45 L37,43 L42,43 C42,38.04 37.96,34 33,34 C28.04,34 24,38.04 24,43 L29,43 L29,45 L24.23,45 C25.14,49 28.73,52 33,52 C35.14,52 37.1,51.25 38.64,50 L34,50 L34,48 L40.48,48 C41.08,47.1 41.52,46.09 41.77,45 L37,45 Z M21,48 L23.21,48 C22.44,46.5 22,44.8 22,43 C22,41.96 22.16,40.96 22.43,40 L20.36,40 C20.13,40.97 20,41.97 20,43 C20,44.77 20.36,46.46 21,48 L21,48 Z M19.74,50 L17,50 L17,48 L18.87,48 C18.53,47.04 18.29,46.04 18.15,45 L15.41,45 L16.71,46.29 L15.29,47.71 L12.29,44.71 C11.9,44.32 11.9,43.68 12.29,43.29 L15.29,40.29 L16.71,41.71 L15.41,43 L18,43 C18,41.97 18.1,40.97 18.3,40 L17,40 L17,38 L18.87,38 C20.94,32.18 26.48,28 33,28 C37.43,28 41.4,29.94 44.15,33 L59,33 L59,35 L45.67,35 C47.14,37.32 48,40.06 48,43 L59,43 L59,45 L47.85,45 C46.87,52.33 40.59,58 33,58 C27.26,58 22.26,54.75 19.74,50 L19.74,50 Z M37,39 C37,38.45 36.55,38 36,38 L30,38 C29.45,38 29,38.45 29,39 L29,41 L31,41 L31,40 L32,40 L32,43 L31,43 L31,45 L35,45 L35,43 L34,43 L34,40 L35,40 L35,41 L37,41 L37,39 Z M49,40 L59,40 L59,38 L49,38 L49,40 Z M49,50 L59,50 L59,48 L49,48 L49,50 Z M57,27 L60.59,27 L57,23.41 L57,27 Z M63.71,27.29 C63.89,27.48 64,27.74 64,28 L64,63 C64,63.55 63.55,64 63,64 L32,64 C31.45,64 31,63.55 31,63 L31,59 L33,59 L33,62 L62,62 L62,29 L56,29 C55.45,29 55,28.55 55,28 L55,22 L33,22 L33,27 L31,27 L31,21 C31,20.45 31.45,20 32,20 L56,20 C56.27,20 56.52,20.11 56.71,20.29 L63.71,27.29 Z M68,24.17 L68,61 C68,61.55 67.55,62 67,62 L65,62 L65,60 L66,60 L66,24.61 L58.62,18 L36,18 L36,19 L34,19 L34,17 C34,16.45 34.45,16 35,16 L59,16 C59.25,16 59.48,16.09 59.67,16.26 L67.67,23.42 C67.88,23.61 68,23.88 68,24.17 L68,24.17 Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function McpIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `mcp_clip_${id}`

  return (
    <svg
      {...props}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.56 7.88L14.5 7.93L8.7 13.62C8.68 13.64 8.67 13.66 8.66 13.68C8.65 13.7 8.64 13.72 8.64 13.75C8.64 13.77 8.65 13.8 8.66 13.82C8.67 13.84 8.68 13.86 8.7 13.88L8.7 13.88L9.89 15.05C9.99 15.15 10.05 15.29 10.06 15.44C10.06 15.58 10 15.72 9.9 15.83L9.89 15.84C9.78 15.94 9.64 16 9.49 16C9.34 16 9.2 15.94 9.09 15.84L7.9 14.67C7.77 14.55 7.68 14.41 7.61 14.25C7.54 14.09 7.51 13.92 7.51 13.75C7.51 13.58 7.54 13.41 7.61 13.25C7.68 13.1 7.77 12.95 7.9 12.83L13.7 7.14C14.01 6.84 14.19 6.42 14.2 5.98C14.2 5.55 14.04 5.13 13.73 4.81L13.7 4.78L13.67 4.75C13.35 4.44 12.91 4.26 12.47 4.26C12.02 4.26 11.58 4.44 11.26 4.75L6.48 9.44H6.48L6.41 9.5C6.31 9.61 6.16 9.67 6.01 9.67C5.86 9.67 5.72 9.61 5.61 9.5C5.51 9.4 5.45 9.26 5.45 9.12C5.44 8.97 5.5 8.83 5.6 8.73L5.61 8.72L10.46 3.96C11.11 3.32 11.12 2.28 10.49 1.63L10.46 1.6C10.14 1.29 9.7 1.11 9.25 1.11C8.81 1.11 8.37 1.29 8.05 1.6L1.64 7.9C1.53 8 1.38 8.06 1.23 8.06C1.08 8.06 0.94 8 0.83 7.9C0.73 7.79 0.67 7.66 0.67 7.51C0.67 7.36 0.72 7.22 0.82 7.12L0.83 7.11L7.25 0.81C7.79 0.29 8.51 0 9.26 0C10 0 10.72 0.29 11.26 0.81C11.89 1.43 12.19 2.3 12.06 3.17C12.94 3.05 13.83 3.34 14.47 3.96L14.5 3.99C14.76 4.25 14.97 4.54 15.11 4.88C15.25 5.21 15.33 5.56 15.33 5.92C15.34 6.28 15.27 6.64 15.14 6.98C15.01 7.31 14.81 7.62 14.56 7.87M12.87 6.32C12.97 6.22 13.03 6.08 13.03 5.94C13.03 5.79 12.98 5.65 12.88 5.55L12.87 5.54C12.76 5.43 12.61 5.37 12.46 5.37C12.31 5.37 12.17 5.43 12.06 5.54L7.32 10.19C7 10.5 6.56 10.68 6.11 10.68C5.66 10.68 5.23 10.5 4.91 10.19C4.76 10.04 4.63 9.86 4.55 9.66C4.46 9.46 4.42 9.25 4.41 9.03C4.41 8.81 4.45 8.6 4.53 8.4C4.61 8.2 4.73 8.01 4.88 7.86L4.91 7.83L9.66 3.17C9.76 3.07 9.82 2.93 9.82 2.79C9.83 2.64 9.77 2.5 9.67 2.4L9.66 2.39C9.55 2.28 9.41 2.22 9.26 2.22C9.11 2.22 8.96 2.28 8.86 2.39L4.11 7.04C3.85 7.3 3.64 7.6 3.49 7.94C3.35 8.28 3.28 8.64 3.28 9.01C3.28 9.38 3.35 9.74 3.49 10.08C3.64 10.41 3.85 10.72 4.11 10.98C4.65 11.5 5.36 11.79 6.11 11.79C6.86 11.79 7.58 11.5 8.12 10.98L12.87 6.32Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function A2AIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 860 860' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='544' cy='307' r='27' fill='currentColor' />
      <circle cx='154' cy='307' r='27' fill='currentColor' />
      <circle cx='706' cy='307' r='27' fill='currentColor' />
      <circle cx='316' cy='307' r='27' fill='currentColor' />
      <path
        d='M336.5 191H162C97.66 191 45.5 243.16 45.5 307.5C45.5 371.84 97.64 424 161.99 424C206.55 424 256.29 424 296.5 424C487.5 424 374 191.01 569 191C613.89 191 658.97 191 698.03 191C762.37 191 814.5 243.16 814.5 307.5C814.5 371.84 762.34 424 698 424H523.5'
        stroke='currentColor'
        strokeWidth='48'
        strokeLinecap='round'
      />
      <path
        d='M256 510C270.36 510 282 521.64 282 536C282 550.36 270.36 562 256 562H148C133.64 562 122 550.36 122 536C122 521.64 133.64 510 148 510H256ZM712 510C726.36 510 738 521.64 738 536C738 550.36 726.36 562 712 562H360C345.64 562 334 550.36 334 536C334 521.64 345.64 510 360 510H712Z'
        fill='currentColor'
      />
      <path
        d='M444 628C458.36 628 470 639.64 470 654C470 668.36 458.36 680 444 680H100C85.64 680 74 668.36 74 654C74 639.64 85.64 628 100 628H444ZM548 628C562.36 628 574 639.64 574 654C574 668.36 562.36 680 548 680C533.64 680 522 668.36 522 654C522 639.64 533.64 628 548 628ZM760 628C774.36 628 786 639.64 786 654C786 668.36 774.36 680 760 680H652C637.64 680 626 668.36 626 654C626 639.64 637.64 628 652 628H760Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function WordpressIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25.93 25.93'>
      <g fill='currentColor'>
        <path d='M1.84,12.96c0,4.4,2.56,8.21,6.27,10.01L2.81,8.44C2.19,9.82,1.84,11.35,1.84,12.96z M20.47,12.4c0-1.37-0.49-2.33-0.92-3.07c-0.56-0.92-1.09-1.69-1.09-2.61c0-1.02,0.78-1.97,1.87-1.97c0.05,0,0.1,0.01,0.14,0.01c-1.98-1.81-4.61-2.92-7.51-2.92c-3.88,0-7.3,1.99-9.29,5.01c0.26,0.01,0.51,0.01,0.72,0.01c1.16,0,2.96-0.14,2.96-0.14c0.6-0.04,0.67,0.85,0.07,0.92c0,0-0.6,0.07-1.27,0.11l4.05,12.05l2.43-7.3l-1.73-4.75c-0.6-0.04-1.17-0.1-1.17-0.1c-0.6-0.04-0.53-0.95,0.07-0.92c0,0,1.84,0.14,2.93,0.14c1.16,0,2.96-0.14,2.96-0.14c0.6-0.04,0.67,0.85,0.07,0.92c0,0-0.6,0.07-1.27,0.11l4.02,11.95l1.11-3.71C20.19,14.55,20.47,13.35,20.47,12.4z M13.16,13.94l-3.34,9.69c1,0.29,2.05,0.45,3.14,0.45c1.29,0,2.54-0.22,3.69-0.63c-0.03-0.05-0.06-0.1-0.08-0.15L13.16,13.94z M22.72,7.63c0.05,0.35,0.08,0.73,0.08,1.14c0,1.13-0.21,2.4-0.85,3.98l-3.4,9.82c3.31-1.93,5.53-5.51,5.53-9.61C24.08,11.03,23.59,9.21,22.72,7.63z' />
        <path d='M0,12.96c0,7.15,5.82,12.96,12.96,12.96c7.15,0,12.96-5.82,12.96-12.96S20.11,0,12.96,0S0,5.81,0,12.96z M0.59,12.96c0-6.82,5.55-12.37,12.37-12.37s12.37,5.55,12.37,12.37S19.78,25.33,12.96,25.33S0.59,19.78,0.59,12.96z' />
      </g>
    </svg>
  )
}

export function AgiloftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 47.3 47.2' xmlns='http://www.w3.org/2000/svg'>
      <path d='M47.3,21.4H0v-4.3l4.3-4.2h43V21.4z' fill='#263A5C' />
      <path d='M47.3,8.6H8.6L17.2,0h30.1V8.6z' fill='#001028' />
      <path d='M0,25.7h47.3V30L43,34.4H0V25.7z' fill='#4A6587' />
      <path d='M0,38.7h38.8l-8.6,8.5H0V38.7z' fill='#6D8DAF' />
    </svg>
  )
}

export function SemrushIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 43.3 26'>
      <path
        fill='#FF642D'
        d='M37.4,12.8c0,0.8-0.4,0.9-1.4,0.9c-1.1,0-1.3-0.2-1.4-1c-0.2-2.1-1.6-3.9-4-4c-0.7-0.1-0.9-0.3-0.9-1.3 c0-0.9,0.1-1.3,0.8-1.3C34.5,6.2,37.4,9.5,37.4,12.8z M43.3,12.8c0-6.2-4.2-12.8-14-12.8H10C9.6,0,9.3,0.2,9.3,0.6 c0,0.2,0.1,0.4,0.3,0.5c0.7,0.6,1.7,1.2,3.1,1.9c1.3,0.7,2.4,1.1,3.4,1.5c0.4,0.2,0.6,0.4,0.6,0.6c0,0.3-0.2,0.6-0.7,0.6H0.7 C0.2,5.6,0,5.9,0,6.2c0,0.3,0.1,0.5,0.3,0.7c1.2,1.3,3.2,2.9,6.1,4.7c2.5,1.6,5.7,3.3,8.2,4.5c0.4,0.2,0.6,0.4,0.6,0.7 c0,0.3-0.2,0.5-0.7,0.5H7.4c-0.4,0-0.6,0.2-0.6,0.5c0,0.2,0.1,0.4,0.3,0.6c1.6,1.5,4.2,3,7.6,4.5c4.6,1.9,9.2,3.1,14.4,3.1 C39,26,43.3,18.6,43.3,12.8z M30.4,21.7c-4.8,0-8.9-3.9-8.9-8.9c0-4.8,4-8.7,8.9-8.7c5,0,8.9,3.9,8.9,8.7 C39.3,17.7,35.4,21.7,30.4,21.7z'
      />
    </svg>
  )
}

export function AhrefsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1065 1300'>
      <path
        fillRule='evenodd'
        fill='#ff8800'
        d='m111.3 0.7h953.4v1264.4h-256.9v-137.8h-21.2c-127 129.9-230.4 172.4-410.4 172.4-227.8 0-376.1-127.3-376.1-339.5v-58.3c0-288.9 121.8-392.4 511-421.5l241-18.6v-180.2h-640.8zm640.8 707.7l-193.4 18.6c-203.9 18.6-248.8 47.8-251.5 169.7-2.7 87.5 42.4 127.2 148.3 127.2 98 0 217.1-53 296.6-132.5z'
      />
    </svg>
  )
}

export function ShopifyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width='48px'
      height='48px'
    >
      <path
        fill='#7cb342'
        d='M37.22,11.78c-0.02-0.21-0.21-0.3-0.35-0.3s-3.21-0.23-3.21-0.23s-2.13-2.13-2.39-2.34	c-0.23-0.23-0.68-0.16-0.87-0.12c-0.02,0-0.47,0.14-1.19,0.38c-0.73-2.09-1.97-3.98-4.19-3.98h-0.21	C24.19,4.38,23.39,4,22.74,4c-5.15,0-7.64,6.44-8.41,9.73c-2.01,0.63-3.44,1.05-3.61,1.13	c-1.12,0.35-1.15,0.38-1.29,1.43c-0.12,0.8-3.05,23.46-3.05,23.46L29.18,44l12.37-2.67	C41.58,41.28,37.24,11.99,37.22,11.78z M27.94,9.48c-0.56,0.16-1.24,0.38-1.92,0.61V9.67	c0-1.26-0.16-2.3-0.47-3.12C26.72,6.7,27.45,7.98,27.94,9.48L27.94,9.48z M24.12,6.81	c0.31,0.8,0.52,1.92,0.52,3.47v0.23c-1.26,0.4-2.6,0.8-3.98,1.24C21.42,8.8,22.9,7.35,24.12,6.81	L24.12,6.81z M22.62,5.36c0.23,0,0.47,0.09,0.66,0.23c-1.66,0.77-3.42,2.72-4.15,6.66	c-1.1,0.35-2.16,0.66-3.16,0.98C16.81,10.23,18.92,5.36,22.62,5.36z'
      />
      <path
        fill='#558b2f'
        d='M36.87,11.43c-0.14,0-3.21-0.23-3.21-0.23s-2.13-2.13-2.39-2.34	C31.17,8.76,31.05,8.71,30.96,8.71L29.25,44l12.37-2.67c0,0-4.33-29.34-4.36-29.55	C37.17,11.57,37.01,11.48,36.87,11.43z'
      />
      <path
        fill='#fff'
        d='M24.79,18.59l-1.47,4.45c0,0-1.34-0.71-2.93-0.71c-2.37,0-2.49,1.5-2.49,1.87	c0,2.03,5.3,2.81,5.3,7.58c0,3.76-2.37,6.18-5.58,6.18c-3.87,0-5.81-2.4-5.81-2.4l1.04-3.41	c0,0,2.03,1.75,3.73,1.75c1.13,0,1.59-0.88,1.59-1.52c0-2.65-4.33-2.77-4.33-7.14c0-3.66,2.63-7.21,7.95-7.21	C23.78,17.99,24.79,18.59,24.79,18.59z'
      />
    </svg>
  )
}

export function BoxCompanyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='2500'
      height='1379'
      viewBox='0 0 444.89 245.41'
    >
      <g fill='#0075C9'>
        <path d='M239.04 72.43c-33.08 0-61.81 18.6-76.32 45.9-14.52-27.3-43.24-45.9-76.32-45.9-19.44 0-37.38 6.42-51.82 17.27V16.93h-.008C34.37 7.55 26.71 0 17.29 0 7.86 0 .208 7.55.008 16.93H0v143.33h.036c.768 47.05 39.13 84.97 86.36 84.97 33.08 0 61.81-18.6 76.32-45.91 14.52 27.31 43.24 45.91 76.32 45.91 47.72 0 86.4-38.68 86.4-86.4.001-47.72-38.68-86.4-86.39-86.4zM86.4 210.65c-28.62 0-51.82-23.2-51.82-51.82 0-28.62 23.2-51.82 51.82-51.82 28.62 0 51.82 23.2 51.82 51.82 0 28.62-23.2 51.82-51.82 51.82zm152.64 0c-28.62 0-51.82-23.2-51.82-51.82 0-28.62 23.2-51.82 51.82-51.82 28.62 0 51.82 23.2 51.82 51.82-.001 28.62-23.2 51.82-51.82 51.82z' />
        <path d='M441.65 218.03l-44.25-59.14 44.25-59.14-.008-.007c5.47-7.62 3.89-18.25-3.65-23.91-7.54-5.66-18.19-4.22-23.98 3.16l-.004-.002-38.19 51.05-38.19-51.05-.6.01c-5.79-7.38-16.44-8.82-23.98-3.16-7.54 5.66-9.12 16.29-3.65 23.91l-.8.01 44.25 59.14-44.24 59.14.8.01c-5.48 7.62-3.89 18.25 3.65 23.91 7.54 5.66 18.19 4.22 23.98-3.15l.6.01 38.19-51.05 38.19 51.05.004-.002c5.79 7.38 16.44 8.81 23.98 3.15 7.54-5.66 9.13-16.29 3.65-23.91l.008-.008z' />
      </g>
    </svg>
  )
}

export function DropboxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 43 40'>
      <path
        d='m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ElasticsearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'>
      <path
        fill='#343741'
        d='M4 64c0 5.54.777 10.88 2.1 16H84c8.84 0 16-7.16 16-16s-7.16-16-16-16H6.1A63.74 63.74 0 0 0 4 64'
      />
      <path
        fill='#fec514'
        d='M111.7 30.65A61.49 61.49 0 0 0 117.92 24C106.19 9.38 88.2 0 68 0 42.72 0 20.96 14.71 10.57 36H98.04a20.12 20.12 0 0 0 13.65-5.35'
      />
      <path
        fill='#00bfb3'
        d='M98.04 92H10.58C20.96 113.29 42.72 128 68 128c20.2 0 38.19-9.38 49.92-24a61.1 61.1 0 0 0-6.23-6.65A20.13 20.13 0 0 0 98.04 92'
      />
    </svg>
  )
}

export function GitlabIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 380 380'>
      <path
        fill='#e24329'
        d='M265.26,174.37l-.213-.558-21.2-55.31c-.424-1.08-1.19-2-2.18-2.63-.988-.634-2.15-.933-3.32-.87-1.17.06-2.29.49-3.21,1.22-.91.74-1.57,1.73-1.87,2.85l-14.31,43.81h-57.91l-14.31-43.81c-.309-1.12-.965-2.12-1.87-2.85-.916-.729-2.04-1.16-3.21-1.22-1.18-.062-2.33.24-3.32.87-.992.63-1.75,1.54-2.18,2.63l-21.2,55.31-.213.55c-6.28,16.39-.929,34.91,13.06,45.49.26.2.49.4.76.06l.187.14,32.29,24.17,15.97,12.09,9.72,7.35c2.34,1.77,5.58,1.77,7.92,0l9.72-7.35,15.97-12.09,32.48-24.32c.03-.23.06-.427.09-.066,13.98-10.58,19.33-29.1,13.05-45.48Z'
      />
      <path
        fill='#fc6d26'
        d='M265.26,174.37l-.213-.558c-10.52,2.16-20.2,6.61-28.5,12.82-.135.1-25.2,19.06-46.55,35.2,15.85,11.99,29.65,22.4,29.65,22.4l32.48-24.32c.03-.23.06-.427.09-.066,13.98-10.58,19.33-29.1,13.05-45.48Z'
      />
      <path
        fill='#fca326'
        d='M160.35,244.23l15.97,12.09,9.72,7.35c2.34,1.77,5.58,1.77,7.92,0l9.72-7.35,15.97-12.09s-13.8-10.42-29.65-22.4c-15.85,11.99-29.65,22.4-29.65,22.4Z'
      />
      <path
        fill='#fc6d26'
        d='M143.45,186.63c-8.29-6.2-17.97-10.66-28.5-12.81l-.213.55c-6.28,16.39-.929,34.91,13.06,45.49.26.2.49.4.76.06l.187.14,32.29,24.17s13.8-10.42,29.65-22.4c-21.35-16.14-46.42-35.1-46.55-35.2Z'
      />
    </svg>
  )
}

export function SSHIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width='48px'
      height='48px'
    >
      <path
        fill='#7cb342'
        d='M37.22,11.78c-0.02-0.21-0.21-0.3-0.35-0.3s-3.21-0.23-3.21-0.23s-2.13-2.13-2.39-2.34	c-0.23-0.23-0.68-0.16-0.87-0.12c-0.02,0-0.47,0.14-1.19,0.38c-0.73-2.09-1.97-3.98-4.19-3.98h-0.21	C24.19,4.38,23.39,4,22.74,4c-5.15,0-7.64,6.44-8.41,9.73c-2.01,0.63-3.44,1.05-3.61,1.13	c-1.12,0.35-1.15,0.38-1.29,1.43c-0.12,0.8-3.05,23.46-3.05,23.46L29.18,44l12.37-2.67	C41.58,41.28,37.24,11.99,37.22,11.78z M27.94,9.48c-0.56,0.16-1.24,0.38-1.92,0.61V9.67	c0-1.26-0.16-2.3-0.47-3.12C26.72,6.7,27.45,7.98,27.94,9.48L27.94,9.48z M24.12,6.81	c0.31,0.8,0.52,1.92,0.52,3.47v0.23c-1.26,0.4-2.6,0.8-3.98,1.24C21.42,8.8,22.9,7.35,24.12,6.81	L24.12,6.81z M22.62,5.36c0.23,0,0.47,0.09,0.66,0.23c-1.66,0.77-3.42,2.72-4.15,6.66	c-1.1,0.35-2.16,0.66-3.16,0.98C16.81,10.23,18.92,5.36,22.62,5.36z'
      />
      <path
        fill='#558b2f'
        d='M36.87,11.43c-0.14,0-3.21-0.23-3.21-0.23s-2.13-2.13-2.39-2.34	C31.17,8.76,31.05,8.71,30.96,8.71L29.25,44l12.37-2.67c0,0-4.33-29.34-4.36-29.55	C37.17,11.57,37.01,11.48,36.87,11.43z'
      />
      <path
        fill='#fff'
        d='M24.79,18.59l-1.47,4.45c0,0-1.34-0.71-2.93-0.71c-2.37,0-2.49,1.5-2.49,1.87	c0,2.03,5.3,2.81,5.3,7.58c0,3.76-2.37,6.18-5.58,6.18c-3.87,0-5.81-2.4-5.81-2.4l1.04-3.41	c0,0,2.03,1.75,3.73,1.75c1.13,0,1.59-0.88,1.59-1.52c0-2.65-4.33-2.77-4.33-7.14c0-3.66,2.63-7.21,7.95-7.21	C23.78,17.99,24.79,18.59,24.79,18.59z'
      />
    </svg>
  )
}

export function DagsterIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='56 56 448 448.001' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M221.56 440.82C221.56 442.77 221.97 444.7 222.76 446.49C223.54 448.29 224.69 449.89 226.13 451.22C227.56 452.55 229.25 453.57 231.1 454.21C232.95 454.85 234.91 455.11 236.85 454.96C310.94 449.66 380.91 397.22 403.25 315.33C404.43 310.62 407.96 308.26 412.67 308.26C415.08 308.36 417.36 309.4 419.01 311.17C420.66 312.93 421.55 315.28 421.48 317.69C421.48 335.95 398.01 383.67 364.44 411.37C362.73 412.81 361.37 414.61 360.45 416.65C359.54 418.69 359.09 420.91 359.15 423.15C359.19 424.97 359.58 426.76 360.31 428.43C361.04 430.09 362.09 431.6 363.4 432.86C364.71 434.11 366.25 435.1 367.95 435.76C369.64 436.42 371.45 436.74 373.26 436.7C376.21 436.7 380.91 434.93 386.8 429.63C410.27 408.41 455 348.91 455 283.51C455 187.62 380.87 105 277.42 105C185.11 105 105.14 180.41 105.14 267.61C105.14 325.35 151 368.94 211.56 368.94C258.02 368.94 300.95 335.95 312.71 290.58C313.88 285.87 317.4 283.51 322.11 283.51C324.52 283.61 326.8 284.65 328.46 286.42C330.11 288.18 331 290.52 330.93 292.94C330.93 313.56 292.12 385.48 213.33 385.48C194.51 385.48 171 380.18 154.52 370.75C152.32 369.68 149.92 369.08 147.47 368.98C145.59 368.91 143.73 369.22 141.98 369.91C140.23 370.59 138.65 371.63 137.32 372.96C136 374.29 134.96 375.88 134.28 377.63C133.6 379.38 133.28 381.25 133.36 383.12C133.44 385.52 134.12 387.87 135.36 389.93C136.59 391.99 138.33 393.7 140.41 394.9C162.17 407.33 188.05 413.76 214.5 413.76C280.36 413.76 340.34 368.98 357.98 303C359.15 298.29 362.69 295.93 367.38 295.93C369.8 296.02 372.08 297.07 373.73 298.83C375.38 300.6 376.27 302.94 376.21 305.36C376.21 332.46 327.99 419.66 235.09 426.73C231.49 426.99 228.12 428.58 225.63 431.18C223.13 433.78 221.68 437.21 221.56 440.82V440.82Z'
        fill='#4F43DD'
      />
      <path
        d='M313.62 215.18C326.3 215.08 338.75 218.59 349.52 225.29C350.61 219.33 351.21 213.29 351.31 207.24C351.31 179.27 330 154.21 304.04 154.21C283.85 154.21 271.23 170.94 271.23 191.6C271.14 202.76 275.06 213.59 282.28 222.1C292.06 217.43 302.78 215.06 313.62 215.18V215.18Z'
        fill='white'
      />
      <path
        d='M374.44 316.51C378.04 304.19 379.63 295.64 379.63 290.08C379.52 287.69 378.49 285.42 376.76 283.76C375.03 282.1 372.72 281.17 370.33 281.16C368.09 281.2 365.93 281.99 364.2 283.4C362.46 284.81 361.24 286.76 360.74 288.94C359.76 292.98 357.66 303.95 355.59 310.91C356.45 308.31 357.23 305.66 357.94 302.97C359.11 298.25 362.65 295.9 367.34 295.9C369.76 295.99 372.04 297.03 373.69 298.8C375.34 300.56 376.23 302.9 376.17 305.32C376.05 309.12 375.45 312.88 374.36 316.52L374.44 316.51Z'
        fill='#352D8E'
      />
      <path
        d='M424.42 303.63C424.31 301.24 423.28 298.98 421.55 297.32C419.82 295.66 417.52 294.72 415.13 294.71C412.89 294.75 410.74 295.54 409.01 296.95C407.27 298.36 406.06 300.31 405.56 302.49C404.56 306.63 402.42 317.76 400.33 324.71H400.42C401.44 321.62 402.4 318.48 403.18 315.29C404.36 310.57 407.89 308.22 412.6 308.22C415.01 308.31 417.29 309.35 418.94 311.12C420.59 312.88 421.48 315.22 421.41 317.64C421.34 320.57 420.94 323.49 420.21 326.33C423.13 316.05 424.42 308.62 424.42 303.63Z'
        fill='#352D8E'
      />
      <path
        d='M313.62 215.18C319.92 215.17 326.2 216.01 332.27 217.68C335.46 213.33 337.06 208.01 336.79 202.62C336.52 197.23 334.4 192.1 330.79 188.08C327.18 184.07 322.3 181.43 316.97 180.59C311.64 179.76 306.19 180.79 301.52 183.51L311.19 199.42L293.09 191.59C290.64 195.55 289.41 200.14 289.56 204.79C289.7 209.45 291.22 213.95 293.92 217.75C300.34 216.02 306.97 215.15 313.62 215.18V215.18Z'
        fill='#030615'
      />
      <path
        d='M174.17 317.58C181.8 317.58 187.98 311.4 187.98 303.77C187.98 296.14 181.8 289.96 174.17 289.96C166.55 289.96 160.37 296.14 160.37 303.77C160.37 311.4 166.55 317.58 174.17 317.58Z'
        fill='#352D8E'
      />
      <path
        d='M174.17 262.33C181.8 262.33 187.98 256.15 187.98 248.52C187.98 240.9 181.8 234.71 174.17 234.71C166.55 234.71 160.37 240.9 160.37 248.52C160.37 256.15 166.55 262.33 174.17 262.33Z'
        fill='#352D8E'
      />
      <path
        d='M146.56 289.96C154.18 289.96 160.36 283.77 160.36 276.15C160.36 268.52 154.18 262.33 146.56 262.33C138.93 262.33 132.75 268.52 132.75 276.15C132.75 283.77 138.93 289.96 146.56 289.96Z'
        fill='#352D8E'
      />
      <path
        d='M208.69 368.91H211.45C257.91 368.91 300.83 335.93 312.6 290.55C313.77 285.84 317.29 283.48 322 283.48C324.42 283.58 326.69 284.62 328.35 286.39C330 288.15 330.89 290.5 330.82 292.92C330.61 297.74 329.52 302.48 327.61 306.91C327.94 306.39 328.23 305.85 328.48 305.29C331.97 297.3 333.77 288.68 333.78 279.96C333.78 266.41 324.36 257.57 310.84 257.57C287.28 257.57 282.55 278.15 272.61 300.15C262.3 323 243.36 347.71 195.59 347.71C145.95 347.71 94.95 312.94 107.39 242.25C107.54 241.37 107.67 240.58 107.76 239.85C105.94 248.98 105.01 258.27 105 267.58C105.14 324.49 149.58 367.59 208.69 368.91Z'
        fill='#352D8E'
      />
    </svg>
  )
}

export function TemporalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='390 391 388 388' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M651.14,517.35C642.02,449.03,618.94,392,583.49,392s-58.53,57.03-67.65,125.35c-68.32,9.12-125.35,32.2-125.35,67.65s57.04,58.53,125.35,67.65c9.12,68.31,32.2,125.35,67.65,125.35s58.53-57.04,67.65-125.35c68.32-9.12,125.35-32.2,125.35-67.65S719.45,526.47,651.14,517.35z M513.61,632.75c-65.43-9.45-103.59-31.08-103.59-47.75s38.16-38.3,103.59-47.75c-1.44,15.75-2.19,31.83-2.19,47.75C511.42,600.92,512.17,617.01,513.61,632.75z M583.49,411.53c16.67,0,38.3,38.16,47.75,103.59c-15.74-1.44-31.83-2.19-47.75-2.19s-32.01,0.75-47.75,2.19C545.19,449.69,566.82,411.53,583.49,411.53z M653.37,632.75c-3.22,0.47-16.43,2.02-19.77,2.35c-0.33,3.35-1.89,16.55-2.35,19.77c-9.45,65.43-31.08,103.59-47.75,103.59s-38.3-38.16-47.75-103.59c-0.46-3.22-2.02-16.43-2.35-19.77c-1.52-15.51-2.44-32.17-2.44-50.1s0.92-34.59,2.44-50.11c15.51-1.52,32.17-2.44,50.1-2.44s34.59,0.92,50.1,2.44c3.35,0.33,16.55,1.89,19.77,2.35c65.43,9.45,103.6,31.09,103.6,47.75S718.8,623.3,653.37,632.75z'
        fill='currentColor'
      />
    </svg>
  )
}

export function DatabricksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 241 266' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M228.09 109.65L120.62 171.67L5.53 105.41L0 108.48V156.58L120.62 225.91L228.09 164.13V189.6L120.62 251.62L5.53 185.35L0 188.42V196.67L120.62 266L241 196.67V148.56L235.47 145.5L120.62 211.53L12.91 149.74V124.28L120.62 186.06L241 116.73V69.33L235 65.79L120.62 131.59L18.45 73.1L120.62 14.38L204.56 62.73L211.94 58.48V52.59L120.62 0L0 69.33V76.88L120.62 146.21L228.09 84.19V109.65Z'
        fill='#FF3621'
      />
    </svg>
  )
}

export function DatadogIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
      <g fill='currentColor'>
        <path d='M57.71 33.72l1.58 20.1L31.4 58.82 29 38.72l3.98-.556c.648.28 1.11.37 1.85.556 1.2.278 2.59.648 4.63-.463.46-.278 1.48-1.11 1.85-1.67zm-43.07 23.9c-.463-.74-1.3-1.57-2.59-2.59-1.85-1.48-1.2-4.08-.093-5.65 1.4-2.69 8.71-6.21 8.34-10.56-.185-1.57-.37-3.61-1.85-5.09-.93.56 0 1.11 0 1.11s-.648-.74-.926-1.85c-.278-.37-.556-.556-.834-1.11-.185.65-.185 1.3-.185 1.3s-.463-1.2-.556-2.13c-.278.46-.37 1.3-.37 1.3s-.648-1.85-.463-2.87c-.278-.834-1.2-2.59-.926-6.48 1.58 1.11 5.1.834 6.48-1.2.463-.648.74-2.5-.185-6.11-.648-2.32-2.22-5.74-2.87-7.04l-.93.09c.37 1.02 1.02 3.24 1.3 4.35.74 3.24 1.02 4.35.648 5.84-.278 1.3-1.02 2.13-2.96 3.06-1.85.926-4.45-1.4-4.54-1.48-1.85-1.48-3.24-3.9-3.43-5-.185-1.3.74-2.04 1.2-3.06-.648.18-1.4.56-1.4.56s.834-.926 1.95-1.67a9.43 9.43 0 0 0 1.2-.834H10.28s1.11-.648 2.32-1.02H10.93l4.45-1.94c1.4-.556 2.69-.37 3.43.648 1.02 1.4 2.04 2.13 4.17 2.69 1.3-.556 1.76-.926 3.43-1.4 1.48-1.67 2.69-1.85 2.69-1.85s-.834.74-.926 1.58c.834-.648 1.76-1.2 1.76-1.2s-.37.46-.648 1.11l.93.09c1.02-.556 2.13-1.02 2.13-1.02s-.37.37-.74.93c.74 0 2.22 0 2.78.09 3.43.093 4.17-3.61 5.47-4.17 1.67-.556 2.41-.926 5.19 1.85 2.41 2.41 4.26 6.58 3.34 7.5-.74.74-2.32-.278-4.08-2.41-.926-1.11-1.57-2.5-1.94-4.17-.185-1.4-1.2-2.22-1.2-2.22s.648 1.4.65 2.59c0 .648.09 3.06 1.11 4.45-.93.19-.185 1.02-.278 1.11-1.2-1.48-3.9-2.5-4.26-2.87 1.48 1.2 4.82 3.9 6.11 6.48 1.2 2.5.46 4.72 1.11 5.28.19.185 2.59 3.15 3.06 4.72.834 2.69.093 5.47-1.02 7.13l-2.96.463a3.92 3.92 0 0 1-1.11-.371c.185-.37.65-1.3.648-1.48l-.185-.278c-.926 1.3-2.5 2.59-3.8 3.34-1.67.926-3.61.834-4.9.37-3.61-1.11-7.04-3.52-7.78-4.17 0 0 0 .463.09.648a28.07 28.07 0 0 0 5 4.17l-4.26.46 2.04 15.75c-.926.09-1.2.19-2.04.37-.834-3.06-2.5-5-4.35-6.21-1.57-1.02-3.8-1.3-5.93-.834l-.93.19c1.48-.185 3.24.093 5 1.2s3.15 3.98 3.71 5.65c.648 2.22 1.11 4.54-.648 7.04-1.3 1.76-5 2.78-7.97.648.83 1.3 1.85 2.32 3.34 2.5 2.13.28 4.17-.093 5.65-1.48 1.2-1.2 1.85-3.8 1.67-6.58l1.95-.278.65 4.9L62.06 56.7l-2.78-25.19-1.57.278L54.56 0 1.94 6.11l6.48 52.43z' />
        <path d='M39.67 30.06c1.4 1.02 2.59 1.67 3.8 1.58.74-.093 1.48-1.3 1.95-2.41.37-.74.37-1.57-.185-1.85-.278-.093-1.4-.093-2.22 0-1.57.185-3.15.74-3.52 1.02-.556.37-.278 1.3.185 1.67m.37-10.84v.093l.93.19c.37.74.74 1.48 1.48 1.85.185 0 .37-.93.56-.93.65 0 1.2.09 1.3.185v-.556c-.093-.926.19-2.59-1.67-3.52-.74-.37-1.67-.185-2.04.185h.185c.463.19.185.37.09.556-.093.37-.185.46 0 1.11' />
        <path d='M31.7 19.41c.463-.37-2.13-.926-4.17.37-1.48 1.02-1.48 3.15-.093 4.35a1.27 1.27 0 0 1 .37.28c.37-.185.93-.37 1.4-.556.93-.278 1.67-.463 2.32-.556.28-.37.65-.926.56-1.94-.093-1.4-1.2-1.11-.37-1.94m15.1 22.5l-4.45 7.4-5.19-1.57-4.54 6.95.185 2.22 24.83-4.54-1.48-15.47-4.08 8.52z' />
      </g>
    </svg>
  )
}

export function DaytonaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 69 73' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='3.63965' y='49.2356' width='24.9293' height='8.54716' fill='currentColor' />
      <rect x='37.1162' y='19.3206' width='28.4906' height='8.54716' fill='currentColor' />
      <rect
        width='29.9151'
        height='8.54717'
        transform='matrix(0.71 -0.71 0.71 0.71 22.16 21.95)'
        fill='currentColor'
      />
      <rect
        width='22.9746'
        height='8.54717'
        transform='matrix(-0.71 -0.71 -0.71 0.71 22.29 43.32)'
        fill='currentColor'
      />
      <rect
        width='24.217'
        height='8.54717'
        transform='matrix(-0.71 0.71 -0.71 -0.71 43.66 55.28)'
        fill='currentColor'
      />
      <rect
        width='27.066'
        height='8.54717'
        transform='matrix(0.71 0.71 0.71 -0.71 43.53 33.91)'
        fill='currentColor'
      />
      <rect
        x='22.1582'
        y='12.9094'
        width='20.6556'
        height='8.54718'
        transform='rotate(90 22.16 12.91)'
        fill='currentColor'
      />
      <rect
        x='52.0732'
        y='42.825'
        width='25.6415'
        height='8.54718'
        transform='rotate(90 52.07 42.83)'
        fill='currentColor'
      />
    </svg>
  )
}

export function MicrosoftDataverseIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clip0 = `dataverse_clip0_${id}`
  const clip1 = `dataverse_clip1_${id}`
  const clip2 = `dataverse_clip2_${id}`
  const paint0 = `dataverse_paint0_${id}`
  const paint1 = `dataverse_paint1_${id}`
  const paint2 = `dataverse_paint2_${id}`
  const paint3 = `dataverse_paint3_${id}`
  const paint4 = `dataverse_paint4_${id}`
  const paint5 = `dataverse_paint5_${id}`
  const paint6 = `dataverse_paint6_${id}`
  return (
    <svg
      {...props}
      width='96'
      height='96'
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath={`url(#${clip0})`}>
        <g clipPath={`url(#${clip1})`}>
          <g clipPath={`url(#${clip2})`}>
            <path
              d='M13.88 21.82C29.1 8.14 49.75 8.19 62.96 18.91C74.98 28.68 77.47 44.32 70.85 55.78C64.23 67.24 52.53 70.15 39.5 62.62L31.73 76.09L31.72 76.09C27.42 83.53 17.89 86.08 10.44 81.78C7.45 80.06 5.25 77.49 3.97 74.55L3.96 74.55C-4.08 55.78 0.2 34.12 13.88 21.82Z'
              fill={`url(#${paint0})`}
            />
            <path
              d='M13.88 21.82C29.1 8.14 49.75 8.19 62.96 18.91C74.98 28.68 77.47 44.32 70.85 55.78C64.23 67.24 52.53 70.15 39.5 62.62L31.73 76.09L31.72 76.09C27.42 83.53 17.89 86.08 10.44 81.78C7.45 80.06 5.25 77.49 3.97 74.55L3.96 74.55C-4.08 55.78 0.2 34.12 13.88 21.82Z'
              fill={`url(#${paint1})`}
              fillOpacity='0.8'
            />
            <path
              d='M85.43 14.22C88.45 15.97 90.67 18.57 91.95 21.54L91.95 21.54C99.94 40.29 95.65 61.91 82 74.18C66.77 87.87 46.13 87.82 32.92 77.09C20.89 67.32 18.41 51.69 25.02 40.23C31.64 28.76 43.35 25.86 56.37 33.38L64.14 19.93L64.15 19.92C68.45 12.47 77.98 9.92 85.43 14.22Z'
              fill={`url(#${paint2})`}
            />
            <path
              d='M85.43 14.22C88.45 15.97 90.67 18.57 91.95 21.54L91.95 21.54C99.94 40.29 95.65 61.91 82 74.18C66.77 87.87 46.13 87.82 32.92 77.09C20.89 67.32 18.41 51.69 25.02 40.23C31.64 28.76 43.35 25.86 56.37 33.38L64.14 19.93L64.15 19.92C68.45 12.47 77.98 9.92 85.43 14.22Z'
              fill={`url(#${paint3})`}
              fillOpacity='0.9'
            />
            <path
              d='M39.5 62.63C52.53 70.15 64.24 67.25 70.85 55.78C77.25 44.71 75.14 29.74 64.15 19.93L56.38 33.38L39.5 62.63Z'
              fill={`url(#${paint4})`}
            />
            <path
              d='M56.38 33.38C43.35 25.86 31.65 28.76 25.03 40.23C18.63 51.3 20.74 66.27 31.74 76.08L39.5 62.63L56.38 33.38Z'
              fill={`url(#${paint5})`}
            />
            <path
              d='M33.32 56.45C37.98 64.52 48.31 67.29 56.38 62.63C64.46 57.96 67.23 47.64 62.56 39.56C57.9 31.49 47.58 28.72 39.5 33.38C31.43 38.04 28.66 48.37 33.32 56.45Z'
              fill={`url(#${paint6})`}
            />
          </g>
        </g>
      </g>
      <defs>
        <radialGradient
          id={paint0}
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(46 49.5) rotate(-148.72) scale(46.22 47.54)'
        >
          <stop offset='0.47' stopColor='#09442A' />
          <stop offset='0.7' stopColor='#136C6C' />
          <stop offset='1' stopColor='#22918B' />
        </radialGradient>
        <radialGradient
          id={paint1}
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(50 32.5) rotate(123.57) scale(66.01 46.55)'
        >
          <stop offset='0.72' stopColor='#1A7F7C' stopOpacity='0' />
          <stop offset='1' stopColor='#16BBDA' />
        </radialGradient>
        <radialGradient
          id={paint2}
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(50.5 44.5) rotate(30.75) scale(45.96 44.51)'
        >
          <stop offset='0.36' stopColor='#136C6C' />
          <stop offset='0.79' stopColor='#42B870' />
          <stop offset='1' stopColor='#76D45E' />
        </radialGradient>
        <radialGradient
          id={paint3}
          cx='0'
          cy='0'
          r='1'
          gradientTransform='matrix(42.5 -36 31.18 36.81 49.5 55.5)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.58' stopColor='#76D45E' stopOpacity='0' />
          <stop offset='1' stopColor='#C8F5B7' />
        </radialGradient>
        <radialGradient
          id={paint4}
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(47.5 48) rotate(-58.9) scale(32.69)'
        >
          <stop offset='0.49' stopColor='#22918B' />
          <stop offset='0.73' stopColor='#42B870' />
          <stop offset='1' stopColor='#43E5CA' />
        </radialGradient>
        <radialGradient
          id={paint5}
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(47.38 49.01) rotate(119.86) scale(31.13 29.4)'
        >
          <stop offset='0.46' stopColor='#08494E' />
          <stop offset='0.74' stopColor='#1A7F7C' />
          <stop offset='1' stopColor='#309C61' />
        </radialGradient>
        <radialGradient
          id={paint6}
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(52.5 40) rotate(120.78) scale(27.35)'
        >
          <stop stopColor='#C8F5B7' />
          <stop offset='0.25' stopColor='#98F0B0' />
          <stop offset='0.64' stopColor='#52D17C' />
          <stop offset='1' stopColor='#119FC5' />
        </radialGradient>
        <clipPath id={clip0}>
          <rect width='96' height='96' fill='white' />
        </clipPath>
        <clipPath id={clip1}>
          <rect width='96' height='96' fill='white' />
        </clipPath>
        <clipPath id={clip2}>
          <rect width='96' height='96' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function KalshiIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 78 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path d='M40.1 0H36.03V20H40.1V0Z' />
      <path d='M0.42 0.02H4.74V8.99L12.82 0.02H18.06L10.65 8.25L18.54 20H13.36L7.6 11.57L4.74 14.75V20H0.42V0.02Z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M34.47 19.81H32.4C30.54 19.81 29.62 19 29.67 17.4C29.12 18.23 28.45 18.88 27.68 19.31C26.89 19.75 25.95 19.98 24.82 19.98C23.17 19.98 21.84 19.6 20.81 18.86C19.81 18.09 19.31 17.03 19.31 15.66C19.31 14.1 19.9 12.9 21.04 12.07C22.21 11.21 23.9 10.78 26.12 10.78H29.06V10.07C29.06 9.41 28.81 8.89 28.31 8.49C27.81 8.1 27.14 7.89 26.28 7.89C25.53 7.89 24.93 8.06 24.45 8.37C23.97 8.7 23.67 9.14 23.59 9.68H19.64C19.77 8.18 20.46 7.02 21.67 6.19C22.88 5.36 24.49 4.92 26.49 4.92C28.58 4.92 30.21 5.38 31.34 6.29C32.48 7.21 33.07 8.54 33.07 10.26V15.43C33.07 15.78 33.15 16.03 33.3 16.18C33.44 16.3 33.7 16.39 34.03 16.39H34.47V19.81ZM26.07 13.46C25.24 13.46 24.57 13.62 24.09 13.98C23.63 14.31 23.4 14.77 23.4 15.37C23.4 15.89 23.59 16.28 23.99 16.59C24.38 16.9 24.93 17.05 25.59 17.05C26.66 17.05 27.49 16.76 28.1 16.16C28.71 15.55 29.04 14.74 29.06 13.73V13.46H26.07Z'
      />
      <path d='M45.51 14.93C45.57 15.58 45.89 16.09 46.47 16.51C47.06 16.9 47.79 17.11 48.68 17.11C49.54 17.11 50.23 16.99 50.73 16.72C51.23 16.43 51.48 16.03 51.48 15.51C51.48 15.14 51.36 14.85 51.13 14.66C50.9 14.47 50.56 14.33 50.15 14.27C49.73 14.16 49.04 14.06 48.08 13.96C46.76 13.79 45.68 13.56 44.82 13.29C43.97 13.02 43.26 12.61 42.76 12.02C42.23 11.44 41.98 10.69 41.98 9.74C41.98 8.78 42.23 7.95 42.76 7.23C43.3 6.48 44.05 5.92 45.01 5.5C45.97 5.11 47.08 4.9 48.33 4.9C50.36 4.92 51.96 5.36 53.19 6.19C54.45 7.02 55.12 8.18 55.22 9.68H51.36C51.29 9.12 51 8.68 50.46 8.33C49.94 7.97 49.27 7.79 48.43 7.79C47.66 7.79 47.04 7.93 46.56 8.22C46.1 8.51 45.87 8.89 45.87 9.37C45.87 9.72 45.99 9.97 46.24 10.13C46.49 10.3 46.83 10.43 47.22 10.51C47.62 10.59 48.31 10.67 49.25 10.76C51.25 10.99 52.78 11.42 53.82 12.04C54.91 12.65 55.43 13.71 55.43 15.22C55.43 16.18 55.14 17.01 54.57 17.74C54.01 18.46 53.24 19.02 52.21 19.42C51.21 19.79 50.04 20 48.73 20C46.68 20 44.99 19.54 43.72 18.65C42.42 17.74 41.75 16.49 41.67 14.93H45.51Z' />
      <path d='M69.75 6.73C68.62 5.67 67.2 5.13 65.45 5.13C63.63 5.13 62.17 5.79 61.07 7.12V0H56.99V20H61.07V12.46C61.07 11.19 61.34 10.22 61.92 9.51C62.51 8.81 63.32 8.45 64.36 8.45C65.37 8.45 66.12 8.78 66.62 9.43C67.12 10.05 67.37 10.97 67.37 12.19V20H71.44V12.02C71.44 9.55 70.88 7.79 69.75 6.73Z' />
      <path d='M73.01 5.3H77.08V19.98H73.01V5.3Z' />
      <path d='M76.47 0.58C76.1 0.21 75.62 0 75.03 0C74.47 0 73.97 0.21 73.57 0.58C73.2 0.96 72.99 1.41 72.99 1.97C72.99 2.53 73.2 3.01 73.57 3.39C73.97 3.76 74.47 3.97 75.03 3.97C75.6 3.97 76.1 3.78 76.47 3.39C76.85 2.99 77.06 2.53 77.06 1.97C77.06 1.41 76.85 0.93 76.47 0.58Z' />
    </svg>
  )
}

export function KetchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 224 213' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='m133.1 43.92 28.76-29.48h-70.38l-77.79 78.08 77.64 76.26-30.05 29.13h70.98l77.64-77.58-76.8-76.41z'
        fill='currentColor'
      />
      <path d='m91.71 86.79v81.44l40.38-41.7v-82.02l-40.38 42.28z' fill='#9B5CFF' />
    </svg>
  )
}

export function PolymarketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='51 209 123 155'>
      <path
        fill='currentColor'
        d='M173.2,363.2L51.1,328.3v-83.7l122.1-34.9V363.2z M161.4,296.2l-89.8,25.6l89.8,25.6L161.4,296.2z M62.9,260.8v51.3l89.8-25.6L62.9,260.8z M161.4,225.3L71.6,251l89.8,25.6L161.4,225.3z'
      />
    </svg>
  )
}

export function GoogleGroupsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 950 950'>
      <path
        d='M0 0 C0.94 0.16 1.89 0.32 2.86 0.49 C41.4 7.38 77.61 23.6 108.36 47.75 C110.83 49.63 113.4 51.31 116 53 C116.46 52.57 116.93 52.15 117.4 51.71 C122.6 47.03 128.04 43.03 133.88 39.19 C134.79 38.58 135.71 37.97 136.66 37.35 C193.07 0.5 260.71 -11.47 326.56 2.19 C345.07 6.3 362.98 12.66 380 21 C380.84 21.41 381.68 21.82 382.55 22.25 C394.72 28.26 406.12 34.88 417 43 C417.91 43.68 417.91 43.68 418.85 44.38 C427.34 50.76 435.33 57.63 443 65 C443.89 65.85 443.89 65.85 444.8 66.72 C453.7 75.25 461.7 84.07 469 94 C469.43 94.57 469.85 95.14 470.29 95.73 C480.43 109.34 488.67 123.71 496 139 C496.45 139.92 496.9 140.84 497.36 141.79 C507.87 163.93 513.87 187.76 517 212 C517.17 213.28 517.34 214.55 517.52 215.87 C518.23 222.32 518.2 228.79 518.24 235.27 C518.24 236.28 518.24 236.28 518.25 237.31 C518.27 240.87 518.29 244.43 518.3 247.99 C518.31 251.63 518.34 255.28 518.38 258.92 C518.41 261.75 518.41 264.59 518.42 267.42 C518.43 269.41 518.45 271.39 518.48 273.38 C518.45 285.76 515.12 295.57 507 305 C499.87 312.03 489.29 317.89 479.06 318.03 C476.62 317.96 474.2 317.86 471.76 317.75 C470.83 317.71 469.89 317.67 468.92 317.63 C466.86 317.54 464.8 317.45 462.73 317.36 C458.16 317.16 453.58 316.97 449 316.78 C445.21 316.63 441.43 316.47 437.64 316.31 C398.91 314.7 360.18 313.33 321.43 312.45 C320.24 312.42 320.24 312.42 319.03 312.4 C302.6 312.03 286.17 311.68 269.74 311.37 C260.42 311.19 251.11 311 241.79 310.81 C240.95 310.8 240.11 310.78 239.24 310.76 C214.74 310.26 190.27 309.43 165.79 308.3 C125.9 306.45 86.04 305.18 46.1 305.15 C44.51 305.15 42.92 305.14 41.33 305.14 C-37.51 305.01 -103.97 308.91 -163.53 367.12 C-188.38 391.98 -210.6 420.04 -229.42 449.72 C-234.45 457.53 -238 461.22 -247.02 463.9 C-257.46 465.68 -265.75 464.63 -274.71 458.77 C-282.12 453.05 -286.55 446.3 -288 437 C-288.09 434.22 -288.14 431.46 -288.13 428.68 C-288.14 427.85 -288.14 427.01 -288.14 426.15 C-288.15 423.36 -288.15 420.56 -288.15 417.76 C-288.15 415.76 -288.15 413.75 -288.16 411.75 C-288.16 406.29 -288.17 400.84 -288.17 395.39 C-288.17 391.97 -288.17 388.56 -288.17 385.14 C-288.18 373.21 -288.19 361.27 -288.19 349.34 C-288.18 338.25 -288.2 327.17 -288.21 316.09 C-288.22 306.54 -288.23 297 -288.23 287.46 C-288.23 281.78 -288.23 276.09 -288.24 270.4 C-288.25 265.04 -288.25 259.67 -288.24 254.31 C-288.24 252.36 -288.25 250.4 -288.25 248.45 C-288.3 231.58 -287.44 214.67 -284.25 198.06 C-284.08 197.16 -283.91 196.26 -283.73 195.34 C-277.33 162.81 -264.84 129.81 -245 103 C-244.31 102.04 -243.62 101.08 -242.9 100.09 C-231.62 84.69 -218.86 69.07 -204 57 C-202.83 56.02 -201.66 55.03 -200.48 54.05 C-165.05 24.48 -123.48 6.45 -78 -1 C-77.21 -1.13 -76.42 -1.26 -75.61 -1.4 C-51.08 -5.27 -24.38 -4.17 0 0 Z '
        fill='#4185F3'
        transform='translate(394,440)'
      />
      <path
        d='M0 0 C0.84 0.41 1.68 0.82 2.55 1.25 C14.72 7.26 26.12 13.88 37 22 C37.91 22.68 37.91 22.68 38.85 23.38 C47.34 29.76 55.33 36.63 63 44 C63.59 44.57 64.19 45.13 64.8 45.72 C73.7 54.25 81.7 63.07 89 73 C89.64 73.86 89.64 73.86 90.29 74.73 C100.43 88.34 108.67 102.71 116 118 C116.67 119.38 116.67 119.38 117.36 120.79 C127.87 142.93 133.87 166.76 137 191 C137.17 192.28 137.34 193.55 137.52 194.87 C138.23 201.32 138.2 207.79 138.24 214.27 C138.24 215.28 138.24 215.28 138.25 216.31 C138.27 219.87 138.29 223.43 138.3 226.99 C138.31 230.63 138.34 234.28 138.38 237.92 C138.41 240.75 138.41 243.59 138.42 246.42 C138.43 248.41 138.45 250.39 138.48 252.38 C138.45 264.76 135.12 274.57 127 284 C118.58 292.31 107.26 297.13 95.43 297.12 C94.32 297.13 93.21 297.13 92.06 297.13 C90.84 297.13 89.62 297.12 88.36 297.12 C86.42 297.12 86.42 297.12 84.43 297.12 C80.83 297.13 77.22 297.12 73.62 297.12 C69.73 297.11 65.85 297.11 61.96 297.11 C55.23 297.11 48.5 297.11 41.76 297.11 C32.03 297.1 22.3 297.09 12.56 297.09 C-3.23 297.09 -19.02 297.08 -34.81 297.08 C-50.16 297.07 -65.5 297.06 -80.84 297.05 C-81.78 297.05 -82.73 297.05 -83.7 297.05 C-88.45 297.05 -93.19 297.05 -97.93 297.05 C-137.29 297.04 -176.64 297.02 -216 297 C-216 296.67 -216 296.34 -216 296 C-215.11 295.78 -214.21 295.56 -213.29 295.34 C-199.61 291.75 -190.3 286.45 -182.34 274.51 C-175.87 262.19 -177.25 248.41 -177.47 234.87 C-177.51 232.14 -177.52 229.42 -177.53 226.69 C-177.59 206.54 -178.59 187.22 -183.19 167.56 C-183.34 166.9 -183.49 166.24 -183.65 165.56 C-193.06 125.06 -212.75 88.11 -240.78 57.45 C-242.91 55.1 -244.99 52.71 -247.06 50.31 C-250.75 46.16 -254.73 42.54 -259 39 C-259.91 38.24 -259.91 38.24 -260.84 37.46 C-262.22 36.3 -263.61 35.15 -265 34 C-261.24 29.06 -257.23 25.68 -252.12 22.19 C-251.38 21.67 -250.63 21.15 -249.85 20.61 C-242.76 15.74 -235.49 11.23 -228 7 C-227.35 6.63 -226.69 6.26 -226.02 5.87 C-214.75 -0.49 -203.12 -5.49 -191 -10 C-189.78 -10.46 -188.57 -10.92 -187.31 -11.4 C-127.13 -32.87 -57.15 -28 0 0 Z '
        fill='#4185F3'
        transform='translate(774,461)'
      />
      <path
        d='M0 0 C2.51 2.22 4.94 4.5 7.35 6.81 C8.23 7.62 9.12 8.43 10.03 9.26 C26.83 25.16 37.11 45.77 43.35 67.81 C43.69 68.99 44.03 70.17 44.39 71.38 C50.59 97.64 47.12 127.31 36.35 151.81 C35.93 152.79 35.93 152.79 35.49 153.79 C25.53 176.37 8.35 195.89 -12.65 208.81 C-13.55 209.41 -14.45 210.01 -15.38 210.63 C-42.35 227.69 -77.57 232.41 -108.65 226.19 C-132.14 220.89 -153.29 209.45 -170.65 192.81 C-171.53 192 -172.41 191.2 -173.32 190.36 C-190.13 174.46 -200.41 153.86 -206.65 131.81 C-206.99 130.63 -207.33 129.46 -207.68 128.24 C-213.89 101.98 -210.42 72.32 -199.65 47.81 C-199.37 47.16 -199.08 46.5 -198.79 45.83 C-188.82 23.25 -171.65 3.74 -150.65 -9.19 C-149.29 -10.08 -149.29 -10.08 -147.91 -11 C-102.93 -39.46 -40.5 -33.45 0 0 Z '
        fill='#4285F4'
        transform='translate(753.65,172.19)'
      />
      <path
        d='M0 0 C2.51 2.22 4.94 4.5 7.35 6.81 C8.23 7.62 9.12 8.43 10.03 9.26 C26.83 25.16 37.11 45.77 43.35 67.81 C43.69 68.99 44.03 70.17 44.39 71.38 C50.59 97.64 47.12 127.31 36.35 151.81 C35.93 152.79 35.93 152.79 35.49 153.79 C25.53 176.37 8.35 195.89 -12.65 208.81 C-13.55 209.41 -14.45 210.01 -15.38 210.63 C-42.35 227.69 -77.57 232.41 -108.65 226.19 C-132.14 220.89 -153.29 209.45 -170.65 192.81 C-171.53 192 -172.41 191.2 -173.32 190.36 C-190.13 174.46 -200.41 153.86 -206.65 131.81 C-206.99 130.63 -207.33 129.46 -207.68 128.24 C-213.89 101.98 -210.42 72.32 -199.65 47.81 C-199.37 47.16 -199.08 46.5 -198.79 45.83 C-188.82 23.25 -171.65 3.74 -150.65 -9.19 C-149.29 -10.08 -149.29 -10.08 -147.91 -11 C-102.93 -39.46 -40.5 -33.45 0 0 Z '
        fill='#4285F4'
        transform='translate(433.65,172.19)'
      />
      <path
        d='M0 0 C3.82 1.3 6.07 2.75 8.81 5.69 C11.42 8.41 14.05 10.95 16.94 13.38 C52 43.74 74.27 91.46 84.38 135.81 C84.61 136.85 84.85 137.88 85.1 138.95 C89.07 157.38 89.43 175.94 89.48 194.73 C89.49 197.46 89.52 200.19 89.56 202.93 C90.07 234.51 90.07 234.51 78.75 248.5 C67.1 260.32 52.91 263.39 36.86 263.53 C33.85 263.53 30.84 263.51 27.84 263.5 C25.71 263.5 23.58 263.5 21.46 263.5 C17.03 263.5 12.59 263.49 8.16 263.47 C2.51 263.44 -3.15 263.44 -8.8 263.45 C-13.18 263.46 -17.56 263.45 -21.94 263.44 C-24.03 263.44 -26.11 263.44 -28.2 263.44 C-45.28 263.46 -61.11 262.68 -74.25 250.44 C-84.29 239.84 -87.3 227.81 -87.34 213.64 C-87.34 212.56 -87.35 211.47 -87.36 210.35 C-87.38 206.84 -87.38 203.32 -87.37 199.81 C-87.38 198.62 -87.38 197.43 -87.38 196.2 C-87.36 178.1 -86.46 160.8 -83 143 C-82.75 141.55 -82.51 140.1 -82.28 138.64 C-78.04 114.58 -68.49 91.45 -57 70 C-56.39 68.85 -55.78 67.69 -55.14 66.5 C-47.06 51.82 -37.09 38.53 -26 26 C-25.23 25.12 -24.46 24.24 -23.66 23.33 C-16.3 15 -8.58 7.08 0 0 Z '
        fill='#1967D2'
        transform='translate(508,495)'
      />
    </svg>
  )
}

/**
 * Google Chat product mark: a hollow four-colour speech bubble with a chamfered
 * upper-right corner, traced from the official 2023 icon
 * (https://commons.wikimedia.org/wiki/File:Google_Chat_icon_(2023).svg) and
 * using the shared Google Workspace two-tone palette the other Google marks in
 * this file already carry.
 */
export function GoogleChatIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 311 320'>
      <path
        fill='#0066da'
        d='M76.37 0.51L76.38 76.98L0 76.96L0 20.77Q0.85 14.81 3.53 10.76Q10.14 0.74 22.75 0.67Q49.41 0.53 76.37 0.51Z'
      />
      <path
        fill='#fbbc04'
        d='M76.37 0.51L233.79 0.53A1.61 1.57 -26.7 0 1 234.71 0.82L235.08 1.09Q234.92 1.15 234.81 1.22Q234.64 1.31 234.64 1.5L234.62 77.01Q234.6 77.01 234.57 77.01L76.41 77.01Q76.4 77 76.38 76.98L76.37 0.51Z'
      />
      <path
        fill='#ea4335'
        d='M235.08 1.09L310.53 76.77L234.62 77.01L234.64 1.5Q234.64 1.31 234.81 1.22Q234.92 1.15 235.08 1.09Z'
      />
      <path
        fill='#2684fc'
        d='M0 76.96L76.38 76.98Q76.4 77 76.41 77.01L76.43 182.69L0 182.67L0 76.96Z'
      />
      <path
        fill='#00ac47'
        d='M310.53 76.77L311 77.11L311 239.01Q308.34 253.54 295.94 257.78Q291.52 259.3 282.91 259.28Q227.02 259.19 169.99 259.11Q161.71 259.1 153.19 259.23Q152.72 259.24 152.39 259.57Q124.49 287.34 96.39 315.59C93.52 318.48 90.27 320.09 86.15 319.48Q80.39 318.63 77.66 313.54Q76.51 311.38 76.49 305.66Q76.42 282.47 76.44 259.13L76.43 220.85L114.21 183.07A1.79 1.77 22.3 0 1 115.47 182.55L233.77 182.59A0.83 0.83 0 0 0 234.6 181.76L234.57 77.01Q234.6 77.01 234.62 77.01L310.53 76.77Z'
      />
      <path
        fill='#00832d'
        d='M76.43 182.69L76.43 220.85L76.44 259.13Q52.47 259.27 28.91 259.22Q19.09 259.2 14.76 257.68Q2.62 253.44 0 238.88L0 182.67L76.43 182.69Z'
      />
    </svg>
  )
}

export function GoogleMeetIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 87.5 72'>
      <path fill='#00832d' d='M49.5 36l8.53 9.75 11.47 7.33 2-17.02-2-16.64-11.69 6.44z' />
      <path fill='#0066da' d='M0 51.5V66c0 3.32 2.69 6 6 6h14.5l3-10.96-3-9.54-9.95-3z' />
      <path fill='#e94235' d='M20.5 0L0 20.5l10.55 3 9.95-3 2.95-9.41z' />
      <path fill='#2684fc' d='M20.5 20.5H0v31h20.5z' />
      <path
        fill='#00ac47'
        d='M82.6 8.68L69.5 19.42v33.66l13.16 10.79c1.97 1.54 4.85.14 4.85-2.37V11c0-2.53-2.94-3.92-4.91-2.32zM49.5 36v15.5h-29V72h43c3.32 0 6-2.68 6-6V53.08z'
      />
      <path fill='#ffba00' d='M63.5 0h-43v20.5h29V36l20-16.57V6c0-3.31-2.68-6-6-6z' />
    </svg>
  )
}

export function CursorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 546 546' fill='currentColor'>
      <path d='m466.38 137.07-206.47-119.2c-6.63-3.83-14.81-3.83-21.44 0l-206.46 119.2c-5.57 3.22-9.01 9.17-9.01 15.62v240.38c0 6.44 3.44 12.4 9.01 15.62l206.47 119.2c6.63 3.83 14.81 3.83 21.44 0l206.47-119.2c5.57-3.22 9.02-9.17 9.02-15.61v-240.37c0-6.44-3.44-12.4-9.01-15.61zm-12.97 25.25-199.32 345.22c-1.35 2.33-4.9 1.38-4.9-1.32v-226.05c0-4.52-2.41-8.69-6.33-10.96l-195.76-113.02c-2.33-1.35-1.38-4.9 1.32-4.9h398.63c5.66 0 9.2 6.14 6.37 11.04h-.009z' />
    </svg>
  )
}

export function DubIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32 64c17.67 0 32-14.33 32-32 0-11.84-6.43-22.19-16-27.72V48h-8v-2.14A15.9 15.9 0 0 1 32 48c-8.84 0-16-7.16-16-16s7.16-16 16-16c2.91 0 5.65.78 8 2.14V1.01A32 32 0 0 0 32 0C14.33 0 0 14.33 0 32s14.33 32 32 32'
        fill='currentColor'
      />
    </svg>
  )
}

export function DowndetectorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 27 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(0, -1)' fillRule='nonzero'>
        <path
          d='M13.34,1 C6.76,1.01 1.27,6 0.64,12.55 L0.58,12.49 L0.58,13.77 L0.58,26.53 L13.34,26.53 C17.99,26.66 22.34,24.26 24.7,20.25 C27.06,16.25 27.06,11.28 24.7,7.28 C22.34,3.27 17.99,0.87 13.34,1 Z'
          fill='#FF160A'
        />
        <path
          d='M14,23.32 C12.98,23.52 11.92,23.52 10.9,23.32 C10.65,23.27 10.46,23.07 10.41,22.82 C10.2,21.8 10.2,20.74 10.41,19.72 C10.46,19.47 10.65,19.27 10.9,19.22 C11.92,19.02 12.98,19.02 14,19.22 C14.25,19.27 14.45,19.47 14.5,19.72 C14.71,20.74 14.71,21.8 14.5,22.82 C14.45,23.07 14.25,23.27 14,23.32 Z'
          fill='#FFFFFF'
        />
        <path
          d='M10.63,17 L9.87,5.66 C9.87,5.25 10.16,4.89 10.57,4.81 C11.84,4.58 13.15,4.58 14.42,4.81 C14.82,4.89 15.11,5.25 15.12,5.66 L14.36,17 C14.35,17.32 14.09,17.58 13.77,17.59 C12.93,17.74 12.06,17.74 11.22,17.59 C10.89,17.59 10.63,17.33 10.63,17 Z'
          fill='#FFFFFF'
        />
      </g>
    </svg>
  )
}

export function DuckDuckGoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='-108 -108 216 216'>
      <circle r='108' fill='#d53' />
      <circle r='96' fill='none' stroke='#ffffff' strokeWidth={7} />
      <path
        d='M-32-55C-62-48-51-6-51-6l19 93 7 3M-39-73h-8l11 4s-11 0-11 7c24-1 35 5 35 5'
        fill='#ddd'
      />
      <path d='M25 95S1 57 1 32c0-47 31-7 31-44S1-58 1-58c-15-19-44-15-44-15l7 4s-7 2-9 4 19-3 28 5c-37 3-31 33-31 33l21 120' />
      <path d='M25-1l38-10c34 5-29 24-33 23C0 7 9 32 45 24s9 20-24 9C-26 20-1-3 25-1' fill='#fc0' />
      <path
        d='M15 78l2-3c22 8 23 11 22-9s0-20-23-3c0-5-13-3-15 0-21-9-23-12-22 2 2 29 1 24 21 14'
        fill='#6b5'
      />
      <path d='M-1 67v12c1 2 17 2 17-2s-8 3-13 1-2-13-2-13' fill='#4a4' />
      <path
        d='M-23-32c-5-6-18-1-15 7 1-4 8-10 15-7m32 0c1-6 11-7 14-1-4-2-10-2-14 1m-33 16a2 2 0 1 1 0 1m-8 3a7 7 0 1 0 0-1m52-6a2 2 0 1 1 0 1m-6 3a6 6 0 1 0 0-1'
        fill='#148'
      />
    </svg>
  )
}

export function RssIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 11C6.39 11 8.68 11.95 10.36 13.64C12.05 15.32 13 17.61 13 20'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 4C8.24 4 12.31 5.69 15.31 8.69C18.31 11.69 20 15.76 20 20'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='5' cy='19' r='1' fill='currentColor' />
    </svg>
  )
}

export function SpotifyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 496 512'>
      <path
        fill='#1ed760'
        d='M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8Z'
      />
      <path d='M406.6 231.1c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3zm-31 76.2c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm-26.9 65.6c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4z' />
    </svg>
  )
}

export function GrainIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 34 34' fill='none'>
      <path
        fill='#00B96C'
        d='M13.8.4a5.91 5.91 0 0 1 4.28 0c1.55.601 3.07 1.3 4.57 2.1.311.17.263.63-.7.74C14.38 6.11 8.51 13.91 8.51 23.08c0 2.86.57 5.58 1.6 8.06.146.35-.221.71-.558.53a42.26 42.26 0 0 1-6.92-4.52 5.91 5.91 0 0 1-2.14-3.7A42.26 42.26 0 0 1 0 17c0-2.19.168-4.35.492-6.45a5.91 5.91 0 0 1 2.14-3.7 42.26 42.26 0 0 1 5.34-3.65A42.26 42.26 0 0 1 13.8.4z'
      />
      <path
        fill='#00B96C'
        d='M29.24 6.85a42.39 42.39 0 0 0-.58-.458 1.85 1.85 0 0 0-1.46-.365c-8.9 1.63-15.65 9.42-15.65 18.79 0 2.91.651 5.67 1.82 8.14.18.38.514.67.913.81a5.91 5.91 0 0 0 3.79-.165c1.98-.77 3.93-1.7 5.83-2.8a42.26 42.26 0 0 0 5.34-3.65 5.91 5.91 0 0 0 2.14-3.7c.324-2.1.492-4.25.492-6.45 0-2.19-.168-4.35-.492-6.45a5.91 5.91 0 0 0-2.14-3.7z'
      />
    </svg>
  )
}

export function GranolaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='34.168 33.75 1239.909 1282.5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='currentColor'
        d='M1033.77,1021.55c-21.6,24.24 -40.11,38.92 -50.31,45.93 c-4.8,3.19 -7.8,7.65 -11.99,11.48 c-22.2,19.14 -46.26,24.83 -63.06,38.23 c-22.8,17.86 -107.98,39.1 -132.18,46.54 c-40.96,9.31 -87.03,12.67 -137.43,10.75c-10.91,0 -20.99 0 -30.26 -0.73 c-3.76 -0.29 -7.54,0.68 -11.31,0.72c-0.15,0 -0.29,0 -0.42,0 c-0.4,0 -1.07 -0.29 -2.01 -0.86c-1.06 -0.65 -2.26 -1.06 -3.51 -1.06 c-0.33,0 -0.65 -0.03 -0.97 -0.07c-5.08 -0.7 -7.78,1.09 -9.73,2.08 c-1.48,0.75 -3.09,0.12 -4.49 -0.77c-4.43 -2.81 -14.32 -9.14 -17.68 -10.16 c-3.32 -1.01 -3.64,0.37 -5.41,0.68c-1.18,0.21 -2.41 -0.21 -3.3 -1.01 c-0.99 -0.9 -2.06 -2.2 -4.5 -3.5c-4.49 -2.39 -6.88,3.04 -13.55 -3.03 c-0.97 -0.88 -1.54 -2.61 -2.85 -2.7c-0.33 -0.02 -0.56 -0.04 -0.89 -0.1 c-6.72 -1.3 -18.92 -3.8 -27.12 -6.29c-9.6 -2.55 -6.61 -4.46 -10.81 -6.37 c-56.4 -21.05 -136.79 -62.52 -166.19 -91.86 c-10.8 -10.84 -23.4 -35.72 -31.2 -42.1 c-6 -5.1 -18 -15.31 -21 -20.41c-2.4 -4.47 0 -12.75 -4.2 -18.49 c-5.4 -7.02 -16.2 -10.85 -26.4 -26.79 c-11.4 -17.86 -18 -41.46 -29.4 -65.7 C202,854.91,175,786.02,175,660.36c0 -84.2,39 -200.93,55.8 -216.88 c10.8 -10.21,9.6 -32.53,17.39 -43.37 c89.01 -123.75,244.8 -214.79,430.2 -224.35 c7.53 -0.39,15.07 -0.63,22.62 -0.72c45.74 -0.53,91.58,4.47,136.04,15.31 c44.41,10.83,86.87,27.73,128.26,46.95c0,0,4.91,0.39,6.21,1.03 c2.16,1.06,3.07,2.99,5.23,4.06c2.16,1.06,5.28,0.16,7.64,0.64 c7.77,1.59,9.17,6.21,10.6,8.05c1.74,2.23,3.83,3.09,7.78,4.22 c10.31,2.96,11.67,6.37,13.07,7.94c1.12,1.25,1.61,2.88,2.17,4.34 c0.57,1.48,1.7,2.84,3.28,3.21c3.42,0.8,8.06,4.98,9.02,10.69 c0.63,3.72,4.65,5.32,3.55,12.3c-0.36,2.26,2.05,5.6 -10.6,18.07 s-39.18,20.33 -55.34,14.14c-55.85 -21.41 -64.13 -25.53 -86.57 -31.65 c-40.96 -11.17 -75.85 -18.76 -118.36 -17.96 c-67.8,1.28 -121.21,7.66 -185.41,29.98 c-28.14,9.97 -81.27,37.11 -107.93,58.24 c-26.66,21.13 -65.26,50.32 -81.19,77.33 c-5.58,9.46 -11.86,18.5 -25.06,33.17 c-19.2,21.05 -41.42,81.93 -48.62,111.28 c-1.8,6.38,2.99,13.4,0.59,19.78c-2.4,7.02 -13.8,10.21 -15,15.95 c-4.8,20.41 -3.6,46.56 -3.6,68.88c0,12.12,3.6,28.7,7.8,38.27 c3,6.38,12.6,10.85,13.8,17.22c0.6,4.46 -5.39,9.56 -5.4,13.39 c0,3.19,5.39,46.57,8.39,52.95c4.2,7.65,17.4,17.22,21,26.15 c2.4,6.38 -4.21,12.76,0.59,19.14c3,3.83,12.61,3.82,16.21,8.92 c4.8,6.38,15,24.87,19.8,30.62c3.6,4.47,10.2,6.39,13.2,8.3 c9,6.38,1.2,12.11,9.6,21.68c26.4,29.98,67.2,66.98,106.2,83.57 c6.02,2.56,67.75,26.13,71.39,26.15 c87,12.83,184.84,11.63,269.44 -35.58 c19.8 -10.85,131.97 -88.81,150.57 -181.3 c4.2 -18.5,9.6 -63.16,7.2 -81.02 c-9.6 -66.34 -50.48 -161.76 -125.41 -197.09 c-39.91 -18.82 -70.2 -18.5 -78 -17.22 c-22.8,4.46 -30.6 -8.93 -51.6 -7.02 c-64.2,5.1 -127.2,22.97 -176.4,74.63 c-45,47.84 -54.01,109.08 -31.21,147.99 c2.4,5.1,1.2,11.48 -3.6,14.67c-2.1,1.28 -4.05,2.87 -4.95,4.55 c-1.79,3.33,3.39,5.11,6.95,6.36c24.96,8.73,33.96,50.84,67,49.06 h7.2c0,0,13.8 0,19.2 -6.38c4.44 -5.24,4.42 -11.35,1.27 -14.06 c-1.4 -1.21 -3.18 -1.93 -3.59 -3.74c-0.45 -1.99 -0.68 -4.61 -0.68 -5.79 c0 -1.28,1.8 -1.92,1.8 -3.2c0 -3.83 -4.2 -7.01 -3.6 -10.84 c0.38 -2.04,3.21 -4.85,5.21 -6.96c1.52 -1.6,1.54 -3.63,0.55 -5.6 c-0.04 -0.07 -0.07 -0.14 -0.11 -0.21c-0.96 -1.97 -1.14 -4.32 -0.49 -6.41 c0.38 -1.2,0.83 -2.49,0.83 -3.78c0.6 -5.74 -1.79 -8.29 -2.39 -12.76 c0 -1.58,8.54 -5.32,11.56 -7.66c0.89 -0.69,0.98 -1.84,0.69 -2.93 c-0.62 -2.32 -1.45 -3.03 -1.45 -7.27c0 -1.02,0.86 -2.44,1.89 -3.79 c2.08 -2.71,4 -5.6,4.94 -8.88l1.66 -5.79 c0.69 -2.42,2.53 -4.34,4.92 -5.15c4.13 -1.39,2.22 -8.13,6.16 -10.01 c1.15 -0.55,4.02,0.15,8.63 -0.83c9.59 -1.91,3 -5.1,4.8 -10.21 c0.84 -3.12,3.44 -2.81,5.96 -2.56c2.02,0.2,3.98 -0.46,5.43 -1.88 c1.43 -1.39,2.87 -3.02,4.81 -3.85c2.43 -1.03,8.81 -1.23,13.38 -1.27 c1.88 -0.02,3.74 -0.29,5.61 -0.51c5.1 -0.6,12.33 -0.24,15.82 -0.77 c4.2 -0.64,6.6 -4.47,10.19 -4.47c3,0,7.21,5.1,10.21,5.1 c3 0,6 -2.55,9 -2.55c1.8,0,2.4,3.19,5.4,3.19 h1.2c0,0,27.6,0.64,56.4,18.49c19.8,12.12,34.2,41.47,34.2,41.47 c13.8,23.6 -1.51,47.86 -1.51,69.55c0,8.93,3,16.58,1.2,24.88 c-1.2,6.38 -6,11.49 -7.8,16.59c-1.8,4.46 -1.79,10.21 -7.79,18.49 c-4.8,7.02 -7.21,7.01 -8.41,8.29c-1.8,1.91 -17.34,25.41 -27.54,34.34 c-27,24.24 -51.96,31.34 -88.56,31.97c-16.2,0.64 -18,3.83 -20.4,3.83 c-8.4,0.64 -46.79 -1.27 -58.8 -3.19c0,0 -53.4 -10.21 -74.4 -20.41 c-11.4 -5.1 -86.41 -60.6 -103.21 -91.86 c-52.2 -98.23 -40.2 -202.84,13.8 -273.01 c39 -51.03,103.2 -117.37,255.59 -130.13 c77.4 -6.38,146.41,3.83,200.41,29.35 c76.2,35.72,132,98.87,166.8,173.5 C1154.8,743.28,1151.37,887.6,1033.77,1021.55z'
      />
    </svg>
  )
}

export function CirclebackIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const patternId = `circleback_pattern_${id}`
  const imageId = `circleback_image_${id}`

  return (
    <svg
      {...props}
      width='280'
      height='280'
      viewBox='0 0 280 280'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <rect width='280' height='280' fill={`url(#${patternId})`} />
      <defs>
        <pattern id={patternId} patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use xlinkHref={`#${imageId}`} transform='scale(0.00357142857)' />
        </pattern>
        <image
          id={imageId}
          width='280'
          height='280'
          preserveAspectRatio='none'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  )
}

export function GreenhouseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 51.4 107.7' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M44.9,32c0,5.2-2.2,9.8-5.8,13.4c-4,4-9.8,5-9.8,8.4c0,4.6,7.4,3.2,14.5,10.3c4.7,4.7,7.6,10.9,7.6,18.1c0,14.2-11.4,25.5-25.7,25.5S0,96.4,0,82.2C0,75,2.9,68.8,7.6,64.1c7.1-7.1,14.5-5.7,14.5-10.3c0-3.4-5.8-4.4-9.8-8.4c-3.6-3.6-5.8-8.2-5.8-13.6C6.5,21.4,15,13,25.4,13c2,0,3.8,0.3,5.3,0.3c2.7,0,4.1-1.2,4.1-3.1c0-1.1-0.5-2.5-0.5-4c0-3.4,2.9-6.2,6.4-6.2S47,2.9,47,6.4c0,3.7-2.9,5.4-5.1,6.2c-1.8,0.6-3.2,1.4-3.2,3.2C38.7,19.2,44.9,22.5,44.9,32z M42.9,82.2c0-9.9-7.3-17.9-17.2-17.9s-17.2,8-17.2,17.9c0,9.8,7.3,17.9,17.2,17.9S42.9,92,42.9,82.2z M37,31.8c0-6.3-5.1-11.5-11.3-11.5s-11.3,5.2-11.3,11.5s5.1,11.5,11.3,11.5S37,38.1,37,31.8z'
        fill='currentColor'
      />
    </svg>
  )
}

export function GreptileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 367 420' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M240.27 49.82L166.8 115.96L115.97 159.44L181.34 220.59L249.78 162.05L196.78 112.47L253.07 61.79L362.61 164.25L178.74 321.49L3.15 157.24L187.01 0L240.27 49.82Z'
        fill='#5DE195'
      />
      <rect
        width='236.453'
        height='83.4566'
        transform='matrix(0.75 -0.66 0 1 188.02 336.54)'
        fill='#5DE195'
      />
      <rect
        width='236.453'
        height='83.4566'
        transform='matrix(0.73 0.68 0 1 0 174.96)'
        fill='#5DE195'
      />
    </svg>
  )
}

export function JiraServiceManagementIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='-290 -40 580 580'>
      <path
        d='M0 0 C5.33 1.52 8.71 5.03 12.63 8.75 C13.68 9.75 13.68 9.75 14.76 10.77 C40.22 35.34 57.41 71.1 58.2 106.71 C58.35 120.69 58.37 134.35 55 148 C54.83 148.69 54.67 149.39 54.5 150.1 C52.45 158.36 49.68 166.25 46.31 174.06 C46.03 174.72 45.76 175.38 45.47 176.06 C43.05 181.43 39.98 186.34 36.84 191.31 C36.38 192.05 35.91 192.79 35.43 193.55 C34.29 195.37 33.14 197.18 32 199 C32.58 199 33.16 199 33.76 199 C48.01 198.97 62.27 198.96 76.52 198.95 C83.41 198.94 90.31 198.94 97.2 198.92 C103.87 198.91 110.55 198.91 117.22 198.91 C119.74 198.9 122.27 198.9 124.79 198.89 C132.86 198.88 140.93 198.9 149 199 C150.12 199.01 151.25 199.03 152.41 199.04 C155.69 199.09 158.97 199.17 162.25 199.26 C163.22 199.27 164.19 199.28 165.19 199.3 C172.2 199.54 177.65 201.11 183.02 205.75 C183.47 206.3 183.92 206.86 184.38 207.44 C184.84 207.99 185.3 208.55 185.77 209.12 C188.35 213.06 189.31 216.63 189.38 221.31 C189.4 222.2 189.43 223.08 189.46 223.99 C188.21 232.17 182.59 238.48 177.63 244.81 C176.18 246.68 174.73 248.55 173.29 250.43 C172.57 251.36 171.84 252.3 171.1 253.26 C168.01 257.3 165 261.39 162 265.5 C156.41 273.13 150.71 280.66 144.96 288.16 C140.58 293.9 136.26 299.68 132 305.5 C126.41 313.13 120.71 320.66 114.96 328.16 C110.58 333.9 106.26 339.68 102 345.5 C97.07 352.22 92.07 358.88 87 365.5 C79.54 375.25 72.25 385.1 65 395 C57.09 405.8 49.1 416.53 40.96 427.16 C36.58 432.9 32.26 438.68 28 444.5 C22.42 452.12 16.72 459.64 10.98 467.14 C6.42 473.11 1.94 479.13 -2.5 485.19 C-7.19 491.59 -11.94 497.89 -17 504 C-39.32 493.95 -56.32 465.12 -65.06 443.35 C-79.14 405.76 -78.75 365.34 -62.24 328.62 C-58.2 320 -53.28 311.92 -48 304 C-54.08 303.87 -60.15 303.75 -66.23 303.63 C-68.54 303.59 -70.85 303.54 -73.15 303.49 C-89.22 303.17 -105.29 302.96 -121.36 302.84 C-124.26 302.82 -127.16 302.79 -130.05 302.77 C-131.01 302.76 -131.97 302.75 -132.96 302.74 C-134.89 302.73 -136.82 302.71 -138.76 302.69 C-144.53 302.65 -150.3 302.61 -156.07 302.58 C-159.72 302.56 -163.37 302.53 -167.02 302.5 C-168.74 302.48 -170.45 302.48 -172.16 302.47 C-174.53 302.47 -176.89 302.44 -179.26 302.42 C-179.94 302.42 -180.63 302.42 -181.34 302.43 C-188.62 302.3 -194.18 299.53 -199.49 294.65 C-203.94 289.79 -204.36 284.41 -204.59 278.14 C-203.01 269.79 -197.82 263.01 -192.56 256.56 C-191.31 254.99 -190.06 253.41 -188.81 251.84 C-188.17 251.04 -187.54 250.24 -186.89 249.41 C-183.88 245.57 -181 241.63 -178.12 237.69 C-173.16 230.9 -168.11 224.18 -163 217.5 C-157.93 210.88 -152.93 204.22 -148 197.5 C-143.07 190.78 -138.07 184.12 -133 177.5 C-125.54 167.75 -118.25 157.9 -111 148 C-103.09 137.2 -95.1 126.47 -86.96 115.84 C-82.58 110.1 -78.26 104.32 -74 98.5 C-68.41 90.87 -62.71 83.34 -56.96 75.84 C-52 69.34 -47.13 62.77 -42.3 56.18 C-37.86 50.12 -33.32 44.15 -28.75 38.19 C-23.47 31.29 -18.33 24.33 -13.32 17.24 C-3.37 3.37 -3.37 3.37 0 0 Z '
        fill='#156DE7'
      />
      <path
        d='M0 0 C5.33 1.52 8.71 5.03 12.63 8.75 C13.68 9.75 13.68 9.75 14.76 10.77 C40.22 35.34 57.41 71.1 58.2 106.71 C58.35 120.69 58.37 134.35 55 148 C54.83 148.69 54.67 149.39 54.5 150.1 C48.62 173.84 36.69 193.39 21.64 212.37 C17.99 216.98 14.48 221.69 11 226.44 C10.42 227.22 9.85 228.01 9.26 228.82 C8.09 230.41 6.92 232 5.76 233.6 C2.81 237.63 -0.16 241.66 -3.12 245.69 C-3.71 246.48 -4.29 247.27 -4.89 248.09 C-8.57 253.08 -12.27 258.05 -16 263 C-20.4 268.85 -24.78 274.73 -29.12 280.63 C-29.66 281.35 -30.2 282.08 -30.75 282.83 C-31.56 283.92 -31.56 283.92 -32.38 285.04 C-32.96 285.79 -33.55 286.55 -34.15 287.32 C-35.62 289.45 -36.71 291.38 -37.84 293.69 C-40.32 298.41 -42.85 303.02 -48.2 304.69 C-55.21 305.69 -62.29 304.94 -69.31 304.44 C-72.98 304.26 -76.64 304.1 -80.31 303.94 C-82.99 303.82 -85.68 303.7 -88.37 303.57 C-100.37 302.98 -112.35 302.83 -124.36 302.76 C-126.29 302.75 -128.23 302.74 -130.16 302.72 C-137.89 302.68 -145.61 302.63 -153.33 302.6 C-157.92 302.58 -162.51 302.54 -167.1 302.5 C-168.81 302.48 -170.52 302.47 -172.22 302.47 C-174.58 302.47 -176.94 302.44 -179.29 302.42 C-179.97 302.42 -180.65 302.42 -181.36 302.43 C-188.63 302.3 -194.19 299.52 -199.49 294.65 C-203.94 289.79 -204.36 284.41 -204.59 278.14 C-203.01 269.79 -197.82 263.01 -192.56 256.56 C-191.31 254.99 -190.06 253.41 -188.81 251.84 C-188.17 251.04 -187.54 250.24 -186.89 249.41 C-183.88 245.57 -181 241.63 -178.12 237.69 C-173.16 230.9 -168.11 224.18 -163 217.5 C-157.93 210.88 -152.93 204.22 -148 197.5 C-143.07 190.78 -138.07 184.12 -133 177.5 C-125.54 167.75 -118.25 157.9 -111 148 C-103.09 137.2 -95.1 126.47 -86.96 115.84 C-82.58 110.1 -78.26 104.32 -74 98.5 C-68.41 90.87 -62.71 83.34 -56.96 75.84 C-52 69.34 -47.13 62.77 -42.3 56.18 C-37.86 50.12 -33.32 44.15 -28.75 38.19 C-23.47 31.29 -18.33 24.33 -13.32 17.24 C-3.37 3.37 -3.37 3.37 0 0 Z '
        fill='#2684FE'
      />
    </svg>
  )
}

export function FlintIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='374 415 519 617' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M374 1004.46L679.798 1031.21V833.875L374 847.451V1004.46Z' fill='currentColor' />
      <path
        d='M374 567.086V676.084L803.573 606.042V764.423L892.518 750.061V415L374 567.086Z'
        fill='currentColor'
      />
      <path
        d='M374 831.711L695.54 817.349V894.67L787.634 891.719V624.536L374 692.217V831.711Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function FirefliesIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const g1 = `fireflies_g1_${id}`
  const g2 = `fireflies_g2_${id}`
  const g3 = `fireflies_g3_${id}`
  const g4 = `fireflies_g4_${id}`
  const g5 = `fireflies_g5_${id}`
  const g6 = `fireflies_g6_${id}`
  const g7 = `fireflies_g7_${id}`
  const g8 = `fireflies_g8_${id}`

  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='-6 -6 68 68'>
      <defs>
        <linearGradient
          id={g1}
          gradientUnits='userSpaceOnUse'
          x1='144.66'
          y1='-133.78'
          x2='54.38'
          y2='-38.92'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE2D7A' />
          <stop offset='0.3' stopColor='#C5388F' />
          <stop offset='0.54' stopColor='#9B4AB0' />
          <stop offset='0.82' stopColor='#6262DE' />
          <stop offset='0.99' stopColor='#3B73FF' />
        </linearGradient>
        <linearGradient
          id={g2}
          gradientUnits='userSpaceOnUse'
          x1='145.17'
          y1='-133.31'
          x2='54.88'
          y2='-38.45'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#FF3C82' />
          <stop offset='0.1' stopColor='#F53E88' />
          <stop offset='0.27' stopColor='#DC4598' />
          <stop offset='0.49' stopColor='#B251B2' />
          <stop offset='0.75' stopColor='#7961D7' />
          <stop offset='0.99' stopColor='#3B73FF' />
        </linearGradient>
        <linearGradient
          id={g3}
          gradientUnits='userSpaceOnUse'
          x1='144.76'
          y1='-123.2'
          x2='114.17'
          y2='-12.34'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE2D7A' />
          <stop offset='0.3' stopColor='#C5388F' />
          <stop offset='0.54' stopColor='#9B4AB0' />
          <stop offset='0.82' stopColor='#6262DE' />
          <stop offset='0.99' stopColor='#3B73FF' />
        </linearGradient>
        <linearGradient
          id={g4}
          gradientUnits='userSpaceOnUse'
          x1='134.82'
          y1='-132.33'
          x2='25.31'
          y2='-98.96'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE2D7A' />
          <stop offset='0.3' stopColor='#C5388F' />
          <stop offset='0.54' stopColor='#9B4AB0' />
          <stop offset='0.82' stopColor='#6262DE' />
          <stop offset='0.99' stopColor='#3B73FF' />
        </linearGradient>
        <linearGradient
          id={g5}
          gradientUnits='userSpaceOnUse'
          x1='82.21'
          y1='-52.79'
          x2='112.88'
          y2='-123.08'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE286E' />
          <stop offset='0.3' stopColor='#C52361' />
          <stop offset='0.54' stopColor='#9B1A4D' />
          <stop offset='0.83' stopColor='#620F30' />
          <stop offset='0.99' stopColor='#3D081E' />
        </linearGradient>
        <linearGradient
          id={g6}
          gradientUnits='userSpaceOnUse'
          x1='107.65'
          y1='-78.53'
          x2='138.33'
          y2='-148.82'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE286E' />
          <stop offset='0.3' stopColor='#C52361' />
          <stop offset='0.54' stopColor='#9B1A4D' />
          <stop offset='0.83' stopColor='#620F30' />
          <stop offset='0.99' stopColor='#3D081E' />
        </linearGradient>
        <linearGradient
          id={g7}
          gradientUnits='userSpaceOnUse'
          x1='70.83'
          y1='-99.32'
          x2='140.3'
          y2='-145.47'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE286E' />
          <stop offset='0.3' stopColor='#C52361' />
          <stop offset='0.54' stopColor='#9B1A4D' />
          <stop offset='0.83' stopColor='#620F30' />
          <stop offset='0.99' stopColor='#3D081E' />
        </linearGradient>
        <linearGradient
          id={g8}
          gradientUnits='userSpaceOnUse'
          x1='297.69'
          y1='-1360.89'
          x2='309.59'
          y2='-1454.88'
          gradientTransform='matrix(0.86 0 0 -0.86 -79.24 -68.17)'
        >
          <stop offset='0' stopColor='#E82A73' />
          <stop offset='0.11' stopColor='#DE286E' />
          <stop offset='0.3' stopColor='#C52361' />
          <stop offset='0.54' stopColor='#9B1A4D' />
          <stop offset='0.83' stopColor='#620F30' />
          <stop offset='0.99' stopColor='#3D081E' />
        </linearGradient>
      </defs>
      <g>
        <path fill={`url(#${g1})`} d='M18.4,0H0v18.3h18.4V0z' />
        <path fill={`url(#${g2})`} d='M40.2,22.1H21.8v18.3h18.4V22.1z' />
        <path
          fill={`url(#${g3})`}
          d='M40.2,0H21.8v18.3H56v-2.6c0-4.2-1.7-8.1-4.6-11.1C48.4,1.7,44.4,0,40.2,0L40.2,0z'
        />
        <path
          fill={`url(#${g4})`}
          d='M0,22.1v18.3c0,4.2,1.7,8.1,4.6,11.1c3,2.9,7,4.6,11.2,4.6h2.6V22.1H0z'
        />
        <path fill={`url(#${g5})`} opacity='0.18' d='M0,0l18.4,18.3H0V0z' />
        <path fill={`url(#${g6})`} opacity='0.18' d='M21.8,22.1l18.4,18.3H21.8V22.1z' />
        <path
          fill={`url(#${g7})`}
          opacity='0.18'
          d='M0,40.3c0,4.2,1.7,8.1,4.6,11.1c3,2.9,7,4.6,11.2,4.6h2.6V22.1L0,40.3z'
        />
        <path
          fill={`url(#${g8})`}
          opacity='0.18'
          d='M40.2,0c4.2,0,8.2,1.7,11.2,4.6c3,2.9,4.6,6.9,4.6,11.1v2.6H21.8L40.2,0z'
        />
      </g>
    </svg>
  )
}

export function BedrockIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `bedrock_gradient_${id}`

  return (
    <svg {...props} viewBox='0.29 0.03 23.67 23.94' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id={gradientId} x1='80%' x2='20%' y1='20%' y2='80%'>
          <stop offset='0%' stopColor='#6350FB' />
          <stop offset='50%' stopColor='#3D8FFF' />
          <stop offset='100%' stopColor='#9AD8F8' />
        </linearGradient>
      </defs>
      <path
        d='M13.05 15.513h3.08c.214 0 .389.177.389.394v1.82a1.704 1.704 0 011.296 1.661c0 .943-.755 1.708-1.685 1.708-.931 0-1.686-.765-1.686-1.708 0-.807.554-1.484 1.297-1.662v-1.425h-2.69v4.663a.395.395 0 01-.188.338l-2.69 1.641a.385.385 0 01-.405-.002l-4.926-3.086a.395.395 0 01-.185-.336V16.3L2.196 14.87A.395.395 0 012 14.555L2 14.528V9.406c0-.14.073-.27.192-.34l2.465-1.462V4.448c0-.129.062-.249.165-.322l.021-.014L9.77 1.058a.385.385 0 01.407 0l2.69 1.675a.395.395 0 01.185.336V7.6h3.856V5.683a1.704 1.704 0 01-1.296-1.662c0-.943.755-1.708 1.685-1.708.931 0 1.685.765 1.685 1.708 0 .807-.553 1.484-1.296 1.662v2.311a.391.391 0 01-.389.394h-4.245v1.806h6.624a1.69 1.69 0 011.64-1.313c.93 0 1.685.764 1.685 1.707 0 .943-.754 1.708-1.685 1.708a1.69 1.69 0 01-1.64-1.314H13.05v1.937h4.953l.915 1.18a1.66 1.66 0 01.84-.227c.931 0 1.685.764 1.685 1.707 0 .943-.754 1.708-1.685 1.708-.93 0-1.685-.765-1.685-1.708 0-.346.102-.668.276-.937l-.724-.935H13.05v1.806zM9.973 1.856L7.93 3.122V6.09h-.778V3.604L5.435 4.669v2.945l2.11 1.36L9.712 7.61V5.334h.778V7.83c0 .136-.07.263-.184.335L7.963 9.638v2.081l1.422 1.009-.446.646-1.406-.998-1.53 1.005-.423-.66 1.605-1.055v-1.99L5.038 8.29l-2.26 1.34v1.676l1.972-1.189.398.677-2.37 1.429V14.3l2.166 1.258 2.27-1.368.397.677-2.176 1.311V19.3l1.876 1.175 2.365-1.426.398.678-2.017 1.216 1.918 1.201 2.298-1.403v-5.78l-4.758 2.893-.4-.675 5.158-3.136V3.289L9.972 1.856zM16.13 18.47a.913.913 0 00-.908.92c0 .507.406.918.908.918a.913.913 0 00.907-.919.913.913 0 00-.907-.92zm3.63-3.81a.913.913 0 00-.908.92c0 .508.406.92.907.92a.913.913 0 00.908-.92.913.913 0 00-.908-.92zm1.555-4.99a.913.913 0 00-.908.92c0 .507.407.918.908.918a.913.913 0 00.907-.919.913.913 0 00-.907-.92zM17.296 3.1a.913.913 0 00-.907.92c0 .508.406.92.907.92a.913.913 0 00.908-.92.913.913 0 00-.908-.92z'
        fill={`url(#${gradientId})`}
        fillRule='nonzero'
      />
    </svg>
  )
}

export function ReductoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='400'
      height='400'
      viewBox='50 40 300 320'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M85.34 70.78H314.66V240.31L226.44 329.22H85.34V70.78ZM107.8 93.23H292.21V204.49H206.49V306.77H107.8L107.8 93.23Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function PulseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 6 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 6.64C0 6.29 0.28 6 0.64 6H1.54C1.89 6 2.18 6.29 2.18 6.64V7.54C2.18 7.89 1.89 8.18 1.54 8.18H0.64C0.28 8.18 0 7.89 0 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 6.64C3.11 6.29 3.4 6 3.75 6H4.65C5.01 6 5.29 6.29 5.29 6.64V7.54C5.29 7.89 5.01 8.18 4.65 8.18H3.75C3.4 8.18 3.11 7.89 3.11 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 6.64C6.23 6.29 6.51 6 6.86 6H7.77C8.12 6 8.4 6.29 8.4 6.64V7.54C8.4 7.89 8.12 8.18 7.77 8.18H6.86C6.51 8.18 6.23 7.89 6.23 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 6.64C9.34 6.29 9.62 6 9.98 6H10.88C11.23 6 11.52 6.29 11.52 6.64V7.54C11.52 7.89 11.23 8.18 10.88 8.18H9.98C9.62 8.18 9.34 7.89 9.34 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 6.64C12.45 6.29 12.74 6 13.09 6H13.99C14.35 6 14.63 6.29 14.63 6.64V7.54C14.63 7.89 14.35 8.18 13.99 8.18H13.09C12.74 8.18 12.45 7.89 12.45 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 6.64C15.57 6.29 15.85 6 16.2 6H17.11C17.46 6 17.74 6.29 17.74 6.64V7.54C17.74 7.89 17.46 8.18 17.11 8.18H16.2C15.85 8.18 15.57 7.89 15.57 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 6.64C18.68 6.29 18.96 6 19.32 6H20.22C20.57 6 20.86 6.29 20.86 6.64V7.54C20.86 7.89 20.57 8.18 20.22 8.18H19.32C18.96 8.18 18.68 7.89 18.68 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 6.64C21.79 6.29 22.08 6 22.43 6H23.33C23.68 6 23.97 6.29 23.97 6.64V7.54C23.97 7.89 23.68 8.18 23.33 8.18H22.43C22.08 8.18 21.79 7.89 21.79 7.54V6.64Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M0 9.75C0 9.4 0.28 9.12 0.64 9.12H1.54C1.89 9.12 2.18 9.4 2.18 9.75V10.66C2.18 11.01 1.89 11.3 1.54 11.3H0.64C0.28 11.3 0 11.01 0 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 9.75C3.11 9.4 3.4 9.12 3.75 9.12H4.65C5.01 9.12 5.29 9.4 5.29 9.75V10.66C5.29 11.01 5.01 11.3 4.65 11.3H3.75C3.4 11.3 3.11 11.01 3.11 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 9.75C6.23 9.4 6.51 9.12 6.86 9.12H7.77C8.12 9.12 8.4 9.4 8.4 9.75V10.66C8.4 11.01 8.12 11.3 7.77 11.3H6.86C6.51 11.3 6.23 11.01 6.23 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 9.75C9.34 9.4 9.62 9.12 9.98 9.12H10.88C11.23 9.12 11.52 9.4 11.52 9.75V10.66C11.52 11.01 11.23 11.3 10.88 11.3H9.98C9.62 11.3 9.34 11.01 9.34 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 9.75C12.45 9.4 12.74 9.12 13.09 9.12H13.99C14.35 9.12 14.63 9.4 14.63 9.75V10.66C14.63 11.01 14.35 11.3 13.99 11.3H13.09C12.74 11.3 12.45 11.01 12.45 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 9.75C15.57 9.4 15.85 9.12 16.2 9.12H17.11C17.46 9.12 17.74 9.4 17.74 9.75V10.66C17.74 11.01 17.46 11.3 17.11 11.3H16.2C15.85 11.3 15.57 11.01 15.57 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 9.75C18.68 9.4 18.96 9.12 19.32 9.12H20.22C20.57 9.12 20.86 9.4 20.86 9.75V10.66C20.86 11.01 20.57 11.3 20.22 11.3H19.32C18.96 11.3 18.68 11.01 18.68 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 9.75C21.79 9.4 22.08 9.12 22.43 9.12H23.33C23.68 9.12 23.97 9.4 23.97 9.75V10.66C23.97 11.01 23.68 11.3 23.33 11.3H22.43C22.08 11.3 21.79 11.01 21.79 10.66V9.75Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M0 12.87C0 12.52 0.28 12.23 0.64 12.23H1.54C1.89 12.23 2.18 12.52 2.18 12.87V13.78C2.18 14.13 1.89 14.41 1.54 14.41H0.64C0.28 14.41 0 14.13 0 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 12.87C3.11 12.52 3.4 12.23 3.75 12.23H4.65C5.01 12.23 5.29 12.52 5.29 12.87V13.78C5.29 14.13 5.01 14.41 4.65 14.41H3.75C3.4 14.41 3.11 14.13 3.11 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 12.87C6.23 12.52 6.51 12.23 6.86 12.23H7.77C8.12 12.23 8.4 12.52 8.4 12.87V13.78C8.4 14.13 8.12 14.41 7.77 14.41H6.86C6.51 14.41 6.23 14.13 6.23 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 12.87C9.34 12.52 9.62 12.23 9.98 12.23H10.88C11.23 12.23 11.52 12.52 11.52 12.87V13.78C11.52 14.13 11.23 14.41 10.88 14.41H9.98C9.62 14.41 9.34 14.13 9.34 13.78V12.87Z'
        fill='#0E7BC9'
      />
      <path
        d='M12.45 12.87C12.45 12.52 12.74 12.23 13.09 12.23H13.99C14.35 12.23 14.63 12.52 14.63 12.87V13.78C14.63 14.13 14.35 14.41 13.99 14.41H13.09C12.74 14.41 12.45 14.13 12.45 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 12.87C15.57 12.52 15.85 12.23 16.2 12.23H17.11C17.46 12.23 17.74 12.52 17.74 12.87V13.78C17.74 14.13 17.46 14.41 17.11 14.41H16.2C15.85 14.41 15.57 14.13 15.57 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 12.87C18.68 12.52 18.96 12.23 19.32 12.23H20.22C20.57 12.23 20.86 12.52 20.86 12.87V13.78C20.86 14.13 20.57 14.41 20.22 14.41H19.32C18.96 14.41 18.68 14.13 18.68 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 12.87C21.79 12.52 22.08 12.23 22.43 12.23H23.33C23.68 12.23 23.97 12.52 23.97 12.87V13.78C23.97 14.13 23.68 14.41 23.33 14.41H22.43C22.08 14.41 21.79 14.13 21.79 13.78V12.87Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M0 15.99C0 15.64 0.28 15.35 0.64 15.35H1.54C1.89 15.35 2.18 15.64 2.18 15.99V16.89C2.18 17.25 1.89 17.53 1.54 17.53H0.64C0.28 17.53 0 17.25 0 16.89V15.99Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 15.99C3.11 15.64 3.4 15.35 3.75 15.35H4.65C5.01 15.35 5.29 15.64 5.29 15.99V16.89C5.29 17.25 5.01 17.53 4.65 17.53H3.75C3.4 17.53 3.11 17.25 3.11 16.89V15.99Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 15.99C6.23 15.64 6.51 15.35 6.86 15.35H7.77C8.12 15.35 8.4 15.64 8.4 15.99V16.89C8.4 17.25 8.12 17.53 7.77 17.53H6.86C6.51 17.53 6.23 17.25 6.23 16.89V15.99Z'
        fill='#0E7BC9'
      />
      <path
        d='M9.34 15.99C9.34 15.64 9.62 15.35 9.98 15.35H10.88C11.23 15.35 11.52 15.64 11.52 15.99V16.89C11.52 17.25 11.23 17.53 10.88 17.53H9.98C9.62 17.53 9.34 17.25 9.34 16.89V15.99Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 15.99C12.45 15.64 12.74 15.35 13.09 15.35H13.99C14.35 15.35 14.63 15.64 14.63 15.99V16.89C14.63 17.25 14.35 17.53 13.99 17.53H13.09C12.74 17.53 12.45 17.25 12.45 16.89V15.99Z'
        fill='#0E7BC9'
      />
      <path
        d='M15.57 15.99C15.57 15.64 15.85 15.35 16.2 15.35H17.11C17.46 15.35 17.74 15.64 17.74 15.99V16.89C17.74 17.25 17.46 17.53 17.11 17.53H16.2C15.85 17.53 15.57 17.25 15.57 16.89V15.99Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 15.99C18.68 15.64 18.96 15.35 19.32 15.35H20.22C20.57 15.35 20.86 15.64 20.86 15.99V16.89C20.86 17.25 20.57 17.53 20.22 17.53H19.32C18.96 17.53 18.68 17.25 18.68 16.89V15.99Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 15.99C21.79 15.64 22.08 15.35 22.43 15.35H23.33C23.68 15.35 23.97 15.64 23.97 15.99V16.89C23.97 17.25 23.68 17.53 23.33 17.53H22.43C22.08 17.53 21.79 17.25 21.79 16.89V15.99Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M0 19.11C0 18.75 0.28 18.47 0.64 18.47H1.54C1.89 18.47 2.18 18.75 2.18 19.11V20.01C2.18 20.36 1.89 20.65 1.54 20.65H0.64C0.28 20.65 0 20.36 0 20.01V19.11Z'
        fill='#0E7BC9'
      />
      <path
        d='M3.11 19.11C3.11 18.75 3.4 18.47 3.75 18.47H4.65C5.01 18.47 5.29 18.75 5.29 19.11V20.01C5.29 20.36 5.01 20.65 4.65 20.65H3.75C3.4 20.65 3.11 20.36 3.11 20.01V19.11Z'
        fill='#0E7BC9'
      />
      <path
        d='M6.23 19.11C6.23 18.75 6.51 18.47 6.86 18.47H7.77C8.12 18.47 8.4 18.75 8.4 19.11V20.01C8.4 20.36 8.12 20.65 7.77 20.65H6.86C6.51 20.65 6.23 20.36 6.23 20.01V19.11Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 19.11C9.34 18.75 9.62 18.47 9.98 18.47H10.88C11.23 18.47 11.52 18.75 11.52 19.11V20.01C11.52 20.36 11.23 20.65 10.88 20.65H9.98C9.62 20.65 9.34 20.36 9.34 20.01V19.11Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 19.11C12.45 18.75 12.74 18.47 13.09 18.47H13.99C14.35 18.47 14.63 18.75 14.63 19.11V20.01C14.63 20.36 14.35 20.65 13.99 20.65H13.09C12.74 20.65 12.45 20.36 12.45 20.01V19.11Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 19.11C15.57 18.75 15.85 18.47 16.2 18.47H17.11C17.46 18.47 17.74 18.75 17.74 19.11V20.01C17.74 20.36 17.46 20.65 17.11 20.65H16.2C15.85 20.65 15.57 20.36 15.57 20.01V19.11Z'
        fill='#0E7BC9'
      />
      <path
        d='M18.68 19.11C18.68 18.75 18.96 18.47 19.32 18.47H20.22C20.57 18.47 20.86 18.75 20.86 19.11V20.01C20.86 20.36 20.57 20.65 20.22 20.65H19.32C18.96 20.65 18.68 20.36 18.68 20.01V19.11Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 19.11C21.79 18.75 22.08 18.47 22.43 18.47H23.33C23.68 18.47 23.97 18.75 23.97 19.11V20.01C23.97 20.36 23.68 20.65 23.33 20.65H22.43C22.08 20.65 21.79 20.36 21.79 20.01V19.11Z'
        fill='#0E7BC9'
      />
      <path
        d='M0 22.22C0 21.87 0.28 21.59 0.64 21.59H1.54C1.89 21.59 2.18 21.87 2.18 22.22V23.13C2.18 23.48 1.89 23.77 1.54 23.77H0.64C0.28 23.77 0 23.48 0 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 22.22C3.11 21.87 3.4 21.59 3.75 21.59H4.65C5.01 21.59 5.29 21.87 5.29 22.22V23.13C5.29 23.48 5.01 23.77 4.65 23.77H3.75C3.4 23.77 3.11 23.48 3.11 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 22.22C6.23 21.87 6.51 21.59 6.86 21.59H7.77C8.12 21.59 8.4 21.87 8.4 22.22V23.13C8.4 23.48 8.12 23.77 7.77 23.77H6.86C6.51 23.77 6.23 23.48 6.23 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 22.22C9.34 21.87 9.62 21.59 9.98 21.59H10.88C11.23 21.59 11.52 21.87 11.52 22.22V23.13C11.52 23.48 11.23 23.77 10.88 23.77H9.98C9.62 23.77 9.34 23.48 9.34 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 22.22C12.45 21.87 12.74 21.59 13.09 21.59H13.99C14.35 21.59 14.63 21.87 14.63 22.22V23.13C14.63 23.48 14.35 23.77 13.99 23.77H13.09C12.74 23.77 12.45 23.48 12.45 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 22.22C15.57 21.87 15.85 21.59 16.2 21.59H17.11C17.46 21.59 17.74 21.87 17.74 22.22V23.13C17.74 23.48 17.46 23.77 17.11 23.77H16.2C15.85 23.77 15.57 23.48 15.57 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 22.22C18.68 21.87 18.96 21.59 19.32 21.59H20.22C20.57 21.59 20.86 21.87 20.86 22.22V23.13C20.86 23.48 20.57 23.77 20.22 23.77H19.32C18.96 23.77 18.68 23.48 18.68 23.13V22.22Z'
        fill='#0E7BC9'
      />
      <path
        d='M21.79 22.22C21.79 21.87 22.08 21.59 22.43 21.59H23.33C23.68 21.59 23.97 21.87 23.97 22.22V23.13C23.97 23.48 23.68 23.77 23.33 23.77H22.43C22.08 23.77 21.79 23.48 21.79 23.13V22.22Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M0 25.34C0 24.99 0.28 24.7 0.64 24.7H1.54C1.89 24.7 2.18 24.99 2.18 25.34V26.25C2.18 26.6 1.89 26.88 1.54 26.88H0.64C0.28 26.88 0 26.6 0 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 25.34C3.11 24.99 3.4 24.7 3.75 24.7H4.65C5.01 24.7 5.29 24.99 5.29 25.34V26.25C5.29 26.6 5.01 26.88 4.65 26.88H3.75C3.4 26.88 3.11 26.6 3.11 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 25.34C6.23 24.99 6.51 24.7 6.86 24.7H7.77C8.12 24.7 8.4 24.99 8.4 25.34V26.25C8.4 26.6 8.12 26.88 7.77 26.88H6.86C6.51 26.88 6.23 26.6 6.23 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 25.34C9.34 24.99 9.62 24.7 9.98 24.7H10.88C11.23 24.7 11.52 24.99 11.52 25.34V26.25C11.52 26.6 11.23 26.88 10.88 26.88H9.98C9.62 26.88 9.34 26.6 9.34 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 25.34C12.45 24.99 12.74 24.7 13.09 24.7H13.99C14.35 24.7 14.63 24.99 14.63 25.34V26.25C14.63 26.6 14.35 26.88 13.99 26.88H13.09C12.74 26.88 12.45 26.6 12.45 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 25.34C15.57 24.99 15.85 24.7 16.2 24.7H17.11C17.46 24.7 17.74 24.99 17.74 25.34V26.25C17.74 26.6 17.46 26.88 17.11 26.88H16.2C15.85 26.88 15.57 26.6 15.57 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 25.34C18.68 24.99 18.96 24.7 19.32 24.7H20.22C20.57 24.7 20.86 24.99 20.86 25.34V26.25C20.86 26.6 20.57 26.88 20.22 26.88H19.32C18.96 26.88 18.68 26.6 18.68 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 25.34C21.79 24.99 22.08 24.7 22.43 24.7H23.33C23.68 24.7 23.97 24.99 23.97 25.34V26.25C23.97 26.6 23.68 26.88 23.33 26.88H22.43C22.08 26.88 21.79 26.6 21.79 26.25V25.34Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M0 28.46C0 28.11 0.28 27.82 0.64 27.82H1.54C1.89 27.82 2.18 28.11 2.18 28.46V29.36C2.18 29.72 1.89 30 1.54 30H0.64C0.28 30 0 29.72 0 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M3.11 28.46C3.11 28.11 3.4 27.82 3.75 27.82H4.65C5.01 27.82 5.29 28.11 5.29 28.46V29.36C5.29 29.72 5.01 30 4.65 30H3.75C3.4 30 3.11 29.72 3.11 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M6.23 28.46C6.23 28.11 6.51 27.82 6.86 27.82H7.77C8.12 27.82 8.4 28.11 8.4 28.46V29.36C8.4 29.72 8.12 30 7.77 30H6.86C6.51 30 6.23 29.72 6.23 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M9.34 28.46C9.34 28.11 9.62 27.82 9.98 27.82H10.88C11.23 27.82 11.52 28.11 11.52 28.46V29.36C11.52 29.72 11.23 30 10.88 30H9.98C9.62 30 9.34 29.72 9.34 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M12.45 28.46C12.45 28.11 12.74 27.82 13.09 27.82H13.99C14.35 27.82 14.63 28.11 14.63 28.46V29.36C14.63 29.72 14.35 30 13.99 30H13.09C12.74 30 12.45 29.72 12.45 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M15.57 28.46C15.57 28.11 15.85 27.82 16.2 27.82H17.11C17.46 27.82 17.74 28.11 17.74 28.46V29.36C17.74 29.72 17.46 30 17.11 30H16.2C15.85 30 15.57 29.72 15.57 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M18.68 28.46C18.68 28.11 18.96 27.82 19.32 27.82H20.22C20.57 27.82 20.86 28.11 20.86 28.46V29.36C20.86 29.72 20.57 30 20.22 30H19.32C18.96 30 18.68 29.72 18.68 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
      <path
        d='M21.79 28.46C21.79 28.11 22.08 27.82 22.43 27.82H23.33C23.68 27.82 23.97 28.11 23.97 28.46V29.36C23.97 29.72 23.68 30 23.33 30H22.43C22.08 30 21.79 29.72 21.79 29.36V28.46Z'
        fill='#030712'
        fillOpacity='0.1'
      />
    </svg>
  )
}

export function SixtyfourIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 158 143' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M32.4 141.17L31.64 140.73V142.48L31.84 142.6L32.4 142.92L32.95 142.6L33.15 142.48V140.73L32.4 141.17Z'
        fill='currentColor'
      />
      <path d='M33.15 140.73V142.6H31.64V140.73L32.4 141.17L33.15 140.73Z' fill='currentColor' />
      <path d='M93.33 105.61V106.56L94.09 107L94.84 106.56V105.61H93.33Z' fill='currentColor' />
      <path d='M94.84 105.61V106.56L94.09 107L93.33 106.56V105.61H94.84Z' fill='currentColor' />
      <path
        d='M125.68 12.99L94.84 30.76L63.99 12.99L32.4 31.19H32.39V68.86L0.8 87.05H0.79V124.72L31.64 142.48V140.73L2.31 123.84V89.67L31.64 106.56V140.73L32.4 141.17L33.15 140.73V106.56L62.48 89.67V123.84L33.15 140.73V142.48L63.24 125.16L93.33 142.48L93.53 142.6L94.09 142.92L94.64 142.6L94.84 142.48L125.69 124.72V87.05L126.24 86.74L126.44 86.61L157.28 68.86V31.19L125.68 12.99ZM63.23 84.86L33.9 67.98V33.8L63.23 50.7V84.86ZM64.75 50.7L94.08 33.8V67.98L64.75 84.86V50.7ZM124.17 123.84L94.84 140.73V106.56L94.09 107L93.33 106.56V140.73L64 123.84V89.67L93.33 106.56V105.61H94.84V106.56L124.17 89.67V123.84ZM124.92 84.86L95.59 67.98V33.8L124.92 50.69V84.86ZM155.77 67.98L126.44 84.86V50.7L155.77 33.8V67.98Z'
        fill='currentColor'
      />
    </svg>
  )
}

/**
 * The "agent" brand wordmark (v1.0 brand guide agentLogotype paths — the same mark
 * the navbar/login header renders), inked with the theme-adaptive
 * `--text-body`. Used as the icon for the Auto model option; the wide viewBox
 * letterboxes itself inside square icon slots.
 */
export function AgentAutoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 441 212'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <g fill='var(--text-body)'>
        <path d='M0 160.9H29.51C29.51 169.08 32.46 175.61 38.37 180.48C44.27 185.12 52.25 187.44 62.31 187.44C73.24 187.44 81.65 185.34 87.56 181.14C93.46 176.71 96.41 170.85 96.41 163.55C96.41 158.24 94.77 153.82 91.49 150.28C88.43 146.74 82.75 143.86 74.44 141.65L46.24 135.01C32.03 131.47 21.42 126.05 14.43 118.75C7.65 111.45 4.26 101.83 4.26 89.88C4.26 79.93 6.78 71.3 11.81 64C17.05 56.7 24.16 51.06 33.12 47.08C42.3 43.09 52.8 41.1 64.6 41.1C76.41 41.1 86.57 43.2 95.1 47.41C103.84 51.61 110.62 57.47 115.43 64.99C120.46 72.52 123.08 81.48 123.3 91.87H93.79C93.57 83.47 90.84 76.94 85.59 72.3C80.34 67.65 73.02 65.33 63.62 65.33C54 65.33 46.57 67.43 41.32 71.63C36.07 75.83 33.45 81.59 33.45 88.89C33.45 99.73 41.32 107.14 57.06 111.12L85.26 118.09C98.81 121.19 108.98 126.28 115.76 133.35C122.53 140.21 125.92 149.61 125.92 161.56C125.92 171.74 123.19 180.7 117.73 188.44C112.26 195.96 104.72 201.82 95.1 206.03C85.7 210.01 74.55 212 61.65 212C42.85 212 27.87 207.35 16.72 198.06C5.57 188.77 0 176.38 0 160.9Z' />
        <path d='M232.8 212H202.13L202.13 49.76H229.54V77.39C232.8 68.34 239.11 60.66 247.81 54.7C256.73 48.52 267.5 45.43 280.12 45.43C294.26 45.43 306.01 49.29 315.36 57.02C324.72 64.75 330.81 75.01 333.64 87.82H328.09C330.27 75.01 336.25 64.75 346.04 57.02C355.83 49.29 367.9 45.43 382.26 45.43C400.54 45.43 414.89 50.84 425.34 61.66C435.78 72.47 441 87.26 441 106.03V212H410.98V113.65C410.98 100.84 407.71 91.02 401.19 84.17C394.88 77.11 386.29 73.58 375.41 73.58C367.79 73.58 361.05 75.34 355.17 78.88C349.52 82.19 345.06 87.04 341.8 93.45C338.53 99.85 336.9 107.36 336.9 115.97V212H306.55V113.32C306.55 100.51 303.4 90.8 297.09 84.17C290.78 77.33 282.19 73.91 271.31 73.91C263.69 73.91 256.95 75.67 251.08 79.21C245.42 82.52 240.96 87.38 237.7 93.78C234.43 99.96 232.8 107.36 232.8 115.97V212Z' />
        <path d='M184.83 20.55C184.83 31.9 175.64 41.1 164.29 41.1C152.95 41.1 143.76 31.9 143.76 20.55C143.76 9.2 152.95 0 164.29 0C175.64 0 184.83 9.2 184.83 20.55Z' />
        <path d='M179.43 212H149.16V49.76C153.76 51.91 158.88 53.12 164.29 53.12C169.7 53.12 174.83 51.91 179.43 49.76V212Z' />
      </g>
    </svg>
  )
}

export function AgentTriggerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 222 222'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M107.822 93.76C107.822 97.35 106.403 100.792 103.884 103.328L103.523 103.692C101.006 106.236 97.59 107.658 94.02 107.658H13.45C6.02 107.658 0 113.718 0 121.191V208.332C0 215.806 6.02 221.866 13.45 221.866H99.96C107.383 221.866 113.4 215.806 113.4 208.332V126.745C113.4 123.419 114.71 120.228 117.047 117.874C119.377 115.527 122.546 114.207 125.849 114.207H207.777C215.198 114.207 221.214 108.148 221.214 100.674V13.53C221.214 6.06 215.198 0 207.777 0H121.26C113.839 0 107.822 6.06 107.822 13.53V93.76ZM134.078 18.55H194.952C199.289 18.55 202.796 22.09 202.796 26.45V87.76C202.796 92.12 199.289 95.66 194.952 95.66H134.078C129.748 95.66 126.233 92.12 126.233 87.76V26.45C126.233 22.09 129.748 18.55 134.078 18.55Z'
        fill='currentColor'
      />
      <path
        d='M207.878 129.57H143.554C135.756 129.57 129.434 135.937 129.434 143.791V207.784C129.434 215.638 135.756 222.005 143.554 222.005H207.878C215.677 222.005 221.999 215.638 221.999 207.784V143.791C221.999 135.937 215.677 129.57 207.878 129.57Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function AgentDeploymentsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 222 222'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M107.822 93.76C107.822 97.35 106.403 100.792 103.884 103.328L103.523 103.692C101.006 106.236 97.59 107.658 94.02 107.658H13.45C6.02 107.658 0 113.718 0 121.191V208.332C0 215.806 6.02 221.866 13.45 221.866H99.96C107.383 221.866 113.4 215.806 113.4 208.332V126.745C113.4 123.419 114.71 120.228 117.047 117.874C119.377 115.527 122.546 114.207 125.849 114.207H207.777C215.198 114.207 221.214 108.148 221.214 100.674V13.53C221.214 6.06 215.198 0 207.777 0H121.26C113.839 0 107.822 6.06 107.822 13.53V93.76ZM134.078 18.55H194.952C199.289 18.55 202.796 22.09 202.796 26.45V87.76C202.796 92.12 199.289 95.66 194.952 95.66H134.078C129.748 95.66 126.233 92.12 126.233 87.76V26.45C126.233 22.09 129.748 18.55 134.078 18.55Z'
        fill='#33C482'
      />
      <path
        d='M207.878 129.57H143.554C135.756 129.57 129.434 135.937 129.434 143.791V207.784C129.434 215.638 135.756 222.005 143.554 222.005H207.878C215.677 222.005 221.999 215.638 221.999 207.784V143.791C221.999 135.937 215.677 129.57 207.878 129.57Z'
        fill='#33C482'
      />
    </svg>
  )
}

export function SimilarwebIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      role='img'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      width='24'
    >
      <path
        d='M22.1 5.78c-1.28 -2 -3.14 -3.67 -5.27 -4.52l-0.63 -0.21a7.43 7.43 0 0 0 -2.15 -0.33c-2.31 0.01 -4.17 1.92 -4.17 4.28a4.3 4.3 0 0 0 0.87 2.6l-0.26 -0.34c0.12 0.19 0.26 0.37 0.42 0.56 0.66 0.8 1.6 1.64 2.82 2.58 3 2.32 4.94 4.38 5.1 6.93 0.04 0.34 0.06 0.7 0.06 1.05 0 1.3 -0.28 2.67 -0.76 3.64h0.01s-0.21 0.38 -0.08 0.49c0.07 0.06 0.21 0.1 0.46 -0.05a12.1 12.1 0 0 0 3.4 -3.33 12.11 12.11 0 0 0 2.09 -6.63 12.1 12.1 0 0 0 -1.9 -6.69zm-9.1 8.72 -1.88 -1.55c-3.93 -2.87 -5.98 -5.97 -4.86 -9.78a8.73 8.73 0 0 1 0.37 -1.02v0s0.28 -0.58 -0.33 -0.29a12.07 12.07 0 0 0 -6.29 9.98 12.11 12.11 0 0 0 2.05 7.42 9.39 9.39 0 0 0 2.15 2.17H4.22c4.15 3.05 7.71 1.45 7.71 1.45h0a4.85 4.85 0 0 0 2.96 -4.49 4.86 4.86 0 0 0 -1.89 -3.87z'
        fill='currentColor'
      />
    </svg>
  )
}

export function CalComIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='101'
      height='22'
      viewBox='0 0 101 22'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.06 20.82C4.32 20.82 0 16.28 0 10.67C0 5.05 4.1 0.47 10.06 0.47C13.22 0.47 15.41 1.44 17.12 3.66L14.36 5.96C13.2 4.73 11.81 4.11 10.06 4.11C6.18 4.11 4.05 7.08 4.05 10.67C4.05 14.26 6.38 17.17 10.06 17.17C11.79 17.17 13.26 16.56 14.42 15.32L17.14 17.72C15.5 19.85 13.26 20.82 10.06 20.82Z'
        fill='currentColor'
      />
      <path
        d='M29.02 5.89H32.73V20.46H29.02V18.33C28.24 19.84 26.96 20.85 24.49 20.85C20.56 20.85 17.41 17.43 17.41 13.23C17.41 9.03 20.56 5.61 24.49 5.61C26.94 5.61 28.24 6.61 29.02 8.13V5.89ZM29.13 13.23C29.13 10.95 27.56 9.06 25.1 9.06C22.73 9.06 21.18 10.97 21.18 13.23C21.18 15.43 22.73 17.4 25.1 17.4C27.55 17.4 29.13 15.49 29.13 13.23Z'
        fill='currentColor'
      />
      <path d='M35.36 0H39.07V20.44H35.36V0Z' fill='currentColor' />
      <path
        d='M40.73 18.52C40.73 17.32 41.69 16.31 42.99 16.31C44.3 16.31 45.22 17.32 45.22 18.52C45.22 19.75 44.28 20.76 42.99 20.76C41.7 20.76 40.73 19.75 40.73 18.52Z'
        fill='currentColor'
      />
      <path
        d='M59.43 18.11C58.05 19.79 55.95 20.85 53.47 20.85C49.04 20.85 45.79 17.43 45.79 13.23C45.79 9.03 49.04 5.61 53.47 5.61C55.86 5.61 57.94 6.61 59.32 8.2L56.45 10.61C55.73 9.72 54.8 9.04 53.47 9.04C51.1 9.04 49.56 10.95 49.56 13.21C49.56 15.47 51.1 17.38 53.47 17.38C54.91 17.38 55.9 16.63 56.63 15.62L59.43 18.11Z'
        fill='currentColor'
      />
      <path
        d='M59.74 13.23C59.74 9.03 63 5.61 67.43 5.61C71.86 5.61 75.11 9.03 75.11 13.23C75.11 17.43 71.86 20.85 67.43 20.85C63 20.83 59.74 17.43 59.74 13.23ZM71.34 13.23C71.34 10.95 69.8 9.06 67.43 9.06C65.06 9.04 63.51 10.95 63.51 13.23C63.51 15.49 65.06 17.4 67.43 17.4C69.8 17.4 71.34 15.49 71.34 13.23Z'
        fill='currentColor'
      />
      <path
        d='M100.23 11.55V20.44H96.52V12.46C96.52 9.94 95.34 8.86 93.58 8.86C91.92 8.86 90.74 9.68 90.74 12.46V20.44H87.03V12.46C87.03 9.94 85.83 8.86 84.09 8.86C82.43 8.86 80.98 9.68 80.98 12.46V20.44H77.27V5.87H80.98V7.89C81.75 6.32 83.15 5.53 85.3 5.53C87.34 5.53 89.05 6.54 89.99 8.24C90.93 6.5 92.31 5.53 94.81 5.53C97.86 5.55 100.23 7.87 100.23 11.55Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function GoogleMapsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 92.3 132.3'>
      <path
        fill='#1a73e8'
        d='M60.2 2.2C55.8.8 51 0 46.1 0 32 0 19.3 6.4 10.8 16.5l21.8 18.3L60.2 2.2z'
      />
      <path
        fill='#ea4335'
        d='M10.8 16.5C4.1 24.5 0 34.9 0 46.1c0 8.7 1.7 15.7 4.6 22l28-33.3-21.8-18.3z'
      />
      <path
        fill='#4285f4'
        d='M46.2 28.5c9.8 0 17.7 7.9 17.7 17.7 0 4.3-1.6 8.3-4.2 11.4 0 0 13.9-16.6 27.5-32.7-5.6-10.8-15.3-19-27-22.7L32.6 34.8c3.3-3.8 8.1-6.3 13.6-6.3'
      />
      <path
        fill='#fbbc04'
        d='M46.2 63.8c-9.8 0-17.7-7.9-17.7-17.7 0-4.3 1.5-8.3 4.1-11.3l-28 33.3c4.8 10.6 12.8 19.2 21 29.9l34.1-40.5c-3.3 3.9-8.1 6.3-13.5 6.3'
      />
      <path
        fill='#34a853'
        d='M59.1 109.2c15.4-24.1 33.3-35 33.3-63 0-7.7-1.9-14.9-5.2-21.3L25.6 98c2.6 3.4 5.3 7.3 7.9 11.3 9.4 14.5 6.8 23.1 12.8 23.1s3.4-8.7 12.8-23.2'
      />
    </svg>
  )
}

export function GooglePagespeedIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='-1.74 -1.81 285.55 266.85' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M272.73 37.23v179.68a18.58 18.58 0 0 1-18.57 18.59H18.65A18.58 18.58 0 0 1 .06 216.94V37.23z'
        fill='#e1e1e1'
      />
      <path
        d='M18.65 0h235.5a18.58 18.58 0 0 1 18.58 18.56v18.67H.07V18.59A18.58 18.58 0 0 1 18.64 0z'
        fill='#c2c2c2'
      />
      <path
        d='M136.3 92.96a99 99 0 0 0-99 99v.13c0 2.08-.12 4.64 0 6.2h43.25a54.87 54.87 0 0 1 0-6.2 55.81 55.81 0 0 1 85.06-47.45l31.12-31.12a98.76 98.76 0 0 0-60.44-20.57z'
        fill='#4285f4'
      />
      <path
        d='M196.73 113.46l-31.14 31.14a55.74 55.74 0 0 1 26.56 47.45 54.87 54.87 0 0 1 0 6.2h43.39c.12-1.48 0-4.12 0-6.2a99 99 0 0 0-38.81-78.59z'
        fill='#f44336'
      />
      <circle cx='24.85' cy='18.59' fill='#eee' r='6.2' />
      <circle cx='49.65' cy='18.59' fill='#eee' r='6.2' />
      <path
        d='M197.01 117.23a3.05 3.05 0 0 0 .59-1.81 3.11 3.11 0 0 0-3.1-3.1 3 3 0 0 0-1.91.68l-67.56 52a18.58 18.58 0 1 0 27.24 24.33l44.73-72.1z'
        fill='#9e9e9e'
      />
    </svg>
  )
}

export function GoogleTranslateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 998.1 998.3'>
      <path
        fill='#DBDBDB'
        d='M931.7 998.3c36.5 0 66.4-29.4 66.4-65.4V265.8c0-36-29.9-65.4-66.4-65.4H283.6l260.1 797.9h388z'
      />
      <path
        fill='#DCDCDC'
        d='M931.7 230.4c9.7 0 18.9 3.8 25.8 10.6 6.8 6.7 10.6 15.5 10.6 24.8v667.1c0 9.3-3.7 18.1-10.6 24.8-6.9 6.8-16.1 10.6-25.8 10.6H565.5L324.9 230.4h606.8m0-30H283.6l260.1 797.9h388c36.5 0 66.4-29.4 66.4-65.4V265.8c0-36-29.9-65.4-66.4-65.4z'
      />
      <polygon fill='#4352B8' points='482.3,809.8 543.7,998.3 714.4,809.8' />
      <path
        fill='#607988'
        d='M936.1 476.1V437H747.6v-63.2h-61.2V437H566.1v39.1h239.4c-12.8 45.1-41.1 87.7-68.7 120.8-48.9-57.9-49.1-76.7-49.1-76.7h-50.8s2.1 28.2 70.7 108.6c-22.3 22.8-39.2 36.3-39.2 36.3l15.6 48.8s23.6-20.3 53.1-51.6c29.6 32.1 67.8 70.7 117.2 116.7l32.1-32.1c-52.9-48-91.7-86.1-120.2-116.7 38.2-45.2 77-102.1 85.2-154.2H936v.1z'
      />
      <path
        fill='#4285F4'
        d='M66.4 0C29.9 0 0 29.9 0 66.5v677c0 36.5 29.9 66.4 66.4 66.4h648.1L454.4 0h-388z'
      />
      <path
        fill='#EEEEEE'
        d='M371.4 430.6c-2.5 30.3-28.4 75.2-91.1 75.2-54.3 0-98.3-44.9-98.3-100.2s44-100.2 98.3-100.2c30.9 0 51.5 13.4 63.3 24.3l41.2-39.6c-27.1-25-62.4-40.6-104.5-40.6-86.1 0-156 69.9-156 156s69.9 156 156 156c90.2 0 149.8-63.3 149.8-152.6 0-12.8-1.6-22.2-3.7-31.8h-146v53.4l91 .1z'
      />
    </svg>
  )
}

export function DsPyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='30 28 185 175' fill='none'>
      <path
        fill='#D34C3F'
        opacity='1'
        stroke='#D34C3F'
        strokeWidth='3'
        d='
M202.41,127.02 
	C202.18,146.16 202.03,164.81 201.69,183.45 
	C201.55,191.01 200.72,191.83 193.29,191.89 
	C172.46,192.05 151.64,192.25 130.81,192.06 
	C104.67,191.81 78.53,191.24 52.39,190.69 
	C42.71,190.48 42.12,189.78 42.16,180.33 
	C42.33,140.85 42.54,101.36 42.76,61.88 
	C42.79,57.39 42.99,52.89 43.11,48.4 
	C43.31,40.55 44.09,39.5 52.08,39.16 
	C62.39,38.71 72.73,38.53 83.05,38.5 
	C112.71,38.42 142.36,38.39 172.02,38.53 
	C179.5,38.56 186.99,39.14 194.45,39.75 
	C201.08,40.29 202.32,41.54 202.35,48.1 
	C202.45,68.75 202.36,89.4 202.35,110.06 
	C202.35,115.54 202.39,121.03 202.41,127.02 
M105.67,111.01 
	C108.47,111.35 111.28,111.92 114.08,111.92 
	C115.42,111.92 117.73,111.04 117.93,110.17 
	C119.15,105.06 119.87,99.84 120.74,94.71 
	C106.97,90.84 103.52,87.19 104.01,77.35 
	C104.5,67.27 107.79,64.14 120.61,61.88 
	C120.93,58.41 121.14,54.8 121.65,51.23 
	C122.15,47.69 120.7,46.38 117.28,46.41 
	C96.32,46.57 75.37,46.66 54.42,46.81 
	C53.32,46.82 52.22,47.18 50.13,47.55 
	C50.13,67.1 50.15,86.54 50.11,105.98 
	C50.11,108.83 51.5,109.68 54.15,109.67 
	C59.31,109.65 64.48,109.66 69.62,110.04 
	C76.19,110.52 77.75,112.89 76.1,119.06 
	C73.83,127.57 75.81,129.9 84.68,129.14 
	C89.88,128.7 91.63,126.49 90.92,121.18 
	C90.73,119.7 90.32,118.24 90.08,116.77 
	C89.4,112.62 91.33,110.22 95.37,110.07 
	C98.49,109.95 101.64,110.59 105.67,111.01 
M175.32,104.57 
	C175.7,107.49 176.07,110.4 176.52,113.92 
	C181.18,113.62 185.77,113.27 190.37,113.04 
	C193.5,112.88 194.63,111.29 194.62,108.25 
	C194.6,89.27 194.64,70.3 194.76,51.32 
	C194.78,48.2 193.74,46.82 190.44,46.83 
	C186.12,46.85 181.81,46.24 177.49,46.2 
	C163.33,46.09 149.18,46.12 135.02,46.09 
	C131.46,46.08 129.6,47.36 129.75,51.41 
	C129.91,55.38 129.41,59.39 128.92,63.35 
	C128.05,70.44 126.52,71.37 119.54,70.68 
	C117.66,70.49 114.2,71.29 113.95,72.27 
	C113.11,75.61 112.45,79.56 113.57,82.61 
	C114.18,84.28 118.51,85.46 121.11,85.37 
	C127.14,85.16 129,86.45 128.85,92.49 
	C128.82,93.81 128.59,95.13 128.41,96.45 
	C127.65,101.99 126.87,107.53 126,113.78 
	C132.08,114.22 137.73,114.64 142.7,115 
	C143.8,109.89 143.71,105.33 145.69,102.03 
	C150.97,93.24 170.33,94.65 175.32,104.57 
M50.1,123.75 
	C49.99,141.72 49.89,159.7 49.75,177.67 
	C49.72,180.5 49.68,182.96 53.68,183.05 
	C73.13,183.48 92.58,184.05 112.03,184.59 
	C115.01,184.67 116.19,183.29 116.08,180.33 
	C115.94,176.34 115.99,172.34 116.04,168.35 
	C116.15,159.6 119.49,156.75 127.02,160.17 
	C128.59,160.89 130.72,161.09 132.38,160.68 
	C133.89,160.32 136.21,158.85 136.26,157.78 
	C136.45,154.1 136.58,150 135.06,146.87 
	C134.45,145.62 129.5,146.45 126.53,146.39 
	C126.07,146.39 125.61,146.77 125.14,146.91 
	C118.99,148.75 116.26,146.97 116,140.53 
	C115.78,135.05 116.07,129.54 115.91,124.05 
	C115.87,122.8 115.08,120.66 114.31,120.49 
	C109.41,119.45 104.41,118.85 99.25,118.08 
	C99.14,120.31 99.05,121.46 99.03,122.61 
	C98.92,131.69 96.08,135.42 87.14,136.82 
	C83.47,137.39 79.5,137.07 75.82,136.36 
	C70.12,135.25 67.09,131.13 66.82,125.33 
	C66.48,118.2 66.49,118.19 59.29,117.47 
	C58.13,117.35 56.95,117.48 55.8,117.32 
	C51.51,116.71 49.45,118.34 50.1,123.75 
M194.72,147.47 
	C194.72,138.73 194.72,129.99 194.72,121.95 
	C186.23,121.95 178.62,121.86 171.01,121.99 
	C167.43,122.05 166.14,120.33 166.55,117.07 
	C166.78,115.27 167.65,113.5 167.65,111.72 
	C167.65,109.69 167.28,105.98 166.61,105.88 
	C162.52,105.23 158.12,104.6 154.19,105.52 
	C150.29,106.44 151.76,110.46 152.29,113.27 
	C153.97,122.03 153.11,123.3 144.17,123.1 
	C137.75,122.96 131.34,122.36 124.47,121.94 
	C124.47,127.52 124.47,132.56 124.47,137.59 
	C142.2,138.21 145.23,140.29 144.78,152.77 
	C144.63,156.99 143.55,161.81 141.2,165.19 
	C137.27,170.85 130.6,169.01 124.4,168.43 
	C124.4,172.46 124.44,176.1 124.39,179.74 
	C124.35,183.1 126.02,184.58 129.28,184.57 
	C149.27,184.56 169.25,184.57 189.23,184.57 
	C192.69,184.58 194.24,183.12 194.24,179.42 
	C194.23,169.1 194.54,158.78 194.72,147.47 
z'
      />
      <path
        fill='none'
        opacity='1'
        stroke='#D34C3F'
        strokeWidth='3'
        d='
M105.22,110.95 
	C101.64,110.59 98.49,109.95 95.37,110.07 
	C91.33,110.22 89.4,112.62 90.08,116.77 
	C90.32,118.24 90.73,119.7 90.92,121.18 
	C91.63,126.49 89.88,128.7 84.68,129.14 
	C75.81,129.9 73.83,127.57 76.1,119.06 
	C77.75,112.89 76.19,110.52 69.62,110.04 
	C64.48,109.66 59.31,109.65 54.15,109.67 
	C51.5,109.68 50.11,108.83 50.11,105.98 
	C50.15,86.54 50.13,67.1 50.13,47.55 
	C52.22,47.18 53.32,46.82 54.42,46.81 
	C75.37,46.66 96.32,46.57 117.28,46.41 
	C120.7,46.38 122.15,47.69 121.65,51.23 
	C121.14,54.8 120.93,58.41 120.61,61.88 
	C107.79,64.14 104.5,67.27 104.01,77.35 
	C103.52,87.19 106.97,90.84 120.74,94.71 
	C119.87,99.84 119.15,105.06 117.93,110.17 
	C117.73,111.04 115.42,111.92 114.08,111.92 
	C111.28,111.92 108.47,111.35 105.22,110.95 
z'
      />
      <path
        fill='none'
        opacity='1'
        stroke='#D34C3F'
        strokeWidth='3'
        d='
M175.23,104.18 
	C170.33,94.65 150.97,93.24 145.69,102.03 
	C143.71,105.33 143.8,109.89 142.7,115 
	C137.73,114.64 132.08,114.22 126,113.78 
	C126.87,107.53 127.65,101.99 128.41,96.45 
	C128.59,95.13 128.82,93.81 128.85,92.49 
	C129,86.45 127.14,85.16 121.11,85.37 
	C118.51,85.46 114.18,84.28 113.57,82.61 
	C112.45,79.56 113.11,75.61 113.95,72.27 
	C114.2,71.29 117.66,70.49 119.54,70.68 
	C126.52,71.37 128.05,70.44 128.92,63.35 
	C129.41,59.39 129.91,55.38 129.75,51.41 
	C129.6,47.36 131.46,46.08 135.02,46.09 
	C149.18,46.12 163.33,46.09 177.49,46.2 
	C181.81,46.24 186.12,46.85 190.44,46.83 
	C193.74,46.82 194.78,48.2 194.76,51.32 
	C194.64,70.3 194.6,89.27 194.62,108.25 
	C194.63,111.29 193.5,112.88 190.37,113.04 
	C185.77,113.27 181.18,113.62 176.52,113.92 
	C176.07,110.4 175.7,107.49 175.23,104.18 
z'
      />
      <path
        fill='none'
        opacity='1'
        stroke='#D34C3F'
        strokeWidth='3'
        d='
M50.11,123.28 
	C49.45,118.34 51.51,116.71 55.8,117.32 
	C56.95,117.48 58.13,117.35 59.29,117.47 
	C66.49,118.19 66.48,118.2 66.82,125.33 
	C67.09,131.13 70.12,135.25 75.82,136.36 
	C79.5,137.07 83.47,137.39 87.14,136.82 
	C96.08,135.42 98.92,131.69 99.03,122.61 
	C99.05,121.46 99.14,120.31 99.25,118.08 
	C104.41,118.85 109.41,119.45 114.31,120.49 
	C115.08,120.66 115.87,122.8 115.91,124.05 
	C116.07,129.54 115.78,135.05 116,140.53 
	C116.26,146.97 118.99,148.75 125.14,146.91 
	C125.61,146.77 126.07,146.39 126.53,146.39 
	C129.5,146.45 134.45,145.62 135.06,146.87 
	C136.58,150 136.45,154.1 136.26,157.78 
	C136.21,158.85 133.89,160.32 132.38,160.68 
	C130.72,161.09 128.59,160.89 127.02,160.17 
	C119.49,156.75 116.15,159.6 116.04,168.35 
	C115.99,172.34 115.94,176.34 116.08,180.33 
	C116.19,183.29 115.01,184.67 112.03,184.59 
	C92.58,184.05 73.13,183.48 53.68,183.05 
	C49.68,182.96 49.72,180.5 49.75,177.67 
	C49.89,159.7 49.99,141.72 50.11,123.28 
z'
      />
      <path
        fill='none'
        opacity='1'
        stroke='#D34C3F'
        strokeWidth='3'
        d='
M194.72,147.96 
	C194.54,158.78 194.23,169.1 194.24,179.42 
	C194.24,183.12 192.69,184.58 189.23,184.57 
	C169.25,184.57 149.27,184.56 129.28,184.57 
	C126.02,184.58 124.35,183.1 124.39,179.74 
	C124.44,176.1 124.4,172.46 124.4,168.43 
	C130.6,169.01 137.27,170.85 141.2,165.19 
	C143.55,161.81 144.63,156.99 144.78,152.77 
	C145.23,140.29 142.2,138.21 124.47,137.59 
	C124.47,132.56 124.47,127.52 124.47,121.94 
	C131.34,122.36 137.75,122.96 144.17,123.1 
	C153.11,123.3 153.97,122.03 152.29,113.27 
	C151.76,110.46 150.29,106.44 154.19,105.52 
	C158.12,104.6 162.52,105.23 166.61,105.88 
	C167.28,105.98 167.65,109.69 167.65,111.72 
	C167.65,113.5 166.78,115.27 166.55,117.07 
	C166.14,120.33 167.43,122.05 171.01,121.99 
	C178.62,121.86 186.23,121.95 194.72,121.95 
	C194.72,129.99 194.72,138.73 194.72,147.96 
z'
      />
    </svg>
  )
}

export function EnrichSoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='3.603 14.239 390.78 365.94'
      fill='none'
    >
      <path
        fill='#5A52F4'
        d='M129.71,319.71 C127.55,322.68 125.65,325.41 123.66,328.28 C113.75,318.44 105.61,310.4 97.51,302.3 C93.63,298.42 89.99,294.27 85.95,290.56 C82.86,287.72 82.46,285.76 85.77,282.55 C104.07,264.83 122.15,246.88 140.29,228.99 C141.18,228.1 141.96,227.09 143.59,225.22 C140.69,225.07 138.82,224.88 136.95,224.88 C102.8,224.87 68.65,224.77 34.5,224.98 C29.32,225.02 27.99,223.34 28.09,218.4 C28.38,204.08 28.19,189.75 28.2,175.42 C28.2,168.4 28.32,168.28 35.59,168.28 C69.07,168.27 102.56,168.28 136.04,168.27 C137.97,168.27 139.89,168.11 141.82,168.02 C142.14,167.51 142.45,167.01 142.77,166.5 C122.84,146.5 102.91,126.49 83.26,106.77 C96.56,93.47 109.45,80.59 122.66,67.39 C123.52,68.16 124.79,69.19 125.93,70.33 C144.55,88.93 163.1,107.6 181.81,126.12 C186.71,130.98 189.09,136.45 189.06,143.44 C188.9,179.42 188.91,215.4 189.05,251.38 C189.07,258.19 186.74,263.65 181.98,268.32 C164.62,285.35 147.3,302.41 129.71,319.71z'
      />
      <path
        fill='#5A52F4'
        d='M276.07,246.91 C288.28,258.99 300.16,270.9 312.24,282.6 C315.16,285.43 315.42,287.25 312.38,290.25 C301.14,301.37 290.17,312.76 279.08,324.04 C278.17,324.96 277.12,325.74 275.9,326.8 C274.63,325.71 273.46,324.82 272.42,323.8 C253.89,305.59 235.42,287.32 216.82,269.18 C211.51,264 208.87,258.14 208.91,250.57 C209.11,214.92 209.08,179.27 208.93,143.62 C208.9,136.65 211.13,131.12 216.05,126.25 C234.87,107.61 253.54,88.82 272.27,70.1 C273.31,69.07 274.47,68.15 275.26,67.44 C288.35,80.58 301.21,93.49 314.6,106.92 C295.16,126.42 275.21,146.44 255.27,166.45 C255.54,166.94 255.81,167.43 256.09,167.92 C257.98,168.04 259.88,168.26 261.78,168.26 C295.43,168.28 329.08,168.27 362.73,168.28 C369.6,168.28 369.78,168.46 369.78,175.25 C369.78,189.91 369.65,204.57 369.86,219.23 C369.93,223.59 368.55,224.98 364.15,224.96 C329.83,224.8 295.52,224.87 261.2,224.87 C259.3,224.87 257.4,224.87 254.87,224.87 C262.35,232.66 269.08,239.66 276.07,246.91z'
      />
    </svg>
  )
}

export function AgentSkillsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M8 1L14.06 4.5V11.5L8 15L1.94 11.5V4.5L8 1Z'
        stroke='currentColor'
        strokeWidth='1.5'
        fill='none'
      />
      <path d='M8 4.5L11 6.25V9.75L8 11.5L5 9.75V6.25L8 4.5Z' fill='currentColor' />
    </svg>
  )
}

export function OktaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 63 63' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M34.6.4l-1.3 16c-.6-.1-1.2-.1-1.9-.1-.8 0-1.6.1-2.3.2l-.7-7.7c0-.2.2-.5.4-.5h1.3L29.5.5c0-.2.2-.5.4-.5h4.3c.3 0 .5.2.4.4zm-10.8.8c-.1-.2-.3-.4-.5-.3l-4 1.5c-.3.1-.4.4-.3.6l3.3 7.1-1.2.5c-.2.1-.3.3-.2.6l3.3 7c1.2-.7 2.5-1.2 3.9-1.5L23.8 1.2zM14 5.7l9.3 13.1c-1.2.8-2.2 1.7-3.1 2.7L14.5 16c-.2-.2-.2-.5 0-.6l1-.8L10 9c-.2-.2-.2-.5 0-.6l3.3-2.7c.2-.3.5-.2.7 0zM6.2 13.2c-.2-.1-.5-.1-.6.1l-2.1 3.7c-.1.2 0 .5.2.6l7.1 3.4-.7 1.1c-.1.2 0 .5.2.6l7.1 3.2c.5-1.3 1.2-2.5 2-3.6L6.2 13.2zM.9 23.3c0-.2.3-.4.5-.3l15.5 4c-.4 1.3-.6 2.7-.7 4.1l-7.8-.6c-.2 0-.4-.2-.4-.5l.2-1.3L.6 28c-.2 0-.4-.2-.4-.5l.7-4.2zM.4 33.8c-.3 0-.4.2-.4.5l.8 4.2c0 .2.3.4.5.3l7.6-2 .2 1.3c0 .2.3.4.5.3l7.5-2.1c-.4-1.3-.7-2.7-.8-4.1L.4 33.8zm2.5 11.1c-.1-.2 0-.5.2-.6l14.5-6.9c.5 1.3 1.3 2.5 2.2 3.6l-6.3 4.5c-.2.1-.5.1-.6-.1L12 44.3l-6.5 4.5c-.2.1-.5.1-.6-.1l-2-3.8zm17.5-3L9.1 53.3c-.2.2-.2.5 0 .6l3.3 2.7c.2.2.5.1.6-.1l4.6-6.4 1 .9c.2.2.5.1.6-.1l4.4-6.4c-1.2-.7-2.3-1.6-3.2-2.6zm-2.2 18.2c-.2-.1-.3-.3-.2-.6L24.6 45c1.2.6 2.6 1.1 3.9 1.4l-2 7.5c-.1.2-.3.4-.5.3l-1.2-.5-2.1 7.6c-.1.2-.3.4-.5.3l-4-1.5zm10.9-13.5l-1.3 16c0 .2.2.5.4.5H33c.2 0 .4-.2.4-.5l-.6-7.8h1.3c.2 0 .4-.2.4-.5l-.7-7.7c-.8.1-1.5.2-2.3.2-.6 0-1.3 0-1.9-.1zm16-43.2c.1-.2 0-.5-.2-.6l-4-1.5c-.2-.1-.5.1-.5.3l-2.1 7.6-1.2-.5c-.2-.1-.5.1-.5.3l-2 7.5c1.4.3 2.7.8 3.9 1.4l6.6-14.5zm8.8 6.3L42.6 21.1c-.9-1-2-1.9-3.2-2.6l4.4-6.4c.1-.2.4-.2.6-.1l1 .9 4.6-6.4c.1-.2.4-.2.6-.1l3.3 2.7c.2.2.2.5 0 .6zM59.9 18.7c.2-.1.3-.4.2-.6L58 14.4c-.1-.2-.4-.3-.6-.1l-6.5 4.5-.7-1.1c-.1-.2-.4-.3-.6-.1L43.3 22c.9 1.1 1.6 2.3 2.2 3.6l14.4-6.9zm2.3 5.8l.7 4.2c0 .2-.1.5-.4.5l-15.9 1.5c-.1-1.4-.4-2.8-.8-4.1l7.5-2.1c.2-.1.5.1.5.3l.2 1.3 7.6-2c.3-.1.5.1.6.4zM61.5 40c.2.1.5-.1.5-.3l.7-4.2c0-.2-.1-.5-.4-.5l-7.8-.7.2-1.3c0-.2-.1-.5-.4-.5l-7.8-.6c0 1.4-.3 2.8-.7 4.1L61.5 40zm-4.1 9.6c-.1.2-.4.3-.6.1l-13.2-9.1c.8-1.1 1.5-2.3 2-3.6l7.1 3.2c.2.1.3.4.2.6L52.2 42l7.1 3.4c.2.1.3.4.2.6l-2.1 3.6zm-17.7-5.4L49 57.3c.1.2.4.2.6.1l3.3-2.7c.2-.2.2-.4 0-.6l-5.5-5.6 1-.8c.2-.2.2-.4 0-.6l-5.5-5.5c1.1.8 0 1.7-1.2 2.4zm0 17.8c-.2.1-.5-.1-.5-.3l-4.2-15.4c1.4-.3 2.7-.8 3.9-1.5l3.3 7c.1.2 0 .5-.2.6l-1.2.5 3.3 7.1c.1.2 0 .5-.2.6L39.7 62z'
        fill='currentColor'
      />
    </svg>
  )
}

export function OnePasswordIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 63.6 63.6' xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(421, 12)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='#FFFFFF'
          d='M-419.9,19.8c0,17,13.7,30.7,30.7,30.7s30.7-13.7,30.7-30.7s-13.7-30.7-30.7-30.7S-419.9,2.8-419.9,19.8z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='#1A8CFF'
          d='M-389.2-4.3c13.3,0,24.1,10.8,24.1,24.1s-10.8,24.1-24.1,24.1c-13.3,0-24.1-10.8-24.1-24.1C-413.4,6.5-402.5-4.3-389.2-4.3'
        />
        <path
          opacity='0.5'
          d='M-421,19.8c0,17.6,14.2,31.8,31.8,31.8c17.6,0,31.8-14.2,31.8-31.8S-371.6-12-389.2-12C-406.8-12-421,2.2-421,19.8L-421,19.8z M-419.9,19.8L-419.9,19.8c0-17,13.7-30.7,30.7-30.7s30.7,13.8,30.7,30.7c0,17-13.7,30.7-30.7,30.7S-419.9,36.8-419.9,19.8L-419.9,19.8z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fillOpacity='0.05244755'
          d='M-358.6,18.1c0,0.5,0,1.1,0,1.6c0,17-13.7,30.7-30.7,30.7s-30.6-13.6-30.6-30.6c0-0.6,0-1.1,0-1.6c0.9,16.2,14.3,29.1,30.7,29.1c16.3,0,29.6-12.7,30.6-28.7L-358.6,18.1z M-389.2-7.6c14.8,0,26.9,12,26.9,26.9c0,8.3-3.8,15.7-9.7,20.6c4.9-4.6,8-11.2,8-18.5c0-13.9-11.3-25.2-25.2-25.2c-13.9,0-25.2,11.3-25.2,25.2c0,7.3,3.1,13.8,8,18.5c-5.9-4.9-9.7-12.3-9.7-20.6C-416.1,4.4-404.1-7.6-389.2-7.6z'
        />
        <path
          opacity='0.2561'
          d='M-389.2-4.3c13.3,0,24.1,10.8,24.1,24.1s-10.8,24.1-24.1,24.1c-13.2,0-23.9-10.6-24.1-23.7v-0.4C-413.4,6.5-402.6-4.3-389.2-4.3z M-389.2-3.2c-12.7,0-23,10.3-23,23s10.3,23,23,23c12.7,0,23-10.3,23-23S-376.5-3.2-389.2-3.2z'
        />
        <path
          fillOpacity='0.25'
          d='M-389.1,0.6c-10.7,0-19.3,8.6-19.3,19.3c0,10.5,8.6,19.1,19.3,19.1c10.5,0,19.1-8.6,19.1-19.1C-370,9.2-378.6,0.6-389.1,0.6z M-389.1,1.7c9.9,0,18,8.1,18,18.2c0,9.9-8.1,18-18,18c-10.1,0-18.2-8.1-18.2-18C-407.3,9.8-399.2,1.7-389.1,1.7z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='#F7F7F7'
          d='M-389.1,1.7c9.9,0,18,8.1,18,18.2c0,9.9-8.1,18-18,18c-10.1,0-18.2-8.1-18.2-18C-407.3,9.8-399.2,1.7-389.1,1.7L-389.1,1.7z'
        />
        <g transform='translate(41, 41)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            fillOpacity='0.05'
            d='M-422-21.2c0,4.5-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2S-422-25.7-422-21.2z'
          />
          <path
            fill='#FFFFFF'
            d='M-430.2-30.5c-5.1,0-9.3,4.2-9.3,9.3s4.2,9.3,9.3,9.3c5.1,0,9.3-4.2,9.3-9.3S-425.1-30.5-430.2-30.5z M-430.2-29.4c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2S-434.8-29.4-430.2-29.4z'
          />
          <path
            fillOpacity='0.15'
            d='M-430.2-29.4c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2S-434.8-29.4-430.2-29.4z M-430.2-28.3c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1S-426.3-28.3-430.2-28.3z'
          />
        </g>
        <g transform='translate(48, 32)'>
          <path
            fill='#FFFFFF'
            d='M-434.2-26.5h-6.1c-1.4,0-2.4,1.2-2.4,2.6v5.9c0,0.5,0.2,1.1,0.5,1.4l0.9,1v0.1l-0.9,1c-0.4,0.4-0.5,0.9-0.5,1.4v12.5c0,1.4,1.1,2.6,2.4,2.6h6.1c1.4,0,2.4-1.2,2.4-2.6v-5.9c0-0.5-0.2-1.1-0.5-1.4l-0.9-1V-9l0.9-1c0.4-0.4,0.5-0.9,0.5-1.4v-12.4C-431.7-25.3-432.8-26.5-434.2-26.5z M-434.2-25.3c0.8,0,1.4,0.7,1.4,1.6v12.3c0,0.3-0.1,0.5-0.3,0.7l-0.9,1c-0.4,0.4-0.4,1.1,0,1.5l0.9,1c0.2,0.2,0.3,0.5,0.3,0.7v5.9c0,0.9-0.6,1.6-1.4,1.6h-6c-0.8,0-1.4-0.7-1.4-1.6v-12.3c0-0.3,0.1-0.5,0.3-0.7l0.9-1c0.4-0.4,0.4-1.1,0-1.5l-0.9-1c-0.2-0.2-0.3-0.5-0.3-0.7v-5.9c0-0.9,0.6-1.6,1.4-1.6H-434.2z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='#0A2D4D'
            d='M-441.6-17.9v-5.9c0-0.9,0.6-1.6,1.4-1.6h6c0.8,0,1.4,0.7,1.4,1.6v12.3c0,0.3-0.1,0.5-0.3,0.7l-0.9,1c-0.4,0.4-0.4,1.1,0,1.5l0.9,1c0.2,0.2,0.3,0.5,0.3,0.7v5.9c0,0.9-0.6,1.6-1.4,1.6h-6c-0.8,0-1.4-0.7-1.4-1.6v-12.2c0-0.3,0.1-0.5,0.3-0.7l0.9-1c0.4-0.4,0.4-1.1,0-1.5l-0.9-1C-441.5-17.3-441.6-17.6-441.6-17.9z'
          />
          <path
            fillOpacity='0.4'
            d='M-434.2-25.4c0.8,0,1.4,0.7,1.4,1.6v12.3c0,0.3-0.1,0.5-0.3,0.7l-0.9,1c-0.4,0.4-0.4,1.1,0,1.5l0.9,1c0.2,0.2,0.3,0.5,0.3,0.7v5.9c0,0.9-0.6,1.6-1.4,1.6h-6c-0.8,0-1.4-0.7-1.4-1.6v-12.2c0-0.3,0.1-0.5,0.3-0.7l0.9-1c0.4-0.4,0.4-1.1,0-1.5l-0.9-1c-0.2-0.2-0.3-0.5-0.3-0.7v-5.9c0-0.9,0.6-1.6,1.4-1.6h6V-25.4z M-434.4-24.2h-5.7c-0.2,0-0.4,0.2-0.5,0.5v0.1v5.8l0,0l0,0l0.9,1c0.7,0.8,0.7,2,0.1,2.8l-0.1,0.1l-0.9,1l0,0l0,0v12.2c0,0.3,0.2,0.5,0.4,0.6l0,0h5.7c0.2,0,0.4-0.2,0.5-0.5v-0.1v-5.8l0,0l0,0l-0.9-1c-0.7-0.8-0.7-2-0.1-2.8l0.1-0.1l0.9-1l0,0l0,0v-12.2C-433.9-24-434.1-24.2-434.4-24.2L-434.4-24.2z'
          />
        </g>
      </g>
    </svg>
  )
}

export function VantaIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const clipId = `vanta_clip_${id}`
  const maskId = `vanta_mask_${id}`
  return (
    <svg {...props} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath={`url(#${clipId})`}>
        <circle cx='256' cy='256' r='256' fill='#AC55FF' />
        <mask
          id={maskId}
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='512'
          height='512'
        >
          <circle cx='256' cy='256' r='256' fill='#AC55FF' />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d='M269.7 530.45C360.29 530.45 407.14 502.38 421.28 474.22C422.09 472.6 420.53 470.76 418.81 471.33C402.86 476.61 390.96 466.81 389.63 455.5C389.63 455.5 385.17 407.54 369.22 402.86C370.17 400.91 374.01 385.59 362.13 371.42C365.38 361.41 362.69 354.81 360.26 349.82C363.22 346.19 365.5 341.51 366.48 336.94C366.73 335.86 366.72 334.9 367.6 333.89C373.2 329.23 379.38 325.39 383.14 318.57C389.92 306.26 385.38 292.2 377.17 281.82C376.33 280.67 375.68 280.12 375.62 277.18C375.64 272.14 374.73 266.97 372.03 262.72C370.65 260.56 368.84 258.69 366.94 256.96C359.05 249.6 349.61 244.16 340.54 238.29C339.3 237.49 337.84 236.43 337.3 234.98C334.45 224.35 327.06 216.13 317.89 213.89C317.69 206.78 310.19 195.98 298.83 195.98C295.37 195.98 292.51 197.87 290.72 194.62C286.57 186.75 278.29 185.29 273.98 185.09C273.25 185.05 273.05 184.08 273.7 183.77C275.09 183.1 277.18 182.19 280.29 180.99C295.88 173.52 289.43 131.01 283.05 108.58C280.06 100.2 272.49 76.38 253.94 74.81C252.66 74.7 251.36 74.73 250.13 75.08C246.56 76.11 243.91 78.97 242.05 82.94C235.91 95.27 234.38 128.56 232.12 142.8C228.92 163.1 226.02 184.87 215.91 193.8C211.61 182.44 205.37 177.17 201.97 177.37C199 178.07 203.02 183.84 201.31 192.34C200.12 197.24 197.41 201.8 192.79 201.8C179.27 201.8 167.1 134.17 163.46 93.55C163.37 92.48 163.26 91.42 163.07 90.37C161.28 80.55 156.12 74.76 150.66 74.76C147.9 74.76 137.96 73.75 126.58 91.64C118.76 105.59 113.8 120.18 113.31 147.34C113.32 174.71 125.53 193.02 130.48 202.02C150.69 235.27 153.39 246.74 149.56 267.01C145.67 286.65 157.53 297.7 157.53 297.7C155.86 300.3 153.65 307.26 153.13 314.9C152.81 319.76 153.8 328.49 156.13 333.89C151.02 344.88 151.15 353.62 151.15 359.13C151.15 371.89 145.58 377.09 138.34 379.36C140.29 386.32 153.28 390.05 160.79 382.61C158.57 404.48 154.47 424.17 148.75 448.55C145.2 465.23 145.8 474.58 148.49 482.5C149.7 486.07 151.6 489.36 153.93 492.32C181.64 527.67 233.63 530.45 269.7 530.45ZM269.65 482.74C259.67 481.12 250.33 476.14 243.51 468.6C225.35 474.62 206.47 459.33 212.21 439.15C213.12 436.5 217.06 437.48 216.67 440.23C216.1 443.78 216.76 447.42 218.28 450.55C222.34 459.83 234.44 462.32 241.85 455.86C244.6 453.44 248.56 454.36 250.42 457.36C266.66 479.4 300.36 475.27 311.65 450.52C313.31 447.07 314.39 443.41 315.02 439.62C315.46 436.92 319.5 437.18 319.61 439.9C320.52 466.52 295.6 486.9 269.65 482.74L269.65 482.74Z'
            fill='#240642'
          />
          <path
            d='M371.525 292.61C369.79 292.61 367.924 295.033 367.446 298.806C366.414 304.125 366.769 313.958 362.028 313.958C358.749 313.958 358.452 307.367 352.942 301.293C347.226 295.399 339.031 294.799 333.774 290.558C330.851 288.53 329.111 286.034 329.301 281.749C329.301 281.749 329.925 274.924 339.134 276.172C343.514 276.63 350.613 277.698 355.007 278.2C362.857 279.087 364.772 273.247 365.005 271.263C365.507 266.612 360.572 262.761 357.448 260.05C353.502 256.613 349.2 253.527 344.742 250.758C343.933 250.256 343.109 249.735 342.286 249.208C331.104 242.076 311.225 230.137 300.077 243.768C296.082 249.12 294.347 255.287 293.095 260.396C290.781 269.747 285.923 273.354 282.474 279.058C276.992 288.111 273.226 298.392 272.938 308.971C272.89 324.244 282.332 339.205 297.397 348.555C309.9 355.117 316.317 355.117 321.325 353.777C322.241 353.465 324.249 352.065 322.87 349.75C322.621 349.257 321.925 348.175 321.501 347.473C320.073 344.846 322.027 342.442 324.921 344.69C326.826 346.181 328.77 347.673 331.011 348.585C332.897 349.35 335.046 349.652 336.995 349.136C336.995 349.136 336.995 349.136 336.999 349.136C339.28 348.39 340.434 346.893 340.566 344.982C340.698 342.701 339.665 340.936 337.954 339.995C335.353 338.728 329.594 335.559 327.162 333.765C324.419 331.844 321.486 328.973 320.468 327.89C317.15 324.361 316.2 320.914 314.134 320.914C313.788 320.934 313.452 321.129 313.218 321.392C311.922 322.777 311.912 325.058 311.849 326.36C311.805 327.32 311.956 328.783 310.611 328.783C307.278 328.783 307.288 321.831 307.293 319.944C307.293 317.36 308.238 310.657 312.229 310.657C313.461 310.657 315.137 312.31 315.795 312.958C324.59 322.723 334.812 330.318 347.762 330.318C357.677 330.318 365.96 324.717 371.169 319.466C375.247 315.371 377.932 310.243 378.112 304.944C378.224 301.585 376.611 292.615 371.525 292.615V292.61ZM314.714 301.697C313.51 302.365 312.073 301.536 310.762 301.107C308.126 300.24 305.135 301.117 302.962 302.843C301.471 304.032 300.331 305.587 299.405 307.264C298.396 309.097 298.206 311.515 296.038 311.515C294.255 311.515 293.358 309.044 293.163 308.025C292.116 302.492 294.786 296.335 299.751 293.683C304.716 291.031 311.6 292.435 314.811 297.056C315.308 297.773 315.732 298.582 315.79 299.455C315.849 300.327 315.483 301.273 314.718 301.697H314.714Z'
            fill='white'
          />
          <path
            d='M249.386 238.371C244.645 238.44 240.046 240.477 236.694 243.919C234.808 245.854 230.608 252.114 231.017 261.761C230.949 263.18 229.083 263.687 228.333 262.478C225.307 257.057 225.132 251.402 226.306 247.229C228.912 238.795 236.274 231.785 246.224 231.785C259.277 231.785 262.551 240.326 263.204 242.973C263.516 244.07 262.161 244.879 261.328 244.099C259.165 242.086 255.827 238.371 249.376 238.371H249.386Z'
            fill='white'
          />
          <path
            d='M250.453 257.471C247.334 257.749 244.874 255.736 244.596 252.621C244.323 249.559 246.384 247.034 249.503 246.756C252.621 246.478 255.15 248.599 255.422 251.66C255.7 254.78 253.571 257.193 250.458 257.471H250.453Z'
            fill='white'
          />
          <path
            d='M148.261 199.172C143.662 199.172 128.582 174.699 128.582 140.145C128.582 124.638 132.563 108.087 139.798 108.087C144.251 108.087 145.26 117.574 145.465 120.387C147.808 150.066 143.983 170.224 149.567 197.109C149.937 198.684 148.987 199.176 148.261 199.176V199.172Z'
            fill='white'
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='512' height='512' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function VercelIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 256 222'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid'
    >
      <g transform='translate(19.2 16.63) scale(0.85)'>
        <polygon fill='currentColor' points='128 0 256 221.71 0 221.71' />
      </g>
    </svg>
  )
}

export function CloudflareIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='16.843 67.616 478.418 356.61'>
      <path
        fill='#f38020'
        d='M331 326c11-26-4-38-19-38l-148-2c-4 0-4-6 1-7l150-2c17-1 37-15 43-33 0 0 10-21 9-24a97 97 0 0 0-187-11c-38-25-78 9-69 46-48 3-65 46-60 72 0 1 1 2 3 2h274c1 0 3-1 3-3z'
      />
      <path
        fill='#faae40'
        d='M381 224c-4 0-6-1-7 1l-5 21c-5 16 3 30 20 31l32 2c4 0 4 6-1 7l-33 1c-36 4-46 39-46 39 0 2 0 3 2 3h113l3-2a81 81 0 0 0-78-103'
      />
    </svg>
  )
}

export function UpstashIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 341' width='24' height='24'>
      <path
        fill='#00C98D'
        d='M0 298.42c56.55 56.55 148.25 56.55 204.8 0c56.55-56.55 56.55-148.25 0-204.8l-25.6 25.6c42.42 42.42 42.42 111.19 0 153.6c-42.42 42.42-111.18 42.42-153.6 0z'
      />
      <path
        fill='#00C98D'
        d='M51.2 247.22c28.28 28.28 74.12 28.28 102.4 0c28.28-28.28 28.28-74.12 0-102.4l-25.6 25.6c14.14 14.14 14.14 37.06 0 51.2c-14.14 14.14-37.06 14.14-51.2 0zM256 42.42c-56.55-56.55-148.25-56.55-204.8 0c-56.55 56.56-56.55 148.25 0 204.8l25.6-25.6c-42.41-42.41-42.41-111.18 0-153.6c42.42-42.42 111.19-42.42 153.6 0z'
      />
      <path
        fill='#00C98D'
        d='M204.8 93.62c-28.28-28.28-74.12-28.28-102.4 0c-28.28 28.28-28.28 74.12 0 102.4l25.6-25.6c-14.14-14.14-14.14-37.06 0-51.2c14.14-14.14 37.06-14.14 51.2 0z'
      />
      <path
        fill='#FFF'
        fillOpacity='.4'
        d='M256 42.42c-56.55-56.55-148.25-56.55-204.8 0c-56.55 56.56-56.55 148.25 0 204.8l25.6-25.6c-42.41-42.41-42.41-111.18 0-153.6c42.42-42.42 111.19-42.42 153.6 0z'
      />
      <path
        fill='#FFF'
        fillOpacity='.4'
        d='M204.8 93.62c-28.28-28.28-74.12-28.28-102.4 0c-28.28 28.28-28.28 74.12 0 102.4l25.6-25.6c-14.14-14.14-14.14-37.06 0-51.2c14.14-14.14 37.06-14.14 51.2 0z'
      />
    </svg>
  )
}

export function UptimeRobotIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 298 298' width='24' height='24'>
      <g fill='#3BD771' transform='translate(.9 .9)'>
        <circle cx='148.1' cy='148.1' r='148.1' opacity='.3' />
        <circle cx='148.1' cy='148.1' r='98.9' />
      </g>
    </svg>
  )
}

export function RevenueCatIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='512'
      height='512'
      viewBox='32.664 36.416 451.285 447.168'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M95 109.77C110.15 106.11 133.61 104 154.79 104C212.05 104 246.32 123.93 246.32 174.65C246.32 205.75 233.74 226.26 214.01 237.44L261.77 318.95C258.05 321.63 250.04 323.18 238.86 323.18C226.28 323.18 217.99 321.67 211.98 318.95L172.23 248.3H167.65C157.79 248.31 147.95 247.6 138.18 246.19V319.26C134.17 321.67 127.02 323.18 116.73 323.18C106.73 323.18 99.29 321.66 95 319.26V109.77ZM137.64 207.85C145.77 209.26 154 209.97 162.24 209.96C187.12 209.96 202.29 200.56 202.29 177.06C202.29 152.89 186.27 142.95 157.67 142.95C150.96 142.92 144.26 143.51 137.64 144.74V207.85Z'
        fill='currentColor'
      />
      <path
        d='M428.53 329.24C428.53 365.53 410.15 375.49 396.31 382.2C360.97 399.32 304.37 379.4 244.21 373.34C189.73 366.21 135.71 361.52 127.31 373.74C124.15 376.83 123.48 386.8 127.31 390.86C138.6 402.85 168.06 394.49 188.92 390.71C195.39 389.69 201.93 392.1 206.08 397.02C210.23 401.94 211.35 408.64 209.02 414.58C206.7 420.52 201.28 424.81 194.81 425.83C185.38 427.26 175.85 427.99 166.31 428C145.99 428 120.44 424.5 105.94 409.07C98.72 401.4 91.33 387.78 97.03 366.47C107.88 326.07 172.81 336.05 248.03 343.63C300.41 348.91 357.23 366.47 379.93 350.34C385.72 346.23 396.52 337.02 390.7 329.24C384.88 321.47 375.35 325.68 362.84 325.68C300.15 325.68 263.24 285.3 263.24 217.92C263.25 167.29 284.18 131.89 318.29 115.09C333.11 107.79 350.42 104 369.59 104C386.29 104 403.27 106.93 414.11 113.37C420.85 123.03 423.78 140.31 422.31 153.2C408.25 146.47 395.36 142.95 378.67 142.95C337.37 142.95 308.95 164.04 308.95 214.99C308.95 265.93 337.07 286.15 376.61 286.15C387.87 286.04 403.1 284.67 422.31 282.05C426.46 297.5 428.53 313.23 428.53 329.24Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function RedisIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 512 512'
      xmlns='http://www.w3.org/2000/svg'
      fillRule='evenodd'
      clipRule='evenodd'
      strokeLinejoin='round'
      strokeMiterlimit='2'
    >
      <path
        d='M479.14 279.86c-34.58 43.58-71.94 93.39-146.65 93.39-66.73 0-91.59-58.86-93.34-106.67 14.62 30.92 43.2 55.95 87.8 54.79C412.74 318.6 471.53 241.13 471.53 170.57c0-84.39-62.95-145.26-172.24-145.26-78.17 0-175 29.74-238.65 76.78-.689 48.42 26.29 111.37 35.97 104.45 55.17-39.67 98.92-65.2 141.35-78.01C175.15 198.58 24.45 361.22 6 389.85c2.08 26.29 34.59 96.84 50.5 96.84 4.84 0 8.99-2.77 13.84-7.61 45.43-51.05 82.47-96.82 115.41-140.93 4.63 64.66 36.42 143.7 125.31 143.7 79.55 0 158.41-57.41 194.38-186.77 4.15-15.91-15.22-28.36-26.29-15.22zm-90.62-104.45c0 40.81-40.12 60.87-76.78 60.87-19.6 0-34.65-5.14-46.55-11.83 21.91-33.17 43.59-67.18 66.89-103.59 41.08 6.95 56.45 29.79 56.45 54.56z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  )
}

export function RipplingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 145.3 109.9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.5,30.5C17.5,18.4,11.4,8.4,0,0h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5 c8.6,3.6,13.5,12.4,13.5,25v24H16v-24c0-12-5.7-20.4-16-25C11.4,52.5,17.5,42.6,17.5,30.5 M69.4,30.5c0-12.1-6.1-22.1-17.5-30.5 h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5c8.6,3.6,13.5,12.4,13.5,25v24h-24v-24c0-12-5.7-20.4-16-25 C63.3,52.5,69.4,42.6,69.4,30.5 M121.4,30.5c0-12.1-6.1-22.1-17.5-30.5h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5 c8.6,3.6,13.5,12.4,13.5,25v24h-24v-24c0-12-5.7-20.4-16-25C115.3,52.5,121.4,42.6,121.4,30.5'
        fill='currentColor'
      />
    </svg>
  )
}

export function RootlyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 250 217' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='m124.8 5.21c-9.62 11.52-15.84 24.61-15.84 35.75 0 11.65 7.22 21.11 15.56 21.11 8.72 0 15.81-10.18 15.81-21.25 0-11.06-6.44-24.29-15.53-35.61z'
        fill='currentColor'
      />
      <path
        d='m124.7 84.29c-9.76 11.45-16.05 23.67-16.05 34.88 0 10.99 7.15 20.82 15.74 20.51 8.72-0.34 16.25-10.31 16.04-21.37-0.27-11.06-6.58-22.64-15.73-34.02z'
        fill='currentColor'
      />
      <path
        d='m48.81 48.5c5.82 18.47 16.5 35.38 33.97 36.06 10.99 0.4 15.38-7.12 15.31-12.52-0.13-9.19-8.14-24.76-36.9-24.76-4.74 0-8.26 0.34-12.38 1.22z'
        fill='currentColor'
      />
      <path
        d='m18.92 99.03c9.83 15.7 22.58 26.25 36.07 26.39 9.9 0 18.18-5.68 18.12-14.34-0.07-7.92-8.35-18.84-25.25-18.84-9.69 0-17.77 2.61-28.94 6.79z'
        fill='currentColor'
      />
      <path
        d='m200.1 48.43c-4.18-1.01-7.63-1.29-13.32-1.29-21.73 0-36.35 9.91-36.69 24.7-0.2 7.52 6.17 12.78 15.83 12.78 14.48 0 26.89-14.79 34.18-36.19z'
        fill='currentColor'
      />
      <path
        d='m230.6 98.96c-9.9-4.58-18.55-6.72-28.77-6.72-15.59 0-26.14 10.72-26.07 19.38 0.07 7.71 7.73 13.53 17.13 13.53 12.34 0 25.23-9.81 37.71-26.19z'
        fill='currentColor'
      />
      <path
        d='m6.12 146.9 3.65 24.48c10.99-2.34 21.41-3.21 34.17-3.21 38.03 0 63.94 13.69 66.15 41.52h28.83c2.69-26.48 24.99-41.52 66.67-41.52 11.62 0 22.37 1.15 34.32 3.21l4.05-24.34c-10.99-1.8-20.72-2.41-32.73-2.41-38.44 0-68.07 10.32-86.55 31.79-16.25-19.98-42.03-31.79-84.53-31.79-12.01 0-23.36 0.61-34.03 2.27z'
        fill='currentColor'
      />
    </svg>
  )
}

export function HexIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1450.3 600'>
      <path
        fill='#EDB9B8'
        fillRule='evenodd'
        d='m250.11,0v199.49h-50V0H0v600h200.11v-300.69h50v300.69h200.18V0h-200.18Zm249.9,0v600h450.29v-250.23h-200.2v149h-50v-199.46h250.2V0h-450.29Zm200.09,199.49v-99.49h50v99.49h-50Zm550.02,0V0h200.18v150l-100,100.09,100,100.09v249.82h-200.18v-300.69h-50v300.69h-200.11v-249.82l100.11-100.09-100.11-100.09V0h200.11v199.49h50Z'
      />
    </svg>
  )
}

export function RabbitmqIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='-7.5 0 271 271'
      preserveAspectRatio='xMidYMid'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M245.44 108.308h-85.09a7.738 7.738 0 0 1-7.735-7.734v-88.68C152.615 5.327 147.29 0 140.726 0h-30.375c-6.568 0-11.89 5.327-11.89 11.894v88.143c0 4.573-3.697 8.29-8.27 8.31l-27.885.133c-4.612.025-8.359-3.717-8.35-8.325l.173-88.241C54.144 5.337 48.817 0 42.24 0H11.89C5.321 0 0 5.327 0 11.894V260.21c0 5.834 4.726 10.56 10.555 10.56H245.44c5.834 0 10.56-4.726 10.56-10.56V118.868c0-5.834-4.726-10.56-10.56-10.56zm-39.902 93.233c0 7.645-6.198 13.844-13.843 13.844H167.69c-7.646 0-13.844-6.199-13.844-13.844v-24.005c0-7.646 6.198-13.844 13.844-13.844h24.005c7.645 0 13.843 6.198 13.843 13.844v24.005z'
        fill='#F60'
      />
    </svg>
  )
}

export function RailwayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 24 24'>
      <path d='M.113 10.27A13 13 0 0 0 0 11.48h18.23a2.3 2.3 0 0 0-.235-.347c-3.117-4.027-4.793-3.677-7.19-3.78-.8-.034-1.34-.048-4.524-.048-1.704 0-3.555.005-5.358.01-.234.63-.459 1.24-.567 1.737h9.342v1.216H.113zm18.26 2.426H.009q.029.488.094.961h16.955c.754 0 1.179-.429 1.315-.96zm-17.318 4.28s2.81 6.902 10.93 7.024c4.855 0 9.027-2.883 10.92-7.024H1.056zM11.988 0C7.5 0 3.593 2.466 1.531 6.108l4.75-.005v-.002c3.71 0 3.849.016 4.573.047l.448.016c1.563.052 3.485.22 4.996 1.364.82.621 2.007 1.99 2.712 2.965.654.902.842 1.94.396 2.934-.408.914-1.289 1.458-2.353 1.458H.391s.099.42.249.886h22.748A12 12 0 0 0 24 12.005C24 5.377 18.621 0 11.988 0' />
    </svg>
  )
}

export function BigQueryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='#4386FA'
        d='M12 2.5a9.5 9.5 0 1 0 5.81 17.02l3.4 3.4a1 1 0 0 0 1.41-1.42l-3.4-3.4A9.5 9.5 0 0 0 12 2.5Zm0 2a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z'
      />
      <path fill='#4386FA' d='M8 11h1.6v4H8v-4Zm3 -2h1.6v6H11V9Zm3 1.5h1.6V15H14v-3.5Z' />
    </svg>
  )
}

/**
 * Splunk wordmark. The lettering is drawn with `currentColor` so it stays legible
 * bare in both light and dark mode; the chevron keeps its brand green.
 */
export function SplunkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 48 48'
      fillRule='evenodd'
      clipRule='evenodd'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill='currentColor'
        d='M13.432 18L13.5 28 15 28 15 18zM32 18v10.005h1.805c0 0 .015-3.609.035-3.608.019.001 2.69 3.743 2.716 3.733.027-.01 1.599-.576 1.599-.59 0-.014-2.684-3.441-2.684-3.448 0-.006 2.251-2.509 2.231-2.529-.06-.06-1.281-.586-1.314-.566-.018.011-2.582 2.796-2.582 2.796V18H32zM2.099 21.05c-.651.137-1.259.552-1.509 1.031-.23.44-.227 1.043.007 1.491.16.305.625.735 1.348 1.246.782.552 1.078.832 1.153 1.092.111.385-.06.752-.434.931-.187.089-.27.101-.603.086-.433-.02-.729-.132-1.172-.446-.14-.099-.269-.167-.285-.152-.016.016-.155.224-.311.466L.01 27.23l.109.081c.06.045.248.158.422.255 1.187.66 2.944.555 3.835-.229.475-.418.697-1.025.602-1.647-.089-.582-.409-.965-1.417-1.695-.791-.573-1.166-.889-1.253-1.059-.167-.326-.049-.643.307-.827.178-.092.251-.102.608-.087.347.015.453.041.741.179l.335.161.263-.41c.144-.224.252-.426.239-.445-.048-.071-.598-.299-.941-.391C3.402 20.995 2.521 20.961 2.099 21.05zM10.031 21.935c.788.369 1.212 1.528 1.041 2.852-.06.467-.227 1.032-.383 1.296-.159.268-.463.56-.705.675-.444.212-1.107.13-1.523-.187-.577-.442-.893-1.524-.772-2.649.111-1.032.483-1.684 1.133-1.986C9.156 21.781 9.7 21.781 10.031 21.935zM9.313 20.784c-.472.106-.85.319-1.254.705l-.366.35V21H6.814 6v5 5h1.693v-4.08l.324.319c.592.583 1.287.814 2.101.701.532-.074.904-.21 1.3-.475 1.111-.743 1.721-2.221 1.554-3.771-.158-1.467-.912-2.484-2.128-2.871C10.531 20.724 9.679 20.702 9.313 20.784zM16.258 21c0 0 .055 5.284.091 5.438.136.583.525 1.137.964 1.374.403.218.727.287 1.333.284.861-.004 1.386-.211 2.027-.8L21 27v1h1.742l-.023-7H21c0 0 .025 4.347 0 4.5-.1.611-.573 1.109-1.053 1.27-.287.096-.786.174-1.086.127C18.549 26.848 18.033 26.507 18 26v-4.977L16.258 21zM30.742 28c0 0-.055-5.284-.091-5.438-.136-.583-.525-1.137-.964-1.374-.403-.218-.727-.287-1.333-.284-.861.004-1.386.211-2.027.8L26 22v-1h-1.742l.023 7H26c0 0-.025-4.347 0-4.5.1-.611.573-1.109 1.053-1.27.287-.096.661-.17 1.086-.127C28.566 22.147 29.031 22.535 29 23v4.977L30.742 28z'
      />
      <path
        fill='#77b539'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40 20.5L40 22 46 24 40 26.601 40 28 47 25 47 23z'
      />
    </svg>
  )
}

export function SnowflakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 146.36 139.16' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='#29B5E8'
        fillRule='evenodd'
        d='M134.81,60.1l-16.47,9.49L134.81,79a8.65,8.65,0,1,1-8.67,15l-29.51-17a8.68,8.68,0,0,1-4.33-7.75,8.48,8.48,0,0,1,.31-2,8.68,8.68,0,0,1,4-5.19l29.51-16.94A8.69,8.69,0,0,1,138,48.31,8.58,8.58,0,0,1,134.81,60.1Zm-15.59,46L89.72,89.13a8.72,8.72,0,0,0-13.06,7.48v33.9a8.69,8.69,0,0,0,17.37,0v-19L110.54,121a8.66,8.66,0,1,0,8.68-15Zm-34-33.16L72.92,85.09a2.44,2.44,0,0,1-1.54.65H67.77a2.51,2.51,0,0,1-1.54-.65L54,72.9a2.45,2.45,0,0,1-.64-1.52v-3.6A2.5,2.5,0,0,1,54,66.25L66.23,54.06a2.5,2.5,0,0,1,1.54-.64h3.61a2.45,2.45,0,0,1,1.54.64L85.18,66.25a2.49,2.49,0,0,1,.63,1.53v3.6A2.44,2.44,0,0,1,85.18,72.9Zm-9.8-3.38A2.59,2.59,0,0,0,74.73,68l-3.55-3.51a2.51,2.51,0,0,0-1.54-.64h-.13a2.46,2.46,0,0,0-1.53.64L64.43,68a2.51,2.51,0,0,0-.63,1.55v.13a2.41,2.41,0,0,0,.63,1.52L68,74.7a2.48,2.48,0,0,0,1.53.64h.13a2.51,2.51,0,0,0,1.54-.64l3.55-3.53a2.49,2.49,0,0,0,.65-1.52ZM19.93,33.08,49.44,50a8.73,8.73,0,0,0,13.07-7.49V8.64a8.69,8.69,0,0,0-17.37,0v19l-16.53-9.5a8.65,8.65,0,1,0-8.68,15ZM84.69,51.16a8.64,8.64,0,0,0,5-1.13l29.5-17a8.65,8.65,0,1,0-8.68-15L94,27.61v-19a8.69,8.69,0,0,0-17.37,0v33.9A8.66,8.66,0,0,0,84.69,51.16ZM54.48,88a8.58,8.58,0,0,0-5,1.13L19.93,106.06a8.66,8.66,0,1,0,8.68,15l16.53-9.49v19a8.69,8.69,0,0,0,17.37,0V96.61A8.65,8.65,0,0,0,54.48,88Zm-8-15.87a8.61,8.61,0,0,0-4-10L13,45.14A8.69,8.69,0,0,0,1.17,48.31,8.59,8.59,0,0,0,4.35,60.1l16.47,9.49L4.35,79A8.65,8.65,0,1,0,13,94l29.48-17A8.59,8.59,0,0,0,46.47,72.13Zm93.15-56.22H138.3v1.63h1.32c.61,0,1-.28,1-.8S140.26,15.91,139.62,15.91Zm-2.94-1.5h3c1.62,0,2.7.89,2.7,2.27a2.16,2.16,0,0,1-1.08,1.9l1.17,1.68v.34h-1.69L139.62,19H138.3V20.6h-1.62Zm8.3,3.22a5.48,5.48,0,0,0-5.58-5.83c-3.31,0-5.51,2.39-5.51,5.83,0,3.28,2.2,5.82,5.51,5.82A5.47,5.47,0,0,0,145,17.63Zm1.38,0c0,3.89-2.6,7.14-7,7.14s-6.89-3.28-6.89-7.14,2.57-7.14,6.89-7.14S146.36,13.73,146.36,17.63Z'
      />
    </svg>
  )
}

export function NewRelicIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 159.36 159.36' xmlns='http://www.w3.org/2000/svg'>
      <polygon
        fill='#46B978'
        points='79.68 .19 18.89 35.29 45.38 50.58 79.68 30.77 122.04 55.23 122.04 104.13 87.73 123.94 87.73 154.52 148.52 119.42 148.52 39.94 79.68 .19'
      />
      <polygon
        fill='#46B978'
        points='53.2 94.97 53.2 143.88 79.68 159.17 79.68 79.68 10.84 39.94 10.84 70.51 53.2 94.97'
      />
    </svg>
  )
}

export function NetSuiteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 93.9 59.4' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#C74634'
        d='M30.5 59.4H65c16.4-.4 29.3-14.1 28.9-30.4C93.5 13.1 80.7.4 65 0H30.5C14.1-.4.4 12.5 0 28.9s12.5 30 28.9 30.4c.5.1 1 .1 1.6.1m33.7-10.5h-33c-10.6-.3-18.9-9.2-18.6-19.8C13 19 21.1 10.8 31.2 10.5h33c10.6-.3 19.5 8 19.8 18.6s-8 19.5-18.6 19.8z'
      />
    </svg>
  )
}

export function WizaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 51 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        d='m50.3 33.6-9.3-3.5c-2.9-10.4-9.6-20.8-17.1-29.4-1.4-1.5-4.4-0.7-4.2 1.9 0.4 6-0.4 13.3-4.4 20.5-0.9 1.6 1.4 3.3 2.9 1.6 3.2-3.3 5.3-9.1 6.3-15.2 3.9 5.4 9.2 13.8 11.2 22.9 0.2 0.9 0.8 1.6 1.6 1.9l6.2 2.3c-4.1 3.3-9.6 6-17.7 6-7.1 0-13.2-2.3-18.5-6l3.6-2.5c3.5 2 7.5 3.5 12.5 3.6 2.5 0 5-0.2 7.3-0.9 2-0.5 1.6-3.2-0.3-3-4 0.5-10.3 0.3-17.1-4.3-0.8-0.5-1.9-0.6-2.7-0.2l-9.2 4.3c-1.4 0.6-2.1 3.1-0.5 4.3 4.7 3.8 12.4 10.1 24.2 10.1 11.9 0 20.4-4.3 25.8-10.1 1.2-1.2 1.2-3.5-0.6-4.3z'
      />
    </svg>
  )
}

export function TriggerDevIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradientId = `triggerdev_paint0_${id}`

  return (
    <svg {...props} viewBox='0 0 109 95' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32.57 38.19L54.53 0.16L108.96 94.42H0.1L22.07 56.38L37.6 65.35L31.18 76.48H77.89L54.53 36.03L48.11 47.16L32.57 38.19Z'
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1='88.2367'
          y1='94.4175'
          x2='87.2207'
          y2='27.8737'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#41FF54' />
          <stop offset='1' stopColor='#E7FF52' />
        </linearGradient>
      </defs>
    </svg>
  )
}

/** Datagma brand icon: navy square with the white Datagma "D" mark. */
export function DatagmaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='24' height='24' fill='#003071' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 4.5H11.5C15.9 4.5 18.5 7.8 18.5 12C18.5 16.2 15.9 19.5 11.5 19.5H6V4.5ZM9.3 7.5V16.5H11.5C13.8 16.5 15.2 14.6 15.2 12C15.2 9.4 13.8 7.5 11.5 7.5H9.3Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

/** LeadMagic brand icon: purple gradient tile with the white spark mark. */
export function LeadMagicIcon(props: SVGProps<SVGSVGElement>) {
  const id = useId()
  const gradient = `leadmagic_grad_${id}`
  return (
    <svg {...props} viewBox='0 0 65 65' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id={gradient} x1='0%' y1='100%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#4C1D95' />
          <stop offset='50%' stopColor='#7C3AED' />
          <stop offset='100%' stopColor='#C4B5FD' />
        </linearGradient>
      </defs>
      <rect width='65' height='65' fill={`url(#${gradient})`} />
      <path
        d='M34.1 37.71C33.54 37.77 33.1 38.02 32.85 38.52C32.59 39.03 32.47 39.65 32.59 40.47C32.59 40.47 34.29 49.83 34.54 50.83C34.79 51.84 35.36 53.47 36.11 53.35C36.93 53.22 36.99 51.52 36.93 50.46C36.93 50.46 36.24 41.6 36.17 40.6C36.11 39.53 35.86 38.71 35.48 38.34C35.11 37.83 34.67 37.64 34.1 37.71Z'
        fill='#FFFFFF'
      />
      <path
        d='M33.53 26.15L35.48 23.2C35.8 22.7 36.11 22.76 36.11 23.14L35.67 26.91C35.61 27.28 35.92 27.72 36.42 27.66L39.75 26.91C39.94 26.91 40.13 27.16 39.94 27.35L37.43 29.54C37.05 29.98 37.05 30.42 37.55 30.74L39.82 32.12C39.94 32.25 39.88 32.43 39.69 32.43L36.99 32.62C36.42 32.68 36.17 33.12 36.24 33.69L37.11 36.96C37.18 37.14 36.99 37.33 36.74 37.08L34.41 34.57C33.97 34.19 33.41 34.26 33.03 34.69L31.4 36.83C31.27 36.96 30.96 36.89 31.02 36.7L31.15 34.19C31.09 33.63 30.71 33.19 30.14 33.25L27.5 34.07C27.25 34.13 27.19 33.82 27.32 33.69L29.26 31.55C29.64 31.11 29.7 30.61 29.14 30.3L26.31 28.98C25.93 28.73 26.12 28.48 26.44 28.48L29.45 28.41C29.89 28.41 30.27 28.1 30.14 27.47C30.14 27.47 29.26 24.33 29.08 23.83C28.89 23.33 29.39 23.01 29.77 23.39L32.34 26.15C32.72 26.59 33.16 26.66 33.53 26.15Z'
        fill='#FFFFFF'
      />
      <path
        d='M32.59 22.39C32.34 22.39 32.09 22.13 32.03 21.76L30.33 13.22C30.27 12.84 30.46 12.15 31.09 12.02C31.65 11.9 32.22 12.34 32.28 12.71L32.91 21.63C32.97 22.01 32.97 22.39 32.59 22.39Z'
        fill='#FFFFFF'
      />
      <path
        d='M40.57 29.73C40.51 29.36 40.88 29.29 41.26 29.29L49.36 27.91C49.86 27.91 50.12 28.41 50.12 28.73C50.24 29.11 49.74 29.73 49.05 29.67L41.32 29.98C41.01 29.98 40.63 30.11 40.57 29.73Z'
        fill='#FFFFFF'
      />
      <path
        d='M16.01 32.37C16.01 31.99 16.64 31.24 17.39 31.24L24.87 31.05C25.24 30.99 25.62 31.12 25.62 31.43C25.62 31.74 25.12 31.87 24.74 31.93L17.21 33.19C16.77 33.13 15.89 32.87 16.01 32.37Z'
        fill='#FFFFFF'
      />
      <path
        d='M38.5 24.27C38.18 24.02 38.81 23.27 39.06 22.95L43.33 17.11C43.58 16.67 44.4 16.42 44.9 16.86C45.28 17.24 45.22 17.8 44.97 18.05L39.31 24.02C39.06 24.27 38.75 24.4 38.5 24.27Z'
        fill='#FFFFFF'
      />
      <path
        d='M18.84 19.43C19.21 18.86 20.03 19.05 20.35 19.3L26.19 24.58C26.5 24.83 26.63 25.21 26.44 25.33C26.25 25.46 25.94 25.4 25.62 25.21L18.96 20.81C18.65 20.56 18.46 19.93 18.84 19.43Z'
        fill='#FFFFFF'
      />
    </svg>
  )
}

/** Dropcontact brand icon: the teal swirl mark from the official wordmark. */
export function DropcontactIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.57 16.22a10.84 10.84 0 0 0-4.698-1.064c-6.01 0-10.88 4.872-10.88 10.88s4.872 10.88 10.88 10.88c4.09 0 7.655-2.258 9.513-5.596l-2.623-1.457a7.88 7.88 0 0 1-6.89 4.053c-4.353 0-7.88-3.528-7.88-7.88s3.528-7.88 7.88-7.88a7.85 7.85 0 0 1 3.403.77l1.295-2.707zm5.21-14.235v25.762h-3.11V.9C29.546.313 27.3 0 25 0 11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25c0-10.337-6.274-19.21-15.222-23.016z'
        fill='currentColor'
      />
    </svg>
  )
}

/** Icypeas brand icon: light tile with the teal ring + rising-step mark. */
export function IcypeasIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 35 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='35' height='33' rx='5' fill='#d4d4d4' />
      <g clipPath='url(#clip0_4921_13194)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.31 26.72C30.7 23.85 32 20.23 32 16.5C32 16.47 32 16.43 32 16.4C32 16.16 31.8 15.97 31.56 15.97H28.9C28.64 15.97 28.44 16.18 28.44 16.43C28.44 16.45 28.44 16.48 28.44 16.5C28.45 19.3 27.51 22.02 25.77 24.22C24.04 26.43 21.61 27.98 18.89 28.63C16.17 29.29 13.3 29 10.76 27.83C8.21 26.66 6.14 24.66 4.87 22.16C3.6 19.66 3.21 16.81 3.76 14.06C4.31 11.32 5.77 8.84 7.9 7.02C10.03 5.2 12.72 4.16 15.52 4.06C18.32 3.95 21.07 4.79 23.33 6.45C23.75 6.75 24.14 7.08 24.51 7.43C24.64 7.55 24.8 7.62 24.98 7.62H27.33C27.58 7.62 27.78 7.42 27.78 7.17V5.93C27.78 5.76 27.71 5.6 27.6 5.48C25.09 2.84 21.76 1.13 18.15 0.64C14.45 0.14 10.69 0.95 7.53 2.92C4.36 4.89 1.98 7.91 0.81 11.45C-0.37 15 -0.27 18.84 1.08 22.31C2.44 25.79 4.97 28.69 8.23 30.5C11.49 32.31 15.28 32.92 18.95 32.23C22.62 31.54 25.93 29.59 28.31 26.72Z'
          fill='#02C29F'
        />
        <path
          d='M34.22 9.17C34.22 9.53 33.92 9.83 33.55 9.83H30.89C30.52 9.83 30.22 10.13 30.22 10.5V13.17C30.22 13.54 29.92 13.83 29.55 13.83H26.89C26.52 13.83 26.22 14.13 26.22 14.5V17.17C26.22 17.53 25.92 17.83 25.55 17.83H22.89C22.52 17.83 22.22 18.13 22.22 18.5V21.17C22.22 21.54 21.92 21.83 21.55 21.83H18.89C18.52 21.83 18.22 22.13 18.22 22.5V25.17C18.22 25.53 17.92 25.83 17.55 25.83H14.44C14.08 25.83 13.78 25.53 13.78 25.17V22.5C13.78 22.13 13.48 21.83 13.11 21.83H10.44C10.07 21.83 9.78 21.54 9.78 21.17V18.5C9.78 18.13 9.48 17.83 9.11 17.83H6.44C6.08 17.83 5.78 17.53 5.78 17.17V14.05C5.78 13.69 6.08 13.39 6.44 13.39H9.56C9.92 13.39 10.22 13.69 10.22 14.05V16.72C10.22 17.09 10.52 17.39 10.89 17.39H13.55C13.92 17.39 14.22 17.69 14.22 18.06V20.72C14.22 21.09 14.52 21.39 14.89 21.39H17.11C17.48 21.39 17.78 21.09 17.78 20.72V18.06C17.78 17.69 18.07 17.39 18.44 17.39H21.11C21.48 17.39 21.78 17.09 21.78 16.72V14.05C21.78 13.69 22.08 13.39 22.44 13.39H25.11C25.48 13.39 25.78 13.09 25.78 12.72V10.06C25.78 9.69 26.08 9.39 26.44 9.39H29.11C29.48 9.39 29.78 9.09 29.78 8.72V6.05C29.78 5.69 30.08 5.39 30.44 5.39H33.55C33.92 5.39 34.22 5.69 34.22 6.05V9.17Z'
          fill='#02C29F'
        />
      </g>
      <defs>
        <clipPath id='clip0_4921_13194'>
          <rect width='35' height='33' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

/** Enrow brand icon: blue tile with the three white stacked rows. */
export function EnrowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 256 256' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#0056FF'
        d='M217.791 0H38.209C17.107 0 0 17.107 0 38.209v179.582C0 238.893 17.107 256 38.209 256h179.582C238.893 256 256 238.893 256 217.791V38.209C256 17.107 238.893 0 217.791 0z'
      />
      <path
        fill='#F0F0F0'
        d='M196.877 58.88H78.055a3.82 3.82 0 0 0-3.82 3.82v17.96a3.82 3.82 0 0 0 3.82 3.82h118.822a3.82 3.82 0 0 0 3.821-3.82V62.701a3.82 3.82 0 0 0-3.821-3.821zm.007 112.641H73.454a3.82 3.82 0 0 0-3.821 3.82V193.3a3.82 3.82 0 0 0 3.82 3.821h123.431a3.821 3.821 0 0 0 3.821-3.821v-17.959a3.82 3.82 0 0 0-3.821-3.82zM141.588 115.2H58.606a3.821 3.821 0 0 0-3.82 3.821v17.958a3.82 3.82 0 0 0 3.82 3.821h82.982a3.82 3.82 0 0 0 3.821-3.821v-17.958a3.82 3.82 0 0 0-3.821-3.821z'
      />
    </svg>
  )
}

// ---- Competitor brand logos (sourced via Context.dev brand-intelligence API, 2026-07-02) ----

export function N8nIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function ZapierIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function MakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function GumloopIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function WorkatoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function PipedreamIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function TinesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function StackAIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function VellumIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='64'
        height='64'
      />
    </svg>
  )
}

export function RetoolIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 128 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='#242424'
        d='M80.64 15.67C80.64 12.91 78.4 10.67 75.64 10.67H18.97C16.21 10.67 13.97 12.91 13.97 15.67V39C13.97 41.76 16.21 44 18.97 44H75.64C78.4 44 80.64 46.24 80.64 49V55.67C80.64 58.43 78.4 60.67 75.64 60.67H38.97C36.21 60.67 33.97 62.91 33.97 65.67V89C33.97 91.76 36.21 94 38.97 94H75.64C78.4 94 80.64 96.24 80.64 99V112.33C80.64 115.1 82.88 117.33 85.64 117.33H108.97C111.74 117.33 113.97 115.1 113.97 112.33V89C113.97 86.24 111.74 84 108.97 84H85.64C82.88 84 80.64 81.76 80.64 79V72.33C80.64 69.57 82.88 67.33 85.64 67.33H108.97C111.74 67.33 113.97 65.1 113.97 62.33V39C113.97 36.24 111.74 34 108.97 34H85.64C82.88 34 80.64 31.76 80.64 29V15.67Z'
      />
    </svg>
  )
}

export function LangflowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='200'
        height='200'
      />
    </svg>
  )
}

export function FlowiseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'>
      <image
        href='data:image/png;base64,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'
        width='200'
        height='200'
      />
    </svg>
  )
}

export function JotformIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='147 132 306 336'
      fill='none'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#0A1551'
        d='M231.287 450.612C237.601 456.733 233.139 467.221 224.173 467.221H168.06C156.989 467.221 147.98 458.488 147.98 447.756V393.358C147.98 384.666 158.799 380.341 165.113 386.462L231.287 450.612Z'
      />
      <path
        fill='#FFB629'
        d='M319.003 454.845C302.393 438.343 302.394 411.589 319.003 395.088L378.947 335.535C395.557 319.033 422.486 319.033 439.096 335.535C455.705 352.036 455.705 378.79 439.096 395.292L379.152 454.845C362.542 471.346 335.613 471.346 319.003 454.845Z'
      />
      <path
        fill='#0099FF'
        d='M160.64 305.204C144.031 288.703 144.031 261.949 160.64 245.447L261.52 145.155C278.129 128.653 305.059 128.653 321.669 145.155C338.278 161.656 338.278 188.41 321.669 204.912L220.789 305.204C204.179 321.705 177.25 321.705 160.64 305.204Z'
      />
      <path
        fill='#FF6100'
        d='M243.108 376.686C226.498 360.185 226.498 333.43 243.108 316.929L379.414 181.511C396.024 165.009 422.953 165.009 439.563 181.511C456.173 198.012 456.173 224.766 439.563 241.268L303.256 376.686C286.647 393.187 259.717 393.187 243.108 376.686Z'
      />
    </svg>
  )
}

export function JupyterIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 44 51' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <path
          id='jupyter-path-0'
          d='M 1.74 5.48C 1.74 7.03 1.62 7.54 1.3 7.91C 0.94 8.24 0.48 8.41 0 8.41L 0.12 9.3C 0.87 9.31 1.59 9.05 2.15 8.56C 2.46 8.19 2.68 7.77 2.82 7.31C 2.95 6.85 2.99 6.37 2.94 5.89L 2.94 0L 1.74 0L 1.74 5.44L 1.74 5.48Z'
        />
        <path
          id='jupyter-path-1'
          d='M 5.5 4.76C 5.5 5.43 5.5 6.03 5.56 6.54L 4.5 6.54L 4.42 5.48C 4.2 5.86 3.89 6.17 3.51 6.38C 3.13 6.59 2.7 6.7 2.26 6.7C 1.23 6.7 0 6.13 0 3.85L 0 0.04L 1.19 0.04L 1.19 3.61C 1.19 4.84 1.58 5.67 2.65 5.67C 2.87 5.67 3.09 5.63 3.3 5.55C 3.51 5.46 3.69 5.34 3.85 5.18C 4 5.03 4.13 4.84 4.21 4.64C 4.3 4.43 4.34 4.21 4.34 3.99L 4.34 0L 5.53 0L 5.53 4.73L 5.5 4.76Z'
        />
        <path
          id='jupyter-path-2'
          d='M 0.05 2.27C 0.05 1.44 0.05 0.77 0 0.15L 1.07 0.15L 1.12 1.27C 1.36 0.86 1.7 0.53 2.11 0.31C 2.52 0.09 2.99 -0.02 3.45 0C 5.04 0 6.23 1.33 6.23 3.31C 6.23 5.64 4.8 6.8 3.25 6.8C 2.85 6.81 2.46 6.73 2.1 6.55C 1.75 6.37 1.45 6.1 1.23 5.77L 1.23 5.77L 1.23 9.33L 0.05 9.33L 0.05 2.3L 0.05 2.27ZM 1.23 4.01C 1.23 4.17 1.25 4.33 1.28 4.49C 1.38 4.88 1.61 5.24 1.94 5.49C 2.26 5.74 2.65 5.87 3.06 5.87C 4.32 5.87 5.06 4.85 5.06 3.36C 5.06 2.06 4.36 0.95 3.11 0.95C 2.61 0.99 2.15 1.21 1.8 1.57C 1.45 1.93 1.25 2.4 1.23 2.9L 1.23 4.01Z'
        />
        <path
          id='jupyter-path-3'
          d='M 1.32 0.02L 2.75 3.85C 2.9 4.28 3.06 4.8 3.17 5.18C 3.29 4.79 3.43 4.29 3.59 3.83L 4.89 0.02L 6.14 0.02L 4.36 4.65C 3.47 6.87 2.93 8.02 2.11 8.72C 1.7 9.09 1.19 9.36 0.65 9.48L 0.36 8.48C 0.74 8.36 1.09 8.16 1.4 7.91C 1.83 7.55 2.18 7.1 2.4 6.59C 2.45 6.5 2.49 6.4 2.5 6.3C 2.49 6.2 2.46 6.09 2.42 5.99L 0 0L 1.3 0L 1.32 0.02Z'
        />
        <path
          id='jupyter-path-4'
          d='M 2.19 0L 2.19 1.87L 3.9 1.87L 3.9 2.76L 2.19 2.76L 2.19 6.27C 2.19 7.07 2.42 7.53 3.08 7.53C 3.31 7.54 3.55 7.51 3.77 7.45L 3.83 8.34C 3.49 8.46 3.13 8.51 2.77 8.5C 2.53 8.52 2.29 8.48 2.07 8.39C 1.85 8.31 1.64 8.18 1.48 8C 1.12 7.52 0.95 6.91 1.01 6.31L 1.01 2.75L 0 2.75L 0 1.86L 1.03 1.86L 1.03 0.28L 2.19 0Z'
        />
        <path
          id='jupyter-path-5'
          d='M 1.18 3.58C 1.15 3.88 1.19 4.18 1.3 4.47C 1.4 4.75 1.57 5.01 1.78 5.23C 2 5.44 2.26 5.6 2.54 5.71C 2.82 5.81 3.13 5.86 3.43 5.83C 4.04 5.85 4.65 5.73 5.21 5.49L 5.41 6.38C 4.72 6.67 3.98 6.8 3.23 6.78C 2.8 6.81 2.36 6.75 1.95 6.59C 1.55 6.44 1.18 6.2 0.87 5.89C 0.56 5.58 0.33 5.2 0.18 4.79C 0.03 4.38 -0.03 3.94 0.01 3.51C 0.01 1.55 1.18 0 3.08 0C 5.22 0 5.75 1.87 5.75 3.06C 5.76 3.25 5.76 3.43 5.75 3.61L 1.15 3.61L 1.18 3.58ZM 4.67 2.69C 4.7 2.45 4.68 2.21 4.62 1.98C 4.55 1.75 4.43 1.53 4.28 1.35C 4.12 1.17 3.93 1.02 3.71 0.92C 3.49 0.82 3.25 0.77 3.01 0.77C 2.52 0.8 2.06 1.02 1.73 1.37C 1.39 1.73 1.2 2.2 1.19 2.69L 4.67 2.69Z'
        />
        <path
          id='jupyter-path-6'
          d='M 0.05 2.19C 0.05 1.43 0.05 0.77 0 0.16L 1.07 0.16L 1.07 1.44L 1.12 1.44C 1.23 1.04 1.47 0.69 1.78 0.44C 2.1 0.18 2.49 0.03 2.9 0.01C 3.01 0 3.13 0 3.24 0.01L 3.24 1.12C 3.1 1.11 2.97 1.11 2.83 1.12C 2.43 1.14 2.04 1.3 1.75 1.58C 1.46 1.86 1.27 2.23 1.24 2.64C 1.2 2.82 1.19 3 1.18 3.19L 1.18 6.65L 0.01 6.65L 0.01 2.2L 0.05 2.19Z'
        />
        <path
          id='jupyter-path-7'
          d='M 6.03 2.84C 6.07 3.43 5.92 4.03 5.62 4.55C 5.32 5.06 4.87 5.48 4.33 5.74C 3.79 6 3.18 6.09 2.59 6.01C 2 5.92 1.44 5.66 1 5.26C 0.55 4.86 0.24 4.34 0.09 3.76C -0.06 3.17 -0.02 2.56 0.18 2C 0.38 1.44 0.75 0.94 1.23 0.59C 1.71 0.23 2.29 0.03 2.89 0C 3.28 -0.02 3.67 0.04 4.04 0.17C 4.41 0.3 4.76 0.5 5.05 0.77C 5.34 1.03 5.58 1.35 5.75 1.7C 5.91 2.06 6.01 2.44 6.03 2.84L 6.03 2.84Z'
        />
        <path
          id='jupyter-path-8'
          d='M 18.7 7.12C 10.68 7.12 3.64 4.25 0 0C 1.41 3.82 3.96 7.12 7.3 9.44C 10.65 11.77 14.62 13.02 18.7 13.02C 22.77 13.02 26.75 11.77 30.09 9.44C 33.43 7.12 35.98 3.82 37.39 0C 33.76 4.25 26.74 7.12 18.7 7.12Z'
        />
        <path
          id='jupyter-path-9'
          d='M 18.7 5.9C 26.71 5.9 33.75 8.77 37.39 13.02C 35.98 9.2 33.43 5.9 30.09 3.58C 26.75 1.25 22.77 0 18.7 0C 14.62 0 10.65 1.25 7.3 3.58C 3.96 5.9 1.41 9.2 0 13.02C 3.64 8.76 10.65 5.9 18.7 5.9Z'
        />
        <path
          id='jupyter-path-10'
          d='M 7.6 3.57C 7.64 4.32 7.46 5.07 7.08 5.72C 6.7 6.37 6.14 6.9 5.46 7.23C 4.78 7.55 4.02 7.67 3.27 7.57C 2.52 7.46 1.82 7.14 1.26 6.63C 0.7 6.13 0.3 5.47 0.12 4.73C -0.07 4 -0.03 3.23 0.22 2.52C 0.48 1.81 0.94 1.19 1.55 0.74C 2.15 0.3 2.88 0.04 3.63 0.01C 4.13 -0.02 4.62 0.05 5.09 0.21C 5.56 0.38 5.98 0.63 6.35 0.97C 6.72 1.3 7.02 1.7 7.23 2.14C 7.45 2.59 7.57 3.07 7.6 3.57L 7.6 3.57Z'
        />
        <path
          id='jupyter-path-11'
          d='M 2.25 4.38C 1.82 4.39 1.39 4.28 1.03 4.05C 0.66 3.82 0.37 3.48 0.19 3.09C 0.02 2.7 -0.04 2.26 0.03 1.83C 0.1 1.41 0.29 1.01 0.59 0.7C 0.88 0.38 1.27 0.16 1.69 0.06C 2.11 -0.04 2.55 -0.01 2.95 0.14C 3.36 0.29 3.71 0.55 3.96 0.9C 4.22 1.25 4.36 1.67 4.38 2.1C 4.4 2.68 4.18 3.25 3.78 3.68C 3.38 4.1 2.83 4.36 2.25 4.38Z'
        />
      </defs>
      <use xlinkHref='#jupyter-path-0' transform='translate(0.54 21.36)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-1' transform='translate(5.68 21.37)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-2' transform='translate(13.39 21.26)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-3' transform='translate(20.43 21.39)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-4' transform='translate(27.55 19.54)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-5' transform='translate(32.47 21.29)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-6' transform='translate(39.98 21.24)' fill='#4E4E4E' />
      <use xlinkHref='#jupyter-path-7' transform='translate(33.48 0.69)' fill='#767677' />
      <use xlinkHref='#jupyter-path-8' transform='translate(3.21 31.27)' fill='#F37726' />
      <use xlinkHref='#jupyter-path-9' transform='translate(3.21 4.88)' fill='#F37726' />
      <use xlinkHref='#jupyter-path-10' transform='translate(3.28 43.09)' fill='#9E9E9E' />
      <use xlinkHref='#jupyter-path-11' transform='translate(1.87 5.43)' fill='#616262' />
    </svg>
  )
}

export function RocketlaneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 19.001 16.514' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(0 -6.486)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.45 6.94L19 14.77L15.45 22.61C14.65 22.86 13.81 23 12.93 23C11.71 23 10.56 22.74 9.53 22.27L12.93 14.77L9.53 7.28C10.56 6.81 11.71 6.55 12.93 6.55C13.81 6.55 14.65 6.69 15.45 6.94Z'
          fill='#0F62FE'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.03 7.01L9.53 14.71L6.03 22.41C5.13 22.75 4.15 22.94 3.14 22.94C2.03 22.94 0.97 22.72 0 22.32L3.45 14.71L0 7.1C0.97 6.71 2.03 6.49 3.14 6.49C4.15 6.49 5.13 6.67 6.03 7.01Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

/**
 * Pydantic Logfire. Single-fill mark drawn with `fill='currentColor'` so it
 * takes white on its brand tile and the block's `iconColor` when rendered bare.
 */
export function LogfireIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 750 750'
      fill='currentColor'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M 741.5 539.73 L 398.2 63.89 C 387.4 49.04 362.48 49.04 351.79 63.89 L 8.49 539.73 C 6.75 542.16 5.41 544.8 4.5 547.66 C 3.58 550.51 3.12 553.44 3.12 556.43 C 3.12 557.93 3.24 559.41 3.47 560.89 C 3.7 562.37 4.05 563.82 4.51 565.24 C 4.97 566.66 5.54 568.04 6.21 569.38 C 6.89 570.71 7.67 571.98 8.54 573.2 C 9.42 574.41 10.38 575.55 11.43 576.61 C 12.48 577.68 13.61 578.65 14.82 579.54 C 16.02 580.42 17.29 581.21 18.62 581.9 C 19.94 582.59 21.32 583.17 22.73 583.64 L 366.03 695.97 L 366.09 695.97 C 368.97 696.91 371.92 697.38 374.95 697.38 C 377.98 697.38 380.94 696.91 383.82 695.97 L 383.88 695.97 L 727.18 583.64 C 729.32 582.95 731.35 582.02 733.27 580.84 C 735.18 579.66 736.94 578.27 738.53 576.68 C 740.12 575.08 741.5 573.32 742.67 571.4 C 743.84 569.48 744.77 567.44 745.45 565.3 C 746.16 563.16 746.6 560.97 746.79 558.72 C 746.97 556.48 746.88 554.25 746.53 552.02 C 746.18 549.8 745.57 547.64 744.71 545.57 C 743.84 543.49 742.75 541.54 741.41 539.73 Z M 375.01 129.46 L 512.61 320.2 L 383.93 278.11 C 382.94 277.78 381.88 277.84 380.89 277.6 C 379.92 277.36 378.93 277.2 377.93 277.11 C 376.95 276.98 376 276.6 375.01 276.6 C 374.02 276.6 373.1 276.98 372.1 277.11 C 371.11 277.22 370.12 277.38 369.15 277.6 C 368.13 277.79 367.08 277.79 366.17 278.11 L 238.27 319.95 L 237.46 320.22 L 375.07 129.45 L 375.02 129.45 Z M 180.6 398.98 L 330.39 349.93 L 346.39 344.72 L 346.39 629.39 L 77.8 541.47 Z M 403.66 629.33 L 403.66 344.72 L 569.45 398.98 L 672.25 541.39 L 403.63 629.33 Z M 403.66 629.33 ' />
    </svg>
  )
}

export function LogRocketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox='0 0 19 28' fill='none' role='img' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.066 3.156A10.53 10.53 0 0 1 9.122 0a10.294 10.294 0 0 1 3.016 3.094 15.59 15.59 0 0 1 2.93 9.777c.637.513 1.293 1.006 1.918 1.53a3.46 3.46 0 0 1 1.104 3.189c-.302 1.457-.592 2.918-.911 4.372a1.214 1.214 0 0 1-1.848.61c-1.027-.825-2.027-1.678-3.05-2.504a4.684 4.684 0 0 1-2.891 1.255 4.678 4.678 0 0 1-3.385-1.22c-.735.541-1.419 1.191-2.138 1.772-.315.31-.666.58-1.046.806a1.215 1.215 0 0 1-1.603-.785c-.329-1.422-.672-2.839-.99-4.263a3.453 3.453 0 0 1 1.163-3.321c.559-.45 1.125-.893 1.694-1.331.159-.08.08-.261.087-.401a15.615 15.615 0 0 1 2.9-9.42m1.007 4.402a2.395 2.395 0 0 0 .21 3.173 2.636 2.636 0 0 0 3.603.075 2.398 2.398 0 0 0 .636-2.634 2.55 2.55 0 0 0-2.14-1.59 2.6 2.6 0 0 0-2.31.974'
      />
      <path
        fill='currentColor'
        d='M5.712 23.082a.605.605 0 0 1 .896-.485 5.778 5.778 0 0 0 5.03 0 .61.61 0 0 1 .896.45c.005.89.005 1.78 0 2.67a.602.602 0 0 1-.94.436c-.267-.226-.508-.48-.764-.719-.407.762-.789 1.534-1.199 2.294a.61.61 0 0 1-1.012.006c-.41-.761-.79-1.538-1.206-2.299-.253.24-.494.494-.761.72a.603.603 0 0 1-.94-.442c-.007-.878 0-1.756 0-2.634M9.102 10.259a1.22 1.22 0 0 0 1.248-1.192v-.008a1.221 1.221 0 0 0-1.24-1.2h-.008A1.22 1.22 0 0 0 7.855 9.05v.008a1.22 1.22 0 0 0 1.24 1.2h.007Z'
      />
    </svg>
  )
}

export function SmartleadIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <g transform='translate(1.4, -1.4)'>
        <path
          d='M12.06 2.39L2.39 12.05C1.07 13.37 1.07 15.51 2.39 16.83L2.39 16.83C3.71 18.14 5.85 18.14 7.16 16.83L16.83 7.16C18.15 5.84 18.15 3.7 16.83 2.39L16.83 2.39C15.51 1.07 13.38 1.07 12.06 2.39Z'
          fill='#0FDECD'
        />
        <path
          opacity='0.797'
          d='M16.83 21.63L7.16 11.96C5.84 10.65 3.71 10.65 2.39 11.96L2.39 11.96C1.07 13.28 1.07 15.42 2.39 16.74L12.05 26.4C13.37 27.72 15.51 27.72 16.83 26.4L16.83 26.4C18.15 25.09 18.15 22.95 16.83 21.63Z'
          fill='#39BAE9'
        />
        <path
          d='M18.5 18.36L21.64 15.22C22.07 14.79 22.07 14.1 21.64 13.67C21.21 13.24 20.52 13.24 20.09 13.67L16.95 16.81C16.52 17.24 16.52 17.94 16.95 18.36C17.38 18.79 18.07 18.79 18.5 18.36Z'
          fill='#0CAEE9'
        />
        <path
          opacity='0.8'
          d='M17.01 12.14L20.15 15.28C20.58 15.71 21.27 15.71 21.7 15.28L21.7 15.28C22.13 14.85 22.13 14.16 21.7 13.73L18.56 10.59C18.13 10.16 17.44 10.16 17.01 10.59L17.01 10.59C16.58 11.02 16.58 11.71 17.01 12.14Z'
          fill='#3AE0D2'
        />
      </g>
    </svg>
  )
}

export function ZohoDeskIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='-24 -6 308 308'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        d='M22.3,293c-1.6,0-3.3-0.5-4.7-1.4c-2.8-1.8-4.2-5.1-3.7-8.4l24.3-149.3c1.3-8,5.4-15.2,11.5-20.4 c6.1-5.2,14-8.1,22-8.1h100.1l5.6-34.3H168c-4.2,0-8.1-1.8-10.8-5c-2.7-3.2-3.9-7.3-3.2-11.4l6.4-39.7c1.1-6.9,7-11.9,14-11.9h37.3 c10,0,19.4,4.4,25.9,12s9.3,17.6,7.7,27.5l-15,92.4c-0.7,4-3,7.6-6.5,9.8L140,196.5c-5.1,3.1-11.6,2.8-16.3-1l-39-31.1 c-3.7-2.9-4.3-8.3-1.3-11.9c2.9-3.7,8.3-4.3,11.9-1.3l37.5,29.9l81-50.2l14.8-91.1c0.8-4.9-0.6-9.9-3.8-13.7c-3.2-3.8-7.9-6-12.9-6 h-34.9l-5.5,34h9.3c4.2,0,8.1,1.8,10.8,5c2.7,3.2,3.9,7.3,3.2,11.4l-6.5,39.9c-1.1,6.9-7,11.9-14,11.9H71.7 c-8.4,0-15.4,6-16.8,14.3L33.6,267.5L63.5,249c2.2-1.4,4.8-2.1,7.5-2.1h109.5c8.4,0,15.4-6,16.8-14.3l6.8-41.9 c0.8-4.6,5.1-7.8,9.7-7c4.6,0.8,7.8,5.1,7,9.7l-6.8,41.9c-1.3,8-5.4,15.2-11.5,20.4c-6.1,5.2-14,8.1-22,8.1H71.7l-45,27.9 C25.4,292.6,23.8,293,22.3,293z'
        fill='#089949'
      />
    </svg>
  )
}

export function PitchBookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox='-3.16 0 102 101.7'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M75.43,0C16.66,4.78-7.6,53.48,2.06,84.09c5.67-8.73,16.21-18.24,37.78-21.76-1.25-25.79,8.08-43.79,35.59-62.33Z' />
      <path d='M45.3,66.03c-14.85,2.43-25.18,6.46-31.65,12.57.2,8.16,2.53,16.13,6.77,23.1,5.02-12.27,21.5-20.95,46.55-21.01-6.1-29.4,7.53-56.33,28.71-74.41-10.48,1.55-20.75,4.31-30.61,8.21-16.13,15.54-22.14,35.57-19.77,51.55Z' />
    </svg>
  )
}

export function FeishuIcon(props: SVGProps<SVGSVGElement>) {
  return <Send {...props} />
}

export function DingTalkIcon(props: SVGProps<SVGSVGElement>) {
  return <Bell {...props} />
}

export function WeComIcon(props: SVGProps<SVGSVGElement>) {
  return <MessageSquareText {...props} />
}
